(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('styled-components'), require('@material-ui/icons/ArrowForward'), require('@material-ui/core'), require('@material-ui/core/CircularProgress'), require('react-dom'), require('@material-ui/core/TextField'), require('react-ga'), require('uuid'), require('@material-ui/core/Box'), require('@material-ui/core/Collapse'), require('@material-ui/core/IconButton'), require('@material-ui/core/Paper'), require('@material-ui/core/Table'), require('@material-ui/core/TableBody'), require('@material-ui/core/TableCell'), require('@material-ui/core/TableContainer'), require('@material-ui/core/TableHead'), require('@material-ui/core/TablePagination'), require('@material-ui/core/TableRow'), require('@material-ui/core/styles'), require('@material-ui/icons/KeyboardArrowDown'), require('@material-ui/icons/KeyboardArrowLeft'), require('@material-ui/icons/KeyboardArrowRight'), require('@material-ui/icons/KeyboardArrowUp')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'styled-components', '@material-ui/icons/ArrowForward', '@material-ui/core', '@material-ui/core/CircularProgress', 'react-dom', '@material-ui/core/TextField', 'react-ga', 'uuid', '@material-ui/core/Box', '@material-ui/core/Collapse', '@material-ui/core/IconButton', '@material-ui/core/Paper', '@material-ui/core/Table', '@material-ui/core/TableBody', '@material-ui/core/TableCell', '@material-ui/core/TableContainer', '@material-ui/core/TableHead', '@material-ui/core/TablePagination', '@material-ui/core/TableRow', '@material-ui/core/styles', '@material-ui/icons/KeyboardArrowDown', '@material-ui/icons/KeyboardArrowLeft', '@material-ui/icons/KeyboardArrowRight', '@material-ui/icons/KeyboardArrowUp'], factory) :
  (global = global || self, factory(global.reactSampleComponentsLibrary = {}, global.React, global.styled, global.ArrowForward, global.core, global.CircularProgress, global.ReactDom, global.TextField, global.ReactGA, global.uuid, global.Box, global.Collapse, global.IconButton, global.Paper, global.Table, global.TableBody, global.TableCell, global.TableContainer, global.TableHead, global.TablePagination, global['TableRow '], global.styles, global.KeyboardArrowDown, global.KeyboardArrowLeft, global.KeyboardArrowRight, global.KeyboardArrowUp));
}(this, (function (exports, React$2, styled, ArrowForward, core, CircularProgress, ReactDOM, TextField, ReactGA, uuid, Box$2, Collapse, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, styles, KeyboardArrowDownIcon, KeyboardArrowLeftIcon, KeyboardArrowRightIcon, KeyboardArrowUpIcon) { 'use strict';

  var React$2__default = 'default' in React$2 ? React$2['default'] : React$2;
  var styled__default = 'default' in styled ? styled['default'] : styled;
  ArrowForward = ArrowForward && Object.prototype.hasOwnProperty.call(ArrowForward, 'default') ? ArrowForward['default'] : ArrowForward;
  CircularProgress = CircularProgress && Object.prototype.hasOwnProperty.call(CircularProgress, 'default') ? CircularProgress['default'] : CircularProgress;
  var ReactDOM__default = 'default' in ReactDOM ? ReactDOM['default'] : ReactDOM;
  TextField = TextField && Object.prototype.hasOwnProperty.call(TextField, 'default') ? TextField['default'] : TextField;
  ReactGA = ReactGA && Object.prototype.hasOwnProperty.call(ReactGA, 'default') ? ReactGA['default'] : ReactGA;
  Box$2 = Box$2 && Object.prototype.hasOwnProperty.call(Box$2, 'default') ? Box$2['default'] : Box$2;
  Collapse = Collapse && Object.prototype.hasOwnProperty.call(Collapse, 'default') ? Collapse['default'] : Collapse;
  IconButton = IconButton && Object.prototype.hasOwnProperty.call(IconButton, 'default') ? IconButton['default'] : IconButton;
  Paper = Paper && Object.prototype.hasOwnProperty.call(Paper, 'default') ? Paper['default'] : Paper;
  Table = Table && Object.prototype.hasOwnProperty.call(Table, 'default') ? Table['default'] : Table;
  TableBody = TableBody && Object.prototype.hasOwnProperty.call(TableBody, 'default') ? TableBody['default'] : TableBody;
  TableCell = TableCell && Object.prototype.hasOwnProperty.call(TableCell, 'default') ? TableCell['default'] : TableCell;
  TableContainer = TableContainer && Object.prototype.hasOwnProperty.call(TableContainer, 'default') ? TableContainer['default'] : TableContainer;
  TableHead = TableHead && Object.prototype.hasOwnProperty.call(TableHead, 'default') ? TableHead['default'] : TableHead;
  TablePagination = TablePagination && Object.prototype.hasOwnProperty.call(TablePagination, 'default') ? TablePagination['default'] : TablePagination;
  TableRow = TableRow && Object.prototype.hasOwnProperty.call(TableRow, 'default') ? TableRow['default'] : TableRow;
  KeyboardArrowDownIcon = KeyboardArrowDownIcon && Object.prototype.hasOwnProperty.call(KeyboardArrowDownIcon, 'default') ? KeyboardArrowDownIcon['default'] : KeyboardArrowDownIcon;
  KeyboardArrowLeftIcon = KeyboardArrowLeftIcon && Object.prototype.hasOwnProperty.call(KeyboardArrowLeftIcon, 'default') ? KeyboardArrowLeftIcon['default'] : KeyboardArrowLeftIcon;
  KeyboardArrowRightIcon = KeyboardArrowRightIcon && Object.prototype.hasOwnProperty.call(KeyboardArrowRightIcon, 'default') ? KeyboardArrowRightIcon['default'] : KeyboardArrowRightIcon;
  KeyboardArrowUpIcon = KeyboardArrowUpIcon && Object.prototype.hasOwnProperty.call(KeyboardArrowUpIcon, 'default') ? KeyboardArrowUpIcon['default'] : KeyboardArrowUpIcon;

  function _typeof(obj) {
    "@babel/helpers - typeof";

    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }

    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }

  function _asyncToGenerator(fn) {
    return function () {
      var self = this,
          args = arguments;
      return new Promise(function (resolve, reject) {
        var gen = fn.apply(self, args);

        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }

        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }

        _next(undefined);
      });
    };
  }

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _extends() {
    _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends.apply(this, arguments);
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};

    var target = _objectWithoutPropertiesLoose(source, excluded);

    var key, i;

    if (Object.getOwnPropertySymbols) {
      var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

      for (i = 0; i < sourceSymbolKeys.length; i++) {
        key = sourceSymbolKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
      }
    }

    return target;
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
      raw = strings.slice(0);
    }

    return Object.freeze(Object.defineProperties(strings, {
      raw: {
        value: Object.freeze(raw)
      }
    }));
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var numbers = {
    xs: 340,
    sm: 500,
    md: 800,
    lg: 1280,
    xl: 1920
  };
  var media = {
    up: function up(bp) {
      return "@media (min-width: ".concat(numbers[bp], "px)");
    },
    down: function down(bp) {
      return "@media (max-width: ".concat(numbers[bp], "px)");
    }
  };
  var breakpoints = _objectSpread2(_objectSpread2({}, numbers), media);

  var variables = {
    spacer: 8
  };

  var colors = {
    pink900: 'var(--pink900)',
    pink800: 'var(--pink800)',
    blue900: 'var(--brand900)',
    blue800: 'var(--brand800)',
    blue700: 'var(--brand700)',
    blue600: 'var(--brand600)',
    bluePrimary: 'var(--brandPrimary)',
    bluePrimaryLight: 'var(--brandPrimaryLight)',
    bluePrimaryDark: 'var(--brandPrimaryDark)',
    blueSecundary: 'var(--brandSecundary)',
    blueSecundaryLight: 'var(--brandSecundaryLight)',
    blueSecundaryDark: 'var(--brandSecundaryDark)',
    yellow900: 'var(--yellow900)',
    yellow800: 'var(--yellow800)',
    lilac900: 'var(--lilac900)',
    lilac800: 'var(--lilac800)',
    purple900: 'var(--purple900)',
    purple800: 'var(--purple800)',
    grey600: 'var(--grey600)',
    grey500: 'var(--grey500)',
    grey400: 'var(--grey400)',
    green100: 'var(--green100)',
    greyPrimary: 'var(--greyPrimary)',
    greyNeutral: 'var(--greyNeutral)',
    greyLight: 'var(--greyLight)',
    red100: 'var(--red100)',
    red200: 'var(--red200)',
    red300: 'var(--red300)',
    white100: 'var(--white100)',
    black100: 'var(--black100)'
  };

  var theme = {
    breakpoints: breakpoints,
    colors: colors,
    variables: variables
  };

  function _templateObject() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'CenturyGothicBold', sans serif;\n  text-decoration: underline;\n  cursor: pointer;\n  color: ", ";\n\n  ", " {\n    margin-top: ", "px 0;\n    font-size: 12px;\n  }\n"]);

    _templateObject = function _templateObject() {
      return data;
    };

    return data;
  }
  var TextLinkWrapped = styled__default.h5(_templateObject(), function (_ref) {
    var color = _ref.color;
    return color ? color : theme.colors.blue900;
  }, theme.breakpoints.down('md'), theme.variables.spacer * 2);

  /**
   * @typedef {object} TextLinkProps
   * @property {string} [text]
   * @property {() => void} [onClick]
   * @property {string} [color]
   * @property {string} [id]
   */

  /** @type {import('react').FC<TextLinkProps>} */

  var TextLink = function TextLink(_ref) {
    var text = _ref.text,
        onClick = _ref.onClick,
        color = _ref.color,
        id = _ref.id;
    return /*#__PURE__*/React$2__default.createElement(TextLinkWrapped, {
      color: color,
      onClick: onClick,
      id: id
    }, text);
  };

  function _templateObject5() {
    var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  margin: 0;\n  font-weight: bold;\n  color: ", ";\n"]);

    _templateObject5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4() {
    var data = _taggedTemplateLiteral(["\n      ", " {\n        border-radius: 0px !important;\n        width: 100%;\n        height: ", "px;\n      }\n    "]);

    _templateObject4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3() {
    var data = _taggedTemplateLiteral(["\n  float: none;\n  border-radius: ", "px !important;\n  background: ", " !important;\n  width: ", "px;\n  height: ", "px;\n\n  .MuiButton-label {\n    color: white;\n    font-weight: bold;\n    text-transform: none;\n    font-size: 16px;\n    font-family: 'CenturyGothic', sans-serif;\n  }\n\n  .MuiButton-contained&:hover {\n    background-color: var(--pink900) !important;\n  }\n\n  ", "\n"]);

    _templateObject3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2() {
    var data = _taggedTemplateLiteral(["\n      ", " {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        margin: 0;\n      }\n    "]);

    _templateObject2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$1() {
    var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  margin-left: ", "px;\n  margin-right: ", "px;\n\n  ", "\n\n  text-align: center;\n\n  ", "\n\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject$1 = function _templateObject() {
      return data;
    };

    return data;
  }
  var useStyles = core.makeStyles({
    icon: {
      fontSize: theme.variables.spacer * 2,
      marginLeft: 10
    }
  });
  var ContainerButton = styled__default.div(_templateObject$1(), function (_ref) {
    var marginVertical = _ref.marginVertical;
    return marginVertical;
  }, function (_ref2) {
    var marginVertical = _ref2.marginVertical;
    return marginVertical;
  }, function (_ref3) {
    var marginHorizontal = _ref3.marginHorizontal;
    return marginHorizontal;
  }, function (_ref4) {
    var marginHorizontal = _ref4.marginHorizontal;
    return marginHorizontal;
  }, function (_ref5) {
    var responsiveWidth = _ref5.responsiveWidth;
    var property = responsiveWidth ? 'min-width' : 'width';
    return "".concat(property, ": ").concat(theme.variables.spacer * 32, "px;");
  }, function (_ref6) {
    var persistFloatingMode = _ref6.persistFloatingMode;
    return persistFloatingMode === false && styled.css(_templateObject2(), theme.breakpoints.down('md'));
  }, theme.breakpoints.down('md'));
  var ButtonWrapper = styled__default(core.Button)(_templateObject3(), theme.variables.spacer * 4, function (_ref7) {
    var disabled = _ref7.disabled,
        backgroundDisabled = _ref7.backgroundDisabled;
    return disabled ? backgroundDisabled ? theme.colors.blue800 : theme.colors.grey600 : theme.colors.pink900;
  }, theme.variables.spacer * 32, theme.variables.spacer * 6, function (_ref8) {
    var persistFloatingMode = _ref8.persistFloatingMode;
    return persistFloatingMode === false && styled.css(_templateObject4(), theme.breakpoints.down('md'), theme.variables.spacer * 7);
  });
  var ButtonTitle = styled__default.p(_templateObject5(), theme.variables.spacer * 2, function (props) {
    return props.visuals ? props.visuals.buttonTextColor : theme.colors.white100;
  });

  /**
   * @typedef {object} ButtonProps
   * @property {string} id
   * @property {boolean} disabled
   * @property {() => void} onClick
   * @property {string} text
   * @property {string} [type=button]
   * @property {boolean} [textLink=false]
   * @property {boolean} backgroundDisabled
   * @property {JSX.Element} icon
   * @property {number} [marginVertical=24]
   * @property {number} [marginHorizontal=24]
   * @property {string} [variant=contained]
   * @property {boolean} responsiveWidth
   * @property {boolean} [persistFloatingMode=true]
   */

  /** @type {import('react').FC<ButtonProps>} */

  var Button = function Button(_ref) {
    var id = _ref.id,
        disabled = _ref.disabled,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
        text = _ref.text,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'button' : _ref$type,
        _ref$textLink = _ref.textLink,
        textLink = _ref$textLink === void 0 ? false : _ref$textLink,
        backgroundDisabled = _ref.backgroundDisabled,
        icon = _ref.icon,
        _ref$marginVertical = _ref.marginVertical,
        marginVertical = _ref$marginVertical === void 0 ? 24 : _ref$marginVertical,
        _ref$marginHorizontal = _ref.marginHorizontal,
        marginHorizontal = _ref$marginHorizontal === void 0 ? 24 : _ref$marginHorizontal,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
        responsiveWidth = _ref.responsiveWidth,
        _ref$persistFloatingM = _ref.persistFloatingMode,
        persistFloatingMode = _ref$persistFloatingM === void 0 ? true : _ref$persistFloatingM;
    var classes = useStyles();
    return /*#__PURE__*/React$2__default.createElement(ContainerButton, {
      id: id,
      marginVertical: marginVertical,
      marginHorizontal: marginHorizontal,
      responsiveWidth: responsiveWidth,
      persistFloatingMode: persistFloatingMode
    }, /*#__PURE__*/React$2__default.createElement(ButtonWrapper, {
      backgroundDisabled: backgroundDisabled,
      variant: variant,
      onClick: onClick,
      disabled: disabled,
      type: type,
      persistFloatingMode: persistFloatingMode
    }, text, icon || /*#__PURE__*/React$2__default.createElement(ArrowForward, {
      className: classes.icon
    })), textLink && /*#__PURE__*/React$2__default.createElement(TextLink, {
      text: textLink.text,
      onClick: textLink.onClick,
      color: textLink.color
    }));
  };

  function _templateObject5$1() {
    var data = _taggedTemplateLiteral(["\n  font-size: ", "px;\n  margin: 0;\n  font-weight: bold;\n  color: ", ";\n"]);

    _templateObject5$1 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$1() {
    var data = _taggedTemplateLiteral(["\n      ", " {\n        border-radius: 0px !important;\n        width: 100%;\n        height: ", "px;\n      }\n    "]);

    _templateObject4$1 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$1() {
    var data = _taggedTemplateLiteral(["\n  float: none;\n  border-radius: ", "px !important;\n  border: ", " !important;\n  background: ", " !important;\n  width: ", "px;\n  height: ", "px;\n\n  .MuiButton-label {\n    color: ", ";\n    font-weight: bold;\n    text-transform: none;\n    font-size: 16px;\n    font-family: 'Montserrat', sans-serif;\n  }\n\n  ", "\n"]);

    _templateObject3$1 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$1() {
    var data = _taggedTemplateLiteral(["\n      ", " {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        margin: 0;\n      }\n    "]);

    _templateObject2$1 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$2() {
    var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  margin-left: ", "px;\n  margin-right: ", "px;\n\n  ", "\n\n  text-align: center;\n\n  ", "\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject$2 = function _templateObject() {
      return data;
    };

    return data;
  }
  var useStyles$1 = core.makeStyles({
    icon: {
      fontSize: theme.variables.spacer * 2,
      marginLeft: 10
    }
  });
  var ContainerButton$1 = styled__default.div(_templateObject$2(), function (_ref) {
    var marginVertical = _ref.marginVertical;
    return marginVertical;
  }, function (_ref2) {
    var marginVertical = _ref2.marginVertical;
    return marginVertical;
  }, function (_ref3) {
    var marginHorizontal = _ref3.marginHorizontal;
    return marginHorizontal;
  }, function (_ref4) {
    var marginHorizontal = _ref4.marginHorizontal;
    return marginHorizontal;
  }, function (_ref5) {
    var responsiveWidth = _ref5.responsiveWidth;
    var property = responsiveWidth ? 'min-width' : 'width';
    return "".concat(property, ": ").concat(theme.variables.spacer * 32, "px;");
  }, function (_ref6) {
    var persistFloatingMode = _ref6.persistFloatingMode;
    return persistFloatingMode === false && styled.css(_templateObject2$1(), theme.breakpoints.down('md'));
  }, theme.breakpoints.down('md'));
  var ButtonWrapper$1 = styled__default(core.Button)(_templateObject3$1(), theme.variables.spacer * 0.8, function (_ref7) {
    var outline = _ref7.outline;
    return outline ? "2px solid ".concat(theme.colors.pink900) : 'none';
  }, function (_ref8) {
    var disabled = _ref8.disabled,
        backgroundDisabled = _ref8.backgroundDisabled,
        outline = _ref8.outline;
    return disabled ? backgroundDisabled ? theme.colors.blue800 : theme.colors.grey600 : outline ? theme.colors.white100 : theme.colors.pink900;
  }, theme.variables.spacer * 32, theme.variables.spacer * 6, function (_ref9) {
    var outline = _ref9.outline;
    return outline ? theme.colors.pink900 : theme.colors.white100;
  }, function (_ref10) {
    var persistFloatingMode = _ref10.persistFloatingMode;
    return persistFloatingMode === false && styled.css(_templateObject4$1(), theme.breakpoints.down('md'), theme.variables.spacer * 7);
  });
  var ButtonTitle$1 = styled__default.p(_templateObject5$1(), theme.variables.spacer * 2, function (props) {
    return props.visuals ? props.visuals.buttonTextColor : theme.colors.white100;
  });

  /**
   * @typedef {object} ButtonProps
   * @property {string} id
   * @property {boolean} disabled
   * @property {() => void} onClick
   * @property {string} text
   * @property {string} [type=button]
   * @property {boolean} [textLink=false]
   * @property {boolean} backgroundDisabled
   * @property {JSX.Element} icon
   * @property {number} [marginVertical=24]
   * @property {number} [marginHorizontal=24]
   * @property {string} [variant=contained]
   * @property {boolean} responsiveWidth
   * @property {boolean} [persistFloatingMode=true]
   * @property {boolean} [outline=false]
   */

  /** @type {import('react').FC<ButtonProps>} */

  var ButtonV2 = function ButtonV2(_ref) {
    var id = _ref.id,
        disabled = _ref.disabled,
        onClick = _ref.onClick,
        text = _ref.text,
        _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'button' : _ref$type,
        _ref$textLink = _ref.textLink,
        textLink = _ref$textLink === void 0 ? false : _ref$textLink,
        backgroundDisabled = _ref.backgroundDisabled,
        icon = _ref.icon,
        _ref$marginVertical = _ref.marginVertical,
        marginVertical = _ref$marginVertical === void 0 ? 24 : _ref$marginVertical,
        _ref$marginHorizontal = _ref.marginHorizontal,
        marginHorizontal = _ref$marginHorizontal === void 0 ? 24 : _ref$marginHorizontal,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? 'contained' : _ref$variant,
        responsiveWidth = _ref.responsiveWidth,
        _ref$persistFloatingM = _ref.persistFloatingMode,
        persistFloatingMode = _ref$persistFloatingM === void 0 ? true : _ref$persistFloatingM,
        _ref$outline = _ref.outline,
        outline = _ref$outline === void 0 ? false : _ref$outline;
    var classes = useStyles$1();
    return /*#__PURE__*/React$2__default.createElement(ContainerButton$1, {
      id: id,
      marginVertical: marginVertical,
      marginHorizontal: marginHorizontal,
      responsiveWidth: responsiveWidth,
      persistFloatingMode: persistFloatingMode
    }, /*#__PURE__*/React$2__default.createElement(ButtonWrapper$1, {
      backgroundDisabled: backgroundDisabled,
      variant: variant,
      onClick: onClick,
      disabled: disabled,
      type: type,
      persistFloatingMode: persistFloatingMode,
      outline: outline
    }, text, icon || /*#__PURE__*/React$2__default.createElement(ArrowForward, {
      className: classes.icon
    })), textLink && /*#__PURE__*/React$2__default.createElement(TextLink, {
      text: textLink.text,
      onClick: textLink.onClick,
      color: textLink.color
    }));
  };

  function _templateObject7() {
    var data = _taggedTemplateLiteral(["\n  border-radius: 4px;\n  width: 100%;\n  height: 100%;\n\n  .MuiCircularProgress-colorPrimary {\n    color: ", ";\n  }\n"]);

    _templateObject7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  width: fit-content;\n  height: 48px;\n  border-radius: 4px;\n\n  min-width: ", ";\n  height: ", ";\n\n  ", " {\n    min-width: ", ";\n  }\n\n  .MuiButton-root {\n    ", "\n  }\n\n  .MuiButton-label {\n    color: ", ";\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    letter-spacing: 0.005em;\n    text-transform: none;\n  }\n\n  :focus,\n  :focus-within {\n    outline: 2px auto ", ";\n    outline-offset: 2px;\n  }\n\n  .MuiButton-iconSizeMedium > *:first-child {\n    font-size: 24px;\n  }\n\n  ", " {\n    .MuiButton-label {\n      font-size: 13.2px;\n      line-height: 20px;\n    }\n\n    .MuiButton-iconSizeMedium > *:first-child {\n      font-size: 20px;\n    }\n  }\n"]);

    _templateObject6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$2() {
    var data = _taggedTemplateLiteral(["\n        background: ", ";\n\n        .MuiTouchRipple-ripple {\n          color: ", ";\n        }\n\n        :hover {\n          background: ", ";\n        }\n\n        :focus {\n          background: ", ";\n        }\n      "]);

    _templateObject5$2 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$2() {
    var data = _taggedTemplateLiteral(["\n        background: ", ";\n\n        .MuiTouchRipple-ripple {\n          color: ", ";\n        }\n\n        :hover {\n          background: ", ";\n        }\n\n        :focus {\n          background: ", ";\n        }\n      "]);

    _templateObject4$2 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$2() {
    var data = _taggedTemplateLiteral(["\n        background-color: ", ";\n\n        .MuiButton-label {\n          color: ", ";\n        }\n\n        .MuiTouchRipple-ripple {\n          color: ", ";\n        }\n\n        :hover {\n          background-color: ", ";\n        }\n\n        :focus {\n          background-color: ", ";\n        }\n      "]);

    _templateObject3$2 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$2() {
    var data = _taggedTemplateLiteral(["\n          &.MuiButton-contained.Mui-disabled {\n            background: ", ";\n          }\n\n          .MuiButton-label {\n            color: ", ";\n          }\n        "]);

    _templateObject2$2 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$3() {
    var data = _taggedTemplateLiteral(["\n          &.MuiButton-contained.Mui-disabled {\n            background: ", ";\n          }\n\n          .MuiButton-label {\n            color: ", ";\n          }\n        "]);

    _templateObject$3 = function _templateObject() {
      return data;
    };

    return data;
  }

  var handleColors = function handleColors(color, disabled) {
    if (disabled) {
      switch (color) {
        case 'primary':
          return styled.css(_templateObject$3(), theme.colors.greyLight, theme.colors.greyPrimary);

        default:
          return styled.css(_templateObject2$2(), theme.colors.white100, theme.colors.greyPrimary);
      }
    }

    switch (color) {
      case 'primary':
        return styled.css(_templateObject3$2(), theme.colors.bluePrimary, theme.colors.white100, theme.colors.bluePrimaryDark, theme.colors.blueSecundary, theme.colors.blueSecundary);

      case 'light':
        return styled.css(_templateObject4$2(), theme.colors.bluePrimaryLight, theme.colors.blueSecundaryDark, theme.colors.blueSecundaryLight, theme.colors.blueSecundaryLight);

      default:
        return styled.css(_templateObject5$2(), theme.colors.white100, theme.colors.blueSecundaryLight, theme.colors.bluePrimaryLight, theme.colors.bluePrimaryLight);
    }
  };

  var ButtonContainer = styled__default.div(_templateObject6(), function (_ref) {
    var buttonWidth = _ref.buttonWidth;
    return buttonWidth;
  }, function (_ref2) {
    var buttonHeight = _ref2.buttonHeight;
    return buttonHeight;
  }, theme.breakpoints.down('md'), function (_ref3) {
    var mobileWidth = _ref3.mobileWidth;
    return mobileWidth;
  }, function (_ref4) {
    var colorType = _ref4.colorType,
        isDisabled = _ref4.isDisabled;
    return handleColors(colorType, isDisabled);
  }, theme.colors.bluePrimaryDark, theme.colors.bluePrimary, theme.breakpoints.down('md'));
  var ButtonWrapper$2 = styled__default(core.Button)(_templateObject7(), theme.colors.greyPrimary);

  /**
   * @typedef {object} ButtonProps
   * @property {string} text
   * @property {'primary'|'light' | "var(--white100)"} [color='primary']
   * @property {string} [width='184px']
   * @property {string} [mobileWidth='148px']
   * @property {string} [height='48px']
   * @property {boolean} [disabled=false]
   * @property {boolean} [icon=false]
   * @property {object} [buttonProps={}}]
   * @property {boolean=} isLoading
   */

  var ButtonV3 = /*#__PURE__*/React$2.forwardRef(function (props, ref) {
    var _props$onClick = props.onClick,
        onClick = _props$onClick === void 0 ? function () {} : _props$onClick,
        _props$text = props.text,
        text = _props$text === void 0 ? '' : _props$text,
        _props$color = props.color,
        color = _props$color === void 0 ? 'primary' : _props$color,
        _props$width = props.width,
        width = _props$width === void 0 ? '184px' : _props$width,
        _props$mobileWidth = props.mobileWidth,
        mobileWidth = _props$mobileWidth === void 0 ? '148px' : _props$mobileWidth,
        _props$height = props.height,
        height = _props$height === void 0 ? '48px' : _props$height,
        _props$disabled = props.disabled,
        disabled = _props$disabled === void 0 ? false : _props$disabled,
        _props$icon = props.icon,
        icon = _props$icon === void 0 ? false : _props$icon,
        _props$buttonProps = props.buttonProps,
        buttonProps = _props$buttonProps === void 0 ? {} : _props$buttonProps,
        _props$isLoading = props.isLoading,
        isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
        rest = _objectWithoutProperties(props, ["onClick", "text", "color", "width", "mobileWidth", "height", "disabled", "icon", "buttonProps", "isLoading"]);

    var isDisabled = disabled || isLoading;
    return /*#__PURE__*/React$2__default.createElement(ButtonContainer, _extends({
      colorType: color,
      buttonWidth: width,
      mobileWidth: mobileWidth,
      buttonHeight: height,
      onClick: isDisabled ? null : onClick,
      isDisabled: disabled
    }, rest), /*#__PURE__*/React$2__default.createElement(ButtonWrapper$2, _extends({
      variant: "contained",
      endIcon: icon && !isLoading && /*#__PURE__*/React$2__default.createElement(ArrowForward, null),
      disableElevation: true,
      disableFocusRipple: true,
      disabled: isDisabled,
      ref: ref
    }, buttonProps), isLoading ? /*#__PURE__*/React$2__default.createElement(CircularProgress, {
      size: 24
    }) : text));
  });

  var BackArrow = function BackArrow(_ref) {
    var size = _ref.size,
        _ref$isDark = _ref.isDark,
        isDark = _ref$isDark === void 0 ? false : _ref$isDark;
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: size || 24,
      height: size || 24,
      viewBox: "0 0 24 24",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M19 12H5",
      stroke: isDark ? theme.colors.white100 : theme.colors.blue900,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M12 5L5 12L12 19",
      stroke: isDark ? theme.colors.white100 : theme.colors.blue900,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject2$3() {
    var data = _taggedTemplateLiteral(["\n  height: 100%;\n  position: fixed;\n  margin-left: 63px;\n  z-index: 5;\n"]);

    _templateObject2$3 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$4() {
    var data = _taggedTemplateLiteral(["\n  margin-top: 113px;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.6;\n  }\n"]);

    _templateObject$4 = function _templateObject() {
      return data;
    };

    return data;
  }
  var ContainerBackButton = styled__default.div(_templateObject$4());
  var ContainerSubHeader = styled__default.div(_templateObject2$3());

  /** @type {import('react').FC<{ functionBackButton: () => void, isDark: boolean }>} */

  var ButtonBackDesktop = function ButtonBackDesktop(_ref) {
    var functionBackButton = _ref.functionBackButton,
        _ref$isDark = _ref.isDark,
        isDark = _ref$isDark === void 0 ? false : _ref$isDark;
    return /*#__PURE__*/React$2__default.createElement(ContainerSubHeader, null, /*#__PURE__*/React$2__default.createElement(ContainerBackButton, {
      id: "desktopBackButton",
      onClick: functionBackButton
    }, /*#__PURE__*/React$2__default.createElement(BackArrow, {
      size: 32,
      isDark: isDark
    })));
  };

  function _templateObject3$3() {
    var data = _taggedTemplateLiteral(["\n        height: 100vh;\n        margin-top: 0;\n      "]);

    _templateObject3$3 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$4() {
    var data = _taggedTemplateLiteral(["\n      height: calc(100vh - 104px) !important;\n      top: 0 !important;\n    "]);

    _templateObject2$4 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$5() {
    var data = _taggedTemplateLiteral(["\n  margin-top: 104px;\n  padding-left: 130px;\n  box-sizing: border-box;\n  width: 100%;\n  z-index: 2;\n\n  ", "\n\n  ", " {\n    flex-direction: column;\n    overflow: auto;\n    padding-top: 24px;\n    padding-bottom: 48px;\n    padding-left: 24px;\n    padding-right: 24px;\n\n    height: calc(100vh - 104px) !important;\n\n    &::-webkit-scrollbar {\n      width: 0px;\n      background: transparent;\n    }\n\n    ", "\n  }\n\n  @media screen and (max-height: 650px) {\n    height: calc(100vh - 104px) !important;\n    margin-top: 104px;\n    top: 0 !important;\n  }\n"]);

    _templateObject$5 = function _templateObject() {
      return data;
    };

    return data;
  }
  var WrapperContainer = styled__default.div(_templateObject$5(), function (_ref) {
    var isMarginDesktop = _ref.isMarginDesktop;
    return isMarginDesktop && styled.css(_templateObject2$4());
  }, theme.breakpoints.down('md'), function (_ref2) {
    var isWithoutHeader = _ref2.isWithoutHeader;
    return isWithoutHeader && styled.css(_templateObject3$3());
  });

  /**
   * @typedef {object} ContainerProps
   * @property {boolean} [isMarginMobile]
   * @property {boolean} [isMarginDesktop]
   */

  /** @type {import('react').FC<ContainerProps>} */

  var Container = function Container(_ref) {
    var children = _ref.children,
        _ref$isMarginMobile = _ref.isMarginMobile,
        isMarginMobile = _ref$isMarginMobile === void 0 ? false : _ref$isMarginMobile,
        _ref$isMarginDesktop = _ref.isMarginDesktop,
        isMarginDesktop = _ref$isMarginDesktop === void 0 ? false : _ref$isMarginDesktop;
    return /*#__PURE__*/React$2__default.createElement(WrapperContainer, {
      isMarginDesktop: isMarginDesktop,
      isMarginMobile: isMarginMobile
    }, children);
  };

  /**
   * @typedef {object} EmojiProps
   * @property {string} symbol
   * @property {string} [label]
   */

  /** @type {import('react').FC<EmojiProps>} */

  var Emoji = function Emoji(_ref) {
    var _ref$label = _ref.label,
        label = _ref$label === void 0 ? '' : _ref$label,
        symbol = _ref.symbol;
    return /*#__PURE__*/React$2__default.createElement("span", {
      className: "emoji",
      role: "img",
      "aria-label": label || '',
      "aria-hidden": label ? 'false' : 'true'
    }, symbol);
  };

  function _templateObject4$3() {
    var data = _taggedTemplateLiteral(["\n  max-width: 82%;\n"]);

    _templateObject4$3 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$4() {
    var data = _taggedTemplateLiteral(["\n  max-width: 95%;\n"]);

    _templateObject3$4 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$5() {
    var data = _taggedTemplateLiteral(["\n  margin: auto;\n  padding: 0 20px;\n"]);

    _templateObject2$5 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$6() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  background: var(--white100);\n"]);

    _templateObject$6 = function _templateObject() {
      return data;
    };

    return data;
  }
  var Screen = styled__default.div(_templateObject$6());
  var BoundaryBox = styled__default.div(_templateObject2$5());
  var Error$1 = styled__default.img(_templateObject3$4());
  var Developer = styled__default.img(_templateObject4$3());

  const img = "data:image/png;base64,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";

  const img$1 = "data:image/png;base64,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";

  var Background = function Background() {
    return /*#__PURE__*/React$2__default.createElement(Screen, null, /*#__PURE__*/React$2__default.createElement(BoundaryBox, null, /*#__PURE__*/React$2__default.createElement(Error$1, {
      src: img
    })), /*#__PURE__*/React$2__default.createElement(BoundaryBox, null, /*#__PURE__*/React$2__default.createElement(Developer, {
      src: img$1
    })));
  };

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation. All rights reserved.
  Licensed under the Apache License, Version 2.0 (the "License"); you may not use
  this file except in compliance with the License. You may obtain a copy of the
  License at http://www.apache.org/licenses/LICENSE-2.0

  THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
  KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
  WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
  MERCHANTABLITY OR NON-INFRINGEMENT.

  See the Apache Version 2.0 License for specific language governing permissions
  and limitations under the License.
  ***************************************************************************** */

  var __assign = function() {
      __assign = Object.assign || function __assign(t) {
          for (var s, i = 1, n = arguments.length; i < n; i++) {
              s = arguments[i];
              for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
          }
          return t;
      };
      return __assign.apply(this, arguments);
  };

  function __read(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  function __spread() {
      for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read(arguments[i]));
      return ar;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  /**
   * Checks whether given value's type is an object literal
   * {@link isPlainObject}.
   *
   * @param wat A value to be checked.
   * @returns A boolean representing the result.
   */
  function isPlainObject(wat) {
      return Object.prototype.toString.call(wat) === '[object Object]';
  }
  /**
   * Checks whether given value has a then function.
   * @param wat A value to be checked.
   */
  function isThenable(wat) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return Boolean(wat && wat.then && typeof wat.then === 'function');
  }

  /**
   * Requires a module which is protected against bundler minification.
   *
   * @param request The module path to resolve
   */
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  function dynamicRequire(mod, request) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return mod.require(request);
  }
  /**
   * Checks whether we're in the Node.js or Browser environment
   *
   * @returns Answer to given question
   */
  function isNodeEnv() {
      return Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]';
  }
  var fallbackGlobalObject = {};
  /**
   * Safely get global scope object
   *
   * @returns Global scope object
   */
  function getGlobalObject() {
      return (isNodeEnv()
          ? global
          : typeof window !== 'undefined'
              ? window
              : typeof self !== 'undefined'
                  ? self
                  : fallbackGlobalObject);
  }
  /**
   * UUID4 generator
   *
   * @returns string Generated UUID4.
   */
  function uuid4() {
      var global = getGlobalObject();
      var crypto = global.crypto || global.msCrypto;
      if (!(crypto === void 0) && crypto.getRandomValues) {
          // Use window.crypto API if available
          var arr = new Uint16Array(8);
          crypto.getRandomValues(arr);
          // set 4 in byte 7
          // eslint-disable-next-line no-bitwise
          arr[3] = (arr[3] & 0xfff) | 0x4000;
          // set 2 most significant bits of byte 9 to '10'
          // eslint-disable-next-line no-bitwise
          arr[4] = (arr[4] & 0x3fff) | 0x8000;
          var pad = function (num) {
              var v = num.toString(16);
              while (v.length < 4) {
                  v = "0" + v;
              }
              return v;
          };
          return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
      }
      // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
      return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          // eslint-disable-next-line no-bitwise
          var r = (Math.random() * 16) | 0;
          // eslint-disable-next-line no-bitwise
          var v = c === 'x' ? r : (r & 0x3) | 0x8;
          return v.toString(16);
      });
  }
  /** JSDoc */
  function consoleSandbox(callback) {
      var global = getGlobalObject();
      var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
      if (!('console' in global)) {
          return callback();
      }
      var originalConsole = global.console;
      var wrappedLevels = {};
      // Restore all wrapped console methods
      levels.forEach(function (level) {
          if (level in global.console && originalConsole[level].__sentry_original__) {
              wrappedLevels[level] = originalConsole[level];
              originalConsole[level] = originalConsole[level].__sentry_original__;
          }
      });
      // Perform callback manipulations
      var result = callback();
      // Revert restoration to wrapped state
      Object.keys(wrappedLevels).forEach(function (level) {
          originalConsole[level] = wrappedLevels[level];
      });
      return result;
  }
  var INITIAL_TIME = Date.now();
  var prevNow = 0;
  var performanceFallback = {
      now: function () {
          var now = Date.now() - INITIAL_TIME;
          if (now < prevNow) {
              now = prevNow;
          }
          prevNow = now;
          return now;
      },
      timeOrigin: INITIAL_TIME,
  };
  var crossPlatformPerformance = (function () {
      if (isNodeEnv()) {
          try {
              var perfHooks = dynamicRequire(module, 'perf_hooks');
              return perfHooks.performance;
          }
          catch (_) {
              return performanceFallback;
          }
      }
      var performance = getGlobalObject().performance;
      if (!performance || !performance.now) {
          return performanceFallback;
      }
      // Polyfill for performance.timeOrigin.
      //
      // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
      // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
      if (performance.timeOrigin === undefined) {
          // As of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always a
          // valid fallback. In the absence of a initial time provided by the browser, fallback to INITIAL_TIME.
          // @ts-ignore ignored because timeOrigin is a readonly property but we want to override
          // eslint-disable-next-line deprecation/deprecation
          performance.timeOrigin = (performance.timing && performance.timing.navigationStart) || INITIAL_TIME;
      }
      return performance;
  })();
  /**
   * Returns a timestamp in seconds with milliseconds precision since the UNIX epoch calculated with the monotonic clock.
   */
  function timestampWithMs() {
      return (crossPlatformPerformance.timeOrigin + crossPlatformPerformance.now()) / 1000;
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  // TODO: Implement different loggers for different environments
  var global$1 = getGlobalObject();
  /** Prefix for logging strings */
  var PREFIX = 'Sentry Logger ';
  /** JSDoc */
  var Logger = /** @class */ (function () {
      /** JSDoc */
      function Logger() {
          this._enabled = false;
      }
      /** JSDoc */
      Logger.prototype.disable = function () {
          this._enabled = false;
      };
      /** JSDoc */
      Logger.prototype.enable = function () {
          this._enabled = true;
      };
      /** JSDoc */
      Logger.prototype.log = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
          }
          if (!this._enabled) {
              return;
          }
          consoleSandbox(function () {
              global$1.console.log(PREFIX + "[Log]: " + args.join(' '));
          });
      };
      /** JSDoc */
      Logger.prototype.warn = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
          }
          if (!this._enabled) {
              return;
          }
          consoleSandbox(function () {
              global$1.console.warn(PREFIX + "[Warn]: " + args.join(' '));
          });
      };
      /** JSDoc */
      Logger.prototype.error = function () {
          var args = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              args[_i] = arguments[_i];
          }
          if (!this._enabled) {
              return;
          }
          consoleSandbox(function () {
              global$1.console.error(PREFIX + "[Error]: " + args.join(' '));
          });
      };
      return Logger;
  }());
  // Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
  global$1.__SENTRY__ = global$1.__SENTRY__ || {};
  var logger = global$1.__SENTRY__.logger || (global$1.__SENTRY__.logger = new Logger());

  /* eslint-disable @typescript-eslint/explicit-function-return-type */
  /** SyncPromise internal states */
  var States;
  (function (States) {
      /** Pending */
      States["PENDING"] = "PENDING";
      /** Resolved / OK */
      States["RESOLVED"] = "RESOLVED";
      /** Rejected / Error */
      States["REJECTED"] = "REJECTED";
  })(States || (States = {}));
  /**
   * Thenable class that behaves like a Promise and follows it's interface
   * but is not async internally
   */
  var SyncPromise = /** @class */ (function () {
      function SyncPromise(executor) {
          var _this = this;
          this._state = States.PENDING;
          this._handlers = [];
          /** JSDoc */
          this._resolve = function (value) {
              _this._setResult(States.RESOLVED, value);
          };
          /** JSDoc */
          this._reject = function (reason) {
              _this._setResult(States.REJECTED, reason);
          };
          /** JSDoc */
          this._setResult = function (state, value) {
              if (_this._state !== States.PENDING) {
                  return;
              }
              if (isThenable(value)) {
                  value.then(_this._resolve, _this._reject);
                  return;
              }
              _this._state = state;
              _this._value = value;
              _this._executeHandlers();
          };
          // TODO: FIXME
          /** JSDoc */
          this._attachHandler = function (handler) {
              _this._handlers = _this._handlers.concat(handler);
              _this._executeHandlers();
          };
          /** JSDoc */
          this._executeHandlers = function () {
              if (_this._state === States.PENDING) {
                  return;
              }
              var cachedHandlers = _this._handlers.slice();
              _this._handlers = [];
              cachedHandlers.forEach(function (handler) {
                  if (handler.done) {
                      return;
                  }
                  if (_this._state === States.RESOLVED) {
                      if (handler.onfulfilled) {
                          // eslint-disable-next-line @typescript-eslint/no-floating-promises
                          handler.onfulfilled(_this._value);
                      }
                  }
                  if (_this._state === States.REJECTED) {
                      if (handler.onrejected) {
                          handler.onrejected(_this._value);
                      }
                  }
                  handler.done = true;
              });
          };
          try {
              executor(this._resolve, this._reject);
          }
          catch (e) {
              this._reject(e);
          }
      }
      /** JSDoc */
      SyncPromise.resolve = function (value) {
          return new SyncPromise(function (resolve) {
              resolve(value);
          });
      };
      /** JSDoc */
      SyncPromise.reject = function (reason) {
          return new SyncPromise(function (_, reject) {
              reject(reason);
          });
      };
      /** JSDoc */
      SyncPromise.all = function (collection) {
          return new SyncPromise(function (resolve, reject) {
              if (!Array.isArray(collection)) {
                  reject(new TypeError("Promise.all requires an array as input."));
                  return;
              }
              if (collection.length === 0) {
                  resolve([]);
                  return;
              }
              var counter = collection.length;
              var resolvedCollection = [];
              collection.forEach(function (item, index) {
                  SyncPromise.resolve(item)
                      .then(function (value) {
                      resolvedCollection[index] = value;
                      counter -= 1;
                      if (counter !== 0) {
                          return;
                      }
                      resolve(resolvedCollection);
                  })
                      .then(null, reject);
              });
          });
      };
      /** JSDoc */
      SyncPromise.prototype.then = function (onfulfilled, onrejected) {
          var _this = this;
          return new SyncPromise(function (resolve, reject) {
              _this._attachHandler({
                  done: false,
                  onfulfilled: function (result) {
                      if (!onfulfilled) {
                          // TODO: ¯\_(ツ)_/¯
                          // TODO: FIXME
                          resolve(result);
                          return;
                      }
                      try {
                          resolve(onfulfilled(result));
                          return;
                      }
                      catch (e) {
                          reject(e);
                          return;
                      }
                  },
                  onrejected: function (reason) {
                      if (!onrejected) {
                          reject(reason);
                          return;
                      }
                      try {
                          resolve(onrejected(reason));
                          return;
                      }
                      catch (e) {
                          reject(e);
                          return;
                      }
                  },
              });
          });
      };
      /** JSDoc */
      SyncPromise.prototype.catch = function (onrejected) {
          return this.then(function (val) { return val; }, onrejected);
      };
      /** JSDoc */
      SyncPromise.prototype.finally = function (onfinally) {
          var _this = this;
          return new SyncPromise(function (resolve, reject) {
              var val;
              var isRejected;
              return _this.then(function (value) {
                  isRejected = false;
                  val = value;
                  if (onfinally) {
                      onfinally();
                  }
              }, function (reason) {
                  isRejected = true;
                  val = reason;
                  if (onfinally) {
                      onfinally();
                  }
              }).then(function () {
                  if (isRejected) {
                      reject(val);
                      return;
                  }
                  resolve(val);
              });
          });
      };
      /** JSDoc */
      SyncPromise.prototype.toString = function () {
          return '[object SyncPromise]';
      };
      return SyncPromise;
  }());

  /**
   * Holds additional event information. {@link Scope.applyToEvent} will be
   * called by the client before an event will be sent.
   */
  var Scope = /** @class */ (function () {
      function Scope() {
          /** Flag if notifiying is happening. */
          this._notifyingListeners = false;
          /** Callback for client to receive scope changes. */
          this._scopeListeners = [];
          /** Callback list that will be called after {@link applyToEvent}. */
          this._eventProcessors = [];
          /** Array of breadcrumbs. */
          this._breadcrumbs = [];
          /** User */
          this._user = {};
          /** Tags */
          this._tags = {};
          /** Extra */
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this._extra = {};
          /** Contexts */
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          this._contexts = {};
      }
      /**
       * Inherit values from the parent scope.
       * @param scope to clone.
       */
      Scope.clone = function (scope) {
          var newScope = new Scope();
          if (scope) {
              newScope._breadcrumbs = __spread(scope._breadcrumbs);
              newScope._tags = __assign({}, scope._tags);
              newScope._extra = __assign({}, scope._extra);
              newScope._contexts = __assign({}, scope._contexts);
              newScope._user = scope._user;
              newScope._level = scope._level;
              newScope._span = scope._span;
              newScope._transactionName = scope._transactionName;
              newScope._fingerprint = scope._fingerprint;
              newScope._eventProcessors = __spread(scope._eventProcessors);
          }
          return newScope;
      };
      /**
       * Add internal on change listener. Used for sub SDKs that need to store the scope.
       * @hidden
       */
      Scope.prototype.addScopeListener = function (callback) {
          this._scopeListeners.push(callback);
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.addEventProcessor = function (callback) {
          this._eventProcessors.push(callback);
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setUser = function (user) {
          this._user = user || {};
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setTags = function (tags) {
          this._tags = __assign(__assign({}, this._tags), tags);
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setTag = function (key, value) {
          var _a;
          this._tags = __assign(__assign({}, this._tags), (_a = {}, _a[key] = value, _a));
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setExtras = function (extras) {
          this._extra = __assign(__assign({}, this._extra), extras);
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setExtra = function (key, extra) {
          var _a;
          this._extra = __assign(__assign({}, this._extra), (_a = {}, _a[key] = extra, _a));
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setFingerprint = function (fingerprint) {
          this._fingerprint = fingerprint;
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setLevel = function (level) {
          this._level = level;
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setTransactionName = function (name) {
          this._transactionName = name;
          this._notifyScopeListeners();
          return this;
      };
      /**
       * Can be removed in major version.
       * @deprecated in favor of {@link this.setTransactionName}
       */
      Scope.prototype.setTransaction = function (name) {
          return this.setTransactionName(name);
      };
      /**
       * @inheritDoc
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Scope.prototype.setContext = function (key, context) {
          var _a;
          this._contexts = __assign(__assign({}, this._contexts), (_a = {}, _a[key] = context, _a));
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.setSpan = function (span) {
          this._span = span;
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.getSpan = function () {
          return this._span;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.getTransaction = function () {
          var span = this.getSpan();
          if (span && span.spanRecorder && span.spanRecorder.spans[0]) {
              return span.spanRecorder.spans[0];
          }
          return undefined;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.update = function (captureContext) {
          if (!captureContext) {
              return this;
          }
          if (typeof captureContext === 'function') {
              var updatedScope = captureContext(this);
              return updatedScope instanceof Scope ? updatedScope : this;
          }
          if (captureContext instanceof Scope) {
              this._tags = __assign(__assign({}, this._tags), captureContext._tags);
              this._extra = __assign(__assign({}, this._extra), captureContext._extra);
              this._contexts = __assign(__assign({}, this._contexts), captureContext._contexts);
              if (captureContext._user) {
                  this._user = captureContext._user;
              }
              if (captureContext._level) {
                  this._level = captureContext._level;
              }
              if (captureContext._fingerprint) {
                  this._fingerprint = captureContext._fingerprint;
              }
          }
          else if (isPlainObject(captureContext)) {
              // eslint-disable-next-line no-param-reassign
              captureContext = captureContext;
              this._tags = __assign(__assign({}, this._tags), captureContext.tags);
              this._extra = __assign(__assign({}, this._extra), captureContext.extra);
              this._contexts = __assign(__assign({}, this._contexts), captureContext.contexts);
              if (captureContext.user) {
                  this._user = captureContext.user;
              }
              if (captureContext.level) {
                  this._level = captureContext.level;
              }
              if (captureContext.fingerprint) {
                  this._fingerprint = captureContext.fingerprint;
              }
          }
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.clear = function () {
          this._breadcrumbs = [];
          this._tags = {};
          this._extra = {};
          this._user = {};
          this._contexts = {};
          this._level = undefined;
          this._transactionName = undefined;
          this._fingerprint = undefined;
          this._span = undefined;
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
          var mergedBreadcrumb = __assign({ timestamp: timestampWithMs() }, breadcrumb);
          this._breadcrumbs =
              maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0
                  ? __spread(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxBreadcrumbs)
                  : __spread(this._breadcrumbs, [mergedBreadcrumb]);
          this._notifyScopeListeners();
          return this;
      };
      /**
       * @inheritDoc
       */
      Scope.prototype.clearBreadcrumbs = function () {
          this._breadcrumbs = [];
          this._notifyScopeListeners();
          return this;
      };
      /**
       * Applies the current context and fingerprint to the event.
       * Note that breadcrumbs will be added by the client.
       * Also if the event has already breadcrumbs on it, we do not merge them.
       * @param event Event
       * @param hint May contain additional informartion about the original exception.
       * @hidden
       */
      Scope.prototype.applyToEvent = function (event, hint) {
          if (this._extra && Object.keys(this._extra).length) {
              event.extra = __assign(__assign({}, this._extra), event.extra);
          }
          if (this._tags && Object.keys(this._tags).length) {
              event.tags = __assign(__assign({}, this._tags), event.tags);
          }
          if (this._user && Object.keys(this._user).length) {
              event.user = __assign(__assign({}, this._user), event.user);
          }
          if (this._contexts && Object.keys(this._contexts).length) {
              event.contexts = __assign(__assign({}, this._contexts), event.contexts);
          }
          if (this._level) {
              event.level = this._level;
          }
          if (this._transactionName) {
              event.transaction = this._transactionName;
          }
          // We want to set the trace context for normal events only if there isn't already
          // a trace context on the event. There is a product feature in place where we link
          // errors with transaction and it relys on that.
          if (this._span) {
              event.contexts = __assign({ trace: this._span.getTraceContext() }, event.contexts);
          }
          this._applyFingerprint(event);
          event.breadcrumbs = __spread((event.breadcrumbs || []), this._breadcrumbs);
          event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
          return this._notifyEventProcessors(__spread(getGlobalEventProcessors(), this._eventProcessors), event, hint);
      };
      /**
       * This will be called after {@link applyToEvent} is finished.
       */
      Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
          var _this = this;
          if (index === void 0) { index = 0; }
          return new SyncPromise(function (resolve, reject) {
              var processor = processors[index];
              if (event === null || typeof processor !== 'function') {
                  resolve(event);
              }
              else {
                  var result = processor(__assign({}, event), hint);
                  if (isThenable(result)) {
                      result
                          .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                          .then(null, reject);
                  }
                  else {
                      _this._notifyEventProcessors(processors, result, hint, index + 1)
                          .then(resolve)
                          .then(null, reject);
                  }
              }
          });
      };
      /**
       * This will be called on every set call.
       */
      Scope.prototype._notifyScopeListeners = function () {
          var _this = this;
          if (!this._notifyingListeners) {
              this._notifyingListeners = true;
              setTimeout(function () {
                  _this._scopeListeners.forEach(function (callback) {
                      callback(_this);
                  });
                  _this._notifyingListeners = false;
              });
          }
      };
      /**
       * Applies fingerprint from the scope to the event if there's one,
       * uses message if there's one instead or get rid of empty fingerprint
       */
      Scope.prototype._applyFingerprint = function (event) {
          // Make sure it's an array first and we actually have something in place
          event.fingerprint = event.fingerprint
              ? Array.isArray(event.fingerprint)
                  ? event.fingerprint
                  : [event.fingerprint]
              : [];
          // If we have something on the scope, then merge it with event
          if (this._fingerprint) {
              event.fingerprint = event.fingerprint.concat(this._fingerprint);
          }
          // If we have no data at all, remove empty array default
          if (event.fingerprint && !event.fingerprint.length) {
              delete event.fingerprint;
          }
      };
      return Scope;
  }());
  /**
   * Retruns the global event processors.
   */
  function getGlobalEventProcessors() {
      var global = getGlobalObject();
      global.__SENTRY__ = global.__SENTRY__ || {};
      global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
      return global.__SENTRY__.globalEventProcessors;
  }

  /**
   * API compatibility version of this hub.
   *
   * WARNING: This number should only be increased when the global interface
   * changes and new methods are introduced.
   *
   * @hidden
   */
  var API_VERSION = 3;
  /**
   * Default maximum number of breadcrumbs added to an event. Can be overwritten
   * with {@link Options.maxBreadcrumbs}.
   */
  var DEFAULT_BREADCRUMBS = 100;
  /**
   * Absolute maximum number of breadcrumbs added to an event. The
   * `maxBreadcrumbs` option cannot be higher than this value.
   */
  var MAX_BREADCRUMBS = 100;
  /**
   * @inheritDoc
   */
  var Hub = /** @class */ (function () {
      /**
       * Creates a new instance of the hub, will push one {@link Layer} into the
       * internal stack on creation.
       *
       * @param client bound to the hub.
       * @param scope bound to the hub.
       * @param version number, higher number means higher priority.
       */
      function Hub(client, scope, _version) {
          if (scope === void 0) { scope = new Scope(); }
          if (_version === void 0) { _version = API_VERSION; }
          this._version = _version;
          /** Is a {@link Layer}[] containing the client and scope */
          this._stack = [];
          this._stack.push({ client: client, scope: scope });
          this.bindClient(client);
      }
      /**
       * @inheritDoc
       */
      Hub.prototype.isOlderThan = function (version) {
          return this._version < version;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.bindClient = function (client) {
          var top = this.getStackTop();
          top.client = client;
          if (client && client.setupIntegrations) {
              client.setupIntegrations();
          }
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.pushScope = function () {
          // We want to clone the content of prev scope
          var stack = this.getStack();
          var parentScope = stack.length > 0 ? stack[stack.length - 1].scope : undefined;
          var scope = Scope.clone(parentScope);
          this.getStack().push({
              client: this.getClient(),
              scope: scope,
          });
          return scope;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.popScope = function () {
          return this.getStack().pop() !== undefined;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.withScope = function (callback) {
          var scope = this.pushScope();
          try {
              callback(scope);
          }
          finally {
              this.popScope();
          }
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.getClient = function () {
          return this.getStackTop().client;
      };
      /** Returns the scope of the top stack. */
      Hub.prototype.getScope = function () {
          return this.getStackTop().scope;
      };
      /** Returns the scope stack for domains or the process. */
      Hub.prototype.getStack = function () {
          return this._stack;
      };
      /** Returns the topmost scope layer in the order domain > local > process. */
      Hub.prototype.getStackTop = function () {
          return this._stack[this._stack.length - 1];
      };
      /**
       * @inheritDoc
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
      Hub.prototype.captureException = function (exception, hint) {
          var eventId = (this._lastEventId = uuid4());
          var finalHint = hint;
          // If there's no explicit hint provided, mimick the same thing that would happen
          // in the minimal itself to create a consistent behavior.
          // We don't do this in the client, as it's the lowest level API, and doing this,
          // would prevent user from having full control over direct calls.
          if (!hint) {
              var syntheticException = void 0;
              try {
                  throw new Error('Sentry syntheticException');
              }
              catch (exception) {
                  syntheticException = exception;
              }
              finalHint = {
                  originalException: exception,
                  syntheticException: syntheticException,
              };
          }
          this._invokeClient('captureException', exception, __assign(__assign({}, finalHint), { event_id: eventId }));
          return eventId;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.captureMessage = function (message, level, hint) {
          var eventId = (this._lastEventId = uuid4());
          var finalHint = hint;
          // If there's no explicit hint provided, mimick the same thing that would happen
          // in the minimal itself to create a consistent behavior.
          // We don't do this in the client, as it's the lowest level API, and doing this,
          // would prevent user from having full control over direct calls.
          if (!hint) {
              var syntheticException = void 0;
              try {
                  throw new Error(message);
              }
              catch (exception) {
                  syntheticException = exception;
              }
              finalHint = {
                  originalException: message,
                  syntheticException: syntheticException,
              };
          }
          this._invokeClient('captureMessage', message, level, __assign(__assign({}, finalHint), { event_id: eventId }));
          return eventId;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.captureEvent = function (event, hint) {
          var eventId = (this._lastEventId = uuid4());
          this._invokeClient('captureEvent', event, __assign(__assign({}, hint), { event_id: eventId }));
          return eventId;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.lastEventId = function () {
          return this._lastEventId;
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
          var top = this.getStackTop();
          if (!top.scope || !top.client) {
              return;
          }
          // eslint-disable-next-line @typescript-eslint/unbound-method
          var _a = (top.client.getOptions && top.client.getOptions()) || {}, _b = _a.beforeBreadcrumb, beforeBreadcrumb = _b === void 0 ? null : _b, _c = _a.maxBreadcrumbs, maxBreadcrumbs = _c === void 0 ? DEFAULT_BREADCRUMBS : _c;
          if (maxBreadcrumbs <= 0) {
              return;
          }
          var timestamp = timestampWithMs();
          var mergedBreadcrumb = __assign({ timestamp: timestamp }, breadcrumb);
          var finalBreadcrumb = beforeBreadcrumb
              ? consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
              : mergedBreadcrumb;
          if (finalBreadcrumb === null) {
              return;
          }
          top.scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, MAX_BREADCRUMBS));
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.setUser = function (user) {
          var top = this.getStackTop();
          if (!top.scope) {
              return;
          }
          top.scope.setUser(user);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.setTags = function (tags) {
          var top = this.getStackTop();
          if (!top.scope) {
              return;
          }
          top.scope.setTags(tags);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.setExtras = function (extras) {
          var top = this.getStackTop();
          if (!top.scope) {
              return;
          }
          top.scope.setExtras(extras);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.setTag = function (key, value) {
          var top = this.getStackTop();
          if (!top.scope) {
              return;
          }
          top.scope.setTag(key, value);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.setExtra = function (key, extra) {
          var top = this.getStackTop();
          if (!top.scope) {
              return;
          }
          top.scope.setExtra(key, extra);
      };
      /**
       * @inheritDoc
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Hub.prototype.setContext = function (name, context) {
          var top = this.getStackTop();
          if (!top.scope) {
              return;
          }
          top.scope.setContext(name, context);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.configureScope = function (callback) {
          var top = this.getStackTop();
          if (top.scope && top.client) {
              callback(top.scope);
          }
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.run = function (callback) {
          var oldHub = makeMain(this);
          try {
              callback(this);
          }
          finally {
              makeMain(oldHub);
          }
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.getIntegration = function (integration) {
          var client = this.getClient();
          if (!client) {
              return null;
          }
          try {
              return client.getIntegration(integration);
          }
          catch (_oO) {
              logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
              return null;
          }
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.startSpan = function (context) {
          return this._callExtensionMethod('startSpan', context);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.startTransaction = function (context) {
          return this._callExtensionMethod('startTransaction', context);
      };
      /**
       * @inheritDoc
       */
      Hub.prototype.traceHeaders = function () {
          return this._callExtensionMethod('traceHeaders');
      };
      /**
       * Internal helper function to call a method on the top client if it exists.
       *
       * @param method The method to call on the client.
       * @param args Arguments to pass to the client function.
       */
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Hub.prototype._invokeClient = function (method) {
          var _a;
          var args = [];
          for (var _i = 1; _i < arguments.length; _i++) {
              args[_i - 1] = arguments[_i];
          }
          var top = this.getStackTop();
          if (top && top.client && top.client[method]) {
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
              (_a = top.client)[method].apply(_a, __spread(args, [top.scope]));
          }
      };
      /**
       * Calls global extension method and binding current instance to the function call
       */
      // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      Hub.prototype._callExtensionMethod = function (method) {
          var args = [];
          for (var _i = 1; _i < arguments.length; _i++) {
              args[_i - 1] = arguments[_i];
          }
          var carrier = getMainCarrier();
          var sentry = carrier.__SENTRY__;
          if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
              return sentry.extensions[method].apply(this, args);
          }
          logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
      };
      return Hub;
  }());
  /** Returns the global shim registry. */
  function getMainCarrier() {
      var carrier = getGlobalObject();
      carrier.__SENTRY__ = carrier.__SENTRY__ || {
          extensions: {},
          hub: undefined,
      };
      return carrier;
  }
  /**
   * Replaces the current main hub with the passed one on the global object
   *
   * @returns The old replaced hub
   */
  function makeMain(hub) {
      var registry = getMainCarrier();
      var oldHub = getHubFromCarrier(registry);
      setHubOnCarrier(registry, hub);
      return oldHub;
  }
  /**
   * Returns the default hub instance.
   *
   * If a hub is already registered in the global carrier but this module
   * contains a more recent version, it replaces the registered version.
   * Otherwise, the currently registered hub will be returned.
   */
  function getCurrentHub() {
      // Get main carrier (global for every environment)
      var registry = getMainCarrier();
      // If there's no hub, or its an old API, assign a new one
      if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
          setHubOnCarrier(registry, new Hub());
      }
      // Prefer domains over global if they are there (applicable only to Node environment)
      if (isNodeEnv()) {
          return getHubFromActiveDomain(registry);
      }
      // Return hub that lives on a global object
      return getHubFromCarrier(registry);
  }
  /**
   * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
   * @returns discovered hub
   */
  function getHubFromActiveDomain(registry) {
      try {
          var property = 'domain';
          var carrier = getMainCarrier();
          var sentry = carrier.__SENTRY__;
          if (!sentry || !sentry.extensions || !sentry.extensions[property]) {
              return getHubFromCarrier(registry);
          }
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          var domain = sentry.extensions[property];
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
          var activeDomain = domain.active;
          // If there's no active domain, just return global hub
          if (!activeDomain) {
              return getHubFromCarrier(registry);
          }
          // If there's no hub on current domain, or it's an old API, assign a new one
          if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
              var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
              setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
          }
          // Return hub that lives on a domain
          return getHubFromCarrier(activeDomain);
      }
      catch (_Oo) {
          // Return hub that lives on a global object
          return getHubFromCarrier(registry);
      }
  }
  /**
   * This will tell whether a carrier has a hub on it or not
   * @param carrier object
   */
  function hasHubOnCarrier(carrier) {
      if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
          return true;
      }
      return false;
  }
  /**
   * This will create a new {@link Hub} and add to the passed object on
   * __SENTRY__.hub.
   * @param carrier object
   * @hidden
   */
  function getHubFromCarrier(carrier) {
      if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) {
          return carrier.__SENTRY__.hub;
      }
      carrier.__SENTRY__ = carrier.__SENTRY__ || {};
      carrier.__SENTRY__.hub = new Hub();
      return carrier.__SENTRY__.hub;
  }
  /**
   * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
   * @param carrier object
   * @param hub Hub
   */
  function setHubOnCarrier(carrier, hub) {
      if (!carrier) {
          return false;
      }
      carrier.__SENTRY__ = carrier.__SENTRY__ || {};
      carrier.__SENTRY__.hub = hub;
      return true;
  }

  /**
   * This calls a function on the current hub.
   * @param method function to call on hub.
   * @param args to pass to function.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function callOnHub(method) {
      var args = [];
      for (var _i = 1; _i < arguments.length; _i++) {
          args[_i - 1] = arguments[_i];
      }
      var hub = getCurrentHub();
      if (hub && hub[method]) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          return hub[method].apply(hub, __spread(args));
      }
      throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
  }
  /**
   * Captures an exception event and sends it to Sentry.
   *
   * @param exception An exception-like object.
   * @returns The generated eventId.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  function captureException(exception, captureContext) {
      var syntheticException;
      try {
          throw new Error('Sentry syntheticException');
      }
      catch (exception) {
          syntheticException = exception;
      }
      return callOnHub('captureException', exception, {
          captureContext: captureContext,
          originalException: exception,
          syntheticException: syntheticException,
      });
  }

  var logger$1 = (function (_ref) {
    var error = _ref.error,
        info = _ref.info;
    if (process.env.REACT_APP_FIREBASE_ENV !== 'production') return;
    captureException(_objectSpread2(_objectSpread2({}, error), info));
  });

  var ErrorBoundary = /*#__PURE__*/function (_Component) {
    _inherits(ErrorBoundary, _Component);

    var _super = _createSuper(ErrorBoundary);

    function ErrorBoundary(props) {
      var _this;

      _classCallCheck(this, ErrorBoundary);

      _this = _super.call(this, props);
      _this.state = {
        hasError: false
      };
      return _this;
    }

    _createClass(ErrorBoundary, [{
      key: "componentDidCatch",
      value: function componentDidCatch(error, info) {
        logger$1({
          error: error,
          info: info
        });
      }
    }, {
      key: "render",
      value: function render() {
        var hasError = this.state.hasError;
        var _this$props = this.props,
            history = _this$props.history,
            children = _this$props.children;

        if (hasError) {
          return /*#__PURE__*/React$2__default.createElement(Background, {
            history: history
          });
        }

        return children;
      }
    }], [{
      key: "getDerivedStateFromError",
      value: function getDerivedStateFromError() {
        return {
          hasError: true
        };
      }
    }]);

    return ErrorBoundary;
  }(React$2.Component);

  function _templateObject$7() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

    _templateObject$7 = function _templateObject() {
      return data;
    };

    return data;
  }
  var Form = styled__default.form(_templateObject$7());

  var Check = function Check() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "9",
      height: "7",
      viewBox: "0 0 9 7",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M8 1L3.1875 6L1 3.72727",
      stroke: "#89D747",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject6$1() {
    var data = _taggedTemplateLiteral(["\n  height: 52px;\n  width: 100%;\n  display: flex;\n"]);

    _templateObject6$1 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$3() {
    var data = _taggedTemplateLiteral(["\n  height: 4px;\n  width: ", "%;\n  background-color: var(--brandSecundary);\n  transition: width 1s;\n"]);

    _templateObject5$3 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$4() {
    var data = _taggedTemplateLiteral(["\n  letter-spacing: 2px;\n  font-family: Teko, sans-serif;\n  font-weight: bold;\n  color: ", ";\n  font-size: 12px;\n  margin: 0;\n  ", " {\n    font-size: 11px;\n  }\n"]);

    _templateObject4$4 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$5() {
    var data = _taggedTemplateLiteral(["\n  letter-spacing: 2px;\n  font-family: Teko, sans-serif;\n  font-weight: bold;\n  color: ", ";\n  font-size: 12px;\n  margin: 0;\n  ", " {\n    font-size: 11px;\n  }\n"]);

    _templateObject3$5 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$6() {
    var data = _taggedTemplateLiteral(["\n  background-color: ", ";\n  padding-left: ", "px;\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  width: 50%;\n  ", " {\n    padding-left: ", "px;\n  }\n"]);

    _templateObject2$6 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$8() {
    var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: 100%;\n  display: flex;\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  flex-direction: column;\n  z-index: 10;\n"]);

    _templateObject$8 = function _templateObject() {
      return data;
    };

    return data;
  }
  var ContainerHeader = styled__default.div(_templateObject$8(), theme.variables.spacer * 6.5);
  var ItemHeader = styled__default.div(_templateObject2$6(), function (_ref) {
    var active = _ref.active;
    return !active ? 'var(--brand900)' : 'var(--black100)';
  }, theme.variables.spacer * 6.5, theme.breakpoints.down('md'), theme.variables.spacer * 2);
  var Title = styled__default.h3(_templateObject3$5(), function (_ref2) {
    var active = _ref2.active;
    return active ? 'var(--brandSecundary);' : 'rgba(255, 255, 255, 0.7);';
  }, theme.breakpoints.down('md'));
  var Text = styled__default.p(_templateObject4$4(), function (_ref3) {
    var active = _ref3.active;
    return active ? theme.colors.grey400 : 'rgba(255, 255, 255, 0.7);';
  }, theme.breakpoints.down('md'));
  var Progress = styled__default.div(_templateObject5$3(), function (_ref4) {
    var value = _ref4.value,
        total = _ref4.total;
    return value / total * 100;
  });
  var WrapperItens = styled__default.div(_templateObject6$1());

  var defaultOptions = [{
    title: 'PARTE 1',
    text: 'INTRODUÇÃO',
    active: true,
    complete: false
  }, {
    title: 'PARTE 2',
    text: 'INFOS BÁSICAS',
    active: false,
    complete: false
  }, {
    title: 'PARTE 3',
    text: 'DOCUMENTOS',
    active: false,
    complete: false
  }];
  /**
   * @typedef {object} HeaderProps
   * @property {number} [total]
   * @property {number} [current]
   * @property {typeof defaultOptions} [options]
   */

  /** @type {import('react').FC<HeaderProps>} */

  var Header = function Header(_ref) {
    var _ref$total = _ref.total,
        total = _ref$total === void 0 ? 100 : _ref$total,
        _ref$current = _ref.current,
        current = _ref$current === void 0 ? 0 : _ref$current,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? defaultOptions : _ref$options;
    return /*#__PURE__*/React$2__default.createElement(ContainerHeader, null, /*#__PURE__*/React$2__default.createElement(WrapperItens, null, options.map(function (item) {
      return /*#__PURE__*/React$2__default.createElement(ItemHeader, {
        key: item.title,
        active: item.active
      }, /*#__PURE__*/React$2__default.createElement(Title, {
        active: item.active
      }, item.title, " ", item.complete && /*#__PURE__*/React$2__default.createElement(Check, null)), /*#__PURE__*/React$2__default.createElement(Text, {
        active: item.active
      }, item.text));
    })), /*#__PURE__*/React$2__default.createElement(Progress, {
      value: current,
      total: total
    }));
  };

  function _templateObject7$1() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  content: ' ';\n  border: 30px solid var(--brandPrimary);\n  box-sizing: border-box;\n  width: 95%;\n  height: 95%;\n  border-radius: 50%;\n  box-shadow: 5px 5px 10px 5px rgba(0, 0, 0, 0.1);\n"]);

    _templateObject7$1 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$2() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: -16px;\n  transform: translateY(-50%);\n  width: 0;\n  height: 0;\n  border-top: 30px solid transparent;\n  border-bottom: 30px solid transparent;\n  border-bottom-width: 30px;\n  border-bottom-style: solid;\n  border-bottom-color: transparent;\n  border-right: 30px solid ", ";\n"]);

    _templateObject6$2 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$4() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  transform: rotate(-45deg);\n  animation: ", " 0.4s linear infinite;\n"]);

    _templateObject5$4 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$5() {
    var data = _taggedTemplateLiteral(["\n  width: 100px;\n  height: 100px;\n  position: relative;\n"]);

    _templateObject4$5 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$6() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(0.5);\n"]);

    _templateObject3$6 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$7() {
    var data = _taggedTemplateLiteral(["\n  position: fixed;\n  width: 100%;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.2);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1300;\n"]);

    _templateObject2$7 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$9() {
    var data = _taggedTemplateLiteral(["\n  from {\n    transform: rotate(-45deg);\n  }\n  to {\n    transform: rotate(315deg);\n  }\n"]);

    _templateObject$9 = function _templateObject() {
      return data;
    };

    return data;
  }
  var rotate = styled.keyframes(_templateObject$9());
  var Overlay = styled__default.div(_templateObject2$7());
  var Wrap = styled__default.div(_templateObject3$6());
  var Box = styled__default.div(_templateObject4$5());
  var ArrowWrapper = styled__default.div(_templateObject5$4(), rotate);
  var Arrow = styled__default.div(_templateObject6$2(), function (_ref) {
    var isDark = _ref.isDark;
    return isDark ? 'var(--white100)' : 'var(--black100)';
  });
  var Box2 = styled__default.div(_templateObject7$1());

  /**
   * @typedef {object} LoadingProviProps
   * @property {boolean} [isLoadingDark]
   */

  /** @type {import('react').FC<LoadingProviProps>} */

  var LoadingProvi = function LoadingProvi(_ref) {
    var _ref$isLoadingDark = _ref.isLoadingDark,
        isLoadingDark = _ref$isLoadingDark === void 0 ? false : _ref$isLoadingDark;
    return /*#__PURE__*/React$2__default.createElement(Overlay, null, /*#__PURE__*/React$2__default.createElement(Wrap, null, /*#__PURE__*/React$2__default.createElement(Box, null, /*#__PURE__*/React$2__default.createElement(ArrowWrapper, null, /*#__PURE__*/React$2__default.createElement(Arrow, {
      isDark: isLoadingDark
    })), /*#__PURE__*/React$2__default.createElement(Box2, null))));
  };

  var CloseModal = function CloseModal() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M14 8L8 14M8 8L14 14M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z",
      stroke: "#DE0C4B",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject10() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"]);

    _templateObject10 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  cursor: pointer;\n  justify-content: flex-end;\n  z-index: 100;\n"]);

    _templateObject9 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8() {
    var data = _taggedTemplateLiteral(["\n  font-family: CenturyGothicBold, sans-serif;\n  color: ", ";\n  font-size: 30px;\n  line-height: 36px;\n  font-weight: 600;\n  font-weight: bold;\n  margin: 0;\n  margin-bottom: 20px;\n\n  ", " {\n    font-size: 20px;\n    line-height: 30px;\n  }\n"]);

    _templateObject8 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7$2() {
    var data = _taggedTemplateLiteral(["\n  ", " {\n    overflow-y: auto;\n  }\n"]);

    _templateObject7$2 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$3() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  margin-bottom: 20px;\n"]);

    _templateObject6$3 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$5() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

    _templateObject5$5 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$6() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  border-radius: 20px;\n  max-width: 800px;\n  max-height: 600px;\n  width: 90%;\n  z-index: 15;\n  /* height: ", "; */\n  /* top: ", "; */\n  max-height: 90vh;\n  margin-top: 20px;\n  box-sizing: border-box;\n  background: white;\n  display: flex;\n  overflow: auto;\n  flex-direction: column;\n  padding: 25px;\n  animation-name: ", ";\n  animation-duration: 0.25s;\n  animation-timing-function: ease-out;\n\n  ", " {\n    padding: 16px;\n  }\n"]);

    _templateObject4$6 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$7() {
    var data = _taggedTemplateLiteral(["\n  from {\n    transform: scale(0);\n  }\n  to {\n    transform: scale(1);\n  }\n"]);

    _templateObject3$7 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$8() {
    var data = _taggedTemplateLiteral(["\n  align-items: center;\n  position: fixed;\n  height: 100%;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 15;\n  background: rgba(0, 0, 0, 0.5);\n  justify-content: center;\n  display: flex;\n  -webkit-animation-name: ", ";\n  -webkit-animation-duration: 0.25s;\n  animation-name: ", ";\n  animation-duration: 0.25s;\n  animation-timing-function: ease-out;\n"]);

    _templateObject2$8 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$a() {
    var data = _taggedTemplateLiteral(["\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n"]);

    _templateObject$a = function _templateObject() {
      return data;
    };

    return data;
  }
  var opacity = styled.keyframes(_templateObject$a()); // ${({ isWithoutHeight }) => (isWithoutHeight ? 'flex-start' : 'center')};

  var Overlay$1 = styled__default.div(_templateObject2$8(), opacity, opacity);
  var scale = styled.keyframes(_templateObject3$7());
  var Container$1 = styled__default.div(_templateObject4$6(), function (_ref) {
    var isWithoutHeight = _ref.isWithoutHeight;
    return isWithoutHeight ? 'unset' : '90vh';
  }, function (_ref2) {
    var isWithoutHeight = _ref2.isWithoutHeight;
    return isWithoutHeight ? '50px' : 'unset';
  }, scale, theme.breakpoints.down('md'));
  var Header$1 = styled__default.div(_templateObject5$5());
  var Body = styled__default.div(_templateObject6$3());
  var Content = styled__default.div(_templateObject7$2(), theme.breakpoints.down('md'));
  var Title$1 = styled__default.h3(_templateObject8(), theme.colors.blue900, theme.breakpoints.down('md'));
  var CloseModalWrapper = styled__default.div(_templateObject9());
  var Footer = styled__default.div(_templateObject10());

  /**
   * @typedef {object} ModalProps
   * @property {boolean} [isWithoutHeight]
   * @property {JSX.Element} [foooter]
   * @property {() => void} onDismiss
   * @property {string} title
   * @property {Record<string, unknown>} containerStyle
   */

  /** @type {import('react').FC<ModalProps>} */

  var Modal = function Modal(_ref) {
    var _ref$isWithoutHeight = _ref.isWithoutHeight,
        isWithoutHeight = _ref$isWithoutHeight === void 0 ? false : _ref$isWithoutHeight,
        _ref$containerStyle = _ref.containerStyle,
        containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
        title = _ref.title,
        onDismiss = _ref.onDismiss,
        children = _ref.children,
        _ref$footer = _ref.footer,
        footer = _ref$footer === void 0 ? null : _ref$footer;
    return /*#__PURE__*/React$2__default.createElement(Overlay$1, {
      isWithoutHeight: isWithoutHeight
    }, /*#__PURE__*/React$2__default.createElement(Container$1, {
      style: _objectSpread2({}, containerStyle),
      isWithoutHeight: isWithoutHeight
    }, /*#__PURE__*/React$2__default.createElement(CloseModalWrapper, {
      id: "close",
      onClick: onDismiss
    }, /*#__PURE__*/React$2__default.createElement(CloseModal, null)), /*#__PURE__*/React$2__default.createElement(Content, null, /*#__PURE__*/React$2__default.createElement(Header$1, null, title && /*#__PURE__*/React$2__default.createElement(Title$1, null, title)), /*#__PURE__*/React$2__default.createElement(Body, null, children), footer && /*#__PURE__*/React$2__default.createElement(Footer, null, footer))));
  };

  function _templateObject2$9() {
    var data = _taggedTemplateLiteral(["\n  font-family: CenturyGothicBold, sans-serif;\n  font-size: 16px;\n  color: ", ";\n  ", " {\n    font-size: 12px;\n  }\n"]);

    _templateObject2$9 = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$b() {
    var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 10px;\n  box-shadow: 2px 1px 15px -9px rgba(0, 0, 0, 0.5);\n  ", " {\n    width: 48%;\n    height: 72px;\n    margin-left: 0;\n  }\n  box-sizing: border-box;\n  width: 108px;\n  height: 108px;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  margin-top: ", "px;\n  margin-left: ", "px;\n  border-radius: 10px;\n  background-color: ", ";\n"]);

    _templateObject$b = function _templateObject() {
      return data;
    };

    return data;
  }
  var ContainerOption = styled__default.div(_templateObject$b(), theme.breakpoints.down('sm'), theme.variables.spacer * 2, theme.variables.spacer, function (_ref) {
    var active = _ref.active;
    return active ? theme.colors.blue900 : theme.colors.white100;
  });
  var Text$1 = styled__default.p(_templateObject2$9(), function (_ref2) {
    var active = _ref2.active;
    return active ? theme.colors.white100 : theme.colors.blue900;
  }, theme.breakpoints.down('md'));

  /**
   * @typedef {object} OptionProps
   * @property {string} [id]
   * @property {boolean} [active]
   * @property {string} [text]
   * @property {() => void} [func]
   */

  /** @type {import('react').FC<OptionProps>} */

  var Option = function Option(_ref) {
    var active = _ref.active,
        text = _ref.text,
        func = _ref.func,
        id = _ref.id;
    return /*#__PURE__*/React$2__default.createElement(ContainerOption, {
      id: id,
      active: active,
      onClick: func
    }, /*#__PURE__*/React$2__default.createElement(Text$1, {
      active: active
    }, text));
  };

  function areInputsEqual(newInputs, lastInputs) {
      if (newInputs.length !== lastInputs.length) {
          return false;
      }
      for (var i = 0; i < newInputs.length; i++) {
          if (newInputs[i] !== lastInputs[i]) {
              return false;
          }
      }
      return true;
  }

  function memoizeOne(resultFn, isEqual) {
      if (isEqual === void 0) { isEqual = areInputsEqual; }
      var lastThis;
      var lastArgs = [];
      var lastResult;
      var calledOnce = false;
      function memoized() {
          var newArgs = [];
          for (var _i = 0; _i < arguments.length; _i++) {
              newArgs[_i] = arguments[_i];
          }
          if (calledOnce && lastThis === this && isEqual(newArgs, lastArgs)) {
              return lastResult;
          }
          lastResult = resultFn.apply(this, newArgs);
          calledOnce = true;
          lastThis = this;
          lastArgs = newArgs;
          return lastResult;
      }
      return memoized;
  }

  function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var inheritsLoose = _inheritsLoose;

  /*

  Based off glamor's StyleSheet, thanks Sunil ❤️

  high performance StyleSheet for css-in-js systems

  - uses multiple style tags behind the scenes for millions of rules
  - uses `insertRule` for appending in production for *much* faster performance

  // usage

  import { StyleSheet } from '@emotion/sheet'

  let styleSheet = new StyleSheet({ key: '', container: document.head })

  styleSheet.insert('#box { border: 1px solid red; }')
  - appends a css rule into the stylesheet

  styleSheet.flush()
  - empties the stylesheet of all its contents

  */
  // $FlowFixMe
  function sheetForTag(tag) {
    if (tag.sheet) {
      // $FlowFixMe
      return tag.sheet;
    } // this weirdness brought to you by firefox

    /* istanbul ignore next */


    for (var i = 0; i < document.styleSheets.length; i++) {
      if (document.styleSheets[i].ownerNode === tag) {
        // $FlowFixMe
        return document.styleSheets[i];
      }
    }
  }

  function createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);

    if (options.nonce !== undefined) {
      tag.setAttribute('nonce', options.nonce);
    }

    tag.appendChild(document.createTextNode(''));
    return tag;
  }

  var StyleSheet =
  /*#__PURE__*/
  function () {
    function StyleSheet(options) {
      this.isSpeedy = options.speedy === undefined ? process.env.NODE_ENV === 'production' : options.speedy;
      this.tags = [];
      this.ctr = 0;
      this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

      this.key = options.key;
      this.container = options.container;
      this.before = null;
    }

    var _proto = StyleSheet.prototype;

    _proto.insert = function insert(rule) {
      // the max length is how many rules we have per style tag, it's 65000 in speedy mode
      // it's 1 in dev because we insert source maps that map a single rule to a location
      // and you can only have one source map per style tag
      if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
        var _tag = createStyleElement(this);

        var before;

        if (this.tags.length === 0) {
          before = this.before;
        } else {
          before = this.tags[this.tags.length - 1].nextSibling;
        }

        this.container.insertBefore(_tag, before);
        this.tags.push(_tag);
      }

      var tag = this.tags[this.tags.length - 1];

      if (this.isSpeedy) {
        var sheet = sheetForTag(tag);

        try {
          // this is a really hot path
          // we check the second character first because having "i"
          // as the second character will happen less often than
          // having "@" as the first character
          var isImportRule = rule.charCodeAt(1) === 105 && rule.charCodeAt(0) === 64; // this is the ultrafast version, works across browsers
          // the big drawback is that the css won't be editable in devtools

          sheet.insertRule(rule, // we need to insert @import rules before anything else
          // otherwise there will be an error
          // technically this means that the @import rules will
          // _usually_(not always since there could be multiple style tags)
          // be the first ones in prod and generally later in dev
          // this shouldn't really matter in the real world though
          // @import is generally only used for font faces from google fonts and etc.
          // so while this could be technically correct then it would be slower and larger
          // for a tiny bit of correctness that won't matter in the real world
          isImportRule ? 0 : sheet.cssRules.length);
        } catch (e) {
          if (process.env.NODE_ENV !== 'production') {
            console.warn("There was a problem inserting the following rule: \"" + rule + "\"", e);
          }
        }
      } else {
        tag.appendChild(document.createTextNode(rule));
      }

      this.ctr++;
    };

    _proto.flush = function flush() {
      // $FlowFixMe
      this.tags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
      });
      this.tags = [];
      this.ctr = 0;
    };

    return StyleSheet;
  }();

  function stylis_min (W) {
    function M(d, c, e, h, a) {
      for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
        g = e.charCodeAt(l);
        l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

        if (0 === b + n + v + m) {
          if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
            switch (g) {
              case 32:
              case 9:
              case 59:
              case 13:
              case 10:
                break;

              default:
                f += e.charAt(l);
            }

            g = 59;
          }

          switch (g) {
            case 123:
              f = f.trim();
              q = f.charCodeAt(0);
              k = 1;

              for (t = ++l; l < B;) {
                switch (g = e.charCodeAt(l)) {
                  case 123:
                    k++;
                    break;

                  case 125:
                    k--;
                    break;

                  case 47:
                    switch (g = e.charCodeAt(l + 1)) {
                      case 42:
                      case 47:
                        a: {
                          for (u = l + 1; u < J; ++u) {
                            switch (e.charCodeAt(u)) {
                              case 47:
                                if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                  l = u + 1;
                                  break a;
                                }

                                break;

                              case 10:
                                if (47 === g) {
                                  l = u + 1;
                                  break a;
                                }

                            }
                          }

                          l = u;
                        }

                    }

                    break;

                  case 91:
                    g++;

                  case 40:
                    g++;

                  case 34:
                  case 39:
                    for (; l++ < J && e.charCodeAt(l) !== g;) {
                    }

                }

                if (0 === k) break;
                l++;
              }

              k = e.substring(t, l);
              0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

              switch (q) {
                case 64:
                  0 < r && (f = f.replace(N, ''));
                  g = f.charCodeAt(1);

                  switch (g) {
                    case 100:
                    case 109:
                    case 115:
                    case 45:
                      r = c;
                      break;

                    default:
                      r = O;
                  }

                  k = M(c, r, k, g, a + 1);
                  t = k.length;
                  0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                  if (0 < t) switch (g) {
                    case 115:
                      f = f.replace(da, ea);

                    case 100:
                    case 109:
                    case 45:
                      k = f + '{' + k + '}';
                      break;

                    case 107:
                      f = f.replace(fa, '$1 $2');
                      k = f + '{' + k + '}';
                      k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                      break;

                    default:
                      k = f + k, 112 === h && (k = (p += k, ''));
                  } else k = '';
                  break;

                default:
                  k = M(c, X(c, f, I), k, h, a + 1);
              }

              F += k;
              k = I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
              break;

            case 125:
            case 59:
              f = (0 < r ? f.replace(N, '') : f).trim();
              if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
                case 0:
                  break;

                case 64:
                  if (105 === g || 99 === g) {
                    G += f + e.charAt(l);
                    break;
                  }

                default:
                  58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
              }
              I = r = u = q = 0;
              f = '';
              g = e.charCodeAt(++l);
          }
        }

        switch (g) {
          case 13:
          case 10:
            47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
            0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
            z = 1;
            D++;
            break;

          case 59:
          case 125:
            if (0 === b + n + v + m) {
              z++;
              break;
            }

          default:
            z++;
            y = e.charAt(l);

            switch (g) {
              case 9:
              case 32:
                if (0 === n + m + b) switch (x) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    y = '';
                    break;

                  default:
                    32 !== g && (y = ' ');
                }
                break;

              case 0:
                y = '\\0';
                break;

              case 12:
                y = '\\f';
                break;

              case 11:
                y = '\\v';
                break;

              case 38:
                0 === n + b + m && (r = I = 1, y = '\f' + y);
                break;

              case 108:
                if (0 === n + b + m + E && 0 < u) switch (l - u) {
                  case 2:
                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                  case 8:
                    111 === K && (E = K);
                }
                break;

              case 58:
                0 === n + b + m && (u = l);
                break;

              case 44:
                0 === b + v + n + m && (r = 1, y += '\r');
                break;

              case 34:
              case 39:
                0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                break;

              case 91:
                0 === n + b + v && m++;
                break;

              case 93:
                0 === n + b + v && m--;
                break;

              case 41:
                0 === n + b + m && v--;
                break;

              case 40:
                if (0 === n + b + m) {
                  if (0 === q) switch (2 * x + 3 * K) {
                    case 533:
                      break;

                    default:
                      q = 1;
                  }
                  v++;
                }

                break;

              case 64:
                0 === b + v + n + m + u + k && (k = 1);
                break;

              case 42:
              case 47:
                if (!(0 < n + m + v)) switch (b) {
                  case 0:
                    switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                      case 235:
                        b = 47;
                        break;

                      case 220:
                        t = l, b = 42;
                    }

                    break;

                  case 42:
                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                }
            }

            0 === b && (f += y);
        }

        K = x;
        x = g;
        l++;
      }

      t = p.length;

      if (0 < t) {
        r = c;
        if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
        p = r.join(',') + '{' + p + '}';

        if (0 !== w * E) {
          2 !== w || L(p, 2) || (E = 0);

          switch (E) {
            case 111:
              p = p.replace(ha, ':-moz-$1') + p;
              break;

            case 112:
              p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
          }

          E = 0;
        }
      }

      return G + p + F;
    }

    function X(d, c, e) {
      var h = c.trim().split(ia);
      c = h;
      var a = h.length,
          m = d.length;

      switch (m) {
        case 0:
        case 1:
          var b = 0;

          for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
            c[b] = Z(d, c[b], e).trim();
          }

          break;

        default:
          var v = b = 0;

          for (c = []; b < a; ++b) {
            for (var n = 0; n < m; ++n) {
              c[v++] = Z(d[n] + ' ', h[b], e).trim();
            }
          }

      }

      return c;
    }

    function Z(d, c, e) {
      var h = c.charCodeAt(0);
      33 > h && (h = (c = c.trim()).charCodeAt(0));

      switch (h) {
        case 38:
          return c.replace(F, '$1' + d.trim());

        case 58:
          return d.trim() + c.replace(F, '$1' + d.trim());

        default:
          if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
      }

      return d + c;
    }

    function P(d, c, e, h) {
      var a = d + ';',
          m = 2 * c + 3 * e + 4 * h;

      if (944 === m) {
        d = a.indexOf(':', 9) + 1;
        var b = a.substring(d, a.length - 1).trim();
        b = a.substring(0, d).trim() + b + ';';
        return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
      }

      if (0 === w || 2 === w && !L(a, 1)) return a;

      switch (m) {
        case 1015:
          return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

        case 951:
          return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

        case 963:
          return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

        case 1009:
          if (100 !== a.charCodeAt(4)) break;

        case 969:
        case 942:
          return '-webkit-' + a + a;

        case 978:
          return '-webkit-' + a + '-moz-' + a + a;

        case 1019:
        case 983:
          return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

        case 883:
          if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
          if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
          break;

        case 932:
          if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
            case 103:
              return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

            case 115:
              return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

            case 98:
              return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
          }
          return '-webkit-' + a + '-ms-' + a + a;

        case 964:
          return '-webkit-' + a + '-ms-flex-' + a + a;

        case 1023:
          if (99 !== a.charCodeAt(8)) break;
          b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
          return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

        case 1005:
          return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

        case 1e3:
          b = a.substring(13).trim();
          c = b.indexOf('-') + 1;

          switch (b.charCodeAt(0) + b.charCodeAt(c)) {
            case 226:
              b = a.replace(G, 'tb');
              break;

            case 232:
              b = a.replace(G, 'tb-rl');
              break;

            case 220:
              b = a.replace(G, 'lr');
              break;

            default:
              return a;
          }

          return '-webkit-' + a + '-ms-' + b + a;

        case 1017:
          if (-1 === a.indexOf('sticky', 9)) break;

        case 975:
          c = (a = d).length - 10;
          b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

          switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
            case 203:
              if (111 > b.charCodeAt(8)) break;

            case 115:
              a = a.replace(b, '-webkit-' + b) + ';' + a;
              break;

            case 207:
            case 102:
              a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
          }

          return a + ';';

        case 938:
          if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
            case 105:
              return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

            case 115:
              return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

            default:
              return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
          }
          break;

        case 973:
        case 989:
          if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

        case 931:
        case 953:
          if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
          break;

        case 962:
          if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
      }

      return a;
    }

    function L(d, c) {
      var e = d.indexOf(1 === c ? ':' : '{'),
          h = d.substring(0, 3 !== c ? e : 10);
      e = d.substring(e + 1, d.length - 1);
      return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }

    function ea(d, c) {
      var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
      return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }

    function H(d, c, e, h, a, m, b, v, n, q) {
      for (var g = 0, x = c, w; g < A; ++g) {
        switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
          case void 0:
          case !1:
          case !0:
          case null:
            break;

          default:
            x = w;
        }
      }

      if (x !== c) return x;
    }

    function T(d) {
      switch (d) {
        case void 0:
        case null:
          A = S.length = 0;
          break;

        default:
          if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
            T(d[c]);
          } else Y = !!d | 0;
      }

      return T;
    }

    function U(d) {
      d = d.prefix;
      void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
      return U;
    }

    function B(d, c) {
      var e = d;
      33 > e.charCodeAt(0) && (e = e.trim());
      V = e;
      e = [V];

      if (0 < A) {
        var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
        void 0 !== h && 'string' === typeof h && (c = h);
      }

      var a = M(O, e, c, 0, 0);
      0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
      V = '';
      E = 0;
      z = D = 1;
      return a;
    }

    var ca = /^\0+/g,
        N = /[\0\r\f]/g,
        aa = /: */g,
        ka = /zoo|gra/,
        ma = /([,: ])(transform)/g,
        ia = /,\r+?/g,
        F = /([\t\r\n ])*\f?&/g,
        fa = /@(k\w+)\s*(\S*)\s*/,
        Q = /::(place)/g,
        ha = /:(read-only)/g,
        G = /[svh]\w+-[tblr]{2}/,
        da = /\(\s*(.*)\s*\)/g,
        oa = /([\s\S]*?);/g,
        ba = /-self|flex-/g,
        na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
        la = /stretch|:\s*\w+\-(?:conte|avail)/,
        ja = /([^-])(image-set\()/,
        z = 1,
        D = 1,
        E = 0,
        w = 1,
        O = [],
        S = [],
        A = 0,
        R = null,
        Y = 0,
        V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
  }

  var weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function (arg) {
      if (cache.has(arg)) {
        // $FlowFixMe
        return cache.get(arg);
      }

      var ret = func(arg);
      cache.set(arg, ret);
      return ret;
    };
  };

  // https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
  // inlined to avoid umd wrapper and peerDep warnings/installing stylis
  // since we use stylis after closure compiler
  var delimiter = '/*|*/';
  var needle = delimiter + '}';

  function toSheet(block) {
    if (block) {
      Sheet.current.insert(block + '}');
    }
  }

  var Sheet = {
    current: null
  };
  var ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch (context) {
      // property
      case 1:
        {
          switch (content.charCodeAt(0)) {
            case 64:
              {
                // @import
                Sheet.current.insert(content + ';');
                return '';
              }
            // charcode for l

            case 108:
              {
                // charcode for b
                // this ignores label
                if (content.charCodeAt(2) === 98) {
                  return '';
                }
              }
          }

          break;
        }
      // selector

      case 2:
        {
          if (ns === 0) return content + delimiter;
          break;
        }
      // at-rule

      case 3:
        {
          switch (ns) {
            // @font-face, @page
            case 102:
            case 112:
              {
                Sheet.current.insert(selectors[0] + content);
                return '';
              }

            default:
              {
                return content + (at === 0 ? delimiter : '');
              }
          }
        }

      case -2:
        {
          content.split(needle).forEach(toSheet);
        }
    }
  };
  var removeLabel = function removeLabel(context, content) {
    if (context === 1 && // charcode for l
    content.charCodeAt(0) === 108 && // charcode for b
    content.charCodeAt(2) === 98 // this ignores label
    ) {
        return '';
      }
  };

  var isBrowser = typeof document !== 'undefined';
  var rootServerStylisCache = {};
  var getServerStylisCache = isBrowser ? undefined : weakMemoize(function () {
    var getCache = weakMemoize(function () {
      return {};
    });
    var prefixTrueCache = {};
    var prefixFalseCache = {};
    return function (prefix) {
      if (prefix === undefined || prefix === true) {
        return prefixTrueCache;
      }

      if (prefix === false) {
        return prefixFalseCache;
      }

      return getCache(prefix);
    };
  });

  var createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;

    if (options.prefix !== undefined) {
      stylisOptions = {
        prefix: options.prefix
      };
    }

    var stylis = new stylis_min(stylisOptions);

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe
      if (/[^a-z-]/.test(key)) {
        throw new Error("Emotion key must only contain lower case alphabetical characters and - but \"" + key + "\" was passed");
      }
    }

    var inserted = {}; // $FlowFixMe

    var container;

    if (isBrowser) {
      container = options.container || document.head;
      var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
      Array.prototype.forEach.call(nodes, function (node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe

        attrib.split(' ').forEach(function (id) {
          inserted[id] = true;
        });

        if (node.parentNode !== container) {
          container.appendChild(node);
        }
      });
    }

    var _insert;

    if (isBrowser) {
      stylis.use(options.stylisPlugins)(ruleSheet);

      _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        Sheet.current = sheet;

        if (process.env.NODE_ENV !== 'production' && serialized.map !== undefined) {
          var map = serialized.map;
          Sheet.current = {
            insert: function insert(rule) {
              sheet.insert(rule + map);
            }
          };
        }

        stylis(selector, serialized.styles);

        if (shouldCache) {
          cache.inserted[name] = true;
        }
      };
    } else {
      stylis.use(removeLabel);
      var serverStylisCache = rootServerStylisCache;

      if (options.stylisPlugins || options.prefix !== undefined) {
        stylis.use(options.stylisPlugins); // $FlowFixMe

        serverStylisCache = getServerStylisCache(options.stylisPlugins || rootServerStylisCache)(options.prefix);
      }

      var getRules = function getRules(selector, serialized) {
        var name = serialized.name;

        if (serverStylisCache[name] === undefined) {
          serverStylisCache[name] = stylis(selector, serialized.styles);
        }

        return serverStylisCache[name];
      };

      _insert = function _insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        var rules = getRules(selector, serialized);

        if (cache.compat === undefined) {
          // in regular mode, we don't set the styles on the inserted cache
          // since we don't need to and that would be wasting memory
          // we return them so that they are rendered in a style tag
          if (shouldCache) {
            cache.inserted[name] = true;
          }

          if ( // using === development instead of !== production
          // because if people do ssr in tests, the source maps showing up would be annoying
          process.env.NODE_ENV === 'development' && serialized.map !== undefined) {
            return rules + serialized.map;
          }

          return rules;
        } else {
          // in compat mode, we put the styles on the inserted cache so
          // that emotion-server can pull out the styles
          // except when we don't want to cache it which was in Global but now
          // is nowhere but we don't want to do a major right now
          // and just in case we're going to leave the case here
          // it's also not affecting client side bundle size
          // so it's really not a big deal
          if (shouldCache) {
            cache.inserted[name] = rules;
          } else {
            return rules;
          }
        }
      };
    }

    if (process.env.NODE_ENV !== 'production') {
      // https://esbench.com/bench/5bf7371a4cd7e6009ef61d0a
      var commentStart = /\/\*/g;
      var commentEnd = /\*\//g;
      stylis.use(function (context, content) {
        switch (context) {
          case -1:
            {
              while (commentStart.test(content)) {
                commentEnd.lastIndex = commentStart.lastIndex;

                if (commentEnd.test(content)) {
                  commentStart.lastIndex = commentEnd.lastIndex;
                  continue;
                }

                throw new Error('Your styles have an unterminated comment ("/*" without corresponding "*/").');
              }

              commentStart.lastIndex = 0;
              break;
            }
        }
      });
      stylis.use(function (context, content, selectors) {
        switch (context) {
          case -1:
            {
              var flag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
              var unsafePseudoClasses = content.match(/(:first|:nth|:nth-last)-child/g);

              if (unsafePseudoClasses && cache.compat !== true) {
                unsafePseudoClasses.forEach(function (unsafePseudoClass) {
                  var ignoreRegExp = new RegExp(unsafePseudoClass + ".*\\/\\* " + flag + " \\*\\/");
                  var ignore = ignoreRegExp.test(content);

                  if (unsafePseudoClass && !ignore) {
                    console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
                  }
                });
              }

              break;
            }
        }
      });
    }

    var cache = {
      key: key,
      sheet: new StyleSheet({
        key: key,
        container: container,
        nonce: options.nonce,
        speedy: options.speedy
      }),
      nonce: options.nonce,
      inserted: inserted,
      registered: {},
      insert: _insert
    };
    return cache;
  };

  var isBrowser$1 = typeof document !== 'undefined';
  function getRegisteredStyles(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function (className) {
      if (registered[className] !== undefined) {
        registeredStyles.push(registered[className]);
      } else {
        rawClassName += className + " ";
      }
    });
    return rawClassName;
  }
  var insertStyles = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;

    if ( // we only need to add the styles to the registered cache if the
    // class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
      cache.registered[className] = serialized.styles;
    }

    if (cache.inserted[serialized.name] === undefined) {
      var stylesForSSR = '';
      var current = serialized;

      do {
        var maybeStyles = cache.insert("." + className, current, cache.sheet, true);

        if (!isBrowser$1 && maybeStyles !== undefined) {
          stylesForSSR += maybeStyles;
        }

        current = current.next;
      } while (current !== undefined);

      if (!isBrowser$1 && stylesForSSR.length !== 0) {
        return stylesForSSR;
      }
    }
  };

  /* eslint-disable */
  // Inspired by https://github.com/garycourt/murmurhash-js
  // Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
  function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash

    var k,
        i = 0,
        len = str.length;

    for (; len >= 4; ++i, len -= 4) {
      k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
      k =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
      k ^=
      /* k >>> r: */
      k >>> 24;
      h =
      /* Math.imul(k, m): */
      (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array


    switch (len) {
      case 3:
        h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

      case 2:
        h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

      case 1:
        h ^= str.charCodeAt(i) & 0xff;
        h =
        /* Math.imul(h, m): */
        (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.


    h ^= h >>> 13;
    h =
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
  }

  var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
  };

  function memoize(fn) {
    var cache = {};
    return function (arg) {
      if (cache[arg] === undefined) cache[arg] = fn(arg);
      return cache[arg];
    };
  }

  var ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
  var UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
  var hyphenateRegex = /[A-Z]|^ms/g;
  var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

  var isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
  };

  var isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
  };

  var processStyleName = memoize(function (styleName) {
    return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
  });

  var processStyleValue = function processStyleValue(key, value) {
    switch (key) {
      case 'animation':
      case 'animationName':
        {
          if (typeof value === 'string') {
            return value.replace(animationRegex, function (match, p1, p2) {
              cursor = {
                name: p1,
                styles: p2,
                next: cursor
              };
              return p1;
            });
          }
        }
    }

    if (unitlessKeys[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
      return value + 'px';
    }

    return value;
  };

  if (process.env.NODE_ENV !== 'production') {
    var contentValuePattern = /(attr|calc|counters?|url)\(/;
    var contentValues = ['normal', 'none', 'counter', 'open-quote', 'close-quote', 'no-open-quote', 'no-close-quote', 'initial', 'inherit', 'unset'];
    var oldProcessStyleValue = processStyleValue;
    var msPattern = /^-ms-/;
    var hyphenPattern = /-(.)/g;
    var hyphenatedCache = {};

    processStyleValue = function processStyleValue(key, value) {
      if (key === 'content') {
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
          console.error("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"" + value + "\"'`");
        }
      }

      var processed = oldProcessStyleValue(key, value);

      if (processed !== '' && !isCustomProperty(key) && key.indexOf('-') !== -1 && hyphenatedCache[key] === undefined) {
        hyphenatedCache[key] = true;
        console.error("Using kebab-case for css properties in objects is not supported. Did you mean " + key.replace(msPattern, 'ms-').replace(hyphenPattern, function (str, _char) {
          return _char.toUpperCase();
        }) + "?");
      }

      return processed;
    };
  }

  var shouldWarnAboutInterpolatingClassNameFromCss = true;

  function handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) {
      return '';
    }

    if (interpolation.__emotion_styles !== undefined) {
      if (process.env.NODE_ENV !== 'production' && interpolation.toString() === 'NO_COMPONENT_SELECTOR') {
        throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
      }

      return interpolation;
    }

    switch (typeof interpolation) {
      case 'boolean':
        {
          return '';
        }

      case 'object':
        {
          if (interpolation.anim === 1) {
            cursor = {
              name: interpolation.name,
              styles: interpolation.styles,
              next: cursor
            };
            return interpolation.name;
          }

          if (interpolation.styles !== undefined) {
            var next = interpolation.next;

            if (next !== undefined) {
              // not the most efficient thing ever but this is a pretty rare case
              // and there will be very few iterations of this generally
              while (next !== undefined) {
                cursor = {
                  name: next.name,
                  styles: next.styles,
                  next: cursor
                };
                next = next.next;
              }
            }

            var styles = interpolation.styles + ";";

            if (process.env.NODE_ENV !== 'production' && interpolation.map !== undefined) {
              styles += interpolation.map;
            }

            return styles;
          }

          return createStringFromObject(mergedProps, registered, interpolation);
        }

      case 'function':
        {
          if (mergedProps !== undefined) {
            var previousCursor = cursor;
            var result = interpolation(mergedProps);
            cursor = previousCursor;
            return handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
          } else if (process.env.NODE_ENV !== 'production') {
            console.error('Functions that are interpolated in css calls will be stringified.\n' + 'If you want to have a css call based on props, create a function that returns a css call like this\n' + 'let dynamicStyle = (props) => css`color: ${props.color}`\n' + 'It can be called directly with props or interpolated in a styled call like this\n' + "let SomeComponent = styled('div')`${dynamicStyle}`");
          }

          break;
        }

      case 'string':
        if (process.env.NODE_ENV !== 'production') {
          var matched = [];
          var replaced = interpolation.replace(animationRegex, function (match, p1, p2) {
            var fakeVarName = "animation" + matched.length;
            matched.push("const " + fakeVarName + " = keyframes`" + p2.replace(/^@keyframes animation-\w+/, '') + "`");
            return "${" + fakeVarName + "}";
          });

          if (matched.length) {
            console.error('`keyframes` output got interpolated into plain string, please wrap it with `css`.\n\n' + 'Instead of doing this:\n\n' + [].concat(matched, ["`" + replaced + "`"]).join('\n') + '\n\nYou should wrap it with `css` like this:\n\n' + ("css`" + replaced + "`"));
          }
        }

        break;
    } // finalize string values (regular strings and functions interpolated into css calls)


    if (registered == null) {
      return interpolation;
    }

    var cached = registered[interpolation];

    if (process.env.NODE_ENV !== 'production' && couldBeSelectorInterpolation && shouldWarnAboutInterpolatingClassNameFromCss && cached !== undefined) {
      console.error('Interpolating a className from css`` is not recommended and will cause problems with composition.\n' + 'Interpolating a className from css`` will be completely unsupported in a future major version of Emotion');
      shouldWarnAboutInterpolatingClassNameFromCss = false;
    }

    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
  }

  function createStringFromObject(mergedProps, registered, obj) {
    var string = '';

    if (Array.isArray(obj)) {
      for (var i = 0; i < obj.length; i++) {
        string += handleInterpolation(mergedProps, registered, obj[i], false);
      }
    } else {
      for (var _key in obj) {
        var value = obj[_key];

        if (typeof value !== 'object') {
          if (registered != null && registered[value] !== undefined) {
            string += _key + "{" + registered[value] + "}";
          } else if (isProcessableValue(value)) {
            string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
          }
        } else {
          if (_key === 'NO_COMPONENT_SELECTOR' && process.env.NODE_ENV !== 'production') {
            throw new Error('Component selectors can only be used in conjunction with babel-plugin-emotion.');
          }

          if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
            for (var _i = 0; _i < value.length; _i++) {
              if (isProcessableValue(value[_i])) {
                string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
              }
            }
          } else {
            var interpolated = handleInterpolation(mergedProps, registered, value, false);

            switch (_key) {
              case 'animation':
              case 'animationName':
                {
                  string += processStyleName(_key) + ":" + interpolated + ";";
                  break;
                }

              default:
                {
                  if (process.env.NODE_ENV !== 'production' && _key === 'undefined') {
                    console.error(UNDEFINED_AS_OBJECT_KEY_ERROR);
                  }

                  string += _key + "{" + interpolated + "}";
                }
            }
          }
        }
      }
    }

    return string;
  }

  var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
  var sourceMapPattern;

  if (process.env.NODE_ENV !== 'production') {
    sourceMapPattern = /\/\*#\ssourceMappingURL=data:application\/json;\S+\s+\*\//;
  } // this is the cursor for keyframes
  // keyframes are stored on the SerializedStyles object as a linked list


  var cursor;
  var serializeStyles = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
      return args[0];
    }

    var stringMode = true;
    var styles = '';
    cursor = undefined;
    var strings = args[0];

    if (strings == null || strings.raw === undefined) {
      stringMode = false;
      styles += handleInterpolation(mergedProps, registered, strings, false);
    } else {
      if (process.env.NODE_ENV !== 'production' && strings[0] === undefined) {
        console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
      }

      styles += strings[0];
    } // we start at 1 since we've already handled the first arg


    for (var i = 1; i < args.length; i++) {
      styles += handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);

      if (stringMode) {
        if (process.env.NODE_ENV !== 'production' && strings[i] === undefined) {
          console.error(ILLEGAL_ESCAPE_SEQUENCE_ERROR);
        }

        styles += strings[i];
      }
    }

    var sourceMap;

    if (process.env.NODE_ENV !== 'production') {
      styles = styles.replace(sourceMapPattern, function (match) {
        sourceMap = match;
        return '';
      });
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time


    labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

    while ((match = labelPattern.exec(styles)) !== null) {
      identifierName += '-' + // $FlowFixMe we know it's not null
      match[1];
    }

    var name = murmur2(styles) + identifierName;

    if (process.env.NODE_ENV !== 'production') {
      // $FlowFixMe SerializedStyles type doesn't have toString property (and we don't want to add it)
      return {
        name: name,
        styles: styles,
        map: sourceMap,
        next: cursor,
        toString: function toString() {
          return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
        }
      };
    }

    return {
      name: name,
      styles: styles,
      next: cursor
    };
  };

  function css() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return serializeStyles(args);
  }

  var isBrowser$2 = typeof document !== 'undefined';

  var EmotionCacheContext = React$2.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement !== 'undefined' ? createCache() : null);
  var ThemeContext = React$2.createContext({});
  var CacheProvider = EmotionCacheContext.Provider;

  var withEmotionCache = function withEmotionCache(func) {
    var render = function render(props, ref) {
      return React$2.createElement(EmotionCacheContext.Consumer, null, function (cache) {
        return func(props, cache, ref);
      });
    }; // $FlowFixMe


    return React$2.forwardRef(render);
  };

  if (!isBrowser$2) {
    var BasicProvider =
    /*#__PURE__*/
    function (_React$Component) {
      inheritsLoose(BasicProvider, _React$Component);

      function BasicProvider(props, context, updater) {
        var _this;

        _this = _React$Component.call(this, props, context, updater) || this;
        _this.state = {
          value: createCache()
        };
        return _this;
      }

      var _proto = BasicProvider.prototype;

      _proto.render = function render() {
        return React$2.createElement(EmotionCacheContext.Provider, this.state, this.props.children(this.state.value));
      };

      return BasicProvider;
    }(React$2.Component);

    withEmotionCache = function withEmotionCache(func) {
      return function (props) {
        return React$2.createElement(EmotionCacheContext.Consumer, null, function (context) {
          if (context === null) {
            return React$2.createElement(BasicProvider, null, function (newContext) {
              return func(props, newContext);
            });
          } else {
            return func(props, context);
          }
        });
      };
    };
  }

  // thus we only need to replace what is a valid character for JS, but not for CSS

  var sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
  };

  var typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
  var labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  var render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible

    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) {
      cssProp = cache.registered[cssProp];
    }

    var type = props[typePropName];
    var registeredStyles = [cssProp];
    var className = '';

    if (typeof props.className === 'string') {
      className = getRegisteredStyles(cache.registered, registeredStyles, props.className);
    } else if (props.className != null) {
      className = props.className + " ";
    }

    var serialized = serializeStyles(registeredStyles);

    if (process.env.NODE_ENV !== 'production' && serialized.name.indexOf('-') === -1) {
      var labelFromStack = props[labelPropName];

      if (labelFromStack) {
        serialized = serializeStyles([serialized, 'label:' + labelFromStack + ';']);
      }
    }

    var rules = insertStyles(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty.call(props, key) && key !== 'css' && key !== typePropName && (process.env.NODE_ENV === 'production' || key !== labelPropName)) {
        newProps[key] = props[key];
      }
    }

    newProps.ref = ref;
    newProps.className = className;
    var ele = React$2.createElement(type, newProps);

    if (!isBrowser$2 && rules !== undefined) {
      var _ref;

      var serializedNames = serialized.name;
      var next = serialized.next;

      while (next !== undefined) {
        serializedNames += ' ' + next.name;
        next = next.next;
      }

      return React$2.createElement(React$2.Fragment, null, React$2.createElement("style", (_ref = {}, _ref["data-emotion-" + cache.key] = serializedNames, _ref.dangerouslySetInnerHTML = {
        __html: rules
      }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
    }

    return ele;
  };

  var Emotion =
  /* #__PURE__ */
  withEmotionCache(function (props, cache, ref) {
    // use Context.read for the theme when it's stable
    if (typeof props.css === 'function') {
      return React$2.createElement(ThemeContext.Consumer, null, function (theme) {
        return render(cache, props, theme, ref);
      });
    }

    return render(cache, props, null, ref);
  });

  if (process.env.NODE_ENV !== 'production') {
    Emotion.displayName = 'EmotionCssPropInternal';
  } // $FlowFixMe


  var jsx = function jsx(type, props) {
    var args = arguments;

    if (props == null || !hasOwnProperty.call(props, 'css')) {
      // $FlowFixMe
      return React$2.createElement.apply(undefined, args);
    }

    if (process.env.NODE_ENV !== 'production' && typeof props.css === 'string' && // check if there is a css declaration
    props.css.indexOf(':') !== -1) {
      throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
    }

    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = Emotion;
    var newProps = {};

    for (var key in props) {
      if (hasOwnProperty.call(props, key)) {
        newProps[key] = props[key];
      }
    }

    newProps[typePropName] = type;

    if (process.env.NODE_ENV !== 'production') {
      var error = new Error();

      if (error.stack) {
        // chrome
        var match = error.stack.match(/at (?:Object\.|)jsx.*\n\s+at ([A-Z][A-Za-z$]+) /);

        if (!match) {
          // safari and firefox
          match = error.stack.match(/.*\n([A-Z][A-Za-z$]+)@/);
        }

        if (match) {
          newProps[labelPropName] = sanitizeIdentifier(match[1]);
        }
      }
    }

    createElementArgArray[1] = newProps;

    for (var i = 2; i < argsLength; i++) {
      createElementArgArray[i] = args[i];
    } // $FlowFixMe


    return React$2.createElement.apply(null, createElementArgArray);
  };

  var keyframes = function keyframes() {
    var insertable = css.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe

    return {
      name: name,
      styles: "@keyframes " + name + "{" + insertable.styles + "}",
      anim: 1,
      toString: function toString() {
        return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
      }
    };
  };

  var classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';

    for (; i < len; i++) {
      var arg = args[i];
      if (arg == null) continue;
      var toAdd = void 0;

      switch (typeof arg) {
        case 'boolean':
          break;

        case 'object':
          {
            if (Array.isArray(arg)) {
              toAdd = classnames(arg);
            } else {
              toAdd = '';

              for (var k in arg) {
                if (arg[k] && k) {
                  toAdd && (toAdd += ' ');
                  toAdd += k;
                }
              }
            }

            break;
          }

        default:
          {
            toAdd = arg;
          }
      }

      if (toAdd) {
        cls && (cls += ' ');
        cls += toAdd;
      }
    }

    return cls;
  };

  function merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = getRegisteredStyles(registered, registeredStyles, className);

    if (registeredStyles.length < 2) {
      return className;
    }

    return rawClassName + css(registeredStyles);
  }

  var ClassNames = withEmotionCache(function (props, context) {
    return React$2.createElement(ThemeContext.Consumer, null, function (theme) {
      var rules = '';
      var serializedHashes = '';
      var hasRendered = false;

      var css = function css() {
        if (hasRendered && process.env.NODE_ENV !== 'production') {
          throw new Error('css can only be used during render');
        }

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var serialized = serializeStyles(args, context.registered);

        if (isBrowser$2) {
          insertStyles(context, serialized, false);
        } else {
          var res = insertStyles(context, serialized, false);

          if (res !== undefined) {
            rules += res;
          }
        }

        if (!isBrowser$2) {
          serializedHashes += " " + serialized.name;
        }

        return context.key + "-" + serialized.name;
      };

      var cx = function cx() {
        if (hasRendered && process.env.NODE_ENV !== 'production') {
          throw new Error('cx can only be used during render');
        }

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return merge(context.registered, css, classnames(args));
      };

      var content = {
        css: css,
        cx: cx,
        theme: theme
      };
      var ele = props.children(content);
      hasRendered = true;

      if (!isBrowser$2 && rules.length !== 0) {
        var _ref;

        return React$2.createElement(React$2.Fragment, null, React$2.createElement("style", (_ref = {}, _ref["data-emotion-" + context.key] = serializedHashes.substring(1), _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = context.sheet.nonce, _ref)), ele);
      }

      return ele;
    });
  });

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function unwrapExports (x) {
  	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
  }

  function createCommonjsModule(fn, module) {
  	return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /** @license React v16.13.1
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
  Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
  function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}var AsyncMode=l;var ConcurrentMode=m;var ContextConsumer=k;var ContextProvider=h;var Element=c;var ForwardRef=n;var Fragment=e;var Lazy=t;var Memo=r;var Portal=d;
  var Profiler=g;var StrictMode=f;var Suspense=p;var isAsyncMode=function(a){return A(a)||z(a)===l};var isConcurrentMode=A;var isContextConsumer=function(a){return z(a)===k};var isContextProvider=function(a){return z(a)===h};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};var isForwardRef=function(a){return z(a)===n};var isFragment=function(a){return z(a)===e};var isLazy=function(a){return z(a)===t};
  var isMemo=function(a){return z(a)===r};var isPortal=function(a){return z(a)===d};var isProfiler=function(a){return z(a)===g};var isStrictMode=function(a){return z(a)===f};var isSuspense=function(a){return z(a)===p};
  var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};var typeOf=z;

  var reactIs_production_min = {
  	AsyncMode: AsyncMode,
  	ConcurrentMode: ConcurrentMode,
  	ContextConsumer: ContextConsumer,
  	ContextProvider: ContextProvider,
  	Element: Element,
  	ForwardRef: ForwardRef,
  	Fragment: Fragment,
  	Lazy: Lazy,
  	Memo: Memo,
  	Portal: Portal,
  	Profiler: Profiler,
  	StrictMode: StrictMode,
  	Suspense: Suspense,
  	isAsyncMode: isAsyncMode,
  	isConcurrentMode: isConcurrentMode,
  	isContextConsumer: isContextConsumer,
  	isContextProvider: isContextProvider,
  	isElement: isElement,
  	isForwardRef: isForwardRef,
  	isFragment: isFragment,
  	isLazy: isLazy,
  	isMemo: isMemo,
  	isPortal: isPortal,
  	isProfiler: isProfiler,
  	isStrictMode: isStrictMode,
  	isSuspense: isSuspense,
  	isValidElementType: isValidElementType,
  	typeOf: typeOf
  };

  var reactIs_development = createCommonjsModule(function (module, exports) {



  if (process.env.NODE_ENV !== "production") {
    (function() {

  // The Symbol used to tag the ReactElement-like types. If there is no native Symbol
  // nor polyfill, then a plain number is used for performance.
  var hasSymbol = typeof Symbol === 'function' && Symbol.for;
  var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
  var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
  var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
  var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
  var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
  var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
  var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
  // (unstable) APIs that have been removed. Can we remove the symbols?

  var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
  var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
  var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
  var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
  var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
  var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
  var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
  var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
  var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
  var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
  var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

  function isValidElementType(type) {
    return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
    type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
  }

  function typeOf(object) {
    if (typeof object === 'object' && object !== null) {
      var $$typeof = object.$$typeof;

      switch ($$typeof) {
        case REACT_ELEMENT_TYPE:
          var type = object.type;

          switch (type) {
            case REACT_ASYNC_MODE_TYPE:
            case REACT_CONCURRENT_MODE_TYPE:
            case REACT_FRAGMENT_TYPE:
            case REACT_PROFILER_TYPE:
            case REACT_STRICT_MODE_TYPE:
            case REACT_SUSPENSE_TYPE:
              return type;

            default:
              var $$typeofType = type && type.$$typeof;

              switch ($$typeofType) {
                case REACT_CONTEXT_TYPE:
                case REACT_FORWARD_REF_TYPE:
                case REACT_LAZY_TYPE:
                case REACT_MEMO_TYPE:
                case REACT_PROVIDER_TYPE:
                  return $$typeofType;

                default:
                  return $$typeof;
              }

          }

        case REACT_PORTAL_TYPE:
          return $$typeof;
      }
    }

    return undefined;
  } // AsyncMode is deprecated along with isAsyncMode

  var AsyncMode = REACT_ASYNC_MODE_TYPE;
  var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
  var ContextConsumer = REACT_CONTEXT_TYPE;
  var ContextProvider = REACT_PROVIDER_TYPE;
  var Element = REACT_ELEMENT_TYPE;
  var ForwardRef = REACT_FORWARD_REF_TYPE;
  var Fragment = REACT_FRAGMENT_TYPE;
  var Lazy = REACT_LAZY_TYPE;
  var Memo = REACT_MEMO_TYPE;
  var Portal = REACT_PORTAL_TYPE;
  var Profiler = REACT_PROFILER_TYPE;
  var StrictMode = REACT_STRICT_MODE_TYPE;
  var Suspense = REACT_SUSPENSE_TYPE;
  var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

  function isAsyncMode(object) {
    {
      if (!hasWarnedAboutDeprecatedIsAsyncMode) {
        hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

        console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
      }
    }

    return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
  }
  function isConcurrentMode(object) {
    return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
  }
  function isContextConsumer(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
  }
  function isContextProvider(object) {
    return typeOf(object) === REACT_PROVIDER_TYPE;
  }
  function isElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  }
  function isForwardRef(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
  }
  function isFragment(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
  }
  function isLazy(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
  }
  function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
  }
  function isPortal(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
  }
  function isProfiler(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
  }
  function isStrictMode(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
  }
  function isSuspense(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
  }

  exports.AsyncMode = AsyncMode;
  exports.ConcurrentMode = ConcurrentMode;
  exports.ContextConsumer = ContextConsumer;
  exports.ContextProvider = ContextProvider;
  exports.Element = Element;
  exports.ForwardRef = ForwardRef;
  exports.Fragment = Fragment;
  exports.Lazy = Lazy;
  exports.Memo = Memo;
  exports.Portal = Portal;
  exports.Profiler = Profiler;
  exports.StrictMode = StrictMode;
  exports.Suspense = Suspense;
  exports.isAsyncMode = isAsyncMode;
  exports.isConcurrentMode = isConcurrentMode;
  exports.isContextConsumer = isContextConsumer;
  exports.isContextProvider = isContextProvider;
  exports.isElement = isElement;
  exports.isForwardRef = isForwardRef;
  exports.isFragment = isFragment;
  exports.isLazy = isLazy;
  exports.isMemo = isMemo;
  exports.isPortal = isPortal;
  exports.isProfiler = isProfiler;
  exports.isStrictMode = isStrictMode;
  exports.isSuspense = isSuspense;
  exports.isValidElementType = isValidElementType;
  exports.typeOf = typeOf;
    })();
  }
  });
  var reactIs_development_1 = reactIs_development.AsyncMode;
  var reactIs_development_2 = reactIs_development.ConcurrentMode;
  var reactIs_development_3 = reactIs_development.ContextConsumer;
  var reactIs_development_4 = reactIs_development.ContextProvider;
  var reactIs_development_5 = reactIs_development.Element;
  var reactIs_development_6 = reactIs_development.ForwardRef;
  var reactIs_development_7 = reactIs_development.Fragment;
  var reactIs_development_8 = reactIs_development.Lazy;
  var reactIs_development_9 = reactIs_development.Memo;
  var reactIs_development_10 = reactIs_development.Portal;
  var reactIs_development_11 = reactIs_development.Profiler;
  var reactIs_development_12 = reactIs_development.StrictMode;
  var reactIs_development_13 = reactIs_development.Suspense;
  var reactIs_development_14 = reactIs_development.isAsyncMode;
  var reactIs_development_15 = reactIs_development.isConcurrentMode;
  var reactIs_development_16 = reactIs_development.isContextConsumer;
  var reactIs_development_17 = reactIs_development.isContextProvider;
  var reactIs_development_18 = reactIs_development.isElement;
  var reactIs_development_19 = reactIs_development.isForwardRef;
  var reactIs_development_20 = reactIs_development.isFragment;
  var reactIs_development_21 = reactIs_development.isLazy;
  var reactIs_development_22 = reactIs_development.isMemo;
  var reactIs_development_23 = reactIs_development.isPortal;
  var reactIs_development_24 = reactIs_development.isProfiler;
  var reactIs_development_25 = reactIs_development.isStrictMode;
  var reactIs_development_26 = reactIs_development.isSuspense;
  var reactIs_development_27 = reactIs_development.isValidElementType;
  var reactIs_development_28 = reactIs_development.typeOf;

  var reactIs = createCommonjsModule(function (module) {

  if (process.env.NODE_ENV === 'production') {
    module.exports = reactIs_production_min;
  } else {
    module.exports = reactIs_development;
  }
  });

  /*
  object-assign
  (c) Sindre Sorhus
  @license MIT
  */
  /* eslint-disable no-unused-vars */
  var getOwnPropertySymbols = Object.getOwnPropertySymbols;
  var hasOwnProperty$1 = Object.prototype.hasOwnProperty;
  var propIsEnumerable = Object.prototype.propertyIsEnumerable;

  function toObject(val) {
  	if (val === null || val === undefined) {
  		throw new TypeError('Object.assign cannot be called with null or undefined');
  	}

  	return Object(val);
  }

  function shouldUseNative() {
  	try {
  		if (!Object.assign) {
  			return false;
  		}

  		// Detect buggy property enumeration order in older V8 versions.

  		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
  		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
  		test1[5] = 'de';
  		if (Object.getOwnPropertyNames(test1)[0] === '5') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test2 = {};
  		for (var i = 0; i < 10; i++) {
  			test2['_' + String.fromCharCode(i)] = i;
  		}
  		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
  			return test2[n];
  		});
  		if (order2.join('') !== '0123456789') {
  			return false;
  		}

  		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
  		var test3 = {};
  		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
  			test3[letter] = letter;
  		});
  		if (Object.keys(Object.assign({}, test3)).join('') !==
  				'abcdefghijklmnopqrst') {
  			return false;
  		}

  		return true;
  	} catch (err) {
  		// We don't expect any of the above to throw, but better to be safe.
  		return false;
  	}
  }

  var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
  	var from;
  	var to = toObject(target);
  	var symbols;

  	for (var s = 1; s < arguments.length; s++) {
  		from = Object(arguments[s]);

  		for (var key in from) {
  			if (hasOwnProperty$1.call(from, key)) {
  				to[key] = from[key];
  			}
  		}

  		if (getOwnPropertySymbols) {
  			symbols = getOwnPropertySymbols(from);
  			for (var i = 0; i < symbols.length; i++) {
  				if (propIsEnumerable.call(from, symbols[i])) {
  					to[symbols[i]] = from[symbols[i]];
  				}
  			}
  		}
  	}

  	return to;
  };

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

  var ReactPropTypesSecret_1 = ReactPropTypesSecret;

  var printWarning = function() {};

  if (process.env.NODE_ENV !== 'production') {
    var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
    var loggedTypeFailures = {};
    var has = Function.call.bind(Object.prototype.hasOwnProperty);

    printWarning = function(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  /**
   * Assert that the values match with the type specs.
   * Error messages are memorized and will only be shown once.
   *
   * @param {object} typeSpecs Map of name to a ReactPropType
   * @param {object} values Runtime values that need to be type-checked
   * @param {string} location e.g. "prop", "context", "child context"
   * @param {string} componentName Name of the component for error messages.
   * @param {?Function} getStack Returns the component stack.
   * @private
   */
  function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
    if (process.env.NODE_ENV !== 'production') {
      for (var typeSpecName in typeSpecs) {
        if (has(typeSpecs, typeSpecName)) {
          var error;
          // Prop type validation may throw. In case they do, we don't want to
          // fail the render phase where it didn't fail before. So we log it.
          // After these have been cleaned up, we'll let them throw.
          try {
            // This is intentionally an invariant that gets caught. It's the same
            // behavior as without this statement except with a better message.
            if (typeof typeSpecs[typeSpecName] !== 'function') {
              var err = Error(
                (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
                'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.'
              );
              err.name = 'Invariant Violation';
              throw err;
            }
            error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
          } catch (ex) {
            error = ex;
          }
          if (error && !(error instanceof Error)) {
            printWarning(
              (componentName || 'React class') + ': type specification of ' +
              location + ' `' + typeSpecName + '` is invalid; the type checker ' +
              'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
              'You may have forgotten to pass an argument to the type checker ' +
              'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
              'shape all require an argument).'
            );
          }
          if (error instanceof Error && !(error.message in loggedTypeFailures)) {
            // Only monitor this failure once because there tends to be a lot of the
            // same error.
            loggedTypeFailures[error.message] = true;

            var stack = getStack ? getStack() : '';

            printWarning(
              'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
            );
          }
        }
      }
    }
  }

  /**
   * Resets warning cache when testing.
   *
   * @private
   */
  checkPropTypes.resetWarningCache = function() {
    if (process.env.NODE_ENV !== 'production') {
      loggedTypeFailures = {};
    }
  };

  var checkPropTypes_1 = checkPropTypes;

  var has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
  var printWarning$1 = function() {};

  if (process.env.NODE_ENV !== 'production') {
    printWarning$1 = function(text) {
      var message = 'Warning: ' + text;
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };
  }

  function emptyFunctionThatReturnsNull() {
    return null;
  }

  var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
    /* global Symbol */
    var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
    var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

    /**
     * Returns the iterator method function contained on the iterable object.
     *
     * Be sure to invoke the function with the iterable as context:
     *
     *     var iteratorFn = getIteratorFn(myIterable);
     *     if (iteratorFn) {
     *       var iterator = iteratorFn.call(myIterable);
     *       ...
     *     }
     *
     * @param {?object} maybeIterable
     * @return {?function}
     */
    function getIteratorFn(maybeIterable) {
      var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
      if (typeof iteratorFn === 'function') {
        return iteratorFn;
      }
    }

    /**
     * Collection of methods that allow declaration and validation of props that are
     * supplied to React components. Example usage:
     *
     *   var Props = require('ReactPropTypes');
     *   var MyArticle = React.createClass({
     *     propTypes: {
     *       // An optional string prop named "description".
     *       description: Props.string,
     *
     *       // A required enum prop named "category".
     *       category: Props.oneOf(['News','Photos']).isRequired,
     *
     *       // A prop named "dialog" that requires an instance of Dialog.
     *       dialog: Props.instanceOf(Dialog).isRequired
     *     },
     *     render: function() { ... }
     *   });
     *
     * A more formal specification of how these methods are used:
     *
     *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
     *   decl := ReactPropTypes.{type}(.isRequired)?
     *
     * Each and every declaration produces a function with the same signature. This
     * allows the creation of custom validation functions. For example:
     *
     *  var MyLink = React.createClass({
     *    propTypes: {
     *      // An optional string or URI prop named "href".
     *      href: function(props, propName, componentName) {
     *        var propValue = props[propName];
     *        if (propValue != null && typeof propValue !== 'string' &&
     *            !(propValue instanceof URI)) {
     *          return new Error(
     *            'Expected a string or an URI for ' + propName + ' in ' +
     *            componentName
     *          );
     *        }
     *      }
     *    },
     *    render: function() {...}
     *  });
     *
     * @internal
     */

    var ANONYMOUS = '<<anonymous>>';

    // Important!
    // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
    var ReactPropTypes = {
      array: createPrimitiveTypeChecker('array'),
      bool: createPrimitiveTypeChecker('boolean'),
      func: createPrimitiveTypeChecker('function'),
      number: createPrimitiveTypeChecker('number'),
      object: createPrimitiveTypeChecker('object'),
      string: createPrimitiveTypeChecker('string'),
      symbol: createPrimitiveTypeChecker('symbol'),

      any: createAnyTypeChecker(),
      arrayOf: createArrayOfTypeChecker,
      element: createElementTypeChecker(),
      elementType: createElementTypeTypeChecker(),
      instanceOf: createInstanceTypeChecker,
      node: createNodeChecker(),
      objectOf: createObjectOfTypeChecker,
      oneOf: createEnumTypeChecker,
      oneOfType: createUnionTypeChecker,
      shape: createShapeTypeChecker,
      exact: createStrictShapeTypeChecker,
    };

    /**
     * inlined Object.is polyfill to avoid requiring consumers ship their own
     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
     */
    /*eslint-disable no-self-compare*/
    function is(x, y) {
      // SameValue algorithm
      if (x === y) {
        // Steps 1-5, 7-10
        // Steps 6.b-6.e: +0 != -0
        return x !== 0 || 1 / x === 1 / y;
      } else {
        // Step 6.a: NaN == NaN
        return x !== x && y !== y;
      }
    }
    /*eslint-enable no-self-compare*/

    /**
     * We use an Error-like object for backward compatibility as people may call
     * PropTypes directly and inspect their output. However, we don't use real
     * Errors anymore. We don't inspect their stack anyway, and creating them
     * is prohibitively expensive if they are created too often, such as what
     * happens in oneOfType() for any type before the one that matched.
     */
    function PropTypeError(message) {
      this.message = message;
      this.stack = '';
    }
    // Make `instanceof Error` still work for returned errors.
    PropTypeError.prototype = Error.prototype;

    function createChainableTypeChecker(validate) {
      if (process.env.NODE_ENV !== 'production') {
        var manualPropTypeCallCache = {};
        var manualPropTypeWarningCount = 0;
      }
      function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
        componentName = componentName || ANONYMOUS;
        propFullName = propFullName || propName;

        if (secret !== ReactPropTypesSecret_1) {
          if (throwOnDirectAccess) {
            // New behavior only for users of `prop-types` package
            var err = new Error(
              'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
              'Use `PropTypes.checkPropTypes()` to call them. ' +
              'Read more at http://fb.me/use-check-prop-types'
            );
            err.name = 'Invariant Violation';
            throw err;
          } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
            // Old behavior for people using React.PropTypes
            var cacheKey = componentName + ':' + propName;
            if (
              !manualPropTypeCallCache[cacheKey] &&
              // Avoid spamming the console because they are often not actionable except for lib authors
              manualPropTypeWarningCount < 3
            ) {
              printWarning$1(
                'You are manually calling a React.PropTypes validation ' +
                'function for the `' + propFullName + '` prop on `' + componentName  + '`. This is deprecated ' +
                'and will throw in the standalone `prop-types` package. ' +
                'You may be seeing this warning due to a third-party PropTypes ' +
                'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
              );
              manualPropTypeCallCache[cacheKey] = true;
              manualPropTypeWarningCount++;
            }
          }
        }
        if (props[propName] == null) {
          if (isRequired) {
            if (props[propName] === null) {
              return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
            }
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
          }
          return null;
        } else {
          return validate(props, propName, componentName, location, propFullName);
        }
      }

      var chainedCheckType = checkType.bind(null, false);
      chainedCheckType.isRequired = checkType.bind(null, true);

      return chainedCheckType;
    }

    function createPrimitiveTypeChecker(expectedType) {
      function validate(props, propName, componentName, location, propFullName, secret) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== expectedType) {
          // `propValue` being instance of, say, date/regexp, pass the 'object'
          // check, but we can offer a more precise error message here rather than
          // 'of type `object`'.
          var preciseType = getPreciseType(propValue);

          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createAnyTypeChecker() {
      return createChainableTypeChecker(emptyFunctionThatReturnsNull);
    }

    function createArrayOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
        }
        var propValue = props[propName];
        if (!Array.isArray(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
        }
        for (var i = 0; i < propValue.length; i++) {
          var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
          if (error instanceof Error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!isValidElement(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createElementTypeTypeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!reactIs.isValidElementType(propValue)) {
          var propType = getPropType(propValue);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createInstanceTypeChecker(expectedClass) {
      function validate(props, propName, componentName, location, propFullName) {
        if (!(props[propName] instanceof expectedClass)) {
          var expectedClassName = expectedClass.name || ANONYMOUS;
          var actualClassName = getClassName(props[propName]);
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createEnumTypeChecker(expectedValues) {
      if (!Array.isArray(expectedValues)) {
        if (process.env.NODE_ENV !== 'production') {
          if (arguments.length > 1) {
            printWarning$1(
              'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
              'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
            );
          } else {
            printWarning$1('Invalid argument supplied to oneOf, expected an array.');
          }
        }
        return emptyFunctionThatReturnsNull;
      }

      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        for (var i = 0; i < expectedValues.length; i++) {
          if (is(propValue, expectedValues[i])) {
            return null;
          }
        }

        var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
          var type = getPreciseType(value);
          if (type === 'symbol') {
            return String(value);
          }
          return value;
        });
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createObjectOfTypeChecker(typeChecker) {
      function validate(props, propName, componentName, location, propFullName) {
        if (typeof typeChecker !== 'function') {
          return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
        }
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
        }
        for (var key in propValue) {
          if (has$1(propValue, key)) {
            var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
            if (error instanceof Error) {
              return error;
            }
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createUnionTypeChecker(arrayOfTypeCheckers) {
      if (!Array.isArray(arrayOfTypeCheckers)) {
        process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
        return emptyFunctionThatReturnsNull;
      }

      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (typeof checker !== 'function') {
          printWarning$1(
            'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
            'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
          );
          return emptyFunctionThatReturnsNull;
        }
      }

      function validate(props, propName, componentName, location, propFullName) {
        for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
          var checker = arrayOfTypeCheckers[i];
          if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
            return null;
          }
        }

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
      }
      return createChainableTypeChecker(validate);
    }

    function createNodeChecker() {
      function validate(props, propName, componentName, location, propFullName) {
        if (!isNode(props[propName])) {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        for (var key in shapeTypes) {
          var checker = shapeTypes[key];
          if (!checker) {
            continue;
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }
      return createChainableTypeChecker(validate);
    }

    function createStrictShapeTypeChecker(shapeTypes) {
      function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        var propType = getPropType(propValue);
        if (propType !== 'object') {
          return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
        }
        // We need to check all keys in case some are required but missing from
        // props.
        var allKeys = objectAssign({}, props[propName], shapeTypes);
        for (var key in allKeys) {
          var checker = shapeTypes[key];
          if (!checker) {
            return new PropTypeError(
              'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
              '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
              '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
            );
          }
          var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
          if (error) {
            return error;
          }
        }
        return null;
      }

      return createChainableTypeChecker(validate);
    }

    function isNode(propValue) {
      switch (typeof propValue) {
        case 'number':
        case 'string':
        case 'undefined':
          return true;
        case 'boolean':
          return !propValue;
        case 'object':
          if (Array.isArray(propValue)) {
            return propValue.every(isNode);
          }
          if (propValue === null || isValidElement(propValue)) {
            return true;
          }

          var iteratorFn = getIteratorFn(propValue);
          if (iteratorFn) {
            var iterator = iteratorFn.call(propValue);
            var step;
            if (iteratorFn !== propValue.entries) {
              while (!(step = iterator.next()).done) {
                if (!isNode(step.value)) {
                  return false;
                }
              }
            } else {
              // Iterator will provide entry [k,v] tuples rather than values.
              while (!(step = iterator.next()).done) {
                var entry = step.value;
                if (entry) {
                  if (!isNode(entry[1])) {
                    return false;
                  }
                }
              }
            }
          } else {
            return false;
          }

          return true;
        default:
          return false;
      }
    }

    function isSymbol(propType, propValue) {
      // Native Symbol.
      if (propType === 'symbol') {
        return true;
      }

      // falsy value can't be a Symbol
      if (!propValue) {
        return false;
      }

      // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
      if (propValue['@@toStringTag'] === 'Symbol') {
        return true;
      }

      // Fallback for non-spec compliant Symbols which are polyfilled.
      if (typeof Symbol === 'function' && propValue instanceof Symbol) {
        return true;
      }

      return false;
    }

    // Equivalent of `typeof` but with special handling for array and regexp.
    function getPropType(propValue) {
      var propType = typeof propValue;
      if (Array.isArray(propValue)) {
        return 'array';
      }
      if (propValue instanceof RegExp) {
        // Old webkits (at least until Android 4.0) return 'function' rather than
        // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
        // passes PropTypes.object.
        return 'object';
      }
      if (isSymbol(propType, propValue)) {
        return 'symbol';
      }
      return propType;
    }

    // This handles more types than `getPropType`. Only used for error messages.
    // See `createPrimitiveTypeChecker`.
    function getPreciseType(propValue) {
      if (typeof propValue === 'undefined' || propValue === null) {
        return '' + propValue;
      }
      var propType = getPropType(propValue);
      if (propType === 'object') {
        if (propValue instanceof Date) {
          return 'date';
        } else if (propValue instanceof RegExp) {
          return 'regexp';
        }
      }
      return propType;
    }

    // Returns a string that is postfixed to a warning about an invalid type.
    // For example, "undefined" or "of type array"
    function getPostfixForTypeWarning(value) {
      var type = getPreciseType(value);
      switch (type) {
        case 'array':
        case 'object':
          return 'an ' + type;
        case 'boolean':
        case 'date':
        case 'regexp':
          return 'a ' + type;
        default:
          return type;
      }
    }

    // Returns class name of the object, if any.
    function getClassName(propValue) {
      if (!propValue.constructor || !propValue.constructor.name) {
        return ANONYMOUS;
      }
      return propValue.constructor.name;
    }

    ReactPropTypes.checkPropTypes = checkPropTypes_1;
    ReactPropTypes.resetWarningCache = checkPropTypes_1.resetWarningCache;
    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  function emptyFunction() {}
  function emptyFunctionWithReset() {}
  emptyFunctionWithReset.resetWarningCache = emptyFunction;

  var factoryWithThrowingShims = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
      if (secret === ReactPropTypesSecret_1) {
        // It is still safe when called from React.
        return;
      }
      var err = new Error(
        'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
        'Use PropTypes.checkPropTypes() to call them. ' +
        'Read more at http://fb.me/use-check-prop-types'
      );
      err.name = 'Invariant Violation';
      throw err;
    }  shim.isRequired = shim;
    function getShim() {
      return shim;
    }  // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
      array: shim,
      bool: shim,
      func: shim,
      number: shim,
      object: shim,
      string: shim,
      symbol: shim,

      any: shim,
      arrayOf: getShim,
      element: shim,
      elementType: shim,
      instanceOf: getShim,
      node: shim,
      objectOf: getShim,
      oneOf: getShim,
      oneOfType: getShim,
      shape: getShim,
      exact: getShim,

      checkPropTypes: emptyFunctionWithReset,
      resetWarningCache: emptyFunction
    };

    ReactPropTypes.PropTypes = ReactPropTypes;

    return ReactPropTypes;
  };

  var propTypes = createCommonjsModule(function (module) {
  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  if (process.env.NODE_ENV !== 'production') {
    var ReactIs = reactIs;

    // By explicitly using `prop-types` you are opting into new development behavior.
    // http://fb.me/prop-types-in-prod
    var throwOnDirectAccess = true;
    module.exports = factoryWithTypeCheckers(ReactIs.isElement, throwOnDirectAccess);
  } else {
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    module.exports = factoryWithThrowingShims();
  }
  });

  // ==============================
  // NO OP
  // ==============================
  var noop = function noop() {};
  // Class Name Prefixer
  // ==============================

  /**
   String representation of component state for styling with class names.

   Expects an array of strings OR a string/object pair:
   - className(['comp', 'comp-arg', 'comp-arg-2'])
     @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
   - className('comp', { some: true, state: false })
     @returns 'react-select__comp react-select__comp--some'
  */

  function applyPrefixToName(prefix, name) {
    if (!name) {
      return prefix;
    } else if (name[0] === '-') {
      return prefix + name;
    } else {
      return prefix + '__' + name;
    }
  }

  function classNames(prefix, state, className) {
    var arr = [className];

    if (state && prefix) {
      for (var key in state) {
        if (state.hasOwnProperty(key) && state[key]) {
          arr.push("" + applyPrefixToName(prefix, key));
        }
      }
    }

    return arr.filter(function (i) {
      return i;
    }).map(function (i) {
      return String(i).trim();
    }).join(' ');
  } // ==============================
  // Clean Value
  // ==============================

  var cleanValue = function cleanValue(value) {
    if (Array.isArray(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [value];
    return [];
  }; // ==============================
  // Scroll Helpers
  // ==============================

  function isDocumentElement(el) {
    return [document.documentElement, document.body, window].indexOf(el) > -1;
  } // Normalized Scroll Top
  // ------------------------------

  function getScrollTop(el) {
    if (isDocumentElement(el)) {
      return window.pageYOffset;
    }

    return el.scrollTop;
  }
  function scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if (isDocumentElement(el)) {
      window.scrollTo(0, top);
      return;
    }

    el.scrollTop = top;
  } // Get Scroll Parent
  // ------------------------------

  function getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    var docEl = document.documentElement; // suck it, flow...

    if (style.position === 'fixed') return docEl;

    for (var parent = element; parent = parent.parentElement;) {
      style = getComputedStyle(parent);

      if (excludeStaticParent && style.position === 'static') {
        continue;
      }

      if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) {
        return parent;
      }
    }

    return docEl;
  } // Animated Scroll To
  // ------------------------------

  /**
    @param t: time (elapsed)
    @param b: initial value
    @param c: amount of change
    @param d: duration
  */

  function easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  }

  function animatedScrollTo(element, to, duration, callback) {
    if (duration === void 0) {
      duration = 200;
    }

    if (callback === void 0) {
      callback = noop;
    }

    var start = getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;

    function animateScroll() {
      currentTime += increment;
      var val = easeOutCubic(currentTime, start, change, duration);
      scrollTo(element, val);

      if (currentTime < duration) {
        window.requestAnimationFrame(animateScroll);
      } else {
        callback(element);
      }
    }

    animateScroll();
  } // Scroll Into View
  // ------------------------------

  function scrollIntoView(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;

    if (focusedRect.bottom + overScroll > menuRect.bottom) {
      scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    } else if (focusedRect.top - overScroll < menuRect.top) {
      scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
  } // ==============================
  // Get bounding client object
  // ==============================
  // cannot get keys using array notation with DOMRect

  function getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
      bottom: rect.bottom,
      height: rect.height,
      left: rect.left,
      right: rect.right,
      top: rect.top,
      width: rect.width
    };
  }
  // Touch Capability Detector
  // ==============================

  function isTouchCapable() {
    try {
      document.createEvent('TouchEvent');
      return true;
    } catch (e) {
      return false;
    }
  } // ==============================
  // Mobile Device Detector
  // ==============================

  function isMobileDevice() {
    try {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
      return false;
    }
  }

  var AutosizeInput_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
  	value: true
  });

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();



  var _react2 = _interopRequireDefault(React$2__default);



  var _propTypes2 = _interopRequireDefault(propTypes);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  var sizerStyle = {
  	position: 'absolute',
  	top: 0,
  	left: 0,
  	visibility: 'hidden',
  	height: 0,
  	overflow: 'scroll',
  	whiteSpace: 'pre'
  };

  var INPUT_PROPS_BLACKLIST = ['extraWidth', 'injectStyles', 'inputClassName', 'inputRef', 'inputStyle', 'minWidth', 'onAutosize', 'placeholderIsMinWidth'];

  var cleanInputProps = function cleanInputProps(inputProps) {
  	INPUT_PROPS_BLACKLIST.forEach(function (field) {
  		return delete inputProps[field];
  	});
  	return inputProps;
  };

  var copyStyles = function copyStyles(styles, node) {
  	node.style.fontSize = styles.fontSize;
  	node.style.fontFamily = styles.fontFamily;
  	node.style.fontWeight = styles.fontWeight;
  	node.style.fontStyle = styles.fontStyle;
  	node.style.letterSpacing = styles.letterSpacing;
  	node.style.textTransform = styles.textTransform;
  };

  var isIE = typeof window !== 'undefined' && window.navigator ? /MSIE |Trident\/|Edge\//.test(window.navigator.userAgent) : false;

  var generateId = function generateId() {
  	// we only need an auto-generated ID for stylesheet injection, which is only
  	// used for IE. so if the browser is not IE, this should return undefined.
  	return isIE ? '_' + Math.random().toString(36).substr(2, 12) : undefined;
  };

  var AutosizeInput = function (_Component) {
  	_inherits(AutosizeInput, _Component);

  	function AutosizeInput(props) {
  		_classCallCheck(this, AutosizeInput);

  		var _this = _possibleConstructorReturn(this, (AutosizeInput.__proto__ || Object.getPrototypeOf(AutosizeInput)).call(this, props));

  		_this.inputRef = function (el) {
  			_this.input = el;
  			if (typeof _this.props.inputRef === 'function') {
  				_this.props.inputRef(el);
  			}
  		};

  		_this.placeHolderSizerRef = function (el) {
  			_this.placeHolderSizer = el;
  		};

  		_this.sizerRef = function (el) {
  			_this.sizer = el;
  		};

  		_this.state = {
  			inputWidth: props.minWidth,
  			inputId: props.id || generateId()
  		};
  		return _this;
  	}

  	_createClass(AutosizeInput, [{
  		key: 'componentDidMount',
  		value: function componentDidMount() {
  			this.mounted = true;
  			this.copyInputStyles();
  			this.updateInputWidth();
  		}
  	}, {
  		key: 'UNSAFE_componentWillReceiveProps',
  		value: function UNSAFE_componentWillReceiveProps(nextProps) {
  			var id = nextProps.id;

  			if (id !== this.props.id) {
  				this.setState({ inputId: id || generateId() });
  			}
  		}
  	}, {
  		key: 'componentDidUpdate',
  		value: function componentDidUpdate(prevProps, prevState) {
  			if (prevState.inputWidth !== this.state.inputWidth) {
  				if (typeof this.props.onAutosize === 'function') {
  					this.props.onAutosize(this.state.inputWidth);
  				}
  			}
  			this.updateInputWidth();
  		}
  	}, {
  		key: 'componentWillUnmount',
  		value: function componentWillUnmount() {
  			this.mounted = false;
  		}
  	}, {
  		key: 'copyInputStyles',
  		value: function copyInputStyles() {
  			if (!this.mounted || !window.getComputedStyle) {
  				return;
  			}
  			var inputStyles = this.input && window.getComputedStyle(this.input);
  			if (!inputStyles) {
  				return;
  			}
  			copyStyles(inputStyles, this.sizer);
  			if (this.placeHolderSizer) {
  				copyStyles(inputStyles, this.placeHolderSizer);
  			}
  		}
  	}, {
  		key: 'updateInputWidth',
  		value: function updateInputWidth() {
  			if (!this.mounted || !this.sizer || typeof this.sizer.scrollWidth === 'undefined') {
  				return;
  			}
  			var newInputWidth = void 0;
  			if (this.props.placeholder && (!this.props.value || this.props.value && this.props.placeholderIsMinWidth)) {
  				newInputWidth = Math.max(this.sizer.scrollWidth, this.placeHolderSizer.scrollWidth) + 2;
  			} else {
  				newInputWidth = this.sizer.scrollWidth + 2;
  			}
  			// add extraWidth to the detected width. for number types, this defaults to 16 to allow for the stepper UI
  			var extraWidth = this.props.type === 'number' && this.props.extraWidth === undefined ? 16 : parseInt(this.props.extraWidth) || 0;
  			newInputWidth += extraWidth;
  			if (newInputWidth < this.props.minWidth) {
  				newInputWidth = this.props.minWidth;
  			}
  			if (newInputWidth !== this.state.inputWidth) {
  				this.setState({
  					inputWidth: newInputWidth
  				});
  			}
  		}
  	}, {
  		key: 'getInput',
  		value: function getInput() {
  			return this.input;
  		}
  	}, {
  		key: 'focus',
  		value: function focus() {
  			this.input.focus();
  		}
  	}, {
  		key: 'blur',
  		value: function blur() {
  			this.input.blur();
  		}
  	}, {
  		key: 'select',
  		value: function select() {
  			this.input.select();
  		}
  	}, {
  		key: 'renderStyles',
  		value: function renderStyles() {
  			// this method injects styles to hide IE's clear indicator, which messes
  			// with input size detection. the stylesheet is only injected when the
  			// browser is IE, and can also be disabled by the `injectStyles` prop.
  			var injectStyles = this.props.injectStyles;

  			return isIE && injectStyles ? _react2.default.createElement('style', { dangerouslySetInnerHTML: {
  					__html: 'input#' + this.state.inputId + '::-ms-clear {display: none;}'
  				} }) : null;
  		}
  	}, {
  		key: 'render',
  		value: function render() {
  			var sizerValue = [this.props.defaultValue, this.props.value, ''].reduce(function (previousValue, currentValue) {
  				if (previousValue !== null && previousValue !== undefined) {
  					return previousValue;
  				}
  				return currentValue;
  			});

  			var wrapperStyle = _extends({}, this.props.style);
  			if (!wrapperStyle.display) wrapperStyle.display = 'inline-block';

  			var inputStyle = _extends({
  				boxSizing: 'content-box',
  				width: this.state.inputWidth + 'px'
  			}, this.props.inputStyle);

  			var inputProps = _objectWithoutProperties(this.props, []);

  			cleanInputProps(inputProps);
  			inputProps.className = this.props.inputClassName;
  			inputProps.id = this.state.inputId;
  			inputProps.style = inputStyle;

  			return _react2.default.createElement(
  				'div',
  				{ className: this.props.className, style: wrapperStyle },
  				this.renderStyles(),
  				_react2.default.createElement('input', _extends({}, inputProps, { ref: this.inputRef })),
  				_react2.default.createElement(
  					'div',
  					{ ref: this.sizerRef, style: sizerStyle },
  					sizerValue
  				),
  				this.props.placeholder ? _react2.default.createElement(
  					'div',
  					{ ref: this.placeHolderSizerRef, style: sizerStyle },
  					this.props.placeholder
  				) : null
  			);
  		}
  	}]);

  	return AutosizeInput;
  }(React$2__default.Component);

  AutosizeInput.propTypes = {
  	className: _propTypes2.default.string, // className for the outer element
  	defaultValue: _propTypes2.default.any, // default field value
  	extraWidth: _propTypes2.default.oneOfType([// additional width for input element
  	_propTypes2.default.number, _propTypes2.default.string]),
  	id: _propTypes2.default.string, // id to use for the input, can be set for consistent snapshots
  	injectStyles: _propTypes2.default.bool, // inject the custom stylesheet to hide clear UI, defaults to true
  	inputClassName: _propTypes2.default.string, // className for the input element
  	inputRef: _propTypes2.default.func, // ref callback for the input element
  	inputStyle: _propTypes2.default.object, // css styles for the input element
  	minWidth: _propTypes2.default.oneOfType([// minimum width for input element
  	_propTypes2.default.number, _propTypes2.default.string]),
  	onAutosize: _propTypes2.default.func, // onAutosize handler: function(newWidth) {}
  	onChange: _propTypes2.default.func, // onChange handler: function(event) {}
  	placeholder: _propTypes2.default.string, // placeholder text
  	placeholderIsMinWidth: _propTypes2.default.bool, // don't collapse size to less than the placeholder
  	style: _propTypes2.default.object, // css styles for the outer element
  	value: _propTypes2.default.any // field value
  };
  AutosizeInput.defaultProps = {
  	minWidth: 1,
  	injectStyles: true
  };

  exports.default = AutosizeInput;
  });

  var AutosizeInput = unwrapExports(AutosizeInput_1);

  function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

  function _inheritsLoose$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
  function getMenuPlacement(_ref) {
    var maxHeight = _ref.maxHeight,
        menuEl = _ref.menuEl,
        minHeight = _ref.minHeight,
        placement = _ref.placement,
        shouldScroll = _ref.shouldScroll,
        isFixedPosition = _ref.isFixedPosition,
        theme = _ref.theme;
    var spacing = theme.spacing;
    var scrollParent = getScrollParent(menuEl);
    var defaultState = {
      placement: 'bottom',
      maxHeight: maxHeight
    }; // something went wrong, return default state

    if (!menuEl || !menuEl.offsetParent) return defaultState; // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered

    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(),
        scrollHeight = _scrollParent$getBoun.height;

    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(),
        menuBottom = _menuEl$getBoundingCl.bottom,
        menuHeight = _menuEl$getBoundingCl.height,
        menuTop = _menuEl$getBoundingCl.top;

    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(),
        containerTop = _menuEl$offsetParent$.top;

    var viewHeight = window.innerHeight;
    var scrollTop = getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;

    switch (placement) {
      case 'auto':
      case 'bottom':
        // 1: the menu will fit, do nothing
        if (viewSpaceBelow >= menuHeight) {
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled


        if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          }

          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained


        if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollDown, scrollDuration);
          } // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.


          var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
          return {
            placement: 'bottom',
            maxHeight: constrainedHeight
          };
        } // 4. Forked beviour when there isn't enough space below
        // AUTO: flip the menu, render above


        if (placement === 'auto' || isFixedPosition) {
          // may need to be constrained after flipping
          var _constrainedHeight = maxHeight;
          var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;

          if (spaceAbove >= minHeight) {
            _constrainedHeight = Math.min(spaceAbove - marginBottom - spacing.controlHeight, maxHeight);
          }

          return {
            placement: 'top',
            maxHeight: _constrainedHeight
          };
        } // BOTTOM: allow browser to increase scrollable area and immediately set scroll


        if (placement === 'bottom') {
          scrollTo(scrollParent, scrollDown);
          return {
            placement: 'bottom',
            maxHeight: maxHeight
          };
        }

        break;

      case 'top':
        // 1: the menu will fit, do nothing
        if (viewSpaceAbove >= menuHeight) {
          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 2: the menu will fit, if scrolled


        if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }

          return {
            placement: 'top',
            maxHeight: maxHeight
          };
        } // 3: the menu will fit, if constrained


        if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
          var _constrainedHeight2 = maxHeight; // we want to provide as much of the menu as possible to the user,
          // so give them whatever is available below rather than the minHeight.

          if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
            _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
          }

          if (shouldScroll) {
            animatedScrollTo(scrollParent, scrollUp, scrollDuration);
          }

          return {
            placement: 'top',
            maxHeight: _constrainedHeight2
          };
        } // 4. not enough space, the browser WILL NOT increase scrollable area when
        // absolutely positioned element rendered above the viewport (only below).
        // Flip the menu, render below


        return {
          placement: 'bottom',
          maxHeight: maxHeight
        };

      default:
        throw new Error("Invalid placement provided \"" + placement + "\".");
    } // fulfil contract with flow: implicit return value of undefined


    return defaultState;
  } // Menu Component
  // ------------------------------

  function alignToControl(placement) {
    var placementToCSSProp = {
      bottom: 'top',
      top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
  }

  var coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
  };

  var menuCSS = function menuCSS(_ref2) {
    var _ref3;

    var placement = _ref2.placement,
        _ref2$theme = _ref2.theme,
        borderRadius = _ref2$theme.borderRadius,
        spacing = _ref2$theme.spacing,
        colors = _ref2$theme.colors;
    return _ref3 = {
      label: 'menu'
    }, _ref3[alignToControl(placement)] = '100%', _ref3.backgroundColor = colors.neutral0, _ref3.borderRadius = borderRadius, _ref3.boxShadow = '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)', _ref3.marginBottom = spacing.menuGutter, _ref3.marginTop = spacing.menuGutter, _ref3.position = 'absolute', _ref3.width = '100%', _ref3.zIndex = 1, _ref3;
  }; // NOTE: internal only

  var MenuPlacer =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$1(MenuPlacer, _Component);

    function MenuPlacer() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.state = {
        maxHeight: _this.props.maxMenuHeight,
        placement: null
      };

      _this.getPlacement = function (ref) {
        var _this$props = _this.props,
            minMenuHeight = _this$props.minMenuHeight,
            maxMenuHeight = _this$props.maxMenuHeight,
            menuPlacement = _this$props.menuPlacement,
            menuPosition = _this$props.menuPosition,
            menuShouldScrollIntoView = _this$props.menuShouldScrollIntoView,
            theme = _this$props.theme;
        var getPortalPlacement = _this.context.getPortalPlacement;
        if (!ref) return; // DO NOT scroll if position is fixed

        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = getMenuPlacement({
          maxHeight: maxMenuHeight,
          menuEl: ref,
          minHeight: minMenuHeight,
          placement: menuPlacement,
          shouldScroll: shouldScroll,
          isFixedPosition: isFixedPosition,
          theme: theme
        });
        if (getPortalPlacement) getPortalPlacement(state);

        _this.setState(state);
      };

      _this.getUpdatedProps = function () {
        var menuPlacement = _this.props.menuPlacement;
        var placement = _this.state.placement || coercePlacement(menuPlacement);
        return _extends$1({}, _this.props, {
          placement: placement,
          maxHeight: _this.state.maxHeight
        });
      };

      return _this;
    }

    var _proto = MenuPlacer.prototype;

    _proto.render = function render() {
      var children = this.props.children;
      return children({
        ref: this.getPlacement,
        placerProps: this.getUpdatedProps()
      });
    };

    return MenuPlacer;
  }(React$2.Component);
  MenuPlacer.contextTypes = {
    getPortalPlacement: propTypes.func
  };

  var Menu = function Menu(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerRef = props.innerRef,
        innerProps = props.innerProps;
    return jsx("div", _extends$1({
      css: getStyles('menu', props),
      className: cx({
        menu: true
      }, className)
    }, innerProps, {
      ref: innerRef
    }), children);
  };
  // Menu List
  // ==============================

  var menuListCSS = function menuListCSS(_ref4) {
    var maxHeight = _ref4.maxHeight,
        baseUnit = _ref4.theme.spacing.baseUnit;
    return {
      maxHeight: maxHeight,
      overflowY: 'auto',
      paddingBottom: baseUnit,
      paddingTop: baseUnit,
      position: 'relative',
      // required for offset[Height, Top] > keyboard scroll
      WebkitOverflowScrolling: 'touch'
    };
  };
  var MenuList = function MenuList(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isMulti = props.isMulti,
        innerRef = props.innerRef;
    return jsx("div", {
      css: getStyles('menuList', props),
      className: cx({
        'menu-list': true,
        'menu-list--is-multi': isMulti
      }, className),
      ref: innerRef
    }, children);
  }; // ==============================
  // Menu Notices
  // ==============================

  var noticeCSS = function noticeCSS(_ref5) {
    var _ref5$theme = _ref5.theme,
        baseUnit = _ref5$theme.spacing.baseUnit,
        colors = _ref5$theme.colors;
    return {
      color: colors.neutral40,
      padding: baseUnit * 2 + "px " + baseUnit * 3 + "px",
      textAlign: 'center'
    };
  };

  var noOptionsMessageCSS = noticeCSS;
  var loadingMessageCSS = noticeCSS;
  var NoOptionsMessage = function NoOptionsMessage(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends$1({
      css: getStyles('noOptionsMessage', props),
      className: cx({
        'menu-notice': true,
        'menu-notice--no-options': true
      }, className)
    }, innerProps), children);
  };
  NoOptionsMessage.defaultProps = {
    children: 'No options'
  };
  var LoadingMessage = function LoadingMessage(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends$1({
      css: getStyles('loadingMessage', props),
      className: cx({
        'menu-notice': true,
        'menu-notice--loading': true
      }, className)
    }, innerProps), children);
  };
  LoadingMessage.defaultProps = {
    children: 'Loading...'
  }; // ==============================
  // Menu Portal
  // ==============================

  var menuPortalCSS = function menuPortalCSS(_ref6) {
    var rect = _ref6.rect,
        offset = _ref6.offset,
        position = _ref6.position;
    return {
      left: rect.left,
      position: position,
      top: offset,
      width: rect.width,
      zIndex: 1
    };
  };
  var MenuPortal =
  /*#__PURE__*/
  function (_Component2) {
    _inheritsLoose$1(MenuPortal, _Component2);

    function MenuPortal() {
      var _this2;

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      _this2 = _Component2.call.apply(_Component2, [this].concat(args)) || this;
      _this2.state = {
        placement: null
      };

      _this2.getPortalPlacement = function (_ref7) {
        var placement = _ref7.placement;
        var initialPlacement = coercePlacement(_this2.props.menuPlacement); // avoid re-renders if the placement has not changed

        if (placement !== initialPlacement) {
          _this2.setState({
            placement: placement
          });
        }
      };

      return _this2;
    }

    var _proto2 = MenuPortal.prototype;

    _proto2.getChildContext = function getChildContext() {
      return {
        getPortalPlacement: this.getPortalPlacement
      };
    } // callback for occassions where the menu must "flip"
    ;

    _proto2.render = function render() {
      var _this$props2 = this.props,
          appendTo = _this$props2.appendTo,
          children = _this$props2.children,
          controlElement = _this$props2.controlElement,
          menuPlacement = _this$props2.menuPlacement,
          position = _this$props2.menuPosition,
          getStyles = _this$props2.getStyles;
      var isFixed = position === 'fixed'; // bail early if required elements aren't present

      if (!appendTo && !isFixed || !controlElement) {
        return null;
      }

      var placement = this.state.placement || coercePlacement(menuPlacement);
      var rect = getBoundingClientObj(controlElement);
      var scrollDistance = isFixed ? 0 : window.pageYOffset;
      var offset = rect[placement] + scrollDistance;
      var state = {
        offset: offset,
        position: position,
        rect: rect
      }; // same wrapper element whether fixed or portalled

      var menuWrapper = jsx("div", {
        css: getStyles('menuPortal', state)
      }, children);
      return appendTo ? ReactDOM.createPortal(menuWrapper, appendTo) : menuWrapper;
    };

    return MenuPortal;
  }(React$2.Component);
  MenuPortal.childContextTypes = {
    getPortalPlacement: propTypes.func
  };

  var isArray = Array.isArray;
  var keyList = Object.keys;
  var hasProp = Object.prototype.hasOwnProperty;

  function equal(a, b) {
    // fast-deep-equal index.js 2.0.1
    if (a === b) return true;

    if (a && b && typeof a == 'object' && typeof b == 'object') {
      var arrA = isArray(a),
          arrB = isArray(b),
          i,
          length,
          key;

      if (arrA && arrB) {
        length = a.length;
        if (length != b.length) return false;

        for (i = length; i-- !== 0;) {
          if (!equal(a[i], b[i])) return false;
        }

        return true;
      }

      if (arrA != arrB) return false;
      var dateA = a instanceof Date,
          dateB = b instanceof Date;
      if (dateA != dateB) return false;
      if (dateA && dateB) return a.getTime() == b.getTime();
      var regexpA = a instanceof RegExp,
          regexpB = b instanceof RegExp;
      if (regexpA != regexpB) return false;
      if (regexpA && regexpB) return a.toString() == b.toString();
      var keys = keyList(a);
      length = keys.length;

      if (length !== keyList(b).length) {
        return false;
      }

      for (i = length; i-- !== 0;) {
        if (!hasProp.call(b, keys[i])) return false;
      } // end fast-deep-equal
      // Custom handling for React


      for (i = length; i-- !== 0;) {
        key = keys[i];

        if (key === '_owner' && a.$$typeof) {
          // React-specific: avoid traversing React elements' _owner.
          //  _owner contains circular references
          // and is not needed when comparing the actual elements (and not their owners)
          // .$$typeof and ._store on just reasonable markers of a react element
          continue;
        } else {
          // all other properties should be traversed as usual
          if (!equal(a[key], b[key])) return false;
        }
      } // fast-deep-equal index.js 2.0.1


      return true;
    }

    return a !== a && b !== b;
  } // end fast-deep-equal


  function exportedEqual(a, b) {
    try {
      return equal(a, b);
    } catch (error) {
      if (error.message && error.message.match(/stack|recursion/i)) {
        // warn on circular references, don't crash
        // browsers give this different errors name and messages:
        // chrome/safari: "RangeError", "Maximum call stack size exceeded"
        // firefox: "InternalError", too much recursion"
        // edge: "Error", "Out of stack space"
        console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
        return false;
      } // some other error. we should definitely know about these


      throw error;
    }
  }

  function _extends$1$1() { _extends$1$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$1.apply(this, arguments); }
  var containerCSS = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        isRtl = _ref.isRtl;
    return {
      label: 'container',
      direction: isRtl ? 'rtl' : null,
      pointerEvents: isDisabled ? 'none' : null,
      // cancel mouse events when disabled
      position: 'relative'
    };
  };
  var SelectContainer = function SelectContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isDisabled = props.isDisabled,
        isRtl = props.isRtl;
    return jsx("div", _extends$1$1({
      css: getStyles('container', props),
      className: cx({
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
      }, className)
    }, innerProps), children);
  }; // ==============================
  // Value Container
  // ==============================

  var valueContainerCSS = function valueContainerCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      alignItems: 'center',
      display: 'flex',
      flex: 1,
      flexWrap: 'wrap',
      padding: spacing.baseUnit / 2 + "px " + spacing.baseUnit * 2 + "px",
      WebkitOverflowScrolling: 'touch',
      position: 'relative',
      overflow: 'hidden'
    };
  };
  var ValueContainer = function ValueContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        isMulti = props.isMulti,
        getStyles = props.getStyles,
        hasValue = props.hasValue;
    return jsx("div", {
      css: getStyles('valueContainer', props),
      className: cx({
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
      }, className)
    }, children);
  }; // ==============================
  // Indicator Container
  // ==============================

  var indicatorsContainerCSS = function indicatorsContainerCSS() {
    return {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'flex',
      flexShrink: 0
    };
  };
  var IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles;
    return jsx("div", {
      css: getStyles('indicatorsContainer', props),
      className: cx({
        indicators: true
      }, className)
    }, children);
  };

  function _templateObject$c() {
    var data = _taggedTemplateLiteralLoose(["\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"]);

    _templateObject$c = function _templateObject() {
      return data;
    };

    return data;
  }

  function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

  function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }

  function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  var _ref2 = process.env.NODE_ENV === "production" ? {
    name: "19bqh2r",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;"
  } : {
    name: "19bqh2r",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
  };

  // ==============================
  // Dropdown & Clear Icons
  // ==============================
  var Svg = function Svg(_ref) {
    var size = _ref.size,
        props = _objectWithoutPropertiesLoose$1(_ref, ["size"]);

    return jsx("svg", _extends$2({
      height: size,
      width: size,
      viewBox: "0 0 20 20",
      "aria-hidden": "true",
      focusable: "false",
      css: _ref2
    }, props));
  };

  var CrossIcon = function CrossIcon(props) {
    return jsx(Svg, _extends$2({
      size: 20
    }, props), jsx("path", {
      d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
  };
  var DownChevron = function DownChevron(props) {
    return jsx(Svg, _extends$2({
      size: 20
    }, props), jsx("path", {
      d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
  }; // ==============================
  // Dropdown & Clear Buttons
  // ==============================

  var baseCSS = function baseCSS(_ref3) {
    var isFocused = _ref3.isFocused,
        _ref3$theme = _ref3.theme,
        baseUnit = _ref3$theme.spacing.baseUnit,
        colors = _ref3$theme.colors;
    return {
      label: 'indicatorContainer',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      ':hover': {
        color: isFocused ? colors.neutral80 : colors.neutral40
      }
    };
  };

  var dropdownIndicatorCSS = baseCSS;
  var DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends$2({}, innerProps, {
      css: getStyles('dropdownIndicator', props),
      className: cx({
        indicator: true,
        'dropdown-indicator': true
      }, className)
    }), children || jsx(DownChevron, null));
  };
  var clearIndicatorCSS = baseCSS;
  var ClearIndicator = function ClearIndicator(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends$2({}, innerProps, {
      css: getStyles('clearIndicator', props),
      className: cx({
        indicator: true,
        'clear-indicator': true
      }, className)
    }), children || jsx(CrossIcon, null));
  }; // ==============================
  // Separator
  // ==============================

  var indicatorSeparatorCSS = function indicatorSeparatorCSS(_ref4) {
    var isDisabled = _ref4.isDisabled,
        _ref4$theme = _ref4.theme,
        baseUnit = _ref4$theme.spacing.baseUnit,
        colors = _ref4$theme.colors;
    return {
      label: 'indicatorSeparator',
      alignSelf: 'stretch',
      backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
      marginBottom: baseUnit * 2,
      marginTop: baseUnit * 2,
      width: 1
    };
  };
  var IndicatorSeparator = function IndicatorSeparator(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("span", _extends$2({}, innerProps, {
      css: getStyles('indicatorSeparator', props),
      className: cx({
        'indicator-separator': true
      }, className)
    }));
  }; // ==============================
  // Loading
  // ==============================

  var loadingDotAnimations = keyframes(_templateObject$c());
  var loadingIndicatorCSS = function loadingIndicatorCSS(_ref5) {
    var isFocused = _ref5.isFocused,
        size = _ref5.size,
        _ref5$theme = _ref5.theme,
        colors = _ref5$theme.colors,
        baseUnit = _ref5$theme.spacing.baseUnit;
    return {
      label: 'loadingIndicator',
      color: isFocused ? colors.neutral60 : colors.neutral20,
      display: 'flex',
      padding: baseUnit * 2,
      transition: 'color 150ms',
      alignSelf: 'center',
      fontSize: size,
      lineHeight: 1,
      marginRight: size,
      textAlign: 'center',
      verticalAlign: 'middle'
    };
  };

  var LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay,
        offset = _ref6.offset;
    return jsx("span", {
      css:
      /*#__PURE__*/
      css({
        animation: loadingDotAnimations + " 1s ease-in-out " + delay + "ms infinite;",
        backgroundColor: 'currentColor',
        borderRadius: '1em',
        display: 'inline-block',
        marginLeft: offset ? '1em' : null,
        height: '1em',
        verticalAlign: 'top',
        width: '1em'
      }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
    });
  };

  var LoadingIndicator = function LoadingIndicator(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isRtl = props.isRtl;
    return jsx("div", _extends$2({}, innerProps, {
      css: getStyles('loadingIndicator', props),
      className: cx({
        indicator: true,
        'loading-indicator': true
      }, className)
    }), jsx(LoadingDot, {
      delay: 0,
      offset: isRtl
    }), jsx(LoadingDot, {
      delay: 160,
      offset: true
    }), jsx(LoadingDot, {
      delay: 320,
      offset: !isRtl
    }));
  };
  LoadingIndicator.defaultProps = {
    size: 4
  };

  function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
  var css$1 = function css(_ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        _ref$theme = _ref.theme,
        colors = _ref$theme.colors,
        borderRadius = _ref$theme.borderRadius,
        spacing = _ref$theme.spacing;
    return {
      label: 'control',
      alignItems: 'center',
      backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
      borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
      borderRadius: borderRadius,
      borderStyle: 'solid',
      borderWidth: 1,
      boxShadow: isFocused ? "0 0 0 1px " + colors.primary : null,
      cursor: 'default',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      minHeight: spacing.controlHeight,
      outline: '0 !important',
      position: 'relative',
      transition: 'all 100ms',
      '&:hover': {
        borderColor: isFocused ? colors.primary : colors.neutral30
      }
    };
  };

  var Control = function Control(props) {
    var children = props.children,
        cx = props.cx,
        getStyles = props.getStyles,
        className = props.className,
        isDisabled = props.isDisabled,
        isFocused = props.isFocused,
        innerRef = props.innerRef,
        innerProps = props.innerProps,
        menuIsOpen = props.menuIsOpen;
    return jsx("div", _extends$3({
      ref: innerRef,
      css: getStyles('control', props),
      className: cx({
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
      }, className)
    }, innerProps), children);
  };

  function _objectWithoutPropertiesLoose$1$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
  var groupCSS = function groupCSS(_ref) {
    var spacing = _ref.theme.spacing;
    return {
      paddingBottom: spacing.baseUnit * 2,
      paddingTop: spacing.baseUnit * 2
    };
  };

  var Group = function Group(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        Heading = props.Heading,
        headingProps = props.headingProps,
        label = props.label,
        theme = props.theme,
        selectProps = props.selectProps;
    return jsx("div", {
      css: getStyles('group', props),
      className: cx({
        group: true
      }, className)
    }, jsx(Heading, _extends$4({}, headingProps, {
      selectProps: selectProps,
      theme: theme,
      getStyles: getStyles,
      cx: cx
    }), label), jsx("div", null, children));
  };

  var groupHeadingCSS = function groupHeadingCSS(_ref2) {
    var spacing = _ref2.theme.spacing;
    return {
      label: 'group',
      color: '#999',
      cursor: 'default',
      display: 'block',
      fontSize: '75%',
      fontWeight: '500',
      marginBottom: '0.25em',
      paddingLeft: spacing.baseUnit * 3,
      paddingRight: spacing.baseUnit * 3,
      textTransform: 'uppercase'
    };
  };
  var GroupHeading = function GroupHeading(props) {
    var className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        theme = props.theme,
        selectProps = props.selectProps,
        cleanProps = _objectWithoutPropertiesLoose$1$1(props, ["className", "cx", "getStyles", "theme", "selectProps"]);

    return jsx("div", _extends$4({
      css: getStyles('groupHeading', _extends$4({
        theme: theme
      }, cleanProps)),
      className: cx({
        'group-heading': true
      }, className)
    }, cleanProps));
  };

  function _extends$5() { _extends$5 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }

  function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
  var inputCSS = function inputCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      margin: spacing.baseUnit / 2,
      paddingBottom: spacing.baseUnit / 2,
      paddingTop: spacing.baseUnit / 2,
      visibility: isDisabled ? 'hidden' : 'visible',
      color: colors.neutral80
    };
  };

  var inputStyle = function inputStyle(isHidden) {
    return {
      label: 'input',
      background: 0,
      border: 0,
      fontSize: 'inherit',
      opacity: isHidden ? 0 : 1,
      outline: 0,
      padding: 0,
      color: 'inherit'
    };
  };

  var Input = function Input(_ref2) {
    var className = _ref2.className,
        cx = _ref2.cx,
        getStyles = _ref2.getStyles,
        innerRef = _ref2.innerRef,
        isHidden = _ref2.isHidden,
        isDisabled = _ref2.isDisabled,
        theme = _ref2.theme,
        selectProps = _ref2.selectProps,
        props = _objectWithoutPropertiesLoose$2(_ref2, ["className", "cx", "getStyles", "innerRef", "isHidden", "isDisabled", "theme", "selectProps"]);

    return jsx("div", {
      css: getStyles('input', _extends$5({
        theme: theme
      }, props))
    }, jsx(AutosizeInput, _extends$5({
      className: cx({
        input: true
      }, className),
      inputRef: innerRef,
      inputStyle: inputStyle(isHidden),
      disabled: isDisabled
    }, props)));
  };

  function _extends$6() { _extends$6 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
  var multiValueCSS = function multiValueCSS(_ref) {
    var _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        borderRadius = _ref$theme.borderRadius,
        colors = _ref$theme.colors;
    return {
      label: 'multiValue',
      backgroundColor: colors.neutral10,
      borderRadius: borderRadius / 2,
      display: 'flex',
      margin: spacing.baseUnit / 2,
      minWidth: 0 // resolves flex/text-overflow bug

    };
  };
  var multiValueLabelCSS = function multiValueLabelCSS(_ref2) {
    var _ref2$theme = _ref2.theme,
        borderRadius = _ref2$theme.borderRadius,
        colors = _ref2$theme.colors,
        cropWithEllipsis = _ref2.cropWithEllipsis;
    return {
      borderRadius: borderRadius / 2,
      color: colors.neutral80,
      fontSize: '85%',
      overflow: 'hidden',
      padding: 3,
      paddingLeft: 6,
      textOverflow: cropWithEllipsis ? 'ellipsis' : null,
      whiteSpace: 'nowrap'
    };
  };
  var multiValueRemoveCSS = function multiValueRemoveCSS(_ref3) {
    var _ref3$theme = _ref3.theme,
        spacing = _ref3$theme.spacing,
        borderRadius = _ref3$theme.borderRadius,
        colors = _ref3$theme.colors,
        isFocused = _ref3.isFocused;
    return {
      alignItems: 'center',
      borderRadius: borderRadius / 2,
      backgroundColor: isFocused && colors.dangerLight,
      display: 'flex',
      paddingLeft: spacing.baseUnit,
      paddingRight: spacing.baseUnit,
      ':hover': {
        backgroundColor: colors.dangerLight,
        color: colors.danger
      }
    };
  };
  var MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children,
        innerProps = _ref4.innerProps;
    return jsx("div", innerProps, children);
  };
  var MultiValueContainer = MultiValueGeneric;
  var MultiValueLabel = MultiValueGeneric;
  function MultiValueRemove(_ref5) {
    var children = _ref5.children,
        innerProps = _ref5.innerProps;
    return jsx("div", innerProps, children || jsx(CrossIcon, {
      size: 14
    }));
  }

  var MultiValue = function MultiValue(props) {
    var children = props.children,
        className = props.className,
        components = props.components,
        cx = props.cx,
        data = props.data,
        getStyles = props.getStyles,
        innerProps = props.innerProps,
        isDisabled = props.isDisabled,
        removeProps = props.removeProps,
        selectProps = props.selectProps;
    var Container = components.Container,
        Label = components.Label,
        Remove = components.Remove;
    return jsx(ClassNames, null, function (_ref6) {
      var css = _ref6.css,
          emotionCx = _ref6.cx;
      return jsx(Container, {
        data: data,
        innerProps: _extends$6({}, innerProps, {
          className: emotionCx(css(getStyles('multiValue', props)), cx({
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
          }, className))
        }),
        selectProps: selectProps
      }, jsx(Label, {
        data: data,
        innerProps: {
          className: emotionCx(css(getStyles('multiValueLabel', props)), cx({
            'multi-value__label': true
          }, className))
        },
        selectProps: selectProps
      }, children), jsx(Remove, {
        data: data,
        innerProps: _extends$6({
          className: emotionCx(css(getStyles('multiValueRemove', props)), cx({
            'multi-value__remove': true
          }, className))
        }, removeProps),
        selectProps: selectProps
      }));
    });
  };

  MultiValue.defaultProps = {
    cropWithEllipsis: true
  };

  function _extends$7() { _extends$7 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
  var optionCSS = function optionCSS(_ref) {
    var isDisabled = _ref.isDisabled,
        isFocused = _ref.isFocused,
        isSelected = _ref.isSelected,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'option',
      backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
      color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
      cursor: 'default',
      display: 'block',
      fontSize: 'inherit',
      padding: spacing.baseUnit * 2 + "px " + spacing.baseUnit * 3 + "px",
      width: '100%',
      userSelect: 'none',
      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
      // provide some affordance on touch devices
      ':active': {
        backgroundColor: !isDisabled && (isSelected ? colors.primary : colors.primary50)
      }
    };
  };

  var Option$1 = function Option(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isDisabled = props.isDisabled,
        isFocused = props.isFocused,
        isSelected = props.isSelected,
        innerRef = props.innerRef,
        innerProps = props.innerProps;
    return jsx("div", _extends$7({
      css: getStyles('option', props),
      className: cx({
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
      }, className),
      ref: innerRef
    }, innerProps), children);
  };

  function _extends$8() { _extends$8 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
  var placeholderCSS = function placeholderCSS(_ref) {
    var _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'placeholder',
      color: colors.neutral50,
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  };

  var Placeholder = function Placeholder(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        innerProps = props.innerProps;
    return jsx("div", _extends$8({
      css: getStyles('placeholder', props),
      className: cx({
        placeholder: true
      }, className)
    }, innerProps), children);
  };

  function _extends$9() { _extends$9 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
  var css$1$1 = function css(_ref) {
    var isDisabled = _ref.isDisabled,
        _ref$theme = _ref.theme,
        spacing = _ref$theme.spacing,
        colors = _ref$theme.colors;
    return {
      label: 'singleValue',
      color: isDisabled ? colors.neutral40 : colors.neutral80,
      marginLeft: spacing.baseUnit / 2,
      marginRight: spacing.baseUnit / 2,
      maxWidth: "calc(100% - " + spacing.baseUnit * 2 + "px)",
      overflow: 'hidden',
      position: 'absolute',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      top: '50%',
      transform: 'translateY(-50%)'
    };
  };

  var SingleValue = function SingleValue(props) {
    var children = props.children,
        className = props.className,
        cx = props.cx,
        getStyles = props.getStyles,
        isDisabled = props.isDisabled,
        innerProps = props.innerProps;
    return jsx("div", _extends$9({
      css: getStyles('singleValue', props),
      className: cx({
        'single-value': true,
        'single-value--is-disabled': isDisabled
      }, className)
    }, innerProps), children);
  };

  function _extends$a() { _extends$a = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
  var components = {
    ClearIndicator: ClearIndicator,
    Control: Control,
    DropdownIndicator: DropdownIndicator,
    DownChevron: DownChevron,
    CrossIcon: CrossIcon,
    Group: Group,
    GroupHeading: GroupHeading,
    IndicatorsContainer: IndicatorsContainer,
    IndicatorSeparator: IndicatorSeparator,
    Input: Input,
    LoadingIndicator: LoadingIndicator,
    Menu: Menu,
    MenuList: MenuList,
    MenuPortal: MenuPortal,
    LoadingMessage: LoadingMessage,
    NoOptionsMessage: NoOptionsMessage,
    MultiValue: MultiValue,
    MultiValueContainer: MultiValueContainer,
    MultiValueLabel: MultiValueLabel,
    MultiValueRemove: MultiValueRemove,
    Option: Option$1,
    Placeholder: Placeholder,
    SelectContainer: SelectContainer,
    SingleValue: SingleValue,
    ValueContainer: ValueContainer
  };
  var defaultComponents = function defaultComponents(props) {
    return _extends$a({}, components, props.components);
  };

  var diacritics = [{
    base: 'A',
    letters: /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
  }, {
    base: 'AA',
    letters: /[\uA732]/g
  }, {
    base: 'AE',
    letters: /[\u00C6\u01FC\u01E2]/g
  }, {
    base: 'AO',
    letters: /[\uA734]/g
  }, {
    base: 'AU',
    letters: /[\uA736]/g
  }, {
    base: 'AV',
    letters: /[\uA738\uA73A]/g
  }, {
    base: 'AY',
    letters: /[\uA73C]/g
  }, {
    base: 'B',
    letters: /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g
  }, {
    base: 'C',
    letters: /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g
  }, {
    base: 'D',
    letters: /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
  }, {
    base: 'DZ',
    letters: /[\u01F1\u01C4]/g
  }, {
    base: 'Dz',
    letters: /[\u01F2\u01C5]/g
  }, {
    base: 'E',
    letters: /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
  }, {
    base: 'F',
    letters: /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g
  }, {
    base: 'G',
    letters: /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
  }, {
    base: 'H',
    letters: /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
  }, {
    base: 'I',
    letters: /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
  }, {
    base: 'J',
    letters: /[\u004A\u24BF\uFF2A\u0134\u0248]/g
  }, {
    base: 'K',
    letters: /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
  }, {
    base: 'L',
    letters: /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
  }, {
    base: 'LJ',
    letters: /[\u01C7]/g
  }, {
    base: 'Lj',
    letters: /[\u01C8]/g
  }, {
    base: 'M',
    letters: /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g
  }, {
    base: 'N',
    letters: /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
  }, {
    base: 'NJ',
    letters: /[\u01CA]/g
  }, {
    base: 'Nj',
    letters: /[\u01CB]/g
  }, {
    base: 'O',
    letters: /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
  }, {
    base: 'OI',
    letters: /[\u01A2]/g
  }, {
    base: 'OO',
    letters: /[\uA74E]/g
  }, {
    base: 'OU',
    letters: /[\u0222]/g
  }, {
    base: 'P',
    letters: /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g
  }, {
    base: 'Q',
    letters: /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g
  }, {
    base: 'R',
    letters: /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
  }, {
    base: 'S',
    letters: /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
  }, {
    base: 'T',
    letters: /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
  }, {
    base: 'TZ',
    letters: /[\uA728]/g
  }, {
    base: 'U',
    letters: /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
  }, {
    base: 'V',
    letters: /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g
  }, {
    base: 'VY',
    letters: /[\uA760]/g
  }, {
    base: 'W',
    letters: /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g
  }, {
    base: 'X',
    letters: /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g
  }, {
    base: 'Y',
    letters: /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
  }, {
    base: 'Z',
    letters: /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
  }, {
    base: 'a',
    letters: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
  }, {
    base: 'aa',
    letters: /[\uA733]/g
  }, {
    base: 'ae',
    letters: /[\u00E6\u01FD\u01E3]/g
  }, {
    base: 'ao',
    letters: /[\uA735]/g
  }, {
    base: 'au',
    letters: /[\uA737]/g
  }, {
    base: 'av',
    letters: /[\uA739\uA73B]/g
  }, {
    base: 'ay',
    letters: /[\uA73D]/g
  }, {
    base: 'b',
    letters: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g
  }, {
    base: 'c',
    letters: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g
  }, {
    base: 'd',
    letters: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
  }, {
    base: 'dz',
    letters: /[\u01F3\u01C6]/g
  }, {
    base: 'e',
    letters: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
  }, {
    base: 'f',
    letters: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g
  }, {
    base: 'g',
    letters: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
  }, {
    base: 'h',
    letters: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
  }, {
    base: 'hv',
    letters: /[\u0195]/g
  }, {
    base: 'i',
    letters: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
  }, {
    base: 'j',
    letters: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g
  }, {
    base: 'k',
    letters: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
  }, {
    base: 'l',
    letters: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
  }, {
    base: 'lj',
    letters: /[\u01C9]/g
  }, {
    base: 'm',
    letters: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g
  }, {
    base: 'n',
    letters: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
  }, {
    base: 'nj',
    letters: /[\u01CC]/g
  }, {
    base: 'o',
    letters: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
  }, {
    base: 'oi',
    letters: /[\u01A3]/g
  }, {
    base: 'ou',
    letters: /[\u0223]/g
  }, {
    base: 'oo',
    letters: /[\uA74F]/g
  }, {
    base: 'p',
    letters: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g
  }, {
    base: 'q',
    letters: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g
  }, {
    base: 'r',
    letters: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
  }, {
    base: 's',
    letters: /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
  }, {
    base: 't',
    letters: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
  }, {
    base: 'tz',
    letters: /[\uA729]/g
  }, {
    base: 'u',
    letters: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
  }, {
    base: 'v',
    letters: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g
  }, {
    base: 'vy',
    letters: /[\uA761]/g
  }, {
    base: 'w',
    letters: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g
  }, {
    base: 'x',
    letters: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g
  }, {
    base: 'y',
    letters: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
  }, {
    base: 'z',
    letters: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
  }];
  var stripDiacritics = function stripDiacritics(str) {
    for (var i = 0; i < diacritics.length; i++) {
      str = str.replace(diacritics[i].letters, diacritics[i].base);
    }

    return str;
  };

  function _extends$b() { _extends$b = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }

  var trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
  };

  var defaultStringify = function defaultStringify(option) {
    return option.label + " " + option.value;
  };

  var createFilter = function createFilter(config) {
    return function (option, rawInput) {
      var _ignoreCase$ignoreAcc = _extends$b({
        ignoreCase: true,
        ignoreAccents: true,
        stringify: defaultStringify,
        trim: true,
        matchFrom: 'any'
      }, config),
          ignoreCase = _ignoreCase$ignoreAcc.ignoreCase,
          ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents,
          stringify = _ignoreCase$ignoreAcc.stringify,
          trim = _ignoreCase$ignoreAcc.trim,
          matchFrom = _ignoreCase$ignoreAcc.matchFrom;

      var input = trim ? trimString(rawInput) : rawInput;
      var candidate = trim ? trimString(stringify(option)) : stringify(option);

      if (ignoreCase) {
        input = input.toLowerCase();
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        input = stripDiacritics(input);
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
  };

  function _extends$1$2() { _extends$1$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1$2.apply(this, arguments); }

  var _ref = process.env.NODE_ENV === "production" ? {
    name: "1laao21-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;"
  } : {
    name: "1laao21-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LmpzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQVFNIiwiZmlsZSI6IkExMXlUZXh0LmpzIiwic291cmNlc0NvbnRlbnQiOlsiLy8gQGZsb3dcbi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgdHlwZSBFbGVtZW50Q29uZmlnIH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vY29yZSc7XG5cbi8vIEFzc2lzdGl2ZSB0ZXh0IHRvIGRlc2NyaWJlIHZpc3VhbCBlbGVtZW50cy4gSGlkZGVuIGZvciBzaWdodGVkIHVzZXJzLlxuY29uc3QgQTExeVRleHQgPSAocHJvcHM6IEVsZW1lbnRDb25maWc8J3NwYW4nPikgPT4gKFxuICAgIDxzcGFuXG4gICAgICBjc3M9e3tcbiAgICAgICAgbGFiZWw6ICdhMTF5VGV4dCcsXG4gICAgICAgIHpJbmRleDogOTk5OSxcbiAgICAgICAgYm9yZGVyOiAwLFxuICAgICAgICBjbGlwOiAncmVjdCgxcHgsIDFweCwgMXB4LCAxcHgpJyxcbiAgICAgICAgaGVpZ2h0OiAxLFxuICAgICAgICB3aWR0aDogMSxcbiAgICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgd2hpdGVTcGFjZTogJ25vd3JhcCcsXG4gICAgICB9fVxuICAgICAgey4uLnByb3BzfVxuICAgIC8+XG4pO1xuXG5leHBvcnQgZGVmYXVsdCBBMTF5VGV4dDtcbiJdfQ== */"
  };

  var A11yText = function A11yText(props) {
    return jsx("span", _extends$1$2({
      css: _ref
    }, props));
  };

  function _extends$2$1() { _extends$2$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2$1.apply(this, arguments); }

  function _objectWithoutPropertiesLoose$3(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
  function DummyInput(_ref) {
    var inProp = _ref.in,
        out = _ref.out,
        onExited = _ref.onExited,
        appear = _ref.appear,
        enter = _ref.enter,
        exit = _ref.exit,
        innerRef = _ref.innerRef,
        emotion = _ref.emotion,
        props = _objectWithoutPropertiesLoose$3(_ref, ["in", "out", "onExited", "appear", "enter", "exit", "innerRef", "emotion"]);

    return jsx("input", _extends$2$1({
      ref: innerRef
    }, props, {
      css:
      /*#__PURE__*/
      css({
        label: 'dummyInput',
        // get rid of any default styles
        background: 0,
        border: 0,
        fontSize: 'inherit',
        outline: 0,
        padding: 0,
        // important! without `width` browsers won't allow focus
        width: 1,
        // remove cursor on desktop
        color: 'transparent',
        // remove cursor on mobile whilst maintaining "scroll into view" behaviour
        left: -100,
        opacity: 0,
        position: 'relative',
        transform: 'scale(0)'
      }, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBbUJNIiwiZmlsZSI6IkR1bW15SW5wdXQuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBAZmxvd1xuLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9jb3JlJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGluOiBpblByb3AsXG4gIG91dCxcbiAgb25FeGl0ZWQsXG4gIGFwcGVhcixcbiAgZW50ZXIsXG4gIGV4aXQsXG4gIGlubmVyUmVmLFxuICBlbW90aW9uLFxuICAuLi5wcm9wc1xufTogYW55KSB7XG4gIHJldHVybiAoXG4gICAgPGlucHV0XG4gICAgICByZWY9e2lubmVyUmVmfVxuICAgICAgey4uLnByb3BzfVxuICAgICAgY3NzPXt7XG4gICAgICAgIGxhYmVsOiAnZHVtbXlJbnB1dCcsXG4gICAgICAgIC8vIGdldCByaWQgb2YgYW55IGRlZmF1bHQgc3R5bGVzXG4gICAgICAgIGJhY2tncm91bmQ6IDAsXG4gICAgICAgIGJvcmRlcjogMCxcbiAgICAgICAgZm9udFNpemU6ICdpbmhlcml0JyxcbiAgICAgICAgb3V0bGluZTogMCxcbiAgICAgICAgcGFkZGluZzogMCxcbiAgICAgICAgLy8gaW1wb3J0YW50ISB3aXRob3V0IGB3aWR0aGAgYnJvd3NlcnMgd29uJ3QgYWxsb3cgZm9jdXNcbiAgICAgICAgd2lkdGg6IDEsXG5cbiAgICAgICAgLy8gcmVtb3ZlIGN1cnNvciBvbiBkZXNrdG9wXG4gICAgICAgIGNvbG9yOiAndHJhbnNwYXJlbnQnLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gbW9iaWxlIHdoaWxzdCBtYWludGFpbmluZyBcInNjcm9sbCBpbnRvIHZpZXdcIiBiZWhhdmlvdXJcbiAgICAgICAgbGVmdDogLTEwMCxcbiAgICAgICAgb3BhY2l0eTogMCxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIHRyYW5zZm9ybTogJ3NjYWxlKDApJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
    }));
  }

  function _inheritsLoose$2(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

  var NodeResolver =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$2(NodeResolver, _Component);

    function NodeResolver() {
      return _Component.apply(this, arguments) || this;
    }

    var _proto = NodeResolver.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.props.innerRef(ReactDOM.findDOMNode(this));
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.props.innerRef(null);
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return NodeResolver;
  }(React$2.Component);

  var STYLE_KEYS = ['boxSizing', 'height', 'overflow', 'paddingRight', 'position'];
  var LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
  };

  function preventTouchMove(e) {
    e.preventDefault();
  }
  function allowTouchMove(e) {
    e.stopPropagation();
  }
  function preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;

    if (top === 0) {
      this.scrollTop = 1;
    } else if (currentScroll === totalScroll) {
      this.scrollTop = top - 1;
    }
  } // `ontouchstart` check works on most browsers
  // `maxTouchPoints` works on IE10/11 and Surface

  function isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
  }

  function _inheritsLoose$1$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
  var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
  var activeScrollLocks = 0;

  var ScrollLock =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$1$1(ScrollLock, _Component);

    function ScrollLock() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.originalStyles = {};
      _this.listenerOptions = {
        capture: false,
        passive: false
      };
      return _this;
    }

    var _proto = ScrollLock.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (!canUseDOM) return;
      var _this$props = this.props,
          accountForScrollbars = _this$props.accountForScrollbars,
          touchScrollTarget = _this$props.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style;

      if (accountForScrollbars) {
        // store any styles already applied to the body
        STYLE_KEYS.forEach(function (key) {
          var val = targetStyle && targetStyle[key];
          _this2.originalStyles[key] = val;
        });
      } // apply the lock styles and padding if this is the first scroll lock


      if (accountForScrollbars && activeScrollLocks < 1) {
        var currentPadding = parseInt(this.originalStyles.paddingRight, 10) || 0;
        var clientWidth = document.body ? document.body.clientWidth : 0;
        var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
        Object.keys(LOCK_STYLES).forEach(function (key) {
          var val = LOCK_STYLES[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });

        if (targetStyle) {
          targetStyle.paddingRight = adjustedPadding + "px";
        }
      } // account for touch devices


      if (target && isTouchDevice()) {
        // Mobile Safari ignores { overflow: hidden } declaration on the body.
        target.addEventListener('touchmove', preventTouchMove, this.listenerOptions); // Allow scroll on provided target

        if (touchScrollTarget) {
          touchScrollTarget.addEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.addEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      } // increment active scroll locks


      activeScrollLocks += 1;
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      var _this3 = this;

      if (!canUseDOM) return;
      var _this$props2 = this.props,
          accountForScrollbars = _this$props2.accountForScrollbars,
          touchScrollTarget = _this$props2.touchScrollTarget;
      var target = document.body;
      var targetStyle = target && target.style; // safely decrement active scroll locks

      activeScrollLocks = Math.max(activeScrollLocks - 1, 0); // reapply original body styles, if any

      if (accountForScrollbars && activeScrollLocks < 1) {
        STYLE_KEYS.forEach(function (key) {
          var val = _this3.originalStyles[key];

          if (targetStyle) {
            targetStyle[key] = val;
          }
        });
      } // remove touch listeners


      if (target && isTouchDevice()) {
        target.removeEventListener('touchmove', preventTouchMove, this.listenerOptions);

        if (touchScrollTarget) {
          touchScrollTarget.removeEventListener('touchstart', preventInertiaScroll, this.listenerOptions);
          touchScrollTarget.removeEventListener('touchmove', allowTouchMove, this.listenerOptions);
        }
      }
    };

    _proto.render = function render() {
      return null;
    };

    return ScrollLock;
  }(React$2.Component);

  ScrollLock.defaultProps = {
    accountForScrollbars: true
  };

  function _inheritsLoose$2$1(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

  var _ref$1 = process.env.NODE_ENV === "production" ? {
    name: "1dsbpcp",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;"
  } : {
    name: "1dsbpcp",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0;",
    map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"
  };

  // NOTE:
  // We shouldn't need this after updating to React v16.3.0, which introduces:
  // - createRef() https://reactjs.org/docs/react-api.html#reactcreateref
  // - forwardRef() https://reactjs.org/docs/react-api.html#reactforwardref
  var ScrollBlock =
  /*#__PURE__*/
  function (_PureComponent) {
    _inheritsLoose$2$1(ScrollBlock, _PureComponent);

    function ScrollBlock() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _PureComponent.call.apply(_PureComponent, [this].concat(args)) || this;
      _this.state = {
        touchScrollTarget: null
      };

      _this.getScrollTarget = function (ref) {
        if (ref === _this.state.touchScrollTarget) return;

        _this.setState({
          touchScrollTarget: ref
        });
      };

      _this.blurSelectInput = function () {
        if (document.activeElement) {
          document.activeElement.blur();
        }
      };

      return _this;
    }

    var _proto = ScrollBlock.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          children = _this$props.children,
          isEnabled = _this$props.isEnabled;
      var touchScrollTarget = this.state.touchScrollTarget; // bail early if not enabled

      if (!isEnabled) return children;
      /*
       * Div
       * ------------------------------
       * blocks scrolling on non-body elements behind the menu
        * NodeResolver
       * ------------------------------
       * we need a reference to the scrollable element to "unlock" scroll on
       * mobile devices
        * ScrollLock
       * ------------------------------
       * actually does the scroll locking
       */

      return jsx("div", null, jsx("div", {
        onClick: this.blurSelectInput,
        css: _ref$1
      }), jsx(NodeResolver, {
        innerRef: this.getScrollTarget
      }, children), touchScrollTarget ? jsx(ScrollLock, {
        touchScrollTarget: touchScrollTarget
      }) : null);
    };

    return ScrollBlock;
  }(React$2.PureComponent);

  function _objectWithoutPropertiesLoose$1$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _inheritsLoose$3(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

  var ScrollCaptor =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$3(ScrollCaptor, _Component);

    function ScrollCaptor() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.isBottom = false;
      _this.isTop = false;
      _this.scrollTarget = void 0;
      _this.touchStart = void 0;

      _this.cancelScroll = function (event) {
        event.preventDefault();
        event.stopPropagation();
      };

      _this.handleEventDelta = function (event, delta) {
        var _this$props = _this.props,
            onBottomArrive = _this$props.onBottomArrive,
            onBottomLeave = _this$props.onBottomLeave,
            onTopArrive = _this$props.onTopArrive,
            onTopLeave = _this$props.onTopLeave;
        var _this$scrollTarget = _this.scrollTarget,
            scrollTop = _this$scrollTarget.scrollTop,
            scrollHeight = _this$scrollTarget.scrollHeight,
            clientHeight = _this$scrollTarget.clientHeight;
        var target = _this.scrollTarget;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false; // reset bottom/top flags

        if (availableScroll > delta && _this.isBottom) {
          if (onBottomLeave) onBottomLeave(event);
          _this.isBottom = false;
        }

        if (isDeltaPositive && _this.isTop) {
          if (onTopLeave) onTopLeave(event);
          _this.isTop = false;
        } // bottom limit


        if (isDeltaPositive && delta > availableScroll) {
          if (onBottomArrive && !_this.isBottom) {
            onBottomArrive(event);
          }

          target.scrollTop = scrollHeight;
          shouldCancelScroll = true;
          _this.isBottom = true; // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
          if (onTopArrive && !_this.isTop) {
            onTopArrive(event);
          }

          target.scrollTop = 0;
          shouldCancelScroll = true;
          _this.isTop = true;
        } // cancel scroll


        if (shouldCancelScroll) {
          _this.cancelScroll(event);
        }
      };

      _this.onWheel = function (event) {
        _this.handleEventDelta(event, event.deltaY);
      };

      _this.onTouchStart = function (event) {
        // set touch start so we can calculate touchmove delta
        _this.touchStart = event.changedTouches[0].clientY;
      };

      _this.onTouchMove = function (event) {
        var deltaY = _this.touchStart - event.changedTouches[0].clientY;

        _this.handleEventDelta(event, deltaY);
      };

      _this.getScrollTarget = function (ref) {
        _this.scrollTarget = ref;
      };

      return _this;
    }

    var _proto = ScrollCaptor.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.startListening(this.scrollTarget);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.stopListening(this.scrollTarget);
    };

    _proto.startListening = function startListening(el) {
      // bail early if no element is available to attach to
      if (!el) return; // all the if statements are to appease Flow 😢

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.addEventListener === 'function') {
        el.addEventListener('touchmove', this.onTouchMove, false);
      }
    };

    _proto.stopListening = function stopListening(el) {
      // all the if statements are to appease Flow 😢
      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('wheel', this.onWheel, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchstart', this.onTouchStart, false);
      }

      if (typeof el.removeEventListener === 'function') {
        el.removeEventListener('touchmove', this.onTouchMove, false);
      }
    };

    _proto.render = function render() {
      return React$2__default.createElement(NodeResolver, {
        innerRef: this.getScrollTarget
      }, this.props.children);
    };

    return ScrollCaptor;
  }(React$2.Component);

  function ScrollCaptorSwitch(_ref) {
    var _ref$isEnabled = _ref.isEnabled,
        isEnabled = _ref$isEnabled === void 0 ? true : _ref$isEnabled,
        props = _objectWithoutPropertiesLoose$1$2(_ref, ["isEnabled"]);

    return isEnabled ? React$2__default.createElement(ScrollCaptor, props) : props.children;
  }

  var instructionsAriaMessage = function instructionsAriaMessage(event, context) {
    if (context === void 0) {
      context = {};
    }

    var _context = context,
        isSearchable = _context.isSearchable,
        isMulti = _context.isMulti,
        label = _context.label,
        isDisabled = _context.isDisabled;

    switch (event) {
      case 'menu':
        return "Use Up and Down to choose options" + (isDisabled ? '' : ', press Enter to select the currently focused option') + ", press Escape to exit the menu, press Tab to select the option and exit the menu.";

      case 'input':
        return (label ? label : 'Select') + " is focused " + (isSearchable ? ',type to refine list' : '') + ", press Down to open the menu, " + (isMulti ? ' press left to focus selected values' : '');

      case 'value':
        return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
    }
  };
  var valueEventAriaMessage = function valueEventAriaMessage(event, context) {
    var value = context.value,
        isDisabled = context.isDisabled;
    if (!value) return;

    switch (event) {
      case 'deselect-option':
      case 'pop-value':
      case 'remove-value':
        return "option " + value + ", deselected.";

      case 'select-option':
        return isDisabled ? "option " + value + " is disabled. Select another option." : "option " + value + ", selected.";
    }
  };
  var valueFocusAriaMessage = function valueFocusAriaMessage(_ref) {
    var focusedValue = _ref.focusedValue,
        getOptionLabel = _ref.getOptionLabel,
        selectValue = _ref.selectValue;
    return "value " + getOptionLabel(focusedValue) + " focused, " + (selectValue.indexOf(focusedValue) + 1) + " of " + selectValue.length + ".";
  };
  var optionFocusAriaMessage = function optionFocusAriaMessage(_ref2) {
    var focusedOption = _ref2.focusedOption,
        getOptionLabel = _ref2.getOptionLabel,
        options = _ref2.options;
    return "option " + getOptionLabel(focusedOption) + " focused" + (focusedOption.isDisabled ? ' disabled' : '') + ", " + (options.indexOf(focusedOption) + 1) + " of " + options.length + ".";
  };
  var resultsAriaMessage = function resultsAriaMessage(_ref3) {
    var inputValue = _ref3.inputValue,
        screenReaderMessage = _ref3.screenReaderMessage;
    return "" + screenReaderMessage + (inputValue ? ' for search term ' + inputValue : '') + ".";
  };

  var formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
  };
  var getOptionLabel = function getOptionLabel(option) {
    return option.label;
  };
  var getOptionValue = function getOptionValue(option) {
    return option.value;
  };
  var isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
  };
  var defaultStyles = {
    clearIndicator: clearIndicatorCSS,
    container: containerCSS,
    control: css$1,
    dropdownIndicator: dropdownIndicatorCSS,
    group: groupCSS,
    groupHeading: groupHeadingCSS,
    indicatorsContainer: indicatorsContainerCSS,
    indicatorSeparator: indicatorSeparatorCSS,
    input: inputCSS,
    loadingIndicator: loadingIndicatorCSS,
    loadingMessage: loadingMessageCSS,
    menu: menuCSS,
    menuList: menuListCSS,
    menuPortal: menuPortalCSS,
    multiValue: multiValueCSS,
    multiValueLabel: multiValueLabelCSS,
    multiValueRemove: multiValueRemoveCSS,
    noOptionsMessage: noOptionsMessageCSS,
    option: optionCSS,
    placeholder: placeholderCSS,
    singleValue: css$1$1,
    valueContainer: valueContainerCSS
  }; // Merge Utility

  var colors$1 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
  };
  var borderRadius = 4; // Used to calculate consistent margin/padding on elements

  var baseUnit = 4; // The minimum height of the control

  var controlHeight = 38; // The amount of space between the control and menu */

  var menuGutter = baseUnit * 2;
  var spacing = {
    baseUnit: baseUnit,
    controlHeight: controlHeight,
    menuGutter: menuGutter
  };
  var defaultTheme = {
    borderRadius: borderRadius,
    colors: colors$1,
    spacing: spacing
  };

  function _objectWithoutPropertiesLoose$2$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _extends$4$1() { _extends$4$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4$1.apply(this, arguments); }

  function _inheritsLoose$4(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

  function _assertThisInitialized$1(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
  var defaultProps = {
    backspaceRemovesValue: true,
    blurInputOnSelect: isTouchCapable(),
    captureMenuScroll: !isTouchCapable(),
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: createFilter(),
    formatGroupLabel: formatGroupLabel,
    getOptionLabel: getOptionLabel,
    getOptionValue: getOptionValue,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: isOptionDisabled,
    loadingMessage: function loadingMessage() {
      return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !isMobileDevice(),
    noOptionsMessage: function noOptionsMessage() {
      return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
      var count = _ref.count;
      return count + " result" + (count !== 1 ? 's' : '') + " available";
    },
    styles: {},
    tabIndex: '0',
    tabSelectsValue: true
  };
  var instanceId = 1;

  var Select =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$4(Select, _Component);

    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
      var _this;

      _this = _Component.call(this, _props) || this;
      _this.state = {
        ariaLiveSelection: '',
        ariaLiveContext: '',
        focusedOption: null,
        focusedValue: null,
        inputIsHidden: false,
        isFocused: false,
        menuOptions: {
          render: [],
          focusable: []
        },
        selectValue: []
      };
      _this.blockOptionHover = false;
      _this.isComposing = false;
      _this.clearFocusValueOnUpdate = false;
      _this.commonProps = void 0;
      _this.components = void 0;
      _this.hasGroups = false;
      _this.initialTouchX = 0;
      _this.initialTouchY = 0;
      _this.inputIsHiddenAfterUpdate = void 0;
      _this.instancePrefix = '';
      _this.openAfterFocus = false;
      _this.scrollToFocusedOptionOnUpdate = false;
      _this.userIsDragging = void 0;
      _this.controlRef = null;

      _this.getControlRef = function (ref) {
        _this.controlRef = ref;
      };

      _this.focusedOptionRef = null;

      _this.getFocusedOptionRef = function (ref) {
        _this.focusedOptionRef = ref;
      };

      _this.menuListRef = null;

      _this.getMenuListRef = function (ref) {
        _this.menuListRef = ref;
      };

      _this.inputRef = null;

      _this.getInputRef = function (ref) {
        _this.inputRef = ref;
      };

      _this.cacheComponents = function (components) {
        _this.components = defaultComponents({
          components: components
        });
      };

      _this.focus = _this.focusInput;
      _this.blur = _this.blurInput;

      _this.onChange = function (newValue, actionMeta) {
        var _this$props = _this.props,
            onChange = _this$props.onChange,
            name = _this$props.name;
        onChange(newValue, _extends$4$1({}, actionMeta, {
          name: name
        }));
      };

      _this.setValue = function (newValue, action, option) {
        if (action === void 0) {
          action = 'set-value';
        }

        var _this$props2 = _this.props,
            closeMenuOnSelect = _this$props2.closeMenuOnSelect,
            isMulti = _this$props2.isMulti;

        _this.onInputChange('', {
          action: 'set-value'
        });

        if (closeMenuOnSelect) {
          _this.inputIsHiddenAfterUpdate = !isMulti;

          _this.onMenuClose();
        } // when the select value should change, we should reset focusedValue


        _this.clearFocusValueOnUpdate = true;

        _this.onChange(newValue, {
          action: action,
          option: option
        });
      };

      _this.selectOption = function (newValue) {
        var _this$props3 = _this.props,
            blurInputOnSelect = _this$props3.blurInputOnSelect,
            isMulti = _this$props3.isMulti;
        var selectValue = _this.state.selectValue;

        if (isMulti) {
          if (_this.isOptionSelected(newValue, selectValue)) {
            var candidate = _this.getOptionValue(newValue);

            _this.setValue(selectValue.filter(function (i) {
              return _this.getOptionValue(i) !== candidate;
            }), 'deselect-option', newValue);

            _this.announceAriaLiveSelection({
              event: 'deselect-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            if (!_this.isOptionDisabled(newValue, selectValue)) {
              _this.setValue([].concat(selectValue, [newValue]), 'select-option', newValue);

              _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                  value: _this.getOptionLabel(newValue)
                }
              });
            } else {
              // announce that option is disabled
              _this.announceAriaLiveSelection({
                event: 'select-option',
                context: {
                  value: _this.getOptionLabel(newValue),
                  isDisabled: true
                }
              });
            }
          }
        } else {
          if (!_this.isOptionDisabled(newValue, selectValue)) {
            _this.setValue(newValue, 'select-option');

            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue)
              }
            });
          } else {
            // announce that option is disabled
            _this.announceAriaLiveSelection({
              event: 'select-option',
              context: {
                value: _this.getOptionLabel(newValue),
                isDisabled: true
              }
            });
          }
        }

        if (blurInputOnSelect) {
          _this.blurInput();
        }
      };

      _this.removeValue = function (removedValue) {
        var selectValue = _this.state.selectValue;

        var candidate = _this.getOptionValue(removedValue);

        var newValue = selectValue.filter(function (i) {
          return _this.getOptionValue(i) !== candidate;
        });

        _this.onChange(newValue.length ? newValue : null, {
          action: 'remove-value',
          removedValue: removedValue
        });

        _this.announceAriaLiveSelection({
          event: 'remove-value',
          context: {
            value: removedValue ? _this.getOptionLabel(removedValue) : ''
          }
        });

        _this.focusInput();
      };

      _this.clearValue = function () {
        var isMulti = _this.props.isMulti;

        _this.onChange(isMulti ? [] : null, {
          action: 'clear'
        });
      };

      _this.popValue = function () {
        var selectValue = _this.state.selectValue;
        var lastSelectedValue = selectValue[selectValue.length - 1];
        var newValue = selectValue.slice(0, selectValue.length - 1);

        _this.announceAriaLiveSelection({
          event: 'pop-value',
          context: {
            value: lastSelectedValue ? _this.getOptionLabel(lastSelectedValue) : ''
          }
        });

        _this.onChange(newValue.length ? newValue : null, {
          action: 'pop-value',
          removedValue: lastSelectedValue
        });
      };

      _this.getOptionLabel = function (data) {
        return _this.props.getOptionLabel(data);
      };

      _this.getOptionValue = function (data) {
        return _this.props.getOptionValue(data);
      };

      _this.getStyles = function (key, props) {
        var base = defaultStyles[key](props);
        base.boxSizing = 'border-box';
        var custom = _this.props.styles[key];
        return custom ? custom(base, props) : base;
      };

      _this.getElementId = function (element) {
        return _this.instancePrefix + "-" + element;
      };

      _this.getActiveDescendentId = function () {
        var menuIsOpen = _this.props.menuIsOpen;
        var _this$state = _this.state,
            menuOptions = _this$state.menuOptions,
            focusedOption = _this$state.focusedOption;
        if (!focusedOption || !menuIsOpen) return undefined;
        var index = menuOptions.focusable.indexOf(focusedOption);
        var option = menuOptions.render[index];
        return option && option.key;
      };

      _this.announceAriaLiveSelection = function (_ref2) {
        var event = _ref2.event,
            context = _ref2.context;

        _this.setState({
          ariaLiveSelection: valueEventAriaMessage(event, context)
        });
      };

      _this.announceAriaLiveContext = function (_ref3) {
        var event = _ref3.event,
            context = _ref3.context;

        _this.setState({
          ariaLiveContext: instructionsAriaMessage(event, _extends$4$1({}, context, {
            label: _this.props['aria-label']
          }))
        });
      };

      _this.onMenuMouseDown = function (event) {
        if (event.button !== 0) {
          return;
        }

        event.stopPropagation();
        event.preventDefault();

        _this.focusInput();
      };

      _this.onMenuMouseMove = function (event) {
        _this.blockOptionHover = false;
      };

      _this.onControlMouseDown = function (event) {
        var openMenuOnClick = _this.props.openMenuOnClick;

        if (!_this.state.isFocused) {
          if (openMenuOnClick) {
            _this.openAfterFocus = true;
          }

          _this.focusInput();
        } else if (!_this.props.menuIsOpen) {
          if (openMenuOnClick) {
            _this.openMenu('first');
          }
        } else {
          if ( // $FlowFixMe
          event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
            _this.onMenuClose();
          }
        }

        if ( // $FlowFixMe
        event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') {
          event.preventDefault();
        }
      };

      _this.onDropdownIndicatorMouseDown = function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        if (_this.props.isDisabled) return;
        var _this$props4 = _this.props,
            isMulti = _this$props4.isMulti,
            menuIsOpen = _this$props4.menuIsOpen;

        _this.focusInput();

        if (menuIsOpen) {
          _this.inputIsHiddenAfterUpdate = !isMulti;

          _this.onMenuClose();
        } else {
          _this.openMenu('first');
        }

        event.preventDefault();
        event.stopPropagation();
      };

      _this.onClearIndicatorMouseDown = function (event) {
        // ignore mouse events that weren't triggered by the primary button
        if (event && event.type === 'mousedown' && event.button !== 0) {
          return;
        }

        _this.clearValue();

        event.stopPropagation();
        _this.openAfterFocus = false;

        if (event.type === 'touchend') {
          _this.focusInput();
        } else {
          setTimeout(function () {
            return _this.focusInput();
          });
        }
      };

      _this.onScroll = function (event) {
        if (typeof _this.props.closeMenuOnScroll === 'boolean') {
          if (event.target instanceof HTMLElement && isDocumentElement(event.target)) {
            _this.props.onMenuClose();
          }
        } else if (typeof _this.props.closeMenuOnScroll === 'function') {
          if (_this.props.closeMenuOnScroll(event)) {
            _this.props.onMenuClose();
          }
        }
      };

      _this.onCompositionStart = function () {
        _this.isComposing = true;
      };

      _this.onCompositionEnd = function () {
        _this.isComposing = false;
      };

      _this.onTouchStart = function (_ref4) {
        var touches = _ref4.touches;
        var touch = touches.item(0);

        if (!touch) {
          return;
        }

        _this.initialTouchX = touch.clientX;
        _this.initialTouchY = touch.clientY;
        _this.userIsDragging = false;
      };

      _this.onTouchMove = function (_ref5) {
        var touches = _ref5.touches;
        var touch = touches.item(0);

        if (!touch) {
          return;
        }

        var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
        var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
        var moveThreshold = 5;
        _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
      };

      _this.onTouchEnd = function (event) {
        if (_this.userIsDragging) return; // close the menu if the user taps outside
        // we're checking on event.target here instead of event.currentTarget, because we want to assert information
        // on events on child elements, not the document (which we've attached this handler to).

        if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) {
          _this.blurInput();
        } // reset move vars


        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
      };

      _this.onControlTouchEnd = function (event) {
        if (_this.userIsDragging) return;

        _this.onControlMouseDown(event);
      };

      _this.onClearIndicatorTouchEnd = function (event) {
        if (_this.userIsDragging) return;

        _this.onClearIndicatorMouseDown(event);
      };

      _this.onDropdownIndicatorTouchEnd = function (event) {
        if (_this.userIsDragging) return;

        _this.onDropdownIndicatorMouseDown(event);
      };

      _this.handleInputChange = function (event) {
        var inputValue = event.currentTarget.value;
        _this.inputIsHiddenAfterUpdate = false;

        _this.onInputChange(inputValue, {
          action: 'input-change'
        });

        _this.onMenuOpen();
      };

      _this.onInputFocus = function (event) {
        var _this$props5 = _this.props,
            isSearchable = _this$props5.isSearchable,
            isMulti = _this$props5.isMulti;

        if (_this.props.onFocus) {
          _this.props.onFocus(event);
        }

        _this.inputIsHiddenAfterUpdate = false;

        _this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });

        _this.setState({
          isFocused: true
        });

        if (_this.openAfterFocus || _this.props.openMenuOnFocus) {
          _this.openMenu('first');
        }

        _this.openAfterFocus = false;
      };

      _this.onInputBlur = function (event) {
        if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
          _this.inputRef.focus();

          return;
        }

        if (_this.props.onBlur) {
          _this.props.onBlur(event);
        }

        _this.onInputChange('', {
          action: 'input-blur'
        });

        _this.onMenuClose();

        _this.setState({
          focusedValue: null,
          isFocused: false
        });
      };

      _this.onOptionHover = function (focusedOption) {
        if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) {
          return;
        }

        _this.setState({
          focusedOption: focusedOption
        });
      };

      _this.shouldHideSelectedOptions = function () {
        var _this$props6 = _this.props,
            hideSelectedOptions = _this$props6.hideSelectedOptions,
            isMulti = _this$props6.isMulti;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
      };

      _this.onKeyDown = function (event) {
        var _this$props7 = _this.props,
            isMulti = _this$props7.isMulti,
            backspaceRemovesValue = _this$props7.backspaceRemovesValue,
            escapeClearsValue = _this$props7.escapeClearsValue,
            inputValue = _this$props7.inputValue,
            isClearable = _this$props7.isClearable,
            isDisabled = _this$props7.isDisabled,
            menuIsOpen = _this$props7.menuIsOpen,
            onKeyDown = _this$props7.onKeyDown,
            tabSelectsValue = _this$props7.tabSelectsValue,
            openMenuOnFocus = _this$props7.openMenuOnFocus;
        var _this$state2 = _this.state,
            focusedOption = _this$state2.focusedOption,
            focusedValue = _this$state2.focusedValue,
            selectValue = _this$state2.selectValue;
        if (isDisabled) return;

        if (typeof onKeyDown === 'function') {
          onKeyDown(event);

          if (event.defaultPrevented) {
            return;
          }
        } // Block option hover events when the user has just pressed a key


        _this.blockOptionHover = true;

        switch (event.key) {
          case 'ArrowLeft':
            if (!isMulti || inputValue) return;

            _this.focusValue('previous');

            break;

          case 'ArrowRight':
            if (!isMulti || inputValue) return;

            _this.focusValue('next');

            break;

          case 'Delete':
          case 'Backspace':
            if (inputValue) return;

            if (focusedValue) {
              _this.removeValue(focusedValue);
            } else {
              if (!backspaceRemovesValue) return;

              if (isMulti) {
                _this.popValue();
              } else if (isClearable) {
                _this.clearValue();
              }
            }

            break;

          case 'Tab':
            if (_this.isComposing) return;

            if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) {
              return;
            }

            _this.selectOption(focusedOption);

            break;

          case 'Enter':
            if (event.keyCode === 229) {
              // ignore the keydown event from an Input Method Editor(IME)
              // ref. https://www.w3.org/TR/uievents/#determine-keydown-keyup-keyCode
              break;
            }

            if (menuIsOpen) {
              if (!focusedOption) return;
              if (_this.isComposing) return;

              _this.selectOption(focusedOption);

              break;
            }

            return;

          case 'Escape':
            if (menuIsOpen) {
              _this.inputIsHiddenAfterUpdate = false;

              _this.onInputChange('', {
                action: 'menu-close'
              });

              _this.onMenuClose();
            } else if (isClearable && escapeClearsValue) {
              _this.clearValue();
            }

            break;

          case ' ':
            // space
            if (inputValue) {
              return;
            }

            if (!menuIsOpen) {
              _this.openMenu('first');

              break;
            }

            if (!focusedOption) return;

            _this.selectOption(focusedOption);

            break;

          case 'ArrowUp':
            if (menuIsOpen) {
              _this.focusOption('up');
            } else {
              _this.openMenu('last');
            }

            break;

          case 'ArrowDown':
            if (menuIsOpen) {
              _this.focusOption('down');
            } else {
              _this.openMenu('first');
            }

            break;

          case 'PageUp':
            if (!menuIsOpen) return;

            _this.focusOption('pageup');

            break;

          case 'PageDown':
            if (!menuIsOpen) return;

            _this.focusOption('pagedown');

            break;

          case 'Home':
            if (!menuIsOpen) return;

            _this.focusOption('first');

            break;

          case 'End':
            if (!menuIsOpen) return;

            _this.focusOption('last');

            break;

          default:
            return;
        }

        event.preventDefault();
      };

      _this.buildMenuOptions = function (props, selectValue) {
        var _props$inputValue = props.inputValue,
            inputValue = _props$inputValue === void 0 ? '' : _props$inputValue,
            options = props.options;

        var toOption = function toOption(option, id) {
          var isDisabled = _this.isOptionDisabled(option, selectValue);

          var isSelected = _this.isOptionSelected(option, selectValue);

          var label = _this.getOptionLabel(option);

          var value = _this.getOptionValue(option);

          if (_this.shouldHideSelectedOptions() && isSelected || !_this.filterOption({
            label: label,
            value: value,
            data: option
          }, inputValue)) {
            return;
          }

          var onHover = isDisabled ? undefined : function () {
            return _this.onOptionHover(option);
          };
          var onSelect = isDisabled ? undefined : function () {
            return _this.selectOption(option);
          };
          var optionId = _this.getElementId('option') + "-" + id;
          return {
            innerProps: {
              id: optionId,
              onClick: onSelect,
              onMouseMove: onHover,
              onMouseOver: onHover,
              tabIndex: -1
            },
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            key: optionId,
            label: label,
            type: 'option',
            value: value
          };
        };

        return options.reduce(function (acc, item, itemIndex) {
          if (item.options) {
            // TODO needs a tidier implementation
            if (!_this.hasGroups) _this.hasGroups = true;
            var items = item.options;
            var children = items.map(function (child, i) {
              var option = toOption(child, itemIndex + "-" + i);
              if (option) acc.focusable.push(child);
              return option;
            }).filter(Boolean);

            if (children.length) {
              var groupId = _this.getElementId('group') + "-" + itemIndex;
              acc.render.push({
                type: 'group',
                key: groupId,
                data: item,
                options: children
              });
            }
          } else {
            var option = toOption(item, "" + itemIndex);

            if (option) {
              acc.render.push(option);
              acc.focusable.push(item);
            }
          }

          return acc;
        }, {
          render: [],
          focusable: []
        });
      };

      var _value = _props.value;
      _this.cacheComponents = memoizeOne(_this.cacheComponents, exportedEqual).bind(_assertThisInitialized$1(_assertThisInitialized$1(_this)));

      _this.cacheComponents(_props.components);

      _this.instancePrefix = 'react-select-' + (_this.props.instanceId || ++instanceId);

      var _selectValue = cleanValue(_value);

      _this.buildMenuOptions = memoizeOne(_this.buildMenuOptions, function (newArgs, lastArgs) {
        var _ref6 = newArgs,
            newProps = _ref6[0],
            newSelectValue = _ref6[1];
        var _ref7 = lastArgs,
            lastProps = _ref7[0],
            lastSelectValue = _ref7[1];
        return exportedEqual(newSelectValue, lastSelectValue) && exportedEqual(newProps.inputValue, lastProps.inputValue) && exportedEqual(newProps.options, lastProps.options);
      }).bind(_assertThisInitialized$1(_assertThisInitialized$1(_this)));

      var _menuOptions = _props.menuIsOpen ? _this.buildMenuOptions(_props, _selectValue) : {
        render: [],
        focusable: []
      };

      _this.state.menuOptions = _menuOptions;
      _this.state.selectValue = _selectValue;
      return _this;
    }

    var _proto = Select.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.startListeningComposition();
      this.startListeningToTouch();

      if (this.props.closeMenuOnScroll && document && document.addEventListener) {
        // Listen to all scroll events, and filter them out inside of 'onScroll'
        document.addEventListener('scroll', this.onScroll, true);
      }

      if (this.props.autoFocus) {
        this.focusInput();
      }
    };

    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this$props8 = this.props,
          options = _this$props8.options,
          value = _this$props8.value,
          menuIsOpen = _this$props8.menuIsOpen,
          inputValue = _this$props8.inputValue; // re-cache custom components

      this.cacheComponents(nextProps.components); // rebuild the menu options

      if (nextProps.value !== value || nextProps.options !== options || nextProps.menuIsOpen !== menuIsOpen || nextProps.inputValue !== inputValue) {
        var selectValue = cleanValue(nextProps.value);
        var menuOptions = nextProps.menuIsOpen ? this.buildMenuOptions(nextProps, selectValue) : {
          render: [],
          focusable: []
        };
        var focusedValue = this.getNextFocusedValue(selectValue);
        var focusedOption = this.getNextFocusedOption(menuOptions.focusable);
        this.setState({
          menuOptions: menuOptions,
          selectValue: selectValue,
          focusedOption: focusedOption,
          focusedValue: focusedValue
        });
      } // some updates should toggle the state of the input visibility


      if (this.inputIsHiddenAfterUpdate != null) {
        this.setState({
          inputIsHidden: this.inputIsHiddenAfterUpdate
        });
        delete this.inputIsHiddenAfterUpdate;
      }
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var _this$props9 = this.props,
          isDisabled = _this$props9.isDisabled,
          menuIsOpen = _this$props9.menuIsOpen;
      var isFocused = this.state.isFocused;

      if ( // ensure focus is restored correctly when the control becomes enabled
      isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
      isFocused && menuIsOpen && !prevProps.menuIsOpen) {
        this.focusInput();
      } // scroll the focused option into view if necessary


      if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
        scrollIntoView(this.menuListRef, this.focusedOptionRef);
        this.scrollToFocusedOptionOnUpdate = false;
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.stopListeningComposition();
      this.stopListeningToTouch();
      document.removeEventListener('scroll', this.onScroll, true);
    };

    // ==============================
    // Consumer Handlers
    // ==============================
    _proto.onMenuOpen = function onMenuOpen() {
      this.props.onMenuOpen();
    };

    _proto.onMenuClose = function onMenuClose() {
      var _this$props10 = this.props,
          isSearchable = _this$props10.isSearchable,
          isMulti = _this$props10.isMulti;
      this.announceAriaLiveContext({
        event: 'input',
        context: {
          isSearchable: isSearchable,
          isMulti: isMulti
        }
      });
      this.onInputChange('', {
        action: 'menu-close'
      });
      this.props.onMenuClose();
    };

    _proto.onInputChange = function onInputChange(newValue, actionMeta) {
      this.props.onInputChange(newValue, actionMeta);
    } // ==============================
    // Methods
    // ==============================
    ;

    _proto.focusInput = function focusInput() {
      if (!this.inputRef) return;
      this.inputRef.focus();
    };

    _proto.blurInput = function blurInput() {
      if (!this.inputRef) return;
      this.inputRef.blur();
    } // aliased for consumers
    ;

    _proto.openMenu = function openMenu(focusOption) {
      var _this2 = this;

      var _this$state3 = this.state,
          selectValue = _this$state3.selectValue,
          isFocused = _this$state3.isFocused;
      var menuOptions = this.buildMenuOptions(this.props, selectValue);
      var isMulti = this.props.isMulti;
      var openAtIndex = focusOption === 'first' ? 0 : menuOptions.focusable.length - 1;

      if (!isMulti) {
        var selectedIndex = menuOptions.focusable.indexOf(selectValue[0]);

        if (selectedIndex > -1) {
          openAtIndex = selectedIndex;
        }
      } // only scroll if the menu isn't already open


      this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
      this.inputIsHiddenAfterUpdate = false;
      this.setState({
        menuOptions: menuOptions,
        focusedValue: null,
        focusedOption: menuOptions.focusable[openAtIndex]
      }, function () {
        _this2.onMenuOpen();

        _this2.announceAriaLiveContext({
          event: 'menu'
        });
      });
    };

    _proto.focusValue = function focusValue(direction) {
      var _this$props11 = this.props,
          isMulti = _this$props11.isMulti,
          isSearchable = _this$props11.isSearchable;
      var _this$state4 = this.state,
          selectValue = _this$state4.selectValue,
          focusedValue = _this$state4.focusedValue; // Only multiselects support value focusing

      if (!isMulti) return;
      this.setState({
        focusedOption: null
      });
      var focusedIndex = selectValue.indexOf(focusedValue);

      if (!focusedValue) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'value'
        });
      }

      var lastIndex = selectValue.length - 1;
      var nextFocus = -1;
      if (!selectValue.length) return;

      switch (direction) {
        case 'previous':
          if (focusedIndex === 0) {
            // don't cycle from the start to the end
            nextFocus = 0;
          } else if (focusedIndex === -1) {
            // if nothing is focused, focus the last value first
            nextFocus = lastIndex;
          } else {
            nextFocus = focusedIndex - 1;
          }

          break;

        case 'next':
          if (focusedIndex > -1 && focusedIndex < lastIndex) {
            nextFocus = focusedIndex + 1;
          }

          break;
      }

      if (nextFocus === -1) {
        this.announceAriaLiveContext({
          event: 'input',
          context: {
            isSearchable: isSearchable,
            isMulti: isMulti
          }
        });
      }

      this.setState({
        inputIsHidden: nextFocus !== -1,
        focusedValue: selectValue[nextFocus]
      });
    };

    _proto.focusOption = function focusOption(direction) {
      if (direction === void 0) {
        direction = 'first';
      }

      var pageSize = this.props.pageSize;
      var _this$state5 = this.state,
          focusedOption = _this$state5.focusedOption,
          menuOptions = _this$state5.menuOptions;
      var options = menuOptions.focusable;
      if (!options.length) return;
      var nextFocus = 0; // handles 'first'

      var focusedIndex = options.indexOf(focusedOption);

      if (!focusedOption) {
        focusedIndex = -1;
        this.announceAriaLiveContext({
          event: 'menu'
        });
      }

      if (direction === 'up') {
        nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
      } else if (direction === 'down') {
        nextFocus = (focusedIndex + 1) % options.length;
      } else if (direction === 'pageup') {
        nextFocus = focusedIndex - pageSize;
        if (nextFocus < 0) nextFocus = 0;
      } else if (direction === 'pagedown') {
        nextFocus = focusedIndex + pageSize;
        if (nextFocus > options.length - 1) nextFocus = options.length - 1;
      } else if (direction === 'last') {
        nextFocus = options.length - 1;
      }

      this.scrollToFocusedOptionOnUpdate = true;
      this.setState({
        focusedOption: options[nextFocus],
        focusedValue: null
      });
      this.announceAriaLiveContext({
        event: 'menu',
        context: {
          isDisabled: isOptionDisabled(options[nextFocus])
        }
      });
    };

    // ==============================
    // Getters
    // ==============================
    _proto.getTheme = function getTheme() {
      // Use the default theme if there are no customizations.
      if (!this.props.theme) {
        return defaultTheme;
      } // If the theme prop is a function, assume the function
      // knows how to merge the passed-in default theme with
      // its own modifications.


      if (typeof this.props.theme === 'function') {
        return this.props.theme(defaultTheme);
      } // Otherwise, if a plain theme object was passed in,
      // overlay it with the default theme.


      return _extends$4$1({}, defaultTheme, this.props.theme);
    };

    _proto.getCommonProps = function getCommonProps() {
      var clearValue = this.clearValue,
          getStyles = this.getStyles,
          setValue = this.setValue,
          selectOption = this.selectOption,
          props = this.props;
      var classNamePrefix = props.classNamePrefix,
          isMulti = props.isMulti,
          isRtl = props.isRtl,
          options = props.options;
      var selectValue = this.state.selectValue;
      var hasValue = this.hasValue();

      var getValue = function getValue() {
        return selectValue;
      };

      var cx = classNames.bind(null, classNamePrefix);
      return {
        cx: cx,
        clearValue: clearValue,
        getStyles: getStyles,
        getValue: getValue,
        hasValue: hasValue,
        isMulti: isMulti,
        isRtl: isRtl,
        options: options,
        selectOption: selectOption,
        setValue: setValue,
        selectProps: props,
        theme: this.getTheme()
      };
    };

    _proto.getNextFocusedValue = function getNextFocusedValue(nextSelectValue) {
      if (this.clearFocusValueOnUpdate) {
        this.clearFocusValueOnUpdate = false;
        return null;
      }

      var _this$state6 = this.state,
          focusedValue = _this$state6.focusedValue,
          lastSelectValue = _this$state6.selectValue;
      var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);

      if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);

        if (nextFocusedIndex > -1) {
          // the focused value is still in the selectValue, return it
          return focusedValue;
        } else if (lastFocusedIndex < nextSelectValue.length) {
          // the focusedValue is not present in the next selectValue array by
          // reference, so return the new value at the same index
          return nextSelectValue[lastFocusedIndex];
        }
      }

      return null;
    };

    _proto.getNextFocusedOption = function getNextFocusedOption(options) {
      var lastFocusedOption = this.state.focusedOption;
      return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    };

    _proto.hasValue = function hasValue() {
      var selectValue = this.state.selectValue;
      return selectValue.length > 0;
    };

    _proto.hasOptions = function hasOptions() {
      return !!this.state.menuOptions.render.length;
    };

    _proto.countOptions = function countOptions() {
      return this.state.menuOptions.focusable.length;
    };

    _proto.isClearable = function isClearable() {
      var _this$props12 = this.props,
          isClearable = _this$props12.isClearable,
          isMulti = _this$props12.isMulti; // single select, by default, IS NOT clearable
      // multi select, by default, IS clearable

      if (isClearable === undefined) return isMulti;
      return isClearable;
    };

    _proto.isOptionDisabled = function isOptionDisabled(option, selectValue) {
      return typeof this.props.isOptionDisabled === 'function' ? this.props.isOptionDisabled(option, selectValue) : false;
    };

    _proto.isOptionSelected = function isOptionSelected(option, selectValue) {
      var _this3 = this;

      if (selectValue.indexOf(option) > -1) return true;

      if (typeof this.props.isOptionSelected === 'function') {
        return this.props.isOptionSelected(option, selectValue);
      }

      var candidate = this.getOptionValue(option);
      return selectValue.some(function (i) {
        return _this3.getOptionValue(i) === candidate;
      });
    };

    _proto.filterOption = function filterOption(option, inputValue) {
      return this.props.filterOption ? this.props.filterOption(option, inputValue) : true;
    };

    _proto.formatOptionLabel = function formatOptionLabel(data, context) {
      if (typeof this.props.formatOptionLabel === 'function') {
        var inputValue = this.props.inputValue;
        var selectValue = this.state.selectValue;
        return this.props.formatOptionLabel(data, {
          context: context,
          inputValue: inputValue,
          selectValue: selectValue
        });
      } else {
        return this.getOptionLabel(data);
      }
    };

    _proto.formatGroupLabel = function formatGroupLabel(data) {
      return this.props.formatGroupLabel(data);
    } // ==============================
    // Mouse Handlers
    // ==============================
    ;

    // ==============================
    // Composition Handlers
    // ==============================
    _proto.startListeningComposition = function startListeningComposition() {
      if (document && document.addEventListener) {
        document.addEventListener('compositionstart', this.onCompositionStart, false);
        document.addEventListener('compositionend', this.onCompositionEnd, false);
      }
    };

    _proto.stopListeningComposition = function stopListeningComposition() {
      if (document && document.removeEventListener) {
        document.removeEventListener('compositionstart', this.onCompositionStart);
        document.removeEventListener('compositionend', this.onCompositionEnd);
      }
    };

    // ==============================
    // Touch Handlers
    // ==============================
    _proto.startListeningToTouch = function startListeningToTouch() {
      if (document && document.addEventListener) {
        document.addEventListener('touchstart', this.onTouchStart, false);
        document.addEventListener('touchmove', this.onTouchMove, false);
        document.addEventListener('touchend', this.onTouchEnd, false);
      }
    };

    _proto.stopListeningToTouch = function stopListeningToTouch() {
      if (document && document.removeEventListener) {
        document.removeEventListener('touchstart', this.onTouchStart);
        document.removeEventListener('touchmove', this.onTouchMove);
        document.removeEventListener('touchend', this.onTouchEnd);
      }
    };

    // ==============================
    // Renderers
    // ==============================
    _proto.constructAriaLiveMessage = function constructAriaLiveMessage() {
      var _this$state7 = this.state,
          ariaLiveContext = _this$state7.ariaLiveContext,
          selectValue = _this$state7.selectValue,
          focusedValue = _this$state7.focusedValue,
          focusedOption = _this$state7.focusedOption;
      var _this$props13 = this.props,
          options = _this$props13.options,
          menuIsOpen = _this$props13.menuIsOpen,
          inputValue = _this$props13.inputValue,
          screenReaderStatus = _this$props13.screenReaderStatus; // An aria live message representing the currently focused value in the select.

      var focusedValueMsg = focusedValue ? valueFocusAriaMessage({
        focusedValue: focusedValue,
        getOptionLabel: this.getOptionLabel,
        selectValue: selectValue
      }) : ''; // An aria live message representing the currently focused option in the select.

      var focusedOptionMsg = focusedOption && menuIsOpen ? optionFocusAriaMessage({
        focusedOption: focusedOption,
        getOptionLabel: this.getOptionLabel,
        options: options
      }) : ''; // An aria live message representing the set of focusable results and current searchterm/inputvalue.

      var resultsMsg = resultsAriaMessage({
        inputValue: inputValue,
        screenReaderMessage: screenReaderStatus({
          count: this.countOptions()
        })
      });
      return focusedValueMsg + " " + focusedOptionMsg + " " + resultsMsg + " " + ariaLiveContext;
    };

    _proto.renderInput = function renderInput() {
      var _this$props14 = this.props,
          isDisabled = _this$props14.isDisabled,
          isSearchable = _this$props14.isSearchable,
          inputId = _this$props14.inputId,
          inputValue = _this$props14.inputValue,
          tabIndex = _this$props14.tabIndex;
      var Input = this.components.Input;
      var inputIsHidden = this.state.inputIsHidden;
      var id = inputId || this.getElementId('input'); // aria attributes makes the JSX "noisy", separated for clarity

      var ariaAttributes = {
        'aria-autocomplete': 'list',
        'aria-label': this.props['aria-label'],
        'aria-labelledby': this.props['aria-labelledby']
      };

      if (!isSearchable) {
        // use a dummy input to maintain focus/blur functionality
        return React$2__default.createElement(DummyInput, _extends$4$1({
          id: id,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: noop,
          onFocus: this.onInputFocus,
          readOnly: true,
          disabled: isDisabled,
          tabIndex: tabIndex,
          value: ""
        }, ariaAttributes));
      }

      var _this$commonProps = this.commonProps,
          cx = _this$commonProps.cx,
          theme = _this$commonProps.theme,
          selectProps = _this$commonProps.selectProps;
      return React$2__default.createElement(Input, _extends$4$1({
        autoCapitalize: "none",
        autoComplete: "off",
        autoCorrect: "off",
        cx: cx,
        getStyles: this.getStyles,
        id: id,
        innerRef: this.getInputRef,
        isDisabled: isDisabled,
        isHidden: inputIsHidden,
        onBlur: this.onInputBlur,
        onChange: this.handleInputChange,
        onFocus: this.onInputFocus,
        selectProps: selectProps,
        spellCheck: "false",
        tabIndex: tabIndex,
        theme: theme,
        type: "text",
        value: inputValue
      }, ariaAttributes));
    };

    _proto.renderPlaceholderOrValue = function renderPlaceholderOrValue() {
      var _this4 = this;

      var _this$components = this.components,
          MultiValue = _this$components.MultiValue,
          MultiValueContainer = _this$components.MultiValueContainer,
          MultiValueLabel = _this$components.MultiValueLabel,
          MultiValueRemove = _this$components.MultiValueRemove,
          SingleValue = _this$components.SingleValue,
          Placeholder = _this$components.Placeholder;
      var commonProps = this.commonProps;
      var _this$props15 = this.props,
          controlShouldRenderValue = _this$props15.controlShouldRenderValue,
          isDisabled = _this$props15.isDisabled,
          isMulti = _this$props15.isMulti,
          inputValue = _this$props15.inputValue,
          placeholder = _this$props15.placeholder;
      var _this$state8 = this.state,
          selectValue = _this$state8.selectValue,
          focusedValue = _this$state8.focusedValue,
          isFocused = _this$state8.isFocused;

      if (!this.hasValue() || !controlShouldRenderValue) {
        return inputValue ? null : React$2__default.createElement(Placeholder, _extends$4$1({}, commonProps, {
          key: "placeholder",
          isDisabled: isDisabled,
          isFocused: isFocused
        }), placeholder);
      }

      if (isMulti) {
        var selectValues = selectValue.map(function (opt, index) {
          var isOptionFocused = opt === focusedValue;
          return React$2__default.createElement(MultiValue, _extends$4$1({}, commonProps, {
            components: {
              Container: MultiValueContainer,
              Label: MultiValueLabel,
              Remove: MultiValueRemove
            },
            isFocused: isOptionFocused,
            isDisabled: isDisabled,
            key: _this4.getOptionValue(opt),
            index: index,
            removeProps: {
              onClick: function onClick() {
                return _this4.removeValue(opt);
              },
              onTouchEnd: function onTouchEnd() {
                return _this4.removeValue(opt);
              },
              onMouseDown: function onMouseDown(e) {
                e.preventDefault();
                e.stopPropagation();
              }
            },
            data: opt
          }), _this4.formatOptionLabel(opt, 'value'));
        });
        return selectValues;
      }

      if (inputValue) {
        return null;
      }

      var singleValue = selectValue[0];
      return React$2__default.createElement(SingleValue, _extends$4$1({}, commonProps, {
        data: singleValue,
        isDisabled: isDisabled
      }), this.formatOptionLabel(singleValue, 'value'));
    };

    _proto.renderClearIndicator = function renderClearIndicator() {
      var ClearIndicator = this.components.ClearIndicator;
      var commonProps = this.commonProps;
      var _this$props16 = this.props,
          isDisabled = _this$props16.isDisabled,
          isLoading = _this$props16.isLoading;
      var isFocused = this.state.isFocused;

      if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) {
        return null;
      }

      var innerProps = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return React$2__default.createElement(ClearIndicator, _extends$4$1({}, commonProps, {
        innerProps: innerProps,
        isFocused: isFocused
      }));
    };

    _proto.renderLoadingIndicator = function renderLoadingIndicator() {
      var LoadingIndicator = this.components.LoadingIndicator;
      var commonProps = this.commonProps;
      var _this$props17 = this.props,
          isDisabled = _this$props17.isDisabled,
          isLoading = _this$props17.isLoading;
      var isFocused = this.state.isFocused;
      if (!LoadingIndicator || !isLoading) return null;
      var innerProps = {
        'aria-hidden': 'true'
      };
      return React$2__default.createElement(LoadingIndicator, _extends$4$1({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    };

    _proto.renderIndicatorSeparator = function renderIndicatorSeparator() {
      var _this$components2 = this.components,
          DropdownIndicator = _this$components2.DropdownIndicator,
          IndicatorSeparator = _this$components2.IndicatorSeparator; // separator doesn't make sense without the dropdown indicator

      if (!DropdownIndicator || !IndicatorSeparator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      return React$2__default.createElement(IndicatorSeparator, _extends$4$1({}, commonProps, {
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    };

    _proto.renderDropdownIndicator = function renderDropdownIndicator() {
      var DropdownIndicator = this.components.DropdownIndicator;
      if (!DropdownIndicator) return null;
      var commonProps = this.commonProps;
      var isDisabled = this.props.isDisabled;
      var isFocused = this.state.isFocused;
      var innerProps = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        'aria-hidden': 'true'
      };
      return React$2__default.createElement(DropdownIndicator, _extends$4$1({}, commonProps, {
        innerProps: innerProps,
        isDisabled: isDisabled,
        isFocused: isFocused
      }));
    };

    _proto.renderMenu = function renderMenu() {
      var _this5 = this;

      var _this$components3 = this.components,
          Group = _this$components3.Group,
          GroupHeading = _this$components3.GroupHeading,
          Menu = _this$components3.Menu,
          MenuList = _this$components3.MenuList,
          MenuPortal = _this$components3.MenuPortal,
          LoadingMessage = _this$components3.LoadingMessage,
          NoOptionsMessage = _this$components3.NoOptionsMessage,
          Option = _this$components3.Option;
      var commonProps = this.commonProps;
      var _this$state9 = this.state,
          focusedOption = _this$state9.focusedOption,
          menuOptions = _this$state9.menuOptions;
      var _this$props18 = this.props,
          captureMenuScroll = _this$props18.captureMenuScroll,
          inputValue = _this$props18.inputValue,
          isLoading = _this$props18.isLoading,
          loadingMessage = _this$props18.loadingMessage,
          minMenuHeight = _this$props18.minMenuHeight,
          maxMenuHeight = _this$props18.maxMenuHeight,
          menuIsOpen = _this$props18.menuIsOpen,
          menuPlacement = _this$props18.menuPlacement,
          menuPosition = _this$props18.menuPosition,
          menuPortalTarget = _this$props18.menuPortalTarget,
          menuShouldBlockScroll = _this$props18.menuShouldBlockScroll,
          menuShouldScrollIntoView = _this$props18.menuShouldScrollIntoView,
          noOptionsMessage = _this$props18.noOptionsMessage,
          onMenuScrollToTop = _this$props18.onMenuScrollToTop,
          onMenuScrollToBottom = _this$props18.onMenuScrollToBottom;
      if (!menuIsOpen) return null; // TODO: Internal Option Type here

      var render = function render(props) {
        // for performance, the menu options in state aren't changed when the
        // focused option changes so we calculate additional props based on that
        var isFocused = focusedOption === props.data;
        props.innerRef = isFocused ? _this5.getFocusedOptionRef : undefined;
        return React$2__default.createElement(Option, _extends$4$1({}, commonProps, props, {
          isFocused: isFocused
        }), _this5.formatOptionLabel(props.data, 'menu'));
      };

      var menuUI;

      if (this.hasOptions()) {
        menuUI = menuOptions.render.map(function (item) {
          if (item.type === 'group') {
            var type = item.type,
                group = _objectWithoutPropertiesLoose$2$1(item, ["type"]);

            var headingId = item.key + "-heading";
            return React$2__default.createElement(Group, _extends$4$1({}, commonProps, group, {
              Heading: GroupHeading,
              headingProps: {
                id: headingId
              },
              label: _this5.formatGroupLabel(item.data)
            }), item.options.map(function (option) {
              return render(option);
            }));
          } else if (item.type === 'option') {
            return render(item);
          }
        });
      } else if (isLoading) {
        var message = loadingMessage({
          inputValue: inputValue
        });
        if (message === null) return null;
        menuUI = React$2__default.createElement(LoadingMessage, commonProps, message);
      } else {
        var _message = noOptionsMessage({
          inputValue: inputValue
        });

        if (_message === null) return null;
        menuUI = React$2__default.createElement(NoOptionsMessage, commonProps, _message);
      }

      var menuPlacementProps = {
        minMenuHeight: minMenuHeight,
        maxMenuHeight: maxMenuHeight,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition,
        menuShouldScrollIntoView: menuShouldScrollIntoView
      };
      var menuElement = React$2__default.createElement(MenuPlacer, _extends$4$1({}, commonProps, menuPlacementProps), function (_ref8) {
        var ref = _ref8.ref,
            _ref8$placerProps = _ref8.placerProps,
            placement = _ref8$placerProps.placement,
            maxHeight = _ref8$placerProps.maxHeight;
        return React$2__default.createElement(Menu, _extends$4$1({}, commonProps, menuPlacementProps, {
          innerRef: ref,
          innerProps: {
            onMouseDown: _this5.onMenuMouseDown,
            onMouseMove: _this5.onMenuMouseMove
          },
          isLoading: isLoading,
          placement: placement
        }), React$2__default.createElement(ScrollCaptorSwitch, {
          isEnabled: captureMenuScroll,
          onTopArrive: onMenuScrollToTop,
          onBottomArrive: onMenuScrollToBottom
        }, React$2__default.createElement(ScrollBlock, {
          isEnabled: menuShouldBlockScroll
        }, React$2__default.createElement(MenuList, _extends$4$1({}, commonProps, {
          innerRef: _this5.getMenuListRef,
          isLoading: isLoading,
          maxHeight: maxHeight
        }), menuUI))));
      }); // positioning behaviour is almost identical for portalled and fixed,
      // so we use the same component. the actual portalling logic is forked
      // within the component based on `menuPosition`

      return menuPortalTarget || menuPosition === 'fixed' ? React$2__default.createElement(MenuPortal, _extends$4$1({}, commonProps, {
        appendTo: menuPortalTarget,
        controlElement: this.controlRef,
        menuPlacement: menuPlacement,
        menuPosition: menuPosition
      }), menuElement) : menuElement;
    };

    _proto.renderFormField = function renderFormField() {
      var _this6 = this;

      var _this$props19 = this.props,
          delimiter = _this$props19.delimiter,
          isDisabled = _this$props19.isDisabled,
          isMulti = _this$props19.isMulti,
          name = _this$props19.name;
      var selectValue = this.state.selectValue;
      if (!name || isDisabled) return;

      if (isMulti) {
        if (delimiter) {
          var value = selectValue.map(function (opt) {
            return _this6.getOptionValue(opt);
          }).join(delimiter);
          return React$2__default.createElement("input", {
            name: name,
            type: "hidden",
            value: value
          });
        } else {
          var input = selectValue.length > 0 ? selectValue.map(function (opt, i) {
            return React$2__default.createElement("input", {
              key: "i-" + i,
              name: name,
              type: "hidden",
              value: _this6.getOptionValue(opt)
            });
          }) : React$2__default.createElement("input", {
            name: name,
            type: "hidden"
          });
          return React$2__default.createElement("div", null, input);
        }
      } else {
        var _value2 = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';

        return React$2__default.createElement("input", {
          name: name,
          type: "hidden",
          value: _value2
        });
      }
    };

    _proto.renderLiveRegion = function renderLiveRegion() {
      if (!this.state.isFocused) return null;
      return React$2__default.createElement(A11yText, {
        "aria-live": "polite"
      }, React$2__default.createElement("p", {
        id: "aria-selection-event"
      }, "\xA0", this.state.ariaLiveSelection), React$2__default.createElement("p", {
        id: "aria-context"
      }, "\xA0", this.constructAriaLiveMessage()));
    };

    _proto.render = function render() {
      var _this$components4 = this.components,
          Control = _this$components4.Control,
          IndicatorsContainer = _this$components4.IndicatorsContainer,
          SelectContainer = _this$components4.SelectContainer,
          ValueContainer = _this$components4.ValueContainer;
      var _this$props20 = this.props,
          className = _this$props20.className,
          id = _this$props20.id,
          isDisabled = _this$props20.isDisabled,
          menuIsOpen = _this$props20.menuIsOpen;
      var isFocused = this.state.isFocused;
      var commonProps = this.commonProps = this.getCommonProps();
      return React$2__default.createElement(SelectContainer, _extends$4$1({}, commonProps, {
        className: className,
        innerProps: {
          id: id,
          onKeyDown: this.onKeyDown
        },
        isDisabled: isDisabled,
        isFocused: isFocused
      }), this.renderLiveRegion(), React$2__default.createElement(Control, _extends$4$1({}, commonProps, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: isDisabled,
        isFocused: isFocused,
        menuIsOpen: menuIsOpen
      }), React$2__default.createElement(ValueContainer, _extends$4$1({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderPlaceholderOrValue(), this.renderInput()), React$2__default.createElement(IndicatorsContainer, _extends$4$1({}, commonProps, {
        isDisabled: isDisabled
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    };

    return Select;
  }(React$2.Component);

  Select.defaultProps = defaultProps;

  function _extends$c() { _extends$c = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }

  function _objectWithoutPropertiesLoose$4(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

  function _inheritsLoose$5(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
  var defaultProps$1 = {
    defaultInputValue: '',
    defaultMenuIsOpen: false,
    defaultValue: null
  };

  var manageState = function manageState(SelectComponent) {
    var _class, _temp;

    return _temp = _class =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose$5(StateManager, _Component);

      function StateManager() {
        var _this;

        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this = _Component.call.apply(_Component, [this].concat(args)) || this;
        _this.select = void 0;
        _this.state = {
          inputValue: _this.props.inputValue !== undefined ? _this.props.inputValue : _this.props.defaultInputValue,
          menuIsOpen: _this.props.menuIsOpen !== undefined ? _this.props.menuIsOpen : _this.props.defaultMenuIsOpen,
          value: _this.props.value !== undefined ? _this.props.value : _this.props.defaultValue
        };

        _this.onChange = function (value, actionMeta) {
          _this.callProp('onChange', value, actionMeta);

          _this.setState({
            value: value
          });
        };

        _this.onInputChange = function (value, actionMeta) {
          // TODO: for backwards compatibility, we allow the prop to return a new
          // value, but now inputValue is a controllable prop we probably shouldn't
          var newValue = _this.callProp('onInputChange', value, actionMeta);

          _this.setState({
            inputValue: newValue !== undefined ? newValue : value
          });
        };

        _this.onMenuOpen = function () {
          _this.callProp('onMenuOpen');

          _this.setState({
            menuIsOpen: true
          });
        };

        _this.onMenuClose = function () {
          _this.callProp('onMenuClose');

          _this.setState({
            menuIsOpen: false
          });
        };

        return _this;
      }

      var _proto = StateManager.prototype;

      _proto.focus = function focus() {
        this.select.focus();
      };

      _proto.blur = function blur() {
        this.select.blur();
      } // FIXME: untyped flow code, return any
      ;

      _proto.getProp = function getProp(key) {
        return this.props[key] !== undefined ? this.props[key] : this.state[key];
      } // FIXME: untyped flow code, return any
      ;

      _proto.callProp = function callProp(name) {
        if (typeof this.props[name] === 'function') {
          var _this$props;

          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          return (_this$props = this.props)[name].apply(_this$props, args);
        }
      };

      _proto.render = function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            defaultInputValue = _this$props2.defaultInputValue,
            defaultMenuIsOpen = _this$props2.defaultMenuIsOpen,
            defaultValue = _this$props2.defaultValue,
            props = _objectWithoutPropertiesLoose$4(_this$props2, ["defaultInputValue", "defaultMenuIsOpen", "defaultValue"]);

        return React$2__default.createElement(SelectComponent, _extends$c({}, props, {
          ref: function ref(_ref) {
            _this2.select = _ref;
          },
          inputValue: this.getProp('inputValue'),
          menuIsOpen: this.getProp('menuIsOpen'),
          onChange: this.onChange,
          onInputChange: this.onInputChange,
          onMenuClose: this.onMenuClose,
          onMenuOpen: this.onMenuOpen,
          value: this.getProp('value')
        }));
      };

      return StateManager;
    }(React$2.Component), _class.defaultProps = defaultProps$1, _temp;
  };

  var index = manageState(Select);

  function _templateObject$d() {
    var data = _taggedTemplateLiteral(["\n  width: 350px;\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject$d = function _templateObject() {
      return data;
    };

    return data;
  }
  var View = styled__default.div(_templateObject$d(), theme.breakpoints.down('sm'));
  var customStyles = function customStyles() {
    return {
      option: function option() {
        return {
          padding: 5,
          height: 35,
          fontSize: 14,
          paddingLeft: 13,
          color: theme.colors.blue800,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: theme.colors.grey500
          },
          textOverflow: 'ellipsis',
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        };
      },
      control: function control(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          border: "1px solid ".concat(theme.colors.blue800),
          borderRadius: 100,
          height: 42,
          fontFamily: 'CenturyGothic, sans serif',
          cursor: 'pointer'
        });
      },
      singleValue: function singleValue(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.blue800,
          fontSize: 16,
          lineHeight: 34
        });
      },
      input: function input(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.blue800,
          fontSize: 16,
          fontFamily: 'CenturyGothic, sans serif'
        });
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.pink900,
          marginRight: 8
        });
      },
      placeholder: function placeholder() {
        return {
          fontFamily: 'CenturyGothic, sans serif',
          color: theme.colors.grey600,
          fontSize: 16
        };
      },
      indicatorSeparator: function indicatorSeparator() {
        return {};
      },
      menuList: function menuList(_menuList) {
        return _objectSpread2(_objectSpread2({}, _menuList), {}, {
          padding: 0,
          zIndex: 100
        });
      },
      menu: function menu(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          borderCollapse: 'separate',
          border: '1px solid var(--brandSecundary)',
          boxSizing: 'border-box',
          borderRadius: '20px',
          overflow: 'auto',
          fontFamily: 'CenturyGothic, sans serif'
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          padding: '2px 16px',
          fontSize: 20
        });
      }
    };
  };

  /**
   * @typedef {object} ReactSelectValue
   * @property {number | string} value
   * @property {string} label
   */

  /**
   * @typedef {object} SelectorProps
   * @property {Array<ReactSelectValue>} [options]
   * @property {ReactSelectValue} [value]
   * @property {((selectedValue: ReactSelectValue) => Void)} [onValueChange]
   * @property {string} [name]
   */

  /** @type {import('react').FC<SelectorProps>} */

  var Selector = function Selector(_ref) {
    var _ref$options = _ref.options,
        options = _ref$options === void 0 ? [] : _ref$options,
        value = _ref.value,
        onValueChange = _ref.onValueChange,
        name = _ref.name,
        props = _objectWithoutProperties(_ref, ["options", "value", "onValueChange", "name"]);

    return /*#__PURE__*/React$2__default.createElement(View, null, /*#__PURE__*/React$2__default.createElement(index, _extends({
      inputProps: {
        'aria-label': {
          name: name
        }
      },
      noOptionsMessage: function noOptionsMessage() {
        return 'Sem opçōes';
      },
      styles: customStyles(),
      options: options,
      value: value,
      onChange: onValueChange
    }, props)));
  };

  var lib = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, '__esModule', {
    value: true
  });
  exports['default'] = autobind;

  function autobind() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (args.length === 1) {
      return boundClass.apply(undefined, args);
    } else {
      return boundMethod.apply(undefined, args);
    }
  }

  /**
   * Use boundMethod to bind all methods on the target.prototype
   */
  function boundClass(target) {
    // (Using reflect to get all keys including symbols)
    var keys = undefined;
    // Use Reflect if exists
    if (typeof Reflect !== 'undefined' && typeof Reflect.ownKeys === 'function') {
      keys = Reflect.ownKeys(target.prototype);
    } else {
      keys = Object.getOwnPropertyNames(target.prototype);
      // use symbols if support is provided
      if (typeof Object.getOwnPropertySymbols === 'function') {
        keys = keys.concat(Object.getOwnPropertySymbols(target.prototype));
      }
    }

    keys.forEach(function (key) {
      // Ignore special case target method
      if (key === 'constructor') {
        return;
      }

      var descriptor = Object.getOwnPropertyDescriptor(target.prototype, key);

      // Only methods need binding
      if (typeof descriptor.value === 'function') {
        Object.defineProperty(target.prototype, key, boundMethod(target, key, descriptor));
      }
    });
    return target;
  }

  /**
   * Return a descriptor removing the value and returning a getter
   * The getter will return a .bind version of the function
   * and memoize the result against a symbol on the instance
   */
  function boundMethod(target, key, descriptor) {
    var fn = descriptor.value;

    if (typeof fn !== 'function') {
      throw new Error('@autobind decorator can only be applied to methods not: ' + typeof fn);
    }

    // In IE11 calling Object.defineProperty has a side-effect of evaluating the
    // getter for the property which is being replaced. This causes infinite
    // recursion and an "Out of stack space" error.
    var definingProperty = false;

    return {
      configurable: true,
      get: function get() {
        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
          return fn;
        }

        var boundFn = fn.bind(this);
        definingProperty = true;
        Object.defineProperty(this, key, {
          value: boundFn,
          configurable: true,
          writable: true
        });
        definingProperty = false;
        return boundFn;
      }
    };
  }
  module.exports = exports['default'];
  });

  unwrapExports(lib);

  var captialize_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = captialize;
  /**
   * Captialize a string
   * @ignore
   * @param {string} string
   * @return {string}
   */
  function captialize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  module.exports = exports["default"];

  });

  unwrapExports(captialize_1);

  var clamp_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = clamp;
  /**
   * Clamp a value between a min and max value
   * @ignore
   * @param {number} value
   * @param {number} min
   * @param {number} max
   * @return {number}
   */
  function clamp(value, min, max) {
    return Math.min(Math.max(value, min), max);
  }
  module.exports = exports["default"];

  });

  unwrapExports(clamp_1);

  var distanceTo_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = distanceTo;
  /**
   * Calculate the distance between pointA and pointB
   * @ignore
   * @param {Point} pointA
   * @param {Point} pointB
   * @return {number} Distance
   */
  function distanceTo(pointA, pointB) {
    var xDiff = Math.pow(pointB.x - pointA.x, 2);
    var yDiff = Math.pow(pointB.y - pointA.y, 2);

    return Math.sqrt(xDiff + yDiff);
  }
  module.exports = exports["default"];

  });

  unwrapExports(distanceTo_1);

  var isDefined_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isDefined;
  /**
   * Check if a value is defined
   * @ignore
   * @param {*} value
   * @return {boolean}
   */
  function isDefined(value) {
    return value !== undefined && value !== null;
  }
  module.exports = exports["default"];

  });

  unwrapExports(isDefined_1);

  var isNumber_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = isNumber;
  /**
   * Check if a value is a number
   * @ignore
   * @param {*} value
   * @return {boolean}
   */
  function isNumber(value) {
    return typeof value === 'number';
  }
  module.exports = exports['default'];

  });

  unwrapExports(isNumber_1);

  var isObject_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

  exports.default = isObject;
  /**
   * Check if a value is an object
   * @ignore
   * @param {*} value
   * @return {boolean}
   */
  function isObject(value) {
    return value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object';
  }
  module.exports = exports['default'];

  });

  unwrapExports(isObject_1);

  var length_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = length;
  /**
   * Calculate the absolute difference between two numbers
   * @ignore
   * @param {number} numA
   * @param {number} numB
   * @return {number}
   */
  function length(numA, numB) {
    return Math.abs(numA - numB);
  }
  module.exports = exports["default"];

  });

  unwrapExports(length_1);

  var utils = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });



  Object.defineProperty(exports, 'captialize', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(captialize_1).default;
    }
  });



  Object.defineProperty(exports, 'clamp', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(clamp_1).default;
    }
  });



  Object.defineProperty(exports, 'distanceTo', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(distanceTo_1).default;
    }
  });



  Object.defineProperty(exports, 'isDefined', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(isDefined_1).default;
    }
  });



  Object.defineProperty(exports, 'isNumber', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(isNumber_1).default;
    }
  });



  Object.defineProperty(exports, 'isObject', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(isObject_1).default;
    }
  });



  Object.defineProperty(exports, 'length', {
    enumerable: true,
    get: function get() {
      return _interopRequireDefault(length_1).default;
    }
  });

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  });

  unwrapExports(utils);

  var valueTransformer = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  exports.getPercentageFromPosition = getPercentageFromPosition;
  exports.getValueFromPosition = getValueFromPosition;
  exports.getValueFromProps = getValueFromProps;
  exports.getPercentageFromValue = getPercentageFromValue;
  exports.getPercentagesFromValues = getPercentagesFromValues;
  exports.getPositionFromValue = getPositionFromValue;
  exports.getPositionsFromValues = getPositionsFromValues;
  exports.getPositionFromEvent = getPositionFromEvent;
  exports.getStepValueFromValue = getStepValueFromValue;



  /**
   * Convert a point into a percentage value
   * @ignore
   * @param {Point} position
   * @param {ClientRect} clientRect
   * @return {number} Percentage value
   */
  function getPercentageFromPosition(position, clientRect) {
    var length = clientRect.width;
    var sizePerc = position.x / length;

    return sizePerc || 0;
  }

  /**
   * Convert a point into a model value
   * @ignore
   * @param {Point} position
   * @param {number} minValue
   * @param {number} maxValue
   * @param {ClientRect} clientRect
   * @return {number}
   */
  function getValueFromPosition(position, minValue, maxValue, clientRect) {
    var sizePerc = getPercentageFromPosition(position, clientRect);
    var valueDiff = maxValue - minValue;

    return minValue + valueDiff * sizePerc;
  }

  /**
   * Convert props into a range value
   * @ignore
   * @param {Object} props
   * @param {boolean} isMultiValue
   * @return {Range}
   */
  function getValueFromProps(props, isMultiValue) {
    if (isMultiValue) {
      return _extends({}, props.value);
    }

    return {
      min: props.minValue,
      max: props.value
    };
  }

  /**
   * Convert a model value into a percentage value
   * @ignore
   * @param {number} value
   * @param {number} minValue
   * @param {number} maxValue
   * @return {number}
   */
  function getPercentageFromValue(value, minValue, maxValue) {
    var validValue = (0, utils.clamp)(value, minValue, maxValue);
    var valueDiff = maxValue - minValue;
    var valuePerc = (validValue - minValue) / valueDiff;

    return valuePerc || 0;
  }

  /**
   * Convert model values into percentage values
   * @ignore
   * @param {Range} values
   * @param {number} minValue
   * @param {number} maxValue
   * @return {Range}
   */
  function getPercentagesFromValues(values, minValue, maxValue) {
    return {
      min: getPercentageFromValue(values.min, minValue, maxValue),
      max: getPercentageFromValue(values.max, minValue, maxValue)
    };
  }

  /**
   * Convert a value into a point
   * @ignore
   * @param {number} value
   * @param {number} minValue
   * @param {number} maxValue
   * @param {ClientRect} clientRect
   * @return {Point} Position
   */
  function getPositionFromValue(value, minValue, maxValue, clientRect) {
    var length = clientRect.width;
    var valuePerc = getPercentageFromValue(value, minValue, maxValue);
    var positionValue = valuePerc * length;

    return {
      x: positionValue,
      y: 0
    };
  }

  /**
   * Convert a range of values into points
   * @ignore
   * @param {Range} values
   * @param {number} minValue
   * @param {number} maxValue
   * @param {ClientRect} clientRect
   * @return {Range}
   */
  function getPositionsFromValues(values, minValue, maxValue, clientRect) {
    return {
      min: getPositionFromValue(values.min, minValue, maxValue, clientRect),
      max: getPositionFromValue(values.max, minValue, maxValue, clientRect)
    };
  }

  /**
   * Convert an event into a point
   * @ignore
   * @param {Event} event
   * @param {ClientRect} clientRect
   * @return {Point}
   */
  function getPositionFromEvent(event, clientRect) {
    var length = clientRect.width;

    var _ref = event.touches ? event.touches[0] : event,
        clientX = _ref.clientX;

    return {
      x: (0, utils.clamp)(clientX - clientRect.left, 0, length),
      y: 0
    };
  }

  /**
   * Convert a value into a step value
   * @ignore
   * @param {number} value
   * @param {number} valuePerStep
   * @return {number}
   */
  function getStepValueFromValue(value, valuePerStep) {
    return Math.round(value / valuePerStep) * valuePerStep;
  }

  });

  unwrapExports(valueTransformer);
  var valueTransformer_1 = valueTransformer.getPercentageFromPosition;
  var valueTransformer_2 = valueTransformer.getValueFromPosition;
  var valueTransformer_3 = valueTransformer.getValueFromProps;
  var valueTransformer_4 = valueTransformer.getPercentageFromValue;
  var valueTransformer_5 = valueTransformer.getPercentagesFromValues;
  var valueTransformer_6 = valueTransformer.getPositionFromValue;
  var valueTransformer_7 = valueTransformer.getPositionsFromValues;
  var valueTransformer_8 = valueTransformer.getPositionFromEvent;
  var valueTransformer_9 = valueTransformer.getStepValueFromValue;

  var defaultClassNames = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /**
   * Default CSS class names
   * @ignore
   * @type {InputRangeClassNames}
   */
  var DEFAULT_CLASS_NAMES = {
    activeTrack: 'input-range__track input-range__track--active',
    disabledInputRange: 'input-range input-range--disabled',
    inputRange: 'input-range',
    labelContainer: 'input-range__label-container',
    maxLabel: 'input-range__label input-range__label--max',
    minLabel: 'input-range__label input-range__label--min',
    slider: 'input-range__slider',
    sliderContainer: 'input-range__slider-container',
    track: 'input-range__track input-range__track--background',
    valueLabel: 'input-range__label input-range__label--value'
  };

  exports.default = DEFAULT_CLASS_NAMES;
  module.exports = exports['default'];

  });

  unwrapExports(defaultClassNames);

  var label = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = Label;



  var _react2 = _interopRequireDefault(React$2__default);



  var _propTypes2 = _interopRequireDefault(propTypes);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  /**
   * @ignore
   * @param {Object} props
   * @param {InputRangeClassNames} props.classNames
   * @param {Function} props.formatLabel
   * @param {string} props.type
   */
  function Label(props) {
    var labelValue = props.formatLabel ? props.formatLabel(props.children, props.type) : props.children;

    return _react2.default.createElement(
      'span',
      { className: props.classNames[props.type + 'Label'] },
      _react2.default.createElement(
        'span',
        { className: props.classNames.labelContainer },
        labelValue
      )
    );
  }

  /**
   * @type {Object}
   * @property {Function} children
   * @property {Function} classNames
   * @property {Function} formatLabel
   * @property {Function} type
   */
  Label.propTypes = {
    children: _propTypes2.default.node.isRequired,
    classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
    formatLabel: _propTypes2.default.func,
    type: _propTypes2.default.string.isRequired
  };
  module.exports = exports['default'];

  });

  unwrapExports(label);

  var rangePropType_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = rangePropType;



  /**
   * @ignore
   * @param {Object} props - React component props
   * @return {?Error} Return Error if validation fails
   */
  function rangePropType(props) {
    var maxValue = props.maxValue,
        minValue = props.minValue;


    if (!(0, utils.isNumber)(minValue) || !(0, utils.isNumber)(maxValue)) {
      return new Error('"minValue" and "maxValue" must be a number');
    }

    if (minValue >= maxValue) {
      return new Error('"minValue" must be smaller than "maxValue"');
    }
  }
  module.exports = exports['default'];

  });

  unwrapExports(rangePropType_1);

  var valuePropType_1 = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = valuePropType;



  /**
   * @ignore
   * @param {Object} props
   * @return {?Error} Return Error if validation fails
   */
  function valuePropType(props, propName) {
    var maxValue = props.maxValue,
        minValue = props.minValue;

    var value = props[propName];

    if (!(0, utils.isNumber)(value) && (!(0, utils.isObject)(value) || !(0, utils.isNumber)(value.min) || !(0, utils.isNumber)(value.max))) {
      return new Error('"' + propName + '" must be a number or a range object');
    }

    if ((0, utils.isNumber)(value) && (value < minValue || value > maxValue)) {
      return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
    }

    if ((0, utils.isObject)(value) && (value.min < minValue || value.min > maxValue || value.max < minValue || value.max > maxValue)) {
      return new Error('"' + propName + '" must be in between "minValue" and "maxValue"');
    }
  }
  module.exports = exports['default'];

  });

  unwrapExports(valuePropType_1);

  var slider = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _class;



  var _react2 = _interopRequireDefault(React$2__default);



  var _propTypes2 = _interopRequireDefault(propTypes);



  var _autobindDecorator2 = _interopRequireDefault(lib);



  var _label2 = _interopRequireDefault(label);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  /**
   * @ignore
   */
  var Slider = (_class = function (_React$Component) {
    _inherits(Slider, _React$Component);

    _createClass(Slider, null, [{
      key: 'propTypes',

      /**
       * Accepted propTypes of Slider
       * @override
       * @return {Object}
       * @property {Function} ariaLabelledby
       * @property {Function} ariaControls
       * @property {Function} className
       * @property {Function} formatLabel
       * @property {Function} maxValue
       * @property {Function} minValue
       * @property {Function} onSliderDrag
       * @property {Function} onSliderKeyDown
       * @property {Function} percentage
       * @property {Function} type
       * @property {Function} value
       */
      get: function get() {
        return {
          ariaLabelledby: _propTypes2.default.string,
          ariaControls: _propTypes2.default.string,
          classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
          formatLabel: _propTypes2.default.func,
          maxValue: _propTypes2.default.number,
          minValue: _propTypes2.default.number,
          onSliderDrag: _propTypes2.default.func.isRequired,
          onSliderKeyDown: _propTypes2.default.func.isRequired,
          percentage: _propTypes2.default.number.isRequired,
          type: _propTypes2.default.string.isRequired,
          value: _propTypes2.default.number.isRequired
        };
      }

      /**
       * @param {Object} props
       * @param {string} [props.ariaLabelledby]
       * @param {string} [props.ariaControls]
       * @param {InputRangeClassNames} props.classNames
       * @param {Function} [props.formatLabel]
       * @param {number} [props.maxValue]
       * @param {number} [props.minValue]
       * @param {Function} props.onSliderKeyDown
       * @param {Function} props.onSliderDrag
       * @param {number} props.percentage
       * @param {number} props.type
       * @param {number} props.value
       */

    }]);

    function Slider(props) {
      _classCallCheck(this, Slider);

      /**
       * @private
       * @type {?Component}
       */
      var _this = _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));

      _this.node = null;
      return _this;
    }

    /**
     * @ignore
     * @override
     * @return {void}
     */


    _createClass(Slider, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.removeDocumentMouseMoveListener();
        this.removeDocumentMouseUpListener();
        this.removeDocumentTouchEndListener();
        this.removeDocumentTouchMoveListener();
      }

      /**
       * @private
       * @return {Object}
       */

    }, {
      key: 'getStyle',
      value: function getStyle() {
        var perc = (this.props.percentage || 0) * 100;
        var style = {
          position: 'absolute',
          left: perc + '%'
        };

        return style;
      }

      /**
       * Listen to mousemove event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentMouseMoveListener',
      value: function addDocumentMouseMoveListener() {
        this.removeDocumentMouseMoveListener();
        this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
      }

      /**
       * Listen to mouseup event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentMouseUpListener',
      value: function addDocumentMouseUpListener() {
        this.removeDocumentMouseUpListener();
        this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
      }

      /**
       * Listen to touchmove event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentTouchMoveListener',
      value: function addDocumentTouchMoveListener() {
        this.removeDocumentTouchMoveListener();
        this.node.ownerDocument.addEventListener('touchmove', this.handleTouchMove);
      }

      /**
       * Listen to touchend event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentTouchEndListener',
      value: function addDocumentTouchEndListener() {
        this.removeDocumentTouchEndListener();
        this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentMouseMoveListener',
      value: function removeDocumentMouseMoveListener() {
        this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentMouseUpListener',
      value: function removeDocumentMouseUpListener() {
        this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentTouchMoveListener',
      value: function removeDocumentTouchMoveListener() {
        this.node.ownerDocument.removeEventListener('touchmove', this.handleTouchMove);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentTouchEndListener',
      value: function removeDocumentTouchEndListener() {
        this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'handleMouseDown',
      value: function handleMouseDown() {
        this.addDocumentMouseMoveListener();
        this.addDocumentMouseUpListener();
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'handleMouseUp',
      value: function handleMouseUp() {
        this.removeDocumentMouseMoveListener();
        this.removeDocumentMouseUpListener();
      }

      /**
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleMouseMove',
      value: function handleMouseMove(event) {
        this.props.onSliderDrag(event, this.props.type);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'handleTouchStart',
      value: function handleTouchStart() {
        this.addDocumentTouchEndListener();
        this.addDocumentTouchMoveListener();
      }

      /**
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleTouchMove',
      value: function handleTouchMove(event) {
        this.props.onSliderDrag(event, this.props.type);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'handleTouchEnd',
      value: function handleTouchEnd() {
        this.removeDocumentTouchMoveListener();
        this.removeDocumentTouchEndListener();
      }

      /**
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(event) {
        this.props.onSliderKeyDown(event, this.props.type);
      }

      /**
       * @override
       * @return {JSX.Element}
       */

    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var style = this.getStyle();

        return _react2.default.createElement(
          'span',
          {
            className: this.props.classNames.sliderContainer,
            ref: function ref(node) {
              _this2.node = node;
            },
            style: style },
          _react2.default.createElement(
            _label2.default,
            {
              classNames: this.props.classNames,
              formatLabel: this.props.formatLabel,
              type: 'value' },
            this.props.value
          ),
          _react2.default.createElement('div', {
            'aria-labelledby': this.props.ariaLabelledby,
            'aria-controls': this.props.ariaControls,
            'aria-valuemax': this.props.maxValue,
            'aria-valuemin': this.props.minValue,
            'aria-valuenow': this.props.value,
            className: this.props.classNames.slider,
            draggable: 'false',
            onKeyDown: this.handleKeyDown,
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleTouchStart,
            role: 'slider',
            tabIndex: '0' })
        );
      }
    }]);

    return Slider;
  }(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype)), _class);
  exports.default = Slider;
  module.exports = exports['default'];

  });

  unwrapExports(slider);

  var track = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _class;



  var _react2 = _interopRequireDefault(React$2__default);



  var _propTypes2 = _interopRequireDefault(propTypes);



  var _autobindDecorator2 = _interopRequireDefault(lib);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  /**
   * @ignore
   */
  var Track = (_class = function (_React$Component) {
    _inherits(Track, _React$Component);

    _createClass(Track, null, [{
      key: 'propTypes',

      /**
       * @override
       * @return {Object}
       * @property {Function} children
       * @property {Function} classNames
       * @property {Boolean} draggableTrack
       * @property {Function} onTrackDrag
       * @property {Function} onTrackMouseDown
       * @property {Function} percentages
       */
      get: function get() {
        return {
          children: _propTypes2.default.node.isRequired,
          classNames: _propTypes2.default.objectOf(_propTypes2.default.string).isRequired,
          draggableTrack: _propTypes2.default.bool,
          onTrackDrag: _propTypes2.default.func,
          onTrackMouseDown: _propTypes2.default.func.isRequired,
          percentages: _propTypes2.default.objectOf(_propTypes2.default.number).isRequired
        };
      }

      /**
       * @param {Object} props
       * @param {InputRangeClassNames} props.classNames
       * @param {Boolean} props.draggableTrack
       * @param {Function} props.onTrackDrag
       * @param {Function} props.onTrackMouseDown
       * @param {number} props.percentages
       */

    }]);

    function Track(props) {
      _classCallCheck(this, Track);

      /**
       * @private
       * @type {?Component}
       */
      var _this = _possibleConstructorReturn(this, (Track.__proto__ || Object.getPrototypeOf(Track)).call(this, props));

      _this.node = null;
      _this.trackDragEvent = null;
      return _this;
    }

    /**
     * @private
     * @return {ClientRect}
     */


    _createClass(Track, [{
      key: 'getClientRect',
      value: function getClientRect() {
        return this.node.getBoundingClientRect();
      }

      /**
       * @private
       * @return {Object} CSS styles
       */

    }, {
      key: 'getActiveTrackStyle',
      value: function getActiveTrackStyle() {
        var width = (this.props.percentages.max - this.props.percentages.min) * 100 + '%';
        var left = this.props.percentages.min * 100 + '%';

        return { left: left, width: width };
      }

      /**
       * Listen to mousemove event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentMouseMoveListener',
      value: function addDocumentMouseMoveListener() {
        this.removeDocumentMouseMoveListener();
        this.node.ownerDocument.addEventListener('mousemove', this.handleMouseMove);
      }

      /**
       * Listen to mouseup event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentMouseUpListener',
      value: function addDocumentMouseUpListener() {
        this.removeDocumentMouseUpListener();
        this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentMouseMoveListener',
      value: function removeDocumentMouseMoveListener() {
        this.node.ownerDocument.removeEventListener('mousemove', this.handleMouseMove);
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentMouseUpListener',
      value: function removeDocumentMouseUpListener() {
        this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
      }

      /**
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleMouseMove',
      value: function handleMouseMove(event) {
        if (!this.props.draggableTrack) {
          return;
        }

        if (this.trackDragEvent !== null) {
          this.props.onTrackDrag(event, this.trackDragEvent);
        }

        this.trackDragEvent = event;
      }

      /**
       * @private
       * @return {void}
       */

    }, {
      key: 'handleMouseUp',
      value: function handleMouseUp() {
        if (!this.props.draggableTrack) {
          return;
        }

        this.removeDocumentMouseMoveListener();
        this.removeDocumentMouseUpListener();
        this.trackDragEvent = null;
      }

      /**
       * @private
       * @param {SyntheticEvent} event - User event
       */

    }, {
      key: 'handleMouseDown',
      value: function handleMouseDown(event) {
        var clientX = event.touches ? event.touches[0].clientX : event.clientX;
        var trackClientRect = this.getClientRect();
        var position = {
          x: clientX - trackClientRect.left,
          y: 0
        };

        this.props.onTrackMouseDown(event, position);

        if (this.props.draggableTrack) {
          this.addDocumentMouseMoveListener();
          this.addDocumentMouseUpListener();
        }
      }

      /**
       * @private
       * @param {SyntheticEvent} event - User event
       */

    }, {
      key: 'handleTouchStart',
      value: function handleTouchStart(event) {
        event.preventDefault();

        this.handleMouseDown(event);
      }

      /**
       * @override
       * @return {JSX.Element}
       */

    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        var activeTrackStyle = this.getActiveTrackStyle();

        return _react2.default.createElement(
          'div',
          {
            className: this.props.classNames.track,
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleTouchStart,
            ref: function ref(node) {
              _this2.node = node;
            } },
          _react2.default.createElement('div', {
            style: activeTrackStyle,
            className: this.props.classNames.activeTrack }),
          this.props.children
        );
      }
    }]);

    return Track;
  }(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleMouseMove', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseMove'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype)), _class);
  exports.default = Track;
  module.exports = exports['default'];

  });

  unwrapExports(track);

  var keyCodes = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  /** @ignore */
  var DOWN_ARROW = exports.DOWN_ARROW = 40;

  /** @ignore */
  var LEFT_ARROW = exports.LEFT_ARROW = 37;

  /** @ignore */
  var RIGHT_ARROW = exports.RIGHT_ARROW = 39;

  /** @ignore */
  var UP_ARROW = exports.UP_ARROW = 38;

  });

  unwrapExports(keyCodes);
  var keyCodes_1 = keyCodes.DOWN_ARROW;
  var keyCodes_2 = keyCodes.LEFT_ARROW;
  var keyCodes_3 = keyCodes.RIGHT_ARROW;
  var keyCodes_4 = keyCodes.UP_ARROW;

  var inputRange = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = undefined;

  var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

  var _class;



  var _react2 = _interopRequireDefault(React$2__default);



  var _propTypes2 = _interopRequireDefault(propTypes);



  var _autobindDecorator2 = _interopRequireDefault(lib);



  var valueTransformer$1 = _interopRequireWildcard(valueTransformer);



  var _defaultClassNames2 = _interopRequireDefault(defaultClassNames);



  var _label2 = _interopRequireDefault(label);



  var _rangePropType2 = _interopRequireDefault(rangePropType_1);



  var _valuePropType2 = _interopRequireDefault(valuePropType_1);



  var _slider2 = _interopRequireDefault(slider);



  var _track2 = _interopRequireDefault(track);





  function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

  function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

  function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object['ke' + 'ys'](descriptor).forEach(function (key) {
      desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;

    if ('value' in desc || desc.initializer) {
      desc.writable = true;
    }

    desc = decorators.slice().reverse().reduce(function (desc, decorator) {
      return decorator(target, property, desc) || desc;
    }, desc);

    if (context && desc.initializer !== void 0) {
      desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
      desc.initializer = undefined;
    }

    if (desc.initializer === void 0) {
      Object['define' + 'Property'](target, property, desc);
      desc = null;
    }

    return desc;
  }

  /**
   * A React component that allows users to input numeric values within a range
   * by dragging its sliders.
   */
  var InputRange = (_class = function (_React$Component) {
    _inherits(InputRange, _React$Component);

    _createClass(InputRange, null, [{
      key: 'propTypes',

      /**
       * @ignore
       * @override
       * @return {Object}
       */
      get: function get() {
        return {
          allowSameValues: _propTypes2.default.bool,
          ariaLabelledby: _propTypes2.default.string,
          ariaControls: _propTypes2.default.string,
          classNames: _propTypes2.default.objectOf(_propTypes2.default.string),
          disabled: _propTypes2.default.bool,
          draggableTrack: _propTypes2.default.bool,
          formatLabel: _propTypes2.default.func,
          maxValue: _rangePropType2.default,
          minValue: _rangePropType2.default,
          name: _propTypes2.default.string,
          onChangeStart: _propTypes2.default.func,
          onChange: _propTypes2.default.func.isRequired,
          onChangeComplete: _propTypes2.default.func,
          step: _propTypes2.default.number,
          value: _valuePropType2.default
        };
      }

      /**
       * @ignore
       * @override
       * @return {Object}
       */

    }, {
      key: 'defaultProps',
      get: function get() {
        return {
          allowSameValues: false,
          classNames: _defaultClassNames2.default,
          disabled: false,
          maxValue: 10,
          minValue: 0,
          step: 1
        };
      }

      /**
       * @param {Object} props
       * @param {boolean} [props.allowSameValues]
       * @param {string} [props.ariaLabelledby]
       * @param {string} [props.ariaControls]
       * @param {InputRangeClassNames} [props.classNames]
       * @param {boolean} [props.disabled = false]
       * @param {Function} [props.formatLabel]
       * @param {number|Range} [props.maxValue = 10]
       * @param {number|Range} [props.minValue = 0]
       * @param {string} [props.name]
       * @param {string} props.onChange
       * @param {Function} [props.onChangeComplete]
       * @param {Function} [props.onChangeStart]
       * @param {number} [props.step = 1]
       * @param {number|Range} props.value
       */

    }]);

    function InputRange(props) {
      _classCallCheck(this, InputRange);

      /**
       * @private
       * @type {?number}
       */
      var _this = _possibleConstructorReturn(this, (InputRange.__proto__ || Object.getPrototypeOf(InputRange)).call(this, props));

      _this.startValue = null;

      /**
       * @private
       * @type {?Component}
       */
      _this.node = null;

      /**
       * @private
       * @type {?Component}
       */
      _this.trackNode = null;

      /**
       * @private
       * @type {bool}
       */
      _this.isSliderDragging = false;

      /**
       * @private
       * @type {?string}
       */
      _this.lastKeyMoved = null;
      return _this;
    }

    /**
     * @ignore
     * @override
     * @return {void}
     */


    _createClass(InputRange, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.removeDocumentMouseUpListener();
        this.removeDocumentTouchEndListener();
      }

      /**
       * Return the CSS class name of the component
       * @private
       * @return {string}
       */

    }, {
      key: 'getComponentClassName',
      value: function getComponentClassName() {
        if (!this.props.disabled) {
          return this.props.classNames.inputRange;
        }

        return this.props.classNames.disabledInputRange;
      }

      /**
       * Return the bounding rect of the track
       * @private
       * @return {ClientRect}
       */

    }, {
      key: 'getTrackClientRect',
      value: function getTrackClientRect() {
        return this.trackNode.getClientRect();
      }

      /**
       * Return the slider key closest to a point
       * @private
       * @param {Point} position
       * @return {string}
       */

    }, {
      key: 'getKeyByPosition',
      value: function getKeyByPosition(position) {
        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
        var positions = valueTransformer$1.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

        if (this.isMultiValue()) {
          var distanceToMin = (0, utils.distanceTo)(position, positions.min);
          var distanceToMax = (0, utils.distanceTo)(position, positions.max);

          if (distanceToMin < distanceToMax) {
            return 'min';
          }
        }

        return 'max';
      }

      /**
       * Return all the slider keys
       * @private
       * @return {string[]}
       */

    }, {
      key: 'getKeys',
      value: function getKeys() {
        if (this.isMultiValue()) {
          return ['min', 'max'];
        }

        return ['max'];
      }

      /**
       * Return true if the difference between the new and the current value is
       * greater or equal to the step amount of the component
       * @private
       * @param {Range} values
       * @return {boolean}
       */

    }, {
      key: 'hasStepDifference',
      value: function hasStepDifference(values) {
        var currentValues = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());

        return (0, utils.length)(values.min, currentValues.min) >= this.props.step || (0, utils.length)(values.max, currentValues.max) >= this.props.step;
      }

      /**
       * Return true if the component accepts a min and max value
       * @private
       * @return {boolean}
       */

    }, {
      key: 'isMultiValue',
      value: function isMultiValue() {
        return (0, utils.isObject)(this.props.value);
      }

      /**
       * Return true if the range is within the max and min value of the component
       * @private
       * @param {Range} values
       * @return {boolean}
       */

    }, {
      key: 'isWithinRange',
      value: function isWithinRange(values) {
        if (this.isMultiValue()) {
          return values.min >= this.props.minValue && values.max <= this.props.maxValue && this.props.allowSameValues ? values.min <= values.max : values.min < values.max;
        }

        return values.max >= this.props.minValue && values.max <= this.props.maxValue;
      }

      /**
       * Return true if the new value should trigger a render
       * @private
       * @param {Range} values
       * @return {boolean}
       */

    }, {
      key: 'shouldUpdate',
      value: function shouldUpdate(values) {
        return this.isWithinRange(values) && this.hasStepDifference(values);
      }

      /**
       * Update the position of a slider
       * @private
       * @param {string} key
       * @param {Point} position
       * @return {void}
       */

    }, {
      key: 'updatePosition',
      value: function updatePosition(key, position) {
        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
        var positions = valueTransformer$1.getPositionsFromValues(values, this.props.minValue, this.props.maxValue, this.getTrackClientRect());

        positions[key] = position;
        this.lastKeyMoved = key;

        this.updatePositions(positions);
      }

      /**
       * Update the positions of multiple sliders
       * @private
       * @param {Object} positions
       * @param {Point} positions.min
       * @param {Point} positions.max
       * @return {void}
       */

    }, {
      key: 'updatePositions',
      value: function updatePositions(positions) {
        var values = {
          min: valueTransformer$1.getValueFromPosition(positions.min, this.props.minValue, this.props.maxValue, this.getTrackClientRect()),
          max: valueTransformer$1.getValueFromPosition(positions.max, this.props.minValue, this.props.maxValue, this.getTrackClientRect())
        };

        var transformedValues = {
          min: valueTransformer$1.getStepValueFromValue(values.min, this.props.step),
          max: valueTransformer$1.getStepValueFromValue(values.max, this.props.step)
        };

        this.updateValues(transformedValues);
      }

      /**
       * Update the value of a slider
       * @private
       * @param {string} key
       * @param {number} value
       * @return {void}
       */

    }, {
      key: 'updateValue',
      value: function updateValue(key, value) {
        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());

        values[key] = value;

        this.updateValues(values);
      }

      /**
       * Update the values of multiple sliders
       * @private
       * @param {Range|number} values
       * @return {void}
       */

    }, {
      key: 'updateValues',
      value: function updateValues(values) {
        if (!this.shouldUpdate(values)) {
          return;
        }

        this.props.onChange(this.isMultiValue() ? values : values.max);
      }

      /**
       * Increment the value of a slider by key name
       * @private
       * @param {string} key
       * @return {void}
       */

    }, {
      key: 'incrementValue',
      value: function incrementValue(key) {
        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
        var value = values[key] + this.props.step;

        this.updateValue(key, value);
      }

      /**
       * Decrement the value of a slider by key name
       * @private
       * @param {string} key
       * @return {void}
       */

    }, {
      key: 'decrementValue',
      value: function decrementValue(key) {
        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
        var value = values[key] - this.props.step;

        this.updateValue(key, value);
      }

      /**
       * Listen to mouseup event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentMouseUpListener',
      value: function addDocumentMouseUpListener() {
        this.removeDocumentMouseUpListener();
        this.node.ownerDocument.addEventListener('mouseup', this.handleMouseUp);
      }

      /**
       * Listen to touchend event
       * @private
       * @return {void}
       */

    }, {
      key: 'addDocumentTouchEndListener',
      value: function addDocumentTouchEndListener() {
        this.removeDocumentTouchEndListener();
        this.node.ownerDocument.addEventListener('touchend', this.handleTouchEnd);
      }

      /**
       * Stop listening to mouseup event
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentMouseUpListener',
      value: function removeDocumentMouseUpListener() {
        this.node.ownerDocument.removeEventListener('mouseup', this.handleMouseUp);
      }

      /**
       * Stop listening to touchend event
       * @private
       * @return {void}
       */

    }, {
      key: 'removeDocumentTouchEndListener',
      value: function removeDocumentTouchEndListener() {
        this.node.ownerDocument.removeEventListener('touchend', this.handleTouchEnd);
      }

      /**
       * Handle any "mousemove" event received by the slider
       * @private
       * @param {SyntheticEvent} event
       * @param {string} key
       * @return {void}
       */

    }, {
      key: 'handleSliderDrag',
      value: function handleSliderDrag(event, key) {
        var _this2 = this;

        if (this.props.disabled) {
          return;
        }

        var position = valueTransformer$1.getPositionFromEvent(event, this.getTrackClientRect());
        this.isSliderDragging = true;
        requestAnimationFrame(function () {
          return _this2.updatePosition(key, position);
        });
      }

      /**
       * Handle any "mousemove" event received by the track
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleTrackDrag',
      value: function handleTrackDrag(event, prevEvent) {
        if (this.props.disabled || !this.props.draggableTrack || this.isSliderDragging) {
          return;
        }

        var _props = this.props,
            maxValue = _props.maxValue,
            minValue = _props.minValue,
            _props$value = _props.value,
            max = _props$value.max,
            min = _props$value.min;


        var position = valueTransformer$1.getPositionFromEvent(event, this.getTrackClientRect());
        var value = valueTransformer$1.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
        var stepValue = valueTransformer$1.getStepValueFromValue(value, this.props.step);

        var prevPosition = valueTransformer$1.getPositionFromEvent(prevEvent, this.getTrackClientRect());
        var prevValue = valueTransformer$1.getValueFromPosition(prevPosition, minValue, maxValue, this.getTrackClientRect());
        var prevStepValue = valueTransformer$1.getStepValueFromValue(prevValue, this.props.step);

        var offset = prevStepValue - stepValue;

        var transformedValues = {
          min: min - offset,
          max: max - offset
        };

        this.updateValues(transformedValues);
      }

      /**
       * Handle any "keydown" event received by the slider
       * @private
       * @param {SyntheticEvent} event
       * @param {string} key
       * @return {void}
       */

    }, {
      key: 'handleSliderKeyDown',
      value: function handleSliderKeyDown(event, key) {
        if (this.props.disabled) {
          return;
        }

        switch (event.keyCode) {
          case keyCodes.LEFT_ARROW:
          case keyCodes.DOWN_ARROW:
            event.preventDefault();
            this.decrementValue(key);
            break;

          case keyCodes.RIGHT_ARROW:
          case keyCodes.UP_ARROW:
            event.preventDefault();
            this.incrementValue(key);
            break;
        }
      }

      /**
       * Handle any "mousedown" event received by the track
       * @private
       * @param {SyntheticEvent} event
       * @param {Point} position
       * @return {void}
       */

    }, {
      key: 'handleTrackMouseDown',
      value: function handleTrackMouseDown(event, position) {
        if (this.props.disabled) {
          return;
        }

        var _props2 = this.props,
            maxValue = _props2.maxValue,
            minValue = _props2.minValue,
            _props2$value = _props2.value,
            max = _props2$value.max,
            min = _props2$value.min;


        event.preventDefault();

        var value = valueTransformer$1.getValueFromPosition(position, minValue, maxValue, this.getTrackClientRect());
        var stepValue = valueTransformer$1.getStepValueFromValue(value, this.props.step);

        if (!this.props.draggableTrack || stepValue > max || stepValue < min) {
          this.updatePosition(this.getKeyByPosition(position), position);
        }
      }

      /**
       * Handle the start of any mouse/touch event
       * @private
       * @return {void}
       */

    }, {
      key: 'handleInteractionStart',
      value: function handleInteractionStart() {
        if (this.props.onChangeStart) {
          this.props.onChangeStart(this.props.value);
        }

        if (this.props.onChangeComplete && !(0, utils.isDefined)(this.startValue)) {
          this.startValue = this.props.value;
        }
      }

      /**
       * Handle the end of any mouse/touch event
       * @private
       * @return {void}
       */

    }, {
      key: 'handleInteractionEnd',
      value: function handleInteractionEnd() {
        if (this.isSliderDragging) {
          this.isSliderDragging = false;
        }

        if (!this.props.onChangeComplete || !(0, utils.isDefined)(this.startValue)) {
          return;
        }

        if (this.startValue !== this.props.value) {
          this.props.onChangeComplete(this.props.value);
        }

        this.startValue = null;
      }

      /**
       * Handle any "keydown" event received by the component
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleKeyDown',
      value: function handleKeyDown(event) {
        this.handleInteractionStart(event);
      }

      /**
       * Handle any "keyup" event received by the component
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleKeyUp',
      value: function handleKeyUp(event) {
        this.handleInteractionEnd(event);
      }

      /**
       * Handle any "mousedown" event received by the component
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleMouseDown',
      value: function handleMouseDown(event) {
        this.handleInteractionStart(event);
        this.addDocumentMouseUpListener();
      }

      /**
       * Handle any "mouseup" event received by the component
       * @private
       * @param {SyntheticEvent} event
       */

    }, {
      key: 'handleMouseUp',
      value: function handleMouseUp(event) {
        this.handleInteractionEnd(event);
        this.removeDocumentMouseUpListener();
      }

      /**
       * Handle any "touchstart" event received by the component
       * @private
       * @param {SyntheticEvent} event
       * @return {void}
       */

    }, {
      key: 'handleTouchStart',
      value: function handleTouchStart(event) {
        this.handleInteractionStart(event);
        this.addDocumentTouchEndListener();
      }

      /**
       * Handle any "touchend" event received by the component
       * @private
       * @param {SyntheticEvent} event
       */

    }, {
      key: 'handleTouchEnd',
      value: function handleTouchEnd(event) {
        this.handleInteractionEnd(event);
        this.removeDocumentTouchEndListener();
      }

      /**
       * Return JSX of sliders
       * @private
       * @return {JSX.Element}
       */

    }, {
      key: 'renderSliders',
      value: function renderSliders() {
        var _this3 = this;

        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
        var percentages = valueTransformer$1.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);
        var keys = this.props.allowSameValues && this.lastKeyMoved === 'min' ? this.getKeys().reverse() : this.getKeys();

        return keys.map(function (key) {
          var value = values[key];
          var percentage = percentages[key];

          var _props3 = _this3.props,
              maxValue = _props3.maxValue,
              minValue = _props3.minValue;


          if (key === 'min') {
            maxValue = values.max;
          } else {
            minValue = values.min;
          }

          var slider = _react2.default.createElement(_slider2.default, {
            ariaLabelledby: _this3.props.ariaLabelledby,
            ariaControls: _this3.props.ariaControls,
            classNames: _this3.props.classNames,
            formatLabel: _this3.props.formatLabel,
            key: key,
            maxValue: maxValue,
            minValue: minValue,
            onSliderDrag: _this3.handleSliderDrag,
            onSliderKeyDown: _this3.handleSliderKeyDown,
            percentage: percentage,
            type: key,
            value: value });

          return slider;
        });
      }

      /**
       * Return JSX of hidden inputs
       * @private
       * @return {JSX.Element}
       */

    }, {
      key: 'renderHiddenInputs',
      value: function renderHiddenInputs() {
        var _this4 = this;

        if (!this.props.name) {
          return [];
        }

        var isMultiValue = this.isMultiValue();
        var values = valueTransformer$1.getValueFromProps(this.props, isMultiValue);

        return this.getKeys().map(function (key) {
          var value = values[key];
          var name = isMultiValue ? '' + _this4.props.name + (0, utils.captialize)(key) : _this4.props.name;

          return _react2.default.createElement('input', { key: key, type: 'hidden', name: name, value: value });
        });
      }

      /**
       * @ignore
       * @override
       * @return {JSX.Element}
       */

    }, {
      key: 'render',
      value: function render() {
        var _this5 = this;

        var componentClassName = this.getComponentClassName();
        var values = valueTransformer$1.getValueFromProps(this.props, this.isMultiValue());
        var percentages = valueTransformer$1.getPercentagesFromValues(values, this.props.minValue, this.props.maxValue);

        return _react2.default.createElement(
          'div',
          {
            'aria-disabled': this.props.disabled,
            ref: function ref(node) {
              _this5.node = node;
            },
            className: componentClassName,
            onKeyDown: this.handleKeyDown,
            onKeyUp: this.handleKeyUp,
            onMouseDown: this.handleMouseDown,
            onTouchStart: this.handleTouchStart },
          _react2.default.createElement(
            _label2.default,
            {
              classNames: this.props.classNames,
              formatLabel: this.props.formatLabel,
              type: 'min' },
            this.props.minValue
          ),
          _react2.default.createElement(
            _track2.default,
            {
              classNames: this.props.classNames,
              draggableTrack: this.props.draggableTrack,
              ref: function ref(trackNode) {
                _this5.trackNode = trackNode;
              },
              percentages: percentages,
              onTrackDrag: this.handleTrackDrag,
              onTrackMouseDown: this.handleTrackMouseDown },
            this.renderSliders()
          ),
          _react2.default.createElement(
            _label2.default,
            {
              classNames: this.props.classNames,
              formatLabel: this.props.formatLabel,
              type: 'max' },
            this.props.maxValue
          ),
          this.renderHiddenInputs()
        );
      }
    }]);

    return InputRange;
  }(_react2.default.Component), (_applyDecoratedDescriptor(_class.prototype, 'handleSliderDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackDrag', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackDrag'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleSliderKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleSliderKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTrackMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTrackMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleInteractionEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleInteractionEnd'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleKeyUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleKeyUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseDown'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleMouseUp', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleMouseUp'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchStart', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchStart'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'handleTouchEnd', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'handleTouchEnd'), _class.prototype)), _class);
  exports.default = InputRange;
  module.exports = exports['default'];

  });

  unwrapExports(inputRange);

  var js = createCommonjsModule(function (module, exports) {

  Object.defineProperty(exports, "__esModule", {
    value: true
  });



  var _inputRange2 = _interopRequireDefault(inputRange);

  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

  /**
   * @ignore
   * @typedef {Object} ClientRect
   * @property {number} height
   * @property {number} left
   * @property {number} top
   * @property {number} width
   */

  /**
   * @typedef {Object} InputRangeClassNames
   * @property {string} activeTrack
   * @property {string} disabledInputRange
   * @property {string} inputRange
   * @property {string} labelContainer
   * @property {string} maxLabel
   * @property {string} minLabel
   * @property {string} slider
   * @property {string} sliderContainer
   * @property {string} track
   * @property {string} valueLabel
   */

  /**
   * @typedef {Function} LabelFormatter
   * @param {number} value
   * @param {string} type
   * @return {string}
   */

  /**
   * @ignore
   * @typedef {Object} Point
   * @property {number} x
   * @property {number} y
   */

  /**
   * @typedef {Object} Range
   * @property {number} min - Min value
   * @property {number} max - Max value
   */

  exports.default = _inputRange2.default;
  module.exports = exports['default'];

  });

  var InputRange = unwrapExports(js);

  function _templateObject$e() {
    var data = _taggedTemplateLiteral(["\n  .input-range__track--active,\n  .input-range__slider {\n    background: ", ";\n    border-color: ", ";\n  }\n  .input-range__label-container {\n    color: var(--greyPrimary);\n  }\n  margin-top: 36px;\n  margin-bottom: 36px;\n"]);

    _templateObject$e = function _templateObject() {
      return data;
    };

    return data;
  }
  var RangeSliderContainer = styled__default.div(_templateObject$e(), function (props) {
    return props.color;
  }, function (props) {
    return props.color;
  });

  /**
   * @typedef {object} RangeSliderProps
   * @property {number} slider
   * @property {(value: numerb) => void} onChange
   * @property {string} color
   */

  /** @type {import('react').FC<RangeSliderProps>} */

  var RangeSlider = function RangeSlider(_ref) {
    var color = _ref.color,
        slider = _ref.slider,
        _onChange = _ref.onChange;
    return /*#__PURE__*/React$2__default.createElement(RangeSliderContainer, {
      color: color
    }, /*#__PURE__*/React$2__default.createElement(InputRange, {
      maxValue: 20000,
      step: 500,
      minValue: 0,
      value: slider,
      onChange: function onChange(value) {
        return _onChange(value);
      },
      onChangeComplete: function onChangeComplete(value) {
        return _onChange(value);
      }
    }));
  };

  var IconHelp = function IconHelp() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "22",
      height: "22",
      viewBox: "0 0 22 22",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M11 0C4.9 0 0 4.9 0 11C0 17.1 4.9 22 11 22C17.1 22 22 17.1 22 11C22 4.9 17.1 0 11 0ZM11 20C6 20 2 16 2 11C2 6 6 2 11 2C16 2 20 6 20 11C20 16 16 20 11 20Z",
      fill: "#DE0C4B"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M12.1998 5.20009C10.0998 4.50009 7.79975 5.60009 7.09975 7.60009C6.99975 8.20009 7.19975 8.80009 7.79975 8.90009C8.29975 9.10009 8.79975 8.90009 8.99975 8.30009C9.39975 7.30009 10.4998 6.70009 11.5998 7.10009C12.3998 7.40009 12.8998 8.10009 12.8998 9.00009C12.8998 10.0001 11.1998 10.8001 10.5998 11.1001C10.4998 11.1001 10.4998 11.2001 10.3998 11.2001L10.2998 11.3001C10.2998 11.3001 10.1998 11.4001 10.1998 11.5001C10.1998 11.6001 10.0998 11.6001 10.0998 11.7001C10.0998 11.8001 10.0998 11.8001 10.0998 11.9001C10.0998 12.0001 10.0998 12.0001 10.0998 12.1001V13.1001C10.0998 13.7001 10.4998 14.1001 11.0998 14.1001C11.6998 14.1001 12.0998 13.7001 12.0998 13.1001V12.8001C13.1998 12.3001 15.0998 11.1001 15.0998 9.10009C14.8998 7.30009 13.7998 5.80009 12.1998 5.20009Z",
      fill: "#DE0C4B"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M11 15C10.4 15 10 15.4 10 16C10 16.6 10.5 17 11 17C11.5 17 12 16.6 12 16C12 15.4 11.6 15 11 15Z",
      fill: "#DE0C4B"
    }));
  };

  function _templateObject3$8() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  top: 16px;\n  right: 16px;\n  z-index: 1;\n"]);

    _templateObject3$8 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$a() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  top: 16px;\n  left: 16px;\n  z-index: 1;\n"]);

    _templateObject2$a = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$f() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: ", ";\n  width: 100%;\n  height: 52px;\n  position: fixed;\n  top: 52px;\n  /* z-index: 5; */\n  background: ", ";\n"]);

    _templateObject$f = function _templateObject() {
      return data;
    };

    return data;
  }
  var ContainerSubHeader$1 = styled__default.div(_templateObject$f(), function (_ref) {
    var isShowBackButton = _ref.isShowBackButton;
    return isShowBackButton ? 'space-between' : 'flex-end';
  }, function (_ref2) {
    var isDark = _ref2.isDark;
    return isDark ? theme.colors.blue900 : theme.colors.white100;
  });
  var ContainerBackButton$1 = styled__default.div(_templateObject2$a());
  var ContainerHelpModal = styled__default.div(_templateObject3$8());

  /**
   * @typedef {object} SubHeaderProps
   * @property {boolean} [isShowBackButton]
   * @property {boolean} [isShowButtonHelpModal]
   * @property {() => void} functionBackButton
   * @property {() => void} functionHelpModal
   * @property {boolean} [isDark=false]
   */

  /** @type {import('react').FC<SubHeaderProps>} */

  var SubHeader = function SubHeader(_ref) {
    var _ref$isShowBackButton = _ref.isShowBackButton,
        isShowBackButton = _ref$isShowBackButton === void 0 ? true : _ref$isShowBackButton,
        _ref$isShowButtonHelp = _ref.isShowButtonHelpModal,
        isShowButtonHelpModal = _ref$isShowButtonHelp === void 0 ? true : _ref$isShowButtonHelp,
        functionBackButton = _ref.functionBackButton,
        functionHelpModal = _ref.functionHelpModal,
        _ref$isDark = _ref.isDark,
        isDark = _ref$isDark === void 0 ? false : _ref$isDark;
    return /*#__PURE__*/React$2__default.createElement(ContainerSubHeader$1, {
      isDark: isDark,
      isShowBackButton: isShowBackButton
    }, isShowBackButton && /*#__PURE__*/React$2__default.createElement(ContainerBackButton$1, {
      id: "subHeaderBack",
      onClick: functionBackButton
    }, /*#__PURE__*/React$2__default.createElement(BackArrow, {
      isDark: isDark
    })), isShowButtonHelpModal && /*#__PURE__*/React$2__default.createElement(ContainerHelpModal, {
      id: "subHeaderHelp",
      onClick: functionHelpModal
    }, /*#__PURE__*/React$2__default.createElement(IconHelp, null)));
  };

  function _templateObject$g() {
    var data = _taggedTemplateLiteral(["\n  display: block;\n  font-family: 'CenturyGothicBold', sans serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 30px;\n  line-height: 36px;\n  text-align: left;\n  color: ", ";\n  ", " {\n    font-size: 20px;\n    line-height: 30px;\n  }\n  ", ";\n  ", ";\n\n  ", ";\n  ", ";\n"]);

    _templateObject$g = function _templateObject() {
      return data;
    };

    return data;
  }
  var TitleWrapper = styled__default.div(_templateObject$g(), function (_ref) {
    var isDark = _ref.isDark;
    return isDark ? theme.colors.pink900 : theme.colors.blue800;
  }, theme.breakpoints.down('md'), function (_ref2) {
    var marginVertical = _ref2.marginVertical;
    return "margin-top: ".concat(marginVertical, "px");
  }, function (_ref3) {
    var marginVertical = _ref3.marginVertical;
    return "margin-bottom: ".concat(marginVertical, "px");
  }, function (_ref4) {
    var marginHorizontal = _ref4.marginHorizontal;
    return "margin-left: ".concat(marginHorizontal, "px");
  }, function (_ref5) {
    var marginHorizontal = _ref5.marginHorizontal;
    return "margin-right: ".concat(marginHorizontal, "px");
  });

  /**
   * @typedef {object} TitleProps
   * @property {string} text
   * @property {boolean} [isDark]
   * @property {number} [marginHorizontal]
   * @property {number} [marginVertical]
   */

  /** @type {import('react').FC<TitleProps>} */

  var Title$2 = function Title(_ref) {
    var text = _ref.text,
        _ref$isDark = _ref.isDark,
        isDark = _ref$isDark === void 0 ? false : _ref$isDark,
        _ref$marginVertical = _ref.marginVertical,
        marginVertical = _ref$marginVertical === void 0 ? 24 : _ref$marginVertical,
        _ref$marginHorizontal = _ref.marginHorizontal,
        marginHorizontal = _ref$marginHorizontal === void 0 ? 0 : _ref$marginHorizontal;
    return /*#__PURE__*/React$2__default.createElement(TitleWrapper, {
      marginVertical: marginVertical,
      marginHorizontal: marginHorizontal,
      isDark: isDark
    }, text);
  };

  function _templateObject2$b() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: row;\n"]);

    _templateObject2$b = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$h() {
    var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  height: 25px;\n  margin-top: 8px;\n  margin-left: 8px;\n  &:hover {\n    opacity: 0.6;\n  }\n"]);

    _templateObject$h = function _templateObject() {
      return data;
    };

    return data;
  }
  var ContainerHelpModal$1 = styled__default.div(_templateObject$h());
  var TitleDesktopWrapper = styled__default.div(_templateObject2$b());

  /**
   * @typedef {object} SubHeaderDesktopProps
   * @property {string} title
   * @property {() => void} handleModal
   * @property {boolean} isShowButtonHelpModal
   */

  /** @type {import('react').FC<SubHeaderDesktopProps>} */

  var SubHeaderDesktop = function SubHeaderDesktop(_ref) {
    var title = _ref.title,
        handleModal = _ref.handleModal,
        _ref$isShowButtonHelp = _ref.isShowButtonHelpModal,
        isShowButtonHelpModal = _ref$isShowButtonHelp === void 0 ? false : _ref$isShowButtonHelp;
    return /*#__PURE__*/React$2__default.createElement(TitleDesktopWrapper, null, /*#__PURE__*/React$2__default.createElement(Title$2, {
      text: title
    }), isShowButtonHelpModal && /*#__PURE__*/React$2__default.createElement(ContainerHelpModal$1, {
      id: "helpButton",
      onClick: function onClick() {
        return handleModal(true);
      }
    }, /*#__PURE__*/React$2__default.createElement(IconHelp, null)));
  };

  function _templateObject$i() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'CenturyGothic', sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 20px;\n  line-height: 30px;\n\n  color: ", ";\n  margin: 0;\n  margin-bottom: ", "px;\n  ", " {\n    font-size: 16px;\n    line-height: 20px;\n  }\n"]);

    _templateObject$i = function _templateObject() {
      return data;
    };

    return data;
  }
  var StyledSubTitle = styled__default.h5(_templateObject$i(), function (_ref) {
    var isDark = _ref.isDark;
    return isDark ? theme.colors.pink900 : theme.colors.blue800;
  }, theme.variables.spacer * 3, theme.breakpoints.down('md'));

  /**
   * @typedef {object} SubTitleProps
   * @property {string | JSX.Element} text
   * @property {boolean} isDark
   */

  /** @type {import('react').FC<SubTitleProps>} */

  var SubTitle = function SubTitle(_ref) {
    var text = _ref.text,
        _ref$isDark = _ref.isDark,
        isDark = _ref$isDark === void 0 ? false : _ref$isDark;
    return /*#__PURE__*/React$2__default.createElement(StyledSubTitle, {
      isDark: isDark
    }, text);
  };

  function _templateObject$j() {
    var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-size: 12px;\n  margin: 0;\n"]);

    _templateObject$j = function _templateObject() {
      return data;
    };

    return data;
  }
  var TextErrorInputWrapped = styled__default.p(_templateObject$j(), theme.colors.red100);

  /**
   * @typedef {object} TextErrorProps
   * @property {string} [text]
   */

  /** @type {import('react').FC<TextErrorProps>} */

  var TextErrorInput = function TextErrorInput(_ref) {
    var _ref$text = _ref.text,
        text = _ref$text === void 0 ? '' : _ref$text;
    return /*#__PURE__*/React$2__default.createElement(TextErrorInputWrapped, null, text);
  };

  function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e["default"]:e}var React=_interopDefault(React$2__default);function _defaults2(e,t){for(var n=Object.getOwnPropertyNames(t),a=0;a<n.length;a++){var i=n[a],r=Object.getOwnPropertyDescriptor(t,i);r&&r.configurable&&e[i]===undefined&&Object.defineProperty(e,i,r);}return e}function _extends$d(){return (_extends$d=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var a in n)Object.prototype.hasOwnProperty.call(n,a)&&(e[a]=n[a]);}return e}).apply(this,arguments)}function _inheritsLoose$6(e,t){e.prototype=Object.create(t.prototype),_defaults2(e.prototype.constructor=e,t);}function _objectWithoutPropertiesLoose$5(e,t){if(null==e)return {};var n,a,i={},r=Object.keys(e);for(a=0;a<r.length;a++)n=r[a],0<=t.indexOf(n)||(i[n]=e[n]);return i}function _assertThisInitialized$2(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var invariant=function(e,t,n,a,i,r,o,s){if(!e){var l;if(t===undefined)l=new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else {var u=[n,a,i,r,o,s],c=0;(l=new Error(t.replace(/%s/g,function(){return u[c++]}))).name="Invariant Violation";}throw l.framesToPop=1,l}},invariant_1=invariant;function setInputSelection(e,t,n){if("selectionStart"in e&&"selectionEnd"in e)e.selectionStart=t,e.selectionEnd=n;else {var a=e.createTextRange();a.collapse(!0),a.moveStart("character",t),a.moveEnd("character",n-t),a.select();}}function getInputSelection(e){var t=0,n=0;if("selectionStart"in e&&"selectionEnd"in e)t=e.selectionStart,n=e.selectionEnd;else {var a=document.selection.createRange();a.parentElement()===e&&(t=-a.moveStart("character",-e.value.length),n=-a.moveEnd("character",-e.value.length));}return {start:t,end:n,length:n-t}}var defaultFormatChars={9:"[0-9]",a:"[A-Za-z]","*":"[A-Za-z0-9]"},defaultMaskChar="_";function parseMask(e,t,n){var a="",i="",r=null,o=[];if(t===undefined&&(t=defaultMaskChar),null==n&&(n=defaultFormatChars),!e||"string"!=typeof e)return {maskChar:t,formatChars:n,mask:null,prefix:null,lastEditablePosition:null,permanents:[]};var s=!1;return e.split("").forEach(function(e){s=!s&&"\\"===e||(s||!n[e]?(o.push(a.length),a.length===o.length-1&&(i+=e)):r=a.length+1,a+=e,!1);}),{maskChar:t,formatChars:n,prefix:i,mask:a,lastEditablePosition:r,permanents:o}}function isPermanentCharacter(e,t){return -1!==e.permanents.indexOf(t)}function isAllowedCharacter(e,t,n){var a=e.mask,i=e.formatChars;if(!n)return !1;if(isPermanentCharacter(e,t))return a[t]===n;var r=i[a[t]];return new RegExp(r).test(n)}function isEmpty(n,e){return e.split("").every(function(e,t){return isPermanentCharacter(n,t)||!isAllowedCharacter(n,t,e)})}function getFilledLength(e,t){var n=e.maskChar,a=e.prefix;if(!n){for(;t.length>a.length&&isPermanentCharacter(e,t.length-1);)t=t.slice(0,t.length-1);return t.length}for(var i=a.length,r=t.length;r>=a.length;r--){var o=t[r];if(!isPermanentCharacter(e,r)&&isAllowedCharacter(e,r,o)){i=r+1;break}}return i}function isFilled(e,t){return getFilledLength(e,t)===e.mask.length}function formatValue(e,t){var n=e.maskChar,a=e.mask,i=e.prefix;if(!n){for((t=insertString(e,"",t,0)).length<i.length&&(t=i);t.length<a.length&&isPermanentCharacter(e,t.length);)t+=a[t.length];return t}if(t)return insertString(e,formatValue(e,""),t,0);for(var r=0;r<a.length;r++)isPermanentCharacter(e,r)?t+=a[r]:t+=n;return t}function clearRange(n,e,a,t){var i=a+t,r=n.maskChar,o=n.mask,s=n.prefix,l=e.split("");if(r)return l.map(function(e,t){return t<a||i<=t?e:isPermanentCharacter(n,t)?o[t]:r}).join("");for(var u=i;u<l.length;u++)isPermanentCharacter(n,u)&&(l[u]="");return a=Math.max(s.length,a),l.splice(a,i-a),e=l.join(""),formatValue(n,e)}function insertString(r,o,e,s){var l=r.mask,u=r.maskChar,c=r.prefix,t=e.split(""),h=isFilled(r,o);return !u&&s>o.length&&(o+=l.slice(o.length,s)),t.every(function(e){for(;i=e,isPermanentCharacter(r,a=s)&&i!==l[a];){if(s>=o.length&&(o+=l[s]),t=e,n=s,u&&isPermanentCharacter(r,n)&&t===u)return !0;if(++s>=l.length)return !1}var t,n,a,i;return !isAllowedCharacter(r,s,e)&&e!==u||(s<o.length?o=u||h||s<c.length?o.slice(0,s)+e+o.slice(s+1):(o=o.slice(0,s)+e+o.slice(s),formatValue(r,o)):u||(o+=e),++s<l.length)}),o}function getInsertStringLength(a,e,t,i){var r=a.mask,o=a.maskChar,n=t.split(""),s=i;return n.every(function(e){for(;n=e,isPermanentCharacter(a,t=i)&&n!==r[t];)if(++i>=r.length)return !1;var t,n;return (isAllowedCharacter(a,i,e)||e===o)&&i++,i<r.length}),i-s}function getLeftEditablePosition(e,t){for(var n=t;0<=n;--n)if(!isPermanentCharacter(e,n))return n;return null}function getRightEditablePosition(e,t){for(var n=e.mask,a=t;a<n.length;++a)if(!isPermanentCharacter(e,a))return a;return null}function getStringValue(e){return e||0===e?e+"":""}function processChange(e,t,n,a,i){var r=e.mask,o=e.prefix,s=e.lastEditablePosition,l=t,u="",c=0,h=0,f=Math.min(i.start,n.start);if(n.end>i.start?h=(c=getInsertStringLength(e,a,u=l.slice(i.start,n.end),f))?i.length:0:l.length<a.length&&(h=a.length-l.length),l=a,h){if(1===h&&!i.length)f=i.start===n.start?getRightEditablePosition(e,n.start):getLeftEditablePosition(e,n.start);l=clearRange(e,l,f,h);}return l=insertString(e,l,u,f),(f+=c)>=r.length?f=r.length:f<o.length&&!c?f=o.length:f>=o.length&&f<s&&c&&(f=getRightEditablePosition(e,f)),u||(u=null),{value:l=formatValue(e,l),enteredString:u,selection:{start:f,end:f}}}function isWindowsPhoneBrowser(){var e=new RegExp("windows","i"),t=new RegExp("phone","i"),n=navigator.userAgent;return e.test(n)&&t.test(n)}function isFunction(e){return "function"==typeof e}function getRequestAnimationFrame(){return window.requestAnimationFrame||window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame}function getCancelAnimationFrame(){return window.cancelAnimationFrame||window.webkitCancelRequestAnimationFrame||window.webkitCancelAnimationFrame||window.mozCancelAnimationFrame}function defer(e){return (!!getCancelAnimationFrame()?getRequestAnimationFrame():function(){return setTimeout(e,1e3/60)})(e)}function cancelDefer(e){(getCancelAnimationFrame()||clearTimeout)(e);}var InputElement=function(c){function e(e){var f=c.call(this,e)||this;f.focused=!1,f.mounted=!1,f.previousSelection=null,f.selectionDeferId=null,f.saveSelectionLoopDeferId=null,f.saveSelectionLoop=function(){f.previousSelection=f.getSelection(),f.saveSelectionLoopDeferId=defer(f.saveSelectionLoop);},f.runSaveSelectionLoop=function(){null===f.saveSelectionLoopDeferId&&f.saveSelectionLoop();},f.stopSaveSelectionLoop=function(){null!==f.saveSelectionLoopDeferId&&(cancelDefer(f.saveSelectionLoopDeferId),f.saveSelectionLoopDeferId=null,f.previousSelection=null);},f.getInputDOMNode=function(){if(!f.mounted)return null;var e=ReactDOM__default.findDOMNode(_assertThisInitialized$2(_assertThisInitialized$2(f))),t="undefined"!=typeof window&&e instanceof window.Element;if(e&&!t)return null;if("INPUT"!==e.nodeName&&(e=e.querySelector("input")),!e)throw new Error("react-input-mask: inputComponent doesn't contain input node");return e},f.getInputValue=function(){var e=f.getInputDOMNode();return e?e.value:null},f.setInputValue=function(e){var t=f.getInputDOMNode();t&&(f.value=e,t.value=e);},f.setCursorToEnd=function(){var e=getFilledLength(f.maskOptions,f.value),t=getRightEditablePosition(f.maskOptions,e);null!==t&&f.setCursorPosition(t);},f.setSelection=function(e,t,n){void 0===n&&(n={});var a=f.getInputDOMNode(),i=f.isFocused();a&&i&&(n.deferred||setInputSelection(a,e,t),null!==f.selectionDeferId&&cancelDefer(f.selectionDeferId),f.selectionDeferId=defer(function(){f.selectionDeferId=null,setInputSelection(a,e,t);}),f.previousSelection={start:e,end:t,length:Math.abs(t-e)});},f.getSelection=function(){return getInputSelection(f.getInputDOMNode())},f.getCursorPosition=function(){return f.getSelection().start},f.setCursorPosition=function(e){f.setSelection(e,e);},f.isFocused=function(){return f.focused},f.getBeforeMaskedValueChangeConfig=function(){var e=f.maskOptions,t=e.mask,n=e.maskChar,a=e.permanents,i=e.formatChars;return {mask:t,maskChar:n,permanents:a,alwaysShowMask:!!f.props.alwaysShowMask,formatChars:i}},f.isInputAutofilled=function(e,t,n,a){var i=f.getInputDOMNode();try{if(i.matches(":-webkit-autofill"))return !0}catch(r){}return !f.focused||a.end<n.length&&t.end===e.length},f.onChange=function(e){var t=_assertThisInitialized$2(_assertThisInitialized$2(f)).beforePasteState,n=_assertThisInitialized$2(_assertThisInitialized$2(f)).previousSelection,a=f.props.beforeMaskedValueChange,i=f.getInputValue(),r=f.value,o=f.getSelection();f.isInputAutofilled(i,o,r,n)&&(r=formatValue(f.maskOptions,""),n={start:0,end:0,length:0}),t&&(n=t.selection,r=t.value,o={start:n.start+i.length,end:n.start+i.length,length:0},i=r.slice(0,n.start)+i+r.slice(n.end),f.beforePasteState=null);var s=processChange(f.maskOptions,i,o,r,n),l=s.enteredString,u=s.selection,c=s.value;if(isFunction(a)){var h=a({value:c,selection:u},{value:r,selection:n},l,f.getBeforeMaskedValueChangeConfig());c=h.value,u=h.selection;}f.setInputValue(c),isFunction(f.props.onChange)&&f.props.onChange(e),f.isWindowsPhoneBrowser?f.setSelection(u.start,u.end,{deferred:!0}):f.setSelection(u.start,u.end);},f.onFocus=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions,a=n.mask,i=n.prefix;if(f.focused=!0,f.mounted=!0,a){if(f.value)getFilledLength(f.maskOptions,f.value)<f.maskOptions.mask.length&&f.setCursorToEnd();else {var r=formatValue(f.maskOptions,i),o=formatValue(f.maskOptions,r),s=getFilledLength(f.maskOptions,o),l=getRightEditablePosition(f.maskOptions,s),u={start:l,end:l};if(isFunction(t)){var c=t({value:o,selection:u},{value:f.value,selection:null},null,f.getBeforeMaskedValueChangeConfig());o=c.value,u=c.selection;}var h=o!==f.getInputValue();h&&f.setInputValue(o),h&&isFunction(f.props.onChange)&&f.props.onChange(e),f.setSelection(u.start,u.end);}f.runSaveSelectionLoop();}isFunction(f.props.onFocus)&&f.props.onFocus(e);},f.onBlur=function(e){var t=f.props.beforeMaskedValueChange,n=f.maskOptions.mask;if(f.stopSaveSelectionLoop(),f.focused=!1,n&&!f.props.alwaysShowMask&&isEmpty(f.maskOptions,f.value)){var a="";if(isFunction(t))a=t({value:a,selection:null},{value:f.value,selection:f.previousSelection},null,f.getBeforeMaskedValueChangeConfig()).value;var i=a!==f.getInputValue();i&&f.setInputValue(a),i&&isFunction(f.props.onChange)&&f.props.onChange(e);}isFunction(f.props.onBlur)&&f.props.onBlur(e);},f.onMouseDown=function(e){if(!f.focused&&document.addEventListener){f.mouseDownX=e.clientX,f.mouseDownY=e.clientY,f.mouseDownTime=(new Date).getTime();var r=function r(e){if(document.removeEventListener("mouseup",r),f.focused){var t=Math.abs(e.clientX-f.mouseDownX),n=Math.abs(e.clientY-f.mouseDownY),a=Math.max(t,n),i=(new Date).getTime()-f.mouseDownTime;(a<=10&&i<=200||a<=5&&i<=300)&&f.setCursorToEnd();}};document.addEventListener("mouseup",r);}isFunction(f.props.onMouseDown)&&f.props.onMouseDown(e);},f.onPaste=function(e){isFunction(f.props.onPaste)&&f.props.onPaste(e),e.defaultPrevented||(f.beforePasteState={value:f.getInputValue(),selection:f.getSelection()},f.setInputValue(""));},f.handleRef=function(e){null==f.props.children&&isFunction(f.props.inputRef)&&f.props.inputRef(e);};var t=e.mask,n=e.maskChar,a=e.formatChars,i=e.alwaysShowMask,r=e.beforeMaskedValueChange,o=e.defaultValue,s=e.value;f.maskOptions=parseMask(t,n,a),null==o&&(o=""),null==s&&(s=o);var l=getStringValue(s);if(f.maskOptions.mask&&(i||l)&&(l=formatValue(f.maskOptions,l),isFunction(r))){var u=e.value;null==e.value&&(u=o),l=r({value:l,selection:null},{value:u=getStringValue(u),selection:null},null,f.getBeforeMaskedValueChangeConfig()).value;}return f.value=l,f}_inheritsLoose$6(e,c);var t=e.prototype;return t.componentDidMount=function(){this.mounted=!0,this.getInputDOMNode()&&(this.isWindowsPhoneBrowser=isWindowsPhoneBrowser(),this.maskOptions.mask&&this.getInputValue()!==this.value&&this.setInputValue(this.value));},t.componentDidUpdate=function(){var e=this.previousSelection,t=this.props,n=t.beforeMaskedValueChange,a=t.alwaysShowMask,i=t.mask,r=t.maskChar,o=t.formatChars,s=this.maskOptions,l=a||this.isFocused(),u=null!=this.props.value,c=u?getStringValue(this.props.value):this.value,h=e?e.start:null;if(this.maskOptions=parseMask(i,r,o),this.maskOptions.mask){!s.mask&&this.isFocused()&&this.runSaveSelectionLoop();var f=this.maskOptions.mask&&this.maskOptions.mask!==s.mask;if(s.mask||u||(c=this.getInputValue()),(f||this.maskOptions.mask&&(c||l))&&(c=formatValue(this.maskOptions,c)),f){var p=getFilledLength(this.maskOptions,c);(null===h||p<h)&&(h=isFilled(this.maskOptions,c)?p:getRightEditablePosition(this.maskOptions,p));}!this.maskOptions.mask||!isEmpty(this.maskOptions,c)||l||u&&this.props.value||(c="");var d={start:h,end:h};if(isFunction(n)){var m=n({value:c,selection:d},{value:this.value,selection:this.previousSelection},null,this.getBeforeMaskedValueChangeConfig());c=m.value,d=m.selection;}this.value=c;var g=this.getInputValue()!==this.value;g?(this.setInputValue(this.value),this.forceUpdate()):f&&this.forceUpdate();var v=!1;null!=d.start&&null!=d.end&&(v=!e||e.start!==d.start||e.end!==d.end),(v||g)&&this.setSelection(d.start,d.end);}else s.mask&&(this.stopSaveSelectionLoop(),this.forceUpdate());},t.componentWillUnmount=function(){this.mounted=!1,null!==this.selectionDeferId&&cancelDefer(this.selectionDeferId),this.stopSaveSelectionLoop();},t.render=function(){var t,e=this.props,n=(e.mask,e.alwaysShowMask,e.maskChar,e.formatChars,e.inputRef,e.beforeMaskedValueChange,e.children),a=_objectWithoutPropertiesLoose$5(e,["mask","alwaysShowMask","maskChar","formatChars","inputRef","beforeMaskedValueChange","children"]);if(n){isFunction(n)||invariant_1(!1);var i=["onChange","onPaste","onMouseDown","onFocus","onBlur","value","disabled","readOnly"],r=_extends$d({},a);i.forEach(function(e){return delete r[e]}),t=n(r),i.filter(function(e){return null!=t.props[e]&&t.props[e]!==a[e]}).length&&invariant_1(!1);}else t=React.createElement("input",_extends$d({ref:this.handleRef},a));var o={onFocus:this.onFocus,onBlur:this.onBlur};return this.maskOptions.mask&&(a.disabled||a.readOnly||(o.onChange=this.onChange,o.onPaste=this.onPaste,o.onMouseDown=this.onMouseDown),null!=a.value&&(o.value=this.value)),t=React.cloneElement(t,o)},e}(React.Component);var reactInputMask_production_min=InputElement;

  /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /**
   * Use invariant() to assert state which your program assumes to be true.
   *
   * Provide sprintf-style format (only %s is supported) and arguments
   * to provide information about what broke and what you were
   * expecting.
   *
   * The invariant message will be stripped in production, but the invariant
   * will remain to ensure logic does not differ in production.
   */

  var NODE_ENV = process.env.NODE_ENV;

  var invariant$1 = function(condition, format, a, b, c, d, e, f) {
    if (NODE_ENV !== 'production') {
      if (format === undefined) {
        throw new Error('invariant requires an error message argument');
      }
    }

    if (!condition) {
      var error;
      if (format === undefined) {
        error = new Error(
          'Minified exception occurred; use the non-minified dev environment ' +
          'for the full error message and additional helpful warnings.'
        );
      } else {
        var args = [a, b, c, d, e, f];
        var argIndex = 0;
        error = new Error(
          format.replace(/%s/g, function() { return args[argIndex++]; })
        );
        error.name = 'Invariant Violation';
      }

      error.framesToPop = 1; // we don't care about invariant's own frame
      throw error;
    }
  };

  var invariant_1$1 = invariant$1;

  /**
   * Copyright (c) 2014-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */

  /**
   * Similar to invariant but only logs a warning if the condition is not met.
   * This can be used to log issues in development environments in critical
   * paths. Removing the logging code for production environments will keep the
   * same logic and follow the same code paths.
   */

  var __DEV__ = process.env.NODE_ENV !== 'production';

  var warning = function() {};

  if (__DEV__) {
    var printWarning$2 = function printWarning(format, args) {
      var len = arguments.length;
      args = new Array(len > 1 ? len - 1 : 0);
      for (var key = 1; key < len; key++) {
        args[key - 1] = arguments[key];
      }
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (x) {}
    };

    warning = function(condition, format, args) {
      var len = arguments.length;
      args = new Array(len > 2 ? len - 2 : 0);
      for (var key = 2; key < len; key++) {
        args[key - 2] = arguments[key];
      }
      if (format === undefined) {
        throw new Error(
            '`warning(condition, format, ...args)` requires a warning ' +
            'message argument'
        );
      }
      if (!condition) {
        printWarning$2.apply(null, [format].concat(args));
      }
    };
  }

  var warning_1 = warning;

  function _interopDefault$1 (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

  var React$1 = _interopDefault$1(React$2__default);

  var invariant$2 = _interopDefault$1(invariant_1$1);
  var warning$1 = _interopDefault$1(warning_1);

  function _defaults2$1(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

  function _extends$e() {
    _extends$e = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$e.apply(this, arguments);
  }

  function _inheritsLoose$7(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;

    _defaults2$1(subClass, superClass);
  }

  function _objectWithoutPropertiesLoose$6(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _assertThisInitialized$3(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function setInputSelection$1(input, start, end) {
    if ('selectionStart' in input && 'selectionEnd' in input) {
      input.selectionStart = start;
      input.selectionEnd = end;
    } else {
      var range = input.createTextRange();
      range.collapse(true);
      range.moveStart('character', start);
      range.moveEnd('character', end - start);
      range.select();
    }
  }
  function getInputSelection$1(input) {
    var start = 0;
    var end = 0;

    if ('selectionStart' in input && 'selectionEnd' in input) {
      start = input.selectionStart;
      end = input.selectionEnd;
    } else {
      var range = document.selection.createRange();

      if (range.parentElement() === input) {
        start = -range.moveStart('character', -input.value.length);
        end = -range.moveEnd('character', -input.value.length);
      }
    }

    return {
      start: start,
      end: end,
      length: end - start
    };
  }

  var defaultFormatChars$1 = {
    '9': '[0-9]',
    'a': '[A-Za-z]',
    '*': '[A-Za-z0-9]'
  };
  var defaultMaskChar$1 = '_';

  function parseMask$1 (mask, maskChar, formatChars) {
    var parsedMaskString = '';
    var prefix = '';
    var lastEditablePosition = null;
    var permanents = [];

    if (maskChar === undefined) {
      maskChar = defaultMaskChar$1;
    }

    if (formatChars == null) {
      formatChars = defaultFormatChars$1;
    }

    if (!mask || typeof mask !== 'string') {
      return {
        maskChar: maskChar,
        formatChars: formatChars,
        mask: null,
        prefix: null,
        lastEditablePosition: null,
        permanents: []
      };
    }

    var isPermanent = false;
    mask.split('').forEach(function (character) {
      if (!isPermanent && character === '\\') {
        isPermanent = true;
      } else {
        if (isPermanent || !formatChars[character]) {
          permanents.push(parsedMaskString.length);

          if (parsedMaskString.length === permanents.length - 1) {
            prefix += character;
          }
        } else {
          lastEditablePosition = parsedMaskString.length + 1;
        }

        parsedMaskString += character;
        isPermanent = false;
      }
    });
    return {
      maskChar: maskChar,
      formatChars: formatChars,
      prefix: prefix,
      mask: parsedMaskString,
      lastEditablePosition: lastEditablePosition,
      permanents: permanents
    };
  }

  /* eslint no-use-before-define: ["error", { functions: false }] */
  function isPermanentCharacter$1(maskOptions, pos) {
    return maskOptions.permanents.indexOf(pos) !== -1;
  }
  function isAllowedCharacter$1(maskOptions, pos, character) {
    var mask = maskOptions.mask,
        formatChars = maskOptions.formatChars;

    if (!character) {
      return false;
    }

    if (isPermanentCharacter$1(maskOptions, pos)) {
      return mask[pos] === character;
    }

    var ruleChar = mask[pos];
    var charRule = formatChars[ruleChar];
    return new RegExp(charRule).test(character);
  }
  function isEmpty$1(maskOptions, value) {
    return value.split('').every(function (character, i) {
      return isPermanentCharacter$1(maskOptions, i) || !isAllowedCharacter$1(maskOptions, i, character);
    });
  }
  function getFilledLength$1(maskOptions, value) {
    var maskChar = maskOptions.maskChar,
        prefix = maskOptions.prefix;

    if (!maskChar) {
      while (value.length > prefix.length && isPermanentCharacter$1(maskOptions, value.length - 1)) {
        value = value.slice(0, value.length - 1);
      }

      return value.length;
    }

    var filledLength = prefix.length;

    for (var i = value.length; i >= prefix.length; i--) {
      var character = value[i];
      var isEnteredCharacter = !isPermanentCharacter$1(maskOptions, i) && isAllowedCharacter$1(maskOptions, i, character);

      if (isEnteredCharacter) {
        filledLength = i + 1;
        break;
      }
    }

    return filledLength;
  }
  function isFilled$1(maskOptions, value) {
    return getFilledLength$1(maskOptions, value) === maskOptions.mask.length;
  }
  function formatValue$1(maskOptions, value) {
    var maskChar = maskOptions.maskChar,
        mask = maskOptions.mask,
        prefix = maskOptions.prefix;

    if (!maskChar) {
      value = insertString$1(maskOptions, '', value, 0);

      if (value.length < prefix.length) {
        value = prefix;
      }

      while (value.length < mask.length && isPermanentCharacter$1(maskOptions, value.length)) {
        value += mask[value.length];
      }

      return value;
    }

    if (value) {
      var emptyValue = formatValue$1(maskOptions, '');
      return insertString$1(maskOptions, emptyValue, value, 0);
    }

    for (var i = 0; i < mask.length; i++) {
      if (isPermanentCharacter$1(maskOptions, i)) {
        value += mask[i];
      } else {
        value += maskChar;
      }
    }

    return value;
  }
  function clearRange$1(maskOptions, value, start, len) {
    var end = start + len;
    var maskChar = maskOptions.maskChar,
        mask = maskOptions.mask,
        prefix = maskOptions.prefix;
    var arrayValue = value.split('');

    if (!maskChar) {
      // remove any permanent chars after clear range, they will be added back by formatValue
      for (var i = end; i < arrayValue.length; i++) {
        if (isPermanentCharacter$1(maskOptions, i)) {
          arrayValue[i] = '';
        }
      }

      start = Math.max(prefix.length, start);
      arrayValue.splice(start, end - start);
      value = arrayValue.join('');
      return formatValue$1(maskOptions, value);
    }

    return arrayValue.map(function (character, i) {
      if (i < start || i >= end) {
        return character;
      }

      if (isPermanentCharacter$1(maskOptions, i)) {
        return mask[i];
      }

      return maskChar;
    }).join('');
  }
  function insertString$1(maskOptions, value, insertStr, insertPosition) {
    var mask = maskOptions.mask,
        maskChar = maskOptions.maskChar,
        prefix = maskOptions.prefix;
    var arrayInsertStr = insertStr.split('');
    var isInputFilled = isFilled$1(maskOptions, value);

    var isUsablePosition = function isUsablePosition(pos, character) {
      return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
    };

    var isUsableCharacter = function isUsableCharacter(character, pos) {
      return !maskChar || !isPermanentCharacter$1(maskOptions, pos) || character !== maskChar;
    };

    if (!maskChar && insertPosition > value.length) {
      value += mask.slice(value.length, insertPosition);
    }

    arrayInsertStr.every(function (insertCharacter) {
      while (!isUsablePosition(insertPosition, insertCharacter)) {
        if (insertPosition >= value.length) {
          value += mask[insertPosition];
        }

        if (!isUsableCharacter(insertCharacter, insertPosition)) {
          return true;
        }

        insertPosition++; // stop iteration if maximum value length reached

        if (insertPosition >= mask.length) {
          return false;
        }
      }

      var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

      if (!isAllowed) {
        return true;
      }

      if (insertPosition < value.length) {
        if (maskChar || isInputFilled || insertPosition < prefix.length) {
          value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition + 1);
        } else {
          value = value.slice(0, insertPosition) + insertCharacter + value.slice(insertPosition);
          value = formatValue$1(maskOptions, value);
        }
      } else if (!maskChar) {
        value += insertCharacter;
      }

      insertPosition++; // stop iteration if maximum value length reached

      return insertPosition < mask.length;
    });
    return value;
  }
  function getInsertStringLength$1(maskOptions, value, insertStr, insertPosition) {
    var mask = maskOptions.mask,
        maskChar = maskOptions.maskChar;
    var arrayInsertStr = insertStr.split('');
    var initialInsertPosition = insertPosition;

    var isUsablePosition = function isUsablePosition(pos, character) {
      return !isPermanentCharacter$1(maskOptions, pos) || character === mask[pos];
    };

    arrayInsertStr.every(function (insertCharacter) {
      while (!isUsablePosition(insertPosition, insertCharacter)) {
        insertPosition++; // stop iteration if maximum value length reached

        if (insertPosition >= mask.length) {
          return false;
        }
      }

      var isAllowed = isAllowedCharacter$1(maskOptions, insertPosition, insertCharacter) || insertCharacter === maskChar;

      if (isAllowed) {
        insertPosition++;
      } // stop iteration if maximum value length reached


      return insertPosition < mask.length;
    });
    return insertPosition - initialInsertPosition;
  }
  function getLeftEditablePosition$1(maskOptions, pos) {
    for (var i = pos; i >= 0; --i) {
      if (!isPermanentCharacter$1(maskOptions, i)) {
        return i;
      }
    }

    return null;
  }
  function getRightEditablePosition$1(maskOptions, pos) {
    var mask = maskOptions.mask;

    for (var i = pos; i < mask.length; ++i) {
      if (!isPermanentCharacter$1(maskOptions, i)) {
        return i;
      }
    }

    return null;
  }
  function getStringValue$1(value) {
    return !value && value !== 0 ? '' : value + '';
  }

  function processChange$1(maskOptions, value, selection, previousValue, previousSelection) {
    var mask = maskOptions.mask,
        prefix = maskOptions.prefix,
        lastEditablePosition = maskOptions.lastEditablePosition;
    var newValue = value;
    var enteredString = '';
    var formattedEnteredStringLength = 0;
    var removedLength = 0;
    var cursorPosition = Math.min(previousSelection.start, selection.start);

    if (selection.end > previousSelection.start) {
      enteredString = newValue.slice(previousSelection.start, selection.end);
      formattedEnteredStringLength = getInsertStringLength$1(maskOptions, previousValue, enteredString, cursorPosition);

      if (!formattedEnteredStringLength) {
        removedLength = 0;
      } else {
        removedLength = previousSelection.length;
      }
    } else if (newValue.length < previousValue.length) {
      removedLength = previousValue.length - newValue.length;
    }

    newValue = previousValue;

    if (removedLength) {
      if (removedLength === 1 && !previousSelection.length) {
        var deleteFromRight = previousSelection.start === selection.start;
        cursorPosition = deleteFromRight ? getRightEditablePosition$1(maskOptions, selection.start) : getLeftEditablePosition$1(maskOptions, selection.start);
      }

      newValue = clearRange$1(maskOptions, newValue, cursorPosition, removedLength);
    }

    newValue = insertString$1(maskOptions, newValue, enteredString, cursorPosition);
    cursorPosition = cursorPosition + formattedEnteredStringLength;

    if (cursorPosition >= mask.length) {
      cursorPosition = mask.length;
    } else if (cursorPosition < prefix.length && !formattedEnteredStringLength) {
      cursorPosition = prefix.length;
    } else if (cursorPosition >= prefix.length && cursorPosition < lastEditablePosition && formattedEnteredStringLength) {
      cursorPosition = getRightEditablePosition$1(maskOptions, cursorPosition);
    }

    newValue = formatValue$1(maskOptions, newValue);

    if (!enteredString) {
      enteredString = null;
    }

    return {
      value: newValue,
      enteredString: enteredString,
      selection: {
        start: cursorPosition,
        end: cursorPosition
      }
    };
  }

  function isWindowsPhoneBrowser$1() {
    var windows = new RegExp('windows', 'i');
    var phone = new RegExp('phone', 'i');
    var ua = navigator.userAgent;
    return windows.test(ua) && phone.test(ua);
  }

  function isFunction$1(value) {
    return typeof value === 'function';
  }

  function getRequestAnimationFrame$1() {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame;
  }

  function getCancelAnimationFrame$1() {
    return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame;
  }

  function defer$1(fn) {
    var hasCancelAnimationFrame = !!getCancelAnimationFrame$1();
    var deferFn;

    if (hasCancelAnimationFrame) {
      deferFn = getRequestAnimationFrame$1();
    } else {
      deferFn = function deferFn() {
        return setTimeout(fn, 1000 / 60);
      };
    }

    return deferFn(fn);
  }
  function cancelDefer$1(deferId) {
    var cancelFn = getCancelAnimationFrame$1() || clearTimeout;
    cancelFn(deferId);
  }

  var InputElement$1 =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose$7(InputElement, _React$Component);

    function InputElement(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this.focused = false;
      _this.mounted = false;
      _this.previousSelection = null;
      _this.selectionDeferId = null;
      _this.saveSelectionLoopDeferId = null;

      _this.saveSelectionLoop = function () {
        _this.previousSelection = _this.getSelection();
        _this.saveSelectionLoopDeferId = defer$1(_this.saveSelectionLoop);
      };

      _this.runSaveSelectionLoop = function () {
        if (_this.saveSelectionLoopDeferId === null) {
          _this.saveSelectionLoop();
        }
      };

      _this.stopSaveSelectionLoop = function () {
        if (_this.saveSelectionLoopDeferId !== null) {
          cancelDefer$1(_this.saveSelectionLoopDeferId);
          _this.saveSelectionLoopDeferId = null;
          _this.previousSelection = null;
        }
      };

      _this.getInputDOMNode = function () {
        if (!_this.mounted) {
          return null;
        }

        var input = ReactDOM__default.findDOMNode(_assertThisInitialized$3(_assertThisInitialized$3(_this)));
        var isDOMNode = typeof window !== 'undefined' && input instanceof window.Element; // workaround for react-test-renderer
        // https://github.com/sanniassin/react-input-mask/issues/147

        if (input && !isDOMNode) {
          return null;
        }

        if (input.nodeName !== 'INPUT') {
          input = input.querySelector('input');
        }

        if (!input) {
          throw new Error('react-input-mask: inputComponent doesn\'t contain input node');
        }

        return input;
      };

      _this.getInputValue = function () {
        var input = _this.getInputDOMNode();

        if (!input) {
          return null;
        }

        return input.value;
      };

      _this.setInputValue = function (value) {
        var input = _this.getInputDOMNode();

        if (!input) {
          return;
        }

        _this.value = value;
        input.value = value;
      };

      _this.setCursorToEnd = function () {
        var filledLength = getFilledLength$1(_this.maskOptions, _this.value);
        var pos = getRightEditablePosition$1(_this.maskOptions, filledLength);

        if (pos !== null) {
          _this.setCursorPosition(pos);
        }
      };

      _this.setSelection = function (start, end, options) {
        if (options === void 0) {
          options = {};
        }

        var input = _this.getInputDOMNode();

        var isFocused = _this.isFocused(); // don't change selection on unfocused input
        // because Safari sets focus on selection change (#154)


        if (!input || !isFocused) {
          return;
        }

        var _options = options,
            deferred = _options.deferred;

        if (!deferred) {
          setInputSelection$1(input, start, end);
        }

        if (_this.selectionDeferId !== null) {
          cancelDefer$1(_this.selectionDeferId);
        } // deferred selection update is required for pre-Lollipop Android browser,
        // but for consistent behavior we do it for all browsers


        _this.selectionDeferId = defer$1(function () {
          _this.selectionDeferId = null;
          setInputSelection$1(input, start, end);
        });
        _this.previousSelection = {
          start: start,
          end: end,
          length: Math.abs(end - start)
        };
      };

      _this.getSelection = function () {
        var input = _this.getInputDOMNode();

        return getInputSelection$1(input);
      };

      _this.getCursorPosition = function () {
        return _this.getSelection().start;
      };

      _this.setCursorPosition = function (pos) {
        _this.setSelection(pos, pos);
      };

      _this.isFocused = function () {
        return _this.focused;
      };

      _this.getBeforeMaskedValueChangeConfig = function () {
        var _this$maskOptions = _this.maskOptions,
            mask = _this$maskOptions.mask,
            maskChar = _this$maskOptions.maskChar,
            permanents = _this$maskOptions.permanents,
            formatChars = _this$maskOptions.formatChars;
        var alwaysShowMask = _this.props.alwaysShowMask;
        return {
          mask: mask,
          maskChar: maskChar,
          permanents: permanents,
          alwaysShowMask: !!alwaysShowMask,
          formatChars: formatChars
        };
      };

      _this.isInputAutofilled = function (value, selection, previousValue, previousSelection) {
        var input = _this.getInputDOMNode(); // only check for positive match because it will be false negative
        // in case of autofill simulation in tests
        //
        // input.matches throws an exception if selector isn't supported


        try {
          if (input.matches(':-webkit-autofill')) {
            return true;
          }
        } catch (e) {} // if input isn't focused then change event must have been triggered
        // either by autofill or event simulation in tests


        if (!_this.focused) {
          return true;
        } // if cursor has moved to the end while previousSelection forbids it
        // then it must be autofill


        return previousSelection.end < previousValue.length && selection.end === value.length;
      };

      _this.onChange = function (event) {
        var _assertThisInitialize = _assertThisInitialized$3(_assertThisInitialized$3(_this)),
            beforePasteState = _assertThisInitialize.beforePasteState;

        var _assertThisInitialize2 = _assertThisInitialized$3(_assertThisInitialized$3(_this)),
            previousSelection = _assertThisInitialize2.previousSelection;

        var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;

        var value = _this.getInputValue();

        var previousValue = _this.value;

        var selection = _this.getSelection(); // autofill replaces entire value, ignore old one
        // https://github.com/sanniassin/react-input-mask/issues/113


        if (_this.isInputAutofilled(value, selection, previousValue, previousSelection)) {
          previousValue = formatValue$1(_this.maskOptions, '');
          previousSelection = {
            start: 0,
            end: 0,
            length: 0
          };
        } // set value and selection as if we haven't
        // cleared input in onPaste handler


        if (beforePasteState) {
          previousSelection = beforePasteState.selection;
          previousValue = beforePasteState.value;
          selection = {
            start: previousSelection.start + value.length,
            end: previousSelection.start + value.length,
            length: 0
          };
          value = previousValue.slice(0, previousSelection.start) + value + previousValue.slice(previousSelection.end);
          _this.beforePasteState = null;
        }

        var changedState = processChange$1(_this.maskOptions, value, selection, previousValue, previousSelection);
        var enteredString = changedState.enteredString;
        var newSelection = changedState.selection;
        var newValue = changedState.value;

        if (isFunction$1(beforeMaskedValueChange)) {
          var modifiedValue = beforeMaskedValueChange({
            value: newValue,
            selection: newSelection
          }, {
            value: previousValue,
            selection: previousSelection
          }, enteredString, _this.getBeforeMaskedValueChangeConfig());
          newValue = modifiedValue.value;
          newSelection = modifiedValue.selection;
        }

        _this.setInputValue(newValue);

        if (isFunction$1(_this.props.onChange)) {
          _this.props.onChange(event);
        }

        if (_this.isWindowsPhoneBrowser) {
          _this.setSelection(newSelection.start, newSelection.end, {
            deferred: true
          });
        } else {
          _this.setSelection(newSelection.start, newSelection.end);
        }
      };

      _this.onFocus = function (event) {
        var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
        var _this$maskOptions2 = _this.maskOptions,
            mask = _this$maskOptions2.mask,
            prefix = _this$maskOptions2.prefix;
        _this.focused = true; // if autoFocus is set, onFocus triggers before componentDidMount

        _this.mounted = true;

        if (mask) {
          if (!_this.value) {
            var emptyValue = formatValue$1(_this.maskOptions, prefix);
            var newValue = formatValue$1(_this.maskOptions, emptyValue);
            var filledLength = getFilledLength$1(_this.maskOptions, newValue);
            var cursorPosition = getRightEditablePosition$1(_this.maskOptions, filledLength);
            var newSelection = {
              start: cursorPosition,
              end: cursorPosition
            };

            if (isFunction$1(beforeMaskedValueChange)) {
              var modifiedValue = beforeMaskedValueChange({
                value: newValue,
                selection: newSelection
              }, {
                value: _this.value,
                selection: null
              }, null, _this.getBeforeMaskedValueChangeConfig());
              newValue = modifiedValue.value;
              newSelection = modifiedValue.selection;
            }

            var isInputValueChanged = newValue !== _this.getInputValue();

            if (isInputValueChanged) {
              _this.setInputValue(newValue);
            }

            if (isInputValueChanged && isFunction$1(_this.props.onChange)) {
              _this.props.onChange(event);
            }

            _this.setSelection(newSelection.start, newSelection.end);
          } else if (getFilledLength$1(_this.maskOptions, _this.value) < _this.maskOptions.mask.length) {
            _this.setCursorToEnd();
          }

          _this.runSaveSelectionLoop();
        }

        if (isFunction$1(_this.props.onFocus)) {
          _this.props.onFocus(event);
        }
      };

      _this.onBlur = function (event) {
        var beforeMaskedValueChange = _this.props.beforeMaskedValueChange;
        var mask = _this.maskOptions.mask;

        _this.stopSaveSelectionLoop();

        _this.focused = false;

        if (mask && !_this.props.alwaysShowMask && isEmpty$1(_this.maskOptions, _this.value)) {
          var newValue = '';

          if (isFunction$1(beforeMaskedValueChange)) {
            var modifiedValue = beforeMaskedValueChange({
              value: newValue,
              selection: null
            }, {
              value: _this.value,
              selection: _this.previousSelection
            }, null, _this.getBeforeMaskedValueChangeConfig());
            newValue = modifiedValue.value;
          }

          var isInputValueChanged = newValue !== _this.getInputValue();

          if (isInputValueChanged) {
            _this.setInputValue(newValue);
          }

          if (isInputValueChanged && isFunction$1(_this.props.onChange)) {
            _this.props.onChange(event);
          }
        }

        if (isFunction$1(_this.props.onBlur)) {
          _this.props.onBlur(event);
        }
      };

      _this.onMouseDown = function (event) {
        // tiny unintentional mouse movements can break cursor
        // position on focus, so we have to restore it in that case
        //
        // https://github.com/sanniassin/react-input-mask/issues/108
        if (!_this.focused && document.addEventListener) {
          _this.mouseDownX = event.clientX;
          _this.mouseDownY = event.clientY;
          _this.mouseDownTime = new Date().getTime();

          var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
            document.removeEventListener('mouseup', mouseUpHandler);

            if (!_this.focused) {
              return;
            }

            var deltaX = Math.abs(mouseUpEvent.clientX - _this.mouseDownX);
            var deltaY = Math.abs(mouseUpEvent.clientY - _this.mouseDownY);
            var axisDelta = Math.max(deltaX, deltaY);

            var timeDelta = new Date().getTime() - _this.mouseDownTime;

            if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
              _this.setCursorToEnd();
            }
          };

          document.addEventListener('mouseup', mouseUpHandler);
        }

        if (isFunction$1(_this.props.onMouseDown)) {
          _this.props.onMouseDown(event);
        }
      };

      _this.onPaste = function (event) {
        if (isFunction$1(_this.props.onPaste)) {
          _this.props.onPaste(event);
        } // event.clipboardData might not work in Android browser
        // cleaning input to get raw text inside onChange handler


        if (!event.defaultPrevented) {
          _this.beforePasteState = {
            value: _this.getInputValue(),
            selection: _this.getSelection()
          };

          _this.setInputValue('');
        }
      };

      _this.handleRef = function (ref) {
        if (_this.props.children == null && isFunction$1(_this.props.inputRef)) {
          _this.props.inputRef(ref);
        }
      };

      var _mask = props.mask,
          _maskChar = props.maskChar,
          _formatChars = props.formatChars,
          _alwaysShowMask = props.alwaysShowMask,
          _beforeMaskedValueChange = props.beforeMaskedValueChange;
      var defaultValue = props.defaultValue,
          _value = props.value;
      _this.maskOptions = parseMask$1(_mask, _maskChar, _formatChars);

      if (defaultValue == null) {
        defaultValue = '';
      }

      if (_value == null) {
        _value = defaultValue;
      }

      var _newValue = getStringValue$1(_value);

      if (_this.maskOptions.mask && (_alwaysShowMask || _newValue)) {
        _newValue = formatValue$1(_this.maskOptions, _newValue);

        if (isFunction$1(_beforeMaskedValueChange)) {
          var oldValue = props.value;

          if (props.value == null) {
            oldValue = defaultValue;
          }

          oldValue = getStringValue$1(oldValue);

          var modifiedValue = _beforeMaskedValueChange({
            value: _newValue,
            selection: null
          }, {
            value: oldValue,
            selection: null
          }, null, _this.getBeforeMaskedValueChangeConfig());

          _newValue = modifiedValue.value;
        }
      }

      _this.value = _newValue;
      return _this;
    }

    var _proto = InputElement.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.mounted = true; // workaround for react-test-renderer
      // https://github.com/sanniassin/react-input-mask/issues/147

      if (!this.getInputDOMNode()) {
        return;
      }

      this.isWindowsPhoneBrowser = isWindowsPhoneBrowser$1();

      if (this.maskOptions.mask && this.getInputValue() !== this.value) {
        this.setInputValue(this.value);
      }
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      var previousSelection = this.previousSelection;
      var _this$props = this.props,
          beforeMaskedValueChange = _this$props.beforeMaskedValueChange,
          alwaysShowMask = _this$props.alwaysShowMask,
          mask = _this$props.mask,
          maskChar = _this$props.maskChar,
          formatChars = _this$props.formatChars;
      var previousMaskOptions = this.maskOptions;
      var showEmpty = alwaysShowMask || this.isFocused();
      var hasValue = this.props.value != null;
      var newValue = hasValue ? getStringValue$1(this.props.value) : this.value;
      var cursorPosition = previousSelection ? previousSelection.start : null;
      this.maskOptions = parseMask$1(mask, maskChar, formatChars);

      if (!this.maskOptions.mask) {
        if (previousMaskOptions.mask) {
          this.stopSaveSelectionLoop(); // render depends on this.maskOptions and this.value,
          // call forceUpdate to keep it in sync

          this.forceUpdate();
        }

        return;
      } else if (!previousMaskOptions.mask && this.isFocused()) {
        this.runSaveSelectionLoop();
      }

      var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== previousMaskOptions.mask;

      if (!previousMaskOptions.mask && !hasValue) {
        newValue = this.getInputValue();
      }

      if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
        newValue = formatValue$1(this.maskOptions, newValue);
      }

      if (isMaskChanged) {
        var filledLength = getFilledLength$1(this.maskOptions, newValue);

        if (cursorPosition === null || filledLength < cursorPosition) {
          if (isFilled$1(this.maskOptions, newValue)) {
            cursorPosition = filledLength;
          } else {
            cursorPosition = getRightEditablePosition$1(this.maskOptions, filledLength);
          }
        }
      }

      if (this.maskOptions.mask && isEmpty$1(this.maskOptions, newValue) && !showEmpty && (!hasValue || !this.props.value)) {
        newValue = '';
      }

      var newSelection = {
        start: cursorPosition,
        end: cursorPosition
      };

      if (isFunction$1(beforeMaskedValueChange)) {
        var modifiedValue = beforeMaskedValueChange({
          value: newValue,
          selection: newSelection
        }, {
          value: this.value,
          selection: this.previousSelection
        }, null, this.getBeforeMaskedValueChangeConfig());
        newValue = modifiedValue.value;
        newSelection = modifiedValue.selection;
      }

      this.value = newValue;
      var isValueChanged = this.getInputValue() !== this.value; // render depends on this.maskOptions and this.value,
      // call forceUpdate to keep it in sync

      if (isValueChanged) {
        this.setInputValue(this.value);
        this.forceUpdate();
      } else if (isMaskChanged) {
        this.forceUpdate();
      }

      var isSelectionChanged = false;

      if (newSelection.start != null && newSelection.end != null) {
        isSelectionChanged = !previousSelection || previousSelection.start !== newSelection.start || previousSelection.end !== newSelection.end;
      }

      if (isSelectionChanged || isValueChanged) {
        this.setSelection(newSelection.start, newSelection.end);
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;

      if (this.selectionDeferId !== null) {
        cancelDefer$1(this.selectionDeferId);
      }

      this.stopSaveSelectionLoop();
    };

    _proto.render = function render() {
      var _this$props2 = this.props,
          mask = _this$props2.mask,
          alwaysShowMask = _this$props2.alwaysShowMask,
          maskChar = _this$props2.maskChar,
          formatChars = _this$props2.formatChars,
          inputRef = _this$props2.inputRef,
          beforeMaskedValueChange = _this$props2.beforeMaskedValueChange,
          children = _this$props2.children,
          restProps = _objectWithoutPropertiesLoose$6(_this$props2, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef", "beforeMaskedValueChange", "children"]);

      var inputElement;
      process.env.NODE_ENV !== "production" ? warning$1( // parse mask to test against actual mask prop as this.maskOptions
      // will be updated later in componentDidUpdate
      !restProps.maxLength || !parseMask$1(mask, maskChar, formatChars).mask, 'react-input-mask: maxLength property shouldn\'t be passed to the masked input. It breaks masking and unnecessary because length is limited by the mask length.') : void 0;

      if (children) {
        !isFunction$1(children) ? process.env.NODE_ENV !== "production" ? invariant$2(false, 'react-input-mask: children must be a function') : invariant$2(false) : void 0;
        var controlledProps = ['onChange', 'onPaste', 'onMouseDown', 'onFocus', 'onBlur', 'value', 'disabled', 'readOnly'];

        var childrenProps = _extends$e({}, restProps);

        controlledProps.forEach(function (propId) {
          return delete childrenProps[propId];
        });
        inputElement = children(childrenProps);
        var conflictProps = controlledProps.filter(function (propId) {
          return inputElement.props[propId] != null && inputElement.props[propId] !== restProps[propId];
        });
        !!conflictProps.length ? process.env.NODE_ENV !== "production" ? invariant$2(false, "react-input-mask: the following props should be passed to the react-input-mask's component and should not be altered in children's function: " + conflictProps.join(', ')) : invariant$2(false) : void 0;
        process.env.NODE_ENV !== "production" ? warning$1(!inputRef, 'react-input-mask: inputRef is ignored when children is passed, attach ref to the children instead') : void 0;
      } else {
        inputElement = React$1.createElement("input", _extends$e({
          ref: this.handleRef
        }, restProps));
      }

      var changedProps = {
        onFocus: this.onFocus,
        onBlur: this.onBlur
      };

      if (this.maskOptions.mask) {
        if (!restProps.disabled && !restProps.readOnly) {
          changedProps.onChange = this.onChange;
          changedProps.onPaste = this.onPaste;
          changedProps.onMouseDown = this.onMouseDown;
        }

        if (restProps.value != null) {
          changedProps.value = this.value;
        }
      }

      inputElement = React$1.cloneElement(inputElement, changedProps);
      return inputElement;
    };

    return InputElement;
  }(React$1.Component);

  var reactInputMask_development = InputElement$1;

  var reactInputMask = createCommonjsModule(function (module) {
  if (process.env.NODE_ENV === 'production') {
    module.exports = reactInputMask_production_min;
  } else {
    module.exports = reactInputMask_development;
  }
  });

  function _templateObject5$6() {
    var data = _taggedTemplateLiteral(["\n      animation: ", " 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;\n      transform: translate3d(0, 0, 0);\n      backface-visibility: hidden;\n      perspective: 1000px;\n    "]);

    _templateObject5$6 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$7() {
    var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject4$7 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$9() {
    var data = _taggedTemplateLiteral(["\n    10%, 90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%, 80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%, 60% {\n    transform: translate3d(4px, 0, 0);\n  }\n"]);

    _templateObject3$9 = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$c() {
    var data = _taggedTemplateLiteral(["\n      & input {\n        color: var(--white100);\n        ::placeholder {\n          color: var(--white100);\n        }\n      }\n    "]);

    _templateObject2$c = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$k() {
    var data = _taggedTemplateLiteral(["\n  width: 350px;\n  ", " {\n    width: 100%;\n  }\n\n  ", "\n"]);

    _templateObject$k = function _templateObject() {
      return data;
    };

    return data;
  }
  var InputWrapper = styled__default.div(_templateObject$k(), theme.breakpoints.down('md'), function (_ref) {
    var isDark = _ref.isDark;
    return isDark && styled.css(_templateObject2$c());
  });
  var shake = styled.keyframes(_templateObject3$9());
  var TextFieldWrapper = styled__default(TextField)(_templateObject4$7(), function (_ref2) {
    var error = _ref2.error;
    return error && styled.css(_templateObject5$6(), shake);
  }, theme.breakpoints.down('md'));

  /**
   * @typedef {object} InputProps
   * @property {string} [placeholder]
   * @property {JSX.Element} [icon]
   * @property {string} [value]
   * @property {boolean} [error]
   * @property {boolean} [isDark]
   */

  /** @type {import('react').FC<InputProps & import('@material-ui/core').TextFieldProps>} */

  var Input$1 = function Input(_ref) {
    var isDark = _ref.isDark,
        placeholder = _ref.placeholder,
        icon = _ref.icon,
        error = _ref.error,
        props = _objectWithoutProperties(_ref, ["isDark", "placeholder", "icon", "error"]);

    return /*#__PURE__*/React$2__default.createElement(InputWrapper, {
      isDark: isDark
    }, /*#__PURE__*/React$2__default.createElement(TextFieldWrapper, _extends({
      placeholder: placeholder,
      margin: "normal",
      error: error
    }, props)), icon && icon);
  };
  Input$1.defaultProps = {
    isDark: false,
    placeholder: '',
    value: undefined,
    onValueChange: function onValueChange() {},
    icon: null,
    error: false,
    mask: ''
  };
  /** @type {import('react').FC<InputProps & import('react-input-mask').Props>} */

  var InputMasks = function InputMasks(_ref2) {
    var placeholder = _ref2.placeholder,
        value = _ref2.value,
        icon = _ref2.icon,
        error = _ref2.error,
        mask = _ref2.mask,
        maskChar = _ref2.maskChar,
        beforeMaskedStateChange = _ref2.beforeMaskedStateChange,
        label = _ref2.label,
        props = _objectWithoutProperties(_ref2, ["placeholder", "value", "icon", "error", "mask", "maskChar", "beforeMaskedStateChange", "label"]);

    return /*#__PURE__*/React$2__default.createElement(InputWrapper, null, /*#__PURE__*/React$2__default.createElement(reactInputMask, _extends({
      alwaysShowMask: false,
      maskChar: maskChar,
      mask: mask,
      beforeMaskedStateChange: beforeMaskedStateChange,
      value: value,
      placeholder: placeholder,
      margin: "normal"
    }, props), function (props) {
      return /*#__PURE__*/React$2__default.createElement(TextFieldWrapper, _extends({
        error: error,
        label: label
      }, props));
    }), icon && icon);
  };
  InputMasks.defaultProps = {
    placeholder: '',
    onValueChange: function onValueChange() {},
    icon: null,
    error: false,
    mask: '',
    value: undefined,
    maskChar: null,
    beforeMaskedStateChange: null
  };

  function _extends$f() {
    _extends$f = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    return _extends$f.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose$7(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  function _inheritsLoose$8(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
  }

  var classnames$1 = createCommonjsModule(function (module) {
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  /* global define */

  (function () {

  	var hasOwn = {}.hasOwnProperty;

  	function classNames () {
  		var classes = [];

  		for (var i = 0; i < arguments.length; i++) {
  			var arg = arguments[i];
  			if (!arg) continue;

  			var argType = typeof arg;

  			if (argType === 'string' || argType === 'number') {
  				classes.push(arg);
  			} else if (Array.isArray(arg) && arg.length) {
  				var inner = classNames.apply(null, arg);
  				if (inner) {
  					classes.push(inner);
  				}
  			} else if (argType === 'object') {
  				for (var key in arg) {
  					if (hasOwn.call(arg, key) && arg[key]) {
  						classes.push(key);
  					}
  				}
  			}
  		}

  		return classes.join(' ');
  	}

  	if ( module.exports) {
  		classNames.default = classNames;
  		module.exports = classNames;
  	} else {
  		window.classNames = classNames;
  	}
  }());
  });

  var config = {
    disabled: false
  };

  var timeoutsShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.number, propTypes.shape({
    enter: propTypes.number,
    exit: propTypes.number,
    appear: propTypes.number
  }).isRequired]) : null;
  var classNamesShape = process.env.NODE_ENV !== 'production' ? propTypes.oneOfType([propTypes.string, propTypes.shape({
    enter: propTypes.string,
    exit: propTypes.string,
    active: propTypes.string
  }), propTypes.shape({
    enter: propTypes.string,
    enterDone: propTypes.string,
    enterActive: propTypes.string,
    exit: propTypes.string,
    exitDone: propTypes.string,
    exitActive: propTypes.string
  })]) : null;

  var TransitionGroupContext = React$2__default.createContext(null);

  var UNMOUNTED = 'unmounted';
  var EXITED = 'exited';
  var ENTERING = 'entering';
  var ENTERED = 'entered';
  var EXITING = 'exiting';
  /**
   * The Transition component lets you describe a transition from one component
   * state to another _over time_ with a simple declarative API. Most commonly
   * it's used to animate the mounting and unmounting of a component, but can also
   * be used to describe in-place transition states as well.
   *
   * ---
   *
   * **Note**: `Transition` is a platform-agnostic base component. If you're using
   * transitions in CSS, you'll probably want to use
   * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
   * instead. It inherits all the features of `Transition`, but contains
   * additional features necessary to play nice with CSS transitions (hence the
   * name of the component).
   *
   * ---
   *
   * By default the `Transition` component does not alter the behavior of the
   * component it renders, it only tracks "enter" and "exit" states for the
   * components. It's up to you to give meaning and effect to those states. For
   * example we can add styles to a component when it enters or exits:
   *
   * ```jsx
   * import { Transition } from 'react-transition-group';
   *
   * const duration = 300;
   *
   * const defaultStyle = {
   *   transition: `opacity ${duration}ms ease-in-out`,
   *   opacity: 0,
   * }
   *
   * const transitionStyles = {
   *   entering: { opacity: 1 },
   *   entered:  { opacity: 1 },
   *   exiting:  { opacity: 0 },
   *   exited:  { opacity: 0 },
   * };
   *
   * const Fade = ({ in: inProp }) => (
   *   <Transition in={inProp} timeout={duration}>
   *     {state => (
   *       <div style={{
   *         ...defaultStyle,
   *         ...transitionStyles[state]
   *       }}>
   *         I'm a fade Transition!
   *       </div>
   *     )}
   *   </Transition>
   * );
   * ```
   *
   * There are 4 main states a Transition can be in:
   *  - `'entering'`
   *  - `'entered'`
   *  - `'exiting'`
   *  - `'exited'`
   *
   * Transition state is toggled via the `in` prop. When `true` the component
   * begins the "Enter" stage. During this stage, the component will shift from
   * its current transition state, to `'entering'` for the duration of the
   * transition and then to the `'entered'` stage once it's complete. Let's take
   * the following example (we'll use the
   * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
   *
   * ```jsx
   * function App() {
   *   const [inProp, setInProp] = useState(false);
   *   return (
   *     <div>
   *       <Transition in={inProp} timeout={500}>
   *         {state => (
   *           // ...
   *         )}
   *       </Transition>
   *       <button onClick={() => setInProp(true)}>
   *         Click to Enter
   *       </button>
   *     </div>
   *   );
   * }
   * ```
   *
   * When the button is clicked the component will shift to the `'entering'` state
   * and stay there for 500ms (the value of `timeout`) before it finally switches
   * to `'entered'`.
   *
   * When `in` is `false` the same thing happens except the state moves from
   * `'exiting'` to `'exited'`.
   */

  var Transition =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose$8(Transition, _React$Component);

    function Transition(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;
      var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

      var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
      var initialStatus;
      _this.appearStatus = null;

      if (props.in) {
        if (appear) {
          initialStatus = EXITED;
          _this.appearStatus = ENTERING;
        } else {
          initialStatus = ENTERED;
        }
      } else {
        if (props.unmountOnExit || props.mountOnEnter) {
          initialStatus = UNMOUNTED;
        } else {
          initialStatus = EXITED;
        }
      }

      _this.state = {
        status: initialStatus
      };
      _this.nextCallback = null;
      return _this;
    }

    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
      var nextIn = _ref.in;

      if (nextIn && prevState.status === UNMOUNTED) {
        return {
          status: EXITED
        };
      }

      return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }


    var _proto = Transition.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.updateStatus(true, this.appearStatus);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var nextStatus = null;

      if (prevProps !== this.props) {
        var status = this.state.status;

        if (this.props.in) {
          if (status !== ENTERING && status !== ENTERED) {
            nextStatus = ENTERING;
          }
        } else {
          if (status === ENTERING || status === ENTERED) {
            nextStatus = EXITING;
          }
        }
      }

      this.updateStatus(false, nextStatus);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.cancelNextCallback();
    };

    _proto.getTimeouts = function getTimeouts() {
      var timeout = this.props.timeout;
      var exit, enter, appear;
      exit = enter = appear = timeout;

      if (timeout != null && typeof timeout !== 'number') {
        exit = timeout.exit;
        enter = timeout.enter; // TODO: remove fallback for next major

        appear = timeout.appear !== undefined ? timeout.appear : enter;
      }

      return {
        exit: exit,
        enter: enter,
        appear: appear
      };
    };

    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
      if (mounting === void 0) {
        mounting = false;
      }

      if (nextStatus !== null) {
        // nextStatus will always be ENTERING or EXITING.
        this.cancelNextCallback();
        var node = ReactDOM__default.findDOMNode(this);

        if (nextStatus === ENTERING) {
          this.performEnter(node, mounting);
        } else {
          this.performExit(node);
        }
      } else if (this.props.unmountOnExit && this.state.status === EXITED) {
        this.setState({
          status: UNMOUNTED
        });
      }
    };

    _proto.performEnter = function performEnter(node, mounting) {
      var _this2 = this;

      var enter = this.props.enter;
      var appearing = this.context ? this.context.isMounting : mounting;
      var timeouts = this.getTimeouts();
      var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
      // if we are mounting and running this it means appear _must_ be set

      if (!mounting && !enter || config.disabled) {
        this.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node);
        });
        return;
      }

      this.props.onEnter(node, appearing);
      this.safeSetState({
        status: ENTERING
      }, function () {
        _this2.props.onEntering(node, appearing);

        _this2.onTransitionEnd(node, enterTimeout, function () {
          _this2.safeSetState({
            status: ENTERED
          }, function () {
            _this2.props.onEntered(node, appearing);
          });
        });
      });
    };

    _proto.performExit = function performExit(node) {
      var _this3 = this;

      var exit = this.props.exit;
      var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

      if (!exit || config.disabled) {
        this.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
        return;
      }

      this.props.onExit(node);
      this.safeSetState({
        status: EXITING
      }, function () {
        _this3.props.onExiting(node);

        _this3.onTransitionEnd(node, timeouts.exit, function () {
          _this3.safeSetState({
            status: EXITED
          }, function () {
            _this3.props.onExited(node);
          });
        });
      });
    };

    _proto.cancelNextCallback = function cancelNextCallback() {
      if (this.nextCallback !== null) {
        this.nextCallback.cancel();
        this.nextCallback = null;
      }
    };

    _proto.safeSetState = function safeSetState(nextState, callback) {
      // This shouldn't be necessary, but there are weird race conditions with
      // setState callbacks and unmounting in testing, so always make sure that
      // we can cancel any pending setState callbacks after we unmount.
      callback = this.setNextCallback(callback);
      this.setState(nextState, callback);
    };

    _proto.setNextCallback = function setNextCallback(callback) {
      var _this4 = this;

      var active = true;

      this.nextCallback = function (event) {
        if (active) {
          active = false;
          _this4.nextCallback = null;
          callback(event);
        }
      };

      this.nextCallback.cancel = function () {
        active = false;
      };

      return this.nextCallback;
    };

    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
      this.setNextCallback(handler);
      var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

      if (!node || doesNotHaveTimeoutOrListener) {
        setTimeout(this.nextCallback, 0);
        return;
      }

      if (this.props.addEndListener) {
        this.props.addEndListener(node, this.nextCallback);
      }

      if (timeout != null) {
        setTimeout(this.nextCallback, timeout);
      }
    };

    _proto.render = function render() {
      var status = this.state.status;

      if (status === UNMOUNTED) {
        return null;
      }

      var _this$props = this.props,
          children = _this$props.children,
          childProps = _objectWithoutPropertiesLoose$7(_this$props, ["children"]); // filter props for Transtition


      delete childProps.in;
      delete childProps.mountOnEnter;
      delete childProps.unmountOnExit;
      delete childProps.appear;
      delete childProps.enter;
      delete childProps.exit;
      delete childProps.timeout;
      delete childProps.addEndListener;
      delete childProps.onEnter;
      delete childProps.onEntering;
      delete childProps.onEntered;
      delete childProps.onExit;
      delete childProps.onExiting;
      delete childProps.onExited;

      if (typeof children === 'function') {
        // allows for nested Transitions
        return React$2__default.createElement(TransitionGroupContext.Provider, {
          value: null
        }, children(status, childProps));
      }

      var child = React$2__default.Children.only(children);
      return (// allows for nested Transitions
        React$2__default.createElement(TransitionGroupContext.Provider, {
          value: null
        }, React$2__default.cloneElement(child, childProps))
      );
    };

    return Transition;
  }(React$2__default.Component);

  Transition.contextType = TransitionGroupContext;
  Transition.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * A `function` child can be used instead of a React element. This function is
     * called with the current transition status (`'entering'`, `'entered'`,
     * `'exiting'`, `'exited'`), which can be used to apply context
     * specific props to a component.
     *
     * ```jsx
     * <Transition in={this.state.in} timeout={150}>
     *   {state => (
     *     <MyComponent className={`fade fade-${state}`} />
     *   )}
     * </Transition>
     * ```
     */
    children: propTypes.oneOfType([propTypes.func.isRequired, propTypes.element.isRequired]).isRequired,

    /**
     * Show the component; triggers the enter or exit states
     */
    in: propTypes.bool,

    /**
     * By default the child component is mounted immediately along with
     * the parent `Transition` component. If you want to "lazy mount" the component on the
     * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
     * mounted, even on "exited", unless you also specify `unmountOnExit`.
     */
    mountOnEnter: propTypes.bool,

    /**
     * By default the child component stays mounted after it reaches the `'exited'` state.
     * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
     */
    unmountOnExit: propTypes.bool,

    /**
     * Normally a component is not transitioned if it is shown when the
     * `<Transition>` component mounts. If you want to transition on the first
     * mount set `appear` to `true`, and the component will transition in as soon
     * as the `<Transition>` mounts.
     *
     * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
     * > only adds an additional enter transition. However, in the
     * > `<CSSTransition>` component that first enter transition does result in
     * > additional `.appear-*` classes, that way you can choose to style it
     * > differently.
     */
    appear: propTypes.bool,

    /**
     * Enable or disable enter transitions.
     */
    enter: propTypes.bool,

    /**
     * Enable or disable exit transitions.
     */
    exit: propTypes.bool,

    /**
     * The duration of the transition, in milliseconds.
     * Required unless `addEndListener` is provided.
     *
     * You may specify a single timeout for all transitions:
     *
     * ```jsx
     * timeout={500}
     * ```
     *
     * or individually:
     *
     * ```jsx
     * timeout={{
     *  appear: 500,
     *  enter: 300,
     *  exit: 500,
     * }}
     * ```
     *
     * - `appear` defaults to the value of `enter`
     * - `enter` defaults to `0`
     * - `exit` defaults to `0`
     *
     * @type {number | { enter?: number, exit?: number, appear?: number }}
     */
    timeout: function timeout(props) {
      var pt = timeoutsShape;
      if (!props.addEndListener) pt = pt.isRequired;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return pt.apply(void 0, [props].concat(args));
    },

    /**
     * Add a custom transition end trigger. Called with the transitioning
     * DOM node and a `done` callback. Allows for more fine grained transition end
     * logic. **Note:** Timeouts are still used as a fallback if provided.
     *
     * ```jsx
     * addEndListener={(node, done) => {
     *   // use the css transitionend event to mark the finish of a transition
     *   node.addEventListener('transitionend', done, false);
     * }}
     * ```
     */
    addEndListener: propTypes.func,

    /**
     * Callback fired before the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEnter: propTypes.func,

    /**
     * Callback fired after the "entering" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool)
     */
    onEntering: propTypes.func,

    /**
     * Callback fired after the "entered" status is applied. An extra parameter
     * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
     *
     * @type Function(node: HtmlElement, isAppearing: bool) -> void
     */
    onEntered: propTypes.func,

    /**
     * Callback fired before the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExit: propTypes.func,

    /**
     * Callback fired after the "exiting" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExiting: propTypes.func,

    /**
     * Callback fired after the "exited" status is applied.
     *
     * @type Function(node: HtmlElement) -> void
     */
    onExited: propTypes.func // Name the function so it is clearer in the documentation

  } : {};

  function noop$1() {}

  Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: noop$1,
    onEntering: noop$1,
    onEntered: noop$1,
    onExit: noop$1,
    onExiting: noop$1,
    onExited: noop$1
  };
  Transition.UNMOUNTED = 0;
  Transition.EXITED = 1;
  Transition.ENTERING = 2;
  Transition.ENTERED = 3;
  Transition.EXITING = 4;

  function _assertThisInitialized$4(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  /**
   * Given `this.props.children`, return an object mapping key to child.
   *
   * @param {*} children `this.props.children`
   * @return {object} Mapping of key to child
   */

  function getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
      return mapFn && React$2.isValidElement(child) ? mapFn(child) : child;
    };

    var result = Object.create(null);
    if (children) React$2.Children.map(children, function (c) {
      return c;
    }).forEach(function (child) {
      // run the map function here instead so that the key is the computed one
      result[child.key] = mapper(child);
    });
    return result;
  }
  /**
   * When you're adding or removing children some may be added or removed in the
   * same render pass. We want to show *both* since we want to simultaneously
   * animate elements in and out. This function takes a previous set of keys
   * and a new set of keys and merges them with its best guess of the correct
   * ordering. In the future we may expose some of the utilities in
   * ReactMultiChild to make this easy, but for now React itself does not
   * directly have this concept of the union of prevChildren and nextChildren
   * so we implement it here.
   *
   * @param {object} prev prev children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @param {object} next next children as returned from
   * `ReactTransitionChildMapping.getChildMapping()`.
   * @return {object} a key set that contains all keys in `prev` and all keys
   * in `next` in a reasonable order.
   */

  function mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};

    function getValueForKey(key) {
      return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list


    var nextKeysPending = Object.create(null);
    var pendingKeys = [];

    for (var prevKey in prev) {
      if (prevKey in next) {
        if (pendingKeys.length) {
          nextKeysPending[prevKey] = pendingKeys;
          pendingKeys = [];
        }
      } else {
        pendingKeys.push(prevKey);
      }
    }

    var i;
    var childMapping = {};

    for (var nextKey in next) {
      if (nextKeysPending[nextKey]) {
        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
          var pendingNextKey = nextKeysPending[nextKey][i];
          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
      }

      childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`


    for (i = 0; i < pendingKeys.length; i++) {
      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    }

    return childMapping;
  }

  function getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
  }

  function getInitialChildMapping(props, onExited) {
    return getChildMapping(props.children, function (child) {
      return React$2.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        appear: getProp(child, 'appear', props),
        enter: getProp(child, 'enter', props),
        exit: getProp(child, 'exit', props)
      });
    });
  }
  function getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = getChildMapping(nextProps.children);
    var children = mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function (key) {
      var child = children[key];
      if (!React$2.isValidElement(child)) return;
      var hasPrev = key in prevChildMapping;
      var hasNext = key in nextChildMapping;
      var prevChild = prevChildMapping[key];
      var isLeaving = React$2.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

      if (hasNext && (!hasPrev || isLeaving)) {
        // console.log('entering', key)
        children[key] = React$2.cloneElement(child, {
          onExited: onExited.bind(null, child),
          in: true,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      } else if (!hasNext && hasPrev && !isLeaving) {
        // item is old (exiting)
        // console.log('leaving', key)
        children[key] = React$2.cloneElement(child, {
          in: false
        });
      } else if (hasNext && hasPrev && React$2.isValidElement(prevChild)) {
        // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = React$2.cloneElement(child, {
          onExited: onExited.bind(null, child),
          in: prevChild.props.in,
          exit: getProp(child, 'exit', nextProps),
          enter: getProp(child, 'enter', nextProps)
        });
      }
    });
    return children;
  }

  var values = Object.values || function (obj) {
    return Object.keys(obj).map(function (k) {
      return obj[k];
    });
  };

  var defaultProps$2 = {
    component: 'div',
    childFactory: function childFactory(child) {
      return child;
    }
    /**
     * The `<TransitionGroup>` component manages a set of transition components
     * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
     * components, `<TransitionGroup>` is a state machine for managing the mounting
     * and unmounting of components over time.
     *
     * Consider the example below. As items are removed or added to the TodoList the
     * `in` prop is toggled automatically by the `<TransitionGroup>`.
     *
     * Note that `<TransitionGroup>`  does not define any animation behavior!
     * Exactly _how_ a list item animates is up to the individual transition
     * component. This means you can mix and match animations across different list
     * items.
     */

  };

  var TransitionGroup =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose$8(TransitionGroup, _React$Component);

    function TransitionGroup(props, context) {
      var _this;

      _this = _React$Component.call(this, props, context) || this;

      var handleExited = _this.handleExited.bind(_assertThisInitialized$4(_assertThisInitialized$4(_this))); // Initial children should all be entering, dependent on appear


      _this.state = {
        contextValue: {
          isMounting: true
        },
        handleExited: handleExited,
        firstRender: true
      };
      return _this;
    }

    var _proto = TransitionGroup.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.mounted = true;
      this.setState({
        contextValue: {
          isMounting: false
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.mounted = false;
    };

    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
      var prevChildMapping = _ref.children,
          handleExited = _ref.handleExited,
          firstRender = _ref.firstRender;
      return {
        children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
        firstRender: false
      };
    };

    _proto.handleExited = function handleExited(child, node) {
      var currentChildMapping = getChildMapping(this.props.children);
      if (child.key in currentChildMapping) return;

      if (child.props.onExited) {
        child.props.onExited(node);
      }

      if (this.mounted) {
        this.setState(function (state) {
          var children = _extends$f({}, state.children);

          delete children[child.key];
          return {
            children: children
          };
        });
      }
    };

    _proto.render = function render() {
      var _this$props = this.props,
          Component = _this$props.component,
          childFactory = _this$props.childFactory,
          props = _objectWithoutPropertiesLoose$7(_this$props, ["component", "childFactory"]);

      var contextValue = this.state.contextValue;
      var children = values(this.state.children).map(childFactory);
      delete props.appear;
      delete props.enter;
      delete props.exit;

      if (Component === null) {
        return React$2__default.createElement(TransitionGroupContext.Provider, {
          value: contextValue
        }, children);
      }

      return React$2__default.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, React$2__default.createElement(Component, props, children));
    };

    return TransitionGroup;
  }(React$2__default.Component);

  TransitionGroup.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * `<TransitionGroup>` renders a `<div>` by default. You can change this
     * behavior by providing a `component` prop.
     * If you use React v16+ and would like to avoid a wrapping `<div>` element
     * you can pass in `component={null}`. This is useful if the wrapping div
     * borks your css styles.
     */
    component: propTypes.any,

    /**
     * A set of `<Transition>` components, that are toggled `in` and out as they
     * leave. the `<TransitionGroup>` will inject specific transition props, so
     * remember to spread them through if you are wrapping the `<Transition>` as
     * with our `<Fade>` example.
     *
     * While this component is meant for multiple `Transition` or `CSSTransition`
     * children, sometimes you may want to have a single transition child with
     * content that you want to be transitioned out and in when you change it
     * (e.g. routes, images etc.) In that case you can change the `key` prop of
     * the transition child as you change its content, this will cause
     * `TransitionGroup` to transition the child out and back in.
     */
    children: propTypes.node,

    /**
     * A convenience prop that enables or disables appear animations
     * for all children. Note that specifying this will override any defaults set
     * on individual children Transitions.
     */
    appear: propTypes.bool,

    /**
     * A convenience prop that enables or disables enter animations
     * for all children. Note that specifying this will override any defaults set
     * on individual children Transitions.
     */
    enter: propTypes.bool,

    /**
     * A convenience prop that enables or disables exit animations
     * for all children. Note that specifying this will override any defaults set
     * on individual children Transitions.
     */
    exit: propTypes.bool,

    /**
     * You may need to apply reactive updates to a child as it is exiting.
     * This is generally done by using `cloneElement` however in the case of an exiting
     * child the element has already been removed and not accessible to the consumer.
     *
     * If you do need to update a child as it leaves you can provide a `childFactory`
     * to wrap every child, even the ones that are leaving.
     *
     * @type Function(child: ReactElement) -> ReactElement
     */
    childFactory: propTypes.func
  } : {};
  TransitionGroup.defaultProps = defaultProps$2;

  var POSITION = {
    TOP_LEFT: 'top-left',
    TOP_RIGHT: 'top-right',
    TOP_CENTER: 'top-center',
    BOTTOM_LEFT: 'bottom-left',
    BOTTOM_RIGHT: 'bottom-right',
    BOTTOM_CENTER: 'bottom-center'
  };
  var TYPE = {
    INFO: 'info',
    SUCCESS: 'success',
    WARNING: 'warning',
    ERROR: 'error',
    DEFAULT: 'default'
  };
  var ACTION = {
    SHOW: 0,
    CLEAR: 1,
    DID_MOUNT: 2,
    WILL_UNMOUNT: 3,
    ON_CHANGE: 4
  };
  var NOOP = function NOOP() {};
  var RT_NAMESPACE = 'Toastify';

  function isValidDelay(val) {
    return typeof val === 'number' && !isNaN(val) && val > 0;
  }
  function objectValues(obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  }
  var canUseDom = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

  function withRequired(fn) {
    fn.isRequired = function (props, propName, componentName) {
      var prop = props[propName];

      if (typeof prop === 'undefined') {
        return new Error("The prop " + propName + " is marked as required in \n      " + componentName + ", but its value is undefined.");
      }

      fn(props, propName, componentName);
    };

    return fn;
  }

  var falseOrDelay = withRequired(function (props, propName, componentName) {
    var prop = props[propName];

    if (prop !== false && !isValidDelay(prop)) {
      return new Error(componentName + " expect " + propName + " \n      to be a valid Number > 0 or equal to false. " + prop + " given.");
    }

    return null;
  });

  var eventManager = {
    list: new Map(),
    emitQueue: new Map(),
    on: function on(event, callback) {
      this.list.has(event) || this.list.set(event, []);
      this.list.get(event).push(callback);
      return this;
    },
    off: function off(event) {
      this.list.delete(event);
      return this;
    },
    cancelEmit: function cancelEmit(event) {
      var timers = this.emitQueue.get(event);

      if (timers) {
        timers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        this.emitQueue.delete(event);
      }

      return this;
    },

    /**
     * Enqueue the event at the end of the call stack
     * Doing so let the user call toast as follow:
     * toast('1')
     * toast('2')
     * toast('3')
     * Without setTimemout the code above will not work
     */
    emit: function emit(event) {
      var _this = this;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      this.list.has(event) && this.list.get(event).forEach(function (callback) {
        var timer = setTimeout(function () {
          callback.apply(void 0, args);
        }, 0);
        _this.emitQueue.has(event) || _this.emitQueue.set(event, []);

        _this.emitQueue.get(event).push(timer);
      });
    }
  };

  function cssTransition(_ref) {
    var enter = _ref.enter,
        exit = _ref.exit,
        _ref$duration = _ref.duration,
        duration = _ref$duration === void 0 ? 750 : _ref$duration,
        _ref$appendPosition = _ref.appendPosition,
        appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition;
    return function Animation(_ref2) {
      var children = _ref2.children,
          position = _ref2.position,
          preventExitTransition = _ref2.preventExitTransition,
          props = _objectWithoutPropertiesLoose$7(_ref2, ["children", "position", "preventExitTransition"]);

      var enterClassName = appendPosition ? enter + "--" + position : enter;
      var exitClassName = appendPosition ? exit + "--" + position : exit;
      var enterDuration, exitDuration;

      if (Array.isArray(duration) && duration.length === 2) {
        enterDuration = duration[0];
        exitDuration = duration[1];
      } else {
        enterDuration = exitDuration = duration;
      }

      var onEnter = function onEnter(node) {
        node.classList.add(enterClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = enterDuration * 0.001 + "s";
      };

      var onEntered = function onEntered(node) {
        node.classList.remove(enterClassName);
        node.style.cssText = '';
      };

      var onExit = function onExit(node) {
        node.classList.add(exitClassName);
        node.style.animationFillMode = 'forwards';
        node.style.animationDuration = exitDuration * 0.001 + "s";
      };

      return React$2__default.createElement(Transition, _extends$f({}, props, {
        timeout: preventExitTransition ? 0 : {
          enter: enterDuration,
          exit: exitDuration
        },
        onEnter: onEnter,
        onEntered: onEntered,
        onExit: preventExitTransition ? NOOP : onExit
      }), children);
    };
  }

  function ProgressBar(_ref) {
    var _cx, _animationEvent;

    var delay = _ref.delay,
        isRunning = _ref.isRunning,
        closeToast = _ref.closeToast,
        type = _ref.type,
        hide = _ref.hide,
        className = _ref.className,
        userStyle = _ref.style,
        controlledProgress = _ref.controlledProgress,
        progress = _ref.progress,
        rtl = _ref.rtl;

    var style = _extends$f({}, userStyle, {
      animationDuration: delay + "ms",
      animationPlayState: isRunning ? 'running' : 'paused',
      opacity: hide ? 0 : 1,
      transform: controlledProgress ? "scaleX(" + progress + ")" : null
    });

    var classNames = classnames$1(RT_NAMESPACE + "__progress-bar", controlledProgress ? RT_NAMESPACE + "__progress-bar--controlled" : RT_NAMESPACE + "__progress-bar--animated", RT_NAMESPACE + "__progress-bar--" + type, (_cx = {}, _cx[RT_NAMESPACE + "__progress-bar--rtl"] = rtl, _cx), className);
    var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? 'onTransitionEnd' : 'onAnimationEnd'] = controlledProgress && progress < 1 ? null : closeToast, _animationEvent);
    return React$2__default.createElement("div", _extends$f({
      className: classNames,
      style: style
    }, animationEvent));
  }

  ProgressBar.propTypes = {
    /**
     * The animation delay which determine when to close the toast
     */
    delay: falseOrDelay.isRequired,

    /**
     * Whether or not the animation is running or paused
     */
    isRunning: propTypes.bool.isRequired,

    /**
     * Func to close the current toast
     */
    closeToast: propTypes.func.isRequired,

    /**
     * Support rtl content
     */
    rtl: propTypes.bool.isRequired,

    /**
     * Optional type : info, success ...
     */
    type: propTypes.string,

    /**
     * Hide or not the progress bar
     */
    hide: propTypes.bool,

    /**
     * Optionnal className
     */
    className: propTypes.oneOfType([propTypes.string, propTypes.object]),

    /**
     * Controlled progress value
     */
    progress: propTypes.number,

    /**
     * Tell wether or not controlled progress bar is used
     */
    controlledProgress: propTypes.bool
  };
  ProgressBar.defaultProps = {
    type: TYPE.DEFAULT,
    hide: false
  };

  function getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
  }

  function getY(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
  }

  var iLoveInternetExplorer = canUseDom && /(msie|trident)/i.test(navigator.userAgent);

  var Toast =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$8(Toast, _Component);

    function Toast() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.state = {
        isRunning: true,
        preventExitTransition: false
      };
      _this.flag = {
        canCloseOnClick: true,
        canDrag: false
      };
      _this.drag = {
        start: 0,
        x: 0,
        y: 0,
        deltaX: 0,
        removalDistance: 0
      };
      _this.boundingRect = null;
      _this.ref = null;

      _this.pauseToast = function () {
        if (_this.props.autoClose) {
          _this.setState({
            isRunning: false
          });
        }
      };

      _this.playToast = function () {
        if (_this.props.autoClose) {
          _this.setState({
            isRunning: true
          });
        }
      };

      _this.onDragStart = function (e) {
        _this.flag.canCloseOnClick = true;
        _this.flag.canDrag = true;
        _this.boundingRect = _this.ref.getBoundingClientRect();
        _this.ref.style.transition = '';
        _this.drag.start = _this.drag.x = getX(e.nativeEvent);
        _this.drag.removalDistance = _this.ref.offsetWidth * (_this.props.draggablePercent / 100);
      };

      _this.onDragMove = function (e) {
        if (_this.flag.canDrag) {
          if (_this.state.isRunning) {
            _this.pauseToast();
          }

          _this.drag.x = getX(e);
          _this.drag.deltaX = _this.drag.x - _this.drag.start;
          _this.drag.y = getY(e); // prevent false positif during a toast click

          _this.drag.start !== _this.drag.x && (_this.flag.canCloseOnClick = false);
          _this.ref.style.transform = "translateX(" + _this.drag.deltaX + "px)";
          _this.ref.style.opacity = 1 - Math.abs(_this.drag.deltaX / _this.drag.removalDistance);
        }
      };

      _this.onDragEnd = function (e) {
        if (_this.flag.canDrag) {
          _this.flag.canDrag = false;

          if (Math.abs(_this.drag.deltaX) > _this.drag.removalDistance) {
            _this.setState({
              preventExitTransition: true
            }, _this.props.closeToast);

            return;
          }

          _this.ref.style.transition = 'transform 0.2s, opacity 0.2s';
          _this.ref.style.transform = 'translateX(0)';
          _this.ref.style.opacity = 1;
        }
      };

      _this.onDragTransitionEnd = function () {
        if (_this.boundingRect) {
          var _this$boundingRect = _this.boundingRect,
              top = _this$boundingRect.top,
              bottom = _this$boundingRect.bottom,
              left = _this$boundingRect.left,
              right = _this$boundingRect.right;

          if (_this.props.pauseOnHover && _this.drag.x >= left && _this.drag.x <= right && _this.drag.y >= top && _this.drag.y <= bottom) {
            _this.pauseToast();
          } else {
            _this.playToast();
          }
        }
      };

      _this.onExitTransitionEnd = function () {
        if (iLoveInternetExplorer) {
          _this.props.onExited();

          return;
        }

        var height = _this.ref.scrollHeight;
        var style = _this.ref.style;
        requestAnimationFrame(function () {
          style.minHeight = 'initial';
          style.height = height + 'px';
          style.transition = 'all 0.4s ';
          requestAnimationFrame(function () {
            style.height = 0;
            style.padding = 0;
            style.margin = 0;
          });
          setTimeout(function () {
            return _this.props.onExited();
          }, 400);
        });
      };

      return _this;
    }

    var _proto = Toast.prototype;

    _proto.componentDidMount = function componentDidMount() {
      this.props.onOpen(this.props.children.props);

      if (this.props.draggable) {
        this.bindDragEvents();
      } // Maybe I could bind the event in the ToastContainer and rely on delegation


      if (this.props.pauseOnFocusLoss) {
        this.bindFocusEvents();
      }
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (prevProps.draggable !== this.props.draggable) {
        if (this.props.draggable) {
          this.bindDragEvents();
        } else {
          this.unbindDragEvents();
        }
      }

      if (prevProps.pauseOnFocusLoss !== this.props.pauseOnFocusLoss) {
        if (this.props.pauseOnFocusLoss) {
          this.bindFocusEvents();
        } else {
          this.unbindFocusEvents();
        }
      }
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.props.onClose(this.props.children.props);

      if (this.props.draggable) {
        this.unbindDragEvents();
      }

      if (this.props.pauseOnFocusLoss) {
        this.unbindFocusEvents();
      }
    };

    _proto.bindFocusEvents = function bindFocusEvents() {
      window.addEventListener('focus', this.playToast);
      window.addEventListener('blur', this.pauseToast);
    };

    _proto.unbindFocusEvents = function unbindFocusEvents() {
      window.removeEventListener('focus', this.playToast);
      window.removeEventListener('blur', this.pauseToast);
    };

    _proto.bindDragEvents = function bindDragEvents() {
      document.addEventListener('mousemove', this.onDragMove);
      document.addEventListener('mouseup', this.onDragEnd);
      document.addEventListener('touchmove', this.onDragMove);
      document.addEventListener('touchend', this.onDragEnd);
    };

    _proto.unbindDragEvents = function unbindDragEvents() {
      document.removeEventListener('mousemove', this.onDragMove);
      document.removeEventListener('mouseup', this.onDragEnd);
      document.removeEventListener('touchmove', this.onDragMove);
      document.removeEventListener('touchend', this.onDragEnd);
    };

    _proto.render = function render() {
      var _cx,
          _this2 = this;

      var _this$props = this.props,
          closeButton = _this$props.closeButton,
          children = _this$props.children,
          autoClose = _this$props.autoClose,
          pauseOnHover = _this$props.pauseOnHover,
          onClick = _this$props.onClick,
          closeOnClick = _this$props.closeOnClick,
          type = _this$props.type,
          hideProgressBar = _this$props.hideProgressBar,
          closeToast = _this$props.closeToast,
          Transition = _this$props.transition,
          position = _this$props.position,
          className = _this$props.className,
          bodyClassName = _this$props.bodyClassName,
          progressClassName = _this$props.progressClassName,
          progressStyle = _this$props.progressStyle,
          updateId = _this$props.updateId,
          role = _this$props.role,
          progress = _this$props.progress,
          rtl = _this$props.rtl;
      var toastProps = {
        className: classnames$1(RT_NAMESPACE + "__toast", RT_NAMESPACE + "__toast--" + type, (_cx = {}, _cx[RT_NAMESPACE + "__toast--rtl"] = rtl, _cx), className)
      };

      if (autoClose && pauseOnHover) {
        toastProps.onMouseEnter = this.pauseToast;
        toastProps.onMouseLeave = this.playToast;
      } // prevent toast from closing when user drags the toast


      if (closeOnClick) {
        toastProps.onClick = function (e) {
          onClick && onClick(e);
          _this2.flag.canCloseOnClick && closeToast();
        };
      }

      var controlledProgress = parseFloat(progress) === progress;
      return React$2__default.createElement(Transition, {
        in: this.props.in,
        appear: true,
        onExited: this.onExitTransitionEnd,
        position: position,
        preventExitTransition: this.state.preventExitTransition
      }, React$2__default.createElement("div", _extends$f({
        onClick: onClick
      }, toastProps, {
        ref: function ref(_ref) {
          return _this2.ref = _ref;
        },
        onMouseDown: this.onDragStart,
        onTouchStart: this.onDragStart,
        onMouseUp: this.onDragTransitionEnd,
        onTouchEnd: this.onDragTransitionEnd
      }), React$2__default.createElement("div", _extends$f({}, this.props.in && {
        role: role
      }, {
        className: classnames$1(RT_NAMESPACE + "__toast-body", bodyClassName)
      }), children), closeButton && closeButton, (autoClose || controlledProgress) && React$2__default.createElement(ProgressBar, _extends$f({}, updateId && !controlledProgress ? {
        key: "pb-" + updateId
      } : {}, {
        rtl: rtl,
        delay: autoClose,
        isRunning: this.state.isRunning,
        closeToast: closeToast,
        hide: hideProgressBar,
        type: type,
        style: progressStyle,
        className: progressClassName,
        controlledProgress: controlledProgress,
        progress: progress
      }))));
    };

    return Toast;
  }(React$2.Component);

  Toast.propTypes = {
    closeButton: propTypes.oneOfType([propTypes.node, propTypes.bool]).isRequired,
    autoClose: falseOrDelay.isRequired,
    children: propTypes.node.isRequired,
    closeToast: propTypes.func.isRequired,
    position: propTypes.oneOf(objectValues(POSITION)).isRequired,
    pauseOnHover: propTypes.bool.isRequired,
    pauseOnFocusLoss: propTypes.bool.isRequired,
    closeOnClick: propTypes.bool.isRequired,
    transition: propTypes.func.isRequired,
    rtl: propTypes.bool.isRequired,
    hideProgressBar: propTypes.bool.isRequired,
    draggable: propTypes.bool.isRequired,
    draggablePercent: propTypes.number.isRequired,
    in: propTypes.bool,
    onExited: propTypes.func,
    onOpen: propTypes.func,
    onClose: propTypes.func,
    type: propTypes.oneOf(objectValues(TYPE)),
    className: propTypes.oneOfType([propTypes.string, propTypes.object]),
    bodyClassName: propTypes.oneOfType([propTypes.string, propTypes.object]),
    progressClassName: propTypes.oneOfType([propTypes.string, propTypes.object]),
    progressStyle: propTypes.object,
    progress: propTypes.number,
    updateId: propTypes.oneOfType([propTypes.string, propTypes.number]),
    ariaLabel: propTypes.string,
    containerId: propTypes.oneOfType([propTypes.string, propTypes.number]),
    role: propTypes.string
  };
  Toast.defaultProps = {
    type: TYPE.DEFAULT,
    in: true,
    onOpen: NOOP,
    onClose: NOOP,
    className: null,
    bodyClassName: null,
    progressClassName: null,
    updateId: null
  };

  function CloseButton(_ref) {
    var closeToast = _ref.closeToast,
        type = _ref.type,
        ariaLabel = _ref.ariaLabel;
    return React$2__default.createElement("button", {
      className: RT_NAMESPACE + "__close-button " + RT_NAMESPACE + "__close-button--" + type,
      type: "button",
      onClick: function onClick(e) {
        e.stopPropagation();
        closeToast(e);
      },
      "aria-label": ariaLabel
    }, "\u2716\uFE0E");
  }

  CloseButton.propTypes = {
    closeToast: propTypes.func,
    arialLabel: propTypes.string
  };
  CloseButton.defaultProps = {
    ariaLabel: 'close'
  };

  var Bounce = cssTransition({
    enter: RT_NAMESPACE + "__bounce-enter",
    exit: RT_NAMESPACE + "__bounce-exit",
    appendPosition: true
  });
  var Slide = cssTransition({
    enter: RT_NAMESPACE + "__slide-enter",
    exit: RT_NAMESPACE + "__slide-exit",
    duration: [450, 750],
    appendPosition: true
  });
  var Zoom = cssTransition({
    enter: RT_NAMESPACE + "__zoom-enter",
    exit: RT_NAMESPACE + "__zoom-exit"
  });
  var Flip = cssTransition({
    enter: RT_NAMESPACE + "__flip-enter",
    exit: RT_NAMESPACE + "__flip-exit"
  });

  var ToastContainer =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose$8(ToastContainer, _Component);

    function ToastContainer() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _Component.call.apply(_Component, [this].concat(args)) || this;
      _this.state = {
        toast: []
      };
      _this.toastKey = 1;
      _this.collection = {};

      _this.isToastActive = function (id) {
        return _this.state.toast.indexOf(id) !== -1;
      };

      return _this;
    }

    var _proto = ToastContainer.prototype;

    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;

      eventManager.cancelEmit(ACTION.WILL_UNMOUNT).on(ACTION.SHOW, function (content, options) {
        return _this2.ref ? _this2.buildToast(content, options) : null;
      }).on(ACTION.CLEAR, function (id) {
        return !_this2.ref ? null : id == null ? _this2.clear() : _this2.removeToast(id);
      }).emit(ACTION.DID_MOUNT, this);
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      eventManager.emit(ACTION.WILL_UNMOUNT, this);
    };

    _proto.removeToast = function removeToast(id) {
      this.setState({
        toast: this.state.toast.filter(function (v) {
          return v !== id;
        })
      }, this.dispatchChange);
    };

    _proto.dispatchChange = function dispatchChange() {
      eventManager.emit(ACTION.ON_CHANGE, this.state.toast.length, this.props.containerId);
    };

    _proto.makeCloseButton = function makeCloseButton(toastClose, toastId, type) {
      var _this3 = this;

      var closeButton = this.props.closeButton;

      if (React$2.isValidElement(toastClose) || toastClose === false) {
        closeButton = toastClose;
      } else if (toastClose === true) {
        closeButton = this.props.closeButton && typeof this.props.closeButton !== 'boolean' ? this.props.closeButton : React$2__default.createElement(CloseButton, null);
      }

      return closeButton === false ? false : React$2.cloneElement(closeButton, {
        closeToast: function closeToast() {
          return _this3.removeToast(toastId);
        },
        type: type
      });
    };

    _proto.getAutoCloseDelay = function getAutoCloseDelay(toastAutoClose) {
      return toastAutoClose === false || isValidDelay(toastAutoClose) ? toastAutoClose : this.props.autoClose;
    };

    _proto.canBeRendered = function canBeRendered(content) {
      return React$2.isValidElement(content) || typeof content === 'string' || typeof content === 'number' || typeof content === 'function';
    };

    _proto.parseClassName = function parseClassName(prop) {
      if (typeof prop === 'string') {
        return prop;
      } else if (prop !== null && typeof prop === 'object' && 'toString' in prop) {
        return prop.toString();
      }

      return null;
    };

    _proto.belongToContainer = function belongToContainer(_ref) {
      var containerId = _ref.containerId;
      return containerId === this.props.containerId;
    };

    _proto.buildToast = function buildToast(content, _ref2) {
      var _this4 = this;

      var delay = _ref2.delay,
          options = _objectWithoutPropertiesLoose$7(_ref2, ["delay"]);

      if (!this.canBeRendered(content)) {
        throw new Error("The element you provided cannot be rendered. You provided an element of type " + typeof content);
      }

      var toastId = options.toastId,
          updateId = options.updateId; // Check for multi-container and also for duplicate toastId
      // Maybe it would be better to extract it

      if (this.props.enableMultiContainer && !this.belongToContainer(options) || this.isToastActive(toastId) && updateId == null) {
        return;
      }

      var closeToast = function closeToast() {
        return _this4.removeToast(toastId);
      };

      var toastOptions = {
        id: toastId,
        // ⚠️ if no options.key, this.toastKey - 1 is assigned
        key: options.key || this.toastKey++,
        type: options.type,
        closeToast: closeToast,
        updateId: options.updateId,
        rtl: this.props.rtl,
        position: options.position || this.props.position,
        transition: options.transition || this.props.transition,
        className: this.parseClassName(options.className || this.props.toastClassName),
        bodyClassName: this.parseClassName(options.bodyClassName || this.props.bodyClassName),
        onClick: options.onClick || this.props.onClick,
        closeButton: this.makeCloseButton(options.closeButton, toastId, options.type),
        pauseOnHover: typeof options.pauseOnHover === 'boolean' ? options.pauseOnHover : this.props.pauseOnHover,
        pauseOnFocusLoss: typeof options.pauseOnFocusLoss === 'boolean' ? options.pauseOnFocusLoss : this.props.pauseOnFocusLoss,
        draggable: typeof options.draggable === 'boolean' ? options.draggable : this.props.draggable,
        draggablePercent: typeof options.draggablePercent === 'number' && !isNaN(options.draggablePercent) ? options.draggablePercent : this.props.draggablePercent,
        closeOnClick: typeof options.closeOnClick === 'boolean' ? options.closeOnClick : this.props.closeOnClick,
        progressClassName: this.parseClassName(options.progressClassName || this.props.progressClassName),
        progressStyle: this.props.progressStyle,
        autoClose: this.getAutoCloseDelay(options.autoClose),
        hideProgressBar: typeof options.hideProgressBar === 'boolean' ? options.hideProgressBar : this.props.hideProgressBar,
        progress: parseFloat(options.progress),
        role: typeof options.role === 'string' ? options.role : this.props.role
      };
      typeof options.onOpen === 'function' && (toastOptions.onOpen = options.onOpen);
      typeof options.onClose === 'function' && (toastOptions.onClose = options.onClose); // add closeToast function to react component only

      if (React$2.isValidElement(content) && typeof content.type !== 'string' && typeof content.type !== 'number') {
        content = React$2.cloneElement(content, {
          closeToast: closeToast
        });
      } else if (typeof content === 'function') {
        content = content({
          closeToast: closeToast
        });
      }

      if (isValidDelay(delay)) {
        setTimeout(function () {
          _this4.appendToast(toastOptions, content, options.staleToastId);
        }, delay);
      } else {
        this.appendToast(toastOptions, content, options.staleToastId);
      }
    };

    _proto.appendToast = function appendToast(options, content, staleToastId) {
      var _extends2;

      var id = options.id,
          updateId = options.updateId;
      this.collection = _extends$f({}, this.collection, (_extends2 = {}, _extends2[id] = {
        options: options,
        content: content,
        position: options.position
      }, _extends2));
      this.setState({
        toast: (updateId ? [].concat(this.state.toast) : [].concat(this.state.toast, [id])).filter(function (id) {
          return id !== staleToastId;
        })
      }, this.dispatchChange);
    };

    _proto.clear = function clear() {
      this.setState({
        toast: []
      });
    };

    _proto.renderToast = function renderToast() {
      var _this5 = this;

      var toastToRender = {};
      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          newestOnTop = _this$props.newestOnTop;
      var collection = newestOnTop ? Object.keys(this.collection).reverse() : Object.keys(this.collection); // group toast by position

      collection.forEach(function (toastId) {
        var _this5$collection$toa = _this5.collection[toastId],
            position = _this5$collection$toa.position,
            options = _this5$collection$toa.options,
            content = _this5$collection$toa.content;
        toastToRender[position] || (toastToRender[position] = []);

        if (_this5.state.toast.indexOf(options.id) !== -1) {
          toastToRender[position].push(React$2__default.createElement(Toast, _extends$f({}, options, {
            isDocumentHidden: _this5.state.isDocumentHidden,
            key: "toast-" + options.key
          }), content));
        } else {
          toastToRender[position].push(null);
          delete _this5.collection[toastId];
        }
      });
      return Object.keys(toastToRender).map(function (position) {
        var _cx;

        var disablePointer = toastToRender[position].length === 1 && toastToRender[position][0] === null;
        var props = {
          className: classnames$1(RT_NAMESPACE + "__toast-container", RT_NAMESPACE + "__toast-container--" + position, (_cx = {}, _cx[RT_NAMESPACE + "__toast-container--rtl"] = _this5.props.rtl, _cx), _this5.parseClassName(className)),
          style: disablePointer ? _extends$f({}, style, {
            pointerEvents: 'none'
          }) : _extends$f({}, style)
        };
        return React$2__default.createElement(TransitionGroup, _extends$f({}, props, {
          key: "container-" + position
        }), toastToRender[position]);
      });
    };

    _proto.render = function render() {
      var _this6 = this;

      return React$2__default.createElement("div", {
        ref: function ref(node) {
          return _this6.ref = node;
        },
        className: "" + RT_NAMESPACE
      }, this.renderToast());
    };

    return ToastContainer;
  }(React$2.Component);

  ToastContainer.propTypes = {
    /**
     * Set toast position
     */
    position: propTypes.oneOf(objectValues(POSITION)),

    /**
     * Disable or set autoClose delay
     */
    autoClose: falseOrDelay,

    /**
     * Disable or set a custom react element for the close button
     */
    closeButton: propTypes.oneOfType([propTypes.node, propTypes.bool]),

    /**
     * Hide or not progress bar when autoClose is enabled
     */
    hideProgressBar: propTypes.bool,

    /**
     * Pause toast duration on hover
     */
    pauseOnHover: propTypes.bool,

    /**
     * Dismiss toast on click
     */
    closeOnClick: propTypes.bool,

    /**
     * Newest on top
     */
    newestOnTop: propTypes.bool,

    /**
     * An optional className
     */
    className: propTypes.oneOfType([propTypes.string, propTypes.object]),

    /**
     * An optional style
     */
    style: propTypes.object,

    /**
     * An optional className for the toast
     */
    toastClassName: propTypes.oneOfType([propTypes.string, propTypes.object]),

    /**
     * An optional className for the toast body
     */
    bodyClassName: propTypes.oneOfType([propTypes.string, propTypes.object]),

    /**
     * An optional className for the toast progress bar
     */
    progressClassName: propTypes.oneOfType([propTypes.string, propTypes.object]),

    /**
     * An optional style for the toast progress bar
     */
    progressStyle: propTypes.object,

    /**
     * Define enter and exit transition using react-transition-group
     */
    transition: propTypes.func,

    /**
     * Support rtl display
     */
    rtl: propTypes.bool,

    /**
     * Allow toast to be draggable
     */
    draggable: propTypes.bool,

    /**
     * The percentage of the toast's width it takes for a drag to dismiss a toast
     */
    draggablePercent: propTypes.number,

    /**
     * Pause the toast on focus loss
     */
    pauseOnFocusLoss: propTypes.bool,

    /**
     * Show the toast only if it includes containerId and it's the same as containerId
     */
    enableMultiContainer: propTypes.bool,

    /**
     * Set id to handle multiple container
     */
    containerId: propTypes.oneOfType([propTypes.string, propTypes.number]),

    /**
     * Set role attribute for the toast body
     */
    role: propTypes.string,

    /**
     * Fired when clicking inside toaster
     */
    onClick: propTypes.func
  };
  ToastContainer.defaultProps = {
    position: POSITION.TOP_RIGHT,
    transition: Bounce,
    rtl: false,
    autoClose: 5000,
    hideProgressBar: false,
    closeButton: React$2__default.createElement(CloseButton, null),
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    newestOnTop: false,
    draggable: true,
    draggablePercent: 80,
    className: null,
    style: null,
    toastClassName: null,
    bodyClassName: null,
    progressClassName: null,
    progressStyle: null,
    role: 'alert'
  };

  var containers = new Map();
  var latestInstance = null;
  var containerDomNode = null;
  var containerConfig = {};
  var queue = [];
  var lazy = false;
  /**
   * Check whether any container is currently mounted in the DOM
   */

  function isAnyContainerMounted() {
    return containers.size > 0;
  }
  /**
   * Get the container by id. Returns the last container declared when no id is given.
   */


  function getContainer(containerId) {
    if (!isAnyContainerMounted()) return null;
    if (!containerId) return containers.get(latestInstance);
    return containers.get(containerId);
  }
  /**
   * Get the toast by id, given it's in the DOM, otherwise returns null
   */


  function getToast(toastId, _ref) {
    var containerId = _ref.containerId;
    var container = getContainer(containerId);
    if (!container) return null;
    var toast = container.collection[toastId];
    if (typeof toast === 'undefined') return null;
    return toast;
  }
  /**
   * Merge provided options with the defaults settings and generate the toastId
   */


  function mergeOptions(options, type) {
    return _extends$f({}, options, {
      type: type,
      toastId: getToastId(options)
    });
  }
  /**
   * Generate a random toastId
   */


  function generateToastId() {
    return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
  }
  /**
   * Generate a toastId or use the one provided
   */


  function getToastId(options) {
    if (options && (typeof options.toastId === 'string' || typeof options.toastId === 'number' && !isNaN(options.toastId))) {
      return options.toastId;
    }

    return generateToastId();
  }
  /**
   * If the container is not mounted, the toast is enqueued and
   * the container lazy mounted
   */


  function dispatchToast(content, options) {
    if (isAnyContainerMounted()) {
      eventManager.emit(ACTION.SHOW, content, options);
    } else {
      queue.push({
        action: ACTION.SHOW,
        content: content,
        options: options
      });

      if (lazy && canUseDom) {
        lazy = false;
        containerDomNode = document.createElement('div');
        document.body.appendChild(containerDomNode);
        ReactDOM.render(React$2__default.createElement(ToastContainer, containerConfig), containerDomNode);
      }
    }

    return options.toastId;
  }

  var toast = function toast(content, options) {
    return dispatchToast(content, mergeOptions(options, options && options.type || TYPE.DEFAULT));
  };
  /**
   * For each available type create a shortcut
   */


  var _loop = function _loop(t) {
    if (TYPE[t] !== TYPE.DEFAULT) {
      toast[TYPE[t].toLowerCase()] = function (content, options) {
        return dispatchToast(content, mergeOptions(options, options && options.type || TYPE[t]));
      };
    }
  };

  for (var t$1 in TYPE) {
    _loop(t$1);
  }
  /**
   * Maybe I should remove warning in favor of warn, I don't know
   */


  toast.warn = toast.warning;
  /**
   * Remove toast programmaticaly
   */

  toast.dismiss = function (id) {
    if (id === void 0) {
      id = null;
    }

    return isAnyContainerMounted() && eventManager.emit(ACTION.CLEAR, id);
  };
  /**
   * return true if one container is displaying the toast
   */


  toast.isActive = function (id) {
    var isToastActive = false;

    if (containers.size > 0) {
      containers.forEach(function (container) {
        if (container.isToastActive(id)) {
          isToastActive = true;
        }
      });
    }

    return isToastActive;
  };

  toast.update = function (toastId, options) {
    if (options === void 0) {
      options = {};
    }

    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function () {
      var toast = getToast(toastId, options);

      if (toast) {
        var oldOptions = toast.options,
            oldContent = toast.content;

        var nextOptions = _extends$f({}, oldOptions, {}, options, {
          toastId: options.toastId || toastId
        });

        if (!options.toastId || options.toastId === toastId) {
          nextOptions.updateId = generateToastId();
        } else {
          nextOptions.staleToastId = toastId;
        }

        var content = typeof nextOptions.render !== 'undefined' ? nextOptions.render : oldContent;
        delete nextOptions.render;
        dispatchToast(content, nextOptions);
      }
    }, 0);
  };
  /**
   * Used for controlled progress bar.
   */


  toast.done = function (id) {
    toast.update(id, {
      progress: 1
    });
  };
  /**
   * Track changes. The callback get the number of toast displayed
   */


  toast.onChange = function (callback) {
    if (typeof callback === 'function') {
      eventManager.on(ACTION.ON_CHANGE, callback);
    }
  };
  /**
   * Configure the ToastContainer when lazy mounted
   */


  toast.configure = function (config) {
    lazy = true;
    containerConfig = config;
  };

  toast.POSITION = POSITION;
  toast.TYPE = TYPE;
  /**
   * Wait until the ToastContainer is mounted to dispatch the toast
   * and attach isActive method
   */

  eventManager.on(ACTION.DID_MOUNT, function (containerInstance) {
    latestInstance = containerInstance.props.containerId || containerInstance;
    containers.set(latestInstance, containerInstance);
    queue.forEach(function (item) {
      eventManager.emit(item.action, item.content, item.options);
    });
    queue = [];
  }).on(ACTION.WILL_UNMOUNT, function (containerInstance) {
    if (containerInstance) containers.delete(containerInstance.props.containerId || containerInstance);else containers.clear();

    if (containers.size === 0) {
      eventManager.off(ACTION.SHOW).off(ACTION.CLEAR);
    }

    if (canUseDom && containerDomNode) {
      document.body.removeChild(containerDomNode);
    }
  });

  /** @type {import('react').FC} */

  var ToastComponent = function ToastComponent() {
    return /*#__PURE__*/React$2__default.createElement(ToastContainer, {
      containerId: "TOAST",
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: true,
      newestOnTop: false,
      closeOnClick: true,
      rtl: false,
      pauseOnVisibilityChange: true,
      draggable: true,
      pauseOnHover: false
    });
  };
  /** @type {(text: string, autoCloseTime: number|boolean) => void} */

  var showToast = function showToast() {
    var text = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Erro, por favor tente mais tarde';
    var autoCloseTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3000;
    toast.dismiss();
    return toast(text, {
      position: 'bottom-center',
      autoClose: autoCloseTime,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true
    });
  };

  function _templateObject$l() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'CenturyGothic', sans-serif;\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 20px;\n\n  display: block;\n\n  color: ", ";\n"]);

    _templateObject$l = function _templateObject() {
      return data;
    };

    return data;
  }
  var StyledLabel = styled__default.label(_templateObject$l(), function (_ref) {
    var isDark = _ref.isDark;
    return isDark ? theme.colors.grey400 : theme.colors.blue900;
  });

  /**
   * @typedef {object} LabelProps
   * @property {string} text
   * @property {boolean} [isDark]
   */

  /** @type {import('react').FC<LabelProps>} */

  var Label = function Label(_ref) {
    var text = _ref.text,
        _ref$isDark = _ref.isDark,
        isDark = _ref$isDark === void 0 ? false : _ref$isDark;
    return /*#__PURE__*/React$2__default.createElement(StyledLabel, {
      isDark: isDark
    }, text);
  };

  /*! *****************************************************************************
  Copyright (c) Microsoft Corporation.

  Permission to use, copy, modify, and/or distribute this software for any
  purpose with or without fee is hereby granted.

  THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
  REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
  AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
  INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
  LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
  OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
  PERFORMANCE OF THIS SOFTWARE.
  ***************************************************************************** */

  function __awaiter(thisArg, _arguments, P, generator) {
      function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
      return new (P || (P = Promise))(function (resolve, reject) {
          function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
          function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
          function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
          step((generator = generator.apply(thisArg, _arguments || [])).next());
      });
  }

  function __generator(thisArg, body) {
      var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
      return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
      function verb(n) { return function (v) { return step([n, v]); }; }
      function step(op) {
          if (f) throw new TypeError("Generator is already executing.");
          while (_) try {
              if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
              if (y = 0, t) op = [op[0] & 2, t.value];
              switch (op[0]) {
                  case 0: case 1: t = op; break;
                  case 4: _.label++; return { value: op[1], done: false };
                  case 5: _.label++; y = op[1]; op = [0]; continue;
                  case 7: op = _.ops.pop(); _.trys.pop(); continue;
                  default:
                      if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                      if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                      if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                      if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                      if (t[2]) _.ops.pop();
                      _.trys.pop(); continue;
              }
              op = body.call(thisArg, _);
          } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
          if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
      }
  }

  function __read$1(o, n) {
      var m = typeof Symbol === "function" && o[Symbol.iterator];
      if (!m) return o;
      var i = m.call(o), r, ar = [], e;
      try {
          while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
      }
      catch (error) { e = { error: error }; }
      finally {
          try {
              if (r && !r.done && (m = i["return"])) m.call(i);
          }
          finally { if (e) throw e.error; }
      }
      return ar;
  }

  function __spread$1() {
      for (var ar = [], i = 0; i < arguments.length; i++)
          ar = ar.concat(__read$1(arguments[i]));
      return ar;
  }

  var COMMON_MIME_TYPES = new Map([
      ['avi', 'video/avi'],
      ['gif', 'image/gif'],
      ['ico', 'image/x-icon'],
      ['jpeg', 'image/jpeg'],
      ['jpg', 'image/jpeg'],
      ['mkv', 'video/x-matroska'],
      ['mov', 'video/quicktime'],
      ['mp4', 'video/mp4'],
      ['pdf', 'application/pdf'],
      ['png', 'image/png'],
      ['zip', 'application/zip'],
      ['doc', 'application/msword'],
      ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
  ]);
  function toFileWithPath(file, path) {
      var f = withMimeType(file);
      if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
          var webkitRelativePath = file.webkitRelativePath;
          Object.defineProperty(f, 'path', {
              value: typeof path === 'string'
                  ? path
                  // If <input webkitdirectory> is set,
                  // the File will have a {webkitRelativePath} property
                  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                  : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                      ? webkitRelativePath
                      : file.name,
              writable: false,
              configurable: false,
              enumerable: true
          });
      }
      return f;
  }
  function withMimeType(file) {
      var name = file.name;
      var hasExtension = name && name.lastIndexOf('.') !== -1;
      if (hasExtension && !file.type) {
          var ext = name.split('.')
              .pop().toLowerCase();
          var type = COMMON_MIME_TYPES.get(ext);
          if (type) {
              Object.defineProperty(file, 'type', {
                  value: type,
                  writable: false,
                  configurable: false,
                  enumerable: true
              });
          }
      }
      return file;
  }

  var FILES_TO_IGNORE = [
      // Thumbnail cache files for macOS and Windows
      '.DS_Store',
      'Thumbs.db' // Windows
  ];
  /**
   * Convert a DragEvent's DataTrasfer object to a list of File objects
   * NOTE: If some of the items are folders,
   * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
   * @param evt
   */
  function fromEvent(evt) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                      ? getDataTransferFiles(evt.dataTransfer, evt.type)
                      : getInputFiles(evt)];
          });
      });
  }
  function isDragEvt(value) {
      return !!value.dataTransfer;
  }
  function getInputFiles(evt) {
      var files = isInput(evt.target)
          ? evt.target.files
              ? fromList(evt.target.files)
              : []
          : [];
      return files.map(function (file) { return toFileWithPath(file); });
  }
  function isInput(value) {
      return value !== null;
  }
  function getDataTransferFiles(dt, type) {
      return __awaiter(this, void 0, void 0, function () {
          var items, files;
          return __generator(this, function (_a) {
              switch (_a.label) {
                  case 0:
                      if (!dt.items) return [3 /*break*/, 2];
                      items = fromList(dt.items)
                          .filter(function (item) { return item.kind === 'file'; });
                      // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                      // only 'dragstart' and 'drop' has access to the data (source node)
                      if (type !== 'drop') {
                          return [2 /*return*/, items];
                      }
                      return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                  case 1:
                      files = _a.sent();
                      return [2 /*return*/, noIgnoredFiles(flatten(files))];
                  case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                          .map(function (file) { return toFileWithPath(file); }))];
              }
          });
      });
  }
  function noIgnoredFiles(files) {
      return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
  }
  // IE11 does not support Array.from()
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
  // https://developer.mozilla.org/en-US/docs/Web/API/FileList
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
  function fromList(items) {
      var files = [];
      // tslint:disable: prefer-for-of
      for (var i = 0; i < items.length; i++) {
          var file = items[i];
          files.push(file);
      }
      return files;
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
  function toFilePromises(item) {
      if (typeof item.webkitGetAsEntry !== 'function') {
          return fromDataTransferItem(item);
      }
      var entry = item.webkitGetAsEntry();
      // Safari supports dropping an image node from a different window and can be retrieved using
      // the DataTransferItem.getAsFile() API
      // NOTE: FileSystemEntry.file() throws if trying to get the file
      if (entry && entry.isDirectory) {
          return fromDirEntry(entry);
      }
      return fromDataTransferItem(item);
  }
  function flatten(items) {
      return items.reduce(function (acc, files) { return __spread$1(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
  }
  function fromDataTransferItem(item) {
      var file = item.getAsFile();
      if (!file) {
          return Promise.reject(item + " is not a File");
      }
      var fwp = toFileWithPath(file);
      return Promise.resolve(fwp);
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
  function fromEntry(entry) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
          });
      });
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
  function fromDirEntry(entry) {
      var reader = entry.createReader();
      return new Promise(function (resolve, reject) {
          var entries = [];
          function readEntries() {
              var _this = this;
              // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
              // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
              reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                  var files, err_1, items;
                  return __generator(this, function (_a) {
                      switch (_a.label) {
                          case 0:
                              if (!!batch.length) return [3 /*break*/, 5];
                              _a.label = 1;
                          case 1:
                              _a.trys.push([1, 3, , 4]);
                              return [4 /*yield*/, Promise.all(entries)];
                          case 2:
                              files = _a.sent();
                              resolve(files);
                              return [3 /*break*/, 4];
                          case 3:
                              err_1 = _a.sent();
                              reject(err_1);
                              return [3 /*break*/, 4];
                          case 4: return [3 /*break*/, 6];
                          case 5:
                              items = Promise.all(batch.map(fromEntry));
                              entries.push(items);
                              // Continue reading
                              readEntries();
                              _a.label = 6;
                          case 6: return [2 /*return*/];
                      }
                  });
              }); }, function (err) {
                  reject(err);
              });
          }
          readEntries();
      });
  }
  // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
  function fromFileEntry(entry) {
      return __awaiter(this, void 0, void 0, function () {
          return __generator(this, function (_a) {
              return [2 /*return*/, new Promise(function (resolve, reject) {
                      entry.file(function (file) {
                          var fwp = toFileWithPath(file, entry.fullPath);
                          resolve(fwp);
                      }, function (err) {
                          reject(err);
                      });
                  })];
          });
      });
  }

  var es = createCommonjsModule(function (module, exports) {

  exports.__esModule = true;

  exports.default = function (file, acceptedFiles) {
    if (file && acceptedFiles) {
      var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
      var fileName = file.name || '';
      var mimeType = (file.type || '').toLowerCase();
      var baseMimeType = mimeType.replace(/\/.*$/, '');
      return acceptedFilesArray.some(function (type) {
        var validType = type.trim().toLowerCase();

        if (validType.charAt(0) === '.') {
          return fileName.toLowerCase().endsWith(validType);
        } else if (validType.endsWith('/*')) {
          // This is something like a image/* mime type
          return baseMimeType === validType.replace(/\/.*$/, '');
        }

        return mimeType === validType;
      });
    }

    return true;
  };
  });

  var accepts = unwrapExports(es);

  function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

  function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

  function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

  var FILE_INVALID_TYPE = 'file-invalid-type';
  var FILE_TOO_LARGE = 'file-too-large';
  var FILE_TOO_SMALL = 'file-too-small';
  var TOO_MANY_FILES = 'too-many-files'; // File Errors

  var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
    return {
      code: FILE_INVALID_TYPE,
      message: "File type must be ".concat(messageSuffix)
    };
  };
  var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
    return {
      code: FILE_TOO_LARGE,
      message: "File is larger than ".concat(maxSize, " bytes")
    };
  };
  var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
    return {
      code: FILE_TOO_SMALL,
      message: "File is smaller than ".concat(minSize, " bytes")
    };
  };
  var TOO_MANY_FILES_REJECTION = {
    code: TOO_MANY_FILES,
    message: 'Too many files'
  }; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
  // that MIME type will always be accepted

  function fileAccepted(file, accept) {
    var isAcceptable = file.type === 'application/x-moz-file' || accepts(file, accept);
    return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
  }
  function fileMatchSize(file, minSize, maxSize) {
    if (isDefined(file.size)) {
      if (isDefined(minSize) && isDefined(maxSize)) {
        if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
        if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
      } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
    }

    return [true, null];
  }

  function isDefined(value) {
    return value !== undefined && value !== null;
  }

  function allFilesAccepted(_ref) {
    var files = _ref.files,
        accept = _ref.accept,
        minSize = _ref.minSize,
        maxSize = _ref.maxSize,
        multiple = _ref.multiple,
        maxFiles = _ref.maxFiles;

    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
      return false;
    }

    return files.every(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
          _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
          accepted = _fileAccepted2[0];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
          sizeMatch = _fileMatchSize2[0];

      return accepted && sizeMatch;
    });
  } // React's synthetic events has event.isPropagationStopped,
  // but to remain compatibility with other libs (Preact) fall back
  // to check event.cancelBubble

  function isPropagationStopped(event) {
    if (typeof event.isPropagationStopped === 'function') {
      return event.isPropagationStopped();
    } else if (typeof event.cancelBubble !== 'undefined') {
      return event.cancelBubble;
    }

    return false;
  }
  function isEvtWithFiles(event) {
    if (!event.dataTransfer) {
      return !!event.target && !!event.target.files;
    } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


    return Array.prototype.some.call(event.dataTransfer.types, function (type) {
      return type === 'Files' || type === 'application/x-moz-file';
    });
  }

  function onDocumentDragOver(event) {
    event.preventDefault();
  }

  function isIe(userAgent) {
    return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
  }

  function isEdge(userAgent) {
    return userAgent.indexOf('Edge/') !== -1;
  }

  function isIeOrEdge() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return isIe(userAgent) || isEdge(userAgent);
  }
  /**
   * This is intended to be used to compose event handlers
   * They are executed in order until one of them calls `event.isPropagationStopped()`.
   * Note that the check is done on the first invoke too,
   * meaning that if propagation was stopped before invoking the fns,
   * no handlers will be executed.
   *
   * @param {Function} fns the event hanlder functions
   * @return {Function} the event handler to add to an element
   */

  function composeEventHandlers() {
    for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
      fns[_key] = arguments[_key];
    }

    return function (event) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      return fns.some(function (fn) {
        if (!isPropagationStopped(event) && fn) {
          fn.apply(void 0, [event].concat(args));
        }

        return isPropagationStopped(event);
      });
    };
  }

  function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray$2(arr) || _nonIterableSpread(); }

  function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

  function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray$2(arr); }

  function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$2(arr, i) || _nonIterableRest$2(); }

  function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

  function _unsupportedIterableToArray$2(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$2(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$2(o, minLen); }

  function _arrayLikeToArray$2(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

  function _iterableToArrayLimit$2(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

  function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

  function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

  function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$8(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

  function _objectWithoutPropertiesLoose$8(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
  /**
   * Convenience wrapper component for the `useDropzone` hook
   *
   * ```jsx
   * <Dropzone>
   *   {({getRootProps, getInputProps}) => (
   *     <div {...getRootProps()}>
   *       <input {...getInputProps()} />
   *       <p>Drag 'n' drop some files here, or click to select files</p>
   *     </div>
   *   )}
   * </Dropzone>
   * ```
   */

  var Dropzone = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
    var children = _ref.children,
        params = _objectWithoutProperties$1(_ref, ["children"]);

    var _useDropzone = useDropzone(params),
        open = _useDropzone.open,
        props = _objectWithoutProperties$1(_useDropzone, ["open"]);

    React$2.useImperativeHandle(ref, function () {
      return {
        open: open
      };
    }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

    return /*#__PURE__*/React$2__default.createElement(React$2.Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
      open: open
    })));
  });
  Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

  var defaultProps$3 = {
    disabled: false,
    getFilesFromEvent: fromEvent,
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false
  };
  Dropzone.defaultProps = defaultProps$3;
  Dropzone.propTypes = {
    /**
     * Render function that exposes the dropzone state and prop getter fns
     *
     * @param {object} params
     * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
     * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
     * @param {Function} params.open Open the native file selection dialog
     * @param {boolean} params.isFocused Dropzone area is in focus
     * @param {boolean} params.isFileDialogActive File dialog is opened
     * @param {boolean} params.isDragActive Active drag is in progress
     * @param {boolean} params.isDragAccept Dragged files are accepted
     * @param {boolean} params.isDragReject Some dragged files are rejected
     * @param {File[]} params.draggedFiles Files in active drag
     * @param {File[]} params.acceptedFiles Accepted files
     * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
     */
    children: propTypes.func,

    /**
     * Set accepted file types.
     * See https://github.com/okonet/attr-accept for more information.
     * Keep in mind that mime type determination is not reliable across platforms. CSV files,
     * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
     * Windows. In some cases there might not be a mime type set at all.
     * See: https://github.com/react-dropzone/react-dropzone/issues/276
     */
    accept: propTypes.oneOfType([propTypes.string, propTypes.arrayOf(propTypes.string)]),

    /**
     * Allow drag 'n' drop (or selection from the file dialog) of multiple files
     */
    multiple: propTypes.bool,

    /**
     * If false, allow dropped items to take over the current browser window
     */
    preventDropOnDocument: propTypes.bool,

    /**
     * If true, disables click to open the native file selection dialog
     */
    noClick: propTypes.bool,

    /**
     * If true, disables SPACE/ENTER to open the native file selection dialog.
     * Note that it also stops tracking the focus state.
     */
    noKeyboard: propTypes.bool,

    /**
     * If true, disables drag 'n' drop
     */
    noDrag: propTypes.bool,

    /**
     * If true, stops drag event propagation to parents
     */
    noDragEventsBubbling: propTypes.bool,

    /**
     * Minimum file size (in bytes)
     */
    minSize: propTypes.number,

    /**
     * Maximum file size (in bytes)
     */
    maxSize: propTypes.number,

    /**
     * Maximum accepted number of files
     * The default value is 0 which means there is no limitation to how many files are accepted.
     */
    maxFiles: propTypes.number,

    /**
     * Enable/disable the dropzone
     */
    disabled: propTypes.bool,

    /**
     * Use this to provide a custom file aggregator
     *
     * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
     */
    getFilesFromEvent: propTypes.func,

    /**
     * Cb for when closing the file dialog with no selection
     */
    onFileDialogCancel: propTypes.func,

    /**
     * Cb for when the `dragenter` event occurs.
     *
     * @param {DragEvent} event
     */
    onDragEnter: propTypes.func,

    /**
     * Cb for when the `dragleave` event occurs
     *
     * @param {DragEvent} event
     */
    onDragLeave: propTypes.func,

    /**
     * Cb for when the `dragover` event occurs
     *
     * @param {DragEvent} event
     */
    onDragOver: propTypes.func,

    /**
     * Cb for when the `drop` event occurs.
     * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
     *
     * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
     * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
     * If `multiple` is set to false and additional files are dropped,
     * all files besides the first will be rejected.
     * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
     *
     * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
     * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
     *
     * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
     * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
     *
     * ```js
     * function onDrop(acceptedFiles) {
     *   const req = request.post('/upload')
     *   acceptedFiles.forEach(file => {
     *     req.attach(file.name, file)
     *   })
     *   req.end(callback)
     * }
     * ```
     *
     * @param {File[]} acceptedFiles
     * @param {FileRejection[]} fileRejections
     * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
     */
    onDrop: propTypes.func,

    /**
     * Cb for when the `drop` event occurs.
     * Note that if no files are accepted, this callback is not invoked.
     *
     * @param {File[]} files
     * @param {(DragEvent|Event)} event
     */
    onDropAccepted: propTypes.func,

    /**
     * Cb for when the `drop` event occurs.
     * Note that if no files are rejected, this callback is not invoked.
     *
     * @param {FileRejection[]} fileRejections
     * @param {(DragEvent|Event)} event
     */
    onDropRejected: propTypes.func
  };
  /**
   * A function that is invoked for the `dragenter`,
   * `dragover` and `dragleave` events.
   * It is not invoked if the items are not files (such as link, text, etc.).
   *
   * @callback dragCb
   * @param {DragEvent} event
   */

  /**
   * A function that is invoked for the `drop` or input change event.
   * It is not invoked if the items are not files (such as link, text, etc.).
   *
   * @callback dropCb
   * @param {File[]} acceptedFiles List of accepted files
   * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */

  /**
   * A function that is invoked for the `drop` or input change event.
   * It is not invoked if the items are files (such as link, text, etc.).
   *
   * @callback dropAcceptedCb
   * @param {File[]} files List of accepted files that meet the given criteria
   * (`accept`, `multiple`, `minSize`, `maxSize`)
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */

  /**
   * A function that is invoked for the `drop` or input change event.
   *
   * @callback dropRejectedCb
   * @param {File[]} files List of rejected files that do not meet the given criteria
   * (`accept`, `multiple`, `minSize`, `maxSize`)
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */

  /**
   * A function that is used aggregate files,
   * in a asynchronous fashion, from drag or input change events.
   *
   * @callback getFilesFromEvent
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   * @returns {(File[]|Promise<File[]>)}
   */

  /**
   * An object with the current dropzone state and some helper functions.
   *
   * @typedef {object} DropzoneState
   * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
   * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
   * @property {Function} open Open the native file selection dialog
   * @property {boolean} isFocused Dropzone area is in focus
   * @property {boolean} isFileDialogActive File dialog is opened
   * @property {boolean} isDragActive Active drag is in progress
   * @property {boolean} isDragAccept Dragged files are accepted
   * @property {boolean} isDragReject Some dragged files are rejected
   * @property {File[]} draggedFiles Files in active drag
   * @property {File[]} acceptedFiles Accepted files
   * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
   */

  var initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    draggedFiles: [],
    acceptedFiles: [],
    fileRejections: []
  };
  /**
   * A React hook that creates a drag 'n' drop area.
   *
   * ```jsx
   * function MyDropzone(props) {
   *   const {getRootProps, getInputProps} = useDropzone({
   *     onDrop: acceptedFiles => {
   *       // do something with the File objects, e.g. upload to some server
   *     }
   *   });
   *   return (
   *     <div {...getRootProps()}>
   *       <input {...getInputProps()} />
   *       <p>Drag and drop some files here, or click to select files</p>
   *     </div>
   *   )
   * }
   * ```
   *
   * @function useDropzone
   *
   * @param {object} props
   * @param {string|string[]} [props.accept] Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
   * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
   * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
   * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
   * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
   * @param {number} [props.minSize=0] Minimum file size (in bytes)
   * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
   * @param {boolean} [props.disabled=false] Enable/disable the dropzone
   * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
   * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
   * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
   * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
   * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
   * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   * @param {dropAcceptedCb} [props.onDropAccepted]
   * @param {dropRejectedCb} [props.onDropRejected]
   *
   * @returns {DropzoneState}
   */

  function useDropzone() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps$3), options),
        accept = _defaultProps$options.accept,
        disabled = _defaultProps$options.disabled,
        getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
        maxSize = _defaultProps$options.maxSize,
        minSize = _defaultProps$options.minSize,
        multiple = _defaultProps$options.multiple,
        maxFiles = _defaultProps$options.maxFiles,
        onDragEnter = _defaultProps$options.onDragEnter,
        onDragLeave = _defaultProps$options.onDragLeave,
        onDragOver = _defaultProps$options.onDragOver,
        onDrop = _defaultProps$options.onDrop,
        onDropAccepted = _defaultProps$options.onDropAccepted,
        onDropRejected = _defaultProps$options.onDropRejected,
        onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
        preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
        noClick = _defaultProps$options.noClick,
        noKeyboard = _defaultProps$options.noKeyboard,
        noDrag = _defaultProps$options.noDrag,
        noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling;

    var rootRef = React$2.useRef(null);
    var inputRef = React$2.useRef(null);

    var _useReducer = React$2.useReducer(reducer, initialState),
        _useReducer2 = _slicedToArray$2(_useReducer, 2),
        state = _useReducer2[0],
        dispatch = _useReducer2[1];

    var isFocused = state.isFocused,
        isFileDialogActive = state.isFileDialogActive,
        draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

    var openFileDialog = React$2.useCallback(function () {
      if (inputRef.current) {
        dispatch({
          type: 'openDialog'
        });
        inputRef.current.value = null;
        inputRef.current.click();
      }
    }, [dispatch]); // Update file dialog active state when the window is focused on

    var onWindowFocus = function onWindowFocus() {
      // Execute the timeout only if the file dialog is opened in the browser
      if (isFileDialogActive) {
        setTimeout(function () {
          if (inputRef.current) {
            var files = inputRef.current.files;

            if (!files.length) {
              dispatch({
                type: 'closeDialog'
              });

              if (typeof onFileDialogCancel === 'function') {
                onFileDialogCancel();
              }
            }
          }
        }, 300);
      }
    };

    React$2.useEffect(function () {
      window.addEventListener('focus', onWindowFocus, false);
      return function () {
        window.removeEventListener('focus', onWindowFocus, false);
      };
    }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

    var onKeyDownCb = React$2.useCallback(function (event) {
      // Ignore keyboard events bubbling up the DOM tree
      if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
        return;
      }

      if (event.keyCode === 32 || event.keyCode === 13) {
        event.preventDefault();
        openFileDialog();
      }
    }, [rootRef, inputRef]); // Update focus state for the dropzone

    var onFocusCb = React$2.useCallback(function () {
      dispatch({
        type: 'focus'
      });
    }, []);
    var onBlurCb = React$2.useCallback(function () {
      dispatch({
        type: 'blur'
      });
    }, []); // Cb to open the file dialog when click occurs on the dropzone

    var onClickCb = React$2.useCallback(function () {
      if (noClick) {
        return;
      } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
      // to ensure React can handle state changes
      // See: https://github.com/react-dropzone/react-dropzone/issues/450


      if (isIeOrEdge()) {
        setTimeout(openFileDialog, 0);
      } else {
        openFileDialog();
      }
    }, [inputRef, noClick]);
    var dragTargetsRef = React$2.useRef([]);

    var onDocumentDrop = function onDocumentDrop(event) {
      if (rootRef.current && rootRef.current.contains(event.target)) {
        // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
      }

      event.preventDefault();
      dragTargetsRef.current = [];
    };

    React$2.useEffect(function () {
      if (preventDropOnDocument) {
        document.addEventListener('dragover', onDocumentDragOver, false);
        document.addEventListener('drop', onDocumentDrop, false);
      }

      return function () {
        if (preventDropOnDocument) {
          document.removeEventListener('dragover', onDocumentDragOver);
          document.removeEventListener('drop', onDocumentDrop);
        }
      };
    }, [rootRef, preventDropOnDocument]);
    var onDragEnterCb = React$2.useCallback(function (event) {
      event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

      event.persist();
      stopPropagation(event);
      dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

      if (isEvtWithFiles(event)) {
        Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
          if (isPropagationStopped(event) && !noDragEventsBubbling) {
            return;
          }

          dispatch({
            draggedFiles: draggedFiles,
            isDragActive: true,
            type: 'setDraggedFiles'
          });

          if (onDragEnter) {
            onDragEnter(event);
          }
        });
      }
    }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
    var onDragOverCb = React$2.useCallback(function (event) {
      event.preventDefault();
      event.persist();
      stopPropagation(event);

      if (event.dataTransfer) {
        try {
          event.dataTransfer.dropEffect = 'copy';
        } catch (_unused) {}
        /* eslint-disable-line no-empty */

      }

      if (isEvtWithFiles(event) && onDragOver) {
        onDragOver(event);
      }

      return false;
    }, [onDragOver, noDragEventsBubbling]);
    var onDragLeaveCb = React$2.useCallback(function (event) {
      event.preventDefault();
      event.persist();
      stopPropagation(event); // Only deactivate once the dropzone and all children have been left

      var targets = dragTargetsRef.current.filter(function (target) {
        return rootRef.current && rootRef.current.contains(target);
      }); // Make sure to remove a target present multiple times only once
      // (Firefox may fire dragenter/dragleave multiple times on the same element)

      var targetIdx = targets.indexOf(event.target);

      if (targetIdx !== -1) {
        targets.splice(targetIdx, 1);
      }

      dragTargetsRef.current = targets;

      if (targets.length > 0) {
        return;
      }

      dispatch({
        isDragActive: false,
        type: 'setDraggedFiles',
        draggedFiles: []
      });

      if (isEvtWithFiles(event) && onDragLeave) {
        onDragLeave(event);
      }
    }, [rootRef, onDragLeave, noDragEventsBubbling]);
    var onDropCb = React$2.useCallback(function (event) {
      event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

      event.persist();
      stopPropagation(event);
      dragTargetsRef.current = [];

      if (isEvtWithFiles(event)) {
        Promise.resolve(getFilesFromEvent(event)).then(function (files) {
          if (isPropagationStopped(event) && !noDragEventsBubbling) {
            return;
          }

          var acceptedFiles = [];
          var fileRejections = [];
          files.forEach(function (file) {
            var _fileAccepted = fileAccepted(file, accept),
                _fileAccepted2 = _slicedToArray$2(_fileAccepted, 2),
                accepted = _fileAccepted2[0],
                acceptError = _fileAccepted2[1];

            var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
                _fileMatchSize2 = _slicedToArray$2(_fileMatchSize, 2),
                sizeMatch = _fileMatchSize2[0],
                sizeError = _fileMatchSize2[1];

            if (accepted && sizeMatch) {
              acceptedFiles.push(file);
            } else {
              var errors = [acceptError, sizeError].filter(function (e) {
                return e;
              });
              fileRejections.push({
                file: file,
                errors: errors
              });
            }
          });

          if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function (file) {
              fileRejections.push({
                file: file,
                errors: [TOO_MANY_FILES_REJECTION]
              });
            });
            acceptedFiles.splice(0);
          }

          dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: 'setFiles'
          });

          if (onDrop) {
            onDrop(acceptedFiles, fileRejections, event);
          }

          if (fileRejections.length > 0 && onDropRejected) {
            onDropRejected(fileRejections, event);
          }

          if (acceptedFiles.length > 0 && onDropAccepted) {
            onDropAccepted(acceptedFiles, event);
          }
        });
      }

      dispatch({
        type: 'reset'
      });
    }, [multiple, accept, minSize, maxSize, maxFiles, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling]);

    var composeHandler = function composeHandler(fn) {
      return disabled ? null : fn;
    };

    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
      return noKeyboard ? null : composeHandler(fn);
    };

    var composeDragHandler = function composeDragHandler(fn) {
      return noDrag ? null : composeHandler(fn);
    };

    var stopPropagation = function stopPropagation(event) {
      if (noDragEventsBubbling) {
        event.stopPropagation();
      }
    };

    var getRootProps = React$2.useMemo(function () {
      return function () {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref2$refKey = _ref2.refKey,
            refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
            onKeyDown = _ref2.onKeyDown,
            onFocus = _ref2.onFocus,
            onBlur = _ref2.onBlur,
            onClick = _ref2.onClick,
            onDragEnter = _ref2.onDragEnter,
            onDragOver = _ref2.onDragOver,
            onDragLeave = _ref2.onDragLeave,
            onDrop = _ref2.onDrop,
            rest = _objectWithoutProperties$1(_ref2, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

        return _objectSpread(_objectSpread(_defineProperty$1({
          onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
          onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
          onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
          onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
          onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
          onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
          onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
          onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
        }, refKey, rootRef), !disabled && !noKeyboard ? {
          tabIndex: 0
        } : {}), rest);
      };
    }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
    var onInputElementClick = React$2.useCallback(function (event) {
      event.stopPropagation();
    }, []);
    var getInputProps = React$2.useMemo(function () {
      return function () {
        var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            _ref3$refKey = _ref3.refKey,
            refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
            onChange = _ref3.onChange,
            onClick = _ref3.onClick,
            rest = _objectWithoutProperties$1(_ref3, ["refKey", "onChange", "onClick"]);

        var inputProps = _defineProperty$1({
          accept: accept,
          multiple: multiple,
          type: 'file',
          style: {
            display: 'none'
          },
          onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
          onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
          autoComplete: 'off',
          tabIndex: -1
        }, refKey, inputRef);

        return _objectSpread(_objectSpread({}, inputProps), rest);
      };
    }, [inputRef, accept, multiple, onDropCb, disabled]);
    var fileCount = draggedFiles.length;
    var isDragAccept = fileCount > 0 && allFilesAccepted({
      files: draggedFiles,
      accept: accept,
      minSize: minSize,
      maxSize: maxSize,
      multiple: multiple,
      maxFiles: maxFiles
    });
    var isDragReject = fileCount > 0 && !isDragAccept;
    return _objectSpread(_objectSpread({}, state), {}, {
      isDragAccept: isDragAccept,
      isDragReject: isDragReject,
      isFocused: isFocused && !disabled,
      getRootProps: getRootProps,
      getInputProps: getInputProps,
      rootRef: rootRef,
      inputRef: inputRef,
      open: composeHandler(openFileDialog)
    });
  }

  function reducer(state, action) {
    /* istanbul ignore next */
    switch (action.type) {
      case 'focus':
        return _objectSpread(_objectSpread({}, state), {}, {
          isFocused: true
        });

      case 'blur':
        return _objectSpread(_objectSpread({}, state), {}, {
          isFocused: false
        });

      case 'openDialog':
        return _objectSpread(_objectSpread({}, state), {}, {
          isFileDialogActive: true
        });

      case 'closeDialog':
        return _objectSpread(_objectSpread({}, state), {}, {
          isFileDialogActive: false
        });

      case 'setDraggedFiles':
        /* eslint no-case-declarations: 0 */
        var isDragActive = action.isDragActive,
            draggedFiles = action.draggedFiles;
        return _objectSpread(_objectSpread({}, state), {}, {
          draggedFiles: draggedFiles,
          isDragActive: isDragActive
        });

      case 'setFiles':
        return _objectSpread(_objectSpread({}, state), {}, {
          acceptedFiles: action.acceptedFiles,
          fileRejections: action.fileRejections
        });

      case 'reset':
        return _objectSpread(_objectSpread({}, state), {}, {
          isFileDialogActive: false,
          isDragActive: false,
          draggedFiles: [],
          acceptedFiles: [],
          fileRejections: []
        });

      default:
        return state;
    }
  }

  function _templateObject26() {
    var data = _taggedTemplateLiteral(["\n  padding-left: 20px;\n"]);

    _templateObject26 = function _templateObject26() {
      return data;
    };

    return data;
  }

  function _templateObject25() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'CenturyGothic', sans-serif;\n  color: ", ";\n"]);

    _templateObject25 = function _templateObject25() {
      return data;
    };

    return data;
  }

  function _templateObject24() {
    var data = _taggedTemplateLiteral(["\n  color: ", ";\n  margin-top: 1em;\n  font-size: 1em;\n  font-family: 'CenturyGothic', sans-serif;\n"]);

    _templateObject24 = function _templateObject24() {
      return data;
    };

    return data;
  }

  function _templateObject23() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'CenturyGothic', sans-serif;\n\n  li {\n    color: ", ";\n    margin-top: 1em;\n    font-family: 'CenturyGothic', sans-serif;\n  }\n"]);

    _templateObject23 = function _templateObject23() {
      return data;
    };

    return data;
  }

  function _templateObject22() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 350px;\n"]);

    _templateObject22 = function _templateObject22() {
      return data;
    };

    return data;
  }

  function _templateObject21() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  z-index: 1;\n  cursor: pointer;\n"]);

    _templateObject21 = function _templateObject21() {
      return data;
    };

    return data;
  }

  function _templateObject20() {
    var data = _taggedTemplateLiteral(["\n  margin-left: 8px;\n"]);

    _templateObject20 = function _templateObject20() {
      return data;
    };

    return data;
  }

  function _templateObject19() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n"]);

    _templateObject19 = function _templateObject19() {
      return data;
    };

    return data;
  }

  function _templateObject18() {
    var data = _taggedTemplateLiteral(["\n  margin: 20px auto !important;\n"]);

    _templateObject18 = function _templateObject18() {
      return data;
    };

    return data;
  }

  function _templateObject17() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n"]);

    _templateObject17 = function _templateObject17() {
      return data;
    };

    return data;
  }

  function _templateObject16() {
    var data = _taggedTemplateLiteral(["\n  margin-top: 30px;\n  display: flex;\n  justify-content: center;\n"]);

    _templateObject16 = function _templateObject16() {
      return data;
    };

    return data;
  }

  function _templateObject15() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n  div {\n    margin: 0 auto;\n    border-radius: 8px;\n\n    video {\n      background-color: white;\n      border-radius: 8px;\n      width: 100%;\n      height: 100%;\n    }\n  }\n"]);

    _templateObject15 = function _templateObject15() {
      return data;
    };

    return data;
  }

  function _templateObject14() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 16px;\n  right: 16px;\n"]);

    _templateObject14 = function _templateObject14() {
      return data;
    };

    return data;
  }

  function _templateObject13() {
    var data = _taggedTemplateLiteral(["\n  max-width: 100%;\n  max-height: 100%;\n  margin-top: 0;\n\n  width: 130px;\n  ", "\n"]);

    _templateObject13 = function _templateObject13() {
      return data;
    };

    return data;
  }

  function _templateObject12() {
    var data = _taggedTemplateLiteral(["\n  font-family: CenturyGothicBold, sans-serif;\n  margin-top: 8px;\n  text-decoration: underline;\n  color: white;\n  font-size: 12px;\n  margin-right: 8px;\n"]);

    _templateObject12 = function _templateObject12() {
      return data;
    };

    return data;
  }

  function _templateObject11() {
    var data = _taggedTemplateLiteral(["\n  font-family: CenturyGothicBold, sans-serif;\n  margin: 0;\n  color: ", ";\n  font-size: 16px;\n  display: flex;\n"]);

    _templateObject11 = function _templateObject11() {
      return data;
    };

    return data;
  }

  function _templateObject10$1() {
    var data = _taggedTemplateLiteral(["\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n  height: 74px;\n  background: rgba(0, 0, 0, 0.5);\n  position: absolute;\n  bottom: 0;\n  &:focus {\n    outline: 0;\n  }\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n"]);

    _templateObject10$1 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9$1() {
    var data = _taggedTemplateLiteral(["\n  background: ", ";\n\n  background-position: center center;\n  background-color: ", ";\n  background-size: ", ";\n  position: relative;\n  width: ", "px;\n  height: 200px;\n  display: flex;\n  cursor: pointer;\n  border-radius: 12px;\n  color: white;\n  flex-direction: column;\n  align-items: center;\n  ", " {\n    flex-direction: row;\n    justify-content: space-around;\n    width: 100%;\n  }\n  &:focus {\n    outline: none;\n  }\n"]);

    _templateObject9$1 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8$1() {
    var data = _taggedTemplateLiteral(["\n  ", " {\n    flex-direction: row;\n    justify-content: space-around;\n    width: 100%;\n    height: 200px;\n  }\n  width: 100%;\n  height: 100%;\n  position: relative;\n"]);

    _templateObject8$1 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7$3() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  width: ", "px;\n  height: 104%;\n  background-color: ", ";\n  bottom: -4px;\n  border-radius: 12px;\n  animation-name: ", ";\n  animation-duration: 3s;\n  animation-timing-function: ease;\n  ", " {\n    width: 101.3%;\n  }\n"]);

    _templateObject7$3 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$4() {
    var data = _taggedTemplateLiteral(["\n  0% {\n    height: 0;\n  }\n  100% {\n    height: 104%;\n  }\n"]);

    _templateObject6$4 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$7() {
    var data = _taggedTemplateLiteral(["\n  width: 100px;\n  margin-top: 20px;\n"]);

    _templateObject5$7 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$8() {
    var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  text-decoration: underline;\n  color: ", ";\n  width: 142px;\n  text-align: center;\n  font-family: 'CenturyGothicBold';\n"]);

    _templateObject4$8 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$a() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  right: 16px;\n  top: 16px;\n"]);

    _templateObject3$a = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$d() {
    var data = _taggedTemplateLiteral(["\n      > div {\n        color: var(--greyPrimary) !important;\n      }\n    "]);

    _templateObject2$d = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$m() {
    var data = _taggedTemplateLiteral(["\n  flex-direction: column;\n  justify-content: space-around;\n  box-sizing: border-box;\n  width: ", "px;\n  position: relative;\n  height: 200px;\n  display: flex;\n  border: 2px dashed var(--brandPrimaryLight);\n  cursor: pointer;\n  opacity: ", ";\n  border-radius: 12px;\n  color: white;\n  &:focus {\n    outline: 0;\n  }\n  align-items: center;\n  border: 2px dashed ", ";\n  cursor: ", ";\n  opacity: ", ";\n  ", ";\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject$m = function _templateObject() {
      return data;
    };

    return data;
  }
  var Container$2 = styled__default.div(_templateObject$m(), function (_ref) {
    var width = _ref.width;
    return width ? width : '515';
  }, function (_ref2) {
    var isDragActive = _ref2.isDragActive;
    return isDragActive ? '0.5' : '1.0';
  }, function (_ref3) {
    var disabled = _ref3.disabled;
    return disabled ? 'var(--greyPrimary)' : 'var(--brandPrimaryLight)';
  }, function (_ref4) {
    var disabled = _ref4.disabled;
    return disabled ? 'not-allowed' : 'pointer';
  }, function (_ref5) {
    var disabled = _ref5.disabled;
    return disabled ? '0.5' : '1';
  }, function (_ref6) {
    var disabled = _ref6.disabled;
    return disabled && styled.css(_templateObject2$d());
  }, breakpoints.down('md'));
  var ContainerIconUpload = styled__default.div(_templateObject3$a());
  var Text$2 = styled__default.p(_templateObject4$8(), colors.blue900);
  var Imagem = styled__default.img(_templateObject5$7());
  var animationHeight = styled.keyframes(_templateObject6$4());
  var Animation = styled__default.div(_templateObject7$3(), function (_ref7) {
    var width = _ref7.width;
    return width ? width : '515';
  }, colors.blue900, animationHeight, breakpoints.down('md'));
  var WrapperProcessing = styled__default.div(_templateObject8$1(), breakpoints.down('md'));
  var ContainerComplete = styled__default.div(_templateObject9$1(), function (_ref8) {
    var preview = _ref8.preview,
        isShowPreview = _ref8.isShowPreview;
    return preview && isShowPreview ? "url(".concat(preview, ") no-repeat") : colors.blue900;
  }, colors.blue900, function (_ref9) {
    var width = _ref9.width,
        preview = _ref9.preview;
    return preview ? 'cover' : width === 216 ? '100%' : '40%';
  }, function (_ref10) {
    var width = _ref10.width;
    return width ? width : '515';
  }, breakpoints.down('md'));
  var ContainerUploadInfo = styled__default.div(_templateObject10$1());
  var TitleUploadInfo = styled__default.div(_templateObject11(), colors.green100);
  var LinkText = styled__default.div(_templateObject12());
  var Image = styled__default.img(_templateObject13(), function (_ref11) {
    var margin = _ref11.margin;
    return margin && 'margin-top: 20px;';
  });
  var IconContainer = styled__default.div(_templateObject14());
  var Wrapper = styled__default.div(_templateObject15());
  var PreviewWrapper = styled__default.div(_templateObject16());
  var Preview = styled__default.img(_templateObject17());
  var WrapperButton = styled__default.div(_templateObject18());
  var WrapperWebcam = styled__default.div(_templateObject19());
  var WrapperIconCheck = styled__default.div(_templateObject20());
  var Input$2 = styled__default.input(_templateObject21());
  var ImageHelp = styled__default.img(_templateObject22());
  var ContainModalContent = styled__default.div(_templateObject23(), colors.blue900);
  var HelpSubSection = styled__default.h3(_templateObject24(), colors.blue900);
  var HelpParagraph = styled__default.p(_templateObject25(), colors.blue900);
  var HelpList = styled__default.ol(_templateObject26());

  var IconUpload = function IconUpload() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "19",
      height: "17",
      viewBox: "0 0 19 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M17.1496 11.0494V14.3252C17.1496 15.226 16.3846 15.9631 15.4496 15.9631H3.54961C2.61461 15.9631 1.84961 15.226 1.84961 14.3252V11.0494M13.7496 5.31665L9.49961 1.22186M9.49961 1.22186L5.24961 5.31665M9.49961 1.22186V11.0494",
      stroke: "#101D37",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  var MAX_SIZE = 26214400;
  var Pending = function Pending(props) {
    var width = props.width,
        onDrop = props.onDrop,
        image = props.image,
        options = props.options,
        onClickInputFile = props.onClickInputFile;

    var _useDropzone = useDropzone({
      onDrop: onDrop,
      accept: options,
      maxSize: MAX_SIZE
    }),
        getRootProps = _useDropzone.getRootProps,
        getInputProps = _useDropzone.getInputProps,
        isDragActive = _useDropzone.isDragActive;

    var inputProps = getInputProps({
      onClick: function onClick() {
        return onClickInputFile();
      }
    });
    inputProps.style = {};
    return /*#__PURE__*/React$2__default.createElement(Container$2, _extends({
      width: width,
      isDragActive: isDragActive
    }, getRootProps()), /*#__PURE__*/React$2__default.createElement(Input$2, inputProps), /*#__PURE__*/React$2__default.createElement(Imagem, {
      src: image,
      alt: "image"
    }), /*#__PURE__*/React$2__default.createElement(Text$2, null, "Clique para fazer o upload"), /*#__PURE__*/React$2__default.createElement(ContainerIconUpload, null, /*#__PURE__*/React$2__default.createElement(IconUpload, null)));
  };

  var Processing = function Processing(_ref) {
    var width = _ref.width,
        image = _ref.image;
    return /*#__PURE__*/React$2__default.createElement(Container$2, {
      width: width
    }, /*#__PURE__*/React$2__default.createElement(Imagem, {
      style: {
        zIndex: 1
      },
      src: image
    }), /*#__PURE__*/React$2__default.createElement(Text$2, {
      style: {
        zIndex: 1,
        color: 'var(--white100)',
        textDecoration: 'none'
      },
      color: "var(--white100)"
    }, "Carregando imagem..."), /*#__PURE__*/React$2__default.createElement(ContainerIconUpload, null, /*#__PURE__*/React$2__default.createElement(IconUpload, null)), /*#__PURE__*/React$2__default.createElement(Animation, {
      width: width
    }));
  };

  var lodash = createCommonjsModule(function (module, exports) {
  (function() {

    /** Used as a safe reference for `undefined` in pre-ES5 environments. */
    var undefined$1;

    /** Used as the semantic version number. */
    var VERSION = '4.17.20';

    /** Used as the size to enable large array optimizations. */
    var LARGE_ARRAY_SIZE = 200;

    /** Error message constants. */
    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
        FUNC_ERROR_TEXT = 'Expected a function';

    /** Used to stand-in for `undefined` hash values. */
    var HASH_UNDEFINED = '__lodash_hash_undefined__';

    /** Used as the maximum memoize cache size. */
    var MAX_MEMOIZE_SIZE = 500;

    /** Used as the internal argument placeholder. */
    var PLACEHOLDER = '__lodash_placeholder__';

    /** Used to compose bitmasks for cloning. */
    var CLONE_DEEP_FLAG = 1,
        CLONE_FLAT_FLAG = 2,
        CLONE_SYMBOLS_FLAG = 4;

    /** Used to compose bitmasks for value comparisons. */
    var COMPARE_PARTIAL_FLAG = 1,
        COMPARE_UNORDERED_FLAG = 2;

    /** Used to compose bitmasks for function metadata. */
    var WRAP_BIND_FLAG = 1,
        WRAP_BIND_KEY_FLAG = 2,
        WRAP_CURRY_BOUND_FLAG = 4,
        WRAP_CURRY_FLAG = 8,
        WRAP_CURRY_RIGHT_FLAG = 16,
        WRAP_PARTIAL_FLAG = 32,
        WRAP_PARTIAL_RIGHT_FLAG = 64,
        WRAP_ARY_FLAG = 128,
        WRAP_REARG_FLAG = 256,
        WRAP_FLIP_FLAG = 512;

    /** Used as default options for `_.truncate`. */
    var DEFAULT_TRUNC_LENGTH = 30,
        DEFAULT_TRUNC_OMISSION = '...';

    /** Used to detect hot functions by number of calls within a span of milliseconds. */
    var HOT_COUNT = 800,
        HOT_SPAN = 16;

    /** Used to indicate the type of lazy iteratees. */
    var LAZY_FILTER_FLAG = 1,
        LAZY_MAP_FLAG = 2,
        LAZY_WHILE_FLAG = 3;

    /** Used as references for various `Number` constants. */
    var INFINITY = 1 / 0,
        MAX_SAFE_INTEGER = 9007199254740991,
        MAX_INTEGER = 1.7976931348623157e+308,
        NAN = 0 / 0;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /** Used to associate wrap methods with their bit flags. */
    var wrapFlags = [
      ['ary', WRAP_ARY_FLAG],
      ['bind', WRAP_BIND_FLAG],
      ['bindKey', WRAP_BIND_KEY_FLAG],
      ['curry', WRAP_CURRY_FLAG],
      ['curryRight', WRAP_CURRY_RIGHT_FLAG],
      ['flip', WRAP_FLIP_FLAG],
      ['partial', WRAP_PARTIAL_FLAG],
      ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
      ['rearg', WRAP_REARG_FLAG]
    ];

    /** `Object#toString` result references. */
    var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        asyncTag = '[object AsyncFunction]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        domExcTag = '[object DOMException]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        nullTag = '[object Null]',
        objectTag = '[object Object]',
        promiseTag = '[object Promise]',
        proxyTag = '[object Proxy]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        symbolTag = '[object Symbol]',
        undefinedTag = '[object Undefined]',
        weakMapTag = '[object WeakMap]',
        weakSetTag = '[object WeakSet]';

    var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';

    /** Used to match empty string literals in compiled template source. */
    var reEmptyStringLeading = /\b__p \+= '';/g,
        reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
        reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

    /** Used to match HTML entities and HTML characters. */
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
        reUnescapedHtml = /[&<>"']/g,
        reHasEscapedHtml = RegExp(reEscapedHtml.source),
        reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

    /** Used to match template delimiters. */
    var reEscape = /<%-([\s\S]+?)%>/g,
        reEvaluate = /<%([\s\S]+?)%>/g,
        reInterpolate = /<%=([\s\S]+?)%>/g;

    /** Used to match property names within property paths. */
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/,
        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

    /**
     * Used to match `RegExp`
     * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
     */
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
        reHasRegExpChar = RegExp(reRegExpChar.source);

    /** Used to match leading and trailing whitespace. */
    var reTrim = /^\s+|\s+$/g,
        reTrimStart = /^\s+/,
        reTrimEnd = /\s+$/;

    /** Used to match wrap detail comments. */
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
        reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
        reSplitDetails = /,? & /;

    /** Used to match words composed of alphanumeric characters. */
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

    /** Used to match backslashes in property paths. */
    var reEscapeChar = /\\(\\)?/g;

    /**
     * Used to match
     * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
     */
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

    /** Used to match `RegExp` flags from their coerced string values. */
    var reFlags = /\w*$/;

    /** Used to detect bad signed hexadecimal string values. */
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

    /** Used to detect binary string values. */
    var reIsBinary = /^0b[01]+$/i;

    /** Used to detect host constructors (Safari). */
    var reIsHostCtor = /^\[object .+?Constructor\]$/;

    /** Used to detect octal string values. */
    var reIsOctal = /^0o[0-7]+$/i;

    /** Used to detect unsigned integer values. */
    var reIsUint = /^(?:0|[1-9]\d*)$/;

    /** Used to match Latin Unicode letters (excluding mathematical operators). */
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

    /** Used to ensure capturing order of template delimiters. */
    var reNoMatch = /($^)/;

    /** Used to match unescaped characters in compiled string literals. */
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

    /** Used to compose unicode character classes. */
    var rsAstralRange = '\\ud800-\\udfff',
        rsComboMarksRange = '\\u0300-\\u036f',
        reComboHalfMarksRange = '\\ufe20-\\ufe2f',
        rsComboSymbolsRange = '\\u20d0-\\u20ff',
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
        rsDingbatRange = '\\u2700-\\u27bf',
        rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
        rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
        rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
        rsPunctuationRange = '\\u2000-\\u206f',
        rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
        rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
        rsVarRange = '\\ufe0e\\ufe0f',
        rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

    /** Used to compose unicode capture groups. */
    var rsApos = "['\u2019]",
        rsAstral = '[' + rsAstralRange + ']',
        rsBreak = '[' + rsBreakRange + ']',
        rsCombo = '[' + rsComboRange + ']',
        rsDigits = '\\d+',
        rsDingbat = '[' + rsDingbatRange + ']',
        rsLower = '[' + rsLowerRange + ']',
        rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
        rsFitz = '\\ud83c[\\udffb-\\udfff]',
        rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
        rsNonAstral = '[^' + rsAstralRange + ']',
        rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
        rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
        rsUpper = '[' + rsUpperRange + ']',
        rsZWJ = '\\u200d';

    /** Used to compose unicode regexes. */
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
        rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
        rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
        rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
        reOptMod = rsModifier + '?',
        rsOptVar = '[' + rsVarRange + ']?',
        rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
        rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
        rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
        rsSeq = rsOptVar + reOptMod + rsOptJoin,
        rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
        rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

    /** Used to match apostrophes. */
    var reApos = RegExp(rsApos, 'g');

    /**
     * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
     * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
     */
    var reComboMark = RegExp(rsCombo, 'g');

    /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

    /** Used to match complex or compound words. */
    var reUnicodeWord = RegExp([
      rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
      rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
      rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
      rsUpper + '+' + rsOptContrUpper,
      rsOrdUpper,
      rsOrdLower,
      rsDigits,
      rsEmoji
    ].join('|'), 'g');

    /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

    /** Used to detect strings that need a more robust regexp to match words. */
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

    /** Used to assign default `context` object properties. */
    var contextProps = [
      'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
      'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
      'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
      'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
      '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
    ];

    /** Used to make template sourceURLs easier to identify. */
    var templateCounter = -1;

    /** Used to identify `toStringTag` values of typed arrays. */
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
    typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
    typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
    typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
    typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
    typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
    typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
    typedArrayTags[errorTag] = typedArrayTags[funcTag] =
    typedArrayTags[mapTag] = typedArrayTags[numberTag] =
    typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
    typedArrayTags[setTag] = typedArrayTags[stringTag] =
    typedArrayTags[weakMapTag] = false;

    /** Used to identify `toStringTag` values supported by `_.clone`. */
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] =
    cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
    cloneableTags[boolTag] = cloneableTags[dateTag] =
    cloneableTags[float32Tag] = cloneableTags[float64Tag] =
    cloneableTags[int8Tag] = cloneableTags[int16Tag] =
    cloneableTags[int32Tag] = cloneableTags[mapTag] =
    cloneableTags[numberTag] = cloneableTags[objectTag] =
    cloneableTags[regexpTag] = cloneableTags[setTag] =
    cloneableTags[stringTag] = cloneableTags[symbolTag] =
    cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
    cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] =
    cloneableTags[weakMapTag] = false;

    /** Used to map Latin Unicode letters to basic Latin letters. */
    var deburredLetters = {
      // Latin-1 Supplement block.
      '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
      '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
      '\xc7': 'C',  '\xe7': 'c',
      '\xd0': 'D',  '\xf0': 'd',
      '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
      '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
      '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
      '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
      '\xd1': 'N',  '\xf1': 'n',
      '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
      '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
      '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
      '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
      '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
      '\xc6': 'Ae', '\xe6': 'ae',
      '\xde': 'Th', '\xfe': 'th',
      '\xdf': 'ss',
      // Latin Extended-A block.
      '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
      '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
      '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
      '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
      '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
      '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
      '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
      '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
      '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
      '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
      '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
      '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
      '\u0134': 'J',  '\u0135': 'j',
      '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
      '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
      '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
      '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
      '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
      '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
      '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
      '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
      '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
      '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
      '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
      '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
      '\u0163': 't',  '\u0165': 't', '\u0167': 't',
      '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
      '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
      '\u0174': 'W',  '\u0175': 'w',
      '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
      '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
      '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
      '\u0132': 'IJ', '\u0133': 'ij',
      '\u0152': 'Oe', '\u0153': 'oe',
      '\u0149': "'n", '\u017f': 's'
    };

    /** Used to map characters to HTML entities. */
    var htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };

    /** Used to map HTML entities to characters. */
    var htmlUnescapes = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    };

    /** Used to escape characters for inclusion in compiled string literals. */
    var stringEscapes = {
      '\\': '\\',
      "'": "'",
      '\n': 'n',
      '\r': 'r',
      '\u2028': 'u2028',
      '\u2029': 'u2029'
    };

    /** Built-in method references without a dependency on `root`. */
    var freeParseFloat = parseFloat,
        freeParseInt = parseInt;

    /** Detect free variable `global` from Node.js. */
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

    /** Detect free variable `self`. */
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

    /** Used as a reference to the global object. */
    var root = freeGlobal || freeSelf || Function('return this')();

    /** Detect free variable `exports`. */
    var freeExports =  exports && !exports.nodeType && exports;

    /** Detect free variable `module`. */
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

    /** Detect the popular CommonJS extension `module.exports`. */
    var moduleExports = freeModule && freeModule.exports === freeExports;

    /** Detect free variable `process` from Node.js. */
    var freeProcess = moduleExports && freeGlobal.process;

    /** Used to access faster Node.js helpers. */
    var nodeUtil = (function() {
      try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;

        if (types) {
          return types;
        }

        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }());

    /* Node.js helper references. */
    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
        nodeIsDate = nodeUtil && nodeUtil.isDate,
        nodeIsMap = nodeUtil && nodeUtil.isMap,
        nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
        nodeIsSet = nodeUtil && nodeUtil.isSet,
        nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    /*--------------------------------------------------------------------------*/

    /**
     * A faster alternative to `Function#apply`, this function invokes `func`
     * with the `this` binding of `thisArg` and the arguments of `args`.
     *
     * @private
     * @param {Function} func The function to invoke.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} args The arguments to invoke `func` with.
     * @returns {*} Returns the result of `func`.
     */
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0: return func.call(thisArg);
        case 1: return func.call(thisArg, args[0]);
        case 2: return func.call(thisArg, args[0], args[1]);
        case 3: return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }

    /**
     * A specialized version of `baseAggregator` for arrays.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.includes` for arrays without support for
     * specifying an index to search from.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }

    /**
     * This function is like `arrayIncludes` except that it accepts a comparator.
     *
     * @private
     * @param {Array} [array] The array to inspect.
     * @param {*} target The value to search for.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {boolean} Returns `true` if `target` is found, else `false`.
     */
    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.map` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the first element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
          length = array == null ? 0 : array.length;

      if (initAccum && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initAccum] Specify using the last element of `array` as
     *  the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;
      if (initAccum && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} [array] The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * Gets the size of an ASCII `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    var asciiSize = baseProperty('length');

    /**
     * Converts an ASCII `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function asciiToArray(string) {
      return string.split('');
    }

    /**
     * Splits an ASCII `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }

    /**
     * The base implementation of methods like `_.findKey` and `_.findLastKey`,
     * without support for iteratee shorthands, which iterates over `collection`
     * using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = key;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.findIndex` and `_.findLastIndex` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} predicate The function invoked per iteration.
     * @param {number} fromIndex The index to search from.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);

      while ((fromRight ? index-- : ++index < length)) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOf(array, value, fromIndex) {
      return value === value
        ? strictIndexOf(array, value, fromIndex)
        : baseFindIndex(array, baseIsNaN, fromIndex);
    }

    /**
     * This function is like `baseIndexOf` except that it accepts a comparator.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @param {Function} comparator The comparator invoked per element.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * The base implementation of `_.isNaN` without support for number objects.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     */
    function baseIsNaN(value) {
      return value !== value;
    }

    /**
     * The base implementation of `_.mean` and `_.meanBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the mean.
     */
    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? (baseSum(array, iteratee) / length) : NAN;
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined$1 : object[key];
      };
    }

    /**
     * The base implementation of `_.propertyOf` without support for deep paths.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyOf(object) {
      return function(key) {
        return object == null ? undefined$1 : object[key];
      };
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight`, without support
     * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initAccum Specify using the first or last element of
     *  `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum
          ? (initAccum = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define the
     * sort order of `array` and replaces criteria objects with their corresponding
     * values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sum` and `_.sumBy` without support for
     * iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(array, iteratee) {
      var result,
          index = -1,
          length = array.length;

      while (++index < length) {
        var current = iteratee(array[index]);
        if (current !== undefined$1) {
          result = result === undefined$1 ? current : (result + current);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.times` without support for iteratee shorthands
     * or max array length checks.
     *
     * @private
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     */
    function baseTimes(n, iteratee) {
      var index = -1,
          result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }

    /**
     * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
     * of key-value pairs for `object` corresponding to the property names of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the key-value pairs.
     */
    function baseToPairs(object, props) {
      return arrayMap(props, function(key) {
        return [key, object[key]];
      });
    }

    /**
     * The base implementation of `_.unary` without support for storing metadata.
     *
     * @private
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     */
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      return arrayMap(props, function(key) {
        return object[key];
      });
    }

    /**
     * Checks if a `cache` value for `key` exists.
     *
     * @private
     * @param {Object} cache The cache to query.
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function cacheHas(cache, key) {
      return cache.has(key);
    }

    /**
     * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the first unmatched string symbol.
     */
    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1,
          length = strSymbols.length;

      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }

    /**
     * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
     * that is not found in the character symbols.
     *
     * @private
     * @param {Array} strSymbols The string symbols to inspect.
     * @param {Array} chrSymbols The character symbols to find.
     * @returns {number} Returns the index of the last unmatched string symbol.
     */
    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;

      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
      return index;
    }

    /**
     * Gets the number of `placeholder` occurrences in `array`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} placeholder The placeholder to search for.
     * @returns {number} Returns the placeholder count.
     */
    function countHolders(array, placeholder) {
      var length = array.length,
          result = 0;

      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }
      return result;
    }

    /**
     * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
     * letters to basic Latin letters.
     *
     * @private
     * @param {string} letter The matched letter to deburr.
     * @returns {string} Returns the deburred letter.
     */
    var deburrLetter = basePropertyOf(deburredLetters);

    /**
     * Used by `_.escape` to convert characters to HTML entities.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    var escapeHtmlChar = basePropertyOf(htmlEscapes);

    /**
     * Used by `_.template` to escape characters for inclusion in compiled string literals.
     *
     * @private
     * @param {string} chr The matched character to escape.
     * @returns {string} Returns the escaped character.
     */
    function escapeStringChar(chr) {
      return '\\' + stringEscapes[chr];
    }

    /**
     * Gets the value at `key` of `object`.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }

    /**
     * Checks if `string` contains Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a symbol is found, else `false`.
     */
    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }

    /**
     * Checks if `string` contains a word composed of Unicode symbols.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {boolean} Returns `true` if a word is found, else `false`.
     */
    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }

    /**
     * Converts `iterator` to an array.
     *
     * @private
     * @param {Object} iterator The iterator to convert.
     * @returns {Array} Returns the converted array.
     */
    function iteratorToArray(iterator) {
      var data,
          result = [];

      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }
      return result;
    }

    /**
     * Converts `map` to its key-value pairs.
     *
     * @private
     * @param {Object} map The map to convert.
     * @returns {Array} Returns the key-value pairs.
     */
    function mapToArray(map) {
      var index = -1,
          result = Array(map.size);

      map.forEach(function(value, key) {
        result[++index] = [key, value];
      });
      return result;
    }

    /**
     * Creates a unary function that invokes `func` with its argument transformed.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {Function} transform The argument transform.
     * @returns {Function} Returns the new function.
     */
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }

    /**
     * Replaces all `placeholder` elements in `array` with an internal placeholder
     * and returns an array of their indexes.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {*} placeholder The placeholder to replace.
     * @returns {Array} Returns the new array of placeholder indexes.
     */
    function replaceHolders(array, placeholder) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }
      return result;
    }

    /**
     * Converts `set` to an array of its values.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the values.
     */
    function setToArray(set) {
      var index = -1,
          result = Array(set.size);

      set.forEach(function(value) {
        result[++index] = value;
      });
      return result;
    }

    /**
     * Converts `set` to its value-value pairs.
     *
     * @private
     * @param {Object} set The set to convert.
     * @returns {Array} Returns the value-value pairs.
     */
    function setToPairs(set) {
      var index = -1,
          result = Array(set.size);

      set.forEach(function(value) {
        result[++index] = [value, value];
      });
      return result;
    }

    /**
     * A specialized version of `_.indexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * A specialized version of `_.lastIndexOf` which performs strict equality
     * comparisons of values, i.e. `===`.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} fromIndex The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return index;
    }

    /**
     * Gets the number of symbols in `string`.
     *
     * @private
     * @param {string} string The string to inspect.
     * @returns {number} Returns the string size.
     */
    function stringSize(string) {
      return hasUnicode(string)
        ? unicodeSize(string)
        : asciiSize(string);
    }

    /**
     * Converts `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function stringToArray(string) {
      return hasUnicode(string)
        ? unicodeToArray(string)
        : asciiToArray(string);
    }

    /**
     * Used by `_.unescape` to convert HTML entities to characters.
     *
     * @private
     * @param {string} chr The matched character to unescape.
     * @returns {string} Returns the unescaped character.
     */
    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

    /**
     * Gets the size of a Unicode `string`.
     *
     * @private
     * @param {string} string The string inspect.
     * @returns {number} Returns the string size.
     */
    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;
      while (reUnicode.test(string)) {
        ++result;
      }
      return result;
    }

    /**
     * Converts a Unicode `string` to an array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the converted array.
     */
    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }

    /**
     * Splits a Unicode `string` into an array of its words.
     *
     * @private
     * @param {string} The string to inspect.
     * @returns {Array} Returns the words of `string`.
     */
    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }

    /*--------------------------------------------------------------------------*/

    /**
     * Create a new pristine `lodash` function using the `context` object.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Util
     * @param {Object} [context=root] The context object.
     * @returns {Function} Returns a new `lodash` function.
     * @example
     *
     * _.mixin({ 'foo': _.constant('foo') });
     *
     * var lodash = _.runInContext();
     * lodash.mixin({ 'bar': lodash.constant('bar') });
     *
     * _.isFunction(_.foo);
     * // => true
     * _.isFunction(_.bar);
     * // => false
     *
     * lodash.isFunction(lodash.foo);
     * // => false
     * lodash.isFunction(lodash.bar);
     * // => true
     *
     * // Create a suped-up `defer` in Node.js.
     * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
     */
    var runInContext = (function runInContext(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

      /** Built-in constructor references. */
      var Array = context.Array,
          Date = context.Date,
          Error = context.Error,
          Function = context.Function,
          Math = context.Math,
          Object = context.Object,
          RegExp = context.RegExp,
          String = context.String,
          TypeError = context.TypeError;

      /** Used for built-in method references. */
      var arrayProto = Array.prototype,
          funcProto = Function.prototype,
          objectProto = Object.prototype;

      /** Used to detect overreaching core-js shims. */
      var coreJsData = context['__core-js_shared__'];

      /** Used to resolve the decompiled source of functions. */
      var funcToString = funcProto.toString;

      /** Used to check objects for own properties. */
      var hasOwnProperty = objectProto.hasOwnProperty;

      /** Used to generate unique IDs. */
      var idCounter = 0;

      /** Used to detect methods masquerading as native. */
      var maskSrcKey = (function() {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? ('Symbol(src)_1.' + uid) : '';
      }());

      /**
       * Used to resolve the
       * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
       * of values.
       */
      var nativeObjectToString = objectProto.toString;

      /** Used to infer the `Object` constructor. */
      var objectCtorString = funcToString.call(Object);

      /** Used to restore the original `_` reference in `_.noConflict`. */
      var oldDash = root._;

      /** Used to detect if a method is native. */
      var reIsNative = RegExp('^' +
        funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
        .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
      );

      /** Built-in value references. */
      var Buffer = moduleExports ? context.Buffer : undefined$1,
          Symbol = context.Symbol,
          Uint8Array = context.Uint8Array,
          allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
          getPrototype = overArg(Object.getPrototypeOf, Object),
          objectCreate = Object.create,
          propertyIsEnumerable = objectProto.propertyIsEnumerable,
          splice = arrayProto.splice,
          spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
          symIterator = Symbol ? Symbol.iterator : undefined$1,
          symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

      var defineProperty = (function() {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }());

      /** Mocked built-ins. */
      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
          ctxNow = Date && Date.now !== root.Date.now && Date.now,
          ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

      /* Built-in method references for those with the same name as other `lodash` methods. */
      var nativeCeil = Math.ceil,
          nativeFloor = Math.floor,
          nativeGetSymbols = Object.getOwnPropertySymbols,
          nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
          nativeIsFinite = context.isFinite,
          nativeJoin = arrayProto.join,
          nativeKeys = overArg(Object.keys, Object),
          nativeMax = Math.max,
          nativeMin = Math.min,
          nativeNow = Date.now,
          nativeParseInt = context.parseInt,
          nativeRandom = Math.random,
          nativeReverse = arrayProto.reverse;

      /* Built-in method references that are verified to be native. */
      var DataView = getNative(context, 'DataView'),
          Map = getNative(context, 'Map'),
          Promise = getNative(context, 'Promise'),
          Set = getNative(context, 'Set'),
          WeakMap = getNative(context, 'WeakMap'),
          nativeCreate = getNative(Object, 'create');

      /** Used to store function metadata. */
      var metaMap = WeakMap && new WeakMap;

      /** Used to lookup unminified function names. */
      var realNames = {};

      /** Used to detect maps, sets, and weakmaps. */
      var dataViewCtorString = toSource(DataView),
          mapCtorString = toSource(Map),
          promiseCtorString = toSource(Promise),
          setCtorString = toSource(Set),
          weakMapCtorString = toSource(WeakMap);

      /** Used to convert symbols to primitives and strings. */
      var symbolProto = Symbol ? Symbol.prototype : undefined$1,
          symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
          symbolToString = symbolProto ? symbolProto.toString : undefined$1;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a `lodash` object which wraps `value` to enable implicit method
       * chain sequences. Methods that operate on and return arrays, collections,
       * and functions can be chained together. Methods that retrieve a single value
       * or may return a primitive value will automatically end the chain sequence
       * and return the unwrapped value. Otherwise, the value must be unwrapped
       * with `_#value`.
       *
       * Explicit chain sequences, which must be unwrapped with `_#value`, may be
       * enabled using `_.chain`.
       *
       * The execution of chained methods is lazy, that is, it's deferred until
       * `_#value` is implicitly or explicitly called.
       *
       * Lazy evaluation allows several methods to support shortcut fusion.
       * Shortcut fusion is an optimization to merge iteratee calls; this avoids
       * the creation of intermediate arrays and can greatly reduce the number of
       * iteratee executions. Sections of a chain sequence qualify for shortcut
       * fusion if the section is applied to an array and iteratees accept only
       * one argument. The heuristic for whether a section qualifies for shortcut
       * fusion is subject to change.
       *
       * Chaining is supported in custom builds as long as the `_#value` method is
       * directly or indirectly included in the build.
       *
       * In addition to lodash methods, wrappers have `Array` and `String` methods.
       *
       * The wrapper `Array` methods are:
       * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
       *
       * The wrapper `String` methods are:
       * `replace` and `split`
       *
       * The wrapper methods that support shortcut fusion are:
       * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
       * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
       * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
       *
       * The chainable wrapper methods are:
       * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
       * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
       * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
       * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
       * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
       * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
       * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
       * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
       * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
       * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
       * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
       * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
       * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
       * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
       * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
       * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
       * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
       * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
       * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
       * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
       * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
       * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
       * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
       * `zipObject`, `zipObjectDeep`, and `zipWith`
       *
       * The wrapper methods that are **not** chainable by default are:
       * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
       * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
       * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
       * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
       * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
       * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
       * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
       * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
       * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
       * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
       * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
       * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
       * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
       * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
       * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
       * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
       * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
       * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
       * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
       * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
       * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
       * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
       * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
       * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
       * `upperFirst`, `value`, and `words`
       *
       * @name _
       * @constructor
       * @category Seq
       * @param {*} value The value to wrap in a `lodash` instance.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2, 3]);
       *
       * // Returns an unwrapped value.
       * wrapped.reduce(_.add);
       * // => 6
       *
       * // Returns a wrapped value.
       * var squares = wrapped.map(square);
       *
       * _.isArray(squares);
       * // => false
       *
       * _.isArray(squares.value());
       * // => true
       */
      function lodash(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }
          if (hasOwnProperty.call(value, '__wrapped__')) {
            return wrapperClone(value);
          }
        }
        return new LodashWrapper(value);
      }

      /**
       * The base implementation of `_.create` without support for assigning
       * properties to the created object.
       *
       * @private
       * @param {Object} proto The object to inherit from.
       * @returns {Object} Returns the new object.
       */
      var baseCreate = (function() {
        function object() {}
        return function(proto) {
          if (!isObject(proto)) {
            return {};
          }
          if (objectCreate) {
            return objectCreate(proto);
          }
          object.prototype = proto;
          var result = new object;
          object.prototype = undefined$1;
          return result;
        };
      }());

      /**
       * The function whose prototype chain sequence wrappers inherit from.
       *
       * @private
       */
      function baseLodash() {
        // No operation performed.
      }

      /**
       * The base constructor for creating `lodash` wrapper objects.
       *
       * @private
       * @param {*} value The value to wrap.
       * @param {boolean} [chainAll] Enable explicit method chain sequences.
       */
      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }

      /**
       * By default, the template delimiters used by lodash are like those in
       * embedded Ruby (ERB) as well as ES2015 template strings. Change the
       * following template settings to use alternative delimiters.
       *
       * @static
       * @memberOf _
       * @type {Object}
       */
      lodash.templateSettings = {

        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        'escape': reEscape,

        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        'evaluate': reEvaluate,

        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        'interpolate': reInterpolate,

        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        'variable': '',

        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        'imports': {

          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          '_': lodash
        }
      };

      // Ensure wrappers are instances of `baseLodash`.
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;

      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
       *
       * @private
       * @constructor
       * @param {*} value The value to wrap.
       */
      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }

      /**
       * Creates a clone of the lazy wrapper object.
       *
       * @private
       * @name clone
       * @memberOf LazyWrapper
       * @returns {Object} Returns the cloned `LazyWrapper` object.
       */
      function lazyClone() {
        var result = new LazyWrapper(this.__wrapped__);
        result.__actions__ = copyArray(this.__actions__);
        result.__dir__ = this.__dir__;
        result.__filtered__ = this.__filtered__;
        result.__iteratees__ = copyArray(this.__iteratees__);
        result.__takeCount__ = this.__takeCount__;
        result.__views__ = copyArray(this.__views__);
        return result;
      }

      /**
       * Reverses the direction of lazy iteration.
       *
       * @private
       * @name reverse
       * @memberOf LazyWrapper
       * @returns {Object} Returns the new reversed `LazyWrapper` object.
       */
      function lazyReverse() {
        if (this.__filtered__) {
          var result = new LazyWrapper(this);
          result.__dir__ = -1;
          result.__filtered__ = true;
        } else {
          result = this.clone();
          result.__dir__ *= -1;
        }
        return result;
      }

      /**
       * Extracts the unwrapped value from its lazy wrapper.
       *
       * @private
       * @name value
       * @memberOf LazyWrapper
       * @returns {*} Returns the unwrapped value.
       */
      function lazyValue() {
        var array = this.__wrapped__.value(),
            dir = this.__dir__,
            isArr = isArray(array),
            isRight = dir < 0,
            arrLength = isArr ? array.length : 0,
            view = getView(0, arrLength, this.__views__),
            start = view.start,
            end = view.end,
            length = end - start,
            index = isRight ? end : (start - 1),
            iteratees = this.__iteratees__,
            iterLength = iteratees.length,
            resIndex = 0,
            takeCount = nativeMin(length, this.__takeCount__);

        if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
          return baseWrapperValue(array, this.__actions__);
        }
        var result = [];

        outer:
        while (length-- && resIndex < takeCount) {
          index += dir;

          var iterIndex = -1,
              value = array[index];

          while (++iterIndex < iterLength) {
            var data = iteratees[iterIndex],
                iteratee = data.iteratee,
                type = data.type,
                computed = iteratee(value);

            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }
          result[resIndex++] = value;
        }
        return result;
      }

      // Ensure `LazyWrapper` is an instance of `baseLodash`.
      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a hash object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Hash(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the hash.
       *
       * @private
       * @name clear
       * @memberOf Hash
       */
      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the hash.
       *
       * @private
       * @name delete
       * @memberOf Hash
       * @param {Object} hash The hash to modify.
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }

      /**
       * Gets the hash value for `key`.
       *
       * @private
       * @name get
       * @memberOf Hash
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function hashGet(key) {
        var data = this.__data__;
        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined$1 : result;
        }
        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }

      /**
       * Checks if a hash value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Hash
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? (data[key] !== undefined$1) : hasOwnProperty.call(data, key);
      }

      /**
       * Sets the hash `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Hash
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the hash instance.
       */
      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = (nativeCreate && value === undefined$1) ? HASH_UNDEFINED : value;
        return this;
      }

      // Add methods to `Hash`.
      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates an list cache object.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function ListCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the list cache.
       *
       * @private
       * @name clear
       * @memberOf ListCache
       */
      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the list cache.
       *
       * @private
       * @name delete
       * @memberOf ListCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function listCacheDelete(key) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        if (index < 0) {
          return false;
        }
        var lastIndex = data.length - 1;
        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }
        --this.size;
        return true;
      }

      /**
       * Gets the list cache value for `key`.
       *
       * @private
       * @name get
       * @memberOf ListCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function listCacheGet(key) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        return index < 0 ? undefined$1 : data[index][1];
      }

      /**
       * Checks if a list cache value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf ListCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }

      /**
       * Sets the list cache `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf ListCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the list cache instance.
       */
      function listCacheSet(key, value) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }
        return this;
      }

      // Add methods to `ListCache`.
      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a map cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function MapCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;

        this.clear();
        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      /**
       * Removes all key-value entries from the map.
       *
       * @private
       * @name clear
       * @memberOf MapCache
       */
      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash,
          'map': new (Map || ListCache),
          'string': new Hash
        };
      }

      /**
       * Removes `key` and its value from the map.
       *
       * @private
       * @name delete
       * @memberOf MapCache
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }

      /**
       * Gets the map value for `key`.
       *
       * @private
       * @name get
       * @memberOf MapCache
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }

      /**
       * Checks if a map value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf MapCache
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }

      /**
       * Sets the map `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf MapCache
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the map cache instance.
       */
      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
            size = data.size;

        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }

      // Add methods to `MapCache`.
      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;

      /*------------------------------------------------------------------------*/

      /**
       *
       * Creates an array cache object to store unique values.
       *
       * @private
       * @constructor
       * @param {Array} [values] The values to cache.
       */
      function SetCache(values) {
        var index = -1,
            length = values == null ? 0 : values.length;

        this.__data__ = new MapCache;
        while (++index < length) {
          this.add(values[index]);
        }
      }

      /**
       * Adds `value` to the array cache.
       *
       * @private
       * @name add
       * @memberOf SetCache
       * @alias push
       * @param {*} value The value to cache.
       * @returns {Object} Returns the cache instance.
       */
      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);
        return this;
      }

      /**
       * Checks if `value` is in the array cache.
       *
       * @private
       * @name has
       * @memberOf SetCache
       * @param {*} value The value to search for.
       * @returns {number} Returns `true` if `value` is found, else `false`.
       */
      function setCacheHas(value) {
        return this.__data__.has(value);
      }

      // Add methods to `SetCache`.
      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;

      /*------------------------------------------------------------------------*/

      /**
       * Creates a stack cache object to store key-value pairs.
       *
       * @private
       * @constructor
       * @param {Array} [entries] The key-value pairs to cache.
       */
      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }

      /**
       * Removes all key-value entries from the stack.
       *
       * @private
       * @name clear
       * @memberOf Stack
       */
      function stackClear() {
        this.__data__ = new ListCache;
        this.size = 0;
      }

      /**
       * Removes `key` and its value from the stack.
       *
       * @private
       * @name delete
       * @memberOf Stack
       * @param {string} key The key of the value to remove.
       * @returns {boolean} Returns `true` if the entry was removed, else `false`.
       */
      function stackDelete(key) {
        var data = this.__data__,
            result = data['delete'](key);

        this.size = data.size;
        return result;
      }

      /**
       * Gets the stack value for `key`.
       *
       * @private
       * @name get
       * @memberOf Stack
       * @param {string} key The key of the value to get.
       * @returns {*} Returns the entry value.
       */
      function stackGet(key) {
        return this.__data__.get(key);
      }

      /**
       * Checks if a stack value for `key` exists.
       *
       * @private
       * @name has
       * @memberOf Stack
       * @param {string} key The key of the entry to check.
       * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
       */
      function stackHas(key) {
        return this.__data__.has(key);
      }

      /**
       * Sets the stack `key` to `value`.
       *
       * @private
       * @name set
       * @memberOf Stack
       * @param {string} key The key of the value to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns the stack cache instance.
       */
      function stackSet(key, value) {
        var data = this.__data__;
        if (data instanceof ListCache) {
          var pairs = data.__data__;
          if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }
          data = this.__data__ = new MapCache(pairs);
        }
        data.set(key, value);
        this.size = data.size;
        return this;
      }

      // Add methods to `Stack`.
      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;

      /*------------------------------------------------------------------------*/

      /**
       * Creates an array of the enumerable property names of the array-like `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @param {boolean} inherited Specify returning inherited property names.
       * @returns {Array} Returns the array of property names.
       */
      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
            isArg = !isArr && isArguments(value),
            isBuff = !isArr && !isArg && isBuffer(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? baseTimes(value.length, String) : [],
            length = result.length;

        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) &&
              !(skipIndexes && (
                 // Safari 9 has enumerable `arguments.length` in strict mode.
                 key == 'length' ||
                 // Node.js 0.10 has enumerable non-index properties on buffers.
                 (isBuff && (key == 'offset' || key == 'parent')) ||
                 // PhantomJS 2 has enumerable non-index properties on typed arrays.
                 (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
                 // Skip index properties.
                 isIndex(key, length)
              ))) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * A specialized version of `_.sample` for arrays.
       *
       * @private
       * @param {Array} array The array to sample.
       * @returns {*} Returns the random element.
       */
      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }

      /**
       * A specialized version of `_.sampleSize` for arrays.
       *
       * @private
       * @param {Array} array The array to sample.
       * @param {number} n The number of elements to sample.
       * @returns {Array} Returns the random elements.
       */
      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }

      /**
       * A specialized version of `_.shuffle` for arrays.
       *
       * @private
       * @param {Array} array The array to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */
      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }

      /**
       * This function is like `assignValue` except that it doesn't assign
       * `undefined` values.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignMergeValue(object, key, value) {
        if ((value !== undefined$1 && !eq(object[key], value)) ||
            (value === undefined$1 && !(key in object))) {
          baseAssignValue(object, key, value);
        }
      }

      /**
       * Assigns `value` to `key` of `object` if the existing value is not equivalent
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function assignValue(object, key, value) {
        var objValue = object[key];
        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
            (value === undefined$1 && !(key in object))) {
          baseAssignValue(object, key, value);
        }
      }

      /**
       * Gets the index at which the `key` is found in `array` of key-value pairs.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {*} key The key to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       */
      function assocIndexOf(array, key) {
        var length = array.length;
        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }
        return -1;
      }

      /**
       * Aggregates elements of `collection` on `accumulator` with keys transformed
       * by `iteratee` and values set by `setter`.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform keys.
       * @param {Object} accumulator The initial aggregated object.
       * @returns {Function} Returns `accumulator`.
       */
      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function(value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.assign` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }

      /**
       * The base implementation of `_.assignIn` without support for multiple sources
       * or `customizer` functions.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @returns {Object} Returns `object`.
       */
      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }

      /**
       * The base implementation of `assignValue` and `assignMergeValue` without
       * value checks.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {string} key The key of the property to assign.
       * @param {*} value The value to assign.
       */
      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
          });
        } else {
          object[key] = value;
        }
      }

      /**
       * The base implementation of `_.at` without support for individual paths.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {string[]} paths The property paths to pick.
       * @returns {Array} Returns the picked elements.
       */
      function baseAt(object, paths) {
        var index = -1,
            length = paths.length,
            result = Array(length),
            skip = object == null;

        while (++index < length) {
          result[index] = skip ? undefined$1 : get(object, paths[index]);
        }
        return result;
      }

      /**
       * The base implementation of `_.clamp` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       */
      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }
          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }
        return number;
      }

      /**
       * The base implementation of `_.clone` and `_.cloneDeep` which tracks
       * traversed objects.
       *
       * @private
       * @param {*} value The value to clone.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Deep clone
       *  2 - Flatten inherited properties
       *  4 - Clone symbols
       * @param {Function} [customizer] The function to customize cloning.
       * @param {string} [key] The key of `value`.
       * @param {Object} [object] The parent object of `value`.
       * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
       * @returns {*} Returns the cloned value.
       */
      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
            isDeep = bitmask & CLONE_DEEP_FLAG,
            isFlat = bitmask & CLONE_FLAT_FLAG,
            isFull = bitmask & CLONE_SYMBOLS_FLAG;

        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }
        if (result !== undefined$1) {
          return result;
        }
        if (!isObject(value)) {
          return value;
        }
        var isArr = isArray(value);
        if (isArr) {
          result = initCloneArray(value);
          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
              isFunc = tag == funcTag || tag == genTag;

          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }
          if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
            result = (isFlat || isFunc) ? {} : initCloneObject(value);
            if (!isDeep) {
              return isFlat
                ? copySymbolsIn(value, baseAssignIn(result, value))
                : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }
            result = initCloneByTag(value, tag, isDeep);
          }
        }
        // Check for circular references and return its corresponding clone.
        stack || (stack = new Stack);
        var stacked = stack.get(value);
        if (stacked) {
          return stacked;
        }
        stack.set(value, result);

        if (isSet(value)) {
          value.forEach(function(subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function(subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }

        var keysFunc = isFull
          ? (isFlat ? getAllKeysIn : getAllKeys)
          : (isFlat ? keysIn : keys);

        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function(subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }
          // Recursively populate clone (susceptible to call stack limits).
          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }

      /**
       * The base implementation of `_.conforms` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property predicates to conform to.
       * @returns {Function} Returns the new spec function.
       */
      function baseConforms(source) {
        var props = keys(source);
        return function(object) {
          return baseConformsTo(object, source, props);
        };
      }

      /**
       * The base implementation of `_.conformsTo` which accepts `props` to check.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property predicates to conform to.
       * @returns {boolean} Returns `true` if `object` conforms, else `false`.
       */
      function baseConformsTo(object, source, props) {
        var length = props.length;
        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (length--) {
          var key = props[length],
              predicate = source[key],
              value = object[key];

          if ((value === undefined$1 && !(key in object)) || !predicate(value)) {
            return false;
          }
        }
        return true;
      }

      /**
       * The base implementation of `_.delay` and `_.defer` which accepts `args`
       * to provide to `func`.
       *
       * @private
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {Array} args The arguments to provide to `func`.
       * @returns {number|Object} Returns the timer id or timeout object.
       */
      function baseDelay(func, wait, args) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return setTimeout(function() { func.apply(undefined$1, args); }, wait);
      }

      /**
       * The base implementation of methods like `_.difference` without support
       * for excluding multiple arrays or iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Array} values The values to exclude.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       */
      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
            includes = arrayIncludes,
            isCommon = true,
            length = array.length,
            result = [],
            valuesLength = values.length;

        if (!length) {
          return result;
        }
        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }
        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        }
        else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }
        outer:
        while (++index < length) {
          var value = array[index],
              computed = iteratee == null ? value : iteratee(value);

          value = (comparator || value !== 0) ? value : 0;
          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;
            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }
            result.push(value);
          }
          else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.forEach` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */
      var baseEach = createBaseEach(baseForOwn);

      /**
       * The base implementation of `_.forEachRight` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       */
      var baseEachRight = createBaseEach(baseForOwnRight, true);

      /**
       * The base implementation of `_.every` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`
       */
      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function(value, index, collection) {
          result = !!predicate(value, index, collection);
          return result;
        });
        return result;
      }

      /**
       * The base implementation of methods like `_.max` and `_.min` which accepts a
       * `comparator` to determine the extremum value.
       *
       * @private
       * @param {Array} array The array to iterate over.
       * @param {Function} iteratee The iteratee invoked per iteration.
       * @param {Function} comparator The comparator used to compare values.
       * @returns {*} Returns the extremum value.
       */
      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
            length = array.length;

        while (++index < length) {
          var value = array[index],
              current = iteratee(value);

          if (current != null && (computed === undefined$1
                ? (current === current && !isSymbol(current))
                : comparator(current, computed)
              )) {
            var computed = current,
                result = value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.fill` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to fill.
       * @param {*} value The value to fill `array` with.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns `array`.
       */
      function baseFill(array, value, start, end) {
        var length = array.length;

        start = toInteger(start);
        if (start < 0) {
          start = -start > length ? 0 : (length + start);
        }
        end = (end === undefined$1 || end > length) ? length : toInteger(end);
        if (end < 0) {
          end += length;
        }
        end = start > end ? 0 : toLength(end);
        while (start < end) {
          array[start++] = value;
        }
        return array;
      }

      /**
       * The base implementation of `_.filter` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       */
      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function(value, index, collection) {
          if (predicate(value, index, collection)) {
            result.push(value);
          }
        });
        return result;
      }

      /**
       * The base implementation of `_.flatten` with support for restricting flattening.
       *
       * @private
       * @param {Array} array The array to flatten.
       * @param {number} depth The maximum recursion depth.
       * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
       * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
       * @param {Array} [result=[]] The initial result value.
       * @returns {Array} Returns the new flattened array.
       */
      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
            length = array.length;

        predicate || (predicate = isFlattenable);
        result || (result = []);

        while (++index < length) {
          var value = array[index];
          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              // Recursively flatten arrays (susceptible to call stack limits).
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `baseForOwn` which iterates over `object`
       * properties returned by `keysFunc` and invokes `iteratee` for each property.
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseFor = createBaseFor();

      /**
       * This function is like `baseFor` except that it iterates over properties
       * in the opposite order.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @returns {Object} Returns `object`.
       */
      var baseForRight = createBaseFor(true);

      /**
       * The base implementation of `_.forOwn` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */
      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }

      /**
       * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Object} Returns `object`.
       */
      function baseForOwnRight(object, iteratee) {
        return object && baseForRight(object, iteratee, keys);
      }

      /**
       * The base implementation of `_.functions` which creates an array of
       * `object` function property names filtered from `props`.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Array} props The property names to filter.
       * @returns {Array} Returns the function names.
       */
      function baseFunctions(object, props) {
        return arrayFilter(props, function(key) {
          return isFunction(object[key]);
        });
      }

      /**
       * The base implementation of `_.get` without support for default values.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @returns {*} Returns the resolved value.
       */
      function baseGet(object, path) {
        path = castPath(path, object);

        var index = 0,
            length = path.length;

        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }
        return (index && index == length) ? object : undefined$1;
      }

      /**
       * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
       * `keysFunc` and `symbolsFunc` to get the enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Function} keysFunc The function to get the keys of `object`.
       * @param {Function} symbolsFunc The function to get the symbols of `object`.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }

      /**
       * The base implementation of `getTag` without fallbacks for buggy environments.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }
        return (symToStringTag && symToStringTag in Object(value))
          ? getRawTag(value)
          : objectToString(value);
      }

      /**
       * The base implementation of `_.gt` which doesn't coerce arguments.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than `other`,
       *  else `false`.
       */
      function baseGt(value, other) {
        return value > other;
      }

      /**
       * The base implementation of `_.has` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }

      /**
       * The base implementation of `_.hasIn` without support for deep paths.
       *
       * @private
       * @param {Object} [object] The object to query.
       * @param {Array|string} key The key to check.
       * @returns {boolean} Returns `true` if `key` exists, else `false`.
       */
      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }

      /**
       * The base implementation of `_.inRange` which doesn't coerce arguments.
       *
       * @private
       * @param {number} number The number to check.
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
       */
      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }

      /**
       * The base implementation of methods like `_.intersection`, without support
       * for iteratee shorthands, that accepts an array of arrays to inspect.
       *
       * @private
       * @param {Array} arrays The arrays to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of shared values.
       */
      function baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? arrayIncludesWith : arrayIncludes,
            length = arrays[0].length,
            othLength = arrays.length,
            othIndex = othLength,
            caches = Array(othLength),
            maxLength = Infinity,
            result = [];

        while (othIndex--) {
          var array = arrays[othIndex];
          if (othIndex && iteratee) {
            array = arrayMap(array, baseUnary(iteratee));
          }
          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
            ? new SetCache(othIndex && array)
            : undefined$1;
        }
        array = arrays[0];

        var index = -1,
            seen = caches[0];

        outer:
        while (++index < length && result.length < maxLength) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;

          value = (comparator || value !== 0) ? value : 0;
          if (!(seen
                ? cacheHas(seen, computed)
                : includes(result, computed, comparator)
              )) {
            othIndex = othLength;
            while (--othIndex) {
              var cache = caches[othIndex];
              if (!(cache
                    ? cacheHas(cache, computed)
                    : includes(arrays[othIndex], computed, comparator))
                  ) {
                continue outer;
              }
            }
            if (seen) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.invert` and `_.invertBy` which inverts
       * `object` with values transformed by `iteratee` and set by `setter`.
       *
       * @private
       * @param {Object} object The object to iterate over.
       * @param {Function} setter The function to set `accumulator` values.
       * @param {Function} iteratee The iteratee to transform values.
       * @param {Object} accumulator The initial inverted object.
       * @returns {Function} Returns `accumulator`.
       */
      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function(value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }

      /**
       * The base implementation of `_.invoke` without support for individual
       * method arguments.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {Array} args The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       */
      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }

      /**
       * The base implementation of `_.isArguments`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       */
      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }

      /**
       * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
       */
      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }

      /**
       * The base implementation of `_.isDate` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
       */
      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }

      /**
       * The base implementation of `_.isEqual` which supports partial comparisons
       * and tracks traversed objects.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {boolean} bitmask The bitmask flags.
       *  1 - Unordered comparison
       *  2 - Partial comparison
       * @param {Function} [customizer] The function to customize comparisons.
       * @param {Object} [stack] Tracks traversed `value` and `other` objects.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       */
      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }
        if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
          return value !== value && other !== other;
        }
        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }

      /**
       * A specialized version of `baseIsEqual` for arrays and objects which performs
       * deep comparisons and tracks traversed objects enabling objects with circular
       * references to be compared.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} [stack] Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object),
            othIsArr = isArray(other),
            objTag = objIsArr ? arrayTag : getTag(object),
            othTag = othIsArr ? arrayTag : getTag(other);

        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;

        var objIsObj = objTag == objectTag,
            othIsObj = othTag == objectTag,
            isSameTag = objTag == othTag;

        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }
          objIsArr = true;
          objIsObj = false;
        }
        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack);
          return (objIsArr || isTypedArray(object))
            ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
            : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }
        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
              othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
                othUnwrapped = othIsWrapped ? other.value() : other;

            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }
        if (!isSameTag) {
          return false;
        }
        stack || (stack = new Stack);
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }

      /**
       * The base implementation of `_.isMap` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       */
      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }

      /**
       * The base implementation of `_.isMatch` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Array} matchData The property names, values, and compare flags to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       */
      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
            length = index,
            noCustomizer = !customizer;

        if (object == null) {
          return !length;
        }
        object = Object(object);
        while (index--) {
          var data = matchData[index];
          if ((noCustomizer && data[2])
                ? data[1] !== object[data[0]]
                : !(data[0] in object)
              ) {
            return false;
          }
        }
        while (++index < length) {
          data = matchData[index];
          var key = data[0],
              objValue = object[key],
              srcValue = data[1];

          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack;
            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }
            if (!(result === undefined$1
                  ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                  : result
                )) {
              return false;
            }
          }
        }
        return true;
      }

      /**
       * The base implementation of `_.isNative` without bad shim checks.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       */
      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }
        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }

      /**
       * The base implementation of `_.isRegExp` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
       */
      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }

      /**
       * The base implementation of `_.isSet` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       */
      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }

      /**
       * The base implementation of `_.isTypedArray` without Node.js optimizations.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       */
      function baseIsTypedArray(value) {
        return isObjectLike(value) &&
          isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }

      /**
       * The base implementation of `_.iteratee`.
       *
       * @private
       * @param {*} [value=_.identity] The value to convert to an iteratee.
       * @returns {Function} Returns the iteratee.
       */
      function baseIteratee(value) {
        // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
        // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
        if (typeof value == 'function') {
          return value;
        }
        if (value == null) {
          return identity;
        }
        if (typeof value == 'object') {
          return isArray(value)
            ? baseMatchesProperty(value[0], value[1])
            : baseMatches(value);
        }
        return property(value);
      }

      /**
       * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }
        var result = [];
        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }
        var isProto = isPrototype(object),
            result = [];

        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.lt` which doesn't coerce arguments.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than `other`,
       *  else `false`.
       */
      function baseLt(value, other) {
        return value < other;
      }

      /**
       * The base implementation of `_.map` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} iteratee The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       */
      function baseMap(collection, iteratee) {
        var index = -1,
            result = isArrayLike(collection) ? Array(collection.length) : [];

        baseEach(collection, function(value, key, collection) {
          result[++index] = iteratee(value, key, collection);
        });
        return result;
      }

      /**
       * The base implementation of `_.matches` which doesn't clone `source`.
       *
       * @private
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       */
      function baseMatches(source) {
        var matchData = getMatchData(source);
        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }
        return function(object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }

      /**
       * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
       *
       * @private
       * @param {string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }
        return function(object) {
          var objValue = get(object, path);
          return (objValue === undefined$1 && objValue === srcValue)
            ? hasIn(object, path)
            : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }

      /**
       * The base implementation of `_.merge` without support for multiple sources.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} [customizer] The function to customize merged values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }
        baseFor(source, function(srcValue, key) {
          stack || (stack = new Stack);
          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          }
          else {
            var newValue = customizer
              ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
              : undefined$1;

            if (newValue === undefined$1) {
              newValue = srcValue;
            }
            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }

      /**
       * A specialized version of `baseMerge` for arrays and objects which performs
       * deep merges and tracks traversed objects enabling objects with circular
       * references to be merged.
       *
       * @private
       * @param {Object} object The destination object.
       * @param {Object} source The source object.
       * @param {string} key The key of the value to merge.
       * @param {number} srcIndex The index of `source`.
       * @param {Function} mergeFunc The function to merge values.
       * @param {Function} [customizer] The function to customize assigned values.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       */
      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
            srcValue = safeGet(source, key),
            stacked = stack.get(srcValue);

        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }
        var newValue = customizer
          ? customizer(objValue, srcValue, (key + ''), object, source, stack)
          : undefined$1;

        var isCommon = newValue === undefined$1;

        if (isCommon) {
          var isArr = isArray(srcValue),
              isBuff = !isArr && isBuffer(srcValue),
              isTyped = !isArr && !isBuff && isTypedArray(srcValue);

          newValue = srcValue;
          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            }
            else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            }
            else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            }
            else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            }
            else {
              newValue = [];
            }
          }
          else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;
            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            }
            else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          }
          else {
            isCommon = false;
          }
        }
        if (isCommon) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }
        assignMergeValue(object, key, newValue);
      }

      /**
       * The base implementation of `_.nth` which doesn't coerce arguments.
       *
       * @private
       * @param {Array} array The array to query.
       * @param {number} n The index of the element to return.
       * @returns {*} Returns the nth element of `array`.
       */
      function baseNth(array, n) {
        var length = array.length;
        if (!length) {
          return;
        }
        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }

      /**
       * The base implementation of `_.orderBy` without param guards.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
       * @param {string[]} orders The sort orders of `iteratees`.
       * @returns {Array} Returns the new sorted array.
       */
      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function(iteratee) {
            if (isArray(iteratee)) {
              return function(value) {
                return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
              }
            }
            return iteratee;
          });
        } else {
          iteratees = [identity];
        }

        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

        var result = baseMap(collection, function(value, key, collection) {
          var criteria = arrayMap(iteratees, function(iteratee) {
            return iteratee(value);
          });
          return { 'criteria': criteria, 'index': ++index, 'value': value };
        });

        return baseSortBy(result, function(object, other) {
          return compareMultiple(object, other, orders);
        });
      }

      /**
       * The base implementation of `_.pick` without support for individual
       * property identifiers.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @returns {Object} Returns the new object.
       */
      function basePick(object, paths) {
        return basePickBy(object, paths, function(value, path) {
          return hasIn(object, path);
        });
      }

      /**
       * The base implementation of  `_.pickBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Object} object The source object.
       * @param {string[]} paths The property paths to pick.
       * @param {Function} predicate The function invoked per property.
       * @returns {Object} Returns the new object.
       */
      function basePickBy(object, paths, predicate) {
        var index = -1,
            length = paths.length,
            result = {};

        while (++index < length) {
          var path = paths[index],
              value = baseGet(object, path);

          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }
        return result;
      }

      /**
       * A specialized version of `baseProperty` which supports deep paths.
       *
       * @private
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       */
      function basePropertyDeep(path) {
        return function(object) {
          return baseGet(object, path);
        };
      }

      /**
       * The base implementation of `_.pullAllBy` without support for iteratee
       * shorthands.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns `array`.
       */
      function basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
            index = -1,
            length = values.length,
            seen = array;

        if (array === values) {
          values = copyArray(values);
        }
        if (iteratee) {
          seen = arrayMap(array, baseUnary(iteratee));
        }
        while (++index < length) {
          var fromIndex = 0,
              value = values[index],
              computed = iteratee ? iteratee(value) : value;

          while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }
            splice.call(array, fromIndex, 1);
          }
        }
        return array;
      }

      /**
       * The base implementation of `_.pullAt` without support for individual
       * indexes or capturing the removed elements.
       *
       * @private
       * @param {Array} array The array to modify.
       * @param {number[]} indexes The indexes of elements to remove.
       * @returns {Array} Returns `array`.
       */
      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0,
            lastIndex = length - 1;

        while (length--) {
          var index = indexes[length];
          if (length == lastIndex || index !== previous) {
            var previous = index;
            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }
        return array;
      }

      /**
       * The base implementation of `_.random` without support for returning
       * floating-point numbers.
       *
       * @private
       * @param {number} lower The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the random number.
       */
      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }

      /**
       * The base implementation of `_.range` and `_.rangeRight` which doesn't
       * coerce arguments.
       *
       * @private
       * @param {number} start The start of the range.
       * @param {number} end The end of the range.
       * @param {number} step The value to increment or decrement by.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the range of numbers.
       */
      function baseRange(start, end, step, fromRight) {
        var index = -1,
            length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
            result = Array(length);

        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }
        return result;
      }

      /**
       * The base implementation of `_.repeat` which doesn't coerce arguments.
       *
       * @private
       * @param {string} string The string to repeat.
       * @param {number} n The number of times to repeat the string.
       * @returns {string} Returns the repeated string.
       */
      function baseRepeat(string, n) {
        var result = '';
        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result;
        }
        // Leverage the exponentiation by squaring algorithm for a faster repeat.
        // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
        do {
          if (n % 2) {
            result += string;
          }
          n = nativeFloor(n / 2);
          if (n) {
            string += string;
          }
        } while (n);

        return result;
      }

      /**
       * The base implementation of `_.rest` which doesn't validate or coerce arguments.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       */
      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }

      /**
       * The base implementation of `_.sample`.
       *
       * @private
       * @param {Array|Object} collection The collection to sample.
       * @returns {*} Returns the random element.
       */
      function baseSample(collection) {
        return arraySample(values(collection));
      }

      /**
       * The base implementation of `_.sampleSize` without param guards.
       *
       * @private
       * @param {Array|Object} collection The collection to sample.
       * @param {number} n The number of elements to sample.
       * @returns {Array} Returns the random elements.
       */
      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }

      /**
       * The base implementation of `_.set`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }
        path = castPath(path, object);

        var index = -1,
            length = path.length,
            lastIndex = length - 1,
            nested = object;

        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
              newValue = value;

          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return object;
          }

          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;
            if (newValue === undefined$1) {
              newValue = isObject(objValue)
                ? objValue
                : (isIndex(path[index + 1]) ? [] : {});
            }
          }
          assignValue(nested, key, newValue);
          nested = nested[key];
        }
        return object;
      }

      /**
       * The base implementation of `setData` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to associate metadata with.
       * @param {*} data The metadata.
       * @returns {Function} Returns `func`.
       */
      var baseSetData = !metaMap ? identity : function(func, data) {
        metaMap.set(func, data);
        return func;
      };

      /**
       * The base implementation of `setToString` without support for hot loop shorting.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var baseSetToString = !defineProperty ? identity : function(func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true
        });
      };

      /**
       * The base implementation of `_.shuffle`.
       *
       * @private
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       */
      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }

      /**
       * The base implementation of `_.slice` without an iteratee call guard.
       *
       * @private
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseSlice(array, start, end) {
        var index = -1,
            length = array.length;

        if (start < 0) {
          start = -start > length ? 0 : (length + start);
        }
        end = end > length ? length : end;
        if (end < 0) {
          end += length;
        }
        length = start > end ? 0 : ((end - start) >>> 0);
        start >>>= 0;

        var result = Array(length);
        while (++index < length) {
          result[index] = array[index + start];
        }
        return result;
      }

      /**
       * The base implementation of `_.some` without support for iteratee shorthands.
       *
       * @private
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} predicate The function invoked per iteration.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       */
      function baseSome(collection, predicate) {
        var result;

        baseEach(collection, function(value, index, collection) {
          result = predicate(value, index, collection);
          return !result;
        });
        return !!result;
      }

      /**
       * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
       * performs a binary search of `array` to determine the index at which `value`
       * should be inserted into `array` in order to maintain its sort order.
       *
       * @private
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {boolean} [retHighest] Specify returning the highest qualified index.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       */
      function baseSortedIndex(array, value, retHighest) {
        var low = 0,
            high = array == null ? low : array.length;

        if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = (low + high) >>> 1,
                computed = array[mid];

            if (computed !== null && !isSymbol(computed) &&
                (retHighest ? (computed <= value) : (computed < value))) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return high;
        }
        return baseSortedIndexBy(array, value, identity, retHighest);
      }

      /**
       * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
       * which invokes `iteratee` for `value` and each element of `array` to compute
       * their sort ranking. The iteratee is invoked with one argument; (value).
       *
       * @private
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} iteratee The iteratee invoked per element.
       * @param {boolean} [retHighest] Specify returning the highest qualified index.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       */
      function baseSortedIndexBy(array, value, iteratee, retHighest) {
        var low = 0,
            high = array == null ? 0 : array.length;
        if (high === 0) {
          return 0;
        }

        value = iteratee(value);
        var valIsNaN = value !== value,
            valIsNull = value === null,
            valIsSymbol = isSymbol(value),
            valIsUndefined = value === undefined$1;

        while (low < high) {
          var mid = nativeFloor((low + high) / 2),
              computed = iteratee(array[mid]),
              othIsDefined = computed !== undefined$1,
              othIsNull = computed === null,
              othIsReflexive = computed === computed,
              othIsSymbol = isSymbol(computed);

          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? (computed <= value) : (computed < value);
          }
          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return nativeMin(high, MAX_ARRAY_INDEX);
      }

      /**
       * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
       * support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */
      function baseSortedUniq(array, iteratee) {
        var index = -1,
            length = array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;

          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.toNumber` which doesn't ensure correct
       * conversions of binary, hexadecimal, or octal string values.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       */
      function baseToNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        return +value;
      }

      /**
       * The base implementation of `_.toString` which doesn't convert nullish
       * values to empty strings.
       *
       * @private
       * @param {*} value The value to process.
       * @returns {string} Returns the string.
       */
      function baseToString(value) {
        // Exit early for strings to avoid a performance hit in some environments.
        if (typeof value == 'string') {
          return value;
        }
        if (isArray(value)) {
          // Recursively convert values (susceptible to call stack limits).
          return arrayMap(value, baseToString) + '';
        }
        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }
        var result = (value + '');
        return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
      }

      /**
       * The base implementation of `_.uniqBy` without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       */
      function baseUniq(array, iteratee, comparator) {
        var index = -1,
            includes = arrayIncludes,
            length = array.length,
            isCommon = true,
            result = [],
            seen = result;

        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        }
        else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);
          if (set) {
            return setToArray(set);
          }
          isCommon = false;
          includes = cacheHas;
          seen = new SetCache;
        }
        else {
          seen = iteratee ? [] : result;
        }
        outer:
        while (++index < length) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;

          value = (comparator || value !== 0) ? value : 0;
          if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }
            if (iteratee) {
              seen.push(computed);
            }
            result.push(value);
          }
          else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }
            result.push(value);
          }
        }
        return result;
      }

      /**
       * The base implementation of `_.unset`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The property path to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       */
      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }

      /**
       * The base implementation of `_.update`.
       *
       * @private
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to update.
       * @param {Function} updater The function to produce the updated value.
       * @param {Function} [customizer] The function to customize path creation.
       * @returns {Object} Returns `object`.
       */
      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }

      /**
       * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
       * without support for iteratee shorthands.
       *
       * @private
       * @param {Array} array The array to query.
       * @param {Function} predicate The function invoked per iteration.
       * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Array} Returns the slice of `array`.
       */
      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length) &&
          predicate(array[index], index, array)) {}

        return isDrop
          ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
          : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
      }

      /**
       * The base implementation of `wrapperValue` which returns the result of
       * performing a sequence of actions on the unwrapped `value`, where each
       * successive action is supplied the return value of the previous.
       *
       * @private
       * @param {*} value The unwrapped value.
       * @param {Array} actions Actions to perform to resolve the unwrapped value.
       * @returns {*} Returns the resolved value.
       */
      function baseWrapperValue(value, actions) {
        var result = value;
        if (result instanceof LazyWrapper) {
          result = result.value();
        }
        return arrayReduce(actions, function(result, action) {
          return action.func.apply(action.thisArg, arrayPush([result], action.args));
        }, result);
      }

      /**
       * The base implementation of methods like `_.xor`, without support for
       * iteratee shorthands, that accepts an array of arrays to inspect.
       *
       * @private
       * @param {Array} arrays The arrays to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of values.
       */
      function baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;
        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }
        var index = -1,
            result = Array(length);

        while (++index < length) {
          var array = arrays[index],
              othIndex = -1;

          while (++othIndex < length) {
            if (othIndex != index) {
              result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
          }
        }
        return baseUniq(baseFlatten(result, 1), iteratee, comparator);
      }

      /**
       * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
       *
       * @private
       * @param {Array} props The property identifiers.
       * @param {Array} values The property values.
       * @param {Function} assignFunc The function to assign values.
       * @returns {Object} Returns the new object.
       */
      function baseZipObject(props, values, assignFunc) {
        var index = -1,
            length = props.length,
            valsLength = values.length,
            result = {};

        while (++index < length) {
          var value = index < valsLength ? values[index] : undefined$1;
          assignFunc(result, props[index], value);
        }
        return result;
      }

      /**
       * Casts `value` to an empty array if it's not an array like object.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Array|Object} Returns the cast array-like object.
       */
      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }

      /**
       * Casts `value` to `identity` if it's not a function.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {Function} Returns cast function.
       */
      function castFunction(value) {
        return typeof value == 'function' ? value : identity;
      }

      /**
       * Casts `value` to a path array if it's not one.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {Object} [object] The object to query keys on.
       * @returns {Array} Returns the cast property path array.
       */
      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }
        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }

      /**
       * A `baseRest` alias which can be replaced with `identity` by module
       * replacement plugins.
       *
       * @private
       * @type {Function}
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      var castRest = baseRest;

      /**
       * Casts `array` to a slice if it's needed.
       *
       * @private
       * @param {Array} array The array to inspect.
       * @param {number} start The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the cast slice.
       */
      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return (!start && end >= length) ? array : baseSlice(array, start, end);
      }

      /**
       * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
       *
       * @private
       * @param {number|Object} id The timer id or timeout object of the timer to clear.
       */
      var clearTimeout = ctxClearTimeout || function(id) {
        return root.clearTimeout(id);
      };

      /**
       * Creates a clone of  `buffer`.
       *
       * @private
       * @param {Buffer} buffer The buffer to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Buffer} Returns the cloned buffer.
       */
      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }
        var length = buffer.length,
            result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

        buffer.copy(result);
        return result;
      }

      /**
       * Creates a clone of `arrayBuffer`.
       *
       * @private
       * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
       * @returns {ArrayBuffer} Returns the cloned array buffer.
       */
      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }

      /**
       * Creates a clone of `dataView`.
       *
       * @private
       * @param {Object} dataView The data view to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned data view.
       */
      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }

      /**
       * Creates a clone of `regexp`.
       *
       * @private
       * @param {Object} regexp The regexp to clone.
       * @returns {Object} Returns the cloned regexp.
       */
      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }

      /**
       * Creates a clone of the `symbol` object.
       *
       * @private
       * @param {Object} symbol The symbol object to clone.
       * @returns {Object} Returns the cloned symbol object.
       */
      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }

      /**
       * Creates a clone of `typedArray`.
       *
       * @private
       * @param {Object} typedArray The typed array to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the cloned typed array.
       */
      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }

      /**
       * Compares values to sort them in ascending order.
       *
       * @private
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {number} Returns the sort order indicator for `value`.
       */
      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1,
              valIsNull = value === null,
              valIsReflexive = value === value,
              valIsSymbol = isSymbol(value);

          var othIsDefined = other !== undefined$1,
              othIsNull = other === null,
              othIsReflexive = other === other,
              othIsSymbol = isSymbol(other);

          if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
              (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
              (valIsNull && othIsDefined && othIsReflexive) ||
              (!valIsDefined && othIsReflexive) ||
              !valIsReflexive) {
            return 1;
          }
          if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
              (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
              (othIsNull && valIsDefined && valIsReflexive) ||
              (!othIsDefined && valIsReflexive) ||
              !othIsReflexive) {
            return -1;
          }
        }
        return 0;
      }

      /**
       * Used by `_.orderBy` to compare multiple properties of a value to another
       * and stable sort them.
       *
       * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
       * specify an order of "desc" for descending or "asc" for ascending sort order
       * of corresponding values.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {boolean[]|string[]} orders The order to sort by for each property.
       * @returns {number} Returns the sort order indicator for `object`.
       */
      function compareMultiple(object, other, orders) {
        var index = -1,
            objCriteria = object.criteria,
            othCriteria = other.criteria,
            length = objCriteria.length,
            ordersLength = orders.length;

        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);
          if (result) {
            if (index >= ordersLength) {
              return result;
            }
            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
          }
        }
        // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
        // that causes it, under certain circumstances, to provide the same value for
        // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
        // for more details.
        //
        // This also ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
      }

      /**
       * Creates an array that is the composition of partially applied arguments,
       * placeholders, and provided arguments into a single array of arguments.
       *
       * @private
       * @param {Array} args The provided arguments.
       * @param {Array} partials The arguments to prepend to those provided.
       * @param {Array} holders The `partials` placeholder indexes.
       * @params {boolean} [isCurried] Specify composing for a curried function.
       * @returns {Array} Returns the new array of composed arguments.
       */
      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1,
            argsLength = args.length,
            holdersLength = holders.length,
            leftIndex = -1,
            leftLength = partials.length,
            rangeLength = nativeMax(argsLength - holdersLength, 0),
            result = Array(leftLength + rangeLength),
            isUncurried = !isCurried;

        while (++leftIndex < leftLength) {
          result[leftIndex] = partials[leftIndex];
        }
        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
        }
        while (rangeLength--) {
          result[leftIndex++] = args[argsIndex++];
        }
        return result;
      }

      /**
       * This function is like `composeArgs` except that the arguments composition
       * is tailored for `_.partialRight`.
       *
       * @private
       * @param {Array} args The provided arguments.
       * @param {Array} partials The arguments to append to those provided.
       * @param {Array} holders The `partials` placeholder indexes.
       * @params {boolean} [isCurried] Specify composing for a curried function.
       * @returns {Array} Returns the new array of composed arguments.
       */
      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1,
            argsLength = args.length,
            holdersIndex = -1,
            holdersLength = holders.length,
            rightIndex = -1,
            rightLength = partials.length,
            rangeLength = nativeMax(argsLength - holdersLength, 0),
            result = Array(rangeLength + rightLength),
            isUncurried = !isCurried;

        while (++argsIndex < rangeLength) {
          result[argsIndex] = args[argsIndex];
        }
        var offset = argsIndex;
        while (++rightIndex < rightLength) {
          result[offset + rightIndex] = partials[rightIndex];
        }
        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }
        return result;
      }

      /**
       * Copies the values of `source` to `array`.
       *
       * @private
       * @param {Array} source The array to copy values from.
       * @param {Array} [array=[]] The array to copy values to.
       * @returns {Array} Returns `array`.
       */
      function copyArray(source, array) {
        var index = -1,
            length = source.length;

        array || (array = Array(length));
        while (++index < length) {
          array[index] = source[index];
        }
        return array;
      }

      /**
       * Copies properties of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy properties from.
       * @param {Array} props The property identifiers to copy.
       * @param {Object} [object={}] The object to copy properties to.
       * @param {Function} [customizer] The function to customize copied values.
       * @returns {Object} Returns `object`.
       */
      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});

        var index = -1,
            length = props.length;

        while (++index < length) {
          var key = props[index];

          var newValue = customizer
            ? customizer(object[key], source[key], key, object, source)
            : undefined$1;

          if (newValue === undefined$1) {
            newValue = source[key];
          }
          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }
        return object;
      }

      /**
       * Copies own symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }

      /**
       * Copies own and inherited symbols of `source` to `object`.
       *
       * @private
       * @param {Object} source The object to copy symbols from.
       * @param {Object} [object={}] The object to copy symbols to.
       * @returns {Object} Returns `object`.
       */
      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }

      /**
       * Creates a function like `_.groupBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} [initializer] The accumulator object initializer.
       * @returns {Function} Returns the new aggregator function.
       */
      function createAggregator(setter, initializer) {
        return function(collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
              accumulator = initializer ? initializer() : {};

          return func(collection, setter, getIteratee(iteratee, 2), accumulator);
        };
      }

      /**
       * Creates a function like `_.assign`.
       *
       * @private
       * @param {Function} assigner The function to assign values.
       * @returns {Function} Returns the new assigner function.
       */
      function createAssigner(assigner) {
        return baseRest(function(object, sources) {
          var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined$1,
              guard = length > 2 ? sources[2] : undefined$1;

          customizer = (assigner.length > 3 && typeof customizer == 'function')
            ? (length--, customizer)
            : undefined$1;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }
          object = Object(object);
          while (++index < length) {
            var source = sources[index];
            if (source) {
              assigner(object, source, index, customizer);
            }
          }
          return object;
        });
      }

      /**
       * Creates a `baseEach` or `baseEachRight` function.
       *
       * @private
       * @param {Function} eachFunc The function to iterate over a collection.
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseEach(eachFunc, fromRight) {
        return function(collection, iteratee) {
          if (collection == null) {
            return collection;
          }
          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }
          var length = collection.length,
              index = fromRight ? length : -1,
              iterable = Object(collection);

          while ((fromRight ? index-- : ++index < length)) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }
          return collection;
        };
      }

      /**
       * Creates a base function for methods like `_.forIn` and `_.forOwn`.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new base function.
       */
      function createBaseFor(fromRight) {
        return function(object, iteratee, keysFunc) {
          var index = -1,
              iterable = Object(object),
              props = keysFunc(object),
              length = props.length;

          while (length--) {
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }
          return object;
        };
      }

      /**
       * Creates a function that wraps `func` to invoke it with the optional `this`
       * binding of `thisArg`.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG,
            Ctor = createCtor(func);

        function wrapper() {
          var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
      }

      /**
       * Creates a function like `_.lowerFirst`.
       *
       * @private
       * @param {string} methodName The name of the `String` case method to use.
       * @returns {Function} Returns the new case function.
       */
      function createCaseFirst(methodName) {
        return function(string) {
          string = toString(string);

          var strSymbols = hasUnicode(string)
            ? stringToArray(string)
            : undefined$1;

          var chr = strSymbols
            ? strSymbols[0]
            : string.charAt(0);

          var trailing = strSymbols
            ? castSlice(strSymbols, 1).join('')
            : string.slice(1);

          return chr[methodName]() + trailing;
        };
      }

      /**
       * Creates a function like `_.camelCase`.
       *
       * @private
       * @param {Function} callback The function to combine each word.
       * @returns {Function} Returns the new compounder function.
       */
      function createCompounder(callback) {
        return function(string) {
          return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
        };
      }

      /**
       * Creates a function that produces an instance of `Ctor` regardless of
       * whether it was invoked as part of a `new` expression or by `call` or `apply`.
       *
       * @private
       * @param {Function} Ctor The constructor to wrap.
       * @returns {Function} Returns the new wrapped function.
       */
      function createCtor(Ctor) {
        return function() {
          // Use a `switch` statement to work with class constructors. See
          // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
          // for more details.
          var args = arguments;
          switch (args.length) {
            case 0: return new Ctor;
            case 1: return new Ctor(args[0]);
            case 2: return new Ctor(args[0], args[1]);
            case 3: return new Ctor(args[0], args[1], args[2]);
            case 4: return new Ctor(args[0], args[1], args[2], args[3]);
            case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }
          var thisBinding = baseCreate(Ctor.prototype),
              result = Ctor.apply(thisBinding, args);

          // Mimic the constructor's `return` behavior.
          // See https://es5.github.io/#x13.2.2 for more details.
          return isObject(result) ? result : thisBinding;
        };
      }

      /**
       * Creates a function that wraps `func` to enable currying.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {number} arity The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);

        function wrapper() {
          var length = arguments.length,
              args = Array(length),
              index = length,
              placeholder = getHolder(wrapper);

          while (index--) {
            args[index] = arguments[index];
          }
          var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
            ? []
            : replaceHolders(args, placeholder);

          length -= holders.length;
          if (length < arity) {
            return createRecurry(
              func, bitmask, createHybrid, wrapper.placeholder, undefined$1,
              args, holders, undefined$1, undefined$1, arity - length);
          }
          var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
          return apply(fn, this, args);
        }
        return wrapper;
      }

      /**
       * Creates a `_.find` or `_.findLast` function.
       *
       * @private
       * @param {Function} findIndexFunc The function to find the collection index.
       * @returns {Function} Returns the new find function.
       */
      function createFind(findIndexFunc) {
        return function(collection, predicate, fromIndex) {
          var iterable = Object(collection);
          if (!isArrayLike(collection)) {
            var iteratee = getIteratee(predicate, 3);
            collection = keys(collection);
            predicate = function(key) { return iteratee(iterable[key], key, iterable); };
          }
          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
        };
      }

      /**
       * Creates a `_.flow` or `_.flowRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new flow function.
       */
      function createFlow(fromRight) {
        return flatRest(function(funcs) {
          var length = funcs.length,
              index = length,
              prereq = LodashWrapper.prototype.thru;

          if (fromRight) {
            funcs.reverse();
          }
          while (index--) {
            var func = funcs[index];
            if (typeof func != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }
            if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
              var wrapper = new LodashWrapper([], true);
            }
          }
          index = wrapper ? index : length;
          while (++index < length) {
            func = funcs[index];

            var funcName = getFuncName(func),
                data = funcName == 'wrapper' ? getData(func) : undefined$1;

            if (data && isLaziable(data[0]) &&
                  data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                  !data[4].length && data[9] == 1
                ) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = (func.length == 1 && isLaziable(func))
                ? wrapper[funcName]()
                : wrapper.thru(func);
            }
          }
          return function() {
            var args = arguments,
                value = args[0];

            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }
            var index = 0,
                result = length ? funcs[index].apply(this, args) : value;

            while (++index < length) {
              result = funcs[index].call(this, result);
            }
            return result;
          };
        });
      }

      /**
       * Creates a function that wraps `func` to invoke it with optional `this`
       * binding of `thisArg`, partial application, and currying.
       *
       * @private
       * @param {Function|string} func The function or method name to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to prepend to those provided to
       *  the new function.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [partialsRight] The arguments to append to those provided
       *  to the new function.
       * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG,
            isBind = bitmask & WRAP_BIND_FLAG,
            isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
            isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
            isFlip = bitmask & WRAP_FLIP_FLAG,
            Ctor = isBindKey ? undefined$1 : createCtor(func);

        function wrapper() {
          var length = arguments.length,
              args = Array(length),
              index = length;

          while (index--) {
            args[index] = arguments[index];
          }
          if (isCurried) {
            var placeholder = getHolder(wrapper),
                holdersCount = countHolders(args, placeholder);
          }
          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }
          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }
          length -= holdersCount;
          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(
              func, bitmask, createHybrid, wrapper.placeholder, thisArg,
              args, newHolders, argPos, ary, arity - length
            );
          }
          var thisBinding = isBind ? thisArg : this,
              fn = isBindKey ? thisBinding[func] : func;

          length = args.length;
          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }
          if (isAry && ary < length) {
            args.length = ary;
          }
          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }
          return fn.apply(thisBinding, args);
        }
        return wrapper;
      }

      /**
       * Creates a function like `_.invertBy`.
       *
       * @private
       * @param {Function} setter The function to set accumulator values.
       * @param {Function} toIteratee The function to resolve iteratees.
       * @returns {Function} Returns the new inverter function.
       */
      function createInverter(setter, toIteratee) {
        return function(object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }

      /**
       * Creates a function that performs a mathematical operation on two values.
       *
       * @private
       * @param {Function} operator The function to perform the operation.
       * @param {number} [defaultValue] The value used for `undefined` arguments.
       * @returns {Function} Returns the new mathematical operation function.
       */
      function createMathOperation(operator, defaultValue) {
        return function(value, other) {
          var result;
          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }
          if (value !== undefined$1) {
            result = value;
          }
          if (other !== undefined$1) {
            if (result === undefined$1) {
              return other;
            }
            if (typeof value == 'string' || typeof other == 'string') {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }
            result = operator(value, other);
          }
          return result;
        };
      }

      /**
       * Creates a function like `_.over`.
       *
       * @private
       * @param {Function} arrayFunc The function to iterate over iteratees.
       * @returns {Function} Returns the new over function.
       */
      function createOver(arrayFunc) {
        return flatRest(function(iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function(args) {
            var thisArg = this;
            return arrayFunc(iteratees, function(iteratee) {
              return apply(iteratee, thisArg, args);
            });
          });
        });
      }

      /**
       * Creates the padding for `string` based on `length`. The `chars` string
       * is truncated if the number of characters exceeds `length`.
       *
       * @private
       * @param {number} length The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padding for `string`.
       */
      function createPadding(length, chars) {
        chars = chars === undefined$1 ? ' ' : baseToString(chars);

        var charsLength = chars.length;
        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }
        var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars)
          ? castSlice(stringToArray(result), 0, length).join('')
          : result.slice(0, length);
      }

      /**
       * Creates a function that wraps `func` to invoke it with the `this` binding
       * of `thisArg` and `partials` prepended to the arguments it receives.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {Array} partials The arguments to prepend to those provided to
       *  the new function.
       * @returns {Function} Returns the new wrapped function.
       */
      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG,
            Ctor = createCtor(func);

        function wrapper() {
          var argsIndex = -1,
              argsLength = arguments.length,
              leftIndex = -1,
              leftLength = partials.length,
              args = Array(leftLength + argsLength),
              fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }
          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }
          return apply(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
      }

      /**
       * Creates a `_.range` or `_.rangeRight` function.
       *
       * @private
       * @param {boolean} [fromRight] Specify iterating from right to left.
       * @returns {Function} Returns the new range function.
       */
      function createRange(fromRight) {
        return function(start, end, step) {
          if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }
          // Ensure the sign of `-0` is preserved.
          start = toFinite(start);
          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          step = step === undefined$1 ? (start < end ? 1 : -1) : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }

      /**
       * Creates a function that performs a relational operation on two values.
       *
       * @private
       * @param {Function} operator The function to perform the operation.
       * @returns {Function} Returns the new relational operation function.
       */
      function createRelationalOperation(operator) {
        return function(value, other) {
          if (!(typeof value == 'string' && typeof other == 'string')) {
            value = toNumber(value);
            other = toNumber(other);
          }
          return operator(value, other);
        };
      }

      /**
       * Creates a function that wraps `func` to continue currying.
       *
       * @private
       * @param {Function} func The function to wrap.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @param {Function} wrapFunc The function to create the `func` wrapper.
       * @param {*} placeholder The placeholder value.
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to prepend to those provided to
       *  the new function.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG,
            newHolders = isCurry ? holders : undefined$1,
            newHoldersRight = isCurry ? undefined$1 : holders,
            newPartials = isCurry ? partials : undefined$1,
            newPartialsRight = isCurry ? undefined$1 : partials;

        bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }
        var newData = [
          func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
          newHoldersRight, argPos, ary, arity
        ];

        var result = wrapFunc.apply(undefined$1, newData);
        if (isLaziable(func)) {
          setData(result, newData);
        }
        result.placeholder = placeholder;
        return setWrapToString(result, func, bitmask);
      }

      /**
       * Creates a function like `_.round`.
       *
       * @private
       * @param {string} methodName The name of the `Math` method to use when rounding.
       * @returns {Function} Returns the new round function.
       */
      function createRound(methodName) {
        var func = Math[methodName];
        return function(number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
          if (precision && nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = (toString(number) + 'e').split('e'),
                value = func(pair[0] + 'e' + (+pair[1] + precision));

            pair = (toString(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
          }
          return func(number);
        };
      }

      /**
       * Creates a set object of `values`.
       *
       * @private
       * @param {Array} values The values to add to the set.
       * @returns {Object} Returns the new set.
       */
      var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
        return new Set(values);
      };

      /**
       * Creates a `_.toPairs` or `_.toPairsIn` function.
       *
       * @private
       * @param {Function} keysFunc The function to get the keys of a given object.
       * @returns {Function} Returns the new pairs function.
       */
      function createToPairs(keysFunc) {
        return function(object) {
          var tag = getTag(object);
          if (tag == mapTag) {
            return mapToArray(object);
          }
          if (tag == setTag) {
            return setToPairs(object);
          }
          return baseToPairs(object, keysFunc(object));
        };
      }

      /**
       * Creates a function that either curries or invokes `func` with optional
       * `this` binding and partially applied arguments.
       *
       * @private
       * @param {Function|string} func The function or method name to wrap.
       * @param {number} bitmask The bitmask flags.
       *    1 - `_.bind`
       *    2 - `_.bindKey`
       *    4 - `_.curry` or `_.curryRight` of a bound function
       *    8 - `_.curry`
       *   16 - `_.curryRight`
       *   32 - `_.partial`
       *   64 - `_.partialRight`
       *  128 - `_.rearg`
       *  256 - `_.ary`
       *  512 - `_.flip`
       * @param {*} [thisArg] The `this` binding of `func`.
       * @param {Array} [partials] The arguments to be partially applied.
       * @param {Array} [holders] The `partials` placeholder indexes.
       * @param {Array} [argPos] The argument positions of the new function.
       * @param {number} [ary] The arity cap of `func`.
       * @param {number} [arity] The arity of `func`.
       * @returns {Function} Returns the new wrapped function.
       */
      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var length = partials ? partials.length : 0;
        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }
        ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;

        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials,
              holdersRight = holders;

          partials = holders = undefined$1;
        }
        var data = isBindKey ? undefined$1 : getData(func);

        var newData = [
          func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
          argPos, ary, arity
        ];

        if (data) {
          mergeData(newData, data);
        }
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1
          ? (isBindKey ? 0 : func.length)
          : nativeMax(newData[9] - length, 0);

        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }
        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result = createPartial(func, bitmask, thisArg, partials);
        } else {
          result = createHybrid.apply(undefined$1, newData);
        }
        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result, newData), func, bitmask);
      }

      /**
       * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
       * of source objects to the destination object for all destination properties
       * that resolve to `undefined`.
       *
       * @private
       * @param {*} objValue The destination value.
       * @param {*} srcValue The source value.
       * @param {string} key The key of the property to assign.
       * @param {Object} object The parent object of `objValue`.
       * @returns {*} Returns the value to assign.
       */
      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 ||
            (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
          return srcValue;
        }
        return objValue;
      }

      /**
       * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
       * objects into destination objects that are passed thru.
       *
       * @private
       * @param {*} objValue The destination value.
       * @param {*} srcValue The source value.
       * @param {string} key The key of the property to merge.
       * @param {Object} object The parent object of `objValue`.
       * @param {Object} source The parent object of `srcValue`.
       * @param {Object} [stack] Tracks traversed source values and their merged
       *  counterparts.
       * @returns {*} Returns the value to assign.
       */
      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          // Recursively merge objects and arrays (susceptible to call stack limits).
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack['delete'](srcValue);
        }
        return objValue;
      }

      /**
       * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
       * objects.
       *
       * @private
       * @param {*} value The value to inspect.
       * @param {string} key The key of the property to inspect.
       * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
       */
      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for arrays with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Array} array The array to compare.
       * @param {Array} other The other array to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `array` and `other` objects.
       * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
       */
      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            arrLength = array.length,
            othLength = other.length;

        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }
        // Check that cyclic values are equal.
        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);
        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }
        var index = -1,
            result = true,
            seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined$1;

        stack.set(array, other);
        stack.set(other, array);

        // Ignore non-index properties.
        while (++index < arrLength) {
          var arrValue = array[index],
              othValue = other[index];

          if (customizer) {
            var compared = isPartial
              ? customizer(othValue, arrValue, index, other, array, stack)
              : customizer(arrValue, othValue, index, array, other, stack);
          }
          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }
            result = false;
            break;
          }
          // Recursively compare arrays (susceptible to call stack limits).
          if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                  if (!cacheHas(seen, othIndex) &&
                      (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                    return seen.push(othIndex);
                  }
                })) {
              result = false;
              break;
            }
          } else if (!(
                arrValue === othValue ||
                  equalFunc(arrValue, othValue, bitmask, customizer, stack)
              )) {
            result = false;
            break;
          }
        }
        stack['delete'](array);
        stack['delete'](other);
        return result;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for comparing objects of
       * the same `toStringTag`.
       *
       * **Note:** This function only supports comparing values with tags of
       * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {string} tag The `toStringTag` of the objects to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if ((object.byteLength != other.byteLength) ||
                (object.byteOffset != other.byteOffset)) {
              return false;
            }
            object = object.buffer;
            other = other.buffer;

          case arrayBufferTag:
            if ((object.byteLength != other.byteLength) ||
                !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }
            return true;

          case boolTag:
          case dateTag:
          case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);

          case errorTag:
            return object.name == other.name && object.message == other.message;

          case regexpTag:
          case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == (other + '');

          case mapTag:
            var convert = mapToArray;

          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);

            if (object.size != other.size && !isPartial) {
              return false;
            }
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) {
              return stacked == other;
            }
            bitmask |= COMPARE_UNORDERED_FLAG;

            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;

          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }
        }
        return false;
      }

      /**
       * A specialized version of `baseIsEqualDeep` for objects with support for
       * partial deep comparisons.
       *
       * @private
       * @param {Object} object The object to compare.
       * @param {Object} other The other object to compare.
       * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
       * @param {Function} customizer The function to customize comparisons.
       * @param {Function} equalFunc The function to determine equivalents of values.
       * @param {Object} stack Tracks traversed `object` and `other` objects.
       * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
       */
      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            objProps = getAllKeys(object),
            objLength = objProps.length,
            othProps = getAllKeys(other),
            othLength = othProps.length;

        if (objLength != othLength && !isPartial) {
          return false;
        }
        var index = objLength;
        while (index--) {
          var key = objProps[index];
          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }
        // Check that cyclic values are equal.
        var objStacked = stack.get(object);
        var othStacked = stack.get(other);
        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }
        var result = true;
        stack.set(object, other);
        stack.set(other, object);

        var skipCtor = isPartial;
        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
              othValue = other[key];

          if (customizer) {
            var compared = isPartial
              ? customizer(othValue, objValue, key, other, object, stack)
              : customizer(objValue, othValue, key, object, other, stack);
          }
          // Recursively compare objects (susceptible to call stack limits).
          if (!(compared === undefined$1
                ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
                : compared
              )) {
            result = false;
            break;
          }
          skipCtor || (skipCtor = key == 'constructor');
        }
        if (result && !skipCtor) {
          var objCtor = object.constructor,
              othCtor = other.constructor;

          // Non `Object` object instances with different constructors are not equal.
          if (objCtor != othCtor &&
              ('constructor' in object && 'constructor' in other) &&
              !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
                typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
          }
        }
        stack['delete'](object);
        stack['delete'](other);
        return result;
      }

      /**
       * A specialized version of `baseRest` which flattens the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @returns {Function} Returns the new function.
       */
      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + '');
      }

      /**
       * Creates an array of own enumerable property names and symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }

      /**
       * Creates an array of own and inherited enumerable property names and
       * symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names and symbols.
       */
      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }

      /**
       * Gets metadata for `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {*} Returns the metadata for `func`.
       */
      var getData = !metaMap ? noop : function(func) {
        return metaMap.get(func);
      };

      /**
       * Gets the name of `func`.
       *
       * @private
       * @param {Function} func The function to query.
       * @returns {string} Returns the function name.
       */
      function getFuncName(func) {
        var result = (func.name + ''),
            array = realNames[result],
            length = hasOwnProperty.call(realNames, result) ? array.length : 0;

        while (length--) {
          var data = array[length],
              otherFunc = data.func;
          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }
        return result;
      }

      /**
       * Gets the argument placeholder value for `func`.
       *
       * @private
       * @param {Function} func The function to inspect.
       * @returns {*} Returns the placeholder value.
       */
      function getHolder(func) {
        var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
        return object.placeholder;
      }

      /**
       * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
       * this function returns the custom method, otherwise it returns `baseIteratee`.
       * If arguments are provided, the chosen function is invoked with them and
       * its result is returned.
       *
       * @private
       * @param {*} [value] The value to convert to an iteratee.
       * @param {number} [arity] The arity of the created iteratee.
       * @returns {Function} Returns the chosen function or its result.
       */
      function getIteratee() {
        var result = lodash.iteratee || iteratee;
        result = result === iteratee ? baseIteratee : result;
        return arguments.length ? result(arguments[0], arguments[1]) : result;
      }

      /**
       * Gets the data for `map`.
       *
       * @private
       * @param {Object} map The map to query.
       * @param {string} key The reference key.
       * @returns {*} Returns the map data.
       */
      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key)
          ? data[typeof key == 'string' ? 'string' : 'hash']
          : data.map;
      }

      /**
       * Gets the property names, values, and compare flags of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the match data of `object`.
       */
      function getMatchData(object) {
        var result = keys(object),
            length = result.length;

        while (length--) {
          var key = result[length],
              value = object[key];

          result[length] = [key, value, isStrictComparable(value)];
        }
        return result;
      }

      /**
       * Gets the native function at `key` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the method to get.
       * @returns {*} Returns the function if it's native, else `undefined`.
       */
      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }

      /**
       * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the raw `toStringTag`.
       */
      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];

        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {}

        var result = nativeObjectToString.call(value);
        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }
        return result;
      }

      /**
       * Creates an array of the own enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
        if (object == null) {
          return [];
        }
        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function(symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };

      /**
       * Creates an array of the own and inherited enumerable symbols of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of symbols.
       */
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
        var result = [];
        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }
        return result;
      };

      /**
       * Gets the `toStringTag` of `value`.
       *
       * @private
       * @param {*} value The value to query.
       * @returns {string} Returns the `toStringTag`.
       */
      var getTag = baseGetTag;

      // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
      if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
          (Map && getTag(new Map) != mapTag) ||
          (Promise && getTag(Promise.resolve()) != promiseTag) ||
          (Set && getTag(new Set) != setTag) ||
          (WeakMap && getTag(new WeakMap) != weakMapTag)) {
        getTag = function(value) {
          var result = baseGetTag(value),
              Ctor = result == objectTag ? value.constructor : undefined$1,
              ctorString = Ctor ? toSource(Ctor) : '';

          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString: return dataViewTag;
              case mapCtorString: return mapTag;
              case promiseCtorString: return promiseTag;
              case setCtorString: return setTag;
              case weakMapCtorString: return weakMapTag;
            }
          }
          return result;
        };
      }

      /**
       * Gets the view, applying any `transforms` to the `start` and `end` positions.
       *
       * @private
       * @param {number} start The start of the view.
       * @param {number} end The end of the view.
       * @param {Array} transforms The transformations to apply to the view.
       * @returns {Object} Returns an object containing the `start` and `end`
       *  positions of the view.
       */
      function getView(start, end, transforms) {
        var index = -1,
            length = transforms.length;

        while (++index < length) {
          var data = transforms[index],
              size = data.size;

          switch (data.type) {
            case 'drop':      start += size; break;
            case 'dropRight': end -= size; break;
            case 'take':      end = nativeMin(end, start + size); break;
            case 'takeRight': start = nativeMax(start, end - size); break;
          }
        }
        return { 'start': start, 'end': end };
      }

      /**
       * Extracts wrapper details from the `source` body comment.
       *
       * @private
       * @param {string} source The source to inspect.
       * @returns {Array} Returns the wrapper details.
       */
      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }

      /**
       * Checks if `path` exists on `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @param {Function} hasFunc The function to check properties.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       */
      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);

        var index = -1,
            length = path.length,
            result = false;

        while (++index < length) {
          var key = toKey(path[index]);
          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }
          object = object[key];
        }
        if (result || ++index != length) {
          return result;
        }
        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) &&
          (isArray(object) || isArguments(object));
      }

      /**
       * Initializes an array clone.
       *
       * @private
       * @param {Array} array The array to clone.
       * @returns {Array} Returns the initialized clone.
       */
      function initCloneArray(array) {
        var length = array.length,
            result = new array.constructor(length);

        // Add properties assigned by `RegExp#exec`.
        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }
        return result;
      }

      /**
       * Initializes an object clone.
       *
       * @private
       * @param {Object} object The object to clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneObject(object) {
        return (typeof object.constructor == 'function' && !isPrototype(object))
          ? baseCreate(getPrototype(object))
          : {};
      }

      /**
       * Initializes an object clone based on its `toStringTag`.
       *
       * **Note:** This function only supports cloning values with tags of
       * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
       *
       * @private
       * @param {Object} object The object to clone.
       * @param {string} tag The `toStringTag` of the object to clone.
       * @param {boolean} [isDeep] Specify a deep clone.
       * @returns {Object} Returns the initialized clone.
       */
      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;
        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);

          case boolTag:
          case dateTag:
            return new Ctor(+object);

          case dataViewTag:
            return cloneDataView(object, isDeep);

          case float32Tag: case float64Tag:
          case int8Tag: case int16Tag: case int32Tag:
          case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
            return cloneTypedArray(object, isDeep);

          case mapTag:
            return new Ctor;

          case numberTag:
          case stringTag:
            return new Ctor(object);

          case regexpTag:
            return cloneRegExp(object);

          case setTag:
            return new Ctor;

          case symbolTag:
            return cloneSymbol(object);
        }
      }

      /**
       * Inserts wrapper `details` in a comment at the top of the `source` body.
       *
       * @private
       * @param {string} source The source to modify.
       * @returns {Array} details The details to insert.
       * @returns {string} Returns the modified source.
       */
      function insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) {
          return source;
        }
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
      }

      /**
       * Checks if `value` is a flattenable `arguments` object or array.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
       */
      function isFlattenable(value) {
        return isArray(value) || isArguments(value) ||
          !!(spreadableSymbol && value && value[spreadableSymbol]);
      }

      /**
       * Checks if `value` is a valid array-like index.
       *
       * @private
       * @param {*} value The value to check.
       * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
       * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
       */
      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;

        return !!length &&
          (type == 'number' ||
            (type != 'symbol' && reIsUint.test(value))) &&
              (value > -1 && value % 1 == 0 && value < length);
      }

      /**
       * Checks if the given arguments are from an iteratee call.
       *
       * @private
       * @param {*} value The potential iteratee value argument.
       * @param {*} index The potential iteratee index or key argument.
       * @param {*} object The potential iteratee object argument.
       * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
       *  else `false`.
       */
      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }
        var type = typeof index;
        if (type == 'number'
              ? (isArrayLike(object) && isIndex(index, object.length))
              : (type == 'string' && index in object)
            ) {
          return eq(object[index], value);
        }
        return false;
      }

      /**
       * Checks if `value` is a property name and not a property path.
       *
       * @private
       * @param {*} value The value to check.
       * @param {Object} [object] The object to query keys on.
       * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
       */
      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }
        var type = typeof value;
        if (type == 'number' || type == 'symbol' || type == 'boolean' ||
            value == null || isSymbol(value)) {
          return true;
        }
        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
          (object != null && value in Object(object));
      }

      /**
       * Checks if `value` is suitable for use as unique object key.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
       */
      function isKeyable(value) {
        var type = typeof value;
        return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
          ? (value !== '__proto__')
          : (value === null);
      }

      /**
       * Checks if `func` has a lazy counterpart.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
       *  else `false`.
       */
      function isLaziable(func) {
        var funcName = getFuncName(func),
            other = lodash[funcName];

        if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
          return false;
        }
        if (func === other) {
          return true;
        }
        var data = getData(other);
        return !!data && func === data[0];
      }

      /**
       * Checks if `func` has its source masked.
       *
       * @private
       * @param {Function} func The function to check.
       * @returns {boolean} Returns `true` if `func` is masked, else `false`.
       */
      function isMasked(func) {
        return !!maskSrcKey && (maskSrcKey in func);
      }

      /**
       * Checks if `func` is capable of being masked.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
       */
      var isMaskable = coreJsData ? isFunction : stubFalse;

      /**
       * Checks if `value` is likely a prototype object.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
       */
      function isPrototype(value) {
        var Ctor = value && value.constructor,
            proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

        return value === proto;
      }

      /**
       * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` if suitable for strict
       *  equality comparisons, else `false`.
       */
      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }

      /**
       * A specialized version of `matchesProperty` for source values suitable
       * for strict equality comparisons, i.e. `===`.
       *
       * @private
       * @param {string} key The key of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       */
      function matchesStrictComparable(key, srcValue) {
        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === srcValue &&
            (srcValue !== undefined$1 || (key in Object(object)));
        };
      }

      /**
       * A specialized version of `_.memoize` which clears the memoized function's
       * cache when it exceeds `MAX_MEMOIZE_SIZE`.
       *
       * @private
       * @param {Function} func The function to have its output memoized.
       * @returns {Function} Returns the new memoized function.
       */
      function memoizeCapped(func) {
        var result = memoize(func, function(key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }
          return key;
        });

        var cache = result.cache;
        return result;
      }

      /**
       * Merges the function metadata of `source` into `data`.
       *
       * Merging metadata reduces the number of wrappers used to invoke a function.
       * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
       * may be applied regardless of execution order. Methods like `_.ary` and
       * `_.rearg` modify function arguments, making the order in which they are
       * executed important, preventing the merging of metadata. However, we make
       * an exception for a safe combined case where curried functions have `_.ary`
       * and or `_.rearg` applied.
       *
       * @private
       * @param {Array} data The destination metadata.
       * @param {Array} source The source metadata.
       * @returns {Array} Returns `data`.
       */
      function mergeData(data, source) {
        var bitmask = data[1],
            srcBitmask = source[1],
            newBitmask = bitmask | srcBitmask,
            isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

        var isCombo =
          ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
          ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
          ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

        // Exit early if metadata can't be merged.
        if (!(isCommon || isCombo)) {
          return data;
        }
        // Use source `thisArg` if available.
        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          // Set when currying a bound function.
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }
        // Compose partial arguments.
        var value = source[3];
        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }
        // Compose partial right arguments.
        value = source[5];
        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }
        // Use source `argPos` if available.
        value = source[7];
        if (value) {
          data[7] = value;
        }
        // Use source `ary` if it's smaller.
        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }
        // Use source `arity` if one is not provided.
        if (data[9] == null) {
          data[9] = source[9];
        }
        // Use source `func` and merge bitmasks.
        data[0] = source[0];
        data[1] = newBitmask;

        return data;
      }

      /**
       * This function is like
       * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * except that it includes inherited enumerable properties.
       *
       * @private
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       */
      function nativeKeysIn(object) {
        var result = [];
        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }
        return result;
      }

      /**
       * Converts `value` to a string using `Object.prototype.toString`.
       *
       * @private
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       */
      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      /**
       * A specialized version of `baseRest` which transforms the rest array.
       *
       * @private
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @param {Function} transform The rest array transform.
       * @returns {Function} Returns the new function.
       */
      function overRest(func, start, transform) {
        start = nativeMax(start === undefined$1 ? (func.length - 1) : start, 0);
        return function() {
          var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);

          while (++index < length) {
            array[index] = args[start + index];
          }
          index = -1;
          var otherArgs = Array(start + 1);
          while (++index < start) {
            otherArgs[index] = args[index];
          }
          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }

      /**
       * Gets the parent value at `path` of `object`.
       *
       * @private
       * @param {Object} object The object to query.
       * @param {Array} path The path to get the parent value of.
       * @returns {*} Returns the parent value.
       */
      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }

      /**
       * Reorder `array` according to the specified indexes where the element at
       * the first index is assigned as the first element, the element at
       * the second index is assigned as the second element, and so on.
       *
       * @private
       * @param {Array} array The array to reorder.
       * @param {Array} indexes The arranged array indexes.
       * @returns {Array} Returns `array`.
       */
      function reorder(array, indexes) {
        var arrLength = array.length,
            length = nativeMin(indexes.length, arrLength),
            oldArray = copyArray(array);

        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }
        return array;
      }

      /**
       * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
       *
       * @private
       * @param {Object} object The object to query.
       * @param {string} key The key of the property to get.
       * @returns {*} Returns the property value.
       */
      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }

        if (key == '__proto__') {
          return;
        }

        return object[key];
      }

      /**
       * Sets metadata for `func`.
       *
       * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
       * period of time, it will trip its breaker and transition to an identity
       * function to avoid garbage collection pauses in V8. See
       * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
       * for more details.
       *
       * @private
       * @param {Function} func The function to associate metadata with.
       * @param {*} data The metadata.
       * @returns {Function} Returns `func`.
       */
      var setData = shortOut(baseSetData);

      /**
       * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
       *
       * @private
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @returns {number|Object} Returns the timer id or timeout object.
       */
      var setTimeout = ctxSetTimeout || function(func, wait) {
        return root.setTimeout(func, wait);
      };

      /**
       * Sets the `toString` method of `func` to return `string`.
       *
       * @private
       * @param {Function} func The function to modify.
       * @param {Function} string The `toString` result.
       * @returns {Function} Returns `func`.
       */
      var setToString = shortOut(baseSetToString);

      /**
       * Sets the `toString` method of `wrapper` to mimic the source of `reference`
       * with wrapper details in a comment at the top of the source body.
       *
       * @private
       * @param {Function} wrapper The function to modify.
       * @param {Function} reference The reference function.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @returns {Function} Returns `wrapper`.
       */
      function setWrapToString(wrapper, reference, bitmask) {
        var source = (reference + '');
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }

      /**
       * Creates a function that'll short out and invoke `identity` instead
       * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
       * milliseconds.
       *
       * @private
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new shortable function.
       */
      function shortOut(func) {
        var count = 0,
            lastCalled = 0;

        return function() {
          var stamp = nativeNow(),
              remaining = HOT_SPAN - (stamp - lastCalled);

          lastCalled = stamp;
          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }
          return func.apply(undefined$1, arguments);
        };
      }

      /**
       * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
       *
       * @private
       * @param {Array} array The array to shuffle.
       * @param {number} [size=array.length] The size of `array`.
       * @returns {Array} Returns `array`.
       */
      function shuffleSelf(array, size) {
        var index = -1,
            length = array.length,
            lastIndex = length - 1;

        size = size === undefined$1 ? length : size;
        while (++index < size) {
          var rand = baseRandom(index, lastIndex),
              value = array[rand];

          array[rand] = array[index];
          array[index] = value;
        }
        array.length = size;
        return array;
      }

      /**
       * Converts `string` to a property path array.
       *
       * @private
       * @param {string} string The string to convert.
       * @returns {Array} Returns the property path array.
       */
      var stringToPath = memoizeCapped(function(string) {
        var result = [];
        if (string.charCodeAt(0) === 46 /* . */) {
          result.push('');
        }
        string.replace(rePropName, function(match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
        });
        return result;
      });

      /**
       * Converts `value` to a string key if it's not a string or symbol.
       *
       * @private
       * @param {*} value The value to inspect.
       * @returns {string|symbol} Returns the key.
       */
      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }
        var result = (value + '');
        return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
      }

      /**
       * Converts `func` to its source code.
       *
       * @private
       * @param {Function} func The function to convert.
       * @returns {string} Returns the source code.
       */
      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}
          try {
            return (func + '');
          } catch (e) {}
        }
        return '';
      }

      /**
       * Updates wrapper `details` based on `bitmask` flags.
       *
       * @private
       * @returns {Array} details The details to modify.
       * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
       * @returns {Array} Returns `details`.
       */
      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function(pair) {
          var value = '_.' + pair[0];
          if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }

      /**
       * Creates a clone of `wrapper`.
       *
       * @private
       * @param {Object} wrapper The wrapper to clone.
       * @returns {Object} Returns the cloned wrapper.
       */
      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }
        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__  = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }

      /*------------------------------------------------------------------------*/

      /**
       * Creates an array of elements split into groups the length of `size`.
       * If `array` can't be split evenly, the final chunk will be the remaining
       * elements.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to process.
       * @param {number} [size=1] The length of each chunk
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the new array of chunks.
       * @example
       *
       * _.chunk(['a', 'b', 'c', 'd'], 2);
       * // => [['a', 'b'], ['c', 'd']]
       *
       * _.chunk(['a', 'b', 'c', 'd'], 3);
       * // => [['a', 'b', 'c'], ['d']]
       */
      function chunk(array, size, guard) {
        if ((guard ? isIterateeCall(array, size, guard) : size === undefined$1)) {
          size = 1;
        } else {
          size = nativeMax(toInteger(size), 0);
        }
        var length = array == null ? 0 : array.length;
        if (!length || size < 1) {
          return [];
        }
        var index = 0,
            resIndex = 0,
            result = Array(nativeCeil(length / size));

        while (index < length) {
          result[resIndex++] = baseSlice(array, index, (index += size));
        }
        return result;
      }

      /**
       * Creates an array with all falsey values removed. The values `false`, `null`,
       * `0`, `""`, `undefined`, and `NaN` are falsey.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to compact.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.compact([0, 1, false, 2, '', 3]);
       * // => [1, 2, 3]
       */
      function compact(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];
          if (value) {
            result[resIndex++] = value;
          }
        }
        return result;
      }

      /**
       * Creates a new array concatenating `array` with any additional arrays
       * and/or values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to concatenate.
       * @param {...*} [values] The values to concatenate.
       * @returns {Array} Returns the new concatenated array.
       * @example
       *
       * var array = [1];
       * var other = _.concat(array, 2, [3], [[4]]);
       *
       * console.log(other);
       * // => [1, 2, 3, [4]]
       *
       * console.log(array);
       * // => [1]
       */
      function concat() {
        var length = arguments.length;
        if (!length) {
          return [];
        }
        var args = Array(length - 1),
            array = arguments[0],
            index = length;

        while (index--) {
          args[index - 1] = arguments[index];
        }
        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }

      /**
       * Creates an array of `array` values not included in the other given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * **Note:** Unlike `_.pullAll`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.without, _.xor
       * @example
       *
       * _.difference([2, 1], [2, 3]);
       * // => [1]
       */
      var difference = baseRest(function(array, values) {
        return isArrayLikeObject(array)
          ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
          : [];
      });

      /**
       * This method is like `_.difference` except that it accepts `iteratee` which
       * is invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */
      var differenceBy = baseRest(function(array, values) {
        var iteratee = last(values);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return isArrayLikeObject(array)
          ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
          : [];
      });

      /**
       * This method is like `_.difference` except that it accepts `comparator`
       * which is invoked to compare elements of `array` to `values`. The order and
       * references of result values are determined by the first array. The comparator
       * is invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...Array} [values] The values to exclude.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       *
       * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }]
       */
      var differenceWith = baseRest(function(array, values) {
        var comparator = last(values);
        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }
        return isArrayLikeObject(array)
          ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator)
          : [];
      });

      /**
       * Creates a slice of `array` with `n` elements dropped from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.drop([1, 2, 3]);
       * // => [2, 3]
       *
       * _.drop([1, 2, 3], 2);
       * // => [3]
       *
       * _.drop([1, 2, 3], 5);
       * // => []
       *
       * _.drop([1, 2, 3], 0);
       * // => [1, 2, 3]
       */
      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = (guard || n === undefined$1) ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      /**
       * Creates a slice of `array` with `n` elements dropped from the end.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to drop.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.dropRight([1, 2, 3]);
       * // => [1, 2]
       *
       * _.dropRight([1, 2, 3], 2);
       * // => [1]
       *
       * _.dropRight([1, 2, 3], 5);
       * // => []
       *
       * _.dropRight([1, 2, 3], 0);
       * // => [1, 2, 3]
       */
      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = (guard || n === undefined$1) ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      /**
       * Creates a slice of `array` excluding elements dropped from the end.
       * Elements are dropped until `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.dropRightWhile(users, function(o) { return !o.active; });
       * // => objects for ['barney']
       *
       * // The `_.matches` iteratee shorthand.
       * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
       * // => objects for ['barney', 'fred']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.dropRightWhile(users, ['active', false]);
       * // => objects for ['barney']
       *
       * // The `_.property` iteratee shorthand.
       * _.dropRightWhile(users, 'active');
       * // => objects for ['barney', 'fred', 'pebbles']
       */
      function dropRightWhile(array, predicate) {
        return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3), true, true)
          : [];
      }

      /**
       * Creates a slice of `array` excluding elements dropped from the beginning.
       * Elements are dropped until `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.dropWhile(users, function(o) { return !o.active; });
       * // => objects for ['pebbles']
       *
       * // The `_.matches` iteratee shorthand.
       * _.dropWhile(users, { 'user': 'barney', 'active': false });
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.dropWhile(users, ['active', false]);
       * // => objects for ['pebbles']
       *
       * // The `_.property` iteratee shorthand.
       * _.dropWhile(users, 'active');
       * // => objects for ['barney', 'fred', 'pebbles']
       */
      function dropWhile(array, predicate) {
        return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3), true)
          : [];
      }

      /**
       * Fills elements of `array` with `value` from `start` up to, but not
       * including, `end`.
       *
       * **Note:** This method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Array
       * @param {Array} array The array to fill.
       * @param {*} value The value to fill `array` with.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _.fill(array, 'a');
       * console.log(array);
       * // => ['a', 'a', 'a']
       *
       * _.fill(Array(3), 2);
       * // => [2, 2, 2]
       *
       * _.fill([4, 6, 8, 10], '*', 1, 3);
       * // => [4, '*', '*', 10]
       */
      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }
        return baseFill(array, value, start, end);
      }

      /**
       * This method is like `_.find` except that it returns the index of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {number} Returns the index of the found element, else `-1`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.findIndex(users, function(o) { return o.user == 'barney'; });
       * // => 0
       *
       * // The `_.matches` iteratee shorthand.
       * _.findIndex(users, { 'user': 'fred', 'active': false });
       * // => 1
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findIndex(users, ['active', false]);
       * // => 0
       *
       * // The `_.property` iteratee shorthand.
       * _.findIndex(users, 'active');
       * // => 2
       */
      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }

      /**
       * This method is like `_.findIndex` except that it iterates over elements
       * of `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=array.length-1] The index to search from.
       * @returns {number} Returns the index of the found element, else `-1`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
       * // => 2
       *
       * // The `_.matches` iteratee shorthand.
       * _.findLastIndex(users, { 'user': 'barney', 'active': true });
       * // => 0
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findLastIndex(users, ['active', false]);
       * // => 2
       *
       * // The `_.property` iteratee shorthand.
       * _.findLastIndex(users, 'active');
       * // => 0
       */
      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length - 1;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0
            ? nativeMax(length + index, 0)
            : nativeMin(index, length - 1);
        }
        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }

      /**
       * Flattens `array` a single level deep.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flatten([1, [2, [3, [4]], 5]]);
       * // => [1, 2, [3, [4]], 5]
       */
      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }

      /**
       * Recursively flattens `array`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * _.flattenDeep([1, [2, [3, [4]], 5]]);
       * // => [1, 2, 3, 4, 5]
       */
      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }

      /**
       * Recursively flatten `array` up to `depth` times.
       *
       * @static
       * @memberOf _
       * @since 4.4.0
       * @category Array
       * @param {Array} array The array to flatten.
       * @param {number} [depth=1] The maximum recursion depth.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * var array = [1, [2, [3, [4]], 5]];
       *
       * _.flattenDepth(array, 1);
       * // => [1, 2, [3, [4]], 5]
       *
       * _.flattenDepth(array, 2);
       * // => [1, 2, 3, [4], 5]
       */
      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }

      /**
       * The inverse of `_.toPairs`; this method returns an object composed
       * from key-value `pairs`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} pairs The key-value pairs.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.fromPairs([['a', 1], ['b', 2]]);
       * // => { 'a': 1, 'b': 2 }
       */
      function fromPairs(pairs) {
        var index = -1,
            length = pairs == null ? 0 : pairs.length,
            result = {};

        while (++index < length) {
          var pair = pairs[index];
          result[pair[0]] = pair[1];
        }
        return result;
      }

      /**
       * Gets the first element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @alias first
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the first element of `array`.
       * @example
       *
       * _.head([1, 2, 3]);
       * // => 1
       *
       * _.head([]);
       * // => undefined
       */
      function head(array) {
        return (array && array.length) ? array[0] : undefined$1;
      }

      /**
       * Gets the index at which the first occurrence of `value` is found in `array`
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. If `fromIndex` is negative, it's used as the
       * offset from the end of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.indexOf([1, 2, 1, 2], 2);
       * // => 1
       *
       * // Search from the `fromIndex`.
       * _.indexOf([1, 2, 1, 2], 2, 2);
       * // => 3
       */
      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = fromIndex == null ? 0 : toInteger(fromIndex);
        if (index < 0) {
          index = nativeMax(length + index, 0);
        }
        return baseIndexOf(array, value, index);
      }

      /**
       * Gets all but the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.initial([1, 2, 3]);
       * // => [1, 2]
       */
      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }

      /**
       * Creates an array of unique values that are included in all given arrays
       * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons. The order and references of result values are
       * determined by the first array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersection([2, 1], [2, 3]);
       * // => [2]
       */
      var intersection = baseRest(function(arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return (mapped.length && mapped[0] === arrays[0])
          ? baseIntersection(mapped)
          : [];
      });

      /**
       * This method is like `_.intersection` except that it accepts `iteratee`
       * which is invoked for each element of each `arrays` to generate the criterion
       * by which they're compared. The order and references of result values are
       * determined by the first array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [2.1]
       *
       * // The `_.property` iteratee shorthand.
       * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }]
       */
      var intersectionBy = baseRest(function(arrays) {
        var iteratee = last(arrays),
            mapped = arrayMap(arrays, castArrayLikeObject);

        if (iteratee === last(mapped)) {
          iteratee = undefined$1;
        } else {
          mapped.pop();
        }
        return (mapped.length && mapped[0] === arrays[0])
          ? baseIntersection(mapped, getIteratee(iteratee, 2))
          : [];
      });

      /**
       * This method is like `_.intersection` except that it accepts `comparator`
       * which is invoked to compare elements of `arrays`. The order and references
       * of result values are determined by the first array. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of intersecting values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.intersectionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }]
       */
      var intersectionWith = baseRest(function(arrays) {
        var comparator = last(arrays),
            mapped = arrayMap(arrays, castArrayLikeObject);

        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        if (comparator) {
          mapped.pop();
        }
        return (mapped.length && mapped[0] === arrays[0])
          ? baseIntersection(mapped, undefined$1, comparator)
          : [];
      });

      /**
       * Converts all elements in `array` into a string separated by `separator`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to convert.
       * @param {string} [separator=','] The element separator.
       * @returns {string} Returns the joined string.
       * @example
       *
       * _.join(['a', 'b', 'c'], '~');
       * // => 'a~b~c'
       */
      function join(array, separator) {
        return array == null ? '' : nativeJoin.call(array, separator);
      }

      /**
       * Gets the last element of `array`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {*} Returns the last element of `array`.
       * @example
       *
       * _.last([1, 2, 3]);
       * // => 3
       */
      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }

      /**
       * This method is like `_.indexOf` except that it iterates over elements of
       * `array` from right to left.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=array.length-1] The index to search from.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.lastIndexOf([1, 2, 1, 2], 2);
       * // => 3
       *
       * // Search from the `fromIndex`.
       * _.lastIndexOf([1, 2, 1, 2], 2, 2);
       * // => 1
       */
      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return -1;
        }
        var index = length;
        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }
        return value === value
          ? strictLastIndexOf(array, value, index)
          : baseFindIndex(array, baseIsNaN, index, true);
      }

      /**
       * Gets the element at index `n` of `array`. If `n` is negative, the nth
       * element from the end is returned.
       *
       * @static
       * @memberOf _
       * @since 4.11.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=0] The index of the element to return.
       * @returns {*} Returns the nth element of `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'd'];
       *
       * _.nth(array, 1);
       * // => 'b'
       *
       * _.nth(array, -2);
       * // => 'c';
       */
      function nth(array, n) {
        return (array && array.length) ? baseNth(array, toInteger(n)) : undefined$1;
      }

      /**
       * Removes all given values from `array` using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
       * to remove elements from an array by predicate.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {...*} [values] The values to remove.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
       *
       * _.pull(array, 'a', 'c');
       * console.log(array);
       * // => ['b', 'b']
       */
      var pull = baseRest(pullAll);

      /**
       * This method is like `_.pull` except that it accepts an array of values to remove.
       *
       * **Note:** Unlike `_.difference`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
       *
       * _.pullAll(array, ['a', 'c']);
       * console.log(array);
       * // => ['b', 'b']
       */
      function pullAll(array, values) {
        return (array && array.length && values && values.length)
          ? basePullAll(array, values)
          : array;
      }

      /**
       * This method is like `_.pullAll` except that it accepts `iteratee` which is
       * invoked for each element of `array` and `values` to generate the criterion
       * by which they're compared. The iteratee is invoked with one argument: (value).
       *
       * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
       *
       * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
       * console.log(array);
       * // => [{ 'x': 2 }]
       */
      function pullAllBy(array, values, iteratee) {
        return (array && array.length && values && values.length)
          ? basePullAll(array, values, getIteratee(iteratee, 2))
          : array;
      }

      /**
       * This method is like `_.pullAll` except that it accepts `comparator` which
       * is invoked to compare elements of `array` to `values`. The comparator is
       * invoked with two arguments: (arrVal, othVal).
       *
       * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Array} values The values to remove.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
       *
       * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
       * console.log(array);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
       */
      function pullAllWith(array, values, comparator) {
        return (array && array.length && values && values.length)
          ? basePullAll(array, values, undefined$1, comparator)
          : array;
      }

      /**
       * Removes elements from `array` corresponding to `indexes` and returns an
       * array of removed elements.
       *
       * **Note:** Unlike `_.at`, this method mutates `array`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {...(number|number[])} [indexes] The indexes of elements to remove.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = ['a', 'b', 'c', 'd'];
       * var pulled = _.pullAt(array, [1, 3]);
       *
       * console.log(array);
       * // => ['a', 'c']
       *
       * console.log(pulled);
       * // => ['b', 'd']
       */
      var pullAt = flatRest(function(array, indexes) {
        var length = array == null ? 0 : array.length,
            result = baseAt(array, indexes);

        basePullAt(array, arrayMap(indexes, function(index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));

        return result;
      });

      /**
       * Removes all elements from `array` that `predicate` returns truthy for
       * and returns an array of the removed elements. The predicate is invoked
       * with three arguments: (value, index, array).
       *
       * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
       * to pull elements from an array by value.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new array of removed elements.
       * @example
       *
       * var array = [1, 2, 3, 4];
       * var evens = _.remove(array, function(n) {
       *   return n % 2 == 0;
       * });
       *
       * console.log(array);
       * // => [1, 3]
       *
       * console.log(evens);
       * // => [2, 4]
       */
      function remove(array, predicate) {
        var result = [];
        if (!(array && array.length)) {
          return result;
        }
        var index = -1,
            indexes = [],
            length = array.length;

        predicate = getIteratee(predicate, 3);
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
          }
        }
        basePullAt(array, indexes);
        return result;
      }

      /**
       * Reverses `array` so that the first element becomes the last, the second
       * element becomes the second to last, and so on.
       *
       * **Note:** This method mutates `array` and is based on
       * [`Array#reverse`](https://mdn.io/Array/reverse).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to modify.
       * @returns {Array} Returns `array`.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _.reverse(array);
       * // => [3, 2, 1]
       *
       * console.log(array);
       * // => [3, 2, 1]
       */
      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }

      /**
       * Creates a slice of `array` from `start` up to, but not including, `end`.
       *
       * **Note:** This method is used instead of
       * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
       * returned.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to slice.
       * @param {number} [start=0] The start position.
       * @param {number} [end=array.length] The end position.
       * @returns {Array} Returns the slice of `array`.
       */
      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        }
        else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }
        return baseSlice(array, start, end);
      }

      /**
       * Uses a binary search to determine the lowest index at which `value`
       * should be inserted into `array` in order to maintain its sort order.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * _.sortedIndex([30, 50], 40);
       * // => 1
       */
      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }

      /**
       * This method is like `_.sortedIndex` except that it accepts `iteratee`
       * which is invoked for `value` and each element of `array` to compute their
       * sort ranking. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * var objects = [{ 'x': 4 }, { 'x': 5 }];
       *
       * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
       * // => 0
       *
       * // The `_.property` iteratee shorthand.
       * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
       * // => 0
       */
      function sortedIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
      }

      /**
       * This method is like `_.indexOf` except that it performs a binary
       * search on a sorted `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
       * // => 1
       */
      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value);
          if (index < length && eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * This method is like `_.sortedIndex` except that it returns the highest
       * index at which `value` should be inserted into `array` in order to
       * maintain its sort order.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
       * // => 4
       */
      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }

      /**
       * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
       * which is invoked for `value` and each element of `array` to compute their
       * sort ranking. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The sorted array to inspect.
       * @param {*} value The value to evaluate.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the index at which `value` should be inserted
       *  into `array`.
       * @example
       *
       * var objects = [{ 'x': 4 }, { 'x': 5 }];
       *
       * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
       * // => 1
       *
       * // The `_.property` iteratee shorthand.
       * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
       * // => 1
       */
      function sortedLastIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
      }

      /**
       * This method is like `_.lastIndexOf` except that it performs a binary
       * search on a sorted `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {*} value The value to search for.
       * @returns {number} Returns the index of the matched value, else `-1`.
       * @example
       *
       * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
       * // => 3
       */
      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;
        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;
          if (eq(array[index], value)) {
            return index;
          }
        }
        return -1;
      }

      /**
       * This method is like `_.uniq` except that it's designed and optimized
       * for sorted arrays.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.sortedUniq([1, 1, 2]);
       * // => [1, 2]
       */
      function sortedUniq(array) {
        return (array && array.length)
          ? baseSortedUniq(array)
          : [];
      }

      /**
       * This method is like `_.uniqBy` except that it's designed and optimized
       * for sorted arrays.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
       * // => [1.1, 2.3]
       */
      function sortedUniqBy(array, iteratee) {
        return (array && array.length)
          ? baseSortedUniq(array, getIteratee(iteratee, 2))
          : [];
      }

      /**
       * Gets all but the first element of `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.tail([1, 2, 3]);
       * // => [2, 3]
       */
      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }

      /**
       * Creates a slice of `array` with `n` elements taken from the beginning.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to take.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.take([1, 2, 3]);
       * // => [1]
       *
       * _.take([1, 2, 3], 2);
       * // => [1, 2]
       *
       * _.take([1, 2, 3], 5);
       * // => [1, 2, 3]
       *
       * _.take([1, 2, 3], 0);
       * // => []
       */
      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }
        n = (guard || n === undefined$1) ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      /**
       * Creates a slice of `array` with `n` elements taken from the end.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {number} [n=1] The number of elements to take.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * _.takeRight([1, 2, 3]);
       * // => [3]
       *
       * _.takeRight([1, 2, 3], 2);
       * // => [2, 3]
       *
       * _.takeRight([1, 2, 3], 5);
       * // => [1, 2, 3]
       *
       * _.takeRight([1, 2, 3], 0);
       * // => []
       */
      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;
        if (!length) {
          return [];
        }
        n = (guard || n === undefined$1) ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      /**
       * Creates a slice of `array` with elements taken from the end. Elements are
       * taken until `predicate` returns falsey. The predicate is invoked with
       * three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': true },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': false }
       * ];
       *
       * _.takeRightWhile(users, function(o) { return !o.active; });
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.matches` iteratee shorthand.
       * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
       * // => objects for ['pebbles']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.takeRightWhile(users, ['active', false]);
       * // => objects for ['fred', 'pebbles']
       *
       * // The `_.property` iteratee shorthand.
       * _.takeRightWhile(users, 'active');
       * // => []
       */
      function takeRightWhile(array, predicate) {
        return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3), false, true)
          : [];
      }

      /**
       * Creates a slice of `array` with elements taken from the beginning. Elements
       * are taken until `predicate` returns falsey. The predicate is invoked with
       * three arguments: (value, index, array).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Array
       * @param {Array} array The array to query.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the slice of `array`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'active': false },
       *   { 'user': 'fred',    'active': false },
       *   { 'user': 'pebbles', 'active': true }
       * ];
       *
       * _.takeWhile(users, function(o) { return !o.active; });
       * // => objects for ['barney', 'fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.takeWhile(users, { 'user': 'barney', 'active': false });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.takeWhile(users, ['active', false]);
       * // => objects for ['barney', 'fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.takeWhile(users, 'active');
       * // => []
       */
      function takeWhile(array, predicate) {
        return (array && array.length)
          ? baseWhile(array, getIteratee(predicate, 3))
          : [];
      }

      /**
       * Creates an array of unique values, in order, from all given arrays using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.union([2], [1, 2]);
       * // => [2, 1]
       */
      var union = baseRest(function(arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });

      /**
       * This method is like `_.union` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which uniqueness is computed. Result values are chosen from the first
       * array in which the value occurs. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * _.unionBy([2.1], [1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */
      var unionBy = baseRest(function(arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
      });

      /**
       * This method is like `_.union` except that it accepts `comparator` which
       * is invoked to compare elements of `arrays`. Result values are chosen from
       * the first array in which the value occurs. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of combined values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.unionWith(objects, others, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */
      var unionWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });

      /**
       * Creates a duplicate-free version of an array, using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons, in which only the first occurrence of each element
       * is kept. The order of result values is determined by the order they occur
       * in the array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniq([2, 1, 2]);
       * // => [2, 1]
       */
      function uniq(array) {
        return (array && array.length) ? baseUniq(array) : [];
      }

      /**
       * This method is like `_.uniq` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * uniqueness is computed. The order of result values is determined by the
       * order they occur in the array. The iteratee is invoked with one argument:
       * (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
       * // => [2.1, 1.2]
       *
       * // The `_.property` iteratee shorthand.
       * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 1 }, { 'x': 2 }]
       */
      function uniqBy(array, iteratee) {
        return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
      }

      /**
       * This method is like `_.uniq` except that it accepts `comparator` which
       * is invoked to compare elements of `array`. The order of result values is
       * determined by the order they occur in the array.The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new duplicate free array.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.uniqWith(objects, _.isEqual);
       * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
       */
      function uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return (array && array.length) ? baseUniq(array, undefined$1, comparator) : [];
      }

      /**
       * This method is like `_.zip` except that it accepts an array of grouped
       * elements and creates an array regrouping the elements to their pre-zip
       * configuration.
       *
       * @static
       * @memberOf _
       * @since 1.2.0
       * @category Array
       * @param {Array} array The array of grouped elements to process.
       * @returns {Array} Returns the new array of regrouped elements.
       * @example
       *
       * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       *
       * _.unzip(zipped);
       * // => [['a', 'b'], [1, 2], [true, false]]
       */
      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }
        var length = 0;
        array = arrayFilter(array, function(group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function(index) {
          return arrayMap(array, baseProperty(index));
        });
      }

      /**
       * This method is like `_.unzip` except that it accepts `iteratee` to specify
       * how regrouped values should be combined. The iteratee is invoked with the
       * elements of each group: (...group).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Array
       * @param {Array} array The array of grouped elements to process.
       * @param {Function} [iteratee=_.identity] The function to combine
       *  regrouped values.
       * @returns {Array} Returns the new array of regrouped elements.
       * @example
       *
       * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
       * // => [[1, 10, 100], [2, 20, 200]]
       *
       * _.unzipWith(zipped, _.add);
       * // => [3, 30, 300]
       */
      function unzipWith(array, iteratee) {
        if (!(array && array.length)) {
          return [];
        }
        var result = unzip(array);
        if (iteratee == null) {
          return result;
        }
        return arrayMap(result, function(group) {
          return apply(iteratee, undefined$1, group);
        });
      }

      /**
       * Creates an array excluding all given values using
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * for equality comparisons.
       *
       * **Note:** Unlike `_.pull`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {Array} array The array to inspect.
       * @param {...*} [values] The values to exclude.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.xor
       * @example
       *
       * _.without([2, 1, 2, 3], 1, 2);
       * // => [3]
       */
      var without = baseRest(function(array, values) {
        return isArrayLikeObject(array)
          ? baseDifference(array, values)
          : [];
      });

      /**
       * Creates an array of unique values that is the
       * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
       * of the given arrays. The order of result values is determined by the order
       * they occur in the arrays.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @returns {Array} Returns the new array of filtered values.
       * @see _.difference, _.without
       * @example
       *
       * _.xor([2, 1], [2, 3]);
       * // => [1, 3]
       */
      var xor = baseRest(function(arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });

      /**
       * This method is like `_.xor` except that it accepts `iteratee` which is
       * invoked for each element of each `arrays` to generate the criterion by
       * which by which they're compared. The order of result values is determined
       * by the order they occur in the arrays. The iteratee is invoked with one
       * argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
       * // => [1.2, 3.4]
       *
       * // The `_.property` iteratee shorthand.
       * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
       * // => [{ 'x': 2 }]
       */
      var xorBy = baseRest(function(arrays) {
        var iteratee = last(arrays);
        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }
        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
      });

      /**
       * This method is like `_.xor` except that it accepts `comparator` which is
       * invoked to compare elements of `arrays`. The order of result values is
       * determined by the order they occur in the arrays. The comparator is invoked
       * with two arguments: (arrVal, othVal).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Array
       * @param {...Array} [arrays] The arrays to inspect.
       * @param {Function} [comparator] The comparator invoked per element.
       * @returns {Array} Returns the new array of filtered values.
       * @example
       *
       * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
       * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
       *
       * _.xorWith(objects, others, _.isEqual);
       * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
       */
      var xorWith = baseRest(function(arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });

      /**
       * Creates an array of grouped elements, the first of which contains the
       * first elements of the given arrays, the second of which contains the
       * second elements of the given arrays, and so on.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zip(['a', 'b'], [1, 2], [true, false]);
       * // => [['a', 1, true], ['b', 2, false]]
       */
      var zip = baseRest(unzip);

      /**
       * This method is like `_.fromPairs` except that it accepts two arrays,
       * one of property identifiers and one of corresponding values.
       *
       * @static
       * @memberOf _
       * @since 0.4.0
       * @category Array
       * @param {Array} [props=[]] The property identifiers.
       * @param {Array} [values=[]] The property values.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.zipObject(['a', 'b'], [1, 2]);
       * // => { 'a': 1, 'b': 2 }
       */
      function zipObject(props, values) {
        return baseZipObject(props || [], values || [], assignValue);
      }

      /**
       * This method is like `_.zipObject` except that it supports property paths.
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Array
       * @param {Array} [props=[]] The property identifiers.
       * @param {Array} [values=[]] The property values.
       * @returns {Object} Returns the new object.
       * @example
       *
       * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
       * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
       */
      function zipObjectDeep(props, values) {
        return baseZipObject(props || [], values || [], baseSet);
      }

      /**
       * This method is like `_.zip` except that it accepts `iteratee` to specify
       * how grouped values should be combined. The iteratee is invoked with the
       * elements of each group: (...group).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Array
       * @param {...Array} [arrays] The arrays to process.
       * @param {Function} [iteratee=_.identity] The function to combine
       *  grouped values.
       * @returns {Array} Returns the new array of grouped elements.
       * @example
       *
       * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
       *   return a + b + c;
       * });
       * // => [111, 222]
       */
      var zipWith = baseRest(function(arrays) {
        var length = arrays.length,
            iteratee = length > 1 ? arrays[length - 1] : undefined$1;

        iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
        return unzipWith(arrays, iteratee);
      });

      /*------------------------------------------------------------------------*/

      /**
       * Creates a `lodash` wrapper instance that wraps `value` with explicit method
       * chain sequences enabled. The result of such sequences must be unwrapped
       * with `_#value`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Seq
       * @param {*} value The value to wrap.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36 },
       *   { 'user': 'fred',    'age': 40 },
       *   { 'user': 'pebbles', 'age': 1 }
       * ];
       *
       * var youngest = _
       *   .chain(users)
       *   .sortBy('age')
       *   .map(function(o) {
       *     return o.user + ' is ' + o.age;
       *   })
       *   .head()
       *   .value();
       * // => 'pebbles is 1'
       */
      function chain(value) {
        var result = lodash(value);
        result.__chain__ = true;
        return result;
      }

      /**
       * This method invokes `interceptor` and returns `value`. The interceptor
       * is invoked with one argument; (value). The purpose of this method is to
       * "tap into" a method chain sequence in order to modify intermediate results.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @param {*} value The value to provide to `interceptor`.
       * @param {Function} interceptor The function to invoke.
       * @returns {*} Returns `value`.
       * @example
       *
       * _([1, 2, 3])
       *  .tap(function(array) {
       *    // Mutate input array.
       *    array.pop();
       *  })
       *  .reverse()
       *  .value();
       * // => [2, 1]
       */
      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }

      /**
       * This method is like `_.tap` except that it returns the result of `interceptor`.
       * The purpose of this method is to "pass thru" values replacing intermediate
       * results in a method chain sequence.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Seq
       * @param {*} value The value to provide to `interceptor`.
       * @param {Function} interceptor The function to invoke.
       * @returns {*} Returns the result of `interceptor`.
       * @example
       *
       * _('  abc  ')
       *  .chain()
       *  .trim()
       *  .thru(function(value) {
       *    return [value];
       *  })
       *  .value();
       * // => ['abc']
       */
      function thru(value, interceptor) {
        return interceptor(value);
      }

      /**
       * This method is the wrapper version of `_.at`.
       *
       * @name at
       * @memberOf _
       * @since 1.0.0
       * @category Seq
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _(object).at(['a[0].b.c', 'a[1]']).value();
       * // => [3, 4]
       */
      var wrapperAt = flatRest(function(paths) {
        var length = paths.length,
            start = length ? paths[0] : 0,
            value = this.__wrapped__,
            interceptor = function(object) { return baseAt(object, paths); };

        if (length > 1 || this.__actions__.length ||
            !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }
        value = value.slice(start, +start + (length ? 1 : 0));
        value.__actions__.push({
          'func': thru,
          'args': [interceptor],
          'thisArg': undefined$1
        });
        return new LodashWrapper(value, this.__chain__).thru(function(array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }
          return array;
        });
      });

      /**
       * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
       *
       * @name chain
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 40 }
       * ];
       *
       * // A sequence without explicit chaining.
       * _(users).head();
       * // => { 'user': 'barney', 'age': 36 }
       *
       * // A sequence with explicit chaining.
       * _(users)
       *   .chain()
       *   .head()
       *   .pick('user')
       *   .value();
       * // => { 'user': 'barney' }
       */
      function wrapperChain() {
        return chain(this);
      }

      /**
       * Executes the chain sequence and returns the wrapped result.
       *
       * @name commit
       * @memberOf _
       * @since 3.2.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var array = [1, 2];
       * var wrapped = _(array).push(3);
       *
       * console.log(array);
       * // => [1, 2]
       *
       * wrapped = wrapped.commit();
       * console.log(array);
       * // => [1, 2, 3]
       *
       * wrapped.last();
       * // => 3
       *
       * console.log(array);
       * // => [1, 2, 3]
       */
      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }

      /**
       * Gets the next value on a wrapped object following the
       * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
       *
       * @name next
       * @memberOf _
       * @since 4.0.0
       * @category Seq
       * @returns {Object} Returns the next iterator value.
       * @example
       *
       * var wrapped = _([1, 2]);
       *
       * wrapped.next();
       * // => { 'done': false, 'value': 1 }
       *
       * wrapped.next();
       * // => { 'done': false, 'value': 2 }
       *
       * wrapped.next();
       * // => { 'done': true, 'value': undefined }
       */
      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }
        var done = this.__index__ >= this.__values__.length,
            value = done ? undefined$1 : this.__values__[this.__index__++];

        return { 'done': done, 'value': value };
      }

      /**
       * Enables the wrapper to be iterable.
       *
       * @name Symbol.iterator
       * @memberOf _
       * @since 4.0.0
       * @category Seq
       * @returns {Object} Returns the wrapper object.
       * @example
       *
       * var wrapped = _([1, 2]);
       *
       * wrapped[Symbol.iterator]() === wrapped;
       * // => true
       *
       * Array.from(wrapped);
       * // => [1, 2]
       */
      function wrapperToIterator() {
        return this;
      }

      /**
       * Creates a clone of the chain sequence planting `value` as the wrapped value.
       *
       * @name plant
       * @memberOf _
       * @since 3.2.0
       * @category Seq
       * @param {*} value The value to plant.
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var wrapped = _([1, 2]).map(square);
       * var other = wrapped.plant([3, 4]);
       *
       * other.value();
       * // => [9, 16]
       *
       * wrapped.value();
       * // => [1, 4]
       */
      function wrapperPlant(value) {
        var result,
            parent = this;

        while (parent instanceof baseLodash) {
          var clone = wrapperClone(parent);
          clone.__index__ = 0;
          clone.__values__ = undefined$1;
          if (result) {
            previous.__wrapped__ = clone;
          } else {
            result = clone;
          }
          var previous = clone;
          parent = parent.__wrapped__;
        }
        previous.__wrapped__ = value;
        return result;
      }

      /**
       * This method is the wrapper version of `_.reverse`.
       *
       * **Note:** This method mutates the wrapped array.
       *
       * @name reverse
       * @memberOf _
       * @since 0.1.0
       * @category Seq
       * @returns {Object} Returns the new `lodash` wrapper instance.
       * @example
       *
       * var array = [1, 2, 3];
       *
       * _(array).reverse().value()
       * // => [3, 2, 1]
       *
       * console.log(array);
       * // => [3, 2, 1]
       */
      function wrapperReverse() {
        var value = this.__wrapped__;
        if (value instanceof LazyWrapper) {
          var wrapped = value;
          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }
          wrapped = wrapped.reverse();
          wrapped.__actions__.push({
            'func': thru,
            'args': [reverse],
            'thisArg': undefined$1
          });
          return new LodashWrapper(wrapped, this.__chain__);
        }
        return this.thru(reverse);
      }

      /**
       * Executes the chain sequence to resolve the unwrapped value.
       *
       * @name value
       * @memberOf _
       * @since 0.1.0
       * @alias toJSON, valueOf
       * @category Seq
       * @returns {*} Returns the resolved unwrapped value.
       * @example
       *
       * _([1, 2, 3]).value();
       * // => [1, 2, 3]
       */
      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the number of times the key was returned by `iteratee`. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * _.countBy([6.1, 4.2, 6.3], Math.floor);
       * // => { '4': 1, '6': 2 }
       *
       * // The `_.property` iteratee shorthand.
       * _.countBy(['one', 'two', 'three'], 'length');
       * // => { '3': 2, '5': 1 }
       */
      var countBy = createAggregator(function(result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          ++result[key];
        } else {
          baseAssignValue(result, key, 1);
        }
      });

      /**
       * Checks if `predicate` returns truthy for **all** elements of `collection`.
       * Iteration is stopped once `predicate` returns falsey. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * **Note:** This method returns `true` for
       * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
       * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
       * elements of empty collections.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if all elements pass the predicate check,
       *  else `false`.
       * @example
       *
       * _.every([true, 1, null, 'yes'], Boolean);
       * // => false
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.every(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.every(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.every(users, 'active');
       * // => false
       */
      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Iterates over elements of `collection`, returning an array of all elements
       * `predicate` returns truthy for. The predicate is invoked with three
       * arguments: (value, index|key, collection).
       *
       * **Note:** Unlike `_.remove`, this method returns a new array.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       * @see _.reject
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': true },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * _.filter(users, function(o) { return !o.active; });
       * // => objects for ['fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.filter(users, { 'age': 36, 'active': true });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.filter(users, ['active', false]);
       * // => objects for ['fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.filter(users, 'active');
       * // => objects for ['barney']
       *
       * // Combining several predicates using `_.overEvery` or `_.overSome`.
       * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
       * // => objects for ['fred', 'barney']
       */
      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Iterates over elements of `collection`, returning the first element
       * `predicate` returns truthy for. The predicate is invoked with three
       * arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=0] The index to search from.
       * @returns {*} Returns the matched element, else `undefined`.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36, 'active': true },
       *   { 'user': 'fred',    'age': 40, 'active': false },
       *   { 'user': 'pebbles', 'age': 1,  'active': true }
       * ];
       *
       * _.find(users, function(o) { return o.age < 40; });
       * // => object for 'barney'
       *
       * // The `_.matches` iteratee shorthand.
       * _.find(users, { 'age': 1, 'active': true });
       * // => object for 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.find(users, ['active', false]);
       * // => object for 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.find(users, 'active');
       * // => object for 'barney'
       */
      var find = createFind(findIndex);

      /**
       * This method is like `_.find` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param {number} [fromIndex=collection.length-1] The index to search from.
       * @returns {*} Returns the matched element, else `undefined`.
       * @example
       *
       * _.findLast([1, 2, 3, 4], function(n) {
       *   return n % 2 == 1;
       * });
       * // => 3
       */
      var findLast = createFind(findLastIndex);

      /**
       * Creates a flattened array of values by running each element in `collection`
       * thru `iteratee` and flattening the mapped results. The iteratee is invoked
       * with three arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [n, n];
       * }
       *
       * _.flatMap([1, 2], duplicate);
       * // => [1, 1, 2, 2]
       */
      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }

      /**
       * This method is like `_.flatMap` except that it recursively flattens the
       * mapped results.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [[[n, n]]];
       * }
       *
       * _.flatMapDeep([1, 2], duplicate);
       * // => [1, 1, 2, 2]
       */
      function flatMapDeep(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), INFINITY);
      }

      /**
       * This method is like `_.flatMap` except that it recursively flattens the
       * mapped results up to `depth` times.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {number} [depth=1] The maximum recursion depth.
       * @returns {Array} Returns the new flattened array.
       * @example
       *
       * function duplicate(n) {
       *   return [[[n, n]]];
       * }
       *
       * _.flatMapDepth([1, 2], duplicate, 2);
       * // => [[1, 1], [2, 2]]
       */
      function flatMapDepth(collection, iteratee, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee), depth);
      }

      /**
       * Iterates over elements of `collection` and invokes `iteratee` for each element.
       * The iteratee is invoked with three arguments: (value, index|key, collection).
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * **Note:** As with other "Collections" methods, objects with a "length"
       * property are iterated like arrays. To avoid this behavior use `_.forIn`
       * or `_.forOwn` for object iteration.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @alias each
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       * @see _.forEachRight
       * @example
       *
       * _.forEach([1, 2], function(value) {
       *   console.log(value);
       * });
       * // => Logs `1` then `2`.
       *
       * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a' then 'b' (iteration order is not guaranteed).
       */
      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.forEach` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @alias eachRight
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array|Object} Returns `collection`.
       * @see _.forEach
       * @example
       *
       * _.forEachRight([1, 2], function(value) {
       *   console.log(value);
       * });
       * // => Logs `2` then `1`.
       */
      function forEachRight(collection, iteratee) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The order of grouped values
       * is determined by the order they occur in `collection`. The corresponding
       * value of each key is an array of elements responsible for generating the
       * key. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * _.groupBy([6.1, 4.2, 6.3], Math.floor);
       * // => { '4': [4.2], '6': [6.1, 6.3] }
       *
       * // The `_.property` iteratee shorthand.
       * _.groupBy(['one', 'two', 'three'], 'length');
       * // => { '3': ['one', 'two'], '5': ['three'] }
       */
      var groupBy = createAggregator(function(result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });

      /**
       * Checks if `value` is in `collection`. If `collection` is a string, it's
       * checked for a substring of `value`, otherwise
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * is used for equality comparisons. If `fromIndex` is negative, it's used as
       * the offset from the end of `collection`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @param {*} value The value to search for.
       * @param {number} [fromIndex=0] The index to search from.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {boolean} Returns `true` if `value` is found, else `false`.
       * @example
       *
       * _.includes([1, 2, 3], 1);
       * // => true
       *
       * _.includes([1, 2, 3], 1, 2);
       * // => false
       *
       * _.includes({ 'a': 1, 'b': 2 }, 1);
       * // => true
       *
       * _.includes('abcd', 'bc');
       * // => true
       */
      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

        var length = collection.length;
        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }
        return isString(collection)
          ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
          : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
      }

      /**
       * Invokes the method at `path` of each element in `collection`, returning
       * an array of the results of each invoked method. Any additional arguments
       * are provided to each invoked method. If `path` is a function, it's invoked
       * for, and `this` bound to, each element in `collection`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Array|Function|string} path The path of the method to invoke or
       *  the function invoked per iteration.
       * @param {...*} [args] The arguments to invoke each method with.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
       * // => [[1, 5, 7], [1, 2, 3]]
       *
       * _.invokeMap([123, 456], String.prototype.split, '');
       * // => [['1', '2', '3'], ['4', '5', '6']]
       */
      var invokeMap = baseRest(function(collection, path, args) {
        var index = -1,
            isFunc = typeof path == 'function',
            result = isArrayLike(collection) ? Array(collection.length) : [];

        baseEach(collection, function(value) {
          result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result;
      });

      /**
       * Creates an object composed of keys generated from the results of running
       * each element of `collection` thru `iteratee`. The corresponding value of
       * each key is the last element responsible for generating the key. The
       * iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
       * @returns {Object} Returns the composed aggregate object.
       * @example
       *
       * var array = [
       *   { 'dir': 'left', 'code': 97 },
       *   { 'dir': 'right', 'code': 100 }
       * ];
       *
       * _.keyBy(array, function(o) {
       *   return String.fromCharCode(o.code);
       * });
       * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
       *
       * _.keyBy(array, 'dir');
       * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
       */
      var keyBy = createAggregator(function(result, value, key) {
        baseAssignValue(result, key, value);
      });

      /**
       * Creates an array of values by running each element in `collection` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
       *
       * The guarded methods are:
       * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
       * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
       * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
       * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new mapped array.
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * _.map([4, 8], square);
       * // => [16, 64]
       *
       * _.map({ 'a': 4, 'b': 8 }, square);
       * // => [16, 64] (iteration order is not guaranteed)
       *
       * var users = [
       *   { 'user': 'barney' },
       *   { 'user': 'fred' }
       * ];
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, 'user');
       * // => ['barney', 'fred']
       */
      function map(collection, iteratee) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.sortBy` except that it allows specifying the sort
       * orders of the iteratees to sort by. If `orders` is unspecified, all values
       * are sorted in ascending order. Otherwise, specify an order of "desc" for
       * descending or "asc" for ascending sort order of corresponding values.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
       *  The iteratees to sort by.
       * @param {string[]} [orders] The sort orders of `iteratees`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
       * @returns {Array} Returns the new sorted array.
       * @example
       *
       * var users = [
       *   { 'user': 'fred',   'age': 48 },
       *   { 'user': 'barney', 'age': 34 },
       *   { 'user': 'fred',   'age': 40 },
       *   { 'user': 'barney', 'age': 36 }
       * ];
       *
       * // Sort by `user` in ascending order and by `age` in descending order.
       * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
       * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
       */
      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }
        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }
        orders = guard ? undefined$1 : orders;
        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }
        return baseOrderBy(collection, iteratees, orders);
      }

      /**
       * Creates an array of elements split into two groups, the first of which
       * contains elements `predicate` returns truthy for, the second of which
       * contains elements `predicate` returns falsey for. The predicate is
       * invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of grouped elements.
       * @example
       *
       * var users = [
       *   { 'user': 'barney',  'age': 36, 'active': false },
       *   { 'user': 'fred',    'age': 40, 'active': true },
       *   { 'user': 'pebbles', 'age': 1,  'active': false }
       * ];
       *
       * _.partition(users, function(o) { return o.active; });
       * // => objects for [['fred'], ['barney', 'pebbles']]
       *
       * // The `_.matches` iteratee shorthand.
       * _.partition(users, { 'age': 1, 'active': false });
       * // => objects for [['pebbles'], ['barney', 'fred']]
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.partition(users, ['active', false]);
       * // => objects for [['barney', 'pebbles'], ['fred']]
       *
       * // The `_.property` iteratee shorthand.
       * _.partition(users, 'active');
       * // => objects for [['fred'], ['barney', 'pebbles']]
       */
      var partition = createAggregator(function(result, value, key) {
        result[key ? 0 : 1].push(value);
      }, function() { return [[], []]; });

      /**
       * Reduces `collection` to a value which is the accumulated result of running
       * each element in `collection` thru `iteratee`, where each successive
       * invocation is supplied the return value of the previous. If `accumulator`
       * is not given, the first element of `collection` is used as the initial
       * value. The iteratee is invoked with four arguments:
       * (accumulator, value, index|key, collection).
       *
       * Many lodash methods are guarded to work as iteratees for methods like
       * `_.reduce`, `_.reduceRight`, and `_.transform`.
       *
       * The guarded methods are:
       * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
       * and `sortBy`
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduceRight
       * @example
       *
       * _.reduce([1, 2], function(sum, n) {
       *   return sum + n;
       * }, 0);
       * // => 3
       *
       * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       *   return result;
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
       */
      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
            initAccum = arguments.length < 3;

        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }

      /**
       * This method is like `_.reduce` except that it iterates over elements of
       * `collection` from right to left.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The initial value.
       * @returns {*} Returns the accumulated value.
       * @see _.reduce
       * @example
       *
       * var array = [[0, 1], [2, 3], [4, 5]];
       *
       * _.reduceRight(array, function(flattened, other) {
       *   return flattened.concat(other);
       * }, []);
       * // => [4, 5, 2, 3, 0, 1]
       */
      function reduceRight(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce,
            initAccum = arguments.length < 3;

        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
      }

      /**
       * The opposite of `_.filter`; this method returns the elements of `collection`
       * that `predicate` does **not** return truthy for.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the new filtered array.
       * @see _.filter
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': false },
       *   { 'user': 'fred',   'age': 40, 'active': true }
       * ];
       *
       * _.reject(users, function(o) { return !o.active; });
       * // => objects for ['fred']
       *
       * // The `_.matches` iteratee shorthand.
       * _.reject(users, { 'age': 40, 'active': true });
       * // => objects for ['barney']
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.reject(users, ['active', false]);
       * // => objects for ['fred']
       *
       * // The `_.property` iteratee shorthand.
       * _.reject(users, 'active');
       * // => objects for ['barney']
       */
      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }

      /**
       * Gets a random element from `collection`.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to sample.
       * @returns {*} Returns the random element.
       * @example
       *
       * _.sample([1, 2, 3, 4]);
       * // => 2
       */
      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }

      /**
       * Gets `n` random elements at unique keys from `collection` up to the
       * size of `collection`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Collection
       * @param {Array|Object} collection The collection to sample.
       * @param {number} [n=1] The number of elements to sample.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the random elements.
       * @example
       *
       * _.sampleSize([1, 2, 3], 2);
       * // => [3, 1]
       *
       * _.sampleSize([1, 2, 3], 4);
       * // => [2, 3, 1]
       */
      function sampleSize(collection, n, guard) {
        if ((guard ? isIterateeCall(collection, n, guard) : n === undefined$1)) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }

      /**
       * Creates an array of shuffled values, using a version of the
       * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to shuffle.
       * @returns {Array} Returns the new shuffled array.
       * @example
       *
       * _.shuffle([1, 2, 3, 4]);
       * // => [4, 1, 3, 2]
       */
      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }

      /**
       * Gets the size of `collection` by returning its length for array-like
       * values or the number of own enumerable string keyed properties for objects.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object|string} collection The collection to inspect.
       * @returns {number} Returns the collection size.
       * @example
       *
       * _.size([1, 2, 3]);
       * // => 3
       *
       * _.size({ 'a': 1, 'b': 2 });
       * // => 2
       *
       * _.size('pebbles');
       * // => 7
       */
      function size(collection) {
        if (collection == null) {
          return 0;
        }
        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }
        var tag = getTag(collection);
        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }
        return baseKeys(collection).length;
      }

      /**
       * Checks if `predicate` returns truthy for **any** element of `collection`.
       * Iteration is stopped once `predicate` returns truthy. The predicate is
       * invoked with three arguments: (value, index|key, collection).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {boolean} Returns `true` if any element passes the predicate check,
       *  else `false`.
       * @example
       *
       * _.some([null, 0, 'yes', false], Boolean);
       * // => true
       *
       * var users = [
       *   { 'user': 'barney', 'active': true },
       *   { 'user': 'fred',   'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.some(users, { 'user': 'barney', 'active': false });
       * // => false
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.some(users, ['active', false]);
       * // => true
       *
       * // The `_.property` iteratee shorthand.
       * _.some(users, 'active');
       * // => true
       */
      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;
        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }
        return func(collection, getIteratee(predicate, 3));
      }

      /**
       * Creates an array of elements, sorted in ascending order by the results of
       * running each element in a collection thru each iteratee. This method
       * performs a stable sort, that is, it preserves the original sort order of
       * equal elements. The iteratees are invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Collection
       * @param {Array|Object} collection The collection to iterate over.
       * @param {...(Function|Function[])} [iteratees=[_.identity]]
       *  The iteratees to sort by.
       * @returns {Array} Returns the new sorted array.
       * @example
       *
       * var users = [
       *   { 'user': 'fred',   'age': 48 },
       *   { 'user': 'barney', 'age': 36 },
       *   { 'user': 'fred',   'age': 30 },
       *   { 'user': 'barney', 'age': 34 }
       * ];
       *
       * _.sortBy(users, [function(o) { return o.user; }]);
       * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
       *
       * _.sortBy(users, ['user', 'age']);
       * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
       */
      var sortBy = baseRest(function(collection, iteratees) {
        if (collection == null) {
          return [];
        }
        var length = iteratees.length;
        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }
        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });

      /*------------------------------------------------------------------------*/

      /**
       * Gets the timestamp of the number of milliseconds that have elapsed since
       * the Unix epoch (1 January 1970 00:00:00 UTC).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Date
       * @returns {number} Returns the timestamp.
       * @example
       *
       * _.defer(function(stamp) {
       *   console.log(_.now() - stamp);
       * }, _.now());
       * // => Logs the number of milliseconds it took for the deferred invocation.
       */
      var now = ctxNow || function() {
        return root.Date.now();
      };

      /*------------------------------------------------------------------------*/

      /**
       * The opposite of `_.before`; this method creates a function that invokes
       * `func` once it's called `n` or more times.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {number} n The number of calls before `func` is invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var saves = ['profile', 'settings'];
       *
       * var done = _.after(saves.length, function() {
       *   console.log('done saving!');
       * });
       *
       * _.forEach(saves, function(type) {
       *   asyncSave({ 'type': type, 'complete': done });
       * });
       * // => Logs 'done saving!' after the two async saves have completed.
       */
      function after(n, func) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }

      /**
       * Creates a function that invokes `func`, with up to `n` arguments,
       * ignoring any additional arguments.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to cap arguments for.
       * @param {number} [n=func.length] The arity cap.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new capped function.
       * @example
       *
       * _.map(['6', '8', '10'], _.ary(parseInt, 1));
       * // => [6, 8, 10]
       */
      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = (func && n == null) ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }

      /**
       * Creates a function that invokes `func`, with the `this` binding and arguments
       * of the created function, while it's called less than `n` times. Subsequent
       * calls to the created function return the result of the last `func` invocation.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {number} n The number of calls at which `func` is no longer invoked.
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * jQuery(element).on('click', _.before(5, addContactToList));
       * // => Allows adding up to 4 contacts to the list.
       */
      function before(n, func) {
        var result;
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        n = toInteger(n);
        return function() {
          if (--n > 0) {
            result = func.apply(this, arguments);
          }
          if (n <= 1) {
            func = undefined$1;
          }
          return result;
        };
      }

      /**
       * Creates a function that invokes `func` with the `this` binding of `thisArg`
       * and `partials` prepended to the arguments it receives.
       *
       * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for partially applied arguments.
       *
       * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
       * property of bound functions.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to bind.
       * @param {*} thisArg The `this` binding of `func`.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * function greet(greeting, punctuation) {
       *   return greeting + ' ' + this.user + punctuation;
       * }
       *
       * var object = { 'user': 'fred' };
       *
       * var bound = _.bind(greet, object, 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bind(greet, object, _, '!');
       * bound('hi');
       * // => 'hi fred!'
       */
      var bind = baseRest(function(func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(func, bitmask, thisArg, partials, holders);
      });

      /**
       * Creates a function that invokes the method at `object[key]` with `partials`
       * prepended to the arguments it receives.
       *
       * This method differs from `_.bind` by allowing bound functions to reference
       * methods that may be redefined or don't yet exist. See
       * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
       * for more details.
       *
       * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Function
       * @param {Object} object The object to invoke the method on.
       * @param {string} key The key of the method.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new bound function.
       * @example
       *
       * var object = {
       *   'user': 'fred',
       *   'greet': function(greeting, punctuation) {
       *     return greeting + ' ' + this.user + punctuation;
       *   }
       * };
       *
       * var bound = _.bindKey(object, 'greet', 'hi');
       * bound('!');
       * // => 'hi fred!'
       *
       * object.greet = function(greeting, punctuation) {
       *   return greeting + 'ya ' + this.user + punctuation;
       * };
       *
       * bound('!');
       * // => 'hiya fred!'
       *
       * // Bound with placeholders.
       * var bound = _.bindKey(object, 'greet', _, '!');
       * bound('hi');
       * // => 'hiya fred!'
       */
      var bindKey = baseRest(function(object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }
        return createWrap(key, bitmask, object, partials, holders);
      });

      /**
       * Creates a function that accepts arguments of `func` and either invokes
       * `func` returning its result, if at least `arity` number of arguments have
       * been provided, or returns a function that accepts the remaining `func`
       * arguments, and so on. The arity of `func` may be specified if `func.length`
       * is not sufficient.
       *
       * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
       * may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curry(abc);
       *
       * curried(1)(2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2)(3);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(1)(_, 3)(2);
       * // => [1, 2, 3]
       */
      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curry.placeholder;
        return result;
      }

      /**
       * This method is like `_.curry` except that arguments are applied to `func`
       * in the manner of `_.partialRight` instead of `_.partial`.
       *
       * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for provided arguments.
       *
       * **Note:** This method doesn't set the "length" property of curried functions.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to curry.
       * @param {number} [arity=func.length] The arity of `func`.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the new curried function.
       * @example
       *
       * var abc = function(a, b, c) {
       *   return [a, b, c];
       * };
       *
       * var curried = _.curryRight(abc);
       *
       * curried(3)(2)(1);
       * // => [1, 2, 3]
       *
       * curried(2, 3)(1);
       * // => [1, 2, 3]
       *
       * curried(1, 2, 3);
       * // => [1, 2, 3]
       *
       * // Curried with placeholders.
       * curried(3)(1, _)(2);
       * // => [1, 2, 3]
       */
      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curryRight.placeholder;
        return result;
      }

      /**
       * Creates a debounced function that delays invoking `func` until after `wait`
       * milliseconds have elapsed since the last time the debounced function was
       * invoked. The debounced function comes with a `cancel` method to cancel
       * delayed `func` invocations and a `flush` method to immediately invoke them.
       * Provide `options` to indicate whether `func` should be invoked on the
       * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
       * with the last arguments provided to the debounced function. Subsequent
       * calls to the debounced function return the result of the last `func`
       * invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the debounced function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.debounce` and `_.throttle`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to debounce.
       * @param {number} [wait=0] The number of milliseconds to delay.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=false]
       *  Specify invoking on the leading edge of the timeout.
       * @param {number} [options.maxWait]
       *  The maximum time `func` is allowed to be delayed before it's invoked.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new debounced function.
       * @example
       *
       * // Avoid costly calculations while the window size is in flux.
       * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
       *
       * // Invoke `sendMail` when clicked, debouncing subsequent calls.
       * jQuery(element).on('click', _.debounce(sendMail, 300, {
       *   'leading': true,
       *   'trailing': false
       * }));
       *
       * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
       * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
       * var source = new EventSource('/stream');
       * jQuery(source).on('message', debounced);
       *
       * // Cancel the trailing debounced invocation.
       * jQuery(window).on('popstate', debounced.cancel);
       */
      function debounce(func, wait, options) {
        var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        wait = toNumber(wait) || 0;
        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
          var args = lastArgs,
              thisArg = lastThis;

          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }

        function leadingEdge(time) {
          // Reset any `maxWait` timer.
          lastInvokeTime = time;
          // Start the timer for the trailing edge.
          timerId = setTimeout(timerExpired, wait);
          // Invoke the leading edge.
          return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime,
              timeWaiting = wait - timeSinceLastCall;

          return maxing
            ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
            : timeWaiting;
        }

        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime;

          // Either this is the first call, activity has stopped and we're at the
          // trailing edge, the system time has gone backwards and we're treating
          // it as the trailing edge, or we've hit the `maxWait` limit.
          return (lastCallTime === undefined$1 || (timeSinceLastCall >= wait) ||
            (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
        }

        function timerExpired() {
          var time = now();
          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }
          // Restart the timer.
          timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
          timerId = undefined$1;

          // Only invoke if we have `lastArgs` which means `func` has been
          // debounced at least once.
          if (trailing && lastArgs) {
            return invokeFunc(time);
          }
          lastArgs = lastThis = undefined$1;
          return result;
        }

        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }
          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }

        function flush() {
          return timerId === undefined$1 ? result : trailingEdge(now());
        }

        function debounced() {
          var time = now(),
              isInvoking = shouldInvoke(time);

          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;

          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }
            if (maxing) {
              // Handle invocations in a tight loop.
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }
          if (timerId === undefined$1) {
            timerId = setTimeout(timerExpired, wait);
          }
          return result;
        }
        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      /**
       * Defers invoking the `func` until the current call stack has cleared. Any
       * additional arguments are provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to defer.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.defer(function(text) {
       *   console.log(text);
       * }, 'deferred');
       * // => Logs 'deferred' after one millisecond.
       */
      var defer = baseRest(function(func, args) {
        return baseDelay(func, 1, args);
      });

      /**
       * Invokes `func` after `wait` milliseconds. Any additional arguments are
       * provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to delay.
       * @param {number} wait The number of milliseconds to delay invocation.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {number} Returns the timer id.
       * @example
       *
       * _.delay(function(text) {
       *   console.log(text);
       * }, 1000, 'later');
       * // => Logs 'later' after one second.
       */
      var delay = baseRest(function(func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });

      /**
       * Creates a function that invokes `func` with arguments reversed.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to flip arguments for.
       * @returns {Function} Returns the new flipped function.
       * @example
       *
       * var flipped = _.flip(function() {
       *   return _.toArray(arguments);
       * });
       *
       * flipped('a', 'b', 'c', 'd');
       * // => ['d', 'c', 'b', 'a']
       */
      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }

      /**
       * Creates a function that memoizes the result of `func`. If `resolver` is
       * provided, it determines the cache key for storing the result based on the
       * arguments provided to the memoized function. By default, the first argument
       * provided to the memoized function is used as the map cache key. The `func`
       * is invoked with the `this` binding of the memoized function.
       *
       * **Note:** The cache is exposed as the `cache` property on the memoized
       * function. Its creation may be customized by replacing the `_.memoize.Cache`
       * constructor with one whose instances implement the
       * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
       * method interface of `clear`, `delete`, `get`, `has`, and `set`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to have its output memoized.
       * @param {Function} [resolver] The function to resolve the cache key.
       * @returns {Function} Returns the new memoized function.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       * var other = { 'c': 3, 'd': 4 };
       *
       * var values = _.memoize(_.values);
       * values(object);
       * // => [1, 2]
       *
       * values(other);
       * // => [3, 4]
       *
       * object.a = 2;
       * values(object);
       * // => [1, 2]
       *
       * // Modify the result cache.
       * values.cache.set(object, ['a', 'b']);
       * values(object);
       * // => ['a', 'b']
       *
       * // Replace `_.memoize.Cache`.
       * _.memoize.Cache = WeakMap;
       */
      function memoize(func, resolver) {
        if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        var memoized = function() {
          var args = arguments,
              key = resolver ? resolver.apply(this, args) : args[0],
              cache = memoized.cache;

          if (cache.has(key)) {
            return cache.get(key);
          }
          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };
        memoized.cache = new (memoize.Cache || MapCache);
        return memoized;
      }

      // Expose `MapCache`.
      memoize.Cache = MapCache;

      /**
       * Creates a function that negates the result of the predicate `func`. The
       * `func` predicate is invoked with the `this` binding and arguments of the
       * created function.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} predicate The predicate to negate.
       * @returns {Function} Returns the new negated function.
       * @example
       *
       * function isEven(n) {
       *   return n % 2 == 0;
       * }
       *
       * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
       * // => [1, 3, 5]
       */
      function negate(predicate) {
        if (typeof predicate != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return function() {
          var args = arguments;
          switch (args.length) {
            case 0: return !predicate.call(this);
            case 1: return !predicate.call(this, args[0]);
            case 2: return !predicate.call(this, args[0], args[1]);
            case 3: return !predicate.call(this, args[0], args[1], args[2]);
          }
          return !predicate.apply(this, args);
        };
      }

      /**
       * Creates a function that is restricted to invoking `func` once. Repeat calls
       * to the function return the value of the first invocation. The `func` is
       * invoked with the `this` binding and arguments of the created function.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to restrict.
       * @returns {Function} Returns the new restricted function.
       * @example
       *
       * var initialize = _.once(createApplication);
       * initialize();
       * initialize();
       * // => `createApplication` is invoked once
       */
      function once(func) {
        return before(2, func);
      }

      /**
       * Creates a function that invokes `func` with its arguments transformed.
       *
       * @static
       * @since 4.0.0
       * @memberOf _
       * @category Function
       * @param {Function} func The function to wrap.
       * @param {...(Function|Function[])} [transforms=[_.identity]]
       *  The argument transforms.
       * @returns {Function} Returns the new function.
       * @example
       *
       * function doubled(n) {
       *   return n * 2;
       * }
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var func = _.overArgs(function(x, y) {
       *   return [x, y];
       * }, [square, doubled]);
       *
       * func(9, 3);
       * // => [81, 6]
       *
       * func(10, 5);
       * // => [100, 10]
       */
      var overArgs = castRest(function(func, transforms) {
        transforms = (transforms.length == 1 && isArray(transforms[0]))
          ? arrayMap(transforms[0], baseUnary(getIteratee()))
          : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

        var funcsLength = transforms.length;
        return baseRest(function(args) {
          var index = -1,
              length = nativeMin(args.length, funcsLength);

          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }
          return apply(func, this, args);
        });
      });

      /**
       * Creates a function that invokes `func` with `partials` prepended to the
       * arguments it receives. This method is like `_.bind` except it does **not**
       * alter the `this` binding.
       *
       * The `_.partial.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 0.2.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var sayHelloTo = _.partial(greet, 'hello');
       * sayHelloTo('fred');
       * // => 'hello fred'
       *
       * // Partially applied with placeholders.
       * var greetFred = _.partial(greet, _, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       */
      var partial = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });

      /**
       * This method is like `_.partial` except that partially applied arguments
       * are appended to the arguments it receives.
       *
       * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
       * builds, may be used as a placeholder for partially applied arguments.
       *
       * **Note:** This method doesn't set the "length" property of partially
       * applied functions.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Function
       * @param {Function} func The function to partially apply arguments to.
       * @param {...*} [partials] The arguments to be partially applied.
       * @returns {Function} Returns the new partially applied function.
       * @example
       *
       * function greet(greeting, name) {
       *   return greeting + ' ' + name;
       * }
       *
       * var greetFred = _.partialRight(greet, 'fred');
       * greetFred('hi');
       * // => 'hi fred'
       *
       * // Partially applied with placeholders.
       * var sayHelloTo = _.partialRight(greet, 'hello', _);
       * sayHelloTo('fred');
       * // => 'hello fred'
       */
      var partialRight = baseRest(function(func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });

      /**
       * Creates a function that invokes `func` with arguments arranged according
       * to the specified `indexes` where the argument value at the first index is
       * provided as the first argument, the argument value at the second index is
       * provided as the second argument, and so on.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Function
       * @param {Function} func The function to rearrange arguments for.
       * @param {...(number|number[])} indexes The arranged argument indexes.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var rearged = _.rearg(function(a, b, c) {
       *   return [a, b, c];
       * }, [2, 0, 1]);
       *
       * rearged('b', 'c', 'a')
       * // => ['a', 'b', 'c']
       */
      var rearg = flatRest(function(func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });

      /**
       * Creates a function that invokes `func` with the `this` binding of the
       * created function and arguments from `start` and beyond provided as
       * an array.
       *
       * **Note:** This method is based on the
       * [rest parameter](https://mdn.io/rest_parameters).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to apply a rest parameter to.
       * @param {number} [start=func.length-1] The start position of the rest parameter.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.rest(function(what, names) {
       *   return what + ' ' + _.initial(names).join(', ') +
       *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
       * });
       *
       * say('hello', 'fred', 'barney', 'pebbles');
       * // => 'hello fred, barney, & pebbles'
       */
      function rest(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }

      /**
       * Creates a function that invokes `func` with the `this` binding of the
       * create function and an array of arguments much like
       * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
       *
       * **Note:** This method is based on the
       * [spread operator](https://mdn.io/spread_operator).
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Function
       * @param {Function} func The function to spread arguments over.
       * @param {number} [start=0] The start position of the spread.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var say = _.spread(function(who, what) {
       *   return who + ' says ' + what;
       * });
       *
       * say(['fred', 'hello']);
       * // => 'fred says hello'
       *
       * var numbers = Promise.all([
       *   Promise.resolve(40),
       *   Promise.resolve(36)
       * ]);
       *
       * numbers.then(_.spread(function(x, y) {
       *   return x + y;
       * }));
       * // => a Promise of 76
       */
      function spread(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function(args) {
          var array = args[start],
              otherArgs = castSlice(args, 0, start);

          if (array) {
            arrayPush(otherArgs, array);
          }
          return apply(func, this, otherArgs);
        });
      }

      /**
       * Creates a throttled function that only invokes `func` at most once per
       * every `wait` milliseconds. The throttled function comes with a `cancel`
       * method to cancel delayed `func` invocations and a `flush` method to
       * immediately invoke them. Provide `options` to indicate whether `func`
       * should be invoked on the leading and/or trailing edge of the `wait`
       * timeout. The `func` is invoked with the last arguments provided to the
       * throttled function. Subsequent calls to the throttled function return the
       * result of the last `func` invocation.
       *
       * **Note:** If `leading` and `trailing` options are `true`, `func` is
       * invoked on the trailing edge of the timeout only if the throttled function
       * is invoked more than once during the `wait` timeout.
       *
       * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
       * until to the next tick, similar to `setTimeout` with a timeout of `0`.
       *
       * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
       * for details over the differences between `_.throttle` and `_.debounce`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {Function} func The function to throttle.
       * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.leading=true]
       *  Specify invoking on the leading edge of the timeout.
       * @param {boolean} [options.trailing=true]
       *  Specify invoking on the trailing edge of the timeout.
       * @returns {Function} Returns the new throttled function.
       * @example
       *
       * // Avoid excessively updating the position while scrolling.
       * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
       *
       * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
       * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
       * jQuery(element).on('click', throttled);
       *
       * // Cancel the trailing throttled invocation.
       * jQuery(window).on('popstate', throttled.cancel);
       */
      function throttle(func, wait, options) {
        var leading = true,
            trailing = true;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }
        return debounce(func, wait, {
          'leading': leading,
          'maxWait': wait,
          'trailing': trailing
        });
      }

      /**
       * Creates a function that accepts up to one argument, ignoring any
       * additional arguments.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Function
       * @param {Function} func The function to cap arguments for.
       * @returns {Function} Returns the new capped function.
       * @example
       *
       * _.map(['6', '8', '10'], _.unary(parseInt));
       * // => [6, 8, 10]
       */
      function unary(func) {
        return ary(func, 1);
      }

      /**
       * Creates a function that provides `value` to `wrapper` as its first
       * argument. Any additional arguments provided to the function are appended
       * to those provided to the `wrapper`. The wrapper is invoked with the `this`
       * binding of the created function.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Function
       * @param {*} value The value to wrap.
       * @param {Function} [wrapper=identity] The wrapper function.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var p = _.wrap(_.escape, function(func, text) {
       *   return '<p>' + func(text) + '</p>';
       * });
       *
       * p('fred, barney, & pebbles');
       * // => '<p>fred, barney, &amp; pebbles</p>'
       */
      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Casts `value` as an array if it's not one.
       *
       * @static
       * @memberOf _
       * @since 4.4.0
       * @category Lang
       * @param {*} value The value to inspect.
       * @returns {Array} Returns the cast array.
       * @example
       *
       * _.castArray(1);
       * // => [1]
       *
       * _.castArray({ 'a': 1 });
       * // => [{ 'a': 1 }]
       *
       * _.castArray('abc');
       * // => ['abc']
       *
       * _.castArray(null);
       * // => [null]
       *
       * _.castArray(undefined);
       * // => [undefined]
       *
       * _.castArray();
       * // => []
       *
       * var array = [1, 2, 3];
       * console.log(_.castArray(array) === array);
       * // => true
       */
      function castArray() {
        if (!arguments.length) {
          return [];
        }
        var value = arguments[0];
        return isArray(value) ? value : [value];
      }

      /**
       * Creates a shallow clone of `value`.
       *
       * **Note:** This method is loosely based on the
       * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
       * and supports cloning arrays, array buffers, booleans, date objects, maps,
       * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
       * arrays. The own enumerable properties of `arguments` objects are cloned
       * as plain objects. An empty object is returned for uncloneable values such
       * as error objects, functions, DOM nodes, and WeakMaps.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to clone.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeep
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var shallow = _.clone(objects);
       * console.log(shallow[0] === objects[0]);
       * // => true
       */
      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }

      /**
       * This method is like `_.clone` except that it accepts `customizer` which
       * is invoked to produce the cloned value. If `customizer` returns `undefined`,
       * cloning is handled by the method instead. The `customizer` is invoked with
       * up to four arguments; (value [, index|key, object, stack]).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to clone.
       * @param {Function} [customizer] The function to customize cloning.
       * @returns {*} Returns the cloned value.
       * @see _.cloneDeepWith
       * @example
       *
       * function customizer(value) {
       *   if (_.isElement(value)) {
       *     return value.cloneNode(false);
       *   }
       * }
       *
       * var el = _.cloneWith(document.body, customizer);
       *
       * console.log(el === document.body);
       * // => false
       * console.log(el.nodeName);
       * // => 'BODY'
       * console.log(el.childNodes.length);
       * // => 0
       */
      function cloneWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }

      /**
       * This method is like `_.clone` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @returns {*} Returns the deep cloned value.
       * @see _.clone
       * @example
       *
       * var objects = [{ 'a': 1 }, { 'b': 2 }];
       *
       * var deep = _.cloneDeep(objects);
       * console.log(deep[0] === objects[0]);
       * // => false
       */
      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }

      /**
       * This method is like `_.cloneWith` except that it recursively clones `value`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to recursively clone.
       * @param {Function} [customizer] The function to customize cloning.
       * @returns {*} Returns the deep cloned value.
       * @see _.cloneWith
       * @example
       *
       * function customizer(value) {
       *   if (_.isElement(value)) {
       *     return value.cloneNode(true);
       *   }
       * }
       *
       * var el = _.cloneDeepWith(document.body, customizer);
       *
       * console.log(el === document.body);
       * // => false
       * console.log(el.nodeName);
       * // => 'BODY'
       * console.log(el.childNodes.length);
       * // => 20
       */
      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }

      /**
       * Checks if `object` conforms to `source` by invoking the predicate
       * properties of `source` with the corresponding property values of `object`.
       *
       * **Note:** This method is equivalent to `_.conforms` when `source` is
       * partially applied.
       *
       * @static
       * @memberOf _
       * @since 4.14.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property predicates to conform to.
       * @returns {boolean} Returns `true` if `object` conforms, else `false`.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       *
       * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
       * // => true
       *
       * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
       * // => false
       */
      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }

      /**
       * Performs a
       * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
       * comparison between two values to determine if they are equivalent.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.eq(object, object);
       * // => true
       *
       * _.eq(object, other);
       * // => false
       *
       * _.eq('a', 'a');
       * // => true
       *
       * _.eq('a', Object('a'));
       * // => false
       *
       * _.eq(NaN, NaN);
       * // => true
       */
      function eq(value, other) {
        return value === other || (value !== value && other !== other);
      }

      /**
       * Checks if `value` is greater than `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than `other`,
       *  else `false`.
       * @see _.lt
       * @example
       *
       * _.gt(3, 1);
       * // => true
       *
       * _.gt(3, 3);
       * // => false
       *
       * _.gt(1, 3);
       * // => false
       */
      var gt = createRelationalOperation(baseGt);

      /**
       * Checks if `value` is greater than or equal to `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is greater than or equal to
       *  `other`, else `false`.
       * @see _.lte
       * @example
       *
       * _.gte(3, 1);
       * // => true
       *
       * _.gte(3, 3);
       * // => true
       *
       * _.gte(1, 3);
       * // => false
       */
      var gte = createRelationalOperation(function(value, other) {
        return value >= other;
      });

      /**
       * Checks if `value` is likely an `arguments` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an `arguments` object,
       *  else `false`.
       * @example
       *
       * _.isArguments(function() { return arguments; }());
       * // => true
       *
       * _.isArguments([1, 2, 3]);
       * // => false
       */
      var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
          !propertyIsEnumerable.call(value, 'callee');
      };

      /**
       * Checks if `value` is classified as an `Array` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array, else `false`.
       * @example
       *
       * _.isArray([1, 2, 3]);
       * // => true
       *
       * _.isArray(document.body.children);
       * // => false
       *
       * _.isArray('abc');
       * // => false
       *
       * _.isArray(_.noop);
       * // => false
       */
      var isArray = Array.isArray;

      /**
       * Checks if `value` is classified as an `ArrayBuffer` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
       * @example
       *
       * _.isArrayBuffer(new ArrayBuffer(2));
       * // => true
       *
       * _.isArrayBuffer(new Array(2));
       * // => false
       */
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

      /**
       * Checks if `value` is array-like. A value is considered array-like if it's
       * not a function and has a `value.length` that's an integer greater than or
       * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
       * @example
       *
       * _.isArrayLike([1, 2, 3]);
       * // => true
       *
       * _.isArrayLike(document.body.children);
       * // => true
       *
       * _.isArrayLike('abc');
       * // => true
       *
       * _.isArrayLike(_.noop);
       * // => false
       */
      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }

      /**
       * This method is like `_.isArrayLike` except that it also checks if `value`
       * is an object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an array-like object,
       *  else `false`.
       * @example
       *
       * _.isArrayLikeObject([1, 2, 3]);
       * // => true
       *
       * _.isArrayLikeObject(document.body.children);
       * // => true
       *
       * _.isArrayLikeObject('abc');
       * // => false
       *
       * _.isArrayLikeObject(_.noop);
       * // => false
       */
      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }

      /**
       * Checks if `value` is classified as a boolean primitive or object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
       * @example
       *
       * _.isBoolean(false);
       * // => true
       *
       * _.isBoolean(null);
       * // => false
       */
      function isBoolean(value) {
        return value === true || value === false ||
          (isObjectLike(value) && baseGetTag(value) == boolTag);
      }

      /**
       * Checks if `value` is a buffer.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
       * @example
       *
       * _.isBuffer(new Buffer(2));
       * // => true
       *
       * _.isBuffer(new Uint8Array(2));
       * // => false
       */
      var isBuffer = nativeIsBuffer || stubFalse;

      /**
       * Checks if `value` is classified as a `Date` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
       * @example
       *
       * _.isDate(new Date);
       * // => true
       *
       * _.isDate('Mon April 23 2012');
       * // => false
       */
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

      /**
       * Checks if `value` is likely a DOM element.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
       * @example
       *
       * _.isElement(document.body);
       * // => true
       *
       * _.isElement('<body>');
       * // => false
       */
      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }

      /**
       * Checks if `value` is an empty object, collection, map, or set.
       *
       * Objects are considered empty if they have no own enumerable string keyed
       * properties.
       *
       * Array-like values such as `arguments` objects, arrays, buffers, strings, or
       * jQuery-like collections are considered empty if they have a `length` of `0`.
       * Similarly, maps and sets are considered empty if they have a `size` of `0`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is empty, else `false`.
       * @example
       *
       * _.isEmpty(null);
       * // => true
       *
       * _.isEmpty(true);
       * // => true
       *
       * _.isEmpty(1);
       * // => true
       *
       * _.isEmpty([1, 2, 3]);
       * // => false
       *
       * _.isEmpty({ 'a': 1 });
       * // => false
       */
      function isEmpty(value) {
        if (value == null) {
          return true;
        }
        if (isArrayLike(value) &&
            (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
              isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }
        var tag = getTag(value);
        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }
        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }
        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }
        return true;
      }

      /**
       * Performs a deep comparison between two values to determine if they are
       * equivalent.
       *
       * **Note:** This method supports comparing arrays, array buffers, booleans,
       * date objects, error objects, maps, numbers, `Object` objects, regexes,
       * sets, strings, symbols, and typed arrays. `Object` objects are compared
       * by their own, not inherited, enumerable properties. Functions and DOM
       * nodes are compared by strict equality, i.e. `===`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * var object = { 'a': 1 };
       * var other = { 'a': 1 };
       *
       * _.isEqual(object, other);
       * // => true
       *
       * object === other;
       * // => false
       */
      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }

      /**
       * This method is like `_.isEqual` except that it accepts `customizer` which
       * is invoked to compare values. If `customizer` returns `undefined`, comparisons
       * are handled by the method instead. The `customizer` is invoked with up to
       * six arguments: (objValue, othValue [, index|key, object, other, stack]).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
       * @example
       *
       * function isGreeting(value) {
       *   return /^h(?:i|ello)$/.test(value);
       * }
       *
       * function customizer(objValue, othValue) {
       *   if (isGreeting(objValue) && isGreeting(othValue)) {
       *     return true;
       *   }
       * }
       *
       * var array = ['hello', 'goodbye'];
       * var other = ['hi', 'goodbye'];
       *
       * _.isEqualWith(array, other, customizer);
       * // => true
       */
      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        var result = customizer ? customizer(value, other) : undefined$1;
        return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
      }

      /**
       * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
       * `SyntaxError`, `TypeError`, or `URIError` object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
       * @example
       *
       * _.isError(new Error);
       * // => true
       *
       * _.isError(Error);
       * // => false
       */
      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }
        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag ||
          (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
      }

      /**
       * Checks if `value` is a finite primitive number.
       *
       * **Note:** This method is based on
       * [`Number.isFinite`](https://mdn.io/Number/isFinite).
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
       * @example
       *
       * _.isFinite(3);
       * // => true
       *
       * _.isFinite(Number.MIN_VALUE);
       * // => true
       *
       * _.isFinite(Infinity);
       * // => false
       *
       * _.isFinite('3');
       * // => false
       */
      function isFinite(value) {
        return typeof value == 'number' && nativeIsFinite(value);
      }

      /**
       * Checks if `value` is classified as a `Function` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a function, else `false`.
       * @example
       *
       * _.isFunction(_);
       * // => true
       *
       * _.isFunction(/abc/);
       * // => false
       */
      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }
        // The use of `Object#toString` avoids issues with the `typeof` operator
        // in Safari 9 which returns 'object' for typed arrays and other constructors.
        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }

      /**
       * Checks if `value` is an integer.
       *
       * **Note:** This method is based on
       * [`Number.isInteger`](https://mdn.io/Number/isInteger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
       * @example
       *
       * _.isInteger(3);
       * // => true
       *
       * _.isInteger(Number.MIN_VALUE);
       * // => false
       *
       * _.isInteger(Infinity);
       * // => false
       *
       * _.isInteger('3');
       * // => false
       */
      function isInteger(value) {
        return typeof value == 'number' && value == toInteger(value);
      }

      /**
       * Checks if `value` is a valid array-like length.
       *
       * **Note:** This method is loosely based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
       * @example
       *
       * _.isLength(3);
       * // => true
       *
       * _.isLength(Number.MIN_VALUE);
       * // => false
       *
       * _.isLength(Infinity);
       * // => false
       *
       * _.isLength('3');
       * // => false
       */
      function isLength(value) {
        return typeof value == 'number' &&
          value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }

      /**
       * Checks if `value` is the
       * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
       * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is an object, else `false`.
       * @example
       *
       * _.isObject({});
       * // => true
       *
       * _.isObject([1, 2, 3]);
       * // => true
       *
       * _.isObject(_.noop);
       * // => true
       *
       * _.isObject(null);
       * // => false
       */
      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }

      /**
       * Checks if `value` is object-like. A value is object-like if it's not `null`
       * and has a `typeof` result of "object".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
       * @example
       *
       * _.isObjectLike({});
       * // => true
       *
       * _.isObjectLike([1, 2, 3]);
       * // => true
       *
       * _.isObjectLike(_.noop);
       * // => false
       *
       * _.isObjectLike(null);
       * // => false
       */
      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }

      /**
       * Checks if `value` is classified as a `Map` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a map, else `false`.
       * @example
       *
       * _.isMap(new Map);
       * // => true
       *
       * _.isMap(new WeakMap);
       * // => false
       */
      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

      /**
       * Performs a partial deep comparison between `object` and `source` to
       * determine if `object` contains equivalent property values.
       *
       * **Note:** This method is equivalent to `_.matches` when `source` is
       * partially applied.
       *
       * Partial comparisons will match empty array and empty object `source`
       * values against any array or object value, respectively. See `_.isEqual`
       * for a list of supported value comparisons.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       * @example
       *
       * var object = { 'a': 1, 'b': 2 };
       *
       * _.isMatch(object, { 'b': 2 });
       * // => true
       *
       * _.isMatch(object, { 'b': 1 });
       * // => false
       */
      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }

      /**
       * This method is like `_.isMatch` except that it accepts `customizer` which
       * is invoked to compare values. If `customizer` returns `undefined`, comparisons
       * are handled by the method instead. The `customizer` is invoked with five
       * arguments: (objValue, srcValue, index|key, object, source).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {Object} object The object to inspect.
       * @param {Object} source The object of property values to match.
       * @param {Function} [customizer] The function to customize comparisons.
       * @returns {boolean} Returns `true` if `object` is a match, else `false`.
       * @example
       *
       * function isGreeting(value) {
       *   return /^h(?:i|ello)$/.test(value);
       * }
       *
       * function customizer(objValue, srcValue) {
       *   if (isGreeting(objValue) && isGreeting(srcValue)) {
       *     return true;
       *   }
       * }
       *
       * var object = { 'greeting': 'hello' };
       * var source = { 'greeting': 'hi' };
       *
       * _.isMatchWith(object, source, customizer);
       * // => true
       */
      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }

      /**
       * Checks if `value` is `NaN`.
       *
       * **Note:** This method is based on
       * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
       * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
       * `undefined` and other non-number values.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
       * @example
       *
       * _.isNaN(NaN);
       * // => true
       *
       * _.isNaN(new Number(NaN));
       * // => true
       *
       * isNaN(undefined);
       * // => true
       *
       * _.isNaN(undefined);
       * // => false
       */
      function isNaN(value) {
        // An `NaN` primitive is the only value that is not equal to itself.
        // Perform the `toStringTag` check first to avoid errors with some
        // ActiveX objects in IE.
        return isNumber(value) && value != +value;
      }

      /**
       * Checks if `value` is a pristine native function.
       *
       * **Note:** This method can't reliably detect native functions in the presence
       * of the core-js package because core-js circumvents this kind of detection.
       * Despite multiple requests, the core-js maintainer has made it clear: any
       * attempt to fix the detection will be obstructed. As a result, we're left
       * with little choice but to throw an error. Unfortunately, this also affects
       * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
       * which rely on core-js.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a native function,
       *  else `false`.
       * @example
       *
       * _.isNative(Array.prototype.push);
       * // => true
       *
       * _.isNative(_);
       * // => false
       */
      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error(CORE_ERROR_TEXT);
        }
        return baseIsNative(value);
      }

      /**
       * Checks if `value` is `null`.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
       * @example
       *
       * _.isNull(null);
       * // => true
       *
       * _.isNull(void 0);
       * // => false
       */
      function isNull(value) {
        return value === null;
      }

      /**
       * Checks if `value` is `null` or `undefined`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
       * @example
       *
       * _.isNil(null);
       * // => true
       *
       * _.isNil(void 0);
       * // => true
       *
       * _.isNil(NaN);
       * // => false
       */
      function isNil(value) {
        return value == null;
      }

      /**
       * Checks if `value` is classified as a `Number` primitive or object.
       *
       * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
       * classified as numbers, use the `_.isFinite` method.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a number, else `false`.
       * @example
       *
       * _.isNumber(3);
       * // => true
       *
       * _.isNumber(Number.MIN_VALUE);
       * // => true
       *
       * _.isNumber(Infinity);
       * // => true
       *
       * _.isNumber('3');
       * // => false
       */
      function isNumber(value) {
        return typeof value == 'number' ||
          (isObjectLike(value) && baseGetTag(value) == numberTag);
      }

      /**
       * Checks if `value` is a plain object, that is, an object created by the
       * `Object` constructor or one with a `[[Prototype]]` of `null`.
       *
       * @static
       * @memberOf _
       * @since 0.8.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * _.isPlainObject(new Foo);
       * // => false
       *
       * _.isPlainObject([1, 2, 3]);
       * // => false
       *
       * _.isPlainObject({ 'x': 0, 'y': 0 });
       * // => true
       *
       * _.isPlainObject(Object.create(null));
       * // => true
       */
      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }
        var proto = getPrototype(value);
        if (proto === null) {
          return true;
        }
        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor &&
          funcToString.call(Ctor) == objectCtorString;
      }

      /**
       * Checks if `value` is classified as a `RegExp` object.
       *
       * @static
       * @memberOf _
       * @since 0.1.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
       * @example
       *
       * _.isRegExp(/abc/);
       * // => true
       *
       * _.isRegExp('/abc/');
       * // => false
       */
      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

      /**
       * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
       * double precision number which isn't the result of a rounded unsafe integer.
       *
       * **Note:** This method is based on
       * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
       * @example
       *
       * _.isSafeInteger(3);
       * // => true
       *
       * _.isSafeInteger(Number.MIN_VALUE);
       * // => false
       *
       * _.isSafeInteger(Infinity);
       * // => false
       *
       * _.isSafeInteger('3');
       * // => false
       */
      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }

      /**
       * Checks if `value` is classified as a `Set` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a set, else `false`.
       * @example
       *
       * _.isSet(new Set);
       * // => true
       *
       * _.isSet(new WeakSet);
       * // => false
       */
      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

      /**
       * Checks if `value` is classified as a `String` primitive or object.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a string, else `false`.
       * @example
       *
       * _.isString('abc');
       * // => true
       *
       * _.isString(1);
       * // => false
       */
      function isString(value) {
        return typeof value == 'string' ||
          (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
      }

      /**
       * Checks if `value` is classified as a `Symbol` primitive or object.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
       * @example
       *
       * _.isSymbol(Symbol.iterator);
       * // => true
       *
       * _.isSymbol('abc');
       * // => false
       */
      function isSymbol(value) {
        return typeof value == 'symbol' ||
          (isObjectLike(value) && baseGetTag(value) == symbolTag);
      }

      /**
       * Checks if `value` is classified as a typed array.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
       * @example
       *
       * _.isTypedArray(new Uint8Array);
       * // => true
       *
       * _.isTypedArray([]);
       * // => false
       */
      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

      /**
       * Checks if `value` is `undefined`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
       * @example
       *
       * _.isUndefined(void 0);
       * // => true
       *
       * _.isUndefined(null);
       * // => false
       */
      function isUndefined(value) {
        return value === undefined$1;
      }

      /**
       * Checks if `value` is classified as a `WeakMap` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
       * @example
       *
       * _.isWeakMap(new WeakMap);
       * // => true
       *
       * _.isWeakMap(new Map);
       * // => false
       */
      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }

      /**
       * Checks if `value` is classified as a `WeakSet` object.
       *
       * @static
       * @memberOf _
       * @since 4.3.0
       * @category Lang
       * @param {*} value The value to check.
       * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
       * @example
       *
       * _.isWeakSet(new WeakSet);
       * // => true
       *
       * _.isWeakSet(new Set);
       * // => false
       */
      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }

      /**
       * Checks if `value` is less than `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than `other`,
       *  else `false`.
       * @see _.gt
       * @example
       *
       * _.lt(1, 3);
       * // => true
       *
       * _.lt(3, 3);
       * // => false
       *
       * _.lt(3, 1);
       * // => false
       */
      var lt = createRelationalOperation(baseLt);

      /**
       * Checks if `value` is less than or equal to `other`.
       *
       * @static
       * @memberOf _
       * @since 3.9.0
       * @category Lang
       * @param {*} value The value to compare.
       * @param {*} other The other value to compare.
       * @returns {boolean} Returns `true` if `value` is less than or equal to
       *  `other`, else `false`.
       * @see _.gte
       * @example
       *
       * _.lte(1, 3);
       * // => true
       *
       * _.lte(3, 3);
       * // => true
       *
       * _.lte(3, 1);
       * // => false
       */
      var lte = createRelationalOperation(function(value, other) {
        return value <= other;
      });

      /**
       * Converts `value` to an array.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Array} Returns the converted array.
       * @example
       *
       * _.toArray({ 'a': 1, 'b': 2 });
       * // => [1, 2]
       *
       * _.toArray('abc');
       * // => ['a', 'b', 'c']
       *
       * _.toArray(1);
       * // => []
       *
       * _.toArray(null);
       * // => []
       */
      function toArray(value) {
        if (!value) {
          return [];
        }
        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }
        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }
        var tag = getTag(value),
            func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

        return func(value);
      }

      /**
       * Converts `value` to a finite number.
       *
       * @static
       * @memberOf _
       * @since 4.12.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted number.
       * @example
       *
       * _.toFinite(3.2);
       * // => 3.2
       *
       * _.toFinite(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toFinite(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toFinite('3.2');
       * // => 3.2
       */
      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }
        value = toNumber(value);
        if (value === INFINITY || value === -INFINITY) {
          var sign = (value < 0 ? -1 : 1);
          return sign * MAX_INTEGER;
        }
        return value === value ? value : 0;
      }

      /**
       * Converts `value` to an integer.
       *
       * **Note:** This method is loosely based on
       * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toInteger(3.2);
       * // => 3
       *
       * _.toInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toInteger(Infinity);
       * // => 1.7976931348623157e+308
       *
       * _.toInteger('3.2');
       * // => 3
       */
      function toInteger(value) {
        var result = toFinite(value),
            remainder = result % 1;

        return result === result ? (remainder ? result - remainder : result) : 0;
      }

      /**
       * Converts `value` to an integer suitable for use as the length of an
       * array-like object.
       *
       * **Note:** This method is based on
       * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toLength(3.2);
       * // => 3
       *
       * _.toLength(Number.MIN_VALUE);
       * // => 0
       *
       * _.toLength(Infinity);
       * // => 4294967295
       *
       * _.toLength('3.2');
       * // => 3
       */
      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }

      /**
       * Converts `value` to a number.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to process.
       * @returns {number} Returns the number.
       * @example
       *
       * _.toNumber(3.2);
       * // => 3.2
       *
       * _.toNumber(Number.MIN_VALUE);
       * // => 5e-324
       *
       * _.toNumber(Infinity);
       * // => Infinity
       *
       * _.toNumber('3.2');
       * // => 3.2
       */
      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }
        if (isSymbol(value)) {
          return NAN;
        }
        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? (other + '') : other;
        }
        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }
        value = value.replace(reTrim, '');
        var isBinary = reIsBinary.test(value);
        return (isBinary || reIsOctal.test(value))
          ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
          : (reIsBadHex.test(value) ? NAN : +value);
      }

      /**
       * Converts `value` to a plain object flattening inherited enumerable string
       * keyed properties of `value` to own properties of the plain object.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {Object} Returns the converted plain object.
       * @example
       *
       * function Foo() {
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.assign({ 'a': 1 }, new Foo);
       * // => { 'a': 1, 'b': 2 }
       *
       * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
       * // => { 'a': 1, 'b': 2, 'c': 3 }
       */
      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }

      /**
       * Converts `value` to a safe integer. A safe integer can be compared and
       * represented correctly.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.toSafeInteger(3.2);
       * // => 3
       *
       * _.toSafeInteger(Number.MIN_VALUE);
       * // => 0
       *
       * _.toSafeInteger(Infinity);
       * // => 9007199254740991
       *
       * _.toSafeInteger('3.2');
       * // => 3
       */
      function toSafeInteger(value) {
        return value
          ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
          : (value === 0 ? value : 0);
      }

      /**
       * Converts `value` to a string. An empty string is returned for `null`
       * and `undefined` values. The sign of `-0` is preserved.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Lang
       * @param {*} value The value to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.toString(null);
       * // => ''
       *
       * _.toString(-0);
       * // => '-0'
       *
       * _.toString([1, 2, 3]);
       * // => '1,2,3'
       */
      function toString(value) {
        return value == null ? '' : baseToString(value);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Assigns own enumerable string keyed properties of source objects to the
       * destination object. Source objects are applied from left to right.
       * Subsequent sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object` and is loosely based on
       * [`Object.assign`](https://mdn.io/Object/assign).
       *
       * @static
       * @memberOf _
       * @since 0.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assignIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assign({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'c': 3 }
       */
      var assign = createAssigner(function(object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }
        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });

      /**
       * This method is like `_.assign` except that it iterates over own and
       * inherited source properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extend
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.assign
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       * }
       *
       * function Bar() {
       *   this.c = 3;
       * }
       *
       * Foo.prototype.b = 2;
       * Bar.prototype.d = 4;
       *
       * _.assignIn({ 'a': 0 }, new Foo, new Bar);
       * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
       */
      var assignIn = createAssigner(function(object, source) {
        copyObject(source, keysIn(source), object);
      });

      /**
       * This method is like `_.assignIn` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias extendWith
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignInWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });

      /**
       * This method is like `_.assign` except that it accepts `customizer`
       * which is invoked to produce the assigned values. If `customizer` returns
       * `undefined`, assignment is handled by the method instead. The `customizer`
       * is invoked with five arguments: (objValue, srcValue, key, object, source).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @see _.assignInWith
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   return _.isUndefined(objValue) ? srcValue : objValue;
       * }
       *
       * var defaults = _.partialRight(_.assignWith, customizer);
       *
       * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });

      /**
       * Creates an array of values corresponding to `paths` of `object`.
       *
       * @static
       * @memberOf _
       * @since 1.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Array} Returns the picked values.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
       *
       * _.at(object, ['a[0].b.c', 'a[1]']);
       * // => [3, 4]
       */
      var at = flatRest(baseAt);

      /**
       * Creates an object that inherits from the `prototype` object. If a
       * `properties` object is given, its own enumerable string keyed properties
       * are assigned to the created object.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Object
       * @param {Object} prototype The object to inherit from.
       * @param {Object} [properties] The properties to assign to the object.
       * @returns {Object} Returns the new object.
       * @example
       *
       * function Shape() {
       *   this.x = 0;
       *   this.y = 0;
       * }
       *
       * function Circle() {
       *   Shape.call(this);
       * }
       *
       * Circle.prototype = _.create(Shape.prototype, {
       *   'constructor': Circle
       * });
       *
       * var circle = new Circle;
       * circle instanceof Circle;
       * // => true
       *
       * circle instanceof Shape;
       * // => true
       */
      function create(prototype, properties) {
        var result = baseCreate(prototype);
        return properties == null ? result : baseAssign(result, properties);
      }

      /**
       * Assigns own and inherited enumerable string keyed properties of source
       * objects to the destination object for all destination properties that
       * resolve to `undefined`. Source objects are applied from left to right.
       * Once a property is set, additional values of the same property are ignored.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaultsDeep
       * @example
       *
       * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
       * // => { 'a': 1, 'b': 2 }
       */
      var defaults = baseRest(function(object, sources) {
        object = Object(object);

        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }

        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;

          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];

            if (value === undefined$1 ||
                (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
              object[key] = source[key];
            }
          }
        }

        return object;
      });

      /**
       * This method is like `_.defaults` except that it recursively assigns
       * default properties.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @see _.defaults
       * @example
       *
       * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
       * // => { 'a': { 'b': 2, 'c': 3 } }
       */
      var defaultsDeep = baseRest(function(args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });

      /**
       * This method is like `_.find` except that it returns the key of the first
       * element `predicate` returns truthy for instead of the element itself.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findKey(users, function(o) { return o.age < 40; });
       * // => 'barney' (iteration order is not guaranteed)
       *
       * // The `_.matches` iteratee shorthand.
       * _.findKey(users, { 'age': 1, 'active': true });
       * // => 'pebbles'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findKey(users, 'active');
       * // => 'barney'
       */
      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }

      /**
       * This method is like `_.findKey` except that it iterates over elements of
       * a collection in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @param {Function} [predicate=_.identity] The function invoked per iteration.
       * @returns {string|undefined} Returns the key of the matched element,
       *  else `undefined`.
       * @example
       *
       * var users = {
       *   'barney':  { 'age': 36, 'active': true },
       *   'fred':    { 'age': 40, 'active': false },
       *   'pebbles': { 'age': 1,  'active': true }
       * };
       *
       * _.findLastKey(users, function(o) { return o.age < 40; });
       * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
       *
       * // The `_.matches` iteratee shorthand.
       * _.findLastKey(users, { 'age': 36, 'active': true });
       * // => 'barney'
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.findLastKey(users, ['active', false]);
       * // => 'fred'
       *
       * // The `_.property` iteratee shorthand.
       * _.findLastKey(users, 'active');
       * // => 'pebbles'
       */
      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }

      /**
       * Iterates over own and inherited enumerable string keyed properties of an
       * object and invokes `iteratee` for each property. The iteratee is invoked
       * with three arguments: (value, key, object). Iteratee functions may exit
       * iteration early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 0.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forInRight
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forIn(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
       */
      function forIn(object, iteratee) {
        return object == null
          ? object
          : baseFor(object, getIteratee(iteratee, 3), keysIn);
      }

      /**
       * This method is like `_.forIn` except that it iterates over properties of
       * `object` in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forIn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forInRight(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
       */
      function forInRight(object, iteratee) {
        return object == null
          ? object
          : baseForRight(object, getIteratee(iteratee, 3), keysIn);
      }

      /**
       * Iterates over own enumerable string keyed properties of an object and
       * invokes `iteratee` for each property. The iteratee is invoked with three
       * arguments: (value, key, object). Iteratee functions may exit iteration
       * early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 0.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forOwnRight
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forOwn(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'a' then 'b' (iteration order is not guaranteed).
       */
      function forOwn(object, iteratee) {
        return object && baseForOwn(object, getIteratee(iteratee, 3));
      }

      /**
       * This method is like `_.forOwn` except that it iterates over properties of
       * `object` in the opposite order.
       *
       * @static
       * @memberOf _
       * @since 2.0.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns `object`.
       * @see _.forOwn
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.forOwnRight(new Foo, function(value, key) {
       *   console.log(key);
       * });
       * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
       */
      function forOwnRight(object, iteratee) {
        return object && baseForOwnRight(object, getIteratee(iteratee, 3));
      }

      /**
       * Creates an array of function property names from own enumerable properties
       * of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functionsIn
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functions(new Foo);
       * // => ['a', 'b']
       */
      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }

      /**
       * Creates an array of function property names from own and inherited
       * enumerable properties of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to inspect.
       * @returns {Array} Returns the function names.
       * @see _.functions
       * @example
       *
       * function Foo() {
       *   this.a = _.constant('a');
       *   this.b = _.constant('b');
       * }
       *
       * Foo.prototype.c = _.constant('c');
       *
       * _.functionsIn(new Foo);
       * // => ['a', 'b', 'c']
       */
      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }

      /**
       * Gets the value at `path` of `object`. If the resolved value is
       * `undefined`, the `defaultValue` is returned in its place.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to get.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.get(object, 'a[0].b.c');
       * // => 3
       *
       * _.get(object, ['a', '0', 'b', 'c']);
       * // => 3
       *
       * _.get(object, 'a.b.c', 'default');
       * // => 'default'
       */
      function get(object, path, defaultValue) {
        var result = object == null ? undefined$1 : baseGet(object, path);
        return result === undefined$1 ? defaultValue : result;
      }

      /**
       * Checks if `path` is a direct property of `object`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = { 'a': { 'b': 2 } };
       * var other = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.has(object, 'a');
       * // => true
       *
       * _.has(object, 'a.b');
       * // => true
       *
       * _.has(object, ['a', 'b']);
       * // => true
       *
       * _.has(other, 'a');
       * // => false
       */
      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }

      /**
       * Checks if `path` is a direct or inherited property of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path to check.
       * @returns {boolean} Returns `true` if `path` exists, else `false`.
       * @example
       *
       * var object = _.create({ 'a': _.create({ 'b': 2 }) });
       *
       * _.hasIn(object, 'a');
       * // => true
       *
       * _.hasIn(object, 'a.b');
       * // => true
       *
       * _.hasIn(object, ['a', 'b']);
       * // => true
       *
       * _.hasIn(object, 'b');
       * // => false
       */
      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }

      /**
       * Creates an object composed of the inverted keys and values of `object`.
       * If `object` contains duplicate values, subsequent values overwrite
       * property assignments of previous values.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Object
       * @param {Object} object The object to invert.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invert(object);
       * // => { '1': 'c', '2': 'b' }
       */
      var invert = createInverter(function(result, value, key) {
        if (value != null &&
            typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }

        result[value] = key;
      }, constant(identity));

      /**
       * This method is like `_.invert` except that the inverted object is generated
       * from the results of running each element of `object` thru `iteratee`. The
       * corresponding inverted value of each inverted key is an array of keys
       * responsible for generating the inverted value. The iteratee is invoked
       * with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.1.0
       * @category Object
       * @param {Object} object The object to invert.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {Object} Returns the new inverted object.
       * @example
       *
       * var object = { 'a': 1, 'b': 2, 'c': 1 };
       *
       * _.invertBy(object);
       * // => { '1': ['a', 'c'], '2': ['b'] }
       *
       * _.invertBy(object, function(value) {
       *   return 'group' + value;
       * });
       * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
       */
      var invertBy = createInverter(function(result, value, key) {
        if (value != null &&
            typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }

        if (hasOwnProperty.call(result, value)) {
          result[value].push(key);
        } else {
          result[value] = [key];
        }
      }, getIteratee);

      /**
       * Invokes the method at `path` of `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {*} Returns the result of the invoked method.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
       *
       * _.invoke(object, 'a[0].b.c.slice', 1, 3);
       * // => [2, 3]
       */
      var invoke = baseRest(baseInvoke);

      /**
       * Creates an array of the own enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects. See the
       * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
       * for more details.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keys(new Foo);
       * // => ['a', 'b'] (iteration order is not guaranteed)
       *
       * _.keys('hi');
       * // => ['0', '1']
       */
      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      /**
       * Creates an array of the own and inherited enumerable property names of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property names.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.keysIn(new Foo);
       * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
       */
      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }

      /**
       * The opposite of `_.mapValues`; this method creates an object with the
       * same values as `object` and keys generated by running each own enumerable
       * string keyed property of `object` thru `iteratee`. The iteratee is invoked
       * with three arguments: (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 3.8.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapValues
       * @example
       *
       * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
       *   return key + value;
       * });
       * // => { 'a1': 1, 'b2': 2 }
       */
      function mapKeys(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);

        baseForOwn(object, function(value, key, object) {
          baseAssignValue(result, iteratee(value, key, object), value);
        });
        return result;
      }

      /**
       * Creates an object with the same keys as `object` and values generated
       * by running each own enumerable string keyed property of `object` thru
       * `iteratee`. The iteratee is invoked with three arguments:
       * (value, key, object).
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Object} Returns the new mapped object.
       * @see _.mapKeys
       * @example
       *
       * var users = {
       *   'fred':    { 'user': 'fred',    'age': 40 },
       *   'pebbles': { 'user': 'pebbles', 'age': 1 }
       * };
       *
       * _.mapValues(users, function(o) { return o.age; });
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       *
       * // The `_.property` iteratee shorthand.
       * _.mapValues(users, 'age');
       * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
       */
      function mapValues(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);

        baseForOwn(object, function(value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }

      /**
       * This method is like `_.assign` except that it recursively merges own and
       * inherited enumerable string keyed properties of source objects into the
       * destination object. Source properties that resolve to `undefined` are
       * skipped if a destination value exists. Array and plain object properties
       * are merged recursively. Other objects and value types are overridden by
       * assignment. Source objects are applied from left to right. Subsequent
       * sources overwrite property assignments of previous sources.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 0.5.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} [sources] The source objects.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {
       *   'a': [{ 'b': 2 }, { 'd': 4 }]
       * };
       *
       * var other = {
       *   'a': [{ 'c': 3 }, { 'e': 5 }]
       * };
       *
       * _.merge(object, other);
       * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
       */
      var merge = createAssigner(function(object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });

      /**
       * This method is like `_.merge` except that it accepts `customizer` which
       * is invoked to produce the merged values of the destination and source
       * properties. If `customizer` returns `undefined`, merging is handled by the
       * method instead. The `customizer` is invoked with six arguments:
       * (objValue, srcValue, key, object, source, stack).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The destination object.
       * @param {...Object} sources The source objects.
       * @param {Function} customizer The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * function customizer(objValue, srcValue) {
       *   if (_.isArray(objValue)) {
       *     return objValue.concat(srcValue);
       *   }
       * }
       *
       * var object = { 'a': [1], 'b': [2] };
       * var other = { 'a': [3], 'b': [4] };
       *
       * _.mergeWith(object, other, customizer);
       * // => { 'a': [1, 3], 'b': [2, 4] }
       */
      var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });

      /**
       * The opposite of `_.pick`; this method creates an object composed of the
       * own and inherited enumerable property paths of `object` that are not omitted.
       *
       * **Note:** This method is considerably slower than `_.pick`.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to omit.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omit(object, ['a', 'c']);
       * // => { 'b': '2' }
       */
      var omit = flatRest(function(object, paths) {
        var result = {};
        if (object == null) {
          return result;
        }
        var isDeep = false;
        paths = arrayMap(paths, function(path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);
        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }
        var length = paths.length;
        while (length--) {
          baseUnset(result, paths[length]);
        }
        return result;
      });

      /**
       * The opposite of `_.pickBy`; this method creates an object composed of
       * the own and inherited enumerable string keyed properties of `object` that
       * `predicate` doesn't return truthy for. The predicate is invoked with two
       * arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.omitBy(object, _.isNumber);
       * // => { 'b': '2' }
       */
      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }

      /**
       * Creates an object composed of the picked `object` properties.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The source object.
       * @param {...(string|string[])} [paths] The property paths to pick.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pick(object, ['a', 'c']);
       * // => { 'a': 1, 'c': 3 }
       */
      var pick = flatRest(function(object, paths) {
        return object == null ? {} : basePick(object, paths);
      });

      /**
       * Creates an object composed of the `object` properties `predicate` returns
       * truthy for. The predicate is invoked with two arguments: (value, key).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The source object.
       * @param {Function} [predicate=_.identity] The function invoked per property.
       * @returns {Object} Returns the new object.
       * @example
       *
       * var object = { 'a': 1, 'b': '2', 'c': 3 };
       *
       * _.pickBy(object, _.isNumber);
       * // => { 'a': 1, 'c': 3 }
       */
      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }
        var props = arrayMap(getAllKeysIn(object), function(prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function(value, path) {
          return predicate(value, path[0]);
        });
      }

      /**
       * This method is like `_.get` except that if the resolved value is a
       * function it's invoked with the `this` binding of its parent object and
       * its result is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @param {Array|string} path The path of the property to resolve.
       * @param {*} [defaultValue] The value returned for `undefined` resolved values.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
       *
       * _.result(object, 'a[0].b.c1');
       * // => 3
       *
       * _.result(object, 'a[0].b.c2');
       * // => 4
       *
       * _.result(object, 'a[0].b.c3', 'default');
       * // => 'default'
       *
       * _.result(object, 'a[0].b.c3', _.constant('default'));
       * // => 'default'
       */
      function result(object, path, defaultValue) {
        path = castPath(path, object);

        var index = -1,
            length = path.length;

        // Ensure the loop is entered when path is empty.
        if (!length) {
          length = 1;
          object = undefined$1;
        }
        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];
          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }
          object = isFunction(value) ? value.call(object) : value;
        }
        return object;
      }

      /**
       * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
       * it's created. Arrays are created for missing index properties while objects
       * are created for all other missing properties. Use `_.setWith` to customize
       * `path` creation.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.set(object, 'a[0].b.c', 4);
       * console.log(object.a[0].b.c);
       * // => 4
       *
       * _.set(object, ['x', '0', 'y', 'z'], 5);
       * console.log(object.x[0].y.z);
       * // => 5
       */
      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }

      /**
       * This method is like `_.set` except that it accepts `customizer` which is
       * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
       * path creation is handled by the method instead. The `customizer` is invoked
       * with three arguments: (nsValue, key, nsObject).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {*} value The value to set.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {};
       *
       * _.setWith(object, '[0][1]', 'a', Object);
       * // => { '0': { '1': 'a' } }
       */
      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }

      /**
       * Creates an array of own enumerable string keyed-value pairs for `object`
       * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
       * entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entries
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairs(new Foo);
       * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
       */
      var toPairs = createToPairs(keys);

      /**
       * Creates an array of own and inherited enumerable string keyed-value pairs
       * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
       * or set, its entries are returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @alias entriesIn
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the key-value pairs.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.toPairsIn(new Foo);
       * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
       */
      var toPairsIn = createToPairs(keysIn);

      /**
       * An alternative to `_.reduce`; this method transforms `object` to a new
       * `accumulator` object which is the result of running each of its own
       * enumerable string keyed properties thru `iteratee`, with each invocation
       * potentially mutating the `accumulator` object. If `accumulator` is not
       * provided, a new object with the same `[[Prototype]]` will be used. The
       * iteratee is invoked with four arguments: (accumulator, value, key, object).
       * Iteratee functions may exit iteration early by explicitly returning `false`.
       *
       * @static
       * @memberOf _
       * @since 1.3.0
       * @category Object
       * @param {Object} object The object to iterate over.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @param {*} [accumulator] The custom accumulator value.
       * @returns {*} Returns the accumulated value.
       * @example
       *
       * _.transform([2, 3, 4], function(result, n) {
       *   result.push(n *= n);
       *   return n % 2 == 0;
       * }, []);
       * // => [4, 9]
       *
       * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
       *   (result[value] || (result[value] = [])).push(key);
       * }, {});
       * // => { '1': ['a', 'c'], '2': ['b'] }
       */
      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object),
            isArrLike = isArr || isBuffer(object) || isTypedArray(object);

        iteratee = getIteratee(iteratee, 4);
        if (accumulator == null) {
          var Ctor = object && object.constructor;
          if (isArrLike) {
            accumulator = isArr ? new Ctor : [];
          }
          else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          }
          else {
            accumulator = {};
          }
        }
        (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
          return iteratee(accumulator, value, index, object);
        });
        return accumulator;
      }

      /**
       * Removes the property at `path` of `object`.
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to unset.
       * @returns {boolean} Returns `true` if the property is deleted, else `false`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 7 } }] };
       * _.unset(object, 'a[0].b.c');
       * // => true
       *
       * console.log(object);
       * // => { 'a': [{ 'b': {} }] };
       *
       * _.unset(object, ['a', '0', 'b', 'c']);
       * // => true
       *
       * console.log(object);
       * // => { 'a': [{ 'b': {} }] };
       */
      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }

      /**
       * This method is like `_.set` except that accepts `updater` to produce the
       * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
       * is invoked with one argument: (value).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {Function} updater The function to produce the updated value.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = { 'a': [{ 'b': { 'c': 3 } }] };
       *
       * _.update(object, 'a[0].b.c', function(n) { return n * n; });
       * console.log(object.a[0].b.c);
       * // => 9
       *
       * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
       * console.log(object.x[0].y.z);
       * // => 0
       */
      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }

      /**
       * This method is like `_.update` except that it accepts `customizer` which is
       * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
       * path creation is handled by the method instead. The `customizer` is invoked
       * with three arguments: (nsValue, key, nsObject).
       *
       * **Note:** This method mutates `object`.
       *
       * @static
       * @memberOf _
       * @since 4.6.0
       * @category Object
       * @param {Object} object The object to modify.
       * @param {Array|string} path The path of the property to set.
       * @param {Function} updater The function to produce the updated value.
       * @param {Function} [customizer] The function to customize assigned values.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var object = {};
       *
       * _.updateWith(object, '[0][1]', _.constant('a'), Object);
       * // => { '0': { '1': 'a' } }
       */
      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }

      /**
       * Creates an array of the own enumerable string keyed property values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.values(new Foo);
       * // => [1, 2] (iteration order is not guaranteed)
       *
       * _.values('hi');
       * // => ['h', 'i']
       */
      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }

      /**
       * Creates an array of the own and inherited enumerable string keyed property
       * values of `object`.
       *
       * **Note:** Non-object values are coerced to objects.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Object
       * @param {Object} object The object to query.
       * @returns {Array} Returns the array of property values.
       * @example
       *
       * function Foo() {
       *   this.a = 1;
       *   this.b = 2;
       * }
       *
       * Foo.prototype.c = 3;
       *
       * _.valuesIn(new Foo);
       * // => [1, 2, 3] (iteration order is not guaranteed)
       */
      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }

      /*------------------------------------------------------------------------*/

      /**
       * Clamps `number` within the inclusive `lower` and `upper` bounds.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Number
       * @param {number} number The number to clamp.
       * @param {number} [lower] The lower bound.
       * @param {number} upper The upper bound.
       * @returns {number} Returns the clamped number.
       * @example
       *
       * _.clamp(-10, -5, 5);
       * // => -5
       *
       * _.clamp(10, -5, 5);
       * // => 5
       */
      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }
        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }
        return baseClamp(toNumber(number), lower, upper);
      }

      /**
       * Checks if `n` is between `start` and up to, but not including, `end`. If
       * `end` is not specified, it's set to `start` with `start` then set to `0`.
       * If `start` is greater than `end` the params are swapped to support
       * negative ranges.
       *
       * @static
       * @memberOf _
       * @since 3.3.0
       * @category Number
       * @param {number} number The number to check.
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
       * @see _.range, _.rangeRight
       * @example
       *
       * _.inRange(3, 2, 4);
       * // => true
       *
       * _.inRange(4, 8);
       * // => true
       *
       * _.inRange(4, 2);
       * // => false
       *
       * _.inRange(2, 2);
       * // => false
       *
       * _.inRange(1.2, 2);
       * // => true
       *
       * _.inRange(5.2, 4);
       * // => false
       *
       * _.inRange(-3, -2, -6);
       * // => true
       */
      function inRange(number, start, end) {
        start = toFinite(start);
        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        number = toNumber(number);
        return baseInRange(number, start, end);
      }

      /**
       * Produces a random number between the inclusive `lower` and `upper` bounds.
       * If only one argument is provided a number between `0` and the given number
       * is returned. If `floating` is `true`, or either `lower` or `upper` are
       * floats, a floating-point number is returned instead of an integer.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @memberOf _
       * @since 0.7.0
       * @category Number
       * @param {number} [lower=0] The lower bound.
       * @param {number} [upper=1] The upper bound.
       * @param {boolean} [floating] Specify returning a floating-point number.
       * @returns {number} Returns the random number.
       * @example
       *
       * _.random(0, 5);
       * // => an integer between 0 and 5
       *
       * _.random(5);
       * // => also an integer between 0 and 5
       *
       * _.random(5, true);
       * // => a floating-point number between 0 and 5
       *
       * _.random(1.2, 5.2);
       * // => a floating-point number between 1.2 and 5.2
       */
      function random(lower, upper, floating) {
        if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }
        if (floating === undefined$1) {
          if (typeof upper == 'boolean') {
            floating = upper;
            upper = undefined$1;
          }
          else if (typeof lower == 'boolean') {
            floating = lower;
            lower = undefined$1;
          }
        }
        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        }
        else {
          lower = toFinite(lower);
          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }
        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }
        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
        }
        return baseRandom(lower, upper);
      }

      /*------------------------------------------------------------------------*/

      /**
       * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the camel cased string.
       * @example
       *
       * _.camelCase('Foo Bar');
       * // => 'fooBar'
       *
       * _.camelCase('--foo-bar--');
       * // => 'fooBar'
       *
       * _.camelCase('__FOO_BAR__');
       * // => 'fooBar'
       */
      var camelCase = createCompounder(function(result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });

      /**
       * Converts the first character of `string` to upper case and the remaining
       * to lower case.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to capitalize.
       * @returns {string} Returns the capitalized string.
       * @example
       *
       * _.capitalize('FRED');
       * // => 'Fred'
       */
      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }

      /**
       * Deburrs `string` by converting
       * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
       * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
       * letters to basic Latin letters and removing
       * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to deburr.
       * @returns {string} Returns the deburred string.
       * @example
       *
       * _.deburr('déjà vu');
       * // => 'deja vu'
       */
      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
      }

      /**
       * Checks if `string` ends with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=string.length] The position to search up to.
       * @returns {boolean} Returns `true` if `string` ends with `target`,
       *  else `false`.
       * @example
       *
       * _.endsWith('abc', 'c');
       * // => true
       *
       * _.endsWith('abc', 'b');
       * // => false
       *
       * _.endsWith('abc', 'b', 2);
       * // => true
       */
      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);

        var length = string.length;
        position = position === undefined$1
          ? length
          : baseClamp(toInteger(position), 0, length);

        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }

      /**
       * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
       * corresponding HTML entities.
       *
       * **Note:** No other characters are escaped. To escape additional
       * characters use a third-party library like [_he_](https://mths.be/he).
       *
       * Though the ">" character is escaped for symmetry, characters like
       * ">" and "/" don't need escaping in HTML and have no special meaning
       * unless they're part of a tag or unquoted attribute value. See
       * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
       * (under "semi-related fun fact") for more details.
       *
       * When working with HTML you should always
       * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
       * XSS vectors.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category String
       * @param {string} [string=''] The string to escape.
       * @returns {string} Returns the escaped string.
       * @example
       *
       * _.escape('fred, barney, & pebbles');
       * // => 'fred, barney, &amp; pebbles'
       */
      function escape(string) {
        string = toString(string);
        return (string && reHasUnescapedHtml.test(string))
          ? string.replace(reUnescapedHtml, escapeHtmlChar)
          : string;
      }

      /**
       * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
       * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to escape.
       * @returns {string} Returns the escaped string.
       * @example
       *
       * _.escapeRegExp('[lodash](https://lodash.com/)');
       * // => '\[lodash\]\(https://lodash\.com/\)'
       */
      function escapeRegExp(string) {
        string = toString(string);
        return (string && reHasRegExpChar.test(string))
          ? string.replace(reRegExpChar, '\\$&')
          : string;
      }

      /**
       * Converts `string` to
       * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the kebab cased string.
       * @example
       *
       * _.kebabCase('Foo Bar');
       * // => 'foo-bar'
       *
       * _.kebabCase('fooBar');
       * // => 'foo-bar'
       *
       * _.kebabCase('__FOO_BAR__');
       * // => 'foo-bar'
       */
      var kebabCase = createCompounder(function(result, word, index) {
        return result + (index ? '-' : '') + word.toLowerCase();
      });

      /**
       * Converts `string`, as space separated words, to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.lowerCase('--Foo-Bar--');
       * // => 'foo bar'
       *
       * _.lowerCase('fooBar');
       * // => 'foo bar'
       *
       * _.lowerCase('__FOO_BAR__');
       * // => 'foo bar'
       */
      var lowerCase = createCompounder(function(result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
      });

      /**
       * Converts the first character of `string` to lower case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.lowerFirst('Fred');
       * // => 'fred'
       *
       * _.lowerFirst('FRED');
       * // => 'fRED'
       */
      var lowerFirst = createCaseFirst('toLowerCase');

      /**
       * Pads `string` on the left and right sides if it's shorter than `length`.
       * Padding characters are truncated if they can't be evenly divided by `length`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.pad('abc', 8);
       * // => '  abc   '
       *
       * _.pad('abc', 8, '_-');
       * // => '_-abc_-_'
       *
       * _.pad('abc', 3);
       * // => 'abc'
       */
      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);

        var strLength = length ? stringSize(string) : 0;
        if (!length || strLength >= length) {
          return string;
        }
        var mid = (length - strLength) / 2;
        return (
          createPadding(nativeFloor(mid), chars) +
          string +
          createPadding(nativeCeil(mid), chars)
        );
      }

      /**
       * Pads `string` on the right side if it's shorter than `length`. Padding
       * characters are truncated if they exceed `length`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.padEnd('abc', 6);
       * // => 'abc   '
       *
       * _.padEnd('abc', 6, '_-');
       * // => 'abc_-_'
       *
       * _.padEnd('abc', 3);
       * // => 'abc'
       */
      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);

        var strLength = length ? stringSize(string) : 0;
        return (length && strLength < length)
          ? (string + createPadding(length - strLength, chars))
          : string;
      }

      /**
       * Pads `string` on the left side if it's shorter than `length`. Padding
       * characters are truncated if they exceed `length`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to pad.
       * @param {number} [length=0] The padding length.
       * @param {string} [chars=' '] The string used as padding.
       * @returns {string} Returns the padded string.
       * @example
       *
       * _.padStart('abc', 6);
       * // => '   abc'
       *
       * _.padStart('abc', 6, '_-');
       * // => '_-_abc'
       *
       * _.padStart('abc', 3);
       * // => 'abc'
       */
      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);

        var strLength = length ? stringSize(string) : 0;
        return (length && strLength < length)
          ? (createPadding(length - strLength, chars) + string)
          : string;
      }

      /**
       * Converts `string` to an integer of the specified radix. If `radix` is
       * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
       * hexadecimal, in which case a `radix` of `16` is used.
       *
       * **Note:** This method aligns with the
       * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
       *
       * @static
       * @memberOf _
       * @since 1.1.0
       * @category String
       * @param {string} string The string to convert.
       * @param {number} [radix=10] The radix to interpret `value` by.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {number} Returns the converted integer.
       * @example
       *
       * _.parseInt('08');
       * // => 8
       *
       * _.map(['6', '08', '10'], _.parseInt);
       * // => [6, 8, 10]
       */
      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }
        return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
      }

      /**
       * Repeats the given string `n` times.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to repeat.
       * @param {number} [n=1] The number of times to repeat the string.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the repeated string.
       * @example
       *
       * _.repeat('*', 3);
       * // => '***'
       *
       * _.repeat('abc', 2);
       * // => 'abcabc'
       *
       * _.repeat('abc', 0);
       * // => ''
       */
      function repeat(string, n, guard) {
        if ((guard ? isIterateeCall(string, n, guard) : n === undefined$1)) {
          n = 1;
        } else {
          n = toInteger(n);
        }
        return baseRepeat(toString(string), n);
      }

      /**
       * Replaces matches for `pattern` in `string` with `replacement`.
       *
       * **Note:** This method is based on
       * [`String#replace`](https://mdn.io/String/replace).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to modify.
       * @param {RegExp|string} pattern The pattern to replace.
       * @param {Function|string} replacement The match replacement.
       * @returns {string} Returns the modified string.
       * @example
       *
       * _.replace('Hi Fred', 'Fred', 'Barney');
       * // => 'Hi Barney'
       */
      function replace() {
        var args = arguments,
            string = toString(args[0]);

        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }

      /**
       * Converts `string` to
       * [snake case](https://en.wikipedia.org/wiki/Snake_case).
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the snake cased string.
       * @example
       *
       * _.snakeCase('Foo Bar');
       * // => 'foo_bar'
       *
       * _.snakeCase('fooBar');
       * // => 'foo_bar'
       *
       * _.snakeCase('--FOO-BAR--');
       * // => 'foo_bar'
       */
      var snakeCase = createCompounder(function(result, word, index) {
        return result + (index ? '_' : '') + word.toLowerCase();
      });

      /**
       * Splits `string` by `separator`.
       *
       * **Note:** This method is based on
       * [`String#split`](https://mdn.io/String/split).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to split.
       * @param {RegExp|string} separator The separator pattern to split by.
       * @param {number} [limit] The length to truncate results to.
       * @returns {Array} Returns the string segments.
       * @example
       *
       * _.split('a-b-c', '-', 2);
       * // => ['a', 'b']
       */
      function split(string, separator, limit) {
        if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }
        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;
        if (!limit) {
          return [];
        }
        string = toString(string);
        if (string && (
              typeof separator == 'string' ||
              (separator != null && !isRegExp(separator))
            )) {
          separator = baseToString(separator);
          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }
        return string.split(separator, limit);
      }

      /**
       * Converts `string` to
       * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
       *
       * @static
       * @memberOf _
       * @since 3.1.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the start cased string.
       * @example
       *
       * _.startCase('--foo-bar--');
       * // => 'Foo Bar'
       *
       * _.startCase('fooBar');
       * // => 'Foo Bar'
       *
       * _.startCase('__FOO_BAR__');
       * // => 'FOO BAR'
       */
      var startCase = createCompounder(function(result, word, index) {
        return result + (index ? ' ' : '') + upperFirst(word);
      });

      /**
       * Checks if `string` starts with the given target string.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {string} [target] The string to search for.
       * @param {number} [position=0] The position to search from.
       * @returns {boolean} Returns `true` if `string` starts with `target`,
       *  else `false`.
       * @example
       *
       * _.startsWith('abc', 'a');
       * // => true
       *
       * _.startsWith('abc', 'b');
       * // => false
       *
       * _.startsWith('abc', 'b', 1);
       * // => true
       */
      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null
          ? 0
          : baseClamp(toInteger(position), 0, string.length);

        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }

      /**
       * Creates a compiled template function that can interpolate data properties
       * in "interpolate" delimiters, HTML-escape interpolated data properties in
       * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
       * properties may be accessed as free variables in the template. If a setting
       * object is given, it takes precedence over `_.templateSettings` values.
       *
       * **Note:** In the development build `_.template` utilizes
       * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
       * for easier debugging.
       *
       * For more information on precompiling templates see
       * [lodash's custom builds documentation](https://lodash.com/custom-builds).
       *
       * For more information on Chrome extension sandboxes see
       * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category String
       * @param {string} [string=''] The template string.
       * @param {Object} [options={}] The options object.
       * @param {RegExp} [options.escape=_.templateSettings.escape]
       *  The HTML "escape" delimiter.
       * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
       *  The "evaluate" delimiter.
       * @param {Object} [options.imports=_.templateSettings.imports]
       *  An object to import into the template as free variables.
       * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
       *  The "interpolate" delimiter.
       * @param {string} [options.sourceURL='lodash.templateSources[n]']
       *  The sourceURL of the compiled template.
       * @param {string} [options.variable='obj']
       *  The data object variable name.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Function} Returns the compiled template function.
       * @example
       *
       * // Use the "interpolate" delimiter to create a compiled template.
       * var compiled = _.template('hello <%= user %>!');
       * compiled({ 'user': 'fred' });
       * // => 'hello fred!'
       *
       * // Use the HTML "escape" delimiter to escape data property values.
       * var compiled = _.template('<b><%- value %></b>');
       * compiled({ 'value': '<script>' });
       * // => '<b>&lt;script&gt;</b>'
       *
       * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
       * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
       * compiled({ 'users': ['fred', 'barney'] });
       * // => '<li>fred</li><li>barney</li>'
       *
       * // Use the internal `print` function in "evaluate" delimiters.
       * var compiled = _.template('<% print("hello " + user); %>!');
       * compiled({ 'user': 'barney' });
       * // => 'hello barney!'
       *
       * // Use the ES template literal delimiter as an "interpolate" delimiter.
       * // Disable support by replacing the "interpolate" delimiter.
       * var compiled = _.template('hello ${ user }!');
       * compiled({ 'user': 'pebbles' });
       * // => 'hello pebbles!'
       *
       * // Use backslashes to treat delimiters as plain text.
       * var compiled = _.template('<%= "\\<%- value %\\>" %>');
       * compiled({ 'value': 'ignored' });
       * // => '<%- value %>'
       *
       * // Use the `imports` option to import `jQuery` as `jq`.
       * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
       * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
       * compiled({ 'users': ['fred', 'barney'] });
       * // => '<li>fred</li><li>barney</li>'
       *
       * // Use the `sourceURL` option to specify a custom sourceURL for the template.
       * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
       * compiled(data);
       * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
       *
       * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
       * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
       * compiled.source;
       * // => function(data) {
       * //   var __t, __p = '';
       * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
       * //   return __p;
       * // }
       *
       * // Use custom template delimiters.
       * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
       * var compiled = _.template('hello {{ user }}!');
       * compiled({ 'user': 'mustache' });
       * // => 'hello mustache!'
       *
       * // Use the `source` property to inline compiled templates for meaningful
       * // line numbers in error messages and stack traces.
       * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
       *   var JST = {\
       *     "main": ' + _.template(mainText).source + '\
       *   };\
       * ');
       */
      function template(string, options, guard) {
        // Based on John Resig's `tmpl` implementation
        // (http://ejohn.org/blog/javascript-micro-templating/)
        // and Laura Doktorova's doT.js (https://github.com/olado/doT).
        var settings = lodash.templateSettings;

        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }
        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);

        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
            importsKeys = keys(imports),
            importsValues = baseValues(imports, importsKeys);

        var isEscaping,
            isEvaluating,
            index = 0,
            interpolate = options.interpolate || reNoMatch,
            source = "__p += '";

        // Compile the regexp to match each delimiter.
        var reDelimiters = RegExp(
          (options.escape || reNoMatch).source + '|' +
          interpolate.source + '|' +
          (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
          (options.evaluate || reNoMatch).source + '|$'
        , 'g');

        // Use a sourceURL for easier debugging.
        // The sourceURL gets injected into the source that's eval-ed, so be careful
        // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
        // and escape the comment, thus injecting code that gets evaled.
        var sourceURL = '//# sourceURL=' +
          (hasOwnProperty.call(options, 'sourceURL')
            ? (options.sourceURL + '').replace(/\s/g, ' ')
            : ('lodash.templateSources[' + (++templateCounter) + ']')
          ) + '\n';

        string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);

          // Escape characters that can't be included in string literals.
          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

          // Replace delimiters with snippets.
          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }
          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }
          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }
          index = offset + match.length;

          // The JS engine embedded in Adobe products needs `match` returned in
          // order to produce the correct `offset` value.
          return match;
        });

        source += "';\n";

        // If `variable` is not specified wrap a with-statement around the generated
        // code to add the data object to the top of the scope chain.
        var variable = hasOwnProperty.call(options, 'variable') && options.variable;
        if (!variable) {
          source = 'with (obj) {\n' + source + '\n}\n';
        }
        // Cleanup code by stripping empty strings.
        source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
          .replace(reEmptyStringMiddle, '$1')
          .replace(reEmptyStringTrailing, '$1;');

        // Frame code as the function body.
        source = 'function(' + (variable || 'obj') + ') {\n' +
          (variable
            ? ''
            : 'obj || (obj = {});\n'
          ) +
          "var __t, __p = ''" +
          (isEscaping
             ? ', __e = _.escape'
             : ''
          ) +
          (isEvaluating
            ? ', __j = Array.prototype.join;\n' +
              "function print() { __p += __j.call(arguments, '') }\n"
            : ';\n'
          ) +
          source +
          'return __p\n}';

        var result = attempt(function() {
          return Function(importsKeys, sourceURL + 'return ' + source)
            .apply(undefined$1, importsValues);
        });

        // Provide the compiled function's source by its `toString` method or
        // the `source` property as a convenience for inlining compiled templates.
        result.source = source;
        if (isError(result)) {
          throw result;
        }
        return result;
      }

      /**
       * Converts `string`, as a whole, to lower case just like
       * [String#toLowerCase](https://mdn.io/toLowerCase).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the lower cased string.
       * @example
       *
       * _.toLower('--Foo-Bar--');
       * // => '--foo-bar--'
       *
       * _.toLower('fooBar');
       * // => 'foobar'
       *
       * _.toLower('__FOO_BAR__');
       * // => '__foo_bar__'
       */
      function toLower(value) {
        return toString(value).toLowerCase();
      }

      /**
       * Converts `string`, as a whole, to upper case just like
       * [String#toUpperCase](https://mdn.io/toUpperCase).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the upper cased string.
       * @example
       *
       * _.toUpper('--foo-bar--');
       * // => '--FOO-BAR--'
       *
       * _.toUpper('fooBar');
       * // => 'FOOBAR'
       *
       * _.toUpper('__foo_bar__');
       * // => '__FOO_BAR__'
       */
      function toUpper(value) {
        return toString(value).toUpperCase();
      }

      /**
       * Removes leading and trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trim('  abc  ');
       * // => 'abc'
       *
       * _.trim('-_-abc-_-', '_-');
       * // => 'abc'
       *
       * _.map(['  foo  ', '  bar  '], _.trim);
       * // => ['foo', 'bar']
       */
      function trim(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrim, '');
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
            chrSymbols = stringToArray(chars),
            start = charsStartIndex(strSymbols, chrSymbols),
            end = charsEndIndex(strSymbols, chrSymbols) + 1;

        return castSlice(strSymbols, start, end).join('');
      }

      /**
       * Removes trailing whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trimEnd('  abc  ');
       * // => '  abc'
       *
       * _.trimEnd('-_-abc-_-', '_-');
       * // => '-_-abc'
       */
      function trimEnd(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimEnd, '');
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
            end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

        return castSlice(strSymbols, 0, end).join('');
      }

      /**
       * Removes leading whitespace or specified characters from `string`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to trim.
       * @param {string} [chars=whitespace] The characters to trim.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {string} Returns the trimmed string.
       * @example
       *
       * _.trimStart('  abc  ');
       * // => 'abc  '
       *
       * _.trimStart('-_-abc-_-', '_-');
       * // => 'abc-_-'
       */
      function trimStart(string, chars, guard) {
        string = toString(string);
        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, '');
        }
        if (!string || !(chars = baseToString(chars))) {
          return string;
        }
        var strSymbols = stringToArray(string),
            start = charsStartIndex(strSymbols, stringToArray(chars));

        return castSlice(strSymbols, start).join('');
      }

      /**
       * Truncates `string` if it's longer than the given maximum string length.
       * The last characters of the truncated string are replaced with the omission
       * string which defaults to "...".
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to truncate.
       * @param {Object} [options={}] The options object.
       * @param {number} [options.length=30] The maximum string length.
       * @param {string} [options.omission='...'] The string to indicate text is omitted.
       * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
       * @returns {string} Returns the truncated string.
       * @example
       *
       * _.truncate('hi-diddly-ho there, neighborino');
       * // => 'hi-diddly-ho there, neighbo...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'length': 24,
       *   'separator': ' '
       * });
       * // => 'hi-diddly-ho there,...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'length': 24,
       *   'separator': /,? +/
       * });
       * // => 'hi-diddly-ho there...'
       *
       * _.truncate('hi-diddly-ho there, neighborino', {
       *   'omission': ' [...]'
       * });
       * // => 'hi-diddly-ho there, neig [...]'
       */
      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH,
            omission = DEFAULT_TRUNC_OMISSION;

        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? toInteger(options.length) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        }
        string = toString(string);

        var strLength = string.length;
        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }
        if (length >= strLength) {
          return string;
        }
        var end = length - stringSize(omission);
        if (end < 1) {
          return omission;
        }
        var result = strSymbols
          ? castSlice(strSymbols, 0, end).join('')
          : string.slice(0, end);

        if (separator === undefined$1) {
          return result + omission;
        }
        if (strSymbols) {
          end += (result.length - end);
        }
        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match,
                substring = result;

            if (!separator.global) {
              separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            }
            separator.lastIndex = 0;
            while ((match = separator.exec(substring))) {
              var newEnd = match.index;
            }
            result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result.lastIndexOf(separator);
          if (index > -1) {
            result = result.slice(0, index);
          }
        }
        return result + omission;
      }

      /**
       * The inverse of `_.escape`; this method converts the HTML entities
       * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
       * their corresponding characters.
       *
       * **Note:** No other HTML entities are unescaped. To unescape additional
       * HTML entities use a third-party library like [_he_](https://mths.be/he).
       *
       * @static
       * @memberOf _
       * @since 0.6.0
       * @category String
       * @param {string} [string=''] The string to unescape.
       * @returns {string} Returns the unescaped string.
       * @example
       *
       * _.unescape('fred, barney, &amp; pebbles');
       * // => 'fred, barney, & pebbles'
       */
      function unescape(string) {
        string = toString(string);
        return (string && reHasEscapedHtml.test(string))
          ? string.replace(reEscapedHtml, unescapeHtmlChar)
          : string;
      }

      /**
       * Converts `string`, as space separated words, to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the upper cased string.
       * @example
       *
       * _.upperCase('--foo-bar');
       * // => 'FOO BAR'
       *
       * _.upperCase('fooBar');
       * // => 'FOO BAR'
       *
       * _.upperCase('__foo_bar__');
       * // => 'FOO BAR'
       */
      var upperCase = createCompounder(function(result, word, index) {
        return result + (index ? ' ' : '') + word.toUpperCase();
      });

      /**
       * Converts the first character of `string` to upper case.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category String
       * @param {string} [string=''] The string to convert.
       * @returns {string} Returns the converted string.
       * @example
       *
       * _.upperFirst('fred');
       * // => 'Fred'
       *
       * _.upperFirst('FRED');
       * // => 'FRED'
       */
      var upperFirst = createCaseFirst('toUpperCase');

      /**
       * Splits `string` into an array of its words.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category String
       * @param {string} [string=''] The string to inspect.
       * @param {RegExp|string} [pattern] The pattern to match words.
       * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
       * @returns {Array} Returns the words of `string`.
       * @example
       *
       * _.words('fred, barney, & pebbles');
       * // => ['fred', 'barney', 'pebbles']
       *
       * _.words('fred, barney, & pebbles', /[^, ]+/g);
       * // => ['fred', 'barney', '&', 'pebbles']
       */
      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;

        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }
        return string.match(pattern) || [];
      }

      /*------------------------------------------------------------------------*/

      /**
       * Attempts to invoke `func`, returning either the result or the caught error
       * object. Any additional arguments are provided to `func` when it's invoked.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Function} func The function to attempt.
       * @param {...*} [args] The arguments to invoke `func` with.
       * @returns {*} Returns the `func` result or error object.
       * @example
       *
       * // Avoid throwing errors for invalid selectors.
       * var elements = _.attempt(function(selector) {
       *   return document.querySelectorAll(selector);
       * }, '>_>');
       *
       * if (_.isError(elements)) {
       *   elements = [];
       * }
       */
      var attempt = baseRest(function(func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error(e);
        }
      });

      /**
       * Binds methods of an object to the object itself, overwriting the existing
       * method.
       *
       * **Note:** This method doesn't set the "length" property of bound functions.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Object} object The object to bind and assign the bound methods to.
       * @param {...(string|string[])} methodNames The object method names to bind.
       * @returns {Object} Returns `object`.
       * @example
       *
       * var view = {
       *   'label': 'docs',
       *   'click': function() {
       *     console.log('clicked ' + this.label);
       *   }
       * };
       *
       * _.bindAll(view, ['click']);
       * jQuery(element).on('click', view.click);
       * // => Logs 'clicked docs' when clicked.
       */
      var bindAll = flatRest(function(object, methodNames) {
        arrayEach(methodNames, function(key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });

      /**
       * Creates a function that iterates over `pairs` and invokes the corresponding
       * function of the first predicate to return truthy. The predicate-function
       * pairs are invoked with the `this` binding and arguments of the created
       * function.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Array} pairs The predicate-function pairs.
       * @returns {Function} Returns the new composite function.
       * @example
       *
       * var func = _.cond([
       *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
       *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
       *   [_.stubTrue,                      _.constant('no match')]
       * ]);
       *
       * func({ 'a': 1, 'b': 2 });
       * // => 'matches A'
       *
       * func({ 'a': 0, 'b': 1 });
       * // => 'matches B'
       *
       * func({ 'a': '1', 'b': '2' });
       * // => 'no match'
       */
      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length,
            toIteratee = getIteratee();

        pairs = !length ? [] : arrayMap(pairs, function(pair) {
          if (typeof pair[1] != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          return [toIteratee(pair[0]), pair[1]];
        });

        return baseRest(function(args) {
          var index = -1;
          while (++index < length) {
            var pair = pairs[index];
            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }

      /**
       * Creates a function that invokes the predicate properties of `source` with
       * the corresponding property values of a given object, returning `true` if
       * all predicates return truthy, else `false`.
       *
       * **Note:** The created function is equivalent to `_.conformsTo` with
       * `source` partially applied.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {Object} source The object of property predicates to conform to.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 2, 'b': 1 },
       *   { 'a': 1, 'b': 2 }
       * ];
       *
       * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
       * // => [{ 'a': 1, 'b': 2 }]
       */
      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that returns `value`.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {*} value The value to return from the new function.
       * @returns {Function} Returns the new constant function.
       * @example
       *
       * var objects = _.times(2, _.constant({ 'a': 1 }));
       *
       * console.log(objects);
       * // => [{ 'a': 1 }, { 'a': 1 }]
       *
       * console.log(objects[0] === objects[1]);
       * // => true
       */
      function constant(value) {
        return function() {
          return value;
        };
      }

      /**
       * Checks `value` to determine whether a default value should be returned in
       * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
       * or `undefined`.
       *
       * @static
       * @memberOf _
       * @since 4.14.0
       * @category Util
       * @param {*} value The value to check.
       * @param {*} defaultValue The default value.
       * @returns {*} Returns the resolved value.
       * @example
       *
       * _.defaultTo(1, 10);
       * // => 1
       *
       * _.defaultTo(undefined, 10);
       * // => 10
       */
      function defaultTo(value, defaultValue) {
        return (value == null || value !== value) ? defaultValue : value;
      }

      /**
       * Creates a function that returns the result of invoking the given functions
       * with the `this` binding of the created function, where each successive
       * invocation is supplied the return value of the previous.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {...(Function|Function[])} [funcs] The functions to invoke.
       * @returns {Function} Returns the new composite function.
       * @see _.flowRight
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var addSquare = _.flow([_.add, square]);
       * addSquare(1, 2);
       * // => 9
       */
      var flow = createFlow();

      /**
       * This method is like `_.flow` except that it creates a function that
       * invokes the given functions from right to left.
       *
       * @static
       * @since 3.0.0
       * @memberOf _
       * @category Util
       * @param {...(Function|Function[])} [funcs] The functions to invoke.
       * @returns {Function} Returns the new composite function.
       * @see _.flow
       * @example
       *
       * function square(n) {
       *   return n * n;
       * }
       *
       * var addSquare = _.flowRight([square, _.add]);
       * addSquare(1, 2);
       * // => 9
       */
      var flowRight = createFlow(true);

      /**
       * This method returns the first argument it receives.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {*} value Any value.
       * @returns {*} Returns `value`.
       * @example
       *
       * var object = { 'a': 1 };
       *
       * console.log(_.identity(object) === object);
       * // => true
       */
      function identity(value) {
        return value;
      }

      /**
       * Creates a function that invokes `func` with the arguments of the created
       * function. If `func` is a property name, the created function returns the
       * property value for a given element. If `func` is an array or object, the
       * created function returns `true` for elements that contain the equivalent
       * source properties, otherwise it returns `false`.
       *
       * @static
       * @since 4.0.0
       * @memberOf _
       * @category Util
       * @param {*} [func=_.identity] The value to convert to a callback.
       * @returns {Function} Returns the callback.
       * @example
       *
       * var users = [
       *   { 'user': 'barney', 'age': 36, 'active': true },
       *   { 'user': 'fred',   'age': 40, 'active': false }
       * ];
       *
       * // The `_.matches` iteratee shorthand.
       * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
       * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
       *
       * // The `_.matchesProperty` iteratee shorthand.
       * _.filter(users, _.iteratee(['user', 'fred']));
       * // => [{ 'user': 'fred', 'age': 40 }]
       *
       * // The `_.property` iteratee shorthand.
       * _.map(users, _.iteratee('user'));
       * // => ['barney', 'fred']
       *
       * // Create custom iteratee shorthands.
       * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
       *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
       *     return func.test(string);
       *   };
       * });
       *
       * _.filter(['abc', 'def'], /ef/);
       * // => ['def']
       */
      function iteratee(func) {
        return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that performs a partial deep comparison between a given
       * object and `source`, returning `true` if the given object has equivalent
       * property values, else `false`.
       *
       * **Note:** The created function is equivalent to `_.isMatch` with `source`
       * partially applied.
       *
       * Partial comparisons will match empty array and empty object `source`
       * values against any array or object value, respectively. See `_.isEqual`
       * for a list of supported value comparisons.
       *
       * **Note:** Multiple values can be checked by combining several matchers
       * using `_.overSome`
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Object} source The object of property values to match.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 1, 'b': 2, 'c': 3 },
       *   { 'a': 4, 'b': 5, 'c': 6 }
       * ];
       *
       * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
       * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
       *
       * // Checking for several possible values
       * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
       * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
       */
      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that performs a partial deep comparison between the
       * value at `path` of a given object to `srcValue`, returning `true` if the
       * object value is equivalent, else `false`.
       *
       * **Note:** Partial comparisons will match empty array and empty object
       * `srcValue` values against any array or object value, respectively. See
       * `_.isEqual` for a list of supported value comparisons.
       *
       * **Note:** Multiple values can be checked by combining several matchers
       * using `_.overSome`
       *
       * @static
       * @memberOf _
       * @since 3.2.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @param {*} srcValue The value to match.
       * @returns {Function} Returns the new spec function.
       * @example
       *
       * var objects = [
       *   { 'a': 1, 'b': 2, 'c': 3 },
       *   { 'a': 4, 'b': 5, 'c': 6 }
       * ];
       *
       * _.find(objects, _.matchesProperty('a', 4));
       * // => { 'a': 4, 'b': 5, 'c': 6 }
       *
       * // Checking for several possible values
       * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
       * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
       */
      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }

      /**
       * Creates a function that invokes the method at `path` of a given object.
       * Any additional arguments are provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Array|string} path The path of the method to invoke.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': _.constant(2) } },
       *   { 'a': { 'b': _.constant(1) } }
       * ];
       *
       * _.map(objects, _.method('a.b'));
       * // => [2, 1]
       *
       * _.map(objects, _.method(['a', 'b']));
       * // => [2, 1]
       */
      var method = baseRest(function(path, args) {
        return function(object) {
          return baseInvoke(object, path, args);
        };
      });

      /**
       * The opposite of `_.method`; this method creates a function that invokes
       * the method at a given path of `object`. Any additional arguments are
       * provided to the invoked method.
       *
       * @static
       * @memberOf _
       * @since 3.7.0
       * @category Util
       * @param {Object} object The object to query.
       * @param {...*} [args] The arguments to invoke the method with.
       * @returns {Function} Returns the new invoker function.
       * @example
       *
       * var array = _.times(3, _.constant),
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.methodOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
       * // => [2, 0]
       */
      var methodOf = baseRest(function(object, args) {
        return function(path) {
          return baseInvoke(object, path, args);
        };
      });

      /**
       * Adds all own enumerable string keyed function properties of a source
       * object to the destination object. If `object` is a function, then methods
       * are added to its prototype as well.
       *
       * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
       * avoid conflicts caused by modifying the original.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {Function|Object} [object=lodash] The destination object.
       * @param {Object} source The object of functions to add.
       * @param {Object} [options={}] The options object.
       * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
       * @returns {Function|Object} Returns `object`.
       * @example
       *
       * function vowels(string) {
       *   return _.filter(string, function(v) {
       *     return /[aeiou]/i.test(v);
       *   });
       * }
       *
       * _.mixin({ 'vowels': vowels });
       * _.vowels('fred');
       * // => ['e']
       *
       * _('fred').vowels().value();
       * // => ['e']
       *
       * _.mixin({ 'vowels': vowels }, { 'chain': false });
       * _('fred').vowels();
       * // => ['e']
       */
      function mixin(object, source, options) {
        var props = keys(source),
            methodNames = baseFunctions(source, props);

        if (options == null &&
            !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }
        var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
            isFunc = isFunction(object);

        arrayEach(methodNames, function(methodName) {
          var func = source[methodName];
          object[methodName] = func;
          if (isFunc) {
            object.prototype[methodName] = function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = copyArray(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });

        return object;
      }

      /**
       * Reverts the `_` variable to its previous value and returns a reference to
       * the `lodash` function.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @returns {Function} Returns the `lodash` function.
       * @example
       *
       * var lodash = _.noConflict();
       */
      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }
        return this;
      }

      /**
       * This method returns `undefined`.
       *
       * @static
       * @memberOf _
       * @since 2.3.0
       * @category Util
       * @example
       *
       * _.times(2, _.noop);
       * // => [undefined, undefined]
       */
      function noop() {
        // No operation performed.
      }

      /**
       * Creates a function that gets the argument at index `n`. If `n` is negative,
       * the nth argument from the end is returned.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {number} [n=0] The index of the argument to return.
       * @returns {Function} Returns the new pass-thru function.
       * @example
       *
       * var func = _.nthArg(1);
       * func('a', 'b', 'c', 'd');
       * // => 'b'
       *
       * var func = _.nthArg(-2);
       * func('a', 'b', 'c', 'd');
       * // => 'c'
       */
      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function(args) {
          return baseNth(args, n);
        });
      }

      /**
       * Creates a function that invokes `iteratees` with the arguments it receives
       * and returns their results.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [iteratees=[_.identity]]
       *  The iteratees to invoke.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.over([Math.max, Math.min]);
       *
       * func(1, 2, 3, 4);
       * // => [4, 1]
       */
      var over = createOver(arrayMap);

      /**
       * Creates a function that checks if **all** of the `predicates` return
       * truthy when invoked with the arguments it receives.
       *
       * Following shorthands are possible for providing predicates.
       * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
       * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [predicates=[_.identity]]
       *  The predicates to check.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.overEvery([Boolean, isFinite]);
       *
       * func('1');
       * // => true
       *
       * func(null);
       * // => false
       *
       * func(NaN);
       * // => false
       */
      var overEvery = createOver(arrayEvery);

      /**
       * Creates a function that checks if **any** of the `predicates` return
       * truthy when invoked with the arguments it receives.
       *
       * Following shorthands are possible for providing predicates.
       * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
       * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {...(Function|Function[])} [predicates=[_.identity]]
       *  The predicates to check.
       * @returns {Function} Returns the new function.
       * @example
       *
       * var func = _.overSome([Boolean, isFinite]);
       *
       * func('1');
       * // => true
       *
       * func(null);
       * // => true
       *
       * func(NaN);
       * // => false
       *
       * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
       * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
       */
      var overSome = createOver(arraySome);

      /**
       * Creates a function that returns the value at `path` of a given object.
       *
       * @static
       * @memberOf _
       * @since 2.4.0
       * @category Util
       * @param {Array|string} path The path of the property to get.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var objects = [
       *   { 'a': { 'b': 2 } },
       *   { 'a': { 'b': 1 } }
       * ];
       *
       * _.map(objects, _.property('a.b'));
       * // => [2, 1]
       *
       * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
       * // => [1, 2]
       */
      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }

      /**
       * The opposite of `_.property`; this method creates a function that returns
       * the value at a given path of `object`.
       *
       * @static
       * @memberOf _
       * @since 3.0.0
       * @category Util
       * @param {Object} object The object to query.
       * @returns {Function} Returns the new accessor function.
       * @example
       *
       * var array = [0, 1, 2],
       *     object = { 'a': array, 'b': array, 'c': array };
       *
       * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
       * // => [2, 0]
       *
       * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
       * // => [2, 0]
       */
      function propertyOf(object) {
        return function(path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }

      /**
       * Creates an array of numbers (positive and/or negative) progressing from
       * `start` up to, but not including, `end`. A step of `-1` is used if a negative
       * `start` is specified without an `end` or `step`. If `end` is not specified,
       * it's set to `start` with `start` then set to `0`.
       *
       * **Note:** JavaScript follows the IEEE-754 standard for resolving
       * floating-point values which can produce unexpected results.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.rangeRight
       * @example
       *
       * _.range(4);
       * // => [0, 1, 2, 3]
       *
       * _.range(-4);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 5);
       * // => [1, 2, 3, 4]
       *
       * _.range(0, 20, 5);
       * // => [0, 5, 10, 15]
       *
       * _.range(0, -4, -1);
       * // => [0, -1, -2, -3]
       *
       * _.range(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.range(0);
       * // => []
       */
      var range = createRange();

      /**
       * This method is like `_.range` except that it populates values in
       * descending order.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {number} [start=0] The start of the range.
       * @param {number} end The end of the range.
       * @param {number} [step=1] The value to increment or decrement by.
       * @returns {Array} Returns the range of numbers.
       * @see _.inRange, _.range
       * @example
       *
       * _.rangeRight(4);
       * // => [3, 2, 1, 0]
       *
       * _.rangeRight(-4);
       * // => [-3, -2, -1, 0]
       *
       * _.rangeRight(1, 5);
       * // => [4, 3, 2, 1]
       *
       * _.rangeRight(0, 20, 5);
       * // => [15, 10, 5, 0]
       *
       * _.rangeRight(0, -4, -1);
       * // => [-3, -2, -1, 0]
       *
       * _.rangeRight(1, 4, 0);
       * // => [1, 1, 1]
       *
       * _.rangeRight(0);
       * // => []
       */
      var rangeRight = createRange(true);

      /**
       * This method returns a new empty array.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Array} Returns the new empty array.
       * @example
       *
       * var arrays = _.times(2, _.stubArray);
       *
       * console.log(arrays);
       * // => [[], []]
       *
       * console.log(arrays[0] === arrays[1]);
       * // => false
       */
      function stubArray() {
        return [];
      }

      /**
       * This method returns `false`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `false`.
       * @example
       *
       * _.times(2, _.stubFalse);
       * // => [false, false]
       */
      function stubFalse() {
        return false;
      }

      /**
       * This method returns a new empty object.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {Object} Returns the new empty object.
       * @example
       *
       * var objects = _.times(2, _.stubObject);
       *
       * console.log(objects);
       * // => [{}, {}]
       *
       * console.log(objects[0] === objects[1]);
       * // => false
       */
      function stubObject() {
        return {};
      }

      /**
       * This method returns an empty string.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {string} Returns the empty string.
       * @example
       *
       * _.times(2, _.stubString);
       * // => ['', '']
       */
      function stubString() {
        return '';
      }

      /**
       * This method returns `true`.
       *
       * @static
       * @memberOf _
       * @since 4.13.0
       * @category Util
       * @returns {boolean} Returns `true`.
       * @example
       *
       * _.times(2, _.stubTrue);
       * // => [true, true]
       */
      function stubTrue() {
        return true;
      }

      /**
       * Invokes the iteratee `n` times, returning an array of the results of
       * each invocation. The iteratee is invoked with one argument; (index).
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {number} n The number of times to invoke `iteratee`.
       * @param {Function} [iteratee=_.identity] The function invoked per iteration.
       * @returns {Array} Returns the array of results.
       * @example
       *
       * _.times(3, String);
       * // => ['0', '1', '2']
       *
       *  _.times(4, _.constant(0));
       * // => [0, 0, 0, 0]
       */
      function times(n, iteratee) {
        n = toInteger(n);
        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }
        var index = MAX_ARRAY_LENGTH,
            length = nativeMin(n, MAX_ARRAY_LENGTH);

        iteratee = getIteratee(iteratee);
        n -= MAX_ARRAY_LENGTH;

        var result = baseTimes(length, iteratee);
        while (++index < n) {
          iteratee(index);
        }
        return result;
      }

      /**
       * Converts `value` to a property path array.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Util
       * @param {*} value The value to convert.
       * @returns {Array} Returns the new property path array.
       * @example
       *
       * _.toPath('a.b.c');
       * // => ['a', 'b', 'c']
       *
       * _.toPath('a[0].b.c');
       * // => ['a', '0', 'b', 'c']
       */
      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }
        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }

      /**
       * Generates a unique ID. If `prefix` is given, the ID is appended to it.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Util
       * @param {string} [prefix=''] The value to prefix the ID with.
       * @returns {string} Returns the unique ID.
       * @example
       *
       * _.uniqueId('contact_');
       * // => 'contact_104'
       *
       * _.uniqueId();
       * // => '105'
       */
      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }

      /*------------------------------------------------------------------------*/

      /**
       * Adds two numbers.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {number} augend The first number in an addition.
       * @param {number} addend The second number in an addition.
       * @returns {number} Returns the total.
       * @example
       *
       * _.add(6, 4);
       * // => 10
       */
      var add = createMathOperation(function(augend, addend) {
        return augend + addend;
      }, 0);

      /**
       * Computes `number` rounded up to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round up.
       * @param {number} [precision=0] The precision to round up to.
       * @returns {number} Returns the rounded up number.
       * @example
       *
       * _.ceil(4.006);
       * // => 5
       *
       * _.ceil(6.004, 2);
       * // => 6.01
       *
       * _.ceil(6040, -2);
       * // => 6100
       */
      var ceil = createRound('ceil');

      /**
       * Divide two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {number} dividend The first number in a division.
       * @param {number} divisor The second number in a division.
       * @returns {number} Returns the quotient.
       * @example
       *
       * _.divide(6, 4);
       * // => 1.5
       */
      var divide = createMathOperation(function(dividend, divisor) {
        return dividend / divisor;
      }, 1);

      /**
       * Computes `number` rounded down to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round down.
       * @param {number} [precision=0] The precision to round down to.
       * @returns {number} Returns the rounded down number.
       * @example
       *
       * _.floor(4.006);
       * // => 4
       *
       * _.floor(0.046, 2);
       * // => 0.04
       *
       * _.floor(4060, -2);
       * // => 4000
       */
      var floor = createRound('floor');

      /**
       * Computes the maximum value of `array`. If `array` is empty or falsey,
       * `undefined` is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {*} Returns the maximum value.
       * @example
       *
       * _.max([4, 2, 8, 6]);
       * // => 8
       *
       * _.max([]);
       * // => undefined
       */
      function max(array) {
        return (array && array.length)
          ? baseExtremum(array, identity, baseGt)
          : undefined$1;
      }

      /**
       * This method is like `_.max` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * the value is ranked. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {*} Returns the maximum value.
       * @example
       *
       * var objects = [{ 'n': 1 }, { 'n': 2 }];
       *
       * _.maxBy(objects, function(o) { return o.n; });
       * // => { 'n': 2 }
       *
       * // The `_.property` iteratee shorthand.
       * _.maxBy(objects, 'n');
       * // => { 'n': 2 }
       */
      function maxBy(array, iteratee) {
        return (array && array.length)
          ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
          : undefined$1;
      }

      /**
       * Computes the mean of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the mean.
       * @example
       *
       * _.mean([4, 2, 8, 6]);
       * // => 5
       */
      function mean(array) {
        return baseMean(array, identity);
      }

      /**
       * This method is like `_.mean` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the value to be averaged.
       * The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the mean.
       * @example
       *
       * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
       *
       * _.meanBy(objects, function(o) { return o.n; });
       * // => 5
       *
       * // The `_.property` iteratee shorthand.
       * _.meanBy(objects, 'n');
       * // => 5
       */
      function meanBy(array, iteratee) {
        return baseMean(array, getIteratee(iteratee, 2));
      }

      /**
       * Computes the minimum value of `array`. If `array` is empty or falsey,
       * `undefined` is returned.
       *
       * @static
       * @since 0.1.0
       * @memberOf _
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {*} Returns the minimum value.
       * @example
       *
       * _.min([4, 2, 8, 6]);
       * // => 2
       *
       * _.min([]);
       * // => undefined
       */
      function min(array) {
        return (array && array.length)
          ? baseExtremum(array, identity, baseLt)
          : undefined$1;
      }

      /**
       * This method is like `_.min` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the criterion by which
       * the value is ranked. The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {*} Returns the minimum value.
       * @example
       *
       * var objects = [{ 'n': 1 }, { 'n': 2 }];
       *
       * _.minBy(objects, function(o) { return o.n; });
       * // => { 'n': 1 }
       *
       * // The `_.property` iteratee shorthand.
       * _.minBy(objects, 'n');
       * // => { 'n': 1 }
       */
      function minBy(array, iteratee) {
        return (array && array.length)
          ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
          : undefined$1;
      }

      /**
       * Multiply two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.7.0
       * @category Math
       * @param {number} multiplier The first number in a multiplication.
       * @param {number} multiplicand The second number in a multiplication.
       * @returns {number} Returns the product.
       * @example
       *
       * _.multiply(6, 4);
       * // => 24
       */
      var multiply = createMathOperation(function(multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);

      /**
       * Computes `number` rounded to `precision`.
       *
       * @static
       * @memberOf _
       * @since 3.10.0
       * @category Math
       * @param {number} number The number to round.
       * @param {number} [precision=0] The precision to round to.
       * @returns {number} Returns the rounded number.
       * @example
       *
       * _.round(4.006);
       * // => 4
       *
       * _.round(4.006, 2);
       * // => 4.01
       *
       * _.round(4060, -2);
       * // => 4100
       */
      var round = createRound('round');

      /**
       * Subtract two numbers.
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {number} minuend The first number in a subtraction.
       * @param {number} subtrahend The second number in a subtraction.
       * @returns {number} Returns the difference.
       * @example
       *
       * _.subtract(6, 4);
       * // => 2
       */
      var subtract = createMathOperation(function(minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);

      /**
       * Computes the sum of the values in `array`.
       *
       * @static
       * @memberOf _
       * @since 3.4.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @returns {number} Returns the sum.
       * @example
       *
       * _.sum([4, 2, 8, 6]);
       * // => 20
       */
      function sum(array) {
        return (array && array.length)
          ? baseSum(array, identity)
          : 0;
      }

      /**
       * This method is like `_.sum` except that it accepts `iteratee` which is
       * invoked for each element in `array` to generate the value to be summed.
       * The iteratee is invoked with one argument: (value).
       *
       * @static
       * @memberOf _
       * @since 4.0.0
       * @category Math
       * @param {Array} array The array to iterate over.
       * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
       * @returns {number} Returns the sum.
       * @example
       *
       * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
       *
       * _.sumBy(objects, function(o) { return o.n; });
       * // => 20
       *
       * // The `_.property` iteratee shorthand.
       * _.sumBy(objects, 'n');
       * // => 20
       */
      function sumBy(array, iteratee) {
        return (array && array.length)
          ? baseSum(array, getIteratee(iteratee, 2))
          : 0;
      }

      /*------------------------------------------------------------------------*/

      // Add methods that return wrapped values in chain sequences.
      lodash.after = after;
      lodash.ary = ary;
      lodash.assign = assign;
      lodash.assignIn = assignIn;
      lodash.assignInWith = assignInWith;
      lodash.assignWith = assignWith;
      lodash.at = at;
      lodash.before = before;
      lodash.bind = bind;
      lodash.bindAll = bindAll;
      lodash.bindKey = bindKey;
      lodash.castArray = castArray;
      lodash.chain = chain;
      lodash.chunk = chunk;
      lodash.compact = compact;
      lodash.concat = concat;
      lodash.cond = cond;
      lodash.conforms = conforms;
      lodash.constant = constant;
      lodash.countBy = countBy;
      lodash.create = create;
      lodash.curry = curry;
      lodash.curryRight = curryRight;
      lodash.debounce = debounce;
      lodash.defaults = defaults;
      lodash.defaultsDeep = defaultsDeep;
      lodash.defer = defer;
      lodash.delay = delay;
      lodash.difference = difference;
      lodash.differenceBy = differenceBy;
      lodash.differenceWith = differenceWith;
      lodash.drop = drop;
      lodash.dropRight = dropRight;
      lodash.dropRightWhile = dropRightWhile;
      lodash.dropWhile = dropWhile;
      lodash.fill = fill;
      lodash.filter = filter;
      lodash.flatMap = flatMap;
      lodash.flatMapDeep = flatMapDeep;
      lodash.flatMapDepth = flatMapDepth;
      lodash.flatten = flatten;
      lodash.flattenDeep = flattenDeep;
      lodash.flattenDepth = flattenDepth;
      lodash.flip = flip;
      lodash.flow = flow;
      lodash.flowRight = flowRight;
      lodash.fromPairs = fromPairs;
      lodash.functions = functions;
      lodash.functionsIn = functionsIn;
      lodash.groupBy = groupBy;
      lodash.initial = initial;
      lodash.intersection = intersection;
      lodash.intersectionBy = intersectionBy;
      lodash.intersectionWith = intersectionWith;
      lodash.invert = invert;
      lodash.invertBy = invertBy;
      lodash.invokeMap = invokeMap;
      lodash.iteratee = iteratee;
      lodash.keyBy = keyBy;
      lodash.keys = keys;
      lodash.keysIn = keysIn;
      lodash.map = map;
      lodash.mapKeys = mapKeys;
      lodash.mapValues = mapValues;
      lodash.matches = matches;
      lodash.matchesProperty = matchesProperty;
      lodash.memoize = memoize;
      lodash.merge = merge;
      lodash.mergeWith = mergeWith;
      lodash.method = method;
      lodash.methodOf = methodOf;
      lodash.mixin = mixin;
      lodash.negate = negate;
      lodash.nthArg = nthArg;
      lodash.omit = omit;
      lodash.omitBy = omitBy;
      lodash.once = once;
      lodash.orderBy = orderBy;
      lodash.over = over;
      lodash.overArgs = overArgs;
      lodash.overEvery = overEvery;
      lodash.overSome = overSome;
      lodash.partial = partial;
      lodash.partialRight = partialRight;
      lodash.partition = partition;
      lodash.pick = pick;
      lodash.pickBy = pickBy;
      lodash.property = property;
      lodash.propertyOf = propertyOf;
      lodash.pull = pull;
      lodash.pullAll = pullAll;
      lodash.pullAllBy = pullAllBy;
      lodash.pullAllWith = pullAllWith;
      lodash.pullAt = pullAt;
      lodash.range = range;
      lodash.rangeRight = rangeRight;
      lodash.rearg = rearg;
      lodash.reject = reject;
      lodash.remove = remove;
      lodash.rest = rest;
      lodash.reverse = reverse;
      lodash.sampleSize = sampleSize;
      lodash.set = set;
      lodash.setWith = setWith;
      lodash.shuffle = shuffle;
      lodash.slice = slice;
      lodash.sortBy = sortBy;
      lodash.sortedUniq = sortedUniq;
      lodash.sortedUniqBy = sortedUniqBy;
      lodash.split = split;
      lodash.spread = spread;
      lodash.tail = tail;
      lodash.take = take;
      lodash.takeRight = takeRight;
      lodash.takeRightWhile = takeRightWhile;
      lodash.takeWhile = takeWhile;
      lodash.tap = tap;
      lodash.throttle = throttle;
      lodash.thru = thru;
      lodash.toArray = toArray;
      lodash.toPairs = toPairs;
      lodash.toPairsIn = toPairsIn;
      lodash.toPath = toPath;
      lodash.toPlainObject = toPlainObject;
      lodash.transform = transform;
      lodash.unary = unary;
      lodash.union = union;
      lodash.unionBy = unionBy;
      lodash.unionWith = unionWith;
      lodash.uniq = uniq;
      lodash.uniqBy = uniqBy;
      lodash.uniqWith = uniqWith;
      lodash.unset = unset;
      lodash.unzip = unzip;
      lodash.unzipWith = unzipWith;
      lodash.update = update;
      lodash.updateWith = updateWith;
      lodash.values = values;
      lodash.valuesIn = valuesIn;
      lodash.without = without;
      lodash.words = words;
      lodash.wrap = wrap;
      lodash.xor = xor;
      lodash.xorBy = xorBy;
      lodash.xorWith = xorWith;
      lodash.zip = zip;
      lodash.zipObject = zipObject;
      lodash.zipObjectDeep = zipObjectDeep;
      lodash.zipWith = zipWith;

      // Add aliases.
      lodash.entries = toPairs;
      lodash.entriesIn = toPairsIn;
      lodash.extend = assignIn;
      lodash.extendWith = assignInWith;

      // Add methods to `lodash.prototype`.
      mixin(lodash, lodash);

      /*------------------------------------------------------------------------*/

      // Add methods that return unwrapped values in chain sequences.
      lodash.add = add;
      lodash.attempt = attempt;
      lodash.camelCase = camelCase;
      lodash.capitalize = capitalize;
      lodash.ceil = ceil;
      lodash.clamp = clamp;
      lodash.clone = clone;
      lodash.cloneDeep = cloneDeep;
      lodash.cloneDeepWith = cloneDeepWith;
      lodash.cloneWith = cloneWith;
      lodash.conformsTo = conformsTo;
      lodash.deburr = deburr;
      lodash.defaultTo = defaultTo;
      lodash.divide = divide;
      lodash.endsWith = endsWith;
      lodash.eq = eq;
      lodash.escape = escape;
      lodash.escapeRegExp = escapeRegExp;
      lodash.every = every;
      lodash.find = find;
      lodash.findIndex = findIndex;
      lodash.findKey = findKey;
      lodash.findLast = findLast;
      lodash.findLastIndex = findLastIndex;
      lodash.findLastKey = findLastKey;
      lodash.floor = floor;
      lodash.forEach = forEach;
      lodash.forEachRight = forEachRight;
      lodash.forIn = forIn;
      lodash.forInRight = forInRight;
      lodash.forOwn = forOwn;
      lodash.forOwnRight = forOwnRight;
      lodash.get = get;
      lodash.gt = gt;
      lodash.gte = gte;
      lodash.has = has;
      lodash.hasIn = hasIn;
      lodash.head = head;
      lodash.identity = identity;
      lodash.includes = includes;
      lodash.indexOf = indexOf;
      lodash.inRange = inRange;
      lodash.invoke = invoke;
      lodash.isArguments = isArguments;
      lodash.isArray = isArray;
      lodash.isArrayBuffer = isArrayBuffer;
      lodash.isArrayLike = isArrayLike;
      lodash.isArrayLikeObject = isArrayLikeObject;
      lodash.isBoolean = isBoolean;
      lodash.isBuffer = isBuffer;
      lodash.isDate = isDate;
      lodash.isElement = isElement;
      lodash.isEmpty = isEmpty;
      lodash.isEqual = isEqual;
      lodash.isEqualWith = isEqualWith;
      lodash.isError = isError;
      lodash.isFinite = isFinite;
      lodash.isFunction = isFunction;
      lodash.isInteger = isInteger;
      lodash.isLength = isLength;
      lodash.isMap = isMap;
      lodash.isMatch = isMatch;
      lodash.isMatchWith = isMatchWith;
      lodash.isNaN = isNaN;
      lodash.isNative = isNative;
      lodash.isNil = isNil;
      lodash.isNull = isNull;
      lodash.isNumber = isNumber;
      lodash.isObject = isObject;
      lodash.isObjectLike = isObjectLike;
      lodash.isPlainObject = isPlainObject;
      lodash.isRegExp = isRegExp;
      lodash.isSafeInteger = isSafeInteger;
      lodash.isSet = isSet;
      lodash.isString = isString;
      lodash.isSymbol = isSymbol;
      lodash.isTypedArray = isTypedArray;
      lodash.isUndefined = isUndefined;
      lodash.isWeakMap = isWeakMap;
      lodash.isWeakSet = isWeakSet;
      lodash.join = join;
      lodash.kebabCase = kebabCase;
      lodash.last = last;
      lodash.lastIndexOf = lastIndexOf;
      lodash.lowerCase = lowerCase;
      lodash.lowerFirst = lowerFirst;
      lodash.lt = lt;
      lodash.lte = lte;
      lodash.max = max;
      lodash.maxBy = maxBy;
      lodash.mean = mean;
      lodash.meanBy = meanBy;
      lodash.min = min;
      lodash.minBy = minBy;
      lodash.stubArray = stubArray;
      lodash.stubFalse = stubFalse;
      lodash.stubObject = stubObject;
      lodash.stubString = stubString;
      lodash.stubTrue = stubTrue;
      lodash.multiply = multiply;
      lodash.nth = nth;
      lodash.noConflict = noConflict;
      lodash.noop = noop;
      lodash.now = now;
      lodash.pad = pad;
      lodash.padEnd = padEnd;
      lodash.padStart = padStart;
      lodash.parseInt = parseInt;
      lodash.random = random;
      lodash.reduce = reduce;
      lodash.reduceRight = reduceRight;
      lodash.repeat = repeat;
      lodash.replace = replace;
      lodash.result = result;
      lodash.round = round;
      lodash.runInContext = runInContext;
      lodash.sample = sample;
      lodash.size = size;
      lodash.snakeCase = snakeCase;
      lodash.some = some;
      lodash.sortedIndex = sortedIndex;
      lodash.sortedIndexBy = sortedIndexBy;
      lodash.sortedIndexOf = sortedIndexOf;
      lodash.sortedLastIndex = sortedLastIndex;
      lodash.sortedLastIndexBy = sortedLastIndexBy;
      lodash.sortedLastIndexOf = sortedLastIndexOf;
      lodash.startCase = startCase;
      lodash.startsWith = startsWith;
      lodash.subtract = subtract;
      lodash.sum = sum;
      lodash.sumBy = sumBy;
      lodash.template = template;
      lodash.times = times;
      lodash.toFinite = toFinite;
      lodash.toInteger = toInteger;
      lodash.toLength = toLength;
      lodash.toLower = toLower;
      lodash.toNumber = toNumber;
      lodash.toSafeInteger = toSafeInteger;
      lodash.toString = toString;
      lodash.toUpper = toUpper;
      lodash.trim = trim;
      lodash.trimEnd = trimEnd;
      lodash.trimStart = trimStart;
      lodash.truncate = truncate;
      lodash.unescape = unescape;
      lodash.uniqueId = uniqueId;
      lodash.upperCase = upperCase;
      lodash.upperFirst = upperFirst;

      // Add aliases.
      lodash.each = forEach;
      lodash.eachRight = forEachRight;
      lodash.first = head;

      mixin(lodash, (function() {
        var source = {};
        baseForOwn(lodash, function(func, methodName) {
          if (!hasOwnProperty.call(lodash.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }()), { 'chain': false });

      /*------------------------------------------------------------------------*/

      /**
       * The semantic version number.
       *
       * @static
       * @memberOf _
       * @type {string}
       */
      lodash.VERSION = VERSION;

      // Assign default placeholders.
      arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
        lodash[methodName].placeholder = lodash;
      });

      // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
      arrayEach(['drop', 'take'], function(methodName, index) {
        LazyWrapper.prototype[methodName] = function(n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);

          var result = (this.__filtered__ && !index)
            ? new LazyWrapper(this)
            : this.clone();

          if (result.__filtered__) {
            result.__takeCount__ = nativeMin(n, result.__takeCount__);
          } else {
            result.__views__.push({
              'size': nativeMin(n, MAX_ARRAY_LENGTH),
              'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
            });
          }
          return result;
        };

        LazyWrapper.prototype[methodName + 'Right'] = function(n) {
          return this.reverse()[methodName](n).reverse();
        };
      });

      // Add `LazyWrapper` methods that accept an `iteratee` value.
      arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
        var type = index + 1,
            isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

        LazyWrapper.prototype[methodName] = function(iteratee) {
          var result = this.clone();
          result.__iteratees__.push({
            'iteratee': getIteratee(iteratee, 3),
            'type': type
          });
          result.__filtered__ = result.__filtered__ || isFilter;
          return result;
        };
      });

      // Add `LazyWrapper` methods for `_.head` and `_.last`.
      arrayEach(['head', 'last'], function(methodName, index) {
        var takeName = 'take' + (index ? 'Right' : '');

        LazyWrapper.prototype[methodName] = function() {
          return this[takeName](1).value()[0];
        };
      });

      // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
      arrayEach(['initial', 'tail'], function(methodName, index) {
        var dropName = 'drop' + (index ? '' : 'Right');

        LazyWrapper.prototype[methodName] = function() {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });

      LazyWrapper.prototype.compact = function() {
        return this.filter(identity);
      };

      LazyWrapper.prototype.find = function(predicate) {
        return this.filter(predicate).head();
      };

      LazyWrapper.prototype.findLast = function(predicate) {
        return this.reverse().find(predicate);
      };

      LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
        if (typeof path == 'function') {
          return new LazyWrapper(this);
        }
        return this.map(function(value) {
          return baseInvoke(value, path, args);
        });
      });

      LazyWrapper.prototype.reject = function(predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };

      LazyWrapper.prototype.slice = function(start, end) {
        start = toInteger(start);

        var result = this;
        if (result.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result);
        }
        if (start < 0) {
          result = result.takeRight(-start);
        } else if (start) {
          result = result.drop(start);
        }
        if (end !== undefined$1) {
          end = toInteger(end);
          result = end < 0 ? result.dropRight(-end) : result.take(end - start);
        }
        return result;
      };

      LazyWrapper.prototype.takeRightWhile = function(predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };

      LazyWrapper.prototype.toArray = function() {
        return this.take(MAX_ARRAY_LENGTH);
      };

      // Add `LazyWrapper` methods to `lodash.prototype`.
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
            isTaker = /^(?:head|last)$/.test(methodName),
            lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
            retUnwrapped = isTaker || /^find/.test(methodName);

        if (!lodashFunc) {
          return;
        }
        lodash.prototype[methodName] = function() {
          var value = this.__wrapped__,
              args = isTaker ? [1] : arguments,
              isLazy = value instanceof LazyWrapper,
              iteratee = args[0],
              useLazy = isLazy || isArray(value);

          var interceptor = function(value) {
            var result = lodashFunc.apply(lodash, arrayPush([value], args));
            return (isTaker && chainAll) ? result[0] : result;
          };

          if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
            // Avoid lazy use if the iteratee has a "length" value other than `1`.
            isLazy = useLazy = false;
          }
          var chainAll = this.__chain__,
              isHybrid = !!this.__actions__.length,
              isUnwrapped = retUnwrapped && !chainAll,
              onlyLazy = isLazy && !isHybrid;

          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result = func.apply(value, args);
            result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined$1 });
            return new LodashWrapper(result, chainAll);
          }
          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }
          result = this.thru(interceptor);
          return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
        };
      });

      // Add `Array` methods to `lodash.prototype`.
      arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
        var func = arrayProto[methodName],
            chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
            retUnwrapped = /^(?:pop|shift)$/.test(methodName);

        lodash.prototype[methodName] = function() {
          var args = arguments;
          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }
          return this[chainName](function(value) {
            return func.apply(isArray(value) ? value : [], args);
          });
        };
      });

      // Map minified method names to their real names.
      baseForOwn(LazyWrapper.prototype, function(func, methodName) {
        var lodashFunc = lodash[methodName];
        if (lodashFunc) {
          var key = lodashFunc.name + '';
          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }
          realNames[key].push({ 'name': methodName, 'func': lodashFunc });
        }
      });

      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        'name': 'wrapper',
        'func': undefined$1
      }];

      // Add methods to `LazyWrapper`.
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;

      // Add chain sequence methods to the `lodash` wrapper.
      lodash.prototype.at = wrapperAt;
      lodash.prototype.chain = wrapperChain;
      lodash.prototype.commit = wrapperCommit;
      lodash.prototype.next = wrapperNext;
      lodash.prototype.plant = wrapperPlant;
      lodash.prototype.reverse = wrapperReverse;
      lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

      // Add lazy aliases.
      lodash.prototype.first = lodash.prototype.head;

      if (symIterator) {
        lodash.prototype[symIterator] = wrapperToIterator;
      }
      return lodash;
    });

    /*--------------------------------------------------------------------------*/

    // Export lodash.
    var _ = runInContext();

    // Some AMD build optimizers, like r.js, check for condition patterns like:
    if (freeModule) {
      // Export for Node.js.
      (freeModule.exports = _)._ = _;
      // Export for CommonJS support.
      freeExports._ = _;
    }
    else {
      // Export to the global object.
      root._ = _;
    }
  }.call(commonjsGlobal));
  });

  var IconCheck = function IconCheck() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "14",
      height: "14",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M15 7.37V8C15 11.85 11.85 15 8 15C4.15 15 1 11.85 1 8C1 4.15 4.15 1 8 1C8.98 1 9.96 1.21 10.87 1.63",
      stroke: "#89D747",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M15.0004 2.3999L8.00039 9.3999L5.90039 7.2999",
      stroke: "#89D747",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  var MAX_SIZE$1 = 26214400;
  var Complete = function Complete(_ref) {
    var width = _ref.width,
        numberOfFiles = _ref.numberOfFiles,
        onDrop = _ref.onDrop,
        image = _ref.image,
        options = _ref.options,
        preview = _ref.preview,
        isShowPreview = _ref.isShowPreview,
        onClickInputFile = _ref.onClickInputFile;

    var _useDropzone = useDropzone({
      onDrop: onDrop,
      maxSize: MAX_SIZE$1,
      accept: options
    }),
        getRootProps = _useDropzone.getRootProps,
        getInputProps = _useDropzone.getInputProps,
        isDragActive = _useDropzone.isDragActive;

    return /*#__PURE__*/React$2__default.createElement(ContainerComplete, _extends({
      isShowPreview: isShowPreview,
      width: width,
      preview: lodash.isString(preview) ? preview : preview && preview.url,
      isDragActive: isDragActive
    }, getRootProps()), /*#__PURE__*/React$2__default.createElement("input", getInputProps({
      onClick: function onClick() {
        return onClickInputFile();
      }
    })), !isShowPreview && /*#__PURE__*/React$2__default.createElement(Imagem, {
      src: image,
      alt: "image"
    }), /*#__PURE__*/React$2__default.createElement(ContainerUploadInfo, null, numberOfFiles && /*#__PURE__*/React$2__default.createElement(TitleUploadInfo, null, "".concat(numberOfFiles, " upload").concat(numberOfFiles > 1 ? 's' : '', " conclu\xEDdo").concat(numberOfFiles > 1 ? 's' : ''), /*#__PURE__*/React$2__default.createElement(WrapperIconCheck, null, /*#__PURE__*/React$2__default.createElement(IconCheck, null))), /*#__PURE__*/React$2__default.createElement(LinkText, null, "Enviar outra")));
  };

  var Disabled = function Disabled(_ref) {
    var disabled = _ref.disabled,
        width = _ref.width,
        image = _ref.image;
    return /*#__PURE__*/React$2__default.createElement(Container$2, {
      disabled: disabled,
      width: width
    }, /*#__PURE__*/React$2__default.createElement(Imagem, {
      src: image,
      alt: "image"
    }), /*#__PURE__*/React$2__default.createElement(Text$2, null, "Clique para fazer o upload"), /*#__PURE__*/React$2__default.createElement(ContainerIconUpload, null, /*#__PURE__*/React$2__default.createElement(IconUpload, null)));
  };

  var useUploadBox = function useUploadBox(props) {
    var setFilesNotUpload = props.setFilesNotUpload,
        filesNotUpload = props.filesNotUpload,
        setNumberOfFiles = props.setNumberOfFiles,
        numberOfFiles = props.numberOfFiles,
        setPreview = props.setPreview,
        preview = props.preview,
        numberOfFilesInitial = props.numberOfFilesInitial,
        _props$origin = props.origin,
        origin = _props$origin === void 0 ? '' : _props$origin;

    var _useState = React$2.useState('pending'),
        _useState2 = _slicedToArray(_useState, 2),
        status = _useState2[0],
        setStatus = _useState2[1];

    var _useState3 = React$2.useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        isShowPreview = _useState4[0],
        setIsShowPreview = _useState4[1];

    var _useState5 = React$2.useState(false),
        _useState6 = _slicedToArray(_useState5, 2),
        isOpenBrowserAppPermissionModal = _useState6[0],
        setBrowserAppPermissionModal = _useState6[1];

    var _useState7 = React$2.useState(false),
        _useState8 = _slicedToArray(_useState7, 2),
        isOpenFileUploadCXHelpModal = _useState8[0],
        setFileUploadCXHelpModal = _useState8[1];

    var _useState9 = React$2.useState(0),
        _useState10 = _slicedToArray(_useState9, 2),
        numberOfPageVisibilityChanges = _useState10[0],
        setNumberOfPageVisibilityChanges = _useState10[1];

    var _useState11 = React$2.useState(false),
        _useState12 = _slicedToArray(_useState11, 2),
        didCallOnDrop = _useState12[0],
        setDidCallOnDrop = _useState12[1];

    var _useState13 = React$2.useState(0),
        _useState14 = _slicedToArray(_useState13, 2),
        numberOfInputFileClicks = _useState14[0],
        setNumberOfInputFileClicks = _useState14[1];

    function setAppropriateStatus() {
      if (numberOfFiles > 0) {
        setStatus('complete');
      } else {
        setStatus('pending');
      }
    }

    React$2.useEffect(function () {
      var fetchData = function fetchData() {
        if (preview.typeExtension === 'application/pdf') {
          setIsShowPreview(false);
        } else {
          setIsShowPreview(true);
        }
      };

      if (numberOfFiles > 0 && numberOfFiles === numberOfFilesInitial) {
        fetchData();
        setStatus('complete');
      }
    }, [preview]);
    React$2.useEffect(function () {
      function onPageVisilityChange() {
        ReactGA.event({
          category: 'file-upload',
          action: 'visibility change to: ' + (document.visibilityState || 'state-not-available')
        });
        setNumberOfPageVisibilityChanges(numberOfPageVisibilityChanges + 1);
        setNumberOfInputFileClicks(0);
        setBrowserAppPermissionModal(false);
        setFileUploadCXHelpModal(false);
      }

      document.addEventListener('visibilitychange', onPageVisilityChange);
      return function () {
        document.removeEventListener('visibilitychange', onPageVisilityChange);
      };
    });
    React$2.useEffect(function () {
      if (numberOfInputFileClicks >= 3) {
        ReactGA.event({
          category: 'file-upload',
          action: 'File picker did not open'
        });
        setBrowserAppPermissionModal(true);
      }
    }, [numberOfInputFileClicks]);

    var onDrop = function onDrop(archives) {
      setStatus('processing');
      setDidCallOnDrop(true);

      if (isOpenBrowserAppPermissionModal || isOpenFileUploadCXHelpModal) {
        setBrowserAppPermissionModal(false);
        setFileUploadCXHelpModal(false);
      }

      if (!archives.length) {
        /**
         * If entering here an error occurred when sending an image and an empty Array entered []
         */
        showToast('Ocorreu um erro ao enviar o arquivo. Escolha um arquivo válido.');
        captureException(new Error('onDrop: archives is empty'));
        setAppropriateStatus();
        return;
      }
      /**
       * Only in the origin/screen selfie, we don't want file type application/pdf to be accepted.
       */


      if (origin === 'selfie' && archives.find(function (archive) {
        return archive.type === 'application/pdf';
      })) {
        showToast('Arquivo PDF não é suportado');
        setAppropriateStatus();
        return;
      }

      try {
        var filesToReadAsBlob = archives.map( /*#__PURE__*/function () {
          var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
            return regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return readFile(file);

                  case 2:
                    return _context.abrupt("return", _context.sent);

                  case 3:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));

          return function (_x) {
            return _ref.apply(this, arguments);
          };
        }());
        Promise.all(filesToReadAsBlob).then(function (files) {
          setFilesNotUpload(filesNotUpload.concat(files.map(function (files) {
            return files.blob;
          })));
          setNumberOfFiles(numberOfFiles + files.length);
          var lastFile = files[files.length - 1];

          if (lastFile.embeddableImage) {
            setPreview(lastFile.preview);
            setIsShowPreview(true);
          }

          setStatus('complete');
        })["catch"](function (error) {
          setAppropriateStatus();
          logger$1({
            error: error
          });

          if (error.name === 'NotReadableError') {
            /**
             * if entering here an error happened with some permission from the user
             */
            showToast('Ocorreu um erro de permissão ao enviar o seu arquivo. Tente enviar um arquivo local do dispositivo.');
            return;
          }

          showToast('Houve um problema, tente novamente por favor!');
        });
      } catch (error) {
        logger$1({
          error: error
        });
        setAppropriateStatus();
        showToast('Houve um problema, tente novamente por favor!');
      }
    };

    function onCloseBrowserAppPermissionAdviserModal() {
      setBrowserAppPermissionModal(false);
      setNumberOfInputFileClicks(0);
    }

    function onClickInputFile() {
      if (didCallOnDrop) {
        return;
      }

      setNumberOfInputFileClicks(function (prev) {
        return prev + 1;
      });
    }

    function onBrowserPermissionDidNotHelp() {
      setBrowserAppPermissionModal(false);
      setFileUploadCXHelpModal(true);
    }

    function onCloseBrowserPermissionDidNotHelp() {
      setBrowserAppPermissionModal(true);
      setFileUploadCXHelpModal(false);
    }

    return [onDrop, status, isShowPreview, isOpenBrowserAppPermissionModal, onCloseBrowserAppPermissionAdviserModal, onClickInputFile, isOpenFileUploadCXHelpModal, onBrowserPermissionDidNotHelp, onCloseBrowserPermissionDidNotHelp];
  };

  function readFile(_x2) {
    return _readFile.apply(this, arguments);
  } // https://stackoverflow.com/a/9458996


  function _readFile() {
    _readFile = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(file) {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt("return", new Promise(function (resolve, reject) {
                var reader = new FileReader();

                reader.onerror = function (event) {
                  var error = event && event.target && event.target.error;

                  if (!error) {
                    logger$1({
                      error: 'FileReaderError, erro em branco'
                    });
                  }

                  reject(error);
                };

                reader.onload = /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(event) {
                    var type, embeddableImage, loadedImageDetails;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            type = file.type;
                            embeddableImage = type.startsWith('image');
                            loadedImageDetails = {
                              type: type,
                              blob: new Blob([event.target.result], {
                                type: type
                              }),
                              preview: embeddableImage ? "data:".concat(type, ";base64,") + convertArrayBufferToBase64(event.target.result) : null,
                              embeddableImage: embeddableImage
                            };
                            resolve(loadedImageDetails);

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref2.apply(this, arguments);
                  };
                }();

                reader.readAsArrayBuffer(file);
              }));

            case 1:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return _readFile.apply(this, arguments);
  }

  function convertArrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var len = bytes.byteLength;

    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }

    return window.btoa(binary);
  } // adapted from https://developer.mozilla.org/en-US/docs/Web/API/Window/navigator#example_1_browser_detect_and_return_a_string


  var getBrowserName = function getBrowserName() {
    if (typeof window != 'undefined') {
      var _window, _window$navigator;

      var userAgent = (_window = window) === null || _window === void 0 ? void 0 : (_window$navigator = _window.navigator) === null || _window$navigator === void 0 ? void 0 : _window$navigator.userAgent;

      switch (true) {
        case userAgent.indexOf('Firefox') > -1:
          return 'Mozilla Firefox';

        case userAgent.indexOf('SamsungBrowser') > -1:
          return 'Samsung Internet';

        case userAgent.indexOf('Opera') > -1:
          return 'Opera';

        case userAgent.indexOf('OPR') > -1:
          return 'Opera';

        case userAgent.indexOf('Trident') > -1:
          return 'Microsoft Internet Explorer';

        case userAgent.indexOf('Edge') > -1:
          return 'Microsoft Edge';

        case userAgent.indexOf('Chrome') > -1:
          return 'Google Chrome ou Chromium';

        case userAgent.indexOf('Safari') > -1:
          return 'Apple Safari';

        default:
          return 'Navegador desconhecido';
      }
    }
  };

  const img$2 = "data:image/png;base64,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";

  const img$3 = "data:image/png;base64,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";

  const img$4 = "data:image/png;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBQNDAsLDBkSEw8UHRofHh0aHBwgJC4nICIsIxwcKDcpLDAxNDQ0Hyc5PTgyPC4zNDL/2wBDAQkJCQwLDBgNDRgyIRwhMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjIyMjL/wAARCAA6AEADASIAAhEBAxEB/8QAGQABAQEAAwAAAAAAAAAAAAAAAAcFAwYI/8QAKRAAAQMEAAYCAgMBAAAAAAAAAQACAwQFBhEHEiExQWETgRQiMlGRsf/EABQBAQAAAAAAAAAAAAAAAAAAAAD/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwC5IiICIsG75rjlirjRXK6RU9SGhxjLXOIB7b0Cg3kXBRVtNcaKKso5mT08zeaORh2HBc6AiIgIiII5e+Nk1vyaqpaCgpqu2wO+MPL3NfI4dyHdRrfbp78qU5Fe58jv9XdqlrWSVDgeRp2GgAAD6AC2+JdmtVjzKektEoMLmCSSIHYgeSdsH1o+t6Vx4c2m20GDW19FFG51XTtlqJNAl73D9gT6Oxr0gj2LcVrli+ONtEVDT1Iic4wySuI5A47IIHfqSe47qy4FmEeZWH8tzGRVsLvjqYmdmnwRvroj/hHhRXi3ardac3fHbo44mzQMmlijGmskJcCAPGwAde1W+FdmtVtw2mq7dIJpq1jZKqXfXnA/h65SSP8AT5Qd4REQEREHmzIuG2SQ5TW01Fb6uuhfIZYqnWw9p6/s89Obwd+VlUGVZVhzqi10tdPRfG8tkp3sa8Md50HA6+l6oU6yzhLRZRf5rsLlLSSTNb8jBEHgkADY6jXQBBFoMeyfJ46i8Q0FbXh7yZKgDmL3edeT9K28I8Yrcexuae4CaKorpBJ+NICPia3YG2ns49z61/S7ZjdigxrH6S007zIynaQZHDRe4kkn/SVqoCIiAiIgIiICIiAiIg//2Q==";

  const img$5 = "data:image/png;base64,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";

  const img$6 = "data:image/png;base64,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";

  const img$7 = "data:image/png;base64,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";

  const img$8 = "data:image/png;base64,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";

  const img$9 = "data:image/png;base64,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";

  /**
   * @typedef {object} UploadBoxProps
   * @property {boolean} [isWebcam]
   * @property {number} [width]
   * @property {string} [text]
   * @property {string} [origin]
   * @property {string | {
   *  extensionType: string
   *  url: string
   * }} [preview]
   * @property {(prev: any) => void} [setPreview]
   * @property {string} [image]
   * @property {(n: number) => void} [setNumberOfFiles]
   * @property {Array} [filesNotUpload]
   * @property {number} [numberOfFiles]
   * @property {string} [options]
   * @property {string} [numberOfFilesInitial]
   */

  /** @type {import('react').FC<UploadBoxProps>} */

  var UploadBox = function UploadBox(props) {
    var isWebcam = props.isWebcam,
        width = props.width,
        text = props.text,
        image = props.image,
        preview = props.preview;

    var _useUploadBox = useUploadBox(props),
        _useUploadBox2 = _slicedToArray(_useUploadBox, 9),
        onDrop = _useUploadBox2[0],
        status = _useUploadBox2[1],
        isShowPreview = _useUploadBox2[2],
        isOpenBrowserAppPermissionModal = _useUploadBox2[3],
        onCloseBrowserAppPermissionAdviserModal = _useUploadBox2[4],
        onClickInputFile = _useUploadBox2[5],
        isOpenFileUploadCXHelpModal = _useUploadBox2[6],
        onBrowserPermissionDidNotHelp = _useUploadBox2[7],
        onCloseBrowserPermissionDidNotHelp = _useUploadBox2[8];

    if (isWebcam) {
      return /*#__PURE__*/React$2__default.createElement(Disabled, {
        disabled: true,
        width: width,
        text: text,
        image: image,
        preview: preview
      });
    }

    var Components = {
      pending: /*#__PURE__*/React$2__default.createElement(Pending, _extends({
        onDrop: onDrop
      }, props, {
        onClickInputFile: onClickInputFile
      })),
      processing: /*#__PURE__*/React$2__default.createElement(Processing, props),
      complete: /*#__PURE__*/React$2__default.createElement(Complete, _extends({
        isShowPreview: isShowPreview,
        onDrop: onDrop
      }, props, {
        onClickInputFile: onClickInputFile
      }))
    };
    return /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, isOpenBrowserAppPermissionModal && /*#__PURE__*/React$2__default.createElement(Modal, {
      title: "Nada acontece?",
      onDismiss: onCloseBrowserAppPermissionAdviserModal,
      footer: /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, /*#__PURE__*/React$2__default.createElement(Button, {
        text: "N\xE3o estou conseguindo",
        onClick: function onClick() {
          ReactGA.event({
            category: 'file-upload',
            action: 'Permissions, tried but didnt help'
          });
          onBrowserPermissionDidNotHelp();
        },
        icon: function icon() {
          return null;
        }
      }))
    }, /*#__PURE__*/React$2__default.createElement(ContainModalContent, null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Seguindo algumas dessas instru\xE7\xF5es pode ajudar a habilitar o envio de arquivos"), /*#__PURE__*/React$2__default.createElement(HelpSubSection, null, "Op\xE7\xE3o 1"), /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Altere o navegador padr\xE3o do Outlook"), /*#__PURE__*/React$2__default.createElement(HelpList, null, /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Abra o aplicativo Outlook")), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Abra o menu"), /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$7,
      alt: ""
    })), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, " Encontre configura\xE7\xF5es"), /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$8,
      alt: ""
    })), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Ative a op\xE7\xE3o \"Usar navegador padr\xE3o\""), /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$9
    }))), /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Ap\xF3s habilitar essa op\xE7\xE3o, fa\xE7a login novamente"), /*#__PURE__*/React$2__default.createElement("hr", null), /*#__PURE__*/React$2__default.createElement(HelpSubSection, null, "Op\xE7\xE3o 2"), /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Configure seu navegador para poder acessar arquivos"), /*#__PURE__*/React$2__default.createElement(HelpList, null, /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Abra as Configura\xE7\xF5es do seu celular ", /*#__PURE__*/React$2__default.createElement("img", {
      width: "25",
      src: img$4,
      alt: ""
    }))), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Encontre a op\xE7\xE3o \"Aplicativos\" e se tiver \"Gerenciar Aplicativos\""), /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$5
    })), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Encontre o nome de seu navegador ", getBrowserName() ? getBrowserName() : ''), ' ', /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$6
    })), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Encontre o menu permiss\xF5es"), /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$2
    })), /*#__PURE__*/React$2__default.createElement("li", null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Dentro de Permiss\xF5es, ative as permiss\xF5es de camera e armazenamento/mem\xF3ria"), /*#__PURE__*/React$2__default.createElement(ImageHelp, {
      src: img$3
    }))))), isOpenFileUploadCXHelpModal && /*#__PURE__*/React$2__default.createElement(Modal, {
      title: "N\xE3o se preocupe",
      onDismiss: onCloseBrowserPermissionDidNotHelp,
      footer: /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, /*#__PURE__*/React$2__default.createElement(Button, {
        text: "Abrir Whatsapp",
        onClick: function onClick() {
          window.open('https://api.whatsapp.com/send?phone=+5511957712414&text=Oi, Provi! Não estou conseguindo enviar documentos e fotos. URL: ${window.location.href}', '_blank', 'noopener');
          ReactGA.event({
            category: 'file-upload',
            action: 'Ok, whatsapp help'
          });
          onCloseBrowserAppPermissionAdviserModal();
          onCloseBrowserPermissionDidNotHelp();
        }
      }))
    }, /*#__PURE__*/React$2__default.createElement(ContainModalContent, null, /*#__PURE__*/React$2__default.createElement(HelpParagraph, null, "Nos envie seus documentos por Whatsapp, nosso telefone de suporte \xE9 (11) 95771-2414"))), Components[status]);
  };

  function _templateObject5$8() {
    var data = _taggedTemplateLiteral(["\n      font-weight: bold;\n      color: ", ";\n    "]);

    _templateObject5$8 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$9() {
    var data = _taggedTemplateLiteral(["\n  font-family: CenturyGothic;\n  color: ", ";\n\n  ", "\n"]);

    _templateObject4$9 = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$b() {
    var data = _taggedTemplateLiteral(["\n      border-color: ", ";\n      background-color: ", ";\n    "]);

    _templateObject3$b = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$e() {
    var data = _taggedTemplateLiteral(["\n  width: 37px;\n  height: 37px;\n  border: 1px solid ", ";\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 7px;\n  background-color: ", ";\n  outline: 0;\n\n  &:last-child {\n    margin-right: 0;\n  }\n\n  &:hover {\n    cursor: ", ";\n  }\n\n  ", "\n"]);

    _templateObject2$e = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$n() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-wrap: wrap;\n  align-content: flex-start;\n  row-gap: 7px;\n\n  ", " {\n    justify-content: center;\n  }\n"]);

    _templateObject$n = function _templateObject() {
      return data;
    };

    return data;
  }
  var Container$3 = styled__default.div(_templateObject$n(), theme.breakpoints.down('md'));
  var Card = styled__default.button.attrs({
    type: 'button'
  })(_templateObject2$e(), theme.colors.grey600, function (_ref) {
    var disabled = _ref.disabled;
    return disabled ? theme.colors.grey400 : 'transparent';
  }, function (_ref2) {
    var disabled = _ref2.disabled;
    return disabled ? 'not-allowed' : 'pointer';
  }, function (_ref3) {
    var selected = _ref3.selected;
    return selected && styled.css(_templateObject3$b(), theme.colors.blue900, theme.colors.blue900);
  });
  var EvaluationNote = styled__default.span(_templateObject4$9(), theme.colors.grey600, function (_ref4) {
    var selected = _ref4.selected;
    return selected && styled.css(_templateObject5$8(), theme.colors.white100);
  });

  /**
   * @typedef {object} RatingProps
   * @property {string=} id
   * @property {boolean=} [disabled=false] - Avoid to select any options while is disabled
   * @property {number=} [min=0] - The minimum value to be rendered as an evaluation note
   * @property {number=} [max=10] - The maximum value to be rendered as
   * @property {number=} value - The component's initial value
   * @property {() => any} [onChange=() => {}] - Is a callback function to notify the parent component about value changes
   * @property {boolean=} [allowDisselect=false] - Allow users to disselect any options without select any other
   */

  /** @type {import('react').FC<RatingProps>} */

  var Rating = function Rating(_ref) {
    var id = _ref.id,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$min = _ref.min,
        min = _ref$min === void 0 ? 0 : _ref$min,
        _ref$max = _ref.max,
        max = _ref$max === void 0 ? 10 : _ref$max,
        value = _ref.value,
        _ref$onChange = _ref.onChange,
        onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
        _ref$allowDisselect = _ref.allowDisselect,
        allowDisselect = _ref$allowDisselect === void 0 ? false : _ref$allowDisselect;

    var _useState = React$2.useState(),
        _useState2 = _slicedToArray(_useState, 2),
        rating = _useState2[0],
        setRating = _useState2[1];

    React$2.useEffect(function () {
      if (!value) {
        return;
      }

      if (isNaN(value)) {
        throw new Error('Value must be an integer');
      }

      if (value > max || value < min) {
        throw new Error('Value cannot be greater than the maximum value or less than the minimum value');
      }

      setRating(value);
    }, [setRating, value, max, min]);

    var onClickRating = function onClickRating(index) {
      if (disabled) {
        return;
      }

      if (rating === index && allowDisselect) {
        setRating(null);
      } else {
        setRating(index);
      }

      onChange(index);
    };

    var renderRatings = React$2.useMemo(function () {
      var items = [];

      var _loop = function _loop(index) {
        index >= min && items.push( /*#__PURE__*/React$2__default.createElement(Card, {
          key: index,
          "data-testid": "rating-card-container-".concat(index),
          selected: index === rating,
          disabled: disabled,
          onClick: function onClick() {
            return onClickRating(index);
          }
        }, /*#__PURE__*/React$2__default.createElement(EvaluationNote, {
          selected: index === rating
        }, index)));
      };

      for (var index = 0; index <= max; index++) {
        _loop(index);
      }

      return items;
    }, [rating, disabled, max, min, onClickRating]);
    return /*#__PURE__*/React$2__default.createElement(Container$3, {
      id: id
    }, renderRatings);
  };

  var ValidSign = function ValidSign(_ref) {
    var props = _extends({}, _ref);

    return /*#__PURE__*/React$2.createElement("svg", _extends({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React$2.createElement("circle", {
      cx: "7.5",
      cy: "7.5",
      r: "7.5",
      fill: "#89D747"
    }), /*#__PURE__*/React$2.createElement("path", {
      d: "M11.3285 5.19238L6.71314 9.80777L4.61523 7.70987",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  var InvalidSign = function InvalidSign(_ref) {
    var props = _extends({}, _ref);

    return /*#__PURE__*/React$2.createElement("svg", _extends({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React$2.createElement("circle", {
      cx: "7.5",
      cy: "7.5",
      r: "7.5",
      fill: "#DE0C4B"
    }), /*#__PURE__*/React$2.createElement("path", {
      d: "M9.80771 5.19238L5.19232 9.80777M5.19232 5.19238L9.80771 9.80777",
      stroke: "white",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject9$2() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject9$2 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8$2() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject8$2 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7$4() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  font-size: 16px;\n  color: ", ";\n  border: none;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  ", " {\n    font-size: 14px;\n  }\n"]);

    _templateObject7$4 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$5() {
    var data = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "]);

    _templateObject6$5 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$9() {
    var data = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "]);

    _templateObject5$9 = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$a() {
    var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  height: 40px;\n  padding: 8px !important;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  background: ", ";\n\n  ", "\n\n  ", "\n\n  :focus-within {\n    outline: 5px auto ", ";\n    svg:not(:first-child) {\n      visibility: hidden;\n    }\n  }\n\n  svg {\n    min-width: 15px;\n    min-height: 15px;\n    margin: auto 0;\n\n    &:first-child {\n      margin-right: 10px;\n    }\n  }\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject4$a = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$c() {
    var data = _taggedTemplateLiteral(["\n        ::after {\n          content: ' *';\n          color: ", ";\n        }\n      "]);

    _templateObject3$c = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$f() {
    var data = _taggedTemplateLiteral(["\n      width: ", ";\n      max-width: initial;\n    "]);

    _templateObject2$f = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$o() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: ", "px;\n  font-size: 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n\n  ", "\n  p {\n    margin-bottom: 8px;\n    margin-top: 0px;\n    display: block;\n    color: ", ";\n    ", "\n  }\n\n  span {\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 700;\n    color: ", ";\n    font-size: 12px;\n    margin-top: 2px;\n  }\n  ", " {\n    width: 100%;\n    max-width: 100%;\n  }\n"]);

    _templateObject$o = function _templateObject() {
      return data;
    };

    return data;
  }
  /** @type {import('styled-components').StyledComponent<"label", any, { isRequired: boolean, isSmall: boolean, label: string, width: string }>} */

  var InputLabel = styled__default.label(_templateObject$o(), function (_ref) {
    var isSmall = _ref.isSmall;
    return isSmall ? '130' : '280';
  }, function (_ref2) {
    var width = _ref2.width;
    return width && styled.css(_templateObject2$f(), width);
  }, theme.colors.blue900, function (_ref3) {
    var isRequired = _ref3.isRequired,
        label = _ref3.label;
    return isRequired && label && styled.css(_templateObject3$c(), theme.colors.pink900);
  }, theme.colors.pink900, theme.breakpoints.down('md'));
  /** @type {import('styled-components').StyledComponent<"(InputMask)", any, { hasError: boolean, isValid: boolean }>} */

  var InputWrapper$1 = styled__default.div(_templateObject4$a(), theme.colors.grey600, theme.colors.white100, function (_ref4) {
    var hasError = _ref4.hasError;
    return hasError && styled.css(_templateObject5$9(), theme.colors.pink900);
  }, function (_ref5) {
    var isValid = _ref5.isValid;
    return isValid && styled.css(_templateObject6$5(), theme.colors.green100);
  }, theme.colors.blue600, theme.breakpoints.down('md'));
  var MaskedInput = styled__default(reactInputMask)(_templateObject7$4(), theme.colors.blue900, theme.colors.grey600, theme.breakpoints.down('md'));
  var ValidSignSVG = styled__default(ValidSign)(_templateObject8$2());
  var InvalidSignSVG = styled__default(InvalidSign)(_templateObject9$2());

  /**
   * @typedef {object} InputProps
   * @property {string} [errorMessage]
   * @property {boolean} [hasError]
   * @property {boolean} [isRequired]
   * @property {boolean} [isSmall]
   * @property {boolean} [isValid]
   * @property {string} [label]
   * @property {string} [mask]
   * @property {string} [placeholder]
   * @property {any} [inputRef]
   * @property {any} [children]
   * @property {string} [maskChar]
   * @property {string} [beforeMaskedStateChange]
   * @property {string} [width]
   */

  /** @type {import('react').FC<InputProps & import('react-input-mask').Props>} */

  var InputField = function InputField(_ref) {
    var errorMessage = _ref.errorMessage,
        hasError = _ref.hasError,
        isRequired = _ref.isRequired,
        isSmall = _ref.isSmall,
        isValid = _ref.isValid,
        label = _ref.label,
        mask = _ref.mask,
        placeholder = _ref.placeholder,
        inputRef = _ref.inputRef,
        children = _ref.children,
        maskChar = _ref.maskChar,
        beforeMaskedStateChange = _ref.beforeMaskedStateChange,
        width = _ref.width,
        props = _objectWithoutProperties(_ref, ["errorMessage", "hasError", "isRequired", "isSmall", "isValid", "label", "mask", "placeholder", "inputRef", "children", "maskChar", "beforeMaskedStateChange", "width"]);

    return /*#__PURE__*/React$2__default.createElement(InputLabel, {
      isRequired: isRequired,
      isSmall: isSmall,
      label: label,
      ref: inputRef,
      width: width
    }, /*#__PURE__*/React$2__default.createElement("p", null, label), /*#__PURE__*/React$2__default.createElement(InputWrapper$1, {
      hasError: !!hasError,
      isValid: !!isValid
    }, children, /*#__PURE__*/React$2__default.createElement(MaskedInput, _extends({
      placeholder: placeholder,
      mask: mask,
      maskChar: maskChar,
      beforeMaskedStateChange: beforeMaskedStateChange
    }, props)), !!isValid && /*#__PURE__*/React$2__default.createElement(ValidSignSVG, null), !!hasError && /*#__PURE__*/React$2__default.createElement(InvalidSignSVG, null)), hasError && /*#__PURE__*/React$2__default.createElement("span", null, errorMessage));
  };
  InputField.defaultProps = {
    errorMessage: null,
    hasError: false,
    isRequired: false,
    isSmall: false,
    isValid: null,
    label: null,
    mask: null,
    placeholder: '',
    inputRef: null,
    children: null,
    maskChar: null,
    beforeMaskedStateChange: null,
    width: null
  };

  var ImageUpload = function ImageUpload() {
    return /*#__PURE__*/React$2.createElement("svg", {
      width: "73",
      height: "65",
      viewBox: "0 0 73 65",
      fill: "none",
      xmlns: "https://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2.createElement("path", {
      d: "M27.4364 26.1931C30.181 26.1931 32.4059 23.9681 32.4059 21.2235C32.4059 18.4789 30.181 16.254 27.4364 16.254C24.6917 16.254 22.4668 18.4789 22.4668 21.2235C22.4668 23.9681 24.6917 26.1931 27.4364 26.1931Z",
      fill: "white"
    }), /*#__PURE__*/React$2.createElement("path", {
      d: "M68.2272 39.5142C65.8805 37.3055 62.9125 35.8561 59.6685 35.442V10.18C59.6685 7.4882 58.5642 5.07245 56.8386 3.27788C55.0441 1.48332 52.6283 0.447998 49.9365 0.447998H9.90392C7.21208 0.447998 4.79632 1.55234 3.00176 3.27788C1.2072 5.07245 0.171875 7.4882 0.171875 10.18V41.999V44.9669V51.3859C0.171875 54.0778 1.27622 56.4935 3.00176 58.2881C4.79632 60.0827 7.21208 61.118 9.90392 61.118H48.625C51.1788 63.1886 54.3538 64.5001 57.8739 64.5001C61.9462 64.5001 65.6044 62.8435 68.2272 60.2207C70.85 57.5979 72.5065 53.9397 72.5065 49.8675C72.5065 45.7952 70.85 42.137 68.2272 39.5142ZM3.83002 10.18C3.83002 8.52353 4.52024 7.00505 5.62458 5.96973C6.72893 4.86538 8.2474 4.17516 9.90392 4.17516H49.9365C51.593 4.17516 53.1115 4.86538 54.2158 5.96973C55.3201 7.07407 56.0104 8.59255 56.0104 10.2491V31.7838L45.7952 21.5686C45.1049 20.8784 43.9316 20.8094 43.1723 21.5686L27.7805 37.0294L17.3583 26.5382C16.668 25.8479 15.4947 25.7789 14.7354 26.5382L3.83002 37.5816V10.18ZM9.8349 57.5979V57.4598C8.17838 57.4598 6.65991 56.7696 5.55556 55.6653C4.52024 54.5609 3.83002 53.0425 3.83002 51.3859V44.9669V42.8273L16.0468 30.5414L26.4691 40.9637C27.1593 41.6539 28.3327 41.6539 29.0919 40.9637L44.4838 25.5028L54.5609 35.649C54.3538 35.718 54.1468 35.7871 53.9397 35.8561C53.6636 35.9251 53.3875 35.9941 53.0424 36.1322C52.7663 36.2012 52.4903 36.3392 52.2142 36.4083C52.0071 36.4773 51.8691 36.5463 51.662 36.6843C51.3859 36.8224 51.1788 36.8914 50.9718 37.0294C50.6267 37.2365 50.2816 37.4436 49.9365 37.6506C49.7294 37.7887 49.5914 37.8577 49.3843 37.9958C49.2462 38.0648 49.1772 38.1338 49.0392 38.2028C48.418 38.6169 47.8658 39.1001 47.3827 39.6523C44.7598 42.2751 43.1033 45.9332 43.1033 50.0055C43.1033 51.0408 43.2414 52.0071 43.4484 53.0425C43.5175 53.3185 43.5865 53.5256 43.6555 53.8017C43.8626 54.4919 44.0696 55.1821 44.3457 55.8723V55.9414C44.6218 56.4935 44.8979 57.1147 45.243 57.5979H9.8349ZM65.5353 57.5979C63.5337 59.5995 60.8419 60.7729 57.8049 60.7729C54.906 60.7729 52.2142 59.5995 50.2816 57.7359C50.0055 57.4598 49.7294 57.1147 49.4533 56.8386C49.2462 56.6316 49.0392 56.3555 48.8321 56.1484C48.556 55.8033 48.349 55.3892 48.1419 54.9751C48.0039 54.699 47.8658 54.4919 47.7278 54.2158C47.5897 53.8707 47.4517 53.4566 47.3827 53.0425C47.3136 52.7664 47.1756 52.4213 47.1066 52.1452C46.9685 51.455 46.8995 50.6957 46.8995 49.9365C46.8995 46.8995 48.1419 44.2077 50.0745 42.2061C52.0071 40.2044 54.768 39.0311 57.8049 39.0311C60.8419 39.0311 63.5337 40.2735 65.5353 42.2061C67.537 44.2077 68.7103 46.8995 68.7103 49.9365C68.7103 52.9044 67.4679 55.5963 65.5353 57.5979Z",
      fill: "white"
    }), /*#__PURE__*/React$2.createElement("path", {
      d: "M59.1171 42.4821C58.979 42.3441 58.772 42.206 58.4959 42.068C58.2888 41.999 58.0818 41.9299 57.8747 41.9299C57.8057 41.9299 57.8057 41.9299 57.8057 41.9299C57.7367 41.9299 57.7367 41.9299 57.7367 41.9299C57.5296 41.9299 57.3225 41.999 57.1155 42.068C56.9084 42.137 56.7013 42.275 56.4943 42.4821L52.2149 46.7614C51.5247 47.4517 51.5247 48.625 52.2149 49.3843C52.9051 50.0745 54.0785 50.0745 54.8377 49.3843L55.9421 48.2799V55.8723C55.9421 56.9076 56.7704 57.7359 57.8057 57.7359C58.841 57.7359 59.6693 56.9076 59.6693 55.8723V48.2799L60.7736 49.3843C61.4638 50.0745 62.6372 50.0745 63.3964 49.3843C64.0866 48.6941 64.0866 47.5207 63.3964 46.7614L59.1171 42.4821Z",
      fill: "white"
    }));
  };

  function _templateObject10$2() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'Montserrat';\n  font-weight: 600;\n  font-size: 16px;\n  text-align: center;\n"]);

    _templateObject10$2 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9$3() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'Montserrat';\n  font-size: 14px;\n  margin-top: 16px;\n  text-align: center;\n\n  span {\n    font-weight: 600;\n    color: var(--greyPrimary);\n  }\n"]);

    _templateObject9$3 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8$3() {
    var data = _taggedTemplateLiteral(["\n  display: none;\n"]);

    _templateObject8$3 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7$5() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject7$5 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$6() {
    var data = _taggedTemplateLiteral(["\n      background-color: ", ";\n      width: 100%;\n      height: 124px;\n      border: 1px dashed ", ";\n      color: var(--greyPrimary);\n      font-weight: 400;\n    "]);

    _templateObject6$6 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$a() {
    var data = _taggedTemplateLiteral(["\n      background-image: url(", ");\n      background-repeat: no-repeat;\n      background-size: cover;\n    "]);

    _templateObject5$a = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$b() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 3px;\n  width: 239px;\n  height: 239px;\n  background-color: ", ";\n  padding: 0 16px 0 16px;\n  color: ", ";\n  font-weight: 600;\n\n  cursor: pointer;\n\n  ", "\n\n  ", "\n"]);

    _templateObject4$b = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$d() {
    var data = _taggedTemplateLiteral(["\n        ::after {\n          content: ' *';\n          color: ", ";\n        }\n      "]);

    _templateObject3$d = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$g() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  font-size: 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n\n  p {\n    margin-bottom: 8px;\n    margin-top: 0px;\n    display: block;\n    color: ", ";\n    ", "\n  }\n\n  span {\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 700;\n    color: ", ";\n    font-size: 12px;\n    margin-top: 2px;\n  }\n  ", " {\n    width: 100%;\n    max-width: 100%;\n  }\n"]);

    _templateObject2$g = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$p() {
    var data = _taggedTemplateLiteral(["\n  .MuiButtonBase-root {\n    width: 239px;\n    height: 32px;\n  }\n"]);

    _templateObject$p = function _templateObject() {
      return data;
    };

    return data;
  }
  var Container$4 = styled__default.div(_templateObject$p());
  var InputLabel$1 = styled__default.label(_templateObject2$g(), theme.colors.blue900, function (_ref) {
    var isRequired = _ref.isRequired,
        label = _ref.label;
    return isRequired && label && styled.css(_templateObject3$d(), theme.colors.pink900);
  }, theme.colors.pink900, theme.breakpoints.down('md'));
  var InputWrapper$2 = styled__default.div(_templateObject4$b(), theme.colors.grey500, theme.colors.white100, function (_ref2) {
    var previewUrl = _ref2.previewUrl,
        variant = _ref2.variant;
    return previewUrl && !variant && styled.css(_templateObject5$a(), previewUrl);
  }, function (_ref3) {
    var variant = _ref3.variant;
    return variant && styled.css(_templateObject6$6(), theme.colors.white100, theme.colors.grey600);
  });
  var IconWrapper = styled__default.div(_templateObject7$5());
  var InputFile = styled__default.input(_templateObject8$3());
  var InputEmptyText = styled__default.div(_templateObject9$3());
  var InputEmptyTitle = styled__default.div(_templateObject10$2());

  /**
   * @typedef {object} InputProps
   * @property {(event) => void} [onChangeHandler]
   * @property {Record<string, unknown>} [containerStyle]
   * @property {string} [previewUrl]
   * @property {string} [emptyTitle]
   * @property {string || JSX.Element} [emptyText]
   * @property {string} [label]
   * @property {boolean} [isRequired]
   * @property {boolean} [hasButton]
   * @property {boolean} [variant]
   * @property {string} [buttonText]
   */

  /** @type {import('react').FC<InputProps} */

  var InputFileField = function InputFileField(_ref) {
    var _ref$onChangeHandler = _ref.onChangeHandler,
        onChangeHandler = _ref$onChangeHandler === void 0 ? function () {} : _ref$onChangeHandler,
        _ref$containerStyle = _ref.containerStyle,
        containerStyle = _ref$containerStyle === void 0 ? {} : _ref$containerStyle,
        _ref$previewUrl = _ref.previewUrl,
        previewUrl = _ref$previewUrl === void 0 ? '' : _ref$previewUrl,
        _ref$emptyTitle = _ref.emptyTitle,
        emptyTitle = _ref$emptyTitle === void 0 ? '' : _ref$emptyTitle,
        _ref$emptyText = _ref.emptyText,
        emptyText = _ref$emptyText === void 0 ? '' : _ref$emptyText,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? '' : _ref$label,
        _ref$isRequired = _ref.isRequired,
        isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
        _ref$hasButton = _ref.hasButton,
        hasButton = _ref$hasButton === void 0 ? false : _ref$hasButton,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? false : _ref$variant,
        _ref$buttonText = _ref.buttonText,
        buttonText = _ref$buttonText === void 0 ? null : _ref$buttonText,
        props = _objectWithoutProperties(_ref, ["onChangeHandler", "containerStyle", "previewUrl", "emptyTitle", "emptyText", "label", "isRequired", "hasButton", "variant", "buttonText"]);

    var inputFileRef = React$2.useRef();
    return /*#__PURE__*/React$2__default.createElement(Container$4, null, /*#__PURE__*/React$2__default.createElement(InputLabel$1, {
      isRequired: isRequired,
      label: label
    }, label && /*#__PURE__*/React$2__default.createElement("p", null, label), /*#__PURE__*/React$2__default.createElement(InputFile, _extends({
      "data-testid": "test-input",
      ref: inputFileRef,
      type: "file",
      onChange: onChangeHandler
    }, props)), /*#__PURE__*/React$2__default.createElement(InputWrapper$2, {
      variant: variant,
      id: "input-wrapper",
      "data-testid": "test-input-wrapper",
      previewUrl: previewUrl,
      style: containerStyle
    }, !previewUrl && !variant && /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, /*#__PURE__*/React$2__default.createElement(IconWrapper, {
      "data-testid": "test-upload-icon"
    }, /*#__PURE__*/React$2__default.createElement(ImageUpload, null)), /*#__PURE__*/React$2__default.createElement(InputEmptyText, null, emptyText || 'Clique para fazer o upload de uma imagem de capa')), !previewUrl && variant && /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, /*#__PURE__*/React$2__default.createElement(InputEmptyTitle, null, emptyTitle || 'Clique para fazer o upload'), /*#__PURE__*/React$2__default.createElement(InputEmptyText, null, emptyText || /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, "O arquivo pode ter no m\xE1ximo ", /*#__PURE__*/React$2__default.createElement("span", null, "1 GB"), "."))), previewUrl && variant && /*#__PURE__*/React$2__default.createElement(InputEmptyTitle, null, "Arquivo: ", previewUrl))), hasButton && /*#__PURE__*/React$2__default.createElement(ButtonV2, {
      outline: true,
      text: buttonText || previewUrl ? 'Editar foto' : 'Escolher foto',
      marginHorizontal: -8,
      marginVertical: 12,
      icon: function icon() {
        return null;
      },
      onClick: function onClick() {
        return inputFileRef.current.click();
      }
    }));
  };

  function _templateObject9$4() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject9$4 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8$4() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject8$4 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7$6() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  font-size: 16px;\n  color: ", ";\n  border: none;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n  resize: none;\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  ", " {\n    font-size: 14px;\n  }\n"]);

    _templateObject7$6 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$7() {
    var data = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "]);

    _templateObject6$7 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$b() {
    var data = _taggedTemplateLiteral(["\n      border: 1px solid ", ";\n    "]);

    _templateObject5$b = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$c() {
    var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  height: 104px;\n  padding: 8px !important;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  background: ", ";\n\n  ", "\n\n  ", "\n\n  :focus-within {\n    outline: 5px auto ", ";\n    svg:not(:first-child) {\n      visibility: hidden;\n    }\n  }\n\n  svg {\n    min-width: 15px;\n    min-height: 15px;\n    margin: auto 0;\n\n    &:first-child {\n      margin-right: 10px;\n    }\n  }\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject4$c = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$e() {
    var data = _taggedTemplateLiteral(["\n        ::after {\n          content: ' *';\n          color: ", ";\n        }\n      "]);

    _templateObject3$e = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$h() {
    var data = _taggedTemplateLiteral(["\n      width: ", ";\n      max-width: initial;\n    "]);

    _templateObject2$h = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$q() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: ", "px;\n  font-size: 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n\n  ", "\n  p {\n    margin-bottom: 8px;\n    margin-top: 0px;\n    display: block;\n    color: ", ";\n    ", "\n  }\n\n  span {\n    font-family: 'Montserrat', sans-serif;\n    font-weight: 700;\n    color: ", ";\n    font-size: 12px;\n    margin-top: 2px;\n  }\n  ", " {\n    width: 100%;\n    max-width: 100%;\n  }\n"]);

    _templateObject$q = function _templateObject() {
      return data;
    };

    return data;
  }
  /** @type {import('styled-components').StyledComponent<"label", any, { isRequired: boolean, isSmall: boolean, label: string, width: string }>} */

  var InputLabel$2 = styled__default.label(_templateObject$q(), function (_ref) {
    var isSmall = _ref.isSmall;
    return isSmall ? '130' : '280';
  }, function (_ref2) {
    var width = _ref2.width;
    return width && styled.css(_templateObject2$h(), width);
  }, theme.colors.blue900, function (_ref3) {
    var isRequired = _ref3.isRequired,
        label = _ref3.label;
    return isRequired && label && styled.css(_templateObject3$e(), theme.colors.pink900);
  }, theme.colors.pink900, theme.breakpoints.down('md'));
  /** @type {import('styled-components').StyledComponent<"(InputMask)", any, { hasError: boolean, isValid: boolean }>} */

  var InputWrapper$3 = styled__default.div(_templateObject4$c(), theme.colors.grey600, theme.colors.white100, function (_ref4) {
    var hasError = _ref4.hasError;
    return hasError && styled.css(_templateObject5$b(), theme.colors.pink900);
  }, function (_ref5) {
    var isValid = _ref5.isValid;
    return isValid && styled.css(_templateObject6$7(), theme.colors.green100);
  }, theme.colors.blue600, theme.breakpoints.down('md'));
  var TextAreaInput = styled__default.textarea(_templateObject7$6(), theme.colors.blue900, theme.colors.grey600, theme.breakpoints.down('md'));
  var ValidSignSVG$1 = styled__default(ValidSign)(_templateObject8$4());
  var InvalidSignSVG$1 = styled__default(InvalidSign)(_templateObject9$4());

  /**
   * @typedef {object} InputProps
   * @property {string} [errorMessage]
   * @property {boolean} [hasError]
   * @property {boolean} [isRequired]
   * @property {boolean} [isSmall]
   * @property {boolean} [isValid]
   * @property {string} [label]
   * @property {string} [placeholder]
   * @property {any} [inputRef]
   * @property {any} [children]
   * @property {string} [width]
   */

  /** @type {import('react').FC<InputProps & import('react-input-mask').Props>} */

  var TextAreaField = function TextAreaField(_ref) {
    var errorMessage = _ref.errorMessage,
        hasError = _ref.hasError,
        isRequired = _ref.isRequired,
        isSmall = _ref.isSmall,
        isValid = _ref.isValid,
        label = _ref.label,
        placeholder = _ref.placeholder,
        inputRef = _ref.inputRef,
        children = _ref.children,
        width = _ref.width,
        props = _objectWithoutProperties(_ref, ["errorMessage", "hasError", "isRequired", "isSmall", "isValid", "label", "placeholder", "inputRef", "children", "width"]);

    return /*#__PURE__*/React$2__default.createElement(InputLabel$2, {
      isRequired: isRequired,
      isSmall: isSmall,
      label: label,
      ref: inputRef,
      width: width
    }, /*#__PURE__*/React$2__default.createElement("p", null, label), /*#__PURE__*/React$2__default.createElement(InputWrapper$3, {
      hasError: !!hasError,
      isValid: !!isValid
    }, children, /*#__PURE__*/React$2__default.createElement(TextAreaInput, _extends({
      placeholder: placeholder
    }, props)), !!isValid && /*#__PURE__*/React$2__default.createElement(ValidSignSVG$1, null), !!hasError && /*#__PURE__*/React$2__default.createElement(InvalidSignSVG$1, null)), hasError && /*#__PURE__*/React$2__default.createElement("span", null, errorMessage));
  };
  TextAreaField.defaultProps = {
    errorMessage: null,
    hasError: false,
    isRequired: false,
    isSmall: false,
    isValid: null,
    label: null,
    placeholder: '',
    inputRef: null,
    children: null,
    width: null
  };

  function _templateObject4$d() {
    var data = _taggedTemplateLiteral(["\n  width: 1rem;\n  height: 1rem;\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  border-radius: 2px;\n  background-color: ", ";\n  color: white;\n  font-size: 12px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  display: grid;\n  place-items: center;\n"]);

    _templateObject4$d = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$f() {
    var data = _taggedTemplateLiteral(["\n      font-family: 'Montserrat', sans-serif;\n      font-weight: 700;\n      background: rgba(92, 181, 254, 0.2);\n      border: 1px solid ", ";\n    "]);

    _templateObject3$f = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$i() {
    var data = _taggedTemplateLiteral(["\n      width: ", "px;\n    "]);

    _templateObject2$i = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$r() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 8px 0 8px;\n  height: ", "px;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  margin-left: ", "px;\n  margin-right: ", "px;\n  border-radius: 3px;\n  cursor: pointer;\n  font-size: 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n  color: ", ";\n  background: ", ";\n  border: 1px solid ", ";\n\n  svg {\n    margin-right: 4px;\n  }\n\n  ", "\n\n  :focus {\n    outline: none;\n  }\n\n  ", "\n\n  ", " {\n    width: 48%;\n  }\n"]);

    _templateObject$r = function _templateObject() {
      return data;
    };

    return data;
  }
  var ButtonWrapper$3 = styled__default.button(_templateObject$r(), function (_ref) {
    var buttonHeight = _ref.buttonHeight;
    return buttonHeight;
  }, function (_ref2) {
    var marginVertical = _ref2.marginVertical;
    return marginVertical;
  }, function (_ref3) {
    var marginVertical = _ref3.marginVertical;
    return marginVertical;
  }, function (_ref4) {
    var marginHorizontal = _ref4.marginHorizontal;
    return marginHorizontal;
  }, function (_ref5) {
    var marginHorizontal = _ref5.marginHorizontal;
    return marginHorizontal;
  }, theme.colors.blue900, theme.colors.white100, theme.colors.grey500, function (_ref6) {
    var buttonWidth = _ref6.buttonWidth;
    return !!buttonWidth && styled.css(_templateObject2$i(), buttonWidth);
  }, function (_ref7) {
    var isActive = _ref7.isActive;
    return isActive && styled.css(_templateObject3$f(), theme.colors.blue600);
  }, theme.breakpoints.down('md'));
  var AbsoluteDiv = styled__default.div(_templateObject4$d(), theme.colors.pink900);

  /**
   * @typedef {object} SelectSectionButtonProps
   * @property {string} id
   * @property {() => void} onClick
   * @property {string} text
   * @property {number} notifications
   * @property {number} [marginVertical=0]
   * @property {number} [marginHorizontal=0]
   * @property {number} [buttonWidth=0]
   * @property {number} [buttonHeight=40]
   * @property {boolean} [isActive=false]
   */

  /** @type {import('react').FC<SelectSectionButtonProps>} */

  var SelectSectionButton = function SelectSectionButton(_ref) {
    var id = _ref.id,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick,
        text = _ref.text,
        notifications = _ref.notifications,
        _ref$marginVertical = _ref.marginVertical,
        marginVertical = _ref$marginVertical === void 0 ? 0 : _ref$marginVertical,
        _ref$marginHorizontal = _ref.marginHorizontal,
        marginHorizontal = _ref$marginHorizontal === void 0 ? 0 : _ref$marginHorizontal,
        _ref$buttonWidth = _ref.buttonWidth,
        buttonWidth = _ref$buttonWidth === void 0 ? 0 : _ref$buttonWidth,
        _ref$buttonHeight = _ref.buttonHeight,
        buttonHeight = _ref$buttonHeight === void 0 ? 40 : _ref$buttonHeight,
        _ref$isActive = _ref.isActive,
        isActive = _ref$isActive === void 0 ? false : _ref$isActive,
        _ref$icon = _ref.icon,
        icon = _ref$icon === void 0 ? null : _ref$icon,
        props = _objectWithoutProperties(_ref, ["id", "onClick", "text", "notifications", "marginVertical", "marginHorizontal", "buttonWidth", "buttonHeight", "isActive", "icon"]);

    return /*#__PURE__*/React$2__default.createElement(ButtonWrapper$3, _extends({
      id: id,
      marginVertical: marginVertical,
      marginHorizontal: marginHorizontal,
      buttonWidth: buttonWidth,
      buttonHeight: buttonHeight,
      onClick: onClick,
      type: "button",
      isActive: isActive
    }, props), !!icon && icon, text, notifications && /*#__PURE__*/React$2__default.createElement(AbsoluteDiv, null, notifications));
  };

  function _templateObject3$g() {
    var data = _taggedTemplateLiteral(["\n      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n      transition: 0.3s;\n\n      :hover {\n        box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.2);\n      }\n    "]);

    _templateObject3$g = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$j() {
    var data = _taggedTemplateLiteral(["\n      border-radius: ", ";\n    "]);

    _templateObject2$j = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$s() {
    var data = _taggedTemplateLiteral(["\n  padding: 1rem;\n  background-color: white;\n\n  ", "\n\n  ", "\n"]);

    _templateObject$s = function _templateObject() {
      return data;
    };

    return data;
  }
  var CardContainer = styled__default.div(_templateObject$s(), function (_ref) {
    var borderRadius = _ref.borderRadius;
    return borderRadius && styled.css(_templateObject2$j(), borderRadius);
  }, function (_ref2) {
    var hasBoxShadow = _ref2.hasBoxShadow;
    return hasBoxShadow && styled.css(_templateObject3$g());
  });

  /**
   * @typedef {object} CardProps
   * @property {string} id
   * @property {string} borderRadius
   * @property {boolean} hasBoxShadow
   */

  var Card$1 = function Card(_ref) {
    var id = _ref.id,
        borderRadius = _ref.borderRadius,
        hasBoxShadow = _ref.hasBoxShadow,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ["id", "borderRadius", "hasBoxShadow", "children"]);

    return /*#__PURE__*/React$2__default.createElement(CardContainer, _extends({
      id: id,
      borderRadius: borderRadius,
      hasBoxShadow: hasBoxShadow
    }, props), children);
  };

  function _templateObject2$k() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  text-align: center;\n\n  div {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 16px;\n\n    strong {\n      font-family: 'Montserrat';\n      font-weight: 600;\n      font-size: 12px;\n    }\n\n    p {\n      font-family: 'Montserrat';\n      font-weight: normal;\n      font-size: 14px;\n      margin: 0;\n    }\n  }\n"]);

    _templateObject2$k = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$t() {
    var data = _taggedTemplateLiteral(["\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: ", ";\n  margin-left: 8px;\n"]);

    _templateObject$t = function _templateObject() {
      return data;
    };

    return data;
  }
  var useStyles$2 = styles.makeStyles({
    root: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      boxSizing: 'border-box'
    },
    table: {
      fontFamily: 'Montserrat',
      fontWeight: 400
    },
    tableContainer: {
      fontFamily: 'Montserrat',
      fontWeight: 400
    },
    tableHead: {
      fontFamily: 'Montserrat',
      fontWeight: 700,
      fontSize: '12px',
      color: 'var(--greyPrimary)'
    },
    evenRow: {
      backgroundColor: 'var(--white100)',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '14px',
      color: 'var(--brandPrimaryDark)'
    },
    oddRow: {
      backgroundColor: 'var(--grey500)',
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '14px',
      color: 'var(--brandPrimaryDark)'
    },
    tableBody: {
      fontFamily: 'Montserrat',
      fontWeight: 400,
      fontSize: '14px',
      color: 'var(--brandPrimaryDark)',
      whiteSpace: 'nowrap'
    },
    paginationTypography: {
      '& div.MuiTablePagination-selectRoot': {
        display: 'none'
      },
      '& p': {
        fontWeight: 600,
        fontFamily: 'Montserrat',
        fontSize: '14px',
        color: 'var(--greyPrimary)'
      },
      '& div.MuiTablePagination-actions': {
        color: 'var(--pink900)'
      },
      '& button.Mui-disabled': {
        color: 'var(--greyPrimary)'
      }
    },
    mobileBox: {
      '& *': {
        width: '100%'
      }
    }
  });
  var Circle = styled__default.div(_templateObject$t(), function (_ref) {
    var color = _ref.color;
    return color ? color : 'var(--greyLight)';
  });
  var MobileBox = styled__default.div(_templateObject2$k());
  var useStylesPagination = styles.makeStyles({
    root: {
      flexShrink: 0,
      '& button.MuiButtonBase-root': {
        color: 'var(--pink900)'
      },
      '& button.Mui-disabled': {
        color: 'var(--greyPrimary)'
      }
    }
  });

  function _templateObject$u() {
    var data = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  background-color: ", ";\n  padding: 8px;\n  border-radius: 5px;\n  font-family: 'Montserrat';\n  font-weight: 600;\n  font-size: 12px;\n  color: ", ";\n  width: fit-content;\n"]);

    _templateObject$u = function _templateObject() {
      return data;
    };

    return data;
  }
  var TagStyle = styled__default.span(_templateObject$u(), function (_ref) {
    var color = _ref.color;
    return color;
  }, function (_ref2) {
    var textColor = _ref2.textColor;
    return textColor ? textColor : 'var(--greyPrimary)';
  });

  /**
   * @typedef {object} TagProps
   * @property {array} text
   * @property {array} color
   */

  var Tag = function Tag(_ref) {
    var text = _ref.text,
        color = _ref.color,
        textColor = _ref.textColor;
    return /*#__PURE__*/React$2__default.createElement(TagStyle, {
      color: color,
      textColor: textColor
    }, text);
  };

  var useScreenMeasure = function useScreenMeasure() {
    var _useState = React$2.useState([window.innerWidth, window.innerHeight]),
        _useState2 = _slicedToArray(_useState, 2),
        dimensions = _useState2[0],
        setDimensions = _useState2[1];

    React$2.useEffect(function () {
      window.addEventListener('resize', function () {
        return setDimensions([window.innerWidth, window.innerHeight]);
      });
      return function () {
        window.removeEventListener('resize', function () {
          return setDimensions([window.innerWidth, window.innerHeight]);
        });
      };
    }, []);

    if ((typeof window === "undefined" ? "undefined" : _typeof(window)) != undefined) {
      return dimensions[0] <= 800;
    }

    return false;
  };

  var useOpen = function useOpen() {
    var _useState = React$2.useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        open = _useState2[0],
        setOpen = _useState2[1];

    var handleOpen = React$2.useCallback(function (state) {
      setOpen(state);
    }, [setOpen]);
    return {
      open: open,
      handleOpen: handleOpen
    };
  };

  /**
   * @typedef {object} MobileRows
   * @property {array} headers
   * @property {array} rows
   * @property {array} mobileHeaders
   * @property {string} classes
   */

  function MobileRows(_ref) {
    var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? [] : _ref$headers,
        _ref$row = _ref.row,
        row = _ref$row === void 0 ? [] : _ref$row,
        _ref$mobileHeaders = _ref.mobileHeaders,
        mobileHeaders = _ref$mobileHeaders === void 0 ? [] : _ref$mobileHeaders,
        index = _ref.index,
        classes = _ref.classes;

    var _useOpen = useOpen(),
        open = _useOpen.open,
        handleOpen = _useOpen.handleOpen;

    return /*#__PURE__*/React$2__default.createElement(React$2__default.Fragment, null, /*#__PURE__*/React$2__default.createElement(TableRow, {
      className: index % 2 === 0 ? classes.evenRow : classes.oddRow,
      onClick: function onClick() {
        return handleOpen(!open);
      },
      style: {
        cursor: 'pointer'
      }
    }, mobileHeaders.map(function (element) {
      return /*#__PURE__*/React$2__default.createElement(TableCell, {
        key: row[element.name],
        component: "th",
        scope: "row",
        className: classes.tableBody,
        style: {
          borderBottom: open && 'none'
        }
      }, element.name == 'status' ? /*#__PURE__*/React$2__default.createElement(Circle, {
        color: row.statusColor
      }) : row[element.name]);
    }), /*#__PURE__*/React$2__default.createElement(TableCell, {
      padding: "none",
      style: {
        borderBottom: open && 'none'
      }
    }, /*#__PURE__*/React$2__default.createElement(IconButton, {
      "aria-label": "expand row",
      size: "small",
      style: {
        color: 'var(--pink900)'
      },
      onClick: function onClick() {
        return handleOpen(!open);
      }
    }, open ? /*#__PURE__*/React$2__default.createElement(KeyboardArrowUpIcon, null) : /*#__PURE__*/React$2__default.createElement(KeyboardArrowDownIcon, null)))), /*#__PURE__*/React$2__default.createElement(TableRow, null, /*#__PURE__*/React$2__default.createElement(TableCell, {
      style: {
        padding: 0
      },
      colSpan: mobileHeaders.length + 1
    }, /*#__PURE__*/React$2__default.createElement(Collapse, {
      "in": open,
      timeout: "auto",
      unmountOnExit: true,
      className: "".concat(index % 2 === 0 ? classes.evenRow : classes.oddRow, " ").concat(classes.mobileBox)
    }, /*#__PURE__*/React$2__default.createElement(Box$2, null, /*#__PURE__*/React$2__default.createElement(MobileBox, null, headers.map(function (element) {
      return !mobileHeaders.map(function (mobileHeader) {
        return mobileHeader.name;
      }).includes(element.name) === true ? /*#__PURE__*/React$2__default.createElement("div", {
        key: uuid.v4()
      }, /*#__PURE__*/React$2__default.createElement("strong", null, element.data), /*#__PURE__*/React$2__default.createElement("p", null, row[element.name])) : null;
    })))))));
  }

  /**
   * @typedef {object} TableComponentProps
   * @property {array} headers
   * @property {array} rows
   * @property {array} mobileHeaders
   */

  var TableComponent = function TableComponent(_ref) {
    var _ref$headers = _ref.headers,
        headers = _ref$headers === void 0 ? [] : _ref$headers,
        _ref$rows = _ref.rows,
        rows = _ref$rows === void 0 ? [] : _ref$rows,
        _ref$mobileHeaders = _ref.mobileHeaders,
        mobileHeaders = _ref$mobileHeaders === void 0 ? [] : _ref$mobileHeaders,
        _ref$customPagination = _ref.customPagination,
        customPagination = _ref$customPagination === void 0 ? [] : _ref$customPagination,
        _ref$handleBackButton = _ref.handleBackButtonClick,
        handleBackButtonClick = _ref$handleBackButton === void 0 ? function () {} : _ref$handleBackButton,
        _ref$handleNextButton = _ref.handleNextButtonClick,
        handleNextButtonClick = _ref$handleNextButton === void 0 ? function () {} : _ref$handleNextButton;
    var isMobile = useScreenMeasure();

    var _useState = React$2.useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        page = _useState2[0],
        setPage = _useState2[1];

    var _useState3 = React$2.useState(5),
        _useState4 = _slicedToArray(_useState3, 2),
        rowsPerPage = _useState4[0],
        setRowsPerPage = _useState4[1];

    var classes = useStyles$2();

    var handleChangePage = function handleChangePage(_event, newPage) {
      setPage(newPage);
    };

    var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
      setRowsPerPage(parseInt(event.target.value, 10));
      setPage(0);
    };

    var _customPagination$ = _objectSpread2({}, customPagination[0]),
        totalItems = _customPagination$.totalItems,
        itemPerPage = _customPagination$.itemPerPage,
        currentPage = _customPagination$.currentPage;

    return /*#__PURE__*/React$2__default.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React$2__default.createElement(TableContainer, {
      className: classes.tableContainer,
      component: Paper
    }, /*#__PURE__*/React$2__default.createElement(Table, {
      className: classes.table
    }, /*#__PURE__*/React$2__default.createElement(TableHead, null, /*#__PURE__*/React$2__default.createElement(TableRow, null, !isMobile || mobileHeaders.length === 0 ? headers.map(function (element) {
      return /*#__PURE__*/React$2__default.createElement(TableCell, {
        key: element.name,
        className: classes.tableHead
      }, element.data);
    }) : mobileHeaders.map(function (element) {
      return /*#__PURE__*/React$2__default.createElement(TableCell, {
        key: element.name,
        className: classes.tableHead
      }, element.data);
    }), /*#__PURE__*/React$2__default.createElement(TableCell, {
      padding: "none"
    }))), /*#__PURE__*/React$2__default.createElement(TableBody, null, !isMobile || mobileHeaders.length === 0 ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row, index) {
      return /*#__PURE__*/React$2__default.createElement(TableRow, {
        key: uuid.v4(),
        className: index % 2 === 0 ? classes.evenRow : classes.oddRow
      }, headers.map(function (element) {
        return /*#__PURE__*/React$2__default.createElement(TableCell, {
          key: row[element.name],
          component: "th",
          scope: "row",
          className: classes.tableBody
        }, element.name == 'status' ? /*#__PURE__*/React$2__default.createElement(Tag, {
          text: row.status,
          color: row.statusColor
        }) : row[element.name]);
      }));
    }) : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row, index) {
      return /*#__PURE__*/React$2__default.createElement(MobileRows, {
        key: uuid.v4(),
        headers: headers,
        row: row,
        index: index,
        mobileHeaders: mobileHeaders,
        page: page,
        rowsPerPage: rowsPerPage,
        classes: classes
      });
    }))), rows.length > 5 && !customPagination.length && /*#__PURE__*/React$2__default.createElement(TablePagination, {
      className: classes.paginationTypography,
      rowsPerPageOptions: [5, 10, 25],
      count: rows.length,
      rowsPerPage: rowsPerPage,
      page: page,
      onChangePage: handleChangePage,
      onChangeRowsPerPage: handleChangeRowsPerPage,
      labelRowsPerPage: "",
      labelDisplayedRows: function labelDisplayedRows(_ref2) {
        var from = _ref2.from,
            to = _ref2.to,
            count = _ref2.count;
        return "".concat(from, "-").concat(to, " de ").concat(count);
      }
    }), !!customPagination.length && totalItems > itemPerPage && /*#__PURE__*/React$2__default.createElement(TablePagination, {
      className: classes.paginationTypography,
      rowsPerPageOptions: [itemPerPage],
      count: totalItems,
      page: currentPage,
      rowsPerPage: itemPerPage,
      onChangePage: function onChangePage() {},
      labelRowsPerPage: "",
      labelDisplayedRows: function labelDisplayedRows() {
        return "".concat(currentPage * itemPerPage - itemPerPage + 1, "-").concat(totalItems >= currentPage * itemPerPage ? currentPage * itemPerPage : totalItems, " de ").concat(totalItems);
      },
      ActionsComponent: function ActionsComponent() {
        return TablePaginationActions({
          count: totalItems,
          page: currentPage,
          rowsPerPage: itemPerPage,
          handleBackButtonClick: handleBackButtonClick,
          handleNextButtonClick: handleNextButtonClick
        });
      }
    })));
  };

  var TablePaginationActions = function TablePaginationActions(_ref3) {
    var count = _ref3.count,
        page = _ref3.page,
        rowsPerPage = _ref3.rowsPerPage,
        handleBackButtonClick = _ref3.handleBackButtonClick,
        handleNextButtonClick = _ref3.handleNextButtonClick;
    var classes = useStylesPagination();
    return /*#__PURE__*/React$2__default.createElement("div", {
      className: classes.root
    }, /*#__PURE__*/React$2__default.createElement(IconButton, {
      onClick: handleBackButtonClick,
      disabled: page === 1,
      "aria-label": "previous page"
    }, /*#__PURE__*/React$2__default.createElement(KeyboardArrowLeftIcon, null)), /*#__PURE__*/React$2__default.createElement(IconButton, {
      onClick: handleNextButtonClick,
      disabled: page >= Math.ceil(count / rowsPerPage),
      "aria-label": "next page"
    }, /*#__PURE__*/React$2__default.createElement(KeyboardArrowRightIcon, null)));
  };

  function _templateObject$v() {
    var data = _taggedTemplateLiteral(["\n  width: ", ";\n  ", " {\n    width: 100%;\n  }\n"]);

    _templateObject$v = function _templateObject() {
      return data;
    };

    return data;
  }
  var View$1 = styled__default.div(_templateObject$v(), function (_ref) {
    var width = _ref.width;
    return width;
  }, theme.breakpoints.down('sm'));
  var customStyles$1 = function customStyles() {
    return {
      option: function option() {
        return {
          padding: 5,
          height: 35,
          fontSize: 14,
          paddingLeft: 13,
          color: theme.colors.blue800,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          '&:hover': {
            backgroundColor: theme.colors.grey500
          },
          textOverflow: 'ellipsis',
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden'
        };
      },
      control: function control(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          border: "1px solid ".concat(theme.colors.grey600),
          borderRadius: 6,
          height: 40,
          marginTop: 8,
          fontFamily: 'CenturyGothic, sans serif',
          cursor: 'pointer'
        });
      },
      singleValue: function singleValue(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.blue800,
          fontSize: 16,
          lineHeight: 34,
          fontWeight: 'bold'
        });
      },
      input: function input(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.blue800,
          fontSize: 16,
          fontFamily: 'CenturyGothic, sans serif'
        });
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.pink900,
          marginRight: 8
        });
      },
      placeholder: function placeholder() {
        return {
          fontFamily: 'CenturyGothic, sans serif',
          color: theme.colors.grey600,
          fontSize: 16
        };
      },
      indicatorSeparator: function indicatorSeparator() {
        return {};
      },
      menuList: function menuList(_menuList) {
        return _objectSpread2(_objectSpread2({}, _menuList), {}, {
          padding: 0,
          zIndex: 100
        });
      },
      menu: function menu(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          borderCollapse: 'separate',
          border: '1px solid var(--brandSecundary)',
          boxSizing: 'border-box',
          borderRadius: '9px',
          overflow: 'auto',
          fontFamily: 'CenturyGothic, sans serif'
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          padding: '2px 16px',
          fontSize: 20
        });
      }
    };
  };

  /**
   * @typedef {object} ReactSelectValue
   * @property {number | string} value
   * @property {string} label
   */

  /**
   * @typedef {object} SelectorProps
   * @property {Array<ReactSelectValue>} [options]
   * @property {ReactSelectValue} [value]
   * @property {((selectedValue: ReactSelectValue) => Void)} [onValueChange]
   * @property {string} [name]
   */

  /** @type {import('react').FC<SelectorProps>} */

  var SelectorV2 = function SelectorV2(_ref) {
    var _ref$options = _ref.options,
        options = _ref$options === void 0 ? [] : _ref$options,
        value = _ref.value,
        onValueChange = _ref.onValueChange,
        name = _ref.name,
        _ref$width = _ref.width,
        width = _ref$width === void 0 ? '360px' : _ref$width,
        props = _objectWithoutProperties(_ref, ["options", "value", "onValueChange", "name", "width"]);

    return /*#__PURE__*/React$2__default.createElement(View$1, {
      width: width
    }, /*#__PURE__*/React$2__default.createElement(index, _extends({
      inputProps: {
        'aria-label': {
          name: name
        }
      },
      noOptionsMessage: function noOptionsMessage() {
        return 'Sem opçōes';
      },
      styles: customStyles$1(),
      options: options,
      value: value,
      onChange: onValueChange
    }, props)));
  };

  function _templateObject2$l() {
    var data = _taggedTemplateLiteral(["\n  width: 16px;\n"]);

    _templateObject2$l = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$w() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  margin: 8px 0;\n  width: auto;\n  cursor: pointer;\n  &:hover {\n    opacity: 0.6;\n  }\n"]);

    _templateObject$w = function _templateObject() {
      return data;
    };

    return data;
  }
  var ItemCheck = styled__default.div(_templateObject$w());
  var WrapperIcon = styled__default.div(_templateObject2$l());

  // Used at checkbox component
  var Checked = function Checked() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("rect", {
      x: "1",
      y: "1",
      width: "30",
      height: "30",
      rx: "3",
      fill: "#70BCFB",
      stroke: "#5CB5FE"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M22.8125 11.93787L13.6875 20.5626L9.625 15.5004",
      stroke: "white",
      strokeWidth: "2.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  // Used at checkbox component
  var Unchecked = function Unchecked() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "32",
      height: "32",
      viewBox: "0 0 32 32",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("rect", {
      x: "1",
      y: "1",
      width: "30",
      height: "30",
      rx: "3",
      stroke: "#757575"
    }));
  };

  /**
   * @typedef {object} CheckboxProps
   * @property {string} id
   * @property {boolean} [status=false]
   * @property {(id) => Void} setFunction
   */

  /** @type {import('react').FC<CheckboxProps>} */

  var Checkbox = function Checkbox(_ref) {
    var _ref$id = _ref.id,
        id = _ref$id === void 0 ? 0 : _ref$id,
        _ref$status = _ref.status,
        status = _ref$status === void 0 ? false : _ref$status,
        _ref$setFunction = _ref.setFunction,
        setFunction = _ref$setFunction === void 0 ? function () {} : _ref$setFunction;
    return /*#__PURE__*/React$2__default.createElement(ItemCheck, {
      key: id,
      onClick: function onClick() {
        return setFunction(id);
      },
      "data-testid": "checkbox-container-".concat(id)
    }, /*#__PURE__*/React$2__default.createElement(WrapperIcon, null, status ? /*#__PURE__*/React$2__default.createElement(Checked, null) : /*#__PURE__*/React$2__default.createElement(Unchecked, null)));
  };

  var CheckedCircle = function CheckedCircle() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("circle", {
      cx: "8",
      cy: "8",
      r: "8",
      fill: "#5CB5FE"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      className: "light",
      d: "M12.3636 5.81818L6.98183 10.4864L4.36365 7.86817",
      stroke: "white",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject5$c() {
    var data = _taggedTemplateLiteral(["\n  height: 40px;\n  width: 100%;\n  display: flex;\n"]);

    _templateObject5$c = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$e() {
    var data = _taggedTemplateLiteral(["\n      color: var(--brandPrimary);\n    "]);

    _templateObject4$e = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$h() {
    var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  font-weight: bold;\n  font-size: 0.75rem;\n  line-height: 18px;\n  display: flex;\n  align-items: center;\n  margin: 0;\n\n  ", "\n\n  ", " {\n    font-size: 11px;\n  }\n\n  svg {\n    margin-right: 9px;\n\n    path {\n      stroke: ", ";\n\n      &.light {\n        stroke: ", ";\n      }\n    }\n  }\n\n  :hover {\n    cursor: inherit;\n  }\n"]);

    _templateObject3$h = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$m() {
    var data = _taggedTemplateLiteral(["\n  background-color: var(--brandPrimaryDark);\n  border-right: 1px solid var(--brandSecundaryLight);\n  display: flex;\n  flex-direction: row;\n  width: 50%;\n  align-items: center;\n  padding-left: 18px;\n"]);

    _templateObject2$m = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$x() {
    var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  z-index: 10;\n"]);

    _templateObject$x = function _templateObject() {
      return data;
    };

    return data;
  }
  var ContainerHeader$1 = styled__default.div(_templateObject$x(), theme.variables.spacer * 6.5);
  var ItemHeader$1 = styled__default.div(_templateObject2$m());
  var StepItem = styled__default.div(_templateObject3$h(), function (_ref) {
    var active = _ref.active;
    return active ? theme.colors.white100 : 'var(--brandSecundaryLight)';
  }, function (_ref2) {
    var isDone = _ref2.isDone;
    return isDone && styled.css(_templateObject4$e());
  }, theme.breakpoints.down('md'), function (_ref3) {
    var active = _ref3.active;
    return active ? theme.colors.white100 : 'var(--brandSecundaryLight)';
  }, theme.colors.white100);
  var WrapperItens$1 = styled__default.div(_templateObject5$c());

  /**
   * @typedef {object} HeaderProps
   * @property {array} [content]
   * @property {number} [current]
   */

  /** @type {import('react').FC<HeaderProps>} */

  var HeaderV2 = function HeaderV2(_ref) {
    var _ref$content = _ref.content,
        content = _ref$content === void 0 ? [] : _ref$content,
        _ref$current = _ref.current,
        current = _ref$current === void 0 ? 1 : _ref$current;
    return /*#__PURE__*/React$2__default.createElement(ContainerHeader$1, null, /*#__PURE__*/React$2__default.createElement(WrapperItens$1, null, content.map(function (item) {
      return /*#__PURE__*/React$2__default.createElement(ItemHeader$1, {
        key: item.id
      }, /*#__PURE__*/React$2__default.createElement(StepItem, {
        isDone: current > item.id,
        active: current === item.id
      }, current > item.id ? /*#__PURE__*/React$2__default.createElement(CheckedCircle, null) : item.icon, item.name));
    })));
  };

  var ExternalLink = function ExternalLink() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M8 15L13 10M13 10L8 5M13 10H1M12 1H18.0909C18.332 1 18.5632 1.09578 18.7337 1.26627C18.9042 1.43675 19 1.66799 19 1.90909V18.0908C19 18.3319 18.9042 18.5632 18.7337 18.7337C18.5632 18.9042 18.332 18.9999 18.0909 18.9999H12",
      stroke: "black",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject2$n() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  cursor: inherit;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.005em;\n\n  svg {\n    height: 18px;\n    margin-left: 9px;\n  }\n\n  ", " {\n    font-size: 13.2px;\n    line-height: 20px;\n\n    svg {\n      height: 14px;\n      margin-left: 7px;\n    }\n  }\n"]);

    _templateObject2$n = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$y() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  padding: 2px;\n  width: fit-content;\n  height: fit-content;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: ", ";\n\n  svg {\n    path {\n      stroke: ", ";\n    }\n  }\n\n  :hover {\n    color: ", ";\n    path {\n      stroke: ", ";\n    }\n  }\n\n  :active {\n    color: ", ";\n    path {\n      stroke: ", ";\n    }\n  }\n\n  :focus,\n  :focus-within {\n    color: ", ";\n    outline: ", " auto 2px;\n    path {\n      stroke: ", ";\n    }\n  }\n\n  :disabled {\n    cursor: initial;\n    color: ", ";\n    path {\n      stroke: ", ";\n    }\n  }\n"]);

    _templateObject$y = function _templateObject() {
      return data;
    };

    return data;
  }
  var ButtonContainer$1 = styled__default.button(_templateObject$y(), function (_ref) {
    var textColor = _ref.textColor;
    return textColor;
  }, function (_ref2) {
    var textColor = _ref2.textColor;
    return textColor;
  }, function (_ref3) {
    var hoverColor = _ref3.hoverColor;
    return hoverColor;
  }, function (_ref4) {
    var hoverColor = _ref4.hoverColor;
    return hoverColor;
  }, function (_ref5) {
    var pressedColor = _ref5.pressedColor;
    return pressedColor;
  }, function (_ref6) {
    var pressedColor = _ref6.pressedColor;
    return pressedColor;
  }, function (_ref7) {
    var focusedColor = _ref7.focusedColor;
    return focusedColor;
  }, function (_ref8) {
    var focusedColor = _ref8.focusedColor;
    return focusedColor;
  }, function (_ref9) {
    var focusedColor = _ref9.focusedColor;
    return focusedColor;
  }, function (_ref10) {
    var disabledColor = _ref10.disabledColor;
    return disabledColor;
  }, function (_ref11) {
    var disabledColor = _ref11.disabledColor;
    return disabledColor;
  });
  var ButtonLabel = styled__default.label(_templateObject2$n(), theme.breakpoints.down('md'));

  /**
   * @typedef {object} TextButtonProps
   * @property {string} [text]
   * @property {boolean} [icon=false]
   * @property {boolean} [disabled=false]
   * @property {string} [color='var(--brandPrimary)']
   * @property {string} [hoverColor='var(--brandSecundary)']
   * @property {string} [pressedColor='var(--brandPrimaryDark)']
   * @property {string} [focusedColor='var(--brandSecundary)']
   * @property {string} [disabledColor='var(--greyPrimary)']
   */

  var TextButton = function TextButton(_ref, props) {
    var _ref$text = _ref.text,
        text = _ref$text === void 0 ? '' : _ref$text,
        _ref$icon = _ref.icon,
        icon = _ref$icon === void 0 ? false : _ref$icon,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$color = _ref.color,
        color = _ref$color === void 0 ? 'var(--brandPrimary)' : _ref$color,
        _ref$hoverColor = _ref.hoverColor,
        hoverColor = _ref$hoverColor === void 0 ? 'var(--brandSecundary)' : _ref$hoverColor,
        _ref$pressedColor = _ref.pressedColor,
        pressedColor = _ref$pressedColor === void 0 ? 'var(--brandPrimaryDark)' : _ref$pressedColor,
        _ref$focusedColor = _ref.focusedColor,
        focusedColor = _ref$focusedColor === void 0 ? 'var(--brandSecundary)' : _ref$focusedColor,
        _ref$disabledColor = _ref.disabledColor,
        disabledColor = _ref$disabledColor === void 0 ? 'var(--greyPrimary)' : _ref$disabledColor,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === void 0 ? function () {} : _ref$onClick;
    return /*#__PURE__*/React$2__default.createElement(ButtonContainer$1, _extends({
      "aria-label": text,
      disabled: disabled,
      textColor: color,
      hoverColor: hoverColor,
      pressedColor: pressedColor,
      focusedColor: focusedColor,
      disabledColor: disabledColor,
      onClick: disabled ? null : onClick
    }, props), /*#__PURE__*/React$2__default.createElement(ButtonLabel, {
      className: "button-label"
    }, text, icon && /*#__PURE__*/React$2__default.createElement(ExternalLink, null)));
  };

  var AngleArrow = function AngleArrow() {
    return /*#__PURE__*/React$2__default.createElement("svg", {
      width: "12",
      height: "12",
      viewBox: "0 0 12 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React$2__default.createElement("path", {
      d: "M4 1L9 6L4 11",
      stroke: "var(--bluePrimary)",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject3$i() {
    var data = _taggedTemplateLiteral(["\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n  font-size: 13px;\n  line-height: 20px;\n  color: ", ";\n"]);

    _templateObject3$i = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$o() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n\n  &:last-child {\n    svg {\n      display: none;\n    }\n\n    span {\n      font-weight: 700;\n      color: ", ";\n    }\n  }\n\n  svg {\n    margin: 0 8px;\n\n    path {\n      stroke: ", ";\n    }\n  }\n"]);

    _templateObject2$o = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$z() {
    var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"]);

    _templateObject$z = function _templateObject() {
      return data;
    };

    return data;
  }
  var Container$5 = styled__default.div(_templateObject$z());
  var Crumb = styled__default.div(_templateObject2$o(), function (_ref) {
    var currentColor = _ref.currentColor;
    return currentColor || 'var(--black100)';
  }, function (_ref2) {
    var currentColor = _ref2.currentColor;
    return currentColor || 'var(--black100)';
  });
  var Text$3 = styled__default.span(_templateObject3$i(), function (_ref3) {
    var color = _ref3.color;
    return color || 'var(--greyNeutral)';
  });

  /**
   * @typedef {object} Breadcrumbs
   * @property {string} color
   * @property {string} currentColor
   * @property {Array<any>} [levels]
   */

  /** @type {import('react').FC<Breadcrumbs>} */

  var Breadcrumbs = function Breadcrumbs(_ref) {
    var color = _ref.color,
        currentColor = _ref.currentColor,
        levels = _ref.levels;
    return /*#__PURE__*/React$2__default.createElement(Container$5, {
      className: "breadcrumb-container"
    }, levels === null || levels === void 0 ? void 0 : levels.map(function (level, index) {
      return /*#__PURE__*/React$2__default.createElement(Crumb, {
        key: index.toString(),
        currentColor: currentColor,
        className: "crumb"
      }, /*#__PURE__*/React$2__default.createElement(Text$3, {
        color: color
      }, level), /*#__PURE__*/React$2__default.createElement(AngleArrow, null));
    }));
  };

  var InvalidSignV2 = function InvalidSignV2(_ref) {
    var props = _extends({}, _ref);

    return /*#__PURE__*/React$2.createElement("svg", _extends({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "https://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React$2.createElement("path", {
      d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
      fill: "#B30142"
    }), /*#__PURE__*/React$2.createElement("path", {
      d: "M10 15C10.5523 15 11 14.5523 11 14C11 13.4477 10.5523 13 10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15Z",
      fill: "white"
    }), /*#__PURE__*/React$2.createElement("rect", {
      x: "9",
      y: "5",
      width: "2",
      height: "6",
      rx: "1",
      fill: "white"
    }));
  };

  var LockV2 = function LockV2(props) {
    return /*#__PURE__*/React$2__default.createElement("svg", _extends({
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "https://www.w3.org/2000/svg"
    }, props), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M16.3636 8H3.63636C3.28491 8 3 8.27982 3 8.625V17.375C3 17.7202 3.28491 18 3.63636 18H16.3636C16.7151 18 17 17.7202 17 17.375V8.625C17 8.27982 16.7151 8 16.3636 8Z",
      fill: "#575757"
    }), /*#__PURE__*/React$2__default.createElement("path", {
      d: "M7 8V5C7 4.20435 7.31607 3.44129 7.87868 2.87868C8.44129 2.31607 9.20435 2 10 2C10.7956 2 11.5587 2.31607 12.1213 2.87868C12.6839 3.44129 13 4.20435 13 5V8",
      stroke: "#575757",
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }));
  };

  function _templateObject17$1() {
    var data = _taggedTemplateLiteral(["\n      ::after {\n        content: ' *';\n        color: ", ";\n      }\n    "]);

    _templateObject17$1 = function _templateObject17() {
      return data;
    };

    return data;
  }

  function _templateObject16$1() {
    var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.005em;\n  margin-bottom: 8px;\n  margin-top: 0px;\n  display: block;\n  color: ", ";\n  ", "\n\n  ", " {\n    font-size: 13.2px;\n    line-height: 20px;\n  }\n"]);

    _templateObject16$1 = function _templateObject16() {
      return data;
    };

    return data;
  }

  function _templateObject15$1() {
    var data = _taggedTemplateLiteral(["\n  color: ", ";\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.0075em;\n  margin-top: 8px;\n\n  ", " {\n    font-size: 13.2px;\n    line-height: 20px;\n    letter-spacing: 0.005em;\n  }\n"]);

    _templateObject15$1 = function _templateObject15() {
      return data;
    };

    return data;
  }

  function _templateObject14$1() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject14$1 = function _templateObject14() {
      return data;
    };

    return data;
  }

  function _templateObject13$1() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject13$1 = function _templateObject13() {
      return data;
    };

    return data;
  }

  function _templateObject12$1() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject12$1 = function _templateObject12() {
      return data;
    };

    return data;
  }

  function _templateObject11$1() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  font-size: 16px;\n  color: var(--black100);\n  border: none;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n\n  &[disabled] {\n    color: ", ";\n    background: transparent;\n    cursor: ", ";\n    user-select: none;\n  }\n\n  ::placeholder {\n    color: ", ";\n  }\n\n  :focus {\n    outline: none;\n  }\n\n  ", " {\n    font-size: 14px;\n  }\n"]);

    _templateObject11$1 = function _templateObject11() {
      return data;
    };

    return data;
  }

  function _templateObject10$3() {
    var data = _taggedTemplateLiteral(["\n      cursor: progress;\n    "]);

    _templateObject10$3 = function _templateObject10() {
      return data;
    };

    return data;
  }

  function _templateObject9$5() {
    var data = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n      cursor: not-allowed;\n    "]);

    _templateObject9$5 = function _templateObject9() {
      return data;
    };

    return data;
  }

  function _templateObject8$5() {
    var data = _taggedTemplateLiteral(["\n      svg {\n        circle {\n          fill: ", ";\n        }\n      }\n    "]);

    _templateObject8$5 = function _templateObject8() {
      return data;
    };

    return data;
  }

  function _templateObject7$7() {
    var data = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n      svg {\n        circle: ", ";\n      }\n    "]);

    _templateObject7$7 = function _templateObject7() {
      return data;
    };

    return data;
  }

  function _templateObject6$8() {
    var data = _taggedTemplateLiteral(["\n      border: 2px solid ", ";\n    "]);

    _templateObject6$8 = function _templateObject6() {
      return data;
    };

    return data;
  }

  function _templateObject5$d() {
    var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  width: 100%;\n  height: 48px;\n  padding: 8px !important;\n  border: 1px solid ", ";\n  border-radius: 3px;\n  background: ", ";\n  border: 2px solid ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n\n    ", "\n\n    \n    \n\n  :focus-within {\n    svg:not(:first-child) {\n      visibility: hidden;\n    }\n  }\n\n  svg {\n    min-width: 15px;\n    min-height: 15px;\n    margin: auto 0;\n\n    &:first-child {\n      margin-right: 10px;\n      stroke: var(--black100);\n    }\n  }\n  ", " {\n    width: 100%;\n  }\n\n  :focus-within {\n    outline: 2px auto ", ";\n  }\n"]);

    _templateObject5$d = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$f() {
    var data = _taggedTemplateLiteral(["\n        width: ", ";\n        max-width: 100%;\n      "]);

    _templateObject4$f = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$j() {
    var data = _taggedTemplateLiteral(["\n      width: ", ";\n      max-width: 100%;\n    "]);

    _templateObject3$j = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$p() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: border-box;\n  }\n\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: ", "px;\n  font-size: 14px;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 700;\n\n  ", " {\n    width: 100%;\n    max-width: 100%;\n  }\n\n  ", "\n\n  ", " {\n    ", "\n  }\n"]);

    _templateObject2$p = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$A() {
    var data = _taggedTemplateLiteral(["\n  width: 100%;\n"]);

    _templateObject$A = function _templateObject() {
      return data;
    };

    return data;
  }
  var Container$6 = styled__default.div(_templateObject$A());
  var InputLabel$3 = styled__default.label(_templateObject2$p(), function (_ref) {
    var isSmall = _ref.isSmall;
    return isSmall ? '130' : '280';
  }, theme.breakpoints.down('md'), function (_ref2) {
    var width = _ref2.width;
    return width && styled.css(_templateObject3$j(), width);
  }, theme.breakpoints.down('md'), function (_ref3) {
    var mobileWidth = _ref3.mobileWidth;
    return mobileWidth && styled.css(_templateObject4$f(), mobileWidth);
  });
  /** @type {import('styled-components').StyledComponent<"(InputMask)", any, { hasError: boolean, isValid: boolean, isDisabled: boolean, isDarkBackground: boolean, isLoading: boolean }>} */

  var InputWrapper$4 = styled__default.div(_templateObject5$d(), theme.colors.white100, theme.colors.white100, theme.colors.bluePrimaryLight, function (_ref4) {
    var isDarkBackground = _ref4.isDarkBackground;
    return isDarkBackground && styled.css(_templateObject6$8(), theme.colors.white100);
  }, function (_ref5) {
    var hasError = _ref5.hasError;
    return hasError && styled.css(_templateObject7$7(), theme.colors.red200, theme.colors.red300);
  }, function (_ref6) {
    var isValid = _ref6.isValid;
    return isValid && styled.css(_templateObject8$5(), theme.colors.bluePrimary);
  }, function (_ref7) {
    var isDisabled = _ref7.isDisabled,
        isDarkBackground = _ref7.isDarkBackground;
    return isDisabled && styled.css(_templateObject9$5(), isDarkBackground ? theme.colors.white100 : theme.colors.greyLight);
  }, function (_ref8) {
    var isLoading = _ref8.isLoading;
    return isLoading && styled.css(_templateObject10$3());
  }, theme.breakpoints.down('md'), function (_ref9) {
    var variant = _ref9.variant;
    return variant ? theme.colors.white100 : theme.colors.bluePrimary;
  });
  var MaskedInput$1 = styled__default(reactInputMask)(_templateObject11$1(), theme.colors.greyPrimary, function (_ref10) {
    var isLoading = _ref10.isLoading;
    return isLoading ? 'progress' : 'not-allowed';
  }, theme.colors.greyNeutral, theme.breakpoints.down('sm'));
  var ValidSignSVG$2 = styled__default(ValidSign)(_templateObject12$1());
  var InvalidSignSVG$2 = styled__default(InvalidSignV2)(_templateObject13$1());
  var LockSVG = styled__default(LockV2)(_templateObject14$1());
  var Error$2 = styled__default.span(_templateObject15$1(), function (_ref11) {
    var variant = _ref11.variant;
    return variant ? 'var(--white100)' : theme.colors.red300;
  }, theme.breakpoints.down('sm'));
  var Label$1 = styled__default.p(_templateObject16$1(), function (_ref12) {
    var variant = _ref12.variant;
    return variant ? theme.colors.white100 : 'var(--black100)';
  }, function (_ref13) {
    var isRequired = _ref13.isRequired,
        label = _ref13.label;
    return isRequired && label && styled.css(_templateObject17$1(), theme.colors.pink900);
  }, theme.breakpoints.down('sm'));

  /**
   * @typedef {object} InputProps
   * @property {string} [errorMessage]
   * @property {boolean} [hasError]
   * @property {boolean} [isRequired]
   * @property {boolean} [isSmall]
   * @property {boolean} [isValid]
   * @property {string} [label]
   * @property {string} [mask]
   * @property {string} [placeholder]
   * @property {string} [backgroundColor]
   * @property {boolean} [variant]
   * @property {any} [inputRef]
   * @property {jsx} [icon]
   * @property {string} [maskChar]
   * @property {string} [width]
   * @property {string} [mobileWidth]
   * @property {boolean} [disabled]
   * @property {boolean} [isDarkBackground]
   * @property {boolean} [isLoading]
   */

  /** @type {import('react').FC<InputProps & import('react-input-mask').Props>} */

  var InputFieldV3 = function InputFieldV3(_ref) {
    var _ref$hasError = _ref.hasError,
        hasError = _ref$hasError === void 0 ? false : _ref$hasError,
        _ref$label = _ref.label,
        label = _ref$label === void 0 ? null : _ref$label,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === void 0 ? 'Digite aqui' : _ref$placeholder,
        _ref$mask = _ref.mask,
        mask = _ref$mask === void 0 ? '' : _ref$mask,
        _ref$maskChar = _ref.maskChar,
        maskChar = _ref$maskChar === void 0 ? ' ' : _ref$maskChar,
        _ref$isRequired = _ref.isRequired,
        isRequired = _ref$isRequired === void 0 ? false : _ref$isRequired,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? false : _ref$variant,
        _ref$isValid = _ref.isValid,
        isValid = _ref$isValid === void 0 ? null : _ref$isValid,
        _ref$inputRef = _ref.inputRef,
        inputRef = _ref$inputRef === void 0 ? null : _ref$inputRef,
        _ref$errorMessage = _ref.errorMessage,
        errorMessage = _ref$errorMessage === void 0 ? null : _ref$errorMessage,
        _ref$isSmall = _ref.isSmall,
        isSmall = _ref$isSmall === void 0 ? false : _ref$isSmall,
        _ref$icon = _ref.icon,
        icon = _ref$icon === void 0 ? null : _ref$icon,
        _ref$width = _ref.width,
        width = _ref$width === void 0 ? '280px' : _ref$width,
        _ref$mobileWidth = _ref.mobileWidth,
        mobileWidth = _ref$mobileWidth === void 0 ? '130px' : _ref$mobileWidth,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$isDarkBackground = _ref.isDarkBackground,
        isDarkBackground = _ref$isDarkBackground === void 0 ? false : _ref$isDarkBackground,
        _ref$isLoading = _ref.isLoading,
        isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
        props = _objectWithoutProperties(_ref, ["hasError", "label", "placeholder", "mask", "maskChar", "isRequired", "variant", "isValid", "inputRef", "errorMessage", "isSmall", "icon", "width", "mobileWidth", "disabled", "isDarkBackground", "isLoading"]);

    return /*#__PURE__*/React$2__default.createElement(Container$6, null, /*#__PURE__*/React$2__default.createElement(InputLabel$3, {
      isRequired: isRequired,
      isSmall: isSmall,
      label: label,
      ref: inputRef,
      width: width,
      mobileWidth: mobileWidth
    }, /*#__PURE__*/React$2__default.createElement(Label$1, {
      variant: variant
    }, label), /*#__PURE__*/React$2__default.createElement(InputWrapper$4, {
      variant: variant,
      hasError: !!hasError,
      isDisabled: !!disabled || isLoading,
      isLoading: !!isLoading,
      isValid: !!isValid && !isLoading,
      isDarkBackground: isDarkBackground
    }, icon, /*#__PURE__*/React$2__default.createElement(MaskedInput$1, _extends({
      placeholder: placeholder,
      mask: mask,
      maskChar: maskChar,
      disabled: disabled || isLoading,
      isLoading: !!isLoading
    }, props)), isLoading && /*#__PURE__*/React$2__default.createElement(CircularProgress, {
      color: "inherit",
      size: 16
    }), !!disabled && !isLoading && /*#__PURE__*/React$2__default.createElement(LockSVG, null), !!isValid && !disabled && !isLoading && /*#__PURE__*/React$2__default.createElement(ValidSignSVG$2, null), !!hasError && !disabled && !isLoading && /*#__PURE__*/React$2__default.createElement(InvalidSignSVG$2, null)), hasError && !disabled && /*#__PURE__*/React$2__default.createElement(Error$2, {
      variant: variant
    }, errorMessage)));
  };
  InputFieldV3.defaultProps = {
    errorMessage: null,
    hasError: false,
    isRequired: false,
    isSmall: false,
    isValid: null,
    label: null,
    mask: null,
    placeholder: '',
    inputRef: null,
    children: null,
    maskChar: null,
    width: null,
    mobileWidth: null,
    variant: false,
    isLoading: false
  };

  /**
   * @name getSelectedColor
   * @description Converts variant to design system color
   * @param {string}
   * @returns {Object}
   */

  var getSelectedColor = function getSelectedColor(type) {
    switch (type) {
      case 'light':
        return {
          enabledMark: theme.colors.white100,
          hoverMark: theme.colors.blueSecundaryLight,
          pressedMark: theme.colors.blueSecundaryDark,
          focusedMark: theme.colors.blueSecundaryLight,
          disabledMark: theme.colors.greyLight,
          enabledMarkOutline: theme.colors.bluePrimary,
          hoverMarkOutline: theme.colors.bluePrimaryDark,
          selectedMarkOutline: theme.colors.bluePrimary,
          disabledMarkOutline: theme.colors.greyPrimary,
          enabledText: theme.colors.black,
          hoverText: theme.colors.bluePrimary,
          pressedText: theme.colors.blueSecundary,
          selectedText: theme.colors.bluePrimaryDark,
          focusedText: theme.colors.bluePrimaryDark,
          focusedTextOutline: theme.colors.bluePrimaryDark,
          disabledText: theme.colors.greyPrimary
        };

      case 'primary':
        return {
          enabledMark: theme.colors.white100,
          hoverMark: theme.colors.bluePrimaryLight,
          pressedMark: theme.colors.blueSecundaryDark,
          focusedMark: theme.colors.bluePrimaryLight,
          disabledMark: theme.colors.greyLight,
          enabledMarkOutline: theme.colors.white100,
          hoverMarkOutline: theme.colors.bluePrimaryLight,
          selectedMarkOutline: theme.colors.white100,
          disabledMarkOutline: theme.colors.greyLight,
          enabledText: theme.colors.white100,
          hoverText: theme.colors.bluePrimaryLight,
          pressedText: theme.colors.blueSecundaryDark,
          selectedText: theme.colors.white100,
          focusedText: theme.colors.bluePrimaryLight,
          focusedTextOutline: theme.colors.white100,
          disabledText: theme.colors.greyLight
        };

      default:
        return {
          enabledMark: theme.colors.white100,
          hoverMark: theme.colors.bluePrimaryLight,
          pressedMark: theme.colors.blueSecundaryDark,
          focusedMark: theme.colors.bluePrimaryLight,
          disabledMark: theme.colors.greyLight,
          enabledMarkOutline: theme.colors.bluePrimary,
          hoverMarkOutline: theme.colors.bluePrimaryDark,
          selectedMarkOutline: theme.colors.bluePrimary,
          disabledMarkOutline: theme.colors.greyPrimary,
          enabledText: theme.colors.black,
          hoverText: theme.colors.bluePrimaryDark,
          pressedText: theme.colors.bluePrimaryDark,
          selectedText: theme.colors.bluePrimary,
          focusedText: theme.colors.bluePrimaryDark,
          focusedTextOutline: theme.colors.bluePrimary,
          disabledText: theme.colors.greyPrimary
        };
    }
  };

  function _templateObject5$e() {
    var data = _taggedTemplateLiteral(["\n  * {\n    box-sizing: content-box !important;\n  }\n"]);

    _templateObject5$e = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$g() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 3px;\n  left: 2px;\n  height: 22px;\n  width: 22px;\n  border: 1px solid ", ";\n  border-radius: 50%;\n  background: ", ";\n\n  transition: 180ms ease-in-out;\n"]);

    _templateObject4$g = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$k() {
    var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  opacity: 0.0001;\n  height: 100%;\n  width: 100%;\n\n  &:checked ~ span:after {\n    display: block;\n  }\n"]);

    _templateObject3$k = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$q() {
    var data = _taggedTemplateLiteral(["\n      color: ", ";\n      cursor: not-allowed;\n\n      :hover,\n      input:hover,\n      > div:hover {\n        ~ span,\n        input,\n        > span {\n          cursor: not-allowed;\n          color: ", " !important;\n          font-weight: 500;\n        }\n\n        ~ div {\n          background: ", ";\n          border: 1px solid ", ";\n        }\n      }\n\n      input ~ div {\n        background: ", ";\n        border: 1px solid ", ";\n      }\n\n      &:active {\n        div:nth-last-child(1) {\n          background: ", " !important;\n        }\n      }\n    "]);

    _templateObject2$q = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$B() {
    var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: center;\n  position: relative;\n  padding: 4px 4px 4px 34px;\n  height: 22px;\n\n  font-family: 'Montserrat', sans-serif;\n  border-radius: 4px;\n  border: 2px solid transparent;\n\n  cursor: pointer;\n  user-select: none;\n\n  color: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.0075em;\n\n  ", " {\n    font-size: 13.2px;\n    line-height: 20px;\n    letter-spacing: 0.005em;\n  }\n\n  input {\n    :checked {\n      ~ span {\n        border: 1px solid ", ";\n        color: ", ";\n        font-weight: 600;\n        letter-spacing: 0.005em;\n        border: none;\n      }\n\n      ~ div {\n        border: 1px solid ", ";\n        background: ", ";\n\n        div {\n          background: ", ";\n          width: 14px;\n          height: 14px;\n          left: 4px;\n          top: 4px;\n          border-radius: 50%;\n          position: absolute;\n        }\n      }\n    }\n\n    :active {\n      ~ span {\n        font-weight: 600;\n        letter-spacing: 0.005em;\n        color: ", ";\n      }\n    }\n\n    :focus ~ span,\n    :focus-within ~ span {\n      font-weight: 600;\n      letter-spacing: 0.005em;\n      color: ", ";\n    }\n\n    :hover {\n      ~ span {\n        font-weight: 600;\n        letter-spacing: 0.005em;\n        color: ", " !important;\n      }\n\n      ~ div {\n        border: 1px solid ", ";\n      }\n    }\n  }\n\n  &:focus,\n  &:focus-within {\n    border: 2px solid ", ";\n\n    div:nth-last-child(1) {\n      background: ", ";\n    }\n  }\n\n  &:active {\n    div:nth-last-child(1) {\n      background: ", " !important;\n    }\n  }\n\n  &:hover {\n    > span {\n      font-weight: 600;\n      letter-spacing: 0.005em;\n      color: ", ";\n    }\n    div {\n      background: ", ";\n    }\n  }\n\n  ", "\n\n  ~ div:hover {\n    ~ span {\n      font-weight: 600;\n      letter-spacing: 0.005em;\n      color: ", " !important;\n    }\n  }\n"]);

    _templateObject$B = function _templateObject() {
      return data;
    };

    return data;
  }
  var Label$2 = styled__default.label(_templateObject$B(), function (_ref) {
    var enabledText = _ref.enabledText;
    return enabledText;
  }, theme.breakpoints.down('sm'), function (_ref2) {
    var focusedTextOutline = _ref2.focusedTextOutline;
    return focusedTextOutline;
  }, function (_ref3) {
    var selectedText = _ref3.selectedText;
    return selectedText;
  }, function (_ref4) {
    var selectedMarkOutline = _ref4.selectedMarkOutline;
    return selectedMarkOutline;
  }, function (_ref5) {
    var enabledMark = _ref5.enabledMark;
    return enabledMark;
  }, theme.colors.bluePrimary, function (_ref6) {
    var pressedText = _ref6.pressedText;
    return pressedText;
  }, function (_ref7) {
    var focusedText = _ref7.focusedText;
    return focusedText;
  }, function (_ref8) {
    var hoverText = _ref8.hoverText;
    return hoverText;
  }, function (_ref9) {
    var hoverMarkOutline = _ref9.hoverMarkOutline;
    return hoverMarkOutline;
  }, function (_ref10) {
    var focusedTextOutline = _ref10.focusedTextOutline;
    return focusedTextOutline;
  }, function (_ref11) {
    var focusedMark = _ref11.focusedMark;
    return focusedMark;
  }, function (_ref12) {
    var pressedMark = _ref12.pressedMark;
    return pressedMark;
  }, function (_ref13) {
    var hoverText = _ref13.hoverText;
    return hoverText;
  }, function (_ref14) {
    var hoverMark = _ref14.hoverMark;
    return hoverMark;
  }, function (_ref15) {
    var disabled = _ref15.disabled;
    return disabled && styled.css(_templateObject2$q(), function (_ref16) {
      var disabledText = _ref16.disabledText;
      return disabledText;
    }, function (_ref17) {
      var disabledText = _ref17.disabledText;
      return disabledText;
    }, function (_ref18) {
      var disabledMark = _ref18.disabledMark;
      return disabledMark;
    }, function (_ref19) {
      var disabledMarkOutline = _ref19.disabledMarkOutline;
      return disabledMarkOutline;
    }, function (_ref20) {
      var disabledMark = _ref20.disabledMark;
      return disabledMark;
    }, function (_ref21) {
      var disabledMarkOutline = _ref21.disabledMarkOutline;
      return disabledMarkOutline;
    }, function (_ref22) {
      var disabledMark = _ref22.disabledMark;
      return disabledMark;
    });
  }, function (_ref23) {
    var hoverText = _ref23.hoverText;
    return hoverText;
  });
  var Radio = styled__default.input.attrs({
    type: 'radio'
  })(_templateObject3$k());
  var Mark = styled__default.div(_templateObject4$g(), theme.colors.bluePrimary, function (_ref24) {
    var enabledMark = _ref24.enabledMark;
    return enabledMark;
  });
  var Container$7 = styled__default.div(_templateObject5$e());

  /**
   * @typedef {object} RadioWrapper
   * @property {string} text
   * @property {string} name
   * @property {'white | light | primary'} variant
   * @property {any} value
   * @property {boolean} readOnly
   * @property {void} onChange
   */

  /** @type {import('react').FC<RadioWrapper>} */

  var RadioWrapper = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
    var _ref$text = _ref.text,
        text = _ref$text === void 0 ? 'Checked' : _ref$text,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'radio' : _ref$name,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? 'Checked' : _ref$value,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? 'white' : _ref$variant,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        props = _objectWithoutProperties(_ref, ["text", "name", "value", "variant", "disabled"]);

    var readOnly = props.readOnly,
        onChange = props.onChange;
    var colors = getSelectedColor(variant);
    return /*#__PURE__*/React$2__default.createElement(Container$7, null, /*#__PURE__*/React$2__default.createElement(Label$2, {
      disabled: disabled,
      onClick: readOnly || disabled ? null : onChange,
      htmlFor: name,
      "data-testid": "test-label",
      enabledMark: colors.enabledMark,
      hoverMark: colors.hoverMark,
      pressedMark: colors.pressedMark,
      focusedMark: colors.focusedMark,
      disabledMark: colors.disabledMark,
      enabledMarkOutline: colors.enabledMarkOutline,
      hoverMarkOutline: colors.hoverMarkOutline,
      selectedMarkOutline: colors.selectedMarkOutline,
      disabledMarkOutline: colors.disabledMarkOutline,
      enabledText: colors.enabledText,
      hoverText: colors.hoverText,
      pressedText: colors.pressedText,
      selectedText: colors.selectedText,
      focusedText: colors.focusedText,
      focusedTextOutline: colors.focusedTextOutline,
      disabledText: colors.disabledText
    }, /*#__PURE__*/React$2__default.createElement(Radio, _extends({
      disabled: disabled,
      ref: ref,
      name: name,
      value: value
    }, props)), /*#__PURE__*/React$2__default.createElement("span", {
      "data-testid": "test-span"
    }, text), /*#__PURE__*/React$2__default.createElement(Mark, {
      enabledMark: colors.enabledMark
    }, /*#__PURE__*/React$2__default.createElement("div", null))));
  });

  function _templateObject5$f() {
    var data = _taggedTemplateLiteral([""]);

    _templateObject5$f = function _templateObject5() {
      return data;
    };

    return data;
  }

  function _templateObject4$h() {
    var data = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 3px;\n  left: 2px;\n  height: 22px;\n  width: 22px;\n  border: 1px solid ", ";\n  border-radius: 2px;\n  transition: 180ms ease-in-out;\n  &:after {\n    content: '';\n    position: absolute;\n    display: none;\n    left: 6.8px;\n    top: 3px;\n    width: 4px;\n    height: 8px;\n    border: solid white;\n    border-width: 0 3px 3px 0;\n    transform: rotate(45deg);\n  }\n"]);

    _templateObject4$h = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$l() {
    var data = _taggedTemplateLiteral(["\n  cursor: pointer;\n  position: absolute;\n  opacity: 0.0001;\n  height: 100%;\n  width: fit-content;\n  &:checked ~ span:after {\n    display: block;\n  }\n"]);

    _templateObject3$l = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$r() {
    var data = _taggedTemplateLiteral(["\n      color: ", ";\n      cursor: not-allowed;\n\n      :hover {\n        color: ", ";\n        font-weight: 500;\n      }\n    "]);

    _templateObject2$r = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$C() {
    var data = _taggedTemplateLiteral(["\n  display: inline-flex;\n  align-items: baseline;\n  position: relative;\n  padding: 4px 4px 4px 34px;\n  height: fit-content;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: normal;\n  border-radius: 4px;\n  border: 2px solid;\n  border-color: transparent;\n  transition: border-color 0.3s ease;\n  cursor: pointer;\n  user-select: none;\n  color: ", ";\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n  ", " {\n    font-size: 13.2px;\n  }\n  &:hover {\n    color: var(--brandPrimaryDark);\n    font-weight: 600;\n    span:nth-last-child(1) {\n      background: ", ";\n    }\n  }\n  input:checked ~ span {\n    border: 1px solid ", ";\n    color: ", ";\n    background-color: transparent;\n    font-weight: 600;\n    border: none;\n  }\n  input:checked ~ span:nth-last-child(1) {\n    border: 1px solid ", ";\n    background: ", ";\n    div {\n      background: ", ";\n      width: 14px;\n      height: 14px;\n      left: 4px;\n      top: 4px;\n      border-radius: 50%;\n      position: absolute;\n    }\n  }\n  span {\n    transition: color 0.3s ease;\n  }\n  :active {\n    span:nth-last-child(1) {\n      background: ", ";\n    }\n    :focus,\n    :focus-within {\n      outline: ", " auto 2px;\n    }\n  }\n\n  input:disabled ~ span:nth-last-child(1) {\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n  ", "\n\n  &:checked {\n    color: ", ";\n  }\n  &:checked ~ span:after {\n    color: ", ";\n  }\n  :focus,\n  :focus-within {\n    outline: ", " auto 2px;\n  }\n"]);

    _templateObject$C = function _templateObject() {
      return data;
    };

    return data;
  }
  var Label$3 = styled__default.label(_templateObject$C(), function (_ref) {
    var textColor = _ref.textColor;
    return textColor || 'var(--black100)';
  }, theme.breakpoints.down('sm'), theme.colors.bluePrimaryLight, function (_ref2) {
    var selectedColor = _ref2.selectedColor;
    return selectedColor;
  }, function (_ref3) {
    var selectedColor = _ref3.selectedColor;
    return selectedColor;
  }, function (_ref4) {
    var selectedColor = _ref4.selectedColor;
    return selectedColor;
  }, function (_ref5) {
    var selectedColor = _ref5.selectedColor;
    return selectedColor;
  }, function (_ref6) {
    var selectedColor = _ref6.selectedColor;
    return selectedColor;
  }, theme.colors.blueSecundaryDark, theme.colors.bluePrimary, theme.colors.grey500, theme.colors.greyPrimary, function (_ref7) {
    var disabled = _ref7.disabled;
    return disabled && styled.css(_templateObject2$r(), theme.colors.grey500, theme.colors.grey500);
  }, function (_ref8) {
    var selectedColor = _ref8.selectedColor;
    return selectedColor;
  }, function (_ref9) {
    var selectedColor = _ref9.selectedColor;
    return selectedColor;
  }, theme.colors.bluePrimary);
  var Box$1 = styled__default.input.attrs({
    type: 'checkbox'
  })(_templateObject3$l());
  var Mark$1 = styled__default.span(_templateObject4$h(), theme.colors.bluePrimary);
  var Container$8 = styled__default.div(_templateObject5$f());

  /**
   * @typedef {object} RadioWrapper
   * @property {string} text
   * @property {string} name
   * @property {string} color
   * @property {string} textColor
   * @property {any} value
   * @property {boolean} defaultChecked
   * @property {boolean} checked
   * @property {boolean} readOnly
   * @property {void} onChange
   */

  /** @type {import('react').FC<RadioWrapper>} */

  var CheckboxWrapper = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
    var _ref$text = _ref.text,
        text = _ref$text === void 0 ? 'Checked' : _ref$text,
        _ref$name = _ref.name,
        name = _ref$name === void 0 ? 'checkbox' : _ref$name,
        _ref$value = _ref.value,
        value = _ref$value === void 0 ? 'Checked' : _ref$value,
        _ref$selectedColor = _ref.selectedColor,
        selectedColor = _ref$selectedColor === void 0 ? 'var(--brandPrimary)' : _ref$selectedColor,
        _ref$textColor = _ref.textColor,
        textColor = _ref$textColor === void 0 ? '' : _ref$textColor,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        props = _objectWithoutProperties(_ref, ["text", "name", "value", "selectedColor", "textColor", "disabled"]);

    var readOnly = props.readOnly,
        onChange = props.onChange;
    return /*#__PURE__*/React$2__default.createElement(Container$8, null, /*#__PURE__*/React$2__default.createElement(Label$3, {
      disabled: disabled,
      onClick: readOnly ? null : onChange,
      htmlFor: name,
      selectedColor: selectedColor,
      textColor: textColor,
      "data-testid": "test-label"
    }, /*#__PURE__*/React$2__default.createElement(Box$1, _extends({
      disabled: disabled,
      ref: ref,
      name: name,
      value: value
    }, props)), /*#__PURE__*/React$2__default.createElement("span", {
      "data-testid": "test-span"
    }, text), /*#__PURE__*/React$2__default.createElement(Mark$1, {
      selectedColor: selectedColor
    })));
  });

  function _templateObject4$i() {
    var data = _taggedTemplateLiteral(["\n  font-weight: 500;\n  font-size: 12.8px;\n  line-height: 20px;\n  letter-spacing: 0.005em;\n  margin-top: 7px;\n\n  ", " {\n    font-size: 11px;\n    line-height: 16px;\n    letter-spacing: 0.0075em;\n  }\n"]);

    _templateObject4$i = function _templateObject4() {
      return data;
    };

    return data;
  }

  function _templateObject3$m() {
    var data = _taggedTemplateLiteral(["\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 24px;\n  letter-spacing: 0.005em;\n\n  ", " {\n    font-size: 13.2px;\n    line-height: 20px;\n  }\n"]);

    _templateObject3$m = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$s() {
    var data = _taggedTemplateLiteral(["\n      > label.select-label {\n        color: var(--white100);\n      }\n\n      > span.select-explainer {\n        color: var(--white100);\n      }\n    "]);

    _templateObject2$s = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$D() {
    var data = _taggedTemplateLiteral(["\n  width: ", ";\n  display: flex;\n  flex-direction: column;\n  font-family: 'Montserrat', sans-serif;\n  font-weight: 500;\n\n  ", " {\n    width: 100%;\n\n    .select-menu {\n      * {\n        font-size: 13.2px;\n        line-height: 20px;\n        letter-spacing: 0.005em;\n      }\n    }\n  }\n\n  ", "\n"]);

    _templateObject$D = function _templateObject() {
      return data;
    };

    return data;
  }
  var View$2 = styled__default.div(_templateObject$D(), function (_ref) {
    var width = _ref.width;
    return width;
  }, theme.breakpoints.down('sm'), function (_ref2) {
    var isVariant = _ref2.isVariant;
    return isVariant && styled.css(_templateObject2$s());
  });
  var Label$4 = styled__default.label(_templateObject3$m(), theme.breakpoints.down('sm'));
  var Explainer = styled__default.span(_templateObject4$i(), theme.breakpoints.down('sm'));

  var borderColor = function borderColor(isFocused, variant) {
    if (variant) {
      return isFocused ? '2px solid var(--black100)' : '2px solid var(--white100)';
    }

    return isFocused ? '2px solid var(--brandPrimary)' : '2px solid var(--brandPrimaryLight)';
  };

  var customStyles$2 = function customStyles(variant) {
    return {
      option: function option() {
        return {
          padding: 12,
          fontSize: 16,
          lineHeight: '24px',
          color: 'var(--black100)',
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          textOverflow: 'ellipsis',
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          '&:hover': {
            backgroundColor: theme.colors.bluePrimaryLight,
            color: theme.colors.bluePrimaryDark
          }
        };
      },
      control: function control(provided, state) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          height: 48,
          marginTop: 8,
          fontFamily: 'Montserrat, sans serif',
          zIndex: 200,
          cursor: 'pointer',
          border: borderColor(state.isFocused, variant),
          boxShadow: 'none',
          '&:hover': {// leaving this empty so it can override the default hover color
          },
          borderRadius: 4
        });
      },
      input: function input(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: theme.colors.blue800,
          fontSize: 16,
          fontFamily: 'Montserrat, sans serif'
        });
      },
      dropdownIndicator: function dropdownIndicator(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          color: 'var(--black100)'
        });
      },
      singleValue: function singleValue(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          fontWeight: 500,
          fontSize: 16,
          lineHeight: '24px',
          letterSpacing: '0.0075em',
          color: 'var(--black100)'
        });
      },
      placeholder: function placeholder() {
        return {
          fontFamily: 'Montserrat, sans serif',
          color: theme.colors.greyPrimary,
          fontSize: 16,
          lineHeight: '24px',
          letterSpacing: '0.0075em',
          fontWeight: 500
        };
      },
      indicatorSeparator: function indicatorSeparator() {
        return {};
      },
      menuList: function menuList(_menuList) {
        return _objectSpread2(_objectSpread2({}, _menuList), {}, {
          padding: 0,
          zIndex: 100
        });
      },
      menu: function menu(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          borderCollapse: 'separate',
          border: '2px solid var(--brandPrimaryLight)',
          boxSizing: 'border-box',
          borderRadius: '4px',
          overflow: 'auto',
          fontFamily: 'Montserrat, sans serif',
          boxShadow: '',
          marginTop: -2
        });
      },
      valueContainer: function valueContainer(provided) {
        return _objectSpread2(_objectSpread2({}, provided), {}, {
          fontSize: 20
        });
      }
    };
  };

  /**
   * @typedef {object} ReactSelectValue
   * @property {number | string} value
   * @property {string} label
   */

  /**
   * @typedef {object} SelectorProps
   * @property {Array<ReactSelectValue>} [options]
   * @property {ReactSelectValue} [value]
   * @property {((selectedValue: ReactSelectValue) => Void)} [onValueChange]
   * @property {string} [name]
   * @property {string} [placeholder]
   * @property {string} [explainer]
   * @property {boolean} [variant]
   */

  /** @type {import('react').FC<SelectorProps>} */

  var SelectorV3 = function SelectorV3(_ref) {
    var _ref$options = _ref.options,
        options = _ref$options === void 0 ? [] : _ref$options,
        value = _ref.value,
        onValueChange = _ref.onValueChange,
        name = _ref.name,
        _ref$width = _ref.width,
        width = _ref$width === void 0 ? '378px' : _ref$width,
        _ref$placeholder = _ref.placeholder,
        placeholder = _ref$placeholder === void 0 ? 'Selecionar' : _ref$placeholder,
        label = _ref.label,
        explainer = _ref.explainer,
        _ref$variant = _ref.variant,
        variant = _ref$variant === void 0 ? false : _ref$variant,
        props = _objectWithoutProperties(_ref, ["options", "value", "onValueChange", "name", "width", "placeholder", "label", "explainer", "variant"]);

    return /*#__PURE__*/React$2__default.createElement(View$2, {
      width: width,
      isVariant: variant
    }, label && /*#__PURE__*/React$2__default.createElement(Label$4, {
      className: "select-label"
    }, label), explainer && /*#__PURE__*/React$2__default.createElement(Explainer, {
      className: "select-explainer"
    }, explainer), /*#__PURE__*/React$2__default.createElement(index, _extends({
      inputProps: {
        'aria-label': {
          name: name
        }
      },
      noOptionsMessage: function noOptionsMessage() {
        return 'Sem opçōes';
      },
      styles: customStyles$2(variant),
      options: options,
      value: value,
      onChange: onValueChange,
      placeholder: placeholder,
      className: "select-menu"
    }, props)));
  };

  function _templateObject$E() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n\n  height: ", ";\n  width: ", ";\n  border-radius: ", ";\n  background-color: ", ";\n\n  &:before {\n    position: absolute;\n    inset: 0;\n    content: '';\n\n    height: ", ";\n    width: ", "%;\n    border-radius: ", ";\n    background-color: ", ";\n\n    transition: width 300ms ease-in;\n  }\n"]);

    _templateObject$E = function _templateObject() {
      return data;
    };

    return data;
  }
  var Container$9 = styled__default.div(_templateObject$E(), function (_ref) {
    var height = _ref.height;
    return height;
  }, function (_ref2) {
    var width = _ref2.width;
    return width;
  }, function (_ref3) {
    var borderRadius = _ref3.borderRadius;
    return borderRadius;
  }, function (_ref4) {
    var backgroundColor = _ref4.backgroundColor;
    return backgroundColor;
  }, function (_ref5) {
    var height = _ref5.height;
    return height;
  }, function (_ref6) {
    var progress = _ref6.progress;
    return progress;
  }, function (_ref7) {
    var borderRadius = _ref7.borderRadius;
    return borderRadius;
  }, function (_ref8) {
    var color = _ref8.color;
    return color;
  });

  /**
   * @typedef {object} ProgressBar
   * @property {string} backgroundColor
   * @property {string} borderRadius
   * @property {string} color
   * @property {string} height
   * @property {string} width
   */

  /** @type {import('react').FC<ProgressBar>} */

  var ProgressBar$1 = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
    var backgroundColor = _ref.backgroundColor,
        _ref$borderRadius = _ref.borderRadius,
        borderRadius = _ref$borderRadius === void 0 ? '20px' : _ref$borderRadius,
        color = _ref.color,
        _ref$height = _ref.height,
        height = _ref$height === void 0 ? '5px' : _ref$height,
        _ref$progress = _ref.progress,
        progress = _ref$progress === void 0 ? 0 : _ref$progress,
        _ref$width = _ref.width,
        width = _ref$width === void 0 ? '100%' : _ref$width;

    var _useState = React$2.useState(0),
        _useState2 = _slicedToArray(_useState, 2),
        currentProgress = _useState2[0],
        setCurrentProgress = _useState2[1]; // Delimit range


    var getProgress = function getProgress(value) {
      switch (true) {
        case value < 0:
          return 0;

        case value > 100:
          return 100;

        default:
          return value;
      }
    };

    React$2.useEffect(function () {
      setCurrentProgress(function () {
        return getProgress(progress);
      });
    }, [progress]);
    React$2.useImperativeHandle(ref, function () {
      return {
        setPercent: function setPercent(value) {
          setCurrentProgress(function () {
            return getProgress(value);
          });
        },
        addPercent: function addPercent(value) {
          setCurrentProgress(function (currentValue) {
            return getProgress(currentValue + value);
          });
        },
        subPercent: function subPercent(value) {
          setCurrentProgress(function (currentValue) {
            return getProgress(currentValue - value);
          });
        }
      };
    }, []);
    return /*#__PURE__*/React$2__default.createElement(Container$9, {
      color: color,
      backgroundColor: backgroundColor,
      borderRadius: borderRadius,
      width: width,
      progress: getProgress(currentProgress),
      height: height
    });
  });

  function _templateObject3$n() {
    var data = _taggedTemplateLiteral(["\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  max-width: calc(100% - 80px);\n  max-height: calc(100vh - 80px);\n  overflow-y: auto;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);\n  z-index: 99999;\n  padding: 1rem;\n  width: ", ";\n  background-color: ", ";\n  border-radius: ", ";\n"]);

    _templateObject3$n = function _templateObject3() {
      return data;
    };

    return data;
  }

  function _templateObject2$t() {
    var data = _taggedTemplateLiteral(["\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 99998;\n  background-color: ", ";\n"]);

    _templateObject2$t = function _templateObject2() {
      return data;
    };

    return data;
  }

  function _templateObject$F() {
    var data = _taggedTemplateLiteral(["\n  * {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n  }\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 99999;\n"]);

    _templateObject$F = function _templateObject() {
      return data;
    };

    return data;
  }
  var ModalWrapper = styled__default.div(_templateObject$F());
  var ModalBackDrop = styled__default.div(_templateObject2$t(), function (_ref) {
    var backdropColor = _ref.backdropColor;
    return backdropColor || 'rgba(0, 0, 0, 0.3)';
  });
  var ModalContainer = styled__default.div(_templateObject3$n(), function (_ref2) {
    var width = _ref2.width;
    return width || '500px';
  }, function (_ref3) {
    var bgColor = _ref3.bgColor;
    return bgColor || 'var(--white100)';
  }, function (_ref4) {
    var borderRadius = _ref4.borderRadius;
    return borderRadius || '4px';
  });

  var PortalModal = /*#__PURE__*/React$2.forwardRef(function (_ref, ref) {
    var width = _ref.width,
        bgColor = _ref.bgColor,
        borderRadius = _ref.borderRadius,
        backdropColor = _ref.backdropColor,
        isReadOnly = _ref.isReadOnly,
        children = _ref.children,
        props = _objectWithoutProperties(_ref, ["width", "bgColor", "borderRadius", "backdropColor", "isReadOnly", "children"]);

    var _useState = React$2.useState(null),
        _useState2 = _slicedToArray(_useState, 2),
        showModal = _useState2[0],
        setShowModal = _useState2[1];

    React$2.useImperativeHandle(ref, function () {
      return {
        openModalFn: function openModalFn() {
          return openModal();
        },
        closeModalFn: function closeModalFn() {
          return closeModal();
        }
      };
    });

    var openModal = function openModal() {
      setShowModal(true);
    };

    var closeModal = function closeModal() {
      setShowModal(false);
    };

    if (showModal) {
      return /*#__PURE__*/ReactDOM__default.createPortal( /*#__PURE__*/React$2__default.createElement(ModalWrapper, null, /*#__PURE__*/React$2__default.createElement(ModalBackDrop, {
        onClick: isReadOnly ? function () {
          return null;
        } : closeModal,
        backdropColor: backdropColor
      }), /*#__PURE__*/React$2__default.createElement(ModalContainer, _extends({
        width: width,
        borderRadius: borderRadius,
        bgColor: bgColor
      }, props), children)), document.getElementById('modal-root'));
    }

    return null;
  });

  exports.Breadcrumbs = Breadcrumbs;
  exports.Button = Button;
  exports.ButtonBackDesktop = ButtonBackDesktop;
  exports.ButtonV2 = ButtonV2;
  exports.ButtonV3 = ButtonV3;
  exports.Card = Card$1;
  exports.CheckBox = CheckboxWrapper;
  exports.Checkbox = Checkbox;
  exports.Container = Container;
  exports.Emoji = Emoji;
  exports.ErrorBoundary = ErrorBoundary;
  exports.Form = Form;
  exports.Header = Header;
  exports.HeaderV2 = HeaderV2;
  exports.Input = Input$1;
  exports.InputField = InputField;
  exports.InputFieldV3 = InputFieldV3;
  exports.InputFileField = InputFileField;
  exports.InputMasks = InputMasks;
  exports.Label = Label;
  exports.LoadingProvi = LoadingProvi;
  exports.Modal = Modal;
  exports.Option = Option;
  exports.PortalModal = PortalModal;
  exports.ProgressBar = ProgressBar$1;
  exports.Radio = RadioWrapper;
  exports.RangeSlider = RangeSlider;
  exports.Rating = Rating;
  exports.SelectSectionButton = SelectSectionButton;
  exports.Selector = Selector;
  exports.SelectorV2 = SelectorV2;
  exports.SelectorV3 = SelectorV3;
  exports.SubHeader = SubHeader;
  exports.SubHeaderDesktop = SubHeaderDesktop;
  exports.SubTitle = SubTitle;
  exports.TableComponent = TableComponent;
  exports.Tag = Tag;
  exports.TextAreaField = TextAreaField;
  exports.TextButton = TextButton;
  exports.TextErrorInput = TextErrorInput;
  exports.TextLink = TextLink;
  exports.Title = Title$2;
  exports.ToastComponent = ToastComponent;
  exports.UploadBox = UploadBox;
  exports.showToast = showToast;
  exports.theme = theme;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=index.umd.js.map
